export const reversePincodeData = {
  "515631": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Tadimarri S.O"
  },
  "515581": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Talupula S.O"
  },
  "515571": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Tanakallu S.O"
  },
  "515311": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Agali S.O (Ananthapur)"
  },
  "515281": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Amarapuram S.O"
  },
  "515241": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Budili S.O"
  },
  "534176": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Pothavaram S.O"
  },
  "813105": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Jagdishpur SO Bhagalpur"
  },
  "813203": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Kahalgaon SO"
  },
  "853202": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Karik Bazar SO"
  },
  "813222": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Mathurapur SO Bhagalpur"
  },
  "812005": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Mirjanhat SO"
  },
  "853203": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Narayanpur SO Bhagalpur"
  },
  "812006": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Nathnagar SO"
  },
  "853204": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Naugachia SO"
  },
  "813209": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Pripainti SO"
  },
  "530052": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Anandapuram S.O (Visakhapatnam)"
  },
  "515871": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Kanekal S.O"
  },
  "515842": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Konakondla S.O"
  },
  "515803": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Old Guntakal S.O"
  },
  "515775": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Pamidi S.O"
  },
  "515405": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Pedda Vadagur S.O"
  },
  "515865": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Rayadurg  Bazar S.O"
  },
  "515455": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Rayalacheruvu S.O"
  },
  "515611": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Tarimala S.O"
  },
  "515867": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Udegolam S.O"
  },
  "515812": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Uravakonda S.O"
  },
  "515832": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Vajrakarur S.O"
  },
  "515870": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Vidapanakal S.O"
  },
  "531173": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Pendurthy S.O"
  },
  "531219": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "R P Agraharam S.O"
  },
  "853205": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "STGoriar SO"
  },
  "813210": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Sabour SO"
  },
  "813108": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Sahkund SO"
  },
  "813212": {
    "state": "BIHAR",
    "district": "MUNGER",
    "office": "Sangrampur SO Bhagalpur"
  },
  "515101": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Chennekothapalli S.O"
  },
  "503186": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Sarangapur S.O"
  },
  "503180": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Shakkarnagar S.O"
  },
  "503187": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Banswada S.O"
  },
  "503101": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Bhiknoor S.O"
  },
  "503125": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Bibipet S.O"
  },
  "503112": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Kamareddy RS S.O"
  },
  "344704": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Dhorimana S.O"
  },
  "344032": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Pachpadra City S.O"
  },
  "342002": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "NDC Jodhpur"
  },
  "344706": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Sedwa S.O"
  },
  "503124": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Lingampet S.O"
  },
  "503309": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Madnoor S.O"
  },
  "503108": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Nagireddypet S.O"
  },
  "503302": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Nizamsagar S.O"
  },
  "503201": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Varni S.O"
  },
  "503306": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Bichkunda S.O"
  },
  "503123": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Domakonda S.O"
  },
  "503102": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Jangampalli S.O"
  },
  "516129": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Rayavaram S.O (Cuddapah)"
  },
  "516237": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Siddavattam S.O"
  },
  "516130": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "T. Sundupalli S.O"
  },
  "516151": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Tangatur S.O"
  },
  "147111": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "Devigarh SO"
  },
  "788162": {
    "state": "ASSAM",
    "district": "HAILAKANDI",
    "office": "Jamira Bazar S.O"
  },
  "788150": {
    "state": "ASSAM",
    "district": "HAILAKANDI",
    "office": "Kalibari Bazar S.O"
  },
  "788801": {
    "state": "ASSAM",
    "district": "HAILAKANDI",
    "office": "Kalinagar S.O"
  },
  "788161": {
    "state": "ASSAM",
    "district": "HAILAKANDI",
    "office": "Katlacherra S.O"
  },
  "788152": {
    "state": "ASSAM",
    "district": "HAILAKANDI",
    "office": "Lakshmisahar S.O"
  },
  "788155": {
    "state": "ASSAM",
    "district": "HAILAKANDI",
    "office": "Ratanpur Road S.O"
  },
  "208001": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Kanpur West SO"
  },
  "503310": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Pitlam S.O"
  },
  "503110": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Rajampet S.O"
  },
  "503145": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Sadasivanagar S.O"
  },
  "503120": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Yerrapahad S.O"
  },
  "503235": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Renjal S.O"
  },
  "503321": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Birkur S.O"
  },
  "503185": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Bodhan S.O"
  },
  "503230": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Dharmaram S.O"
  },
  "503202": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Edapalli S.O"
  },
  "503246": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Jannepalli S.O"
  },
  "503305": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Jukkal S.O"
  },
  "273001": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Buxipur SO"
  },
  "505186": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Garrepalli S.O"
  },
  "505153": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Kalvasrirampur S.O"
  },
  "505162": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Kolanur S.O"
  },
  "505152": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Pothkapalli S.O"
  },
  "505514": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Anthergaon Textiles S.O"
  },
  "505187": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Basanthnagar S.O"
  },
  "505212": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Centanary Colony S.O"
  },
  "505525": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Elgaid S.O"
  },
  "505209": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Scab S.O"
  },
  "505188": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Kamanpur S.O"
  },
  "505122": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Jammikunta S.O"
  },
  "505498": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Kakatiya Cannal Campus S.O"
  },
  "524324": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "VIKRAMASIMHAPURI UNIVERSITY SO"
  },
  "501301": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Ghatkesar S.O"
  },
  "500088": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Samskruthi S.O"
  },
  "500100": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Kompally S.O"
  },
  "501401": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Medchal S.O"
  },
  "501102": {
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "office": "Allampalli S.O."
  },
  "500101": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Shamirpet S.O"
  },
  "500078": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Nisa Hakimpet S.O"
  },
  "501509": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Yacharam S.O"
  },
  "500043": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Airforce Academy S.O"
  },
  "500087": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "JJ Nagar Colony S.O"
  },
  "501505": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Hayatnagar S.O"
  },
  "500055": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "IDA Jeedimetla S.O"
  },
  "813207": {
    "state": "BIHAR",
    "district": "BANKA",
    "office": "Khesar SO"
  },
  "813110": {
    "state": "BIHAR",
    "district": "BANKA",
    "office": "Panjwara SO"
  },
  "813109": {
    "state": "BIHAR",
    "district": "BANKA",
    "office": "Punsia SO"
  },
  "813107": {
    "state": "BIHAR",
    "district": "BANKA",
    "office": "Rajoun SO"
  },
  "813211": {
    "state": "BIHAR",
    "district": "BANKA",
    "office": "Shambhuganj SO"
  },
  "522658": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Ipuru S.O"
  },
  "522614": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Karempudi S.O"
  },
  "344011": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Bishala S.O"
  },
  "342304": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Mandore SO"
  },
  "142049": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Guru Teg Bahadur Garh SO"
  },
  "503207": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Kotgir S.O"
  },
  "851210": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Mahna SO"
  },
  "851127": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Manjhaul SO"
  },
  "534239": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Dirusumarru S.O"
  },
  "534237": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Kalla S.O"
  },
  "534247": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Rayakuduru S.O"
  },
  "534202": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Sreeramapuram S.O"
  },
  "534243": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Srungavruksham S.O"
  },
  "534199": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Undi S.O"
  },
  "848201": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "BBazar SO"
  },
  "534134": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Attili S.O"
  },
  "502293": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Singoor Project S.O"
  },
  "502284": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "IIT HYDERABAD SO"
  },
  "851113": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "BDeorhi SO"
  },
  "851111": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Bachhawara SO"
  },
  "851112": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Barauni SO"
  },
  "503301": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Mirzapur S.O"
  },
  "503206": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Mosra S.O"
  },
  "503245": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Navipet S.O"
  },
  "585447": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "MANHALLI  S.O"
  },
  "585404": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Naubad SO"
  },
  "151214": {
    "state": "PUNJAB",
    "district": "FARIDKOT",
    "office": "Ghugiana BO"
  },
  "503114": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Gandhari S.O"
  },
  "503144": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Ramareddy S.O"
  },
  "503122": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Yellareddy S.O"
  },
  "507204": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Bommakal S.O"
  },
  "507169": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Cheruvumadharam S.O"
  },
  "507208": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Chintakani S.O"
  },
  "507002": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Y.C. Roads S.O"
  },
  "507168": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Enkoor S.O"
  },
  "507003": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Trunk Road S.O"
  },
  "507158": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Gokinepalli S.O"
  },
  "507209": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Kallur S.O"
  },
  "507122": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Karepalli S.O"
  },
  "851120": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Bhagwanpur SO"
  },
  "848204": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Garhpura SO"
  },
  "851204": {
    "state": "BIHAR",
    "district": "KHAGARIA",
    "office": "Khagaria Mukhya Dakghar SO"
  },
  "851211": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Lakhminia SO"
  },
  "847451": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "KUNAUALI BAZAR SO"
  },
  "851128": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Mansurchak SO"
  },
  "502114": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Irkode S.O"
  },
  "534238": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Polamuru S.O"
  },
  "534240": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Konithiwada S.O"
  },
  "534206": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Kopalle S.O"
  },
  "534210": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Palakoderu S.O"
  },
  "472445": {
    "state": "MADHYA PRADESH",
    "district": "Niwari",
    "office": "Taricharkala S.O"
  },
  "851213": {
    "state": "BIHAR",
    "district": "KHAGARIA",
    "office": "Maheshkhunt SO"
  },
  "851214": {
    "state": "BIHAR",
    "district": "KHAGARIA",
    "office": "Mansi SO"
  },
  "851201": {
    "state": "BIHAR",
    "district": "KHAGARIA",
    "office": "Chautham SO"
  },
  "515231": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Gorantla S.O"
  },
  "515271": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Gudibanda S.O (Ananthapur)"
  },
  "515164": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Guttur S.O"
  },
  "515212": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Hindupur Sevamandir S.O"
  },
  "515303": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Kallumarri S.O"
  },
  "515556": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Amadagur S.O"
  },
  "515661": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Bathalapalli S.O"
  },
  "515672": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Dharmavaram R.S S.O"
  },
  "515521": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Gandlapenta S.O"
  },
  "783135": {
    "state": "ASSAM",
    "district": "SOUTH SALMARA MANCACHAR",
    "office": "Fekamari S.O"
  },
  "827016": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "NDC B.S.CITY"
  },
  "515591": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Clock Tower Kadiri S.O"
  },
  "515641": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Kanaganapalli S.O"
  },
  "515531": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Kondakamarla S.O"
  },
  "515541": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Kutagulla S.O"
  },
  "515511": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Mudigubba S.O"
  },
  "515551": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Nallacheruvu S.O"
  },
  "515154": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Pamudurthi S.O"
  },
  "515501": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Patnam S.O"
  },
  "515341": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Chilamathur S.O"
  },
  "515286": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Hemavathi S.O"
  },
  "515144": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Bukkapatnam S.O"
  },
  "505129": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Khadeemabadi S.O"
  },
  "505470": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Molangur S.O"
  },
  "505505": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Ootur S.O"
  },
  "505474": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Tadikal S.O"
  },
  "505475": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Vavilala S.O"
  },
  "505502": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Veenavanka S.O"
  },
  "505490": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Keshavapatnam S.O"
  },
  "505472": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Saidapur S.O"
  },
  "505101": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Uppal S.O"
  },
  "505480": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Vangara S.O"
  },
  "754031": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Barambagarh S.O"
  },
  "754028": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Charbatia S.O"
  },
  "754027": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Chasapara S.O"
  },
  "754037": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Kanpur S.O"
  },
  "754022": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Kotasahi S.O"
  },
  "754290": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Mouda S.O"
  },
  "505497": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Bheemdevarpalli S.O"
  },
  "505102": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Kamalapur S.O"
  },
  "505471": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Mulkunur S.O"
  },
  "505476": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Yelkathurthi S.O"
  },
  "515133": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Kothacheruvu S.O"
  },
  "515159": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Krishnapuram S.O (Ananthapur)"
  },
  "515651": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Medapuram S.O"
  },
  "141114": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Samrala SO"
  },
  "825103": {
    "state": "JHARKHAND",
    "district": "CHATRA",
    "office": "Simaria SO"
  },
  "829143": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Balkudra SO"
  },
  "824304": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "NPGCL Aditi Nagar S.O"
  },
  "802204": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Hasan Bazar SO"
  },
  "802158": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Jagdishpur SO Bhojpur"
  },
  "523264": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Tallur S.O (Prakasam)"
  },
  "523263": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Tellapadu S.O"
  },
  "524221": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Chakalakonda S.O"
  },
  "524240": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Dagadarthi S.O"
  },
  "524152": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Damavaram S.O"
  },
  "524222": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Duthalur S.O"
  },
  "524236": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Gandipalem S.O"
  },
  "523262": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Throvagunta S.O"
  },
  "524223": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Jaladanki S.O"
  },
  "524224": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Kaligiri S.O"
  },
  "524239": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Kondapuram S.O (Nellore)"
  },
  "501503": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Chevella S.O"
  },
  "501121": {
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "office": "Dharur S.O"
  },
  "501202": {
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "office": "Mominpet S.O"
  },
  "501111": {
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "office": "Nawabpet S.O"
  },
  "501142": {
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "office": "Peddimal S.O"
  },
  "501501": {
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "office": "Purgi S.O"
  },
  "501203": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Shankarpalli S.O"
  },
  "501141": {
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "office": "Tandur S.O"
  },
  "813213": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "S R Sultanganj SO"
  },
  "822123": {
    "state": "JHARKHAND",
    "district": "PALAMU",
    "office": "Patan SO Palamau"
  },
  "531084": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Kd Peta S.O"
  },
  "531114": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Kothakota S.O (Visakhapatnam)"
  },
  "531022": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "A Koduru S.O"
  },
  "822132": {
    "state": "JHARKHAND",
    "district": "PALAMU",
    "office": "Bishrampur SO Palamau"
  },
  "444602": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Amravati Camp S.O"
  },
  "531126": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Payakaraopeta S.O"
  },
  "516329": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Vaimpalle S.O"
  },
  "516293": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Vallur S.O (Cuddapah)"
  },
  "516321": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Veerapunayanipalle S.O"
  },
  "531149": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Araku Colony S.O"
  },
  "501144": {
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "office": "Yalal S.O"
  },
  "501504": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Moinabad S.O"
  },
  "524300": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Somasila Hill Colony S.O"
  },
  "524142": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Bitragunta S.O"
  },
  "852161": {
    "state": "BIHAR",
    "district": "KHAGARIA",
    "office": "Beldaur SO"
  },
  "534208": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Rayalam S.O"
  },
  "534204": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "S.R.K.R .Engg.college S.O"
  },
  "534207": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Tundurru S.O"
  },
  "851118": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Baro SO"
  },
  "788163": {
    "state": "ASSAM",
    "district": "HAILAKANDI",
    "office": "Lala S.O"
  },
  "788165": {
    "state": "ASSAM",
    "district": "HAILAKANDI",
    "office": "Manipur Bagan S.O"
  },
  "788734": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Anipur S.O"
  },
  "788736": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Dullabcherra S.O"
  },
  "788737": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Olivacherra S.O"
  },
  "788166": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Ramkrishnanagar S.O"
  },
  "788735": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Ratabari S.O"
  },
  "788156": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Anilgarh S.O"
  },
  "533274": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Gopalapuram S.O (East Godavari)"
  },
  "533253": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Malikipuram S.O"
  },
  "533250": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Mori S.O (East Godavari)"
  },
  "533247": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Nagaram S.O (East Godavari)"
  },
  "533229": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Palivela S.O"
  },
  "533248": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Ponnamanda S.O"
  },
  "533238": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Ravulapalem S.O"
  },
  "533236": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Ryali S.O"
  },
  "533251": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Sakhinetipalli S.O"
  },
  "533244": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Sivakodu S.O"
  },
  "533249": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Tatipaka S.O"
  },
  "515445": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Ammaladinne S.O"
  },
  "515002": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Anantapur Engg College S.O"
  },
  "825405": {
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "office": "Barhi SO Hazaribag"
  },
  "533290": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Kotikesavaram S.O"
  },
  "754025": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Choudwar Bazar S.O"
  },
  "802205": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Karath SO"
  },
  "768033": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Sohella S.O"
  },
  "788806": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Badarpur S.O (Karimganj"
  },
  "788723": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Baraigram S.O"
  },
  "788733": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Bazarghat S.O (Karimganj"
  },
  "788701": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Bhanga Bazaar S.O"
  },
  "788725": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Chandkhira S.O"
  },
  "788726": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Hatikhira S.O"
  },
  "788728": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Isabeel S.O"
  },
  "147007": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "New Lal Bagh Colony SO"
  },
  "140402": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "Rajpura Township SO"
  },
  "333517": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Bhainsawata Kalan S.O"
  },
  "847122": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Bisfi SO"
  },
  "331027": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Bissau S.O"
  },
  "333020": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Chanana S.O"
  },
  "333055": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Kankaria S.O"
  },
  "759151": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Pabitranagar S.O"
  },
  "201001": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Ramte Ram Road SO"
  },
  "847227": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Khutauna SO"
  },
  "847232": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Ladania SO"
  },
  "847421": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Laukaha SO"
  },
  "847231": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Lohat SO"
  },
  "847214": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "M G Bazar SO"
  },
  "503003": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Nizamabad RS S.O"
  },
  "575009": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Bajal S.O"
  },
  "141110": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Hambran SO"
  },
  "802183": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Gaudarh Rudranagar SO"
  },
  "802313": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Gunari SO"
  },
  "802206": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Kasap SO"
  },
  "802314": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Kayamnagar SO"
  },
  "802159": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Jitaura SO"
  },
  "847301": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Hayaghat Bilashpur SO"
  },
  "282001": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "Baluganj SO"
  },
  "501106": {
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "office": "Kotpalli S.O"
  },
  "516213": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Vontimitta S.O"
  },
  "781320": {
    "state": "ASSAM",
    "district": "BAKSA",
    "office": "Salbari S.O"
  },
  "781367": {
    "state": "ASSAM",
    "district": "BAKSA",
    "office": "Tambulpur S.O"
  },
  "781377": {
    "state": "ASSAM",
    "district": "BAKSA",
    "office": "Thamna S.O (Nalbari)"
  },
  "781371": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Tihu S.O"
  },
  "788117": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Barjalenga S.O"
  },
  "788817": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Behara Bazar S.O"
  },
  "788113": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Dwarband S.O"
  },
  "788802": {
    "state": "ASSAM",
    "district": "HAILAKANDI",
    "office": "Panchgram S.O"
  },
  "383002": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Himatnagar Station Road SO"
  },
  "383422": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Poshina SO"
  },
  "343029": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Bhinmal Sadar Bazar S.O"
  },
  "382430": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Kathwada Maize Product SO"
  },
  "847104": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Bharwara SO"
  },
  "847302": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Jalley SO"
  },
  "846003": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Benta South SO"
  },
  "384330": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Satlasana SO"
  },
  "494230": {
    "state": "CHHATTISGARH",
    "district": "KONDAGAON",
    "office": "Piprabahigaon S.O"
  },
  "141008": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Shivpuri SO Ludhiana"
  },
  "504204": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Bheemaram S.O"
  },
  "504201": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Chinnoor S.O"
  },
  "504294": {
    "state": "TELANGANA",
    "district": "KUMURAM BHEEM ASIFABAD",
    "office": "Chirrakunta S.O"
  },
  "504302": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Coal Chemical Complex S.O"
  },
  "504206": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Dandepalli S.O"
  },
  "504207": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Donabanda S.O"
  },
  "504216": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Jaipur S.O"
  },
  "504205": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Jannaram S.O"
  },
  "504231": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Kalyani Khani S.O"
  },
  "504214": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Kotapalli S.O"
  },
  "504215": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Luxettipet S.O"
  },
  "504209": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Mancherial Cement Works S.O"
  },
  "504219": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Nennel S.O"
  },
  "503307": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Bhimgal Busstand S.O"
  },
  "503165": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Darpalli S.O"
  },
  "503175": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Dichpalli RS S.O"
  },
  "503164": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Indalwai RS S.O"
  },
  "533237": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Vubalanka S.O"
  },
  "515561": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Obula Devara Cheruvu S.O"
  },
  "506342": {
    "state": "TELANGANA",
    "district": "WARANGAL RURAL",
    "office": "Atmakur S.O"
  },
  "507210": {
    "state": "TELANGANA",
    "district": "MAHABUBABAD",
    "office": "Garla S.O"
  },
  "847204": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Bishnupur SO Darbhanga"
  },
  "847427": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Ghanshyampur SO Darbhanga"
  },
  "506112": {
    "state": "TELANGANA",
    "district": "MAHABUBABAD",
    "office": "Kesamudram S.O"
  },
  "506135": {
    "state": "TELANGANA",
    "district": "MAHABUBABAD",
    "office": "Kothaguda S.O"
  },
  "495116": {
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "office": "Belgahana SO"
  },
  "495004": {
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "office": "Cmd College Bilaspur SO"
  },
  "788816": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Jalalpur S.O (Cachar"
  },
  "784171": {
    "state": "ASSAM",
    "district": "Biswanath",
    "office": "Tetenbari S.O"
  },
  "784149": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Thelamara S.O"
  },
  "516193": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Porumamilla S.O"
  },
  "516003": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Ravindra Nagar S.O"
  },
  "516269": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Rayachoti S.O"
  },
  "516215": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Sambepalli S.O"
  },
  "516002": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Shankarapuram (Cuddapah) S.O"
  },
  "516505": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Tekurpet S.O"
  },
  "516268": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Veeraballi S.O"
  },
  "516105": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Anantharajupet S.O"
  },
  "516501": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Atlur S.O"
  },
  "516128": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Chakrapunayanipet S.O"
  },
  "516101": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Kodur Rs S.O"
  },
  "494347": {
    "state": "CHHATTISGARH",
    "district": "KONDAGAON",
    "office": "Vishrampuri S.O"
  },
  "494237": {
    "state": "CHHATTISGARH",
    "district": "KONDAGAON",
    "office": "Makdi SO"
  },
  "494010": {
    "state": "CHHATTISGARH",
    "district": "BASTAR",
    "office": "Lohandiguda S.O"
  },
  "494552": {
    "state": "CHHATTISGARH",
    "district": "DANTEWADA",
    "office": "Nakulnar S.O"
  },
  "503308": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Kammarpalli S.O"
  },
  "503218": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Kissannagar S.O"
  },
  "503213": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Makloor S.O"
  },
  "516247": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Madhavaram S.O (Cuddapah)"
  },
  "516126": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Mannur S.O (Cuddapah)"
  },
  "516152": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Mantapampalli S.O"
  },
  "516150": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Nandalur S.O"
  },
  "495224": {
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "office": "Bilha SO"
  },
  "495112": {
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "office": "Ganiyari SO"
  },
  "495222": {
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "office": "Hirri Mines SO"
  },
  "495550": {
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "office": "Jairam Nagar SO"
  },
  "495113": {
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "office": "Kargi Road SO"
  },
  "847105": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Baheri SO Darbhanga"
  },
  "759147": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Deepasikha S.O"
  },
  "822112": {
    "state": "JHARKHAND",
    "district": "GARHWA",
    "office": "Bhawnathpur SO"
  },
  "822129": {
    "state": "JHARKHAND",
    "district": "GARHWA",
    "office": "Bhawnathpur TownShip SO"
  },
  "822114": {
    "state": "JHARKHAND",
    "district": "GARHWA",
    "office": "Garhwa SO"
  },
  "822133": {
    "state": "JHARKHAND",
    "district": "GARHWA",
    "office": "Meral SO"
  },
  "822120": {
    "state": "JHARKHAND",
    "district": "PALAMU",
    "office": "Mohammad Ganj SO"
  },
  "754023": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "CHHATIA S.O"
  },
  "754296": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "SUNGUDA S.O"
  },
  "754024": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Dhanmandal S.O"
  },
  "755013": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Pritipur S.O"
  },
  "160055": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Chandigarh Sector 56 SO"
  },
  "755043": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Panikoili S.O"
  },
  "755014": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Rambag S.O"
  },
  "639103": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Kulumani SO"
  },
  "754082": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "BYREE S.O"
  },
  "505425": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "Dharmapuri S.O"
  },
  "755016": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Singhpur S.O (Jajapur)"
  },
  "754217": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Alba S.O"
  },
  "754219": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Aul S.O"
  },
  "754218": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Batipada S.O"
  },
  "754253": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Bedari S.O"
  },
  "754239": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Bhuinpur S.O"
  },
  "754208": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Chandol S.O"
  },
  "754292": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Charinangal S.O"
  },
  "754222": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Chaudakulat S.O"
  },
  "754240": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Dandisahi S.O"
  },
  "754210": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Danpur S.O (Kendrapara)"
  },
  "754289": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Derabish S.O"
  },
  "754214": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Indupur S.O"
  },
  "754248": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Iswarpur S.O"
  },
  "754244": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Jampara S.O"
  },
  "754216": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Jaria S.O (Kendrapara)"
  },
  "754223": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Karilopatna S.O"
  },
  "505529": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "Polas S.O"
  },
  "505460": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "Raikal S.O"
  },
  "754295": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Athagarh Bazar S.O"
  },
  "754032": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Narasinghpur S.O"
  },
  "802222": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Khutahan SO"
  },
  "802162": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Nawada Ben SO"
  },
  "533232": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Chintaluru S.O"
  },
  "535525": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Ravivalasa S.O"
  },
  "535005": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Apsp Quarters S.O"
  },
  "515763": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Bommaganipalli S.O"
  },
  "515701": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Bukkarayasamudram S.O"
  },
  "755017": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Sujanpur S.O (Jajapur)"
  },
  "755018": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Sukinda S.O"
  },
  "754205": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Balichandrapur S.O"
  },
  "755036": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Ahiyas S.O"
  },
  "755027": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Arei S.O"
  },
  "755003": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Bari Cuttack S.O"
  },
  "822121": {
    "state": "JHARKHAND",
    "district": "GARHWA",
    "office": "Nagar Utari SO"
  },
  "516401": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Tondur S.O"
  },
  "335522": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "PALLU S.O"
  },
  "506105": {
    "state": "TELANGANA",
    "district": "MAHABUBABAD",
    "office": "Kuravi S.O"
  },
  "506315": {
    "state": "TELANGANA",
    "district": "MAHABUBABAD",
    "office": "Maripeda S.O"
  },
  "506368": {
    "state": "TELANGANA",
    "district": "MAHABUBABAD",
    "office": "Nallikaddur S.O"
  },
  "506132": {
    "state": "TELANGANA",
    "district": "WARANGAL RURAL",
    "office": "Narsampet S.O"
  },
  "506104": {
    "state": "TELANGANA",
    "district": "MAHABUBABAD",
    "office": "Neerada S.O"
  },
  "506122": {
    "state": "TELANGANA",
    "district": "WARANGAL RURAL",
    "office": "Nekkonda S.O"
  },
  "506102": {
    "state": "TELANGANA",
    "district": "MAHABUBABAD",
    "office": "New Abadi S.O"
  },
  "506365": {
    "state": "TELANGANA",
    "district": "WARANGAL RURAL",
    "office": "Parwathagiri S.O"
  },
  "506369": {
    "state": "TELANGANA",
    "district": "WARANGAL RURAL",
    "office": "Redlawada S.O"
  },
  "506006": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Deshaipet S.O"
  },
  "506330": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Dharmaram S.O"
  },
  "495552": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Akaltara SO"
  },
  "495559": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Baloda SO"
  },
  "495668": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Janjgir HO"
  },
  "495669": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "VIDYUT NAGAR LACHHANPUR S.O."
  },
  "515408": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Yadiki S.O"
  },
  "515415": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Chukkalur S.O"
  },
  "515751": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Atmakur(ATP) S.O"
  },
  "533107": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Satellite City S.O"
  },
  "535260": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Bondapalli S.O"
  },
  "535126": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Therlam S.O"
  },
  "535124": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Uttaravalli S.O"
  },
  "516349": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Vemula S.O"
  },
  "517194": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Bhakarapet S.O"
  },
  "517305": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Cherlopalle S.O"
  },
  "517152": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Damalacheruvu S.O"
  },
  "517297": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Gurramkonda S.O"
  },
  "517213": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Gyarampalle kothapalle S.O"
  },
  "517236": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Kalakada S.O"
  },
  "517234": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Kalikiri S.O"
  },
  "847304": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Kamtaul SO"
  },
  "847121": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Keoti Ranway SO"
  },
  "847107": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Keotsa Baruari SO"
  },
  "846009": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Laxmisagar SO Darbhanga"
  },
  "847115": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Muria SO"
  },
  "847306": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Pindaruch SO"
  },
  "846005": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Postal Traning Centre SO"
  },
  "847307": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Ratanpur SO Darbhanga"
  },
  "847337": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Ryam Factory SO"
  },
  "846007": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Saramohanpur SO"
  },
  "847123": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Singhwara SO"
  },
  "847202": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Sahoparari SO"
  },
  "305813": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Arain S.O"
  },
  "305811": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Kuchil S.O"
  },
  "741123": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Padmamala BO"
  },
  "305004": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Regional College Ajmer S.O"
  },
  "786003": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Central Revenue Building S.O"
  },
  "786184": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Chabua S.O"
  },
  "786004": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Dibrugarh University S.O"
  },
  "786101": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Dikom S.O"
  },
  "786602": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Duliajan S.O"
  },
  "786614": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Jeypore S.O"
  },
  "786001": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Graham Bazar S.O"
  },
  "785676": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Khowang Ghat S.O"
  },
  "785675": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Khowang S.O"
  },
  "786010": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Lahoal S.O"
  },
  "786012": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Mohanbari Air Field S.O"
  },
  "786610": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Naharkatia S.O"
  },
  "786621": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Namrup S.O"
  },
  "786611": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Rajgarh (Dibrugarh) S.O"
  },
  "847101": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Anandpur SO"
  },
  "847203": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Biraul SO"
  },
  "845432": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Rajpur SO East Champaran"
  },
  "845433": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Ramgahrwa SO"
  },
  "845305": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Raxaul SO"
  },
  "845434": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Sangrampur SO East Champaran"
  },
  "845435": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Semra SO East Champaran"
  },
  "845456": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Sugauli SO"
  },
  "845436": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Tetaria Factory SO"
  },
  "845437": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Turkaulia SO"
  },
  "506103": {
    "state": "TELANGANA",
    "district": "MAHABUBABAD",
    "office": "Kambalapalli S.O"
  },
  "506007": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "K.M.College S.O"
  },
  "847303": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Jogiara SO"
  },
  "495663": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Gopal Nagar SO Chattisgarh Circle"
  },
  "501143": {
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "office": "Basheerabad S.O"
  },
  "501502": {
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "office": "Bompalli S.O"
  },
  "501158": {
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "office": "CCI Tandur S.O"
  },
  "524421": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Menakur S.O"
  },
  "524126": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Nayudupeta S.O"
  },
  "524323": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Nidiguntapalem S.O"
  },
  "524129": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Pellakur S.O"
  },
  "524345": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Podalakur S.O"
  },
  "524121": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Sullurpeta S.O"
  },
  "524408": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Rapur S.O"
  },
  "524313": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Mypadu S.O"
  },
  "524366": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Northrajupalem S.O"
  },
  "524303": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Revur S.O"
  },
  "524308": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Sangam S.O"
  },
  "524302": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Anantasagaram S.O"
  },
  "524002": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Stonehousepet S.O"
  },
  "524311": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Thotapalliguduru S.O"
  },
  "524318": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Vidavalur S.O"
  },
  "524319": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Kammapalem S.O"
  },
  "500036": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Osmannagar S.O"
  },
  "523171": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "A.B.V.Palem S.O"
  },
  "523190": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Idupulapadu S.O"
  },
  "523167": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Inkollu S.O"
  },
  "523181": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Kadavakuduru S.O"
  },
  "523184": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Pandillapalli S.O"
  },
  "523169": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Parchur S.O"
  },
  "523157": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Prasad Nagar So (C ) S.O"
  },
  "523185": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Santharavur S.O"
  },
  "523170": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Swarna S.O"
  },
  "847106": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Kansi Simri SO"
  },
  "845401": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Motihari HO"
  },
  "841302": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Purwari Telpa SO"
  },
  "786103": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Tengakhat S.O"
  },
  "786612": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Tingkhong S.O"
  },
  "787033": {
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "office": "Bhogpur Chariali S.O"
  },
  "784161": {
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "office": "Bihupuria S.O"
  },
  "787055": {
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "office": "Dhakuakhana S.O"
  },
  "503225": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Modtad S.O"
  },
  "503212": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Nandipet S.O"
  },
  "503219": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Sriramsagar Project S.O"
  },
  "503311": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Vailpur S.O"
  },
  "503223": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Zirayathnagar S.O"
  },
  "494635": {
    "state": "CHHATTISGARH",
    "district": "KANKER",
    "office": "Sambalpur S.O"
  },
  "494335": {
    "state": "CHHATTISGARH",
    "district": "KANKER",
    "office": "Sarona S.O"
  },
  "494332": {
    "state": "CHHATTISGARH",
    "district": "KANKER",
    "office": "Govindpur S.O."
  },
  "523281": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Gudluru S.O"
  },
  "523271": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Kamepalli S.O"
  },
  "500005": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "C.R.P. Camp S.O"
  },
  "500113": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Kandukur S.O"
  },
  "501359": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Mankhal S.O"
  },
  "501218": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Shamshabad S.O"
  },
  "500112": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Badangpet S.O"
  },
  "501506": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Ibrahimpatnam S.O"
  },
  "501510": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Ragannaguda X Road S.O"
  },
  "494111": {
    "state": "CHHATTISGARH",
    "district": "SUKMA",
    "office": "Sukma S.O"
  },
  "494442": {
    "state": "CHHATTISGARH",
    "district": "BASTAR",
    "office": "Tokapal Rajoor S.O"
  },
  "494115": {
    "state": "CHHATTISGARH",
    "district": "BASTAR",
    "office": "Tongpal S.O"
  },
  "507182": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Komminepalli S.O"
  },
  "507159": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Kusumanchi S.O"
  },
  "491441": {
    "state": "CHHATTISGARH",
    "district": "RAJNANDGAON",
    "office": "Rajnandgaon Stadium SO"
  },
  "535463": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Garugubilli S.O"
  },
  "535523": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Gummalakshmipuram S.O"
  },
  "503188": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Rudrur S.O"
  },
  "535594": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Jiyyammavalsa S.O"
  },
  "535521": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Komarada S.O"
  },
  "535524": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Kurupam S.O"
  },
  "535526": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Merangi S.O"
  },
  "535534": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Mondemkhallu S.O"
  },
  "535582": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "DATTIRAJERU S.O"
  },
  "488059": {
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "office": "Gunour S.O"
  },
  "212308": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "NTPC Kohdar Meja SO"
  },
  "522646": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Savalyapuram S.O"
  },
  "522401": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Siripuram S.O (Guntur)"
  },
  "533436": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Rajavommangi S.O"
  },
  "533291": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Rangampeta S.O"
  },
  "533446": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Sankhavaram S.O"
  },
  "533408": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Thondangi S.O"
  },
  "533401": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Ammajipeta S.O"
  },
  "501508": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Raipole S.O"
  },
  "501512": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Ramoji Film City S.O"
  },
  "501511": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Sanghinagar S.O"
  },
  "500039": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Uppal S.O"
  },
  "786008": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Mohanaghat S.O"
  },
  "786191": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Naoholia S.O"
  },
  "494448": {
    "state": "CHHATTISGARH",
    "district": "BIJAPUR",
    "office": "Madded S.O"
  },
  "508253": {
    "state": "TELANGANA",
    "district": "YADADRI BHUVANAGIRI",
    "office": "Narayanpur S.O"
  },
  "506003": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Bapujinagar S.O"
  },
  "534267": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Gummaluru S.O"
  },
  "848202": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Meghaul SO"
  },
  "851129": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Mirzapur Banduar SO"
  },
  "851130": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Naokothi SO"
  },
  "851203": {
    "state": "BIHAR",
    "district": "KHAGARIA",
    "office": "Jamalpur Gogri SO"
  },
  "851205": {
    "state": "BIHAR",
    "district": "KHAGARIA",
    "office": "Koshi College SO"
  },
  "502303": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Papannapet S.O"
  },
  "851212": {
    "state": "BIHAR",
    "district": "KHAGARIA",
    "office": "Mohaddipur SO Khagaria"
  },
  "851215": {
    "state": "BIHAR",
    "district": "KHAGARIA",
    "office": "Naya Gaon SO Begusarai"
  },
  "851216": {
    "state": "BIHAR",
    "district": "KHAGARIA",
    "office": "Parbatta SO"
  },
  "848203": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Sakarpura SO"
  },
  "851206": {
    "state": "BIHAR",
    "district": "KHAGARIA",
    "office": "Alauli S.O"
  },
  "852129": {
    "state": "BIHAR",
    "district": "SAHARSA",
    "office": "Sonbersa Raj SO"
  },
  "851131": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Rajaura SO"
  },
  "851117": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Refinery Township SO"
  },
  "851217": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Sahebpur Kamal SO"
  },
  "851132": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Sripur SO"
  },
  "851218": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Suhird Nagar SO"
  },
  "851133": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Teghra SO"
  },
  "851134": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Ullao SO"
  },
  "852219": {
    "state": "BIHAR",
    "district": "MADHEPURA",
    "office": "Shah Alam Nagar SO"
  },
  "852128": {
    "state": "BIHAR",
    "district": "MADHEPURA",
    "office": "Singheshwar SO"
  },
  "852132": {
    "state": "BIHAR",
    "district": "MADHEPURA",
    "office": "Shankarpur Bazar SO"
  },
  "852130": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Sukhpur SO"
  },
  "852131": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Supaul Bazar SO"
  },
  "534222": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Velpur S.O"
  },
  "534004": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Chataparru S.O"
  },
  "534425": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Bhimadole S.O"
  },
  "534448": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Buttayagudem S.O"
  },
  "852126": {
    "state": "BIHAR",
    "district": "SAHARSA",
    "office": "Salkhua Bazar SO"
  },
  "852127": {
    "state": "BIHAR",
    "district": "SAHARSA",
    "office": "Simri Bakhtiarpur SO"
  },
  "500090": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Pragathinagar S.O"
  },
  "524405": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Manubolu S.O"
  },
  "515741": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Belguppa S.O"
  },
  "532148": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Sigadam S.O"
  },
  "852221": {
    "state": "BIHAR",
    "district": "SAHARSA",
    "office": "Sour Bazar SO"
  },
  "532455": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Kotturu S.O"
  },
  "532457": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Nivagam S.O"
  },
  "518196": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Akumalla S.O"
  },
  "518543": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Allagadda MDG S.O"
  },
  "518124": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Banaganapalle South S.O"
  },
  "518523": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Bandi Atmakur S.O"
  },
  "518553": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Chagalamarri S.O"
  },
  "822124": {
    "state": "JHARKHAND",
    "district": "PALAMU",
    "office": "Rehala SO"
  },
  "822134": {
    "state": "JHARKHAND",
    "district": "GARHWA",
    "office": "Manjhiaon SO"
  },
  "533007": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Dairy Farm Center S.O"
  },
  "517505": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Perumallapalle S.O"
  },
  "508245": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Marriguda S.O"
  },
  "508244": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Munugode S.O"
  },
  "508373": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Nampalli S.O"
  },
  "508254": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Narkatpalli S.O"
  },
  "508266": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Pedavoora S.O"
  },
  "508002": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Ramagiri S.O"
  },
  "508256": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Gurrampode S.O"
  },
  "503217": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Balkonda S.O"
  },
  "500075": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "C.B.I.T S.O"
  },
  "500089": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Manikonda S.O"
  },
  "999999": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "TEST OFFICE"
  },
  "534406": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Chebrole S.O (West Godavari)"
  },
  "534460": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Chintalapudi S.O"
  },
  "534462": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Dharmajigudem S.O"
  },
  "534426": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Dwaraka Tirumala S.O"
  },
  "534455": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Gowrisankara Puram S.O"
  },
  "534456": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Jeelugumilli S.O"
  },
  "534449": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Kamavarapukota S.O"
  },
  "534311": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Kannapuram S.O"
  },
  "534312": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Koyyalagudem S.O"
  },
  "534475": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Vijayarai S.O"
  },
  "534451": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Lakkavaram S.O (West Godavari)"
  },
  "783385": {
    "state": "ASSAM",
    "district": "CHIRANG",
    "office": "Dhaligaon S.O"
  },
  "532187": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Bairisingupuram S.O"
  },
  "533440": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Samalkot H.O"
  },
  "518583": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Gajulapalle S.O"
  },
  "518593": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Kanala S.O"
  },
  "523331": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Pedda Dornala S.O"
  },
  "755025": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Barundai S.O"
  },
  "755004": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Binjharpur S.O"
  },
  "755005": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Brahmabarada S.O"
  },
  "755062": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Chitalo S.O"
  },
  "755026": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Dangadi S.O"
  },
  "848506": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Baghra SO Samastipur"
  },
  "848216": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Bihrha SO"
  },
  "848113": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Birouli Rural Institute SO"
  },
  "848207": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Bithan SO"
  },
  "802163": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Naya Mohamad  Pur SO"
  },
  "755007": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Debidwar S.O"
  },
  "755008": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Dharmasala S.O"
  },
  "755024": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Haridaspur S.O"
  },
  "755019": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Dolipur S.O"
  },
  "755023": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Jenapur S.O"
  },
  "753004": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Chauliaganj S.O"
  },
  "754131": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "KISHORENAGAR S.O"
  },
  "754021": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "JAGATPUR S.O"
  },
  "754130": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "SOMPUR S.O"
  },
  "755006": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Dasarathpur S.O"
  },
  "755009": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Kabirpur S.O"
  },
  "523346": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Pitikayagulla S.O"
  },
  "523328": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Pullala Cheruvu S.O"
  },
  "523368": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Racherla S.O"
  },
  "523369": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Rajupalem S.O (Prakasam)"
  },
  "384440": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Kadi SO"
  },
  "506310": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Panthani S.O"
  },
  "506314": {
    "state": "TELANGANA",
    "district": "WARANGAL RURAL",
    "office": "Raiparthy S.O"
  },
  "506166": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Mamnoor S.O"
  },
  "504299": {
    "state": "TELANGANA",
    "district": "KUMURAM BHEEM ASIFABAD",
    "office": "Sirpur S.O"
  },
  "506317": {
    "state": "TELANGANA",
    "district": "MAHABUBABAD",
    "office": "Peddavangara S.O"
  },
  "506008": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Fort Warangal S.O."
  },
  "506163": {
    "state": "TELANGANA",
    "district": "MAHABUBABAD",
    "office": "Turrur S.O"
  },
  "846004": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Darbhanga HO"
  },
  "385320": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Bhabhar SO"
  },
  "383030": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Gambhoi SO"
  },
  "385505": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Dantiwada Colony SO"
  },
  "385535": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Disa Mukhya Dak Ghar SO"
  },
  "495220": {
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "office": "Chakarbhata Camp SO"
  },
  "506318": {
    "state": "TELANGANA",
    "district": "MAHABUBABAD",
    "office": "Waddekothapally S.O"
  },
  "516104": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Chitvel S.O"
  },
  "517129": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Arugonda S.O"
  },
  "784175": {
    "state": "ASSAM",
    "district": "Biswanath",
    "office": "Sootea S.O"
  },
  "788815": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Kalain S.O"
  },
  "815352": {
    "state": "JHARKHAND",
    "district": "JAMTARA",
    "office": "Karmatar SO"
  },
  "518302": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Adoni Arts College S.O"
  },
  "518395": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Alur S.O (Kurnool)"
  },
  "518347": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Aspari S.O"
  },
  "518348": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Halaharvi S.O"
  },
  "518333": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Halvi S.O"
  },
  "518346": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Holalagondi S.O"
  },
  "518308": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Ingaladahal S.O"
  },
  "518350": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Kadivella S.O"
  },
  "518344": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Kavuthalam S.O"
  },
  "518313": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Kosigi S.O"
  },
  "518345": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Mantralaya S.O (Kurnool)"
  },
  "518343": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Nandavaram S.O"
  },
  "518396": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Nemakallu S.O"
  },
  "518380": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Pattikonda S.O"
  },
  "518323": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Peddakadubur S.O"
  },
  "517415": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Baireddipalle S.O"
  },
  "517416": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Bangarupalem S.O"
  },
  "517004": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Chittoor North S.O"
  },
  "517002": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Lalugardens S.O"
  },
  "517125": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Gangadhara Nellore S.O"
  },
  "506313": {
    "state": "TELANGANA",
    "district": "WARANGAL RURAL",
    "office": "Wardhannapet S.O"
  },
  "508223": {
    "state": "TELANGANA",
    "district": "SURYAPET",
    "office": "Tirumalgiri S.O"
  },
  "506316": {
    "state": "TELANGANA",
    "district": "JANGOAN",
    "office": "Zaffargadh S.O"
  },
  "759101": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Talcher Thermal S.O"
  },
  "506222": {
    "state": "TELANGANA",
    "district": "JANGOAN",
    "office": "Kodakondla S.O"
  },
  "506005": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Rangshaipet S.O"
  },
  "506333": {
    "state": "TELANGANA",
    "district": "WARANGAL RURAL",
    "office": "Duggondi S.O"
  },
  "509382": {
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "office": "Bhutpur S.O"
  },
  "509407": {
    "state": "TELANGANA",
    "district": "Narayanpet",
    "office": "Damargidda S.O"
  },
  "509204": {
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "office": "Devarkadra S.O"
  },
  "509205": {
    "state": "TELANGANA",
    "district": "Narayanpet",
    "office": "Dhanwada S.O"
  },
  "509334": {
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "office": "Hunwada S.O"
  },
  "509350": {
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "office": "Husnabad S.O"
  },
  "509002": {
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "office": "Ind. Estate S.O"
  },
  "509353": {
    "state": "TELANGANA",
    "district": "Narayanpet",
    "office": "Jaklair S.O"
  },
  "509371": {
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "office": "Koilkonda S.O"
  },
  "509339": {
    "state": "TELANGANA",
    "district": "Narayanpet",
    "office": "Kosgi S.O"
  },
  "509352": {
    "state": "TELANGANA",
    "district": "Narayanpet",
    "office": "Krishna S.O"
  },
  "508214": {
    "state": "TELANGANA",
    "district": "SURYAPET",
    "office": "I.E.Suryapet S.O"
  },
  "534461": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Pragadavaram S.O"
  },
  "534401": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Pulla S.O"
  },
  "534452": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Tadikalapudi S.O"
  },
  "851202": {
    "state": "BIHAR",
    "district": "KHAGARIA",
    "office": "Gogri SO"
  },
  "523370": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Ravipadu S.O (Prakasam)"
  },
  "523332": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Tarlupadu S.O"
  },
  "523371": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Thummalacheruvu S.O"
  },
  "523372": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Thurimella S.O"
  },
  "523320": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Tokapalle S.O"
  },
  "523326": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Tripurantakam S.O"
  },
  "523329": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Vemulakota S.O"
  },
  "518135": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Dornipadu S.O"
  },
  "802160": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Koilwar SO"
  },
  "802161": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Narhi Chandi SO"
  },
  "505503": {
    "state": "TELANGANA",
    "district": "JAYASHANKAR BHUPALAPALLY",
    "office": "Kataram S.O"
  },
  "754035": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Nuapatna S.O"
  },
  "754201": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Rameswar S.O"
  },
  "754030": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Tigiria S.O"
  },
  "518674": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Gospadu S.O"
  },
  "518134": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Koilakuntla Bus Stand S.O"
  },
  "518123": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Kolimigundla S.O"
  },
  "531118": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Krishna Bazar(Narsipatnam) S.O"
  },
  "517643": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Kovanur S.O"
  },
  "533464": {
    "state": "PUDUCHERRY",
    "district": "YANAM",
    "office": "Yanam S.O"
  },
  "533430": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Dharamavaram S.O"
  },
  "822125": {
    "state": "JHARKHAND",
    "district": "GARHWA",
    "office": "Ranka Raj SO"
  },
  "517589": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Nagalapuram S.O (Chittoor)"
  },
  "517590": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Nagari S.O"
  },
  "517591": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Nindra S.O"
  },
  "517620": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Pallam S.O"
  },
  "535593": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Mamidipalle S.O"
  },
  "535125": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Mettapalli S.O"
  },
  "535568": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Piridi S.O"
  },
  "535579": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Ramabhadrapuram S.O"
  },
  "535591": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Salur S.O"
  },
  "535128": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Chipurupalle S.O"
  },
  "535003": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Vzm R.S S.O"
  },
  "535546": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Seethanagaram S.O"
  },
  "535101": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Shreeramnagar S.O"
  },
  "508206": {
    "state": "TELANGANA",
    "district": "SURYAPET",
    "office": "Kodad S.O"
  },
  "508233": {
    "state": "TELANGANA",
    "district": "SURYAPET",
    "office": "Munagala S.O"
  },
  "508221": {
    "state": "TELANGANA",
    "district": "SURYAPET",
    "office": "Noothankal S.O"
  },
  "508279": {
    "state": "TELANGANA",
    "district": "SURYAPET",
    "office": "Nagaram S.O"
  },
  "508212": {
    "state": "TELANGANA",
    "district": "SURYAPET",
    "office": "Sirikonda S.O"
  },
  "508280": {
    "state": "TELANGANA",
    "district": "SURYAPET",
    "office": "Thungathurthi S.O"
  },
  "333010": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Churella S.O"
  },
  "508277": {
    "state": "TELANGANA",
    "district": "YADADRI BHUVANAGIRI",
    "office": "Mothcore S.O"
  },
  "508284": {
    "state": "TELANGANA",
    "district": "YADADRI BHUVANAGIRI",
    "office": "Pochampalli S.O"
  },
  "845307": {
    "state": "BIHAR",
    "district": "PASHCHIM CHAMPARAN",
    "office": "Sikta SO"
  },
  "824219": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Amas SO"
  },
  "824116": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Anti SO"
  },
  "824217": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Bankey Bajar SO"
  },
  "824201": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Barachatti SO"
  },
  "824111": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Amba SO"
  },
  "768204": {
    "state": "ODISHA",
    "district": "JHARSUGUDA",
    "office": "O.M.P. Line Jharsuguda S.O"
  },
  "524321": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Survepalli S.O"
  },
  "524407": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Sydapuram S.O"
  },
  "524401": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Tada S.O"
  },
  "524415": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Vakadu S.O"
  },
  "524320": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Venkatachalasatram S.O"
  },
  "524132": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Venkatagiri Town S.O"
  },
  "524413": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Vidyanagar S.O (Nellore)"
  },
  "524309": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Virur S.O"
  },
  "524402": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Vojili S.O"
  },
  "517130": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Iral S.O"
  },
  "517128": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Iruvaram S.O"
  },
  "517131": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Kanipakam S.O"
  },
  "517432": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Kolamasanapalle S.O"
  },
  "814165": {
    "state": "JHARKHAND",
    "district": "GODDA",
    "office": "Lalmatia Colliery SO"
  },
  "814154": {
    "state": "JHARKHAND",
    "district": "GODDA",
    "office": "Mahgama SO"
  },
  "516004": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Yerramukkapalli S.O"
  },
  "788164": {
    "state": "ASSAM",
    "district": "HAILAKANDI",
    "office": "Monacherra S.O"
  },
  "788168": {
    "state": "ASSAM",
    "district": "HAILAKANDI",
    "office": "Rajyeswarpur S.O"
  },
  "517640": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Panagal S.O"
  },
  "517586": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Pannur S.O (Chittoor)"
  },
  "517642": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Peddakannali S.O"
  },
  "517587": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Pissatur S.O"
  },
  "517583": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Puttur S.O"
  },
  "517588": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Satyavedu S.O"
  },
  "517571": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Sri Bommarajapuram S.O"
  },
  "517641": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Thondamanadu S.O"
  },
  "517541": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Varadaiahpalem S.O"
  },
  "517584": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Vepagunta S.O (Chittoor)"
  },
  "517619": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Yerpedu S.O"
  },
  "517561": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Kattakindavenkatapuram S.O"
  },
  "517569": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Pachikapallam S.O"
  },
  "755010": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Kaipara S.O"
  },
  "524347": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "AP Genco Nelatur SO"
  },
  "506002": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Warangal H.O"
  },
  "515291": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Neelakantapuram S.O"
  },
  "515261": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Parigi S.O"
  },
  "515124": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Peddamanthur S.O"
  },
  "515110": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Penukonda S.O"
  },
  "515305": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Rallahalli S.O"
  },
  "515123": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Roddam S.O"
  },
  "515122": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Somandepalli S.O"
  },
  "783330": {
    "state": "ASSAM",
    "district": "DHUBRI",
    "office": "Fakirganj S.O"
  },
  "533223": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Kothapeta S.O (East Godavari)"
  },
  "533254": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Lakkavaram S.O (East Godavari)"
  },
  "534245": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Viravasaram S.O"
  },
  "534126": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Alamuru S.O (West Godavari)"
  },
  "534123": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Atchanta S.O"
  },
  "534266": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Doddipatla S.O"
  },
  "534268": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Ellamanchili S.O"
  },
  "534265": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Jinnuru S.O"
  },
  "534338": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Kavitam S.O"
  },
  "534250": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Lankalakoderu S.O"
  },
  "534281": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Mogalturu S.O"
  },
  "534275": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Narsapur S.O (West Godavari)"
  },
  "506165": {
    "state": "TELANGANA",
    "district": "Mulugu",
    "office": "Eturunagaram S.O"
  },
  "506349": {
    "state": "TELANGANA",
    "district": "Mulugu",
    "office": "Mallampalli S.O"
  },
  "508112": {
    "state": "TELANGANA",
    "district": "YADADRI BHUVANAGIRI",
    "office": "Valigonda S.O"
  },
  "508286": {
    "state": "TELANGANA",
    "district": "YADADRI BHUVANAGIRI",
    "office": "Wangapalli S.O"
  },
  "508115": {
    "state": "TELANGANA",
    "district": "YADADRI BHUVANAGIRI",
    "office": "Yadgarpalli S.O"
  },
  "508252": {
    "state": "TELANGANA",
    "district": "YADADRI BHUVANAGIRI",
    "office": "Choutuppala S.O"
  },
  "506169": {
    "state": "TELANGANA",
    "district": "JAYASHANKAR BHUPALAPALLY",
    "office": "Bhupalapalli S.O"
  },
  "382315": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Rakhial RS SO"
  },
  "506356": {
    "state": "TELANGANA",
    "district": "JAYASHANKAR BHUPALAPALLY",
    "office": "Chityal S.O"
  },
  "506345": {
    "state": "TELANGANA",
    "district": "JAYASHANKAR BHUPALAPALLY",
    "office": "Ghanpur  S.O"
  },
  "504106": {
    "state": "TELANGANA",
    "district": "Nirmal",
    "office": "Nirmal S.O"
  },
  "534209": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Mogallu S.O"
  },
  "533297": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Gandepalli S.O"
  },
  "533296": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Adikavi Nannayya University Campus S.O"
  },
  "533354": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "INDUKURUPETA S.O"
  },
  "533353": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "DEWANCHERUVU S.O"
  },
  "851126": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Garhara SO"
  },
  "534467": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "T.Narasapuram S.O"
  },
  "506331": {
    "state": "TELANGANA",
    "district": "WARANGAL RURAL",
    "office": "Togarrai S.O"
  },
  "509338": {
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "office": "Kodangal S.O"
  },
  "508205": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Kattangur S.O"
  },
  "787023": {
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "office": "Naoboicha S.O"
  },
  "787052": {
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "office": "Panigaon S.O"
  },
  "787056": {
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "office": "Pathalipam S.O"
  },
  "523166": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Ipurupalem S.O"
  },
  "523168": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Karamchedu S.O"
  },
  "500064": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Bahadurpura S.O"
  },
  "524127": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Yellasiri S.O"
  },
  "523101": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "S.Konda S.O"
  },
  "523274": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Tanguturu Bus Stand S.O"
  },
  "523292": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Ulavapadu S.O"
  },
  "523279": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Uppalapadu (K) S.O"
  },
  "523116": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "V V Palem S.O"
  },
  "523272": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Vallur S.O (Prakasam)"
  },
  "523104": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Woollapalem S.O"
  },
  "523110": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Botlagudur S.O"
  },
  "523112": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "C.S.Puram S.O"
  },
  "523247": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Darsi S.O"
  },
  "523246": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Gotlagattu S.O"
  },
  "523227": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "H.M.Padu S.O"
  },
  "534280": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Sitaramapuram S.O"
  },
  "534217": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Iragavaram S.O"
  },
  "534330": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Khandavalli S.O"
  },
  "534218": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Mandapaka S.O"
  },
  "534227": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Mortha S.O"
  },
  "534320": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Penugonda Bazar S.O"
  },
  "534328": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Peravali S.O"
  },
  "534324": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Vadali S.O (West Godavari)"
  },
  "852137": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Surpatganj SO"
  },
  "852138": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Tharbitta SO"
  },
  "852139": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Triveniganj SO"
  },
  "852220": {
    "state": "BIHAR",
    "district": "MADHEPURA",
    "office": "Udakishunganj SO"
  },
  "523241": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Konakana Metla S.O"
  },
  "523304": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Kurichedu S.O"
  },
  "523223": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Mogallur S.O"
  },
  "523265": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Mundlamur S.O"
  },
  "524404": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Bangarupeta S.O"
  },
  "524341": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Chejerla S.O"
  },
  "524406": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Chennur S.O (Nellore)"
  },
  "524412": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Chillakur S.O"
  },
  "508211": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Nakrekal S.O"
  },
  "508210": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Vallala S.O"
  },
  "755028": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Kalaringatta S.O"
  },
  "755022": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Korei S.O"
  },
  "755011": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Mangalpur S.O (Jajapur)"
  },
  "755012": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Mashra S.O"
  },
  "754246": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Madanpur S.O (Kendrapara)"
  },
  "754224": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Mahakalpara S.O"
  },
  "754213": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Marsaghai S.O"
  },
  "754231": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Namouza S.O"
  },
  "754227": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Olavar S.O"
  },
  "754215": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Pattamundai S.O"
  },
  "755061": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Govindpur Kutchery S.O"
  },
  "509202": {
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "office": "Balanagar S.O"
  },
  "752001": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Manikarnika S.O"
  },
  "226001": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Lalbagh SO Lucknow"
  },
  "509321": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Amangal S.O"
  },
  "534444": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "KUKUNOOR SO"
  },
  "534244": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Vissakoderu S.O"
  },
  "534236": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Yelurupadu S.O"
  },
  "508255": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Chandur S.O"
  },
  "508105": {
    "state": "TELANGANA",
    "district": "YADADRI BHUVANAGIRI",
    "office": "Raghunathpur S.O"
  },
  "508113": {
    "state": "TELANGANA",
    "district": "YADADRI BHUVANAGIRI",
    "office": "Ramannapeta S.O"
  },
  "508285": {
    "state": "TELANGANA",
    "district": "YADADRI BHUVANAGIRI",
    "office": "Tekulasomaram S.O"
  },
  "506367": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Maddur S.O"
  },
  "509133": {
    "state": "TELANGANA",
    "district": "JOGULAMBA GADWAL",
    "office": "Krishna Nagar S.O"
  },
  "509128": {
    "state": "TELANGANA",
    "district": "JOGULAMBA GADWAL",
    "office": "Manavapad S.O"
  },
  "509132": {
    "state": "TELANGANA",
    "district": "JOGULAMBA GADWAL",
    "office": "Muldakal S.O"
  },
  "509126": {
    "state": "TELANGANA",
    "district": "JOGULAMBA GADWAL",
    "office": "Rajoli S.O"
  },
  "509153": {
    "state": "TELANGANA",
    "district": "JOGULAMBA GADWAL",
    "office": "Undavelly S.O"
  },
  "502221": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Charakpally S.O"
  },
  "502278": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Gujvail S.O"
  },
  "502267": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Ibrahimnagar S.O"
  },
  "788738": {
    "state": "ASSAM",
    "district": "HAILAKANDI",
    "office": "BIDYANAGAR S.O"
  },
  "815357": {
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "office": "Karogram SO"
  },
  "788160": {
    "state": "ASSAM",
    "district": "HAILAKANDI",
    "office": "Jaffirband S.O"
  },
  "524134": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Dakkili S.O"
  },
  "524414": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Gundavolu S.O"
  },
  "524131": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Jayampu S.O"
  },
  "524410": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Kadivedu S.O"
  },
  "524409": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Kalichedu S.O"
  },
  "524343": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Kaluvoya S.O"
  },
  "524203": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Anemadugu S.O"
  },
  "524201": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Kavali Bazar S.O"
  },
  "500030": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Rajendranagar S.O"
  },
  "523135": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Chinaganjam S.O"
  },
  "523165": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Jandrapet S.O"
  },
  "523187": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Vetapalem S.O"
  },
  "752004": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Baliguali S.O"
  },
  "822111": {
    "state": "JHARKHAND",
    "district": "LATEHAR",
    "office": "Barwadih SO"
  },
  "533451": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Tatiparthi S.O"
  },
  "508250": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Chintapalli S.O"
  },
  "508114": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Chityala S.O"
  },
  "508248": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Gandhinagar S.O"
  },
  "534146": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Prattipadu S.O"
  },
  "522409": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Atchampet S.O"
  },
  "813101": {
    "state": "BIHAR",
    "district": "BANKA",
    "office": "Amarpur SO Banka"
  },
  "522015": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Abbineniguntapalem S.O"
  },
  "522017": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Etukuru S.O"
  },
  "522005": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Nallapadu S.O"
  },
  "522235": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Pedanandipadu S.O"
  },
  "522019": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Prathipadu S.O (Guntur)"
  },
  "522020": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Amaravathi S.O"
  },
  "522502": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "K.C.Works S.O"
  },
  "522016": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Lemalle S.O"
  },
  "522508": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Namburu S.O"
  },
  "522303": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Nutakki S.O"
  },
  "522509": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Pedakakani S.O"
  },
  "522305": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Pedapalem S.O"
  },
  "522240": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "SRM University S.O"
  },
  "522659": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Ainavole S.O"
  },
  "522663": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Bandlamottu S.O"
  },
  "522616": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Subbaiah Thota S.O"
  },
  "522612": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Durgi S.O"
  },
  "522233": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Edlapadu S.O"
  },
  "534316": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Gopalapuram S.O (West Godavari)"
  },
  "522302": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Pedavadlapudi S.O"
  },
  "522018": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Ponnekallu S.O"
  },
  "522410": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Krosuru S.O"
  },
  "522435": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Machavaram S.O (Narasaraopet)"
  },
  "522426": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Macherla S.O (Guntur)"
  },
  "522438": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Medikonduru S.O"
  },
  "522408": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Muppalla S.O (Guntur)"
  },
  "841420": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Rajapatti SO"
  },
  "841423": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Sidhwalia SO"
  },
  "814160": {
    "state": "JHARKHAND",
    "district": "GODDA",
    "office": "Meharma SO"
  },
  "814147": {
    "state": "JHARKHAND",
    "district": "GODDA",
    "office": "Pathergama SO"
  },
  "814153": {
    "state": "JHARKHAND",
    "district": "GODDA",
    "office": "Poraiyahat SO"
  },
  "814151": {
    "state": "JHARKHAND",
    "district": "DUMKA",
    "office": "Saraiyahat SO"
  },
  "781335": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Nalbari H.O"
  },
  "814156": {
    "state": "JHARKHAND",
    "district": "GODDA",
    "office": "Sarouni Bazar SO"
  },
  "534450": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Gopannapalem S.O"
  },
  "534435": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Pedavegi"
  },
  "504202": {
    "state": "TELANGANA",
    "district": "Nirmal",
    "office": "Peddur S.O"
  },
  "504105": {
    "state": "TELANGANA",
    "district": "Nirmal",
    "office": "Soan S.O"
  },
  "382122": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Dantali B.O"
  },
  "504101": {
    "state": "TELANGANA",
    "district": "Nirmal",
    "office": "Basar S.O"
  },
  "504103": {
    "state": "TELANGANA",
    "district": "Nirmal",
    "office": "Bhainsa S.O"
  },
  "504110": {
    "state": "TELANGANA",
    "district": "Nirmal",
    "office": "Chincholi  S.O"
  },
  "504306": {
    "state": "TELANGANA",
    "district": "Nirmal",
    "office": "Dilawarpur S.O"
  },
  "504109": {
    "state": "TELANGANA",
    "district": "Nirmal",
    "office": "Kuntala S.O"
  },
  "504310": {
    "state": "TELANGANA",
    "district": "Nirmal",
    "office": "Mamda S.O"
  },
  "508258": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Dindi Project S.O"
  },
  "508257": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Gudipally S.O"
  },
  "508377": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Halia S.O"
  },
  "508202": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Hillcolony S.O"
  },
  "508243": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Kondamallepalli S.O"
  },
  "533228": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Vanapalli S.O"
  },
  "533218": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Peruru S.O"
  },
  "385421": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Memadpur SO"
  },
  "144402": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "Satnampura SO"
  },
  "847201": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Bahera SO"
  },
  "783124": {
    "state": "ASSAM",
    "district": "GOALPARA",
    "office": "Dudhnoi S.O"
  },
  "504323": {
    "state": "TELANGANA",
    "district": "ADILABAD",
    "office": "Neradigonda S.O"
  },
  "504311": {
    "state": "TELANGANA",
    "district": "ADILABAD",
    "office": "Ootnur S.O"
  },
  "504312": {
    "state": "TELANGANA",
    "district": "ADILABAD",
    "office": "Tamsi S.O"
  },
  "504293": {
    "state": "TELANGANA",
    "district": "KUMURAM BHEEM ASIFABAD",
    "office": "Asifabad S.O"
  },
  "847103": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Benipur SO"
  },
  "480997": {
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "office": "Ghansore S.O"
  },
  "521225": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Gollapudi S.O"
  },
  "605403": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Valudareddy S.O"
  },
  "202001": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Sarai Khirni SO"
  },
  "521235": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Tiruvuru S.O"
  },
  "521110": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Veeravalli S.O"
  },
  "521185": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Nandigama S.O"
  },
  "522436": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Parastyalluru S.O"
  },
  "522402": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Pedakurapadu S.O"
  },
  "522413": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Piduguralla S.O"
  },
  "522412": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Rajupalem S.O (Guntur)"
  },
  "522421": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Rentachintala S.O"
  },
  "522613": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Veldurthy S.O"
  },
  "504251": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Bellampalli R.S. S.O"
  },
  "504102": {
    "state": "TELANGANA",
    "district": "Nirmal",
    "office": "Mudhole S.O"
  },
  "504203": {
    "state": "TELANGANA",
    "district": "Nirmal",
    "office": "Khanapur S.O"
  },
  "504104": {
    "state": "TELANGANA",
    "district": "Nirmal",
    "office": "Narsapur S.O"
  },
  "507167": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Tallada S.O"
  },
  "507170": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Tallampahad S.O"
  },
  "507305": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Tanikella S.O"
  },
  "507163": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Tirumalayapalem S.O"
  },
  "507318": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "V.V.Palem S.O"
  },
  "507165": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Wyra S.O"
  },
  "521260": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Manikonda S.O"
  },
  "521330": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Angaluru S.O"
  },
  "521324": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Bantumilli S.O"
  },
  "505530": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Thotapalli S.O"
  },
  "226003": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Sarfraj SO"
  },
  "505303": {
    "state": "TELANGANA",
    "district": "RAJANNA SIRCILLA",
    "office": "Kishandaspet S.O"
  },
  "505403": {
    "state": "TELANGANA",
    "district": "RAJANNA SIRCILLA",
    "office": "Marripalli S.O"
  },
  "505404": {
    "state": "TELANGANA",
    "district": "RAJANNA SIRCILLA",
    "office": "Mustabad S.O"
  },
  "505305": {
    "state": "TELANGANA",
    "district": "RAJANNA SIRCILLA",
    "office": "Racherla Boppapur S.O"
  },
  "505307": {
    "state": "TELANGANA",
    "district": "RAJANNA SIRCILLA",
    "office": "Rudrangi S.O"
  },
  "505301": {
    "state": "TELANGANA",
    "district": "RAJANNA SIRCILLA",
    "office": "Sirsilla S.O"
  },
  "814111": {
    "state": "JHARKHAND",
    "district": "PAKUR",
    "office": "Amrapara SO"
  },
  "754220": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Rajkanika S.O"
  },
  "521004": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Krishna University S.O"
  },
  "284001": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Jhansi Sadar Bazar SO"
  },
  "521366": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Pedana S.O"
  },
  "811301": {
    "state": "BIHAR",
    "district": "JAMUI",
    "office": "Aliganj SO Jamui"
  },
  "811303": {
    "state": "BIHAR",
    "district": "JAMUI",
    "office": "Chakai SO"
  },
  "815355": {
    "state": "JHARKHAND",
    "district": "JAMTARA",
    "office": "Nala SO"
  },
  "788120": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Bhaga Bazar S.O"
  },
  "815359": {
    "state": "JHARKHAND",
    "district": "JAMTARA",
    "office": "Kundahit SO"
  },
  "815354": {
    "state": "JHARKHAND",
    "district": "JAMTARA",
    "office": "Mihijam SO"
  },
  "848114": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Dalsingsarai Bazar SO"
  },
  "754225": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Rajnagar S.O (Kendrapara)"
  },
  "754212": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Sribaldevjew S.O"
  },
  "754250": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Thakurpatna S.O"
  },
  "505467": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Husnabad S.O"
  },
  "505469": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Manakondur S.O"
  },
  "523291": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Ramapatnam S.O"
  },
  "845107": {
    "state": "BIHAR",
    "district": "PASHCHIM CHAMPARAN",
    "office": "Valmiki Nagar SO"
  },
  "841440": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Thawe SO"
  },
  "841416": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Kishunpura SO"
  },
  "845101": {
    "state": "BIHAR",
    "district": "PASHCHIM CHAMPARAN",
    "office": "Bagaha SO"
  },
  "845438": {
    "state": "BIHAR",
    "district": "PASHCHIM CHAMPARAN",
    "office": "Lal Bazar Bettiah SO"
  },
  "804401": {
    "state": "BIHAR",
    "district": "ARWAL",
    "office": "Arwal SO"
  },
  "534122": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Maruteru S.O"
  },
  "534327": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Poduru S.O"
  },
  "534230": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Aravalli S.O"
  },
  "752119": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Lataharan"
  },
  "752107": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Nayahat"
  },
  "752106": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Dola Bedi Chhak NDT"
  },
  "752104": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Pipili SO"
  },
  "505306": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "Ambaripet S.O"
  },
  "521320": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Kruthivennu SO"
  },
  "636705": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Vennampatti H.B S.O"
  },
  "804432": {
    "state": "BIHAR",
    "district": "JEHANABAD",
    "office": "Bandhuganj SO"
  },
  "804405": {
    "state": "BIHAR",
    "district": "JEHANABAD",
    "office": "Dharaut SO"
  },
  "504304": {
    "state": "TELANGANA",
    "district": "ADILABAD",
    "office": "Boath S.O"
  },
  "504002": {
    "state": "TELANGANA",
    "district": "ADILABAD",
    "office": "Dasnapur Colony  D.S.O"
  },
  "504307": {
    "state": "TELANGANA",
    "district": "ADILABAD",
    "office": "Echoda S.O"
  },
  "754200": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Bahugram S.O"
  },
  "841231": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Andar SO"
  },
  "841227": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Gaushalaroad Siwan SO"
  },
  "841434": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Goreakothi SO"
  },
  "841435": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Guthni SO"
  },
  "841236": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Hasanpura SO"
  },
  "841238": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Mahrajganj SO Siwan"
  },
  "841240": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Mahuwal Mahal SO"
  },
  "841239": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Mairwa SO"
  },
  "841507": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Mora SO Siwan"
  },
  "841439": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Mustfabad SO"
  },
  "841241": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Pachrukhi SO"
  },
  "841504": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Raghunathpur SO Siwan"
  },
  "841243": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Sahpur SO"
  },
  "841226": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Satation Road SO"
  },
  "841244": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Takipur SO"
  },
  "841506": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Tarwara SO"
  },
  "522034": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Industrial Estate S.O (Guntur)"
  },
  "522112": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Kakumanu S.O"
  },
  "522619": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Ganapavaram S.O (Guntur)"
  },
  "524342": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Dachur S.O"
  },
  "847428": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Bharathi SO"
  },
  "788101": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Banskandi S.O"
  },
  "788126": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Binnakandi Ghat S.O"
  },
  "788111": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Dalu S.O"
  },
  "788114": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Dholai Bazar S.O"
  },
  "788106": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Fulertal S.O"
  },
  "788123": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Bekirpar S.O"
  },
  "788110": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Borkhola S.O"
  },
  "500052": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "S.V.P.N.P.A. S.O"
  },
  "500079": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Hasthinapuram S.O"
  },
  "523230": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Kanigiri S.O"
  },
  "523253": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Uppalapadu (P) S.O"
  },
  "523224": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Veligandla S.O"
  },
  "509129": {
    "state": "TELANGANA",
    "district": "JOGULAMBA GADWAL",
    "office": "Macherla S.O"
  },
  "751002": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Santarapur S.O"
  },
  "504308": {
    "state": "TELANGANA",
    "district": "ADILABAD",
    "office": "Gudihatnoor S.O"
  },
  "504309": {
    "state": "TELANGANA",
    "district": "ADILABAD",
    "office": "Gumma S.O"
  },
  "504346": {
    "state": "TELANGANA",
    "district": "ADILABAD",
    "office": "Indervelli S.O"
  },
  "504313": {
    "state": "TELANGANA",
    "district": "KUMURAM BHEEM ASIFABAD",
    "office": "Jainoor S.O"
  },
  "824236": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Tekari SO"
  },
  "804435": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Main SO"
  },
  "804402": {
    "state": "BIHAR",
    "district": "ARWAL",
    "office": "Baidrabad SO"
  },
  "804419": {
    "state": "BIHAR",
    "district": "ARWAL",
    "office": "Karpi SO"
  },
  "804421": {
    "state": "BIHAR",
    "district": "ARWAL",
    "office": "Kurtha SO"
  },
  "804423": {
    "state": "BIHAR",
    "district": "ARWAL",
    "office": "Nagla Kinger SO"
  },
  "804426": {
    "state": "BIHAR",
    "district": "ARWAL",
    "office": "SP Imamganj SO"
  },
  "804428": {
    "state": "BIHAR",
    "district": "ARWAL",
    "office": "Usari SO"
  },
  "804406": {
    "state": "BIHAR",
    "district": "JEHANABAD",
    "office": "Ghosi SO Jehanabad"
  },
  "804417": {
    "state": "BIHAR",
    "district": "JEHANABAD",
    "office": "Jehanabad RS SO"
  },
  "804418": {
    "state": "BIHAR",
    "district": "JEHANABAD",
    "office": "Kako SO"
  },
  "804420": {
    "state": "BIHAR",
    "district": "JEHANABAD",
    "office": "Kazisarai SO"
  },
  "852108": {
    "state": "BIHAR",
    "district": "MADHEPURA",
    "office": "Gamaharia SO"
  },
  "852109": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Ganpatganj SO Supaul"
  },
  "852110": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Garh Baruari SO"
  },
  "852115": {
    "state": "BIHAR",
    "district": "MADHEPURA",
    "office": "Gwalpara SO"
  },
  "804422": {
    "state": "BIHAR",
    "district": "JEHANABAD",
    "office": "Makhdumpur SO"
  },
  "804429": {
    "state": "BIHAR",
    "district": "JEHANABAD",
    "office": "Nehalpur SO"
  },
  "804424": {
    "state": "BIHAR",
    "district": "JEHANABAD",
    "office": "Paibigha SO"
  },
  "804425": {
    "state": "BIHAR",
    "district": "JEHANABAD",
    "office": "Sakurabad SO"
  },
  "804427": {
    "state": "BIHAR",
    "district": "JEHANABAD",
    "office": "Tehta SO"
  },
  "494001": {
    "state": "CHHATTISGARH",
    "district": "BASTAR",
    "office": "Jagdalpur Sadar Bzr S.O"
  },
  "502291": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Sadasivpet S.O"
  },
  "500008": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Toli Chowki S.O"
  },
  "507203": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Madhira S.O"
  },
  "507160": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Nelakondapalli S.O"
  },
  "533355": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "GANGAVARAM S.O"
  },
  "534416": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Kaikaram S.O"
  },
  "522009": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Perecherla Junction S.O"
  },
  "505453": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "Medpalli S.O"
  },
  "505325": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "Metpalli S.O"
  },
  "505331": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "Muthyampet S.O"
  },
  "505454": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "Nerella S.O"
  },
  "505455": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "Pochampad Project Colony S.O"
  },
  "505462": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "Sirikonda S.O"
  },
  "505405": {
    "state": "TELANGANA",
    "district": "RAJANNA SIRCILLA",
    "office": "Tadoor S.O"
  },
  "505302": {
    "state": "TELANGANA",
    "district": "RAJANNA SIRCILLA",
    "office": "Vemulawada S.O"
  },
  "505524": {
    "state": "TELANGANA",
    "district": "RAJANNA SIRCILLA",
    "office": "Boenpalli S.O"
  },
  "505402": {
    "state": "TELANGANA",
    "district": "RAJANNA SIRCILLA",
    "office": "Ellanthakunta S.O"
  },
  "505002": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Mukharampura S.O"
  },
  "505304": {
    "state": "TELANGANA",
    "district": "RAJANNA SIRCILLA",
    "office": "Gambhiraopet S.O"
  },
  "505466": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Anthakpet S.O"
  },
  "505528": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Bejjanki S.O"
  },
  "505415": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Choppadandi S.O"
  },
  "505401": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Elgandal S.O"
  },
  "505445": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Gangadhara S.O"
  },
  "507183": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Pindipolu S.O"
  },
  "507304": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Siripuram S.O"
  },
  "507161": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Subled S.O"
  },
  "755044": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Chandikhol S.O"
  },
  "509135": {
    "state": "TELANGANA",
    "district": "JOGULAMBA GADWAL",
    "office": "Uppal Camp S.O"
  },
  "506244": {
    "state": "TELANGANA",
    "district": "JANGOAN",
    "office": "Raghunath Pally S.O"
  },
  "534269": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Kodamanchili S.O"
  },
  "502251": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Hadnur S.O"
  },
  "502249": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Mirzapur S.O"
  },
  "502286": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Narayankhed S.O"
  },
  "502256": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Nyalkal S.O"
  },
  "502257": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Raikode S.O"
  },
  "502318": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Ranjhole S.O"
  },
  "508374": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Madgulapally S.O"
  },
  "509335": {
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "office": "Kulakcherla S.O"
  },
  "505451": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Kothapalli S.O"
  },
  "535547": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Makkuva S.O"
  },
  "841245": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Zeradei SO"
  },
  "502287": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Sirgapur S.O"
  },
  "502246": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Zarasangam S.O"
  },
  "534216": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Vundrajavaram S.O"
  },
  "534124": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Penumantra S.O"
  },
  "534225": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Relangi S.O"
  },
  "814143": {
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "office": "Kunda SO Deoghar"
  },
  "815353": {
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "office": "Madhupur Bazar SO"
  },
  "814152": {
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "office": "Rohani SO"
  },
  "523201": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Ramnagar(A) S.O"
  },
  "505481": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Nustulapur S.O"
  },
  "505531": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Ramadugu S.O"
  },
  "505473": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Shanigaram S.O"
  },
  "506347": {
    "state": "TELANGANA",
    "district": "Mulugu",
    "office": "Pasra S.O"
  },
  "506142": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Madikonda S.O"
  },
  "506151": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Peddapendyal S.O"
  },
  "506144": {
    "state": "TELANGANA",
    "district": "JANGOAN",
    "office": "Abadighanpur S.O"
  },
  "506143": {
    "state": "TELANGANA",
    "district": "JANGOAN",
    "office": "Ghanpur Station S.O"
  },
  "506172": {
    "state": "TELANGANA",
    "district": "Mulugu",
    "office": "Kamalapur Town Ship S.O"
  },
  "506319": {
    "state": "TELANGANA",
    "district": "WARANGAL RURAL",
    "office": "Shayampet S.O"
  },
  "505452": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "Mallial S.O"
  },
  "753008": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Madhusudan Nagar S.O (Cuttack)"
  },
  "755015": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Sankhachilla S.O"
  },
  "506370": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Waddepalli S.O"
  },
  "523180": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Ammanabrolu S.O"
  },
  "509130": {
    "state": "TELANGANA",
    "district": "WANAPARTHY",
    "office": "Amerchinta S.O"
  },
  "509131": {
    "state": "TELANGANA",
    "district": "WANAPARTHY",
    "office": "Atmacore S.O"
  },
  "383001": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Hajipura SO"
  },
  "508234": {
    "state": "TELANGANA",
    "district": "SURYAPET",
    "office": "Nadigudem S.O"
  },
  "516108": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Obulavaripalli S.O"
  },
  "508376": {
    "state": "TELANGANA",
    "district": "SURYAPET",
    "office": "Tekumatla S.O"
  },
  "506329": {
    "state": "TELANGANA",
    "district": "WARANGAL RURAL",
    "office": "Sangam S.O"
  },
  "508004": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "S.L.B.C Campcolny Gandamvarigudem S.O"
  },
  "841237": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Hussainganj SO"
  },
  "841502": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Khujhwa SO"
  },
  "384241": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Mujpur SO"
  },
  "754114": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Mandasahi S.O"
  },
  "505504": {
    "state": "TELANGANA",
    "district": "JAYASHANKAR BHUPALAPALLY",
    "office": "Mahadeopur S.O"
  },
  "535592": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Pachipenta S.O"
  },
  "385340": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Radhanpur Rajgadhi SO"
  },
  "384275": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Ranuj SO"
  },
  "384245": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Sami SO"
  },
  "384246": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Sankheshwar SO"
  },
  "385350": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Santalpur SO"
  },
  "841242": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Paterhi SO"
  },
  "841287": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Asaon SO"
  },
  "755051": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Rasulpur S.O"
  },
  "509219": {
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "office": "Koukuntla S.O"
  },
  "508201": {
    "state": "TELANGANA",
    "district": "SURYAPET",
    "office": "Garidepally S.O"
  },
  "508204": {
    "state": "TELANGANA",
    "district": "SURYAPET",
    "office": "Huzurnagar S.O"
  },
  "508246": {
    "state": "TELANGANA",
    "district": "SURYAPET",
    "office": "Medlacheruvu S.O"
  },
  "508218": {
    "state": "TELANGANA",
    "district": "SURYAPET",
    "office": "Nereducharla S.O"
  },
  "508224": {
    "state": "TELANGANA",
    "district": "SURYAPET",
    "office": "Arvapalli S.O"
  },
  "508238": {
    "state": "TELANGANA",
    "district": "SURYAPET",
    "office": "Gudibanda S.O"
  },
  "517193": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Chinnagottigallu S.O"
  },
  "517277": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Chintaparthi S.O"
  },
  "506145": {
    "state": "TELANGANA",
    "district": "JANGOAN",
    "office": "Malkapur S.O"
  },
  "506221": {
    "state": "TELANGANA",
    "district": "JANGOAN",
    "office": "Buchannapet S.O"
  },
  "506301": {
    "state": "TELANGANA",
    "district": "JANGOAN",
    "office": "Chagal S.O"
  },
  "506223": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Chiryal S.O"
  },
  "506302": {
    "state": "TELANGANA",
    "district": "JANGOAN",
    "office": "Devaruppal S.O"
  },
  "506252": {
    "state": "TELANGANA",
    "district": "JANGOAN",
    "office": "Ippaguda S.O"
  },
  "506348": {
    "state": "TELANGANA",
    "district": "JAYASHANKAR BHUPALAPALLY",
    "office": "Regonda S.O"
  },
  "517581": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Narayanavaram S.O"
  },
  "517113": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Kallur S.O (Chittoor)"
  },
  "517235": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Mahal S.O (Chittoor)"
  },
  "517172": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Mangalampet S.O"
  },
  "517237": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Medikurthi S.O"
  },
  "517102": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Narasingapuram S.O (Chittoor)"
  },
  "517112": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Pakala S.O"
  },
  "517214": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Nehru Bazar (Piler) S.O"
  },
  "517192": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Rompicherla S.O (Chittoor)"
  },
  "517291": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Tarigonda S.O"
  },
  "517299": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Vayalpad S.O"
  },
  "517536": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Akkurthi S.O"
  },
  "517645": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Buchinaidu Kandriga S.O"
  },
  "534326": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Sidhantam S.O"
  },
  "502314": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Sirpura S.O"
  },
  "506391": {
    "state": "TELANGANA",
    "district": "WARANGAL RURAL",
    "office": "Nadikuda S.O"
  },
  "754228": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Patakura S.O (Kendrapara)"
  },
  "754245": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Barpada S.O"
  },
  "534411": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Vunguturu S.O (West Godavari)"
  },
  "505450": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "Ibrahimpatnam S.O"
  },
  "518385": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Maddikera S.O"
  },
  "384272": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Sariyad SO"
  },
  "384151": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Sidhpur SO"
  },
  "385360": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Varahi SO"
  },
  "384285": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Wagdod SO"
  },
  "755049": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Kantigadia S.O"
  },
  "515621": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Perur S.O (Ananthapur)"
  },
  "523226": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Chimakurty S.O"
  },
  "523280": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Ethamukkala S.O"
  },
  "523182": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Karavadi S.O"
  },
  "523303": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Kommalapadu S.O"
  },
  "523212": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "M.M.T. Road S.O"
  },
  "523211": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Maddipadu S.O"
  },
  "523301": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Marturu S.O"
  },
  "505527": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Lower Manair Dam Colony S.O"
  },
  "509358": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Kadthal S.O"
  },
  "505526": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "Endapalli S.O"
  },
  "505532": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "Gollapalli S.O"
  },
  "502295": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "P.R.Pally Chowrasta S.O"
  },
  "502345": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Kamkole S.O"
  },
  "502281": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Jagadevpur S.O"
  },
  "502276": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Kodurkurd S.O"
  },
  "502372": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Kondapak S.O"
  },
  "502301": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Kuknoorpally S.O"
  },
  "502280": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Nangnoor S.O"
  },
  "787026": {
    "state": "ASSAM",
    "district": "DHEMAJI",
    "office": "Bordoloni S.O"
  },
  "787059": {
    "state": "ASSAM",
    "district": "DHEMAJI",
    "office": "Silapathar S.O"
  },
  "509152": {
    "state": "TELANGANA",
    "district": "JOGULAMBA GADWAL",
    "office": "Alampur S.O"
  },
  "509127": {
    "state": "TELANGANA",
    "district": "JOGULAMBA GADWAL",
    "office": "Ieeja S.O"
  },
  "508278": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Nidamanoor S.O"
  },
  "393140": {
    "state": "GUJARAT",
    "district": "NARMADA",
    "office": "Pratap Nagar SO Narmada"
  },
  "393145": {
    "state": "GUJARAT",
    "district": "NARMADA",
    "office": "Rajpipla SO"
  },
  "508208": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "NSP Camp Miryalaguda S.O"
  },
  "508247": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Thipparthi S.O"
  },
  "841505": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Sasamusa SO"
  },
  "533352": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Nellipaka S.O"
  },
  "491888": {
    "state": "CHHATTISGARH",
    "district": "RAJNANDGAON",
    "office": "Gandai Pandaria SO"
  },
  "508101": {
    "state": "TELANGANA",
    "district": "YADADRI BHUVANAGIRI",
    "office": "Alir S.O"
  },
  "517526": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Papanaidupet S.O"
  },
  "509409": {
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "office": "Lalkot S.O"
  },
  "509411": {
    "state": "TELANGANA",
    "district": "Narayanpet",
    "office": "Maddur S.O"
  },
  "508355": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Wadapally S.O"
  },
  "505184": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Manthani S.O"
  },
  "505174": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "P.P Colony S.O"
  },
  "505208": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Ramagundam S.O"
  },
  "505185": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Sultanabad S.O"
  },
  "505416": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Dharmaram S.O"
  },
  "754008": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Banki S.O"
  },
  "508111": {
    "state": "TELANGANA",
    "district": "YADADRI BHUVANAGIRI",
    "office": "Atmakur S.O"
  },
  "502102": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Nizampet S.O"
  },
  "502375": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Palamakula S.O"
  },
  "502279": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Pamulaparthy S.O"
  },
  "502311": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Pregnapur S.O"
  },
  "502210": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Kohir S.O"
  },
  "502228": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Madhunagar S.O"
  },
  "521122": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Gandhikshetram S.O"
  },
  "521133": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Ghantasala S.O"
  },
  "521136": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "K.P.Centre S.O"
  },
  "517582": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Karvetinagar S.O"
  },
  "517520": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Renigunta S.O"
  },
  "517502": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "S.V.University S.O"
  },
  "517503": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Tiruchanoor S.O"
  },
  "517501": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Tirupati West S.O"
  },
  "508217": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Vemulapally S.O"
  },
  "509208": {
    "state": "TELANGANA",
    "district": "Narayanpet",
    "office": "Makthal S.O"
  },
  "509351": {
    "state": "TELANGANA",
    "district": "Narayanpet",
    "office": "Marrikal S.O"
  },
  "509337": {
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "office": "Mohammadabad S.O"
  },
  "509210": {
    "state": "TELANGANA",
    "district": "Narayanpet",
    "office": "Narayanpet S.O"
  },
  "509340": {
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "office": "Nawabpet S.O"
  },
  "509380": {
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "office": "Musapet S.O"
  },
  "509324": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Kalwakurthy S.O"
  },
  "521150": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Kaja S.O"
  },
  "521132": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Kodali S.O"
  },
  "502312": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Kodakandla S.O"
  },
  "814149": {
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "office": "Sarath SO"
  },
  "814150": {
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "office": "Sarwan SO"
  },
  "816102": {
    "state": "JHARKHAND",
    "district": "SAHEBGANJ",
    "office": "Barhait SO"
  },
  "754294": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Chatra S.O (Jagatsinghapur)"
  },
  "841446": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Narendrapur SO"
  },
  "384221": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Vadavali SO"
  },
  "384260": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Manund SO"
  },
  "509320": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Marchala S.O"
  },
  "509357": {
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "office": "Midjil S.O"
  },
  "509302": {
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "office": "Town Jadcherla S.O"
  },
  "509349": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Vangoor S.O"
  },
  "509360": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Veldanda S.O"
  },
  "509375": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Achampet S.O"
  },
  "509201": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Amrabad S.O"
  },
  "509203": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Bijnapally S.O"
  },
  "509206": {
    "state": "TELANGANA",
    "district": "WANAPARTHY",
    "office": "Gopalpet S.O"
  },
  "509102": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Kollapur S.O"
  },
  "752111": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Konark"
  },
  "509408": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Keshampet S.O"
  },
  "509207": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Kondurgu S.O"
  },
  "509228": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Kothur S.O"
  },
  "509327": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Madgul S.O"
  },
  "509410": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Mogalgidda S.O"
  },
  "509325": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Palmakole S.O"
  },
  "506170": {
    "state": "TELANGANA",
    "district": "JAYASHANKAR BHUPALAPALLY",
    "office": "KTPP S.O"
  },
  "509216": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Shadnagar S.O"
  },
  "522439": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Vijayapuri South S.O"
  },
  "534165": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "West Vipparru S.O"
  },
  "521202": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "APIIIT S.O"
  },
  "521111": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Gollapalli S.O (Krishna)"
  },
  "521105": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Hanuman Junction S.O"
  },
  "509217": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Shahabad S.O"
  },
  "515321": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Rolla S.O"
  },
  "752114": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Rench"
  },
  "509106": {
    "state": "TELANGANA",
    "district": "WANAPARTHY",
    "office": "Gandhichowk"
  },
  "517507": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "S.P.Medical College for women SVIMS"
  },
  "392165": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Pakhajan SO"
  },
  "392220": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Palej SO"
  },
  "394115": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Panoli SO"
  },
  "393115": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Rajpardi SO"
  },
  "781137": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Aggumi S.O"
  },
  "781381": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Baihata Chariali S.O"
  },
  "781030": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "North Guwahati S.O"
  },
  "573103": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Arsikere East S.O"
  },
  "573162": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Bageshpura S.O"
  },
  "507157": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Palair S.O"
  },
  "783350": {
    "state": "ASSAM",
    "district": "KOKRAJHAR",
    "office": "Kachugaon S.O"
  },
  "783369": {
    "state": "ASSAM",
    "district": "KOKRAJHAR",
    "office": "Salakati Project S.O"
  },
  "783337": {
    "state": "ASSAM",
    "district": "DHUBRI",
    "office": "Sapatgram S.O"
  },
  "783346": {
    "state": "ASSAM",
    "district": "KOKRAJHAR",
    "office": "Serfanguri S.O"
  },
  "783373": {
    "state": "ASSAM",
    "district": "CHIRANG",
    "office": "Sidli S.O"
  },
  "783361": {
    "state": "ASSAM",
    "district": "KOKRAJHAR",
    "office": "Srirampur S.O (Kokrajhar)"
  },
  "783332": {
    "state": "ASSAM",
    "district": "KOKRAJHAR",
    "office": "Tamarhat S.O"
  },
  "532458": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "L.N.Peta S.O"
  },
  "781380": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Baihata S.O"
  },
  "781141": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Bamunigaon S.O (Kamrup)"
  },
  "781121": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Bezera S.O"
  },
  "781122": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Bijoynagar S.O"
  },
  "781123": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Boko S.O"
  },
  "781120": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Borduar S.O"
  },
  "781124": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Chhaygaon S.O"
  },
  "781129": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Hahimbazar S.O"
  },
  "781102": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Hajo S.O"
  },
  "782403": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Khetri S.O (Kamrup)"
  },
  "502296": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Ismailkhanpet S.O"
  },
  "502270": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Jogipet S.O"
  },
  "502294": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Manjira Barrage S.O"
  },
  "502300": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Muthangi S.O"
  },
  "502319": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Patancheru Ph.II S.O"
  },
  "754010": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Bairoi S.O"
  },
  "517592": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Ekambarakuppam S.O"
  },
  "502329": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Rudraram S.O"
  },
  "521328": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Koduru S.O"
  },
  "508117": {
    "state": "TELANGANA",
    "district": "YADADRI BHUVANAGIRI",
    "office": "Bhongir Gunj S.O"
  },
  "782402": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Sonapur S.O"
  },
  "781024": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Zoo Road S.O"
  },
  "781366": {
    "state": "ASSAM",
    "district": "BAKSA",
    "office": "Goreswar S.O"
  },
  "781025": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Ambari Fatasil S.O"
  },
  "781026": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Narangi S.O"
  },
  "781027": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Satgaon S.O"
  },
  "393030": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Hansot SO"
  },
  "521311": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Indupalli S.O"
  },
  "521106": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Kanumolu S.O"
  },
  "521207": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Musunuru S.O"
  },
  "521213": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Ramanakkapet S.O"
  },
  "521214": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Tsanubanda S.O"
  },
  "521215": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Vissannapet S.O"
  },
  "521109": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Telaprolu S.O"
  },
  "521403": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Gampalagudem S.O"
  },
  "515134": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Puttaparthy Main Bazar NDTSO"
  },
  "176200": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Bhadwar SO"
  },
  "176059": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Chachian SO"
  },
  "521401": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Penugolanu S.O"
  },
  "524230": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Nandipadu S.O"
  },
  "524310": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Seetaramapuram S.O"
  },
  "508126": {
    "state": "TELANGANA",
    "district": "YADADRI BHUVANAGIRI",
    "office": "Bibinagar S.O"
  },
  "811305": {
    "state": "BIHAR",
    "district": "JAMUI",
    "office": "Gidhaur SO"
  },
  "788102": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Dewan S.O"
  },
  "521312": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Vunguturu S.O (Krishna)"
  },
  "855101": {
    "state": "BIHAR",
    "district": "KISHANGANJ",
    "office": "Bahadurganj SO Kishanganj"
  },
  "394810": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Ilav SO"
  },
  "392150": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Jambusar Bazar SO"
  },
  "524225": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Siddanakonduru S.O"
  },
  "524226": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Udayagiri S.O (Nellore)"
  },
  "524227": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Varikuntapadu S.O"
  },
  "524228": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Vinjamur S.O"
  },
  "523261": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Muppavaram S.O"
  },
  "523183": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "N.G.Padu S.O"
  },
  "523213": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Ravinuthala S.O"
  },
  "523302": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Santhamagulur S.O"
  },
  "523225": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Santhanuthalapadu S.O"
  },
  "577002": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Kasturaba Extension S.O"
  },
  "577589": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Kondajji S.O"
  },
  "577530": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Malebennur S.O"
  },
  "577534": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Mayakonda S.O"
  },
  "577004": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Modi Circle Davanagere S.O"
  },
  "493344": {
    "state": "CHHATTISGARH",
    "district": "BALODA BAZAR",
    "office": "Katgi SO"
  },
  "493449": {
    "state": "CHHATTISGARH",
    "district": "MAHASAMUND",
    "office": "Bagbahra SO"
  },
  "493116": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Baikunth SO"
  },
  "493332": {
    "state": "CHHATTISGARH",
    "district": "BALODA BAZAR",
    "office": "Baloda Bazar SO"
  },
  "493554": {
    "state": "CHHATTISGARH",
    "district": "MAHASAMUND",
    "office": "Basna SO"
  },
  "493118": {
    "state": "CHHATTISGARH",
    "district": "BALODA BAZAR",
    "office": "Bhatapara Sadar Bazar SO"
  },
  "493338": {
    "state": "CHHATTISGARH",
    "district": "BALODA BAZAR",
    "office": "Bilaigarh SO"
  },
  "493221": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Birgaon SO"
  },
  "523113": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Pokur S.O"
  },
  "502107": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Pullur S.O"
  },
  "502269": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Alladurg S.O"
  },
  "502273": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Andole S.O"
  },
  "502307": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "IDA Pashamailaram S.O"
  },
  "851116": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "BTPP SO"
  },
  "502371": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Nizampet S.O"
  },
  "502285": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Kandi S.O"
  },
  "502306": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Nandikandi S.O"
  },
  "502313": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Narsapur S.O"
  },
  "502290": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Regode S.O"
  },
  "502321": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Digwal S.O"
  },
  "521149": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Guduru S.O"
  },
  "573111": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Bagur S.O (Hassan)"
  },
  "573112": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Banavara S.O"
  },
  "504292": {
    "state": "TELANGANA",
    "district": "KUMURAM BHEEM ASIFABAD",
    "office": "Rebbena S.O"
  },
  "504273": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Rechini S.O"
  },
  "521131": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Lakshmipuram S.O (Krishna)"
  },
  "176217": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Charri SO"
  },
  "176057": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Dari SO"
  },
  "176204": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Gangtha SO"
  },
  "176210": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Harchakian SO"
  },
  "176213": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Hpbose Dharamsala SO"
  },
  "176205": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Kotla SO Kangra"
  },
  "176202": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Nurpur SO"
  },
  "176065": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Rajhoon SO"
  },
  "176058": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Rey SO"
  },
  "176211": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Saliali SO"
  },
  "176206": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Shahpur Kangra SO"
  },
  "783375": {
    "state": "ASSAM",
    "district": "CHIRANG",
    "office": "Runikhata S.O"
  },
  "783354": {
    "state": "ASSAM",
    "district": "KOKRAJHAR",
    "office": "Saktiashram S.O"
  },
  "532123": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "S.R.Puram S.O"
  },
  "532122": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Vunukuru S.O"
  },
  "532264": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Baruva R S S.O"
  },
  "532263": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Baruva S.O"
  },
  "532220": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Brahmanatarla S.O"
  },
  "532243": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Haripuram S.O"
  },
  "532312": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Ichchapuram S.O"
  },
  "532290": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Kanchili S.O"
  },
  "532222": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Kasibugga S.O (Srikakulam)"
  },
  "532322": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Kaviti S.O"
  },
  "532195": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Kotabommali S.O"
  },
  "532242": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Mandasa S.O"
  },
  "532292": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Manikyapuram S.O"
  },
  "504296": {
    "state": "TELANGANA",
    "district": "KUMURAM BHEEM ASIFABAD",
    "office": "Industrial Area S.O"
  },
  "506371": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Hasanparthy S.O"
  },
  "491445": {
    "state": "CHHATTISGARH",
    "district": "RAJNANDGAON",
    "office": "Dongargarh SO"
  },
  "573115": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Belur Hassan S.O"
  },
  "506355": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Marrimuchal S.O"
  },
  "506224": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Mustial S.O"
  },
  "502305": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Bdl Bhanur S.O"
  },
  "393110": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Jhagadia SO"
  },
  "392160": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Karmad SO"
  },
  "392170": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Kavi SO"
  },
  "392155": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Kora SO Bharuch"
  },
  "392012": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Maktampur SO"
  },
  "176029": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Ranital SO Kangra"
  },
  "176022": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Rehan SO"
  },
  "176056": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Sunehar SO"
  },
  "176037": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Sunhi SO"
  },
  "516350": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Tallapalle S.O"
  },
  "516474": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Tallaproddatur S.O"
  },
  "393150": {
    "state": "GUJARAT",
    "district": "NARMADA",
    "office": "Lachharas SO"
  },
  "393130": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Netrang SO"
  },
  "392210": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Nabipur SO"
  },
  "392015": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Narmada Nagar SO Bharuch"
  },
  "387710": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Ramol SO"
  },
  "388430": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Dharmaj SO"
  },
  "388625": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Gudel SO"
  },
  "388150": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Nar SO"
  },
  "388450": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Petlad SO"
  },
  "388460": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Piplav SO"
  },
  "388570": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Ras SO"
  },
  "388170": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Sayma SO"
  },
  "387240": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Sojitra SO"
  },
  "387550": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Nayka SO"
  },
  "387365": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Torna SO"
  },
  "387380": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Vaso SO"
  },
  "387115": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Alindra Nadiad SO"
  },
  "387330": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Mohlel SO"
  },
  "387650": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Nirmali SO Kheda"
  },
  "751017": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Osap Campus S.O"
  },
  "506134": {
    "state": "TELANGANA",
    "district": "MAHABUBABAD",
    "office": "Gudur S.O"
  },
  "518390": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Tuggali S.O"
  },
  "387350": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Palana SO"
  },
  "387560": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Radhu SO"
  },
  "387210": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Dabhou SO"
  },
  "388610": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Dhuvaran Power Station SO"
  },
  "388590": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Jharola SO"
  },
  "388550": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Kathana RS SO"
  },
  "388620": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Khambhat SO"
  },
  "388440": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Mahelav SO"
  },
  "388480": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Sundarna SO"
  },
  "388180": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Tarapur SO Anand"
  },
  "825321": {
    "state": "JHARKHAND",
    "district": "CHATRA",
    "office": "Tandwa SO Chatra"
  },
  "532215": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Meliaputti S.O"
  },
  "532211": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Naupada S.O (Srikakulam)"
  },
  "532221": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Palasa S.O"
  },
  "532218": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Pundi R S S.O"
  },
  "532216": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Chapara S.O"
  },
  "829101": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Argada SO"
  },
  "829102": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Barkakana SO"
  },
  "829105": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Bhadaninagar SO"
  },
  "829110": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Gola SO Ramgarh"
  },
  "493770": {
    "state": "CHHATTISGARH",
    "district": "DHAMTARI",
    "office": "Bhakhara SO"
  },
  "493996": {
    "state": "CHHATTISGARH",
    "district": "GARIYABAND",
    "office": "Chhura SO"
  },
  "516127": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Penagalur S.O"
  },
  "516107": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Pullampet S.O"
  },
  "392230": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Ikhar SO"
  },
  "176225": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Tilokpur SO Kangra"
  },
  "532212": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Naupada RS S.O"
  },
  "176403": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Damtal SO"
  },
  "176216": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Dharamsala Cantt SO"
  },
  "387310": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Boriavi SO"
  },
  "516454": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Simhadripuram S.O"
  },
  "176051": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Raja Ka Talab SO"
  },
  "517644": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Kothapet (Srikalahasti) S.O"
  },
  "505330": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "Ailapur S.O"
  },
  "505501": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "Kodimial S.O"
  },
  "493890": {
    "state": "CHHATTISGARH",
    "district": "GARIYABAND",
    "office": "Deobhog SO"
  },
  "176401": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Indora SO"
  },
  "532284": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Sompeta S.O"
  },
  "532203": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Venkateswara Colony S.O"
  },
  "532404": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Srikurmam S.O"
  },
  "532219": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Akkupalli S.O"
  },
  "532291": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Ms Palli S.O"
  },
  "517504": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Tirumala S.O (Chittoor)"
  },
  "829202": {
    "state": "JHARKHAND",
    "district": "LATEHAR",
    "office": "Balumath SO"
  },
  "829203": {
    "state": "JHARKHAND",
    "district": "LATEHAR",
    "office": "Chandwa SO"
  },
  "502032": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Mig Colony S.O"
  },
  "811211": {
    "state": "BIHAR",
    "district": "MUNGER",
    "office": "Bariarpur SO Munger"
  },
  "521125": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Mopidevi S.O"
  },
  "521135": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Movva S.O"
  },
  "521120": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Nagayalanka S.O"
  },
  "577007": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Davangere University Campus S.O"
  },
  "577003": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Rm Yard  Davanagere S.O"
  },
  "493335": {
    "state": "CHHATTISGARH",
    "district": "BALODA BAZAR",
    "office": "Kasdol SO"
  },
  "493441": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Arang SO"
  },
  "509401": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Lingala S.O"
  },
  "383235": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Vadali SO Sabarkantha"
  },
  "385135": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Iqbalgadh SO"
  },
  "385545": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Khimat SO"
  },
  "385550": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Sihori SO"
  },
  "787110": {
    "state": "ASSAM",
    "district": "DHEMAJI",
    "office": "Sissiborgaon S.O"
  },
  "782450": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Baithalangsho S.O"
  },
  "787061": {
    "state": "ASSAM",
    "district": "DHEMAJI",
    "office": "Simen Chapori S.O"
  },
  "521156": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Nidumolu S.O"
  },
  "521002": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Chilakalapudi S.O"
  },
  "493222": {
    "state": "CHHATTISGARH",
    "district": "BALODA BAZAR",
    "office": "Bhatgaon SO Raipur"
  },
  "493196": {
    "state": "CHHATTISGARH",
    "district": "BALODA BAZAR",
    "office": "Grasim Vihar Rawan SO"
  },
  "493113": {
    "state": "CHHATTISGARH",
    "district": "BALODA BAZAR",
    "office": "Hathband SO"
  },
  "829117": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Marar SO"
  },
  "829118": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Patratu SO"
  },
  "825411": {
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "office": "Padma SO"
  },
  "829134": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Sarubera SO"
  },
  "829133": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Sounda D SO"
  },
  "388140": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Bochasan RS SO"
  },
  "388160": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Pandoli SO"
  },
  "782140": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Samaguri S.O"
  },
  "506175": {
    "state": "TELANGANA",
    "district": "JANGOAN",
    "office": "Jangaon Bazar S.O"
  },
  "506201": {
    "state": "TELANGANA",
    "district": "JANGOAN",
    "office": "Pembarthy S.O"
  },
  "506303": {
    "state": "TELANGANA",
    "district": "JANGOAN",
    "office": "Waddicherla Nawabpet S.O"
  },
  "506168": {
    "state": "TELANGANA",
    "district": "JAYASHANKAR BHUPALAPALLY",
    "office": "Chelpur S.O"
  },
  "521003": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Chintaguntapalem S.O"
  },
  "521332": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Dokiparru S.O"
  },
  "521356": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Gudlavalleru S.O"
  },
  "788112": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Derby S.O"
  },
  "518349": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Tungabhadra S.O"
  },
  "516110": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Peddarachapalli S.O"
  },
  "396440": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Karadi SO"
  },
  "516203": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Khajipet S.O"
  },
  "176214": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Tiara SO"
  },
  "393151": {
    "state": "GUJARAT",
    "district": "NARMADA",
    "office": "Kevadia Colony SO"
  },
  "521158": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Nimmakuru S.O"
  },
  "504272": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Tandur  S.O"
  },
  "504297": {
    "state": "TELANGANA",
    "district": "KUMURAM BHEEM ASIFABAD",
    "office": "Tiryani S.O"
  },
  "504295": {
    "state": "TELANGANA",
    "district": "KUMURAM BHEEM ASIFABAD",
    "office": "Wankidi S.O"
  },
  "521157": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Pamarru Bazar S.O"
  },
  "521138": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Pedasanagallu S.O"
  },
  "521162": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Polavaram(K) S.O"
  },
  "521331": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Kavutaram S.O"
  },
  "521369": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Munjuluru S.O"
  },
  "811308": {
    "state": "BIHAR",
    "district": "JAMUI",
    "office": "Jhajha SO"
  },
  "811317": {
    "state": "BIHAR",
    "district": "JAMUI",
    "office": "Khaira SO Jamui"
  },
  "811312": {
    "state": "BIHAR",
    "district": "JAMUI",
    "office": "Laxmipur Jamui SO"
  },
  "811313": {
    "state": "BIHAR",
    "district": "JAMUI",
    "office": "Mallehpur SO"
  },
  "176201": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Jassur SO"
  },
  "176060": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Darang SO"
  },
  "176402": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Kandrori SO"
  },
  "518176": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Nandivargam S.O"
  },
  "518502": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "N.G.O.S Colony S.O"
  },
  "518122": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Owk S.O"
  },
  "518112": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Panem S.O"
  },
  "518166": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Perusomula S.O"
  },
  "518511": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Polur S.O (Kurnool)"
  },
  "518513": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Santajutur S.O"
  },
  "518155": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Uyyalawada S.O"
  },
  "516356": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Chapadu S.O"
  },
  "516310": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Chilamakur S.O"
  },
  "516431": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Dommaranandyala S.O"
  },
  "516175": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Duvvur S.O (Cuddapah)"
  },
  "523214": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "J.Pangulur S.O"
  },
  "523286": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Kothapatnam S.O"
  },
  "516361": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Holmespet S.O"
  },
  "516434": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Jammalamadugu S.O"
  },
  "506366": {
    "state": "TELANGANA",
    "district": "JAYASHANKAR BHUPALAPALLY",
    "office": "Mogullapalli S.O"
  },
  "506344": {
    "state": "TELANGANA",
    "district": "Mulugu",
    "office": "Govindaraopet S.O"
  },
  "534195": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "P.N.Kolanu S.O"
  },
  "534166": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Pentapadu S.O"
  },
  "516362": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Khadarabad S.O"
  },
  "516359": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Korrapadu S.O"
  },
  "516380": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Muddanur S.O"
  },
  "516172": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Mydekur S.O"
  },
  "531151": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Araku Rs S.O"
  },
  "506352": {
    "state": "TELANGANA",
    "district": "Mulugu",
    "office": "Jangalapally S.O"
  },
  "506343": {
    "state": "TELANGANA",
    "district": "Mulugu",
    "office": "Mulug S.O"
  },
  "811315": {
    "state": "BIHAR",
    "district": "JAMUI",
    "office": "Sikandra SO Jamui"
  },
  "811316": {
    "state": "BIHAR",
    "district": "JAMUI",
    "office": "Simultala SO"
  },
  "811314": {
    "state": "BIHAR",
    "district": "JAMUI",
    "office": "Sono SO"
  },
  "811202": {
    "state": "BIHAR",
    "district": "MUNGER",
    "office": "Basudeopur SO"
  },
  "502247": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Makkarajpet S.O"
  },
  "829106": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Bhurkunda Bazar SO"
  },
  "385570": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Suigam SO"
  },
  "385555": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Thara SO"
  },
  "385565": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Tharad SO"
  },
  "509336": {
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "office": "Rawulapally S.O"
  },
  "516257": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Lakkireddy Palli S.O"
  },
  "502316": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Kowdipally S.O"
  },
  "502271": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Shankarampet S.O"
  },
  "493773": {
    "state": "CHHATTISGARH",
    "district": "DHAMTARI",
    "office": "Dhamtari SO"
  },
  "493889": {
    "state": "CHHATTISGARH",
    "district": "GARIYABAND",
    "office": "Gariaband SO"
  },
  "825101": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Chittarpur SO"
  },
  "535502": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Parvatipuram Bus Stand S.O"
  },
  "533348": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Donkarayi S.O"
  },
  "533351": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Thotapalli S.O (Khammam)"
  },
  "533349": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "V.R. PURAM S.O"
  },
  "507114": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Burgampahad S.O"
  },
  "507133": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Charla S.O"
  },
  "507137": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Dummagudem S.O"
  },
  "507116": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Hwp Aswapur Colony S.O"
  },
  "507117": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Manuguru Colls S.O"
  },
  "507115": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "T.P.Campus S.O"
  },
  "507140": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "S.N.Puram S.O"
  },
  "507128": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Sarapaka S.O"
  },
  "507202": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Banigandlapahad S.O"
  },
  "811302": {
    "state": "BIHAR",
    "district": "LAKHISARAI",
    "office": "Barhiya SO"
  },
  "502115": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Akkannapet S.O"
  },
  "502255": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Chegunta S.O"
  },
  "502113": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Haveli Ghanpur S.O"
  },
  "502109": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Machavaram S.O"
  },
  "502248": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Narsingee S.O"
  },
  "502125": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Podichanpally S.O"
  },
  "502117": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Rajpally S.O"
  },
  "502334": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Toopran S.O"
  },
  "502310": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Allipur S.O"
  },
  "502108": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Dubbak S.O"
  },
  "516270": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Masapet Bazar S.O"
  },
  "516504": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Neelakantaraopet S.O"
  },
  "396427": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Kaliawadi SO"
  },
  "517247": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Punganur S.O"
  },
  "517423": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Rallabudugur S.O"
  },
  "517401": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Ramakuppam S.O"
  },
  "517352": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Rishivalley S.O"
  },
  "517414": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Royalpet S.O"
  },
  "517123": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Sodam S.O"
  },
  "176064": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Paraur SO"
  },
  "781125": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Mirza S.O"
  },
  "781376": {
    "state": "ASSAM",
    "district": "BAKSA",
    "office": "Darkuchi S.O"
  },
  "531011": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Atchutapuram S.O"
  },
  "531036": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Chodavaram S.O"
  },
  "531030": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Devarapalli S.O (Visakhapatnam)"
  },
  "531002": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Nidanam Doddi S.O"
  },
  "535559": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Bobbili Govt.Hospital Road S.O"
  },
  "535240": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Alamanda R S S.O"
  },
  "535216": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Bhogapuram S.O"
  },
  "535160": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Bonangi S.O"
  },
  "535581": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Challapeta S.O"
  },
  "535006": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Denkada S.O"
  },
  "535148": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Dharmavaram S.O"
  },
  "535270": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Gajapathinagaram S.O"
  },
  "535215": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Gantyada S.O"
  },
  "515211": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Kirikera S.O"
  },
  "515601": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Kodikonda S.O"
  },
  "494661": {
    "state": "CHHATTISGARH",
    "district": "NARAYANPUR",
    "office": "Narayanpur S.O (Narayanpur)"
  },
  "312615": {
    "state": "RAJASTHAN",
    "district": "PRATAPGARH",
    "office": "Arnod S.O"
  },
  "126110": {
    "state": "HARYANA",
    "district": "JIND",
    "office": "Dharthrath S.O"
  },
  "126101": {
    "state": "HARYANA",
    "district": "JIND",
    "office": "Julana S.O"
  },
  "126125": {
    "state": "HARYANA",
    "district": "JIND",
    "office": "Naguran S.O"
  },
  "126116": {
    "state": "HARYANA",
    "district": "JIND",
    "office": "Narwana City S.O"
  },
  "507136": {
    "state": "TELANGANA",
    "district": "Mulugu",
    "office": "Venkatapuram S.O"
  },
  "494226": {
    "state": "CHHATTISGARH",
    "district": "KONDAGAON",
    "office": "Kondagaon Naka S.O"
  },
  "494229": {
    "state": "CHHATTISGARH",
    "district": "KONDAGAON",
    "office": "Pharasgaon Camp S.O"
  },
  "494228": {
    "state": "CHHATTISGARH",
    "district": "KONDAGAON",
    "office": "Pharasgaon S.O"
  },
  "515331": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Lepakshi S.O"
  },
  "515301": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Madakasira S.O"
  },
  "515202": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Muddireddypalli S.O"
  },
  "176203": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Ladori SO"
  },
  "509110": {
    "state": "TELANGANA",
    "district": "WANAPARTHY",
    "office": "Madanapuram S.O"
  },
  "509104": {
    "state": "TELANGANA",
    "district": "WANAPARTHY",
    "office": "Pebbair S.O"
  },
  "509105": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Pentlavally S.O"
  },
  "509120": {
    "state": "TELANGANA",
    "district": "WANAPARTHY",
    "office": "Srirangapur S.O"
  },
  "534102": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Tadepalligudem Bazar S.O"
  },
  "522237": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Tulluru S.O"
  },
  "523252": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Pothakamur S.O"
  },
  "523254": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Sankavaram S.O"
  },
  "523109": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Ponnalore S.O"
  },
  "509311": {
    "state": "TELANGANA",
    "district": "Narayanpet",
    "office": "Utkur S.O"
  },
  "385540": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Junadisa SO"
  },
  "385520": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Kanodar SO"
  },
  "506332": {
    "state": "TELANGANA",
    "district": "WARANGAL RURAL",
    "office": "Chennaraopet S.O"
  },
  "506324": {
    "state": "TELANGANA",
    "district": "MAHABUBABAD",
    "office": "Dantalapalli S.O"
  },
  "385001": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Palanpur Delhigate SO"
  },
  "385110": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Ambaji SO"
  },
  "385530": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Bhildi SO"
  },
  "385510": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Chandisar SO"
  },
  "385210": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Chhapi SO"
  },
  "385010": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Chitrasani SO"
  },
  "385120": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Danta Bhavangadh SO"
  },
  "506381": {
    "state": "TELANGANA",
    "district": "MAHABUBABAD",
    "office": "Dornakal S.O"
  },
  "380058": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Ghuma S.O"
  },
  "382210": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Sarkhej SO"
  },
  "534432": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Denduluru S.O"
  },
  "534427": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Gundugolanu So. S.O"
  },
  "534007": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Sb Colony S.O"
  },
  "534437": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Pedapadu S.O"
  },
  "502277": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Duddeda S.O"
  },
  "507118": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Ramavaram S.O"
  },
  "507303": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Sathupalli S.O"
  },
  "507120": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Sujathanagar S.O"
  },
  "855102": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Barsoi SO"
  },
  "509235": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Thoodukurthy S.O"
  },
  "382433": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Kuha SO"
  },
  "382330": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Naroda I E SO"
  },
  "382425": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Bareja SO Ahmedabad"
  },
  "382435": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Nandej SO"
  },
  "495683": {
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "office": "Rajgamar Colliery SO"
  },
  "804453": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "PUNPUN S.O"
  },
  "385330": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Deodar SO"
  },
  "509209": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Nagarkurnool S.O"
  },
  "509215": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Palem S.O"
  },
  "509412": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Peddakothapally S.O"
  },
  "509385": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Thelkapally S.O"
  },
  "509406": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Thimmajipet S.O"
  },
  "535004": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Vizianagaram Court Complex S.O"
  },
  "535250": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Jami S.O"
  },
  "825325": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Kedla SO"
  },
  "825316": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Kuju SO"
  },
  "829119": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Patratu TPS SO"
  },
  "829150": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Ramgarh Project SO"
  },
  "825330": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Topa Coliery SO"
  },
  "495691": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Malkharoda SO"
  },
  "495689": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Sakti SO"
  },
  "495442": {
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "office": "Ratanpur SO Bilaspur"
  },
  "495330": {
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "office": "Takhatpur SO"
  },
  "495003": {
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "office": "Sakri"
  },
  "383010": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Vaktapur SO"
  },
  "507164": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Vemsur S.O"
  },
  "507211": {
    "state": "TELANGANA",
    "district": "MAHABUBABAD",
    "office": "Bayyaram S.O"
  },
  "494670": {
    "state": "CHHATTISGARH",
    "district": "KANKER",
    "office": "Korar S.O"
  },
  "494336": {
    "state": "CHHATTISGARH",
    "district": "KANKER",
    "office": "Lakhanpuri S.O"
  },
  "825414": {
    "state": "JHARKHAND",
    "district": "CHATRA",
    "office": "Hunterganj SO"
  },
  "493891": {
    "state": "CHHATTISGARH",
    "district": "GARIYABAND",
    "office": "Gohrapadar SO"
  },
  "509381": {
    "state": "TELANGANA",
    "district": "WANAPARTHY",
    "office": "Kothakota S.O"
  },
  "531061": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Dimili S.O"
  },
  "531019": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Jawaharlalnehru Pharmacity S.O"
  },
  "531034": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "K Kotapadu S.O"
  },
  "531031": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Kasimkota S.O"
  },
  "509376": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Uppununthala S.O"
  },
  "509326": {
    "state": "TELANGANA",
    "district": "NAGARKURNOOL",
    "office": "Srisailam Dam  S.O"
  },
  "393010": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "ONGC Colony SO"
  },
  "829201": {
    "state": "JHARKHAND",
    "district": "CHATRA",
    "office": "Bachra SO"
  },
  "324005": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Mahaveer Nagar Kota S.O"
  },
  "325003": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Cable Nagar S.O"
  },
  "247001": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Khalapar SO"
  },
  "324002": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Kota Jn. S.O"
  },
  "324003": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Industerial Estate Kota S.O"
  },
  "680001": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Thrissur Central SO"
  },
  "494333": {
    "state": "CHHATTISGARH",
    "district": "KANKER",
    "office": "Narharpur S.O"
  },
  "494776": {
    "state": "CHHATTISGARH",
    "district": "KANKER",
    "office": "Pakhanjore Camp S.O"
  },
  "491001": {
    "state": "CHHATTISGARH",
    "district": "DURG",
    "office": "Pulgaon Durg SO"
  },
  "388630": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Kansari SO"
  },
  "491335": {
    "state": "CHHATTISGARH",
    "district": "BEMETARA",
    "office": "Bemetara SO"
  },
  "491332": {
    "state": "CHHATTISGARH",
    "district": "BEMETARA",
    "office": "Berla SO"
  },
  "491331": {
    "state": "CHHATTISGARH",
    "district": "BEMETARA",
    "office": "Dhamdha SO"
  },
  "496001": {
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "office": "Raigarh Jute Mill SO"
  },
  "506015": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "K C Colony S.O"
  },
  "781101": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Changsari S.O"
  },
  "670301": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Cherukunnu SO"
  },
  "325209": {
    "state": "RAJASTHAN",
    "district": "BARAN",
    "office": "Anta Gas Power Project Anta S.O"
  },
  "365555": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Dungar SO"
  },
  "365601": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Amreli J P SO"
  },
  "365610": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Babapur SO"
  },
  "365421": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Babra SO Amreli"
  },
  "364522": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Badhada SO"
  },
  "365440": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Bagasra SO"
  },
  "365630": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Chalala SO"
  },
  "365410": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Chamaradi SO"
  },
  "365435": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Chavand SO"
  },
  "383450": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Vasai SO"
  },
  "383434": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Verabar SO"
  },
  "383460": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Vijaynagar SO"
  },
  "847234": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Pandaul SO"
  },
  "784163": {
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "office": "Pathalipahar S.O"
  },
  "785104": {
    "state": "ASSAM",
    "district": "MAJULI",
    "office": "Garmursatra S.O"
  },
  "785611": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Badulipaar S.O"
  },
  "785602": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Barpathar S.O"
  },
  "176219": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Mcleodganj SO"
  },
  "176052": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Yol Camp SO"
  },
  "491221": {
    "state": "CHHATTISGARH",
    "district": "DURG",
    "office": "Anda SO"
  },
  "491225": {
    "state": "CHHATTISGARH",
    "district": "BALOD",
    "office": "Arjunda SO"
  },
  "491226": {
    "state": "CHHATTISGARH",
    "district": "BALOD",
    "office": "Balod SO"
  },
  "364130": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Datha SO"
  },
  "364320": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Dhola SO"
  },
  "364505": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Gariyadhar SO"
  },
  "360005": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Rajkot Sau Uni Area SO"
  },
  "363650": {
    "state": "GUJARAT",
    "district": "MORBI",
    "office": "Tankara SO"
  },
  "360024": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Veraval Shapar SO"
  },
  "847215": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "RKCollage SO"
  },
  "847235": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Rajnagar SO Madhubani"
  },
  "847236": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Rampatti SO"
  },
  "847411": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Rudrapur SO Madhubani"
  },
  "382424": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Chandkheda Society Area SO"
  },
  "495448": {
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "office": "PondiUproda SO"
  },
  "495674": {
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "office": "Bhaisma SO"
  },
  "363621": {
    "state": "GUJARAT",
    "district": "MORBI",
    "office": "Wankaner SO"
  },
  "364730": {
    "state": "GUJARAT",
    "district": "BOTAD",
    "office": "Dhasa Gam SO"
  },
  "364740": {
    "state": "GUJARAT",
    "district": "BOTAD",
    "office": "Dhasa Jn SO"
  },
  "364750": {
    "state": "GUJARAT",
    "district": "BOTAD",
    "office": "Gadhada Sn SO"
  },
  "785703": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Ptc Dergaon S.O"
  },
  "785101": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Bahana S.O"
  },
  "785631": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Borholla S.O"
  },
  "785010": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Chengeli Gaon S.O"
  },
  "360311": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Gondal Bhuvneshwari Pith SO"
  },
  "785702": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Bengenakhowa S.O"
  },
  "785612": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Bokakhat S.O"
  },
  "364140": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Talaja SO"
  },
  "364260": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Tana SO"
  },
  "364120": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Tansa SO"
  },
  "364145": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Thaliya SO"
  },
  "364150": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Trapaj SO"
  },
  "364330": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Umrala SO"
  },
  "490021": {
    "state": "CHHATTISGARH",
    "district": "DURG",
    "office": "Bhilai East SO"
  },
  "490025": {
    "state": "CHHATTISGARH",
    "district": "DURG",
    "office": "Bhilai Marshalling Yard SO"
  },
  "491228": {
    "state": "CHHATTISGARH",
    "district": "BALOD",
    "office": "Mines Office Dallirajhara SO"
  },
  "491230": {
    "state": "CHHATTISGARH",
    "district": "BALOD",
    "office": "Dondi SO"
  },
  "491771": {
    "state": "CHHATTISGARH",
    "district": "BALOD",
    "office": "Dondi Lohara SO"
  },
  "785618": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Baruabamungaon S.O"
  },
  "364765": {
    "state": "GUJARAT",
    "district": "BOTAD",
    "office": "Ugamedi SO"
  },
  "360060": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Virnagar SO"
  },
  "360360": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Jetalsar Jn SO"
  },
  "360370": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Jetpur SO"
  },
  "360470": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Kolki SO Rajkot"
  },
  "534002": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Venkata Rao Peta S.O"
  },
  "387220": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Malataj SO"
  },
  "531162": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Chittivalasa S.O"
  },
  "530027": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Gopalapatnam S.O"
  },
  "387570": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Ratanpur SO Kheda"
  },
  "387430": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Sinhuj SO"
  },
  "785614": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Dergaon Chariali S.O"
  },
  "785622": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Dhekial S.O"
  },
  "785625": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Kamarbandha Ali S.O"
  },
  "785619": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Kamargaon S.O (Golaghat)"
  },
  "785613": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Letekujaan S.O"
  },
  "785705": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Merapani S.O"
  },
  "785615": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Numaligarh S.O"
  },
  "785603": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Oating S.O"
  },
  "785601": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Sarupathar S.O"
  },
  "382405": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Narol SO"
  },
  "495557": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Seorinarayan SO"
  },
  "495687": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Baradwar SO"
  },
  "364310": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Vallabhipur SO"
  },
  "364060": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Vartej SO"
  },
  "786174": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Pengri S.O"
  },
  "250001": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "W K Road SO"
  },
  "121102": {
    "state": "HARYANA",
    "district": "PALWAL",
    "office": "New Township Palwal SO"
  },
  "682052": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kakkanad NDC"
  },
  "250110": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "Modipuram SO"
  },
  "464770": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Udaipura S.O"
  },
  "786154": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Saikhowaghat S.O"
  },
  "786146": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Sukhanpukhuri S.O"
  },
  "786156": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Talap S.O (Tinsukia)"
  },
  "786148": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Monkhooli S.O."
  },
  "518145": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Nossam S.O"
  },
  "518594": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Rudravaram S.O"
  },
  "518563": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Sirvel S.O"
  },
  "518512": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Thimmapuram S.O"
  },
  "518573": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Yallur S.O"
  },
  "516433": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Chinnakomerla S.O"
  },
  "495661": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Birra SO"
  },
  "847308": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Sahar SO Madhubani"
  },
  "491223": {
    "state": "CHHATTISGARH",
    "district": "BALOD",
    "office": "Gunderdehi SO"
  },
  "504301": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Ramakrishnapur S.O"
  },
  "781023": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Amerigog S.O"
  },
  "781017": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Azara S.O"
  },
  "531077": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Hukumpeta S.O"
  },
  "531087": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Koyyuru S.O"
  },
  "531027": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Madugula S.O"
  },
  "531113": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Makavarapalem S.O"
  },
  "530029": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "R R V Puram S.O"
  },
  "530047": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Vepagunta S.O (Visakhapatnam)"
  },
  "530045": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Gitam Engg. College S.O"
  },
  "530048": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Madhurawada S.O"
  },
  "530012": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "B H P V S.O"
  },
  "531163": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Bheemunipatnam S.O"
  },
  "493555": {
    "state": "CHHATTISGARH",
    "district": "MAHASAMUND",
    "office": "Jagdishpur SO Mahasamund"
  },
  "821101": {
    "state": "BIHAR",
    "district": "KAIMUR (BHABUA)",
    "office": "Bhabua SO"
  },
  "847239": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Sakri Madhubani SO"
  },
  "847424": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Sarisavpahi SO"
  },
  "847410": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Tamuria SO"
  },
  "847240": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Umgaon kothi SO"
  },
  "843312": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Aurai SO Muzaffarpur"
  },
  "385130": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Shri Amirgadh SO"
  },
  "813221": {
    "state": "BIHAR",
    "district": "MUNGER",
    "office": "TARAPUR SO"
  },
  "502381": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Rangampet S.O"
  },
  "502302": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Tekmal S.O"
  },
  "781015": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Guwahati Airport S.O"
  },
  "495682": {
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "office": "Manikpur Colliery SO"
  },
  "518165": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Sanjamala S.O"
  },
  "518510": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Yerraguntla S.O (Kurnool)"
  },
  "382120": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Detroj SO"
  },
  "382460": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Dhandhuka SO"
  },
  "821102": {
    "state": "BIHAR",
    "district": "KAIMUR (BHABUA)",
    "office": "Bhagwanpur SO Kaimur Bhabua"
  },
  "531115": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Nathavaram S.O"
  },
  "502331": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Yousufpet S.O"
  },
  "803213": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Barh SO Patna"
  },
  "801307": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Bhathar SO"
  },
  "803108": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Chandi SO"
  },
  "531024": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Paderoo S.O"
  },
  "813103": {
    "state": "BIHAR",
    "district": "BANKA",
    "office": "Barahat SO"
  },
  "813202": {
    "state": "BIHAR",
    "district": "BANKA",
    "office": "Belhar SO"
  },
  "534197": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Pippara S.O"
  },
  "522501": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Tadepalle S.O"
  },
  "522236": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Tadikonda S.O"
  },
  "382455": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Dholera SO"
  },
  "382115": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Godhavi SO"
  },
  "382145": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Katosan Road SO"
  },
  "382265": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Kauka SO"
  },
  "382240": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Koth SO"
  },
  "813104": {
    "state": "BIHAR",
    "district": "BANKA",
    "office": "Bounsi SO"
  },
  "813201": {
    "state": "BIHAR",
    "district": "MUNGER",
    "office": "Asarganj SO"
  },
  "534235": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Akividu S.O"
  },
  "801301": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Ekangersarai SO"
  },
  "803110": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Harnaut SO"
  },
  "502336": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Kadlakal S.O"
  },
  "502335": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Masaipet S.O"
  },
  "814131": {
    "state": "BIHAR",
    "district": "BANKA",
    "office": "Chandan SO"
  },
  "813106": {
    "state": "BIHAR",
    "district": "BANKA",
    "office": "Katoria SO"
  },
  "531040": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Pedabayalu S.O"
  },
  "531025": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Ravikamatham S.O"
  },
  "531133": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Gudem S.O"
  },
  "531026": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Vaddadi S.O"
  },
  "531117": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Vemulapudi S.O"
  },
  "502130": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Kuchanpally S.O"
  },
  "382230": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Lothal Bhurkhi RS SO"
  },
  "491668": {
    "state": "CHHATTISGARH",
    "district": "RAJNANDGAON",
    "office": "Bandha Bazar SO"
  },
  "516355": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Kallur S.O (Cuddapah)"
  },
  "382427": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Aslali SO"
  },
  "841403": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Baniapur SO"
  },
  "491885": {
    "state": "CHHATTISGARH",
    "district": "RAJNANDGAON",
    "office": "Chhuikhadan SO"
  },
  "491558": {
    "state": "CHHATTISGARH",
    "district": "RAJNANDGAON",
    "office": "Chhuria SO"
  },
  "491557": {
    "state": "CHHATTISGARH",
    "district": "RAJNANDGAON",
    "office": "Chichola SO"
  },
  "491661": {
    "state": "CHHATTISGARH",
    "district": "RAJNANDGAON",
    "office": "Dongargaon SO"
  },
  "585102": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "GB Court S.O"
  },
  "585212": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Ghanagapur T S.O"
  },
  "585265": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Gobbur S.O"
  },
  "585310": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Jewargi S.O"
  },
  "573116": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Channarayapatna S.O"
  },
  "753014": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Avinab Bidanasi S.O"
  },
  "585311": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Kadaganchi S.O"
  },
  "585312": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Kalgi S.O"
  },
  "585313": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Kamalapur S.O (Kalaburagi)"
  },
  "585314": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Khajuri S.O (Kalaburagi)"
  },
  "517418": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Thamballapalle S.O"
  },
  "517424": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Venkatagirikota S.O"
  },
  "516228": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Anantharajupuram S.O"
  },
  "516227": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Badvel S.O"
  },
  "516259": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Balathimmayyagaripalli S.O"
  },
  "518360": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Yemmiganur bazar S.O"
  },
  "518422": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Atmakur S.O (Kurnool)"
  },
  "518006": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Balaji Nagar S.O"
  },
  "518462": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Belagal S.O"
  },
  "518432": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Brahmanakotkur S.O"
  },
  "518465": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Devanakonda S.O"
  },
  "518222": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Dhone S.O"
  },
  "518225": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Krishnagiri S.O"
  },
  "786002": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Assam Medical College S.O"
  },
  "782482": {
    "state": "ASSAM",
    "district": "KARBI ANGLONG",
    "office": "Bakalighat S.O"
  },
  "782490": {
    "state": "ASSAM",
    "district": "KARBI ANGLONG",
    "office": "Bokajan C F S.O"
  },
  "782480": {
    "state": "ASSAM",
    "district": "KARBI ANGLONG",
    "office": "Bokajan S.O"
  },
  "782470": {
    "state": "ASSAM",
    "district": "KARBI ANGLONG",
    "office": "Dhansripar S.O"
  },
  "811101": {
    "state": "BIHAR",
    "district": "SHEIKHPURA",
    "office": "Barbigha SO"
  },
  "848209": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Singhia SO"
  },
  "848210": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Rusera Thana SO"
  },
  "848127": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Sarairanjan SO"
  },
  "848236": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Singhia Ghat SO"
  },
  "518508": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Gadivemula S.O"
  },
  "518452": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Gargeyapuram S.O"
  },
  "518463": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Gonegandla S.O"
  },
  "518466": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Gudur S.O (Kurnool)"
  },
  "518220": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Jaladurgam S.O"
  },
  "516502": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Chennampalli S.O"
  },
  "516162": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Chennur S.O (Cuddapah)"
  },
  "841201": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Bareja SO Saran"
  },
  "841204": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Chainwa SO"
  },
  "841205": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Daudpur SO Saran"
  },
  "841206": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Dayalpur SO Saran"
  },
  "841207": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Dighwara SO"
  },
  "841208": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Ekma SO"
  },
  "841311": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Garkha SO"
  },
  "841211": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Gultenganj SO"
  },
  "531023": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Govada S.O"
  },
  "516173": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Onipenta S.O"
  },
  "516411": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Peddapasupula S.O"
  },
  "516432": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Vaddirala S.O"
  },
  "516312": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Vv Reddy Nagar S.O"
  },
  "516309": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Yerraguntla S.O (Cuddapah)"
  },
  "516421": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Agadur S.O"
  },
  "516484": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Balapanur S.O"
  },
  "516289": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Kamalapuram S.O (Cuddapah)"
  },
  "516444": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Kondapuram S.O (Cuddapah)"
  },
  "516464": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Lavanur S.O"
  },
  "535273": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Mentada S.O"
  },
  "535145": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "S Kota S.O"
  },
  "517551": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Vadamalpet S.O"
  },
  "781031": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Amingaon S.O"
  },
  "783120": {
    "state": "ASSAM",
    "district": "GOALPARA",
    "office": "Agia S.O"
  },
  "783335": {
    "state": "ASSAM",
    "district": "DHUBRI",
    "office": "Agomoni S.O"
  },
  "783339": {
    "state": "ASSAM",
    "district": "DHUBRI",
    "office": "Alamganj S.O"
  },
  "783349": {
    "state": "ASSAM",
    "district": "DHUBRI",
    "office": "Bagribari S.O"
  },
  "783390": {
    "state": "ASSAM",
    "district": "CHIRANG",
    "office": "Bijni S.O"
  },
  "829103": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Barkakana NTS SO"
  },
  "829109": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Giddi C SO"
  },
  "535220": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Kotagandredu S.O"
  },
  "535183": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Kothavalasa S.O"
  },
  "516396": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Lingala S.O (Cuddapah)"
  },
  "516218": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Nandimandalam S.O"
  },
  "516339": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Payasampalle S.O"
  },
  "516216": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Pendlimarri S.O"
  },
  "516391": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Pulivendla Bus stand S.O"
  },
  "535161": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "L Kota S.O"
  },
  "535217": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Nellimarla S.O"
  },
  "535580": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Pedamanapuram S.O"
  },
  "535204": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Pusapatirega S.O"
  },
  "535218": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Ramathirtam S.O"
  },
  "221007": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Sarnath SO"
  },
  "782462": {
    "state": "ASSAM",
    "district": "KARBI ANGLONG",
    "office": "Diphu Govt.College S.O"
  },
  "782441": {
    "state": "ASSAM",
    "district": "KARBI ANGLONG",
    "office": "Dokmaka S.O"
  },
  "782485": {
    "state": "ASSAM",
    "district": "WEST KARBI ANGLONG",
    "office": "Donkamokam S.O"
  },
  "782486": {
    "state": "ASSAM",
    "district": "WEST KARBI ANGLONG",
    "office": "Hamren S.O"
  },
  "782435": {
    "state": "ASSAM",
    "district": "HOJAI",
    "office": "Hojai S.O"
  },
  "782481": {
    "state": "ASSAM",
    "district": "KARBI ANGLONG",
    "office": "Howraghat S.O"
  },
  "782428": {
    "state": "ASSAM",
    "district": "HOJAI",
    "office": "Jamunamukh S.O"
  },
  "600100": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Pallikaranai SO"
  },
  "522324": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Kolluru S.O"
  },
  "522313": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Kuchipudi S.O"
  },
  "522202": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Satyanarayanapuram S.O (Guntur)"
  },
  "522212": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Chebrole S.O (Guntur)"
  },
  "522309": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Cherukupalle S.O"
  },
  "522113": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Cheruvu S.O"
  },
  "522258": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Dhulipudi S.O"
  },
  "522341": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Intur S.O"
  },
  "522304": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Kollipara S.O"
  },
  "522306": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Nandivelugu S.O"
  },
  "522265": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Repalle S.O"
  },
  "783348": {
    "state": "ASSAM",
    "district": "DHUBRI",
    "office": "Bilasipara S.O"
  },
  "783393": {
    "state": "ASSAM",
    "district": "CHIRANG",
    "office": "Boro Bazar S.O"
  },
  "783123": {
    "state": "ASSAM",
    "district": "GOALPARA",
    "office": "Dhupdhara S.O"
  },
  "783360": {
    "state": "ASSAM",
    "district": "KOKRAJHAR",
    "office": "Gossaigaon S.O"
  },
  "521130": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Pedakallepalli S.O"
  },
  "803212": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Bakhtiyarpur SO"
  },
  "363330": {
    "state": "GUJARAT",
    "district": "MORBI",
    "office": "Halvad SO"
  },
  "244001": {
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "office": "SPF Mrd SO"
  },
  "363745": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Bajana SO"
  },
  "363520": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Chotila SO"
  },
  "853201": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Bihpur SO"
  },
  "812004": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Sahebganj"
  },
  "813204": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Ekchari SO"
  },
  "530044": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Pedagantyada S.O"
  },
  "387345": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Narsanda SO"
  },
  "387355": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Piplag SO"
  },
  "387360": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Salun SO"
  },
  "825413": {
    "state": "JHARKHAND",
    "district": "KODERMA",
    "office": "Telaiya Dam SO"
  },
  "387002": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Patel Society Area Tso Nad SO"
  },
  "387230": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Pij SO"
  },
  "535213": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Singavaram S.O"
  },
  "535281": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Vepada S.O"
  },
  "785609": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Kaziranga National Park S.O"
  },
  "785626": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Maheema S.O"
  },
  "848130": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Tajpur SO Samastipur"
  },
  "848132": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Ujiarpur SO"
  },
  "848503": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Vidhyapati Nagar SO"
  },
  "530049": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Special Economic Zone P.O"
  },
  "530053": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Aganampudi S.O"
  },
  "533347": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Mothugudem S.O"
  },
  "363410": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Chuda SO"
  },
  "363750": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Dasada SO"
  },
  "363115": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "VITHALGADH SO"
  },
  "363310": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Dhrangadhra SO"
  },
  "363780": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Adariyana SO"
  },
  "781364": {
    "state": "ASSAM",
    "district": "BAKSA",
    "office": "Maharipara S.O"
  },
  "783388": {
    "state": "ASSAM",
    "district": "BONGAIGAON",
    "office": "A.P.Mill S.O"
  },
  "783384": {
    "state": "ASSAM",
    "district": "BONGAIGAON",
    "office": "Abhayapuri S.O"
  },
  "783380": {
    "state": "ASSAM",
    "district": "BONGAIGAON",
    "office": "Barpara S.O"
  },
  "781150": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Chandrapur S.O (Kamrup)"
  },
  "782401": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Digaru S.O"
  },
  "781005": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Dispur S.O"
  },
  "828109": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Govindpur SO Dhanbad"
  },
  "826004": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Indian School Of Mines SO"
  },
  "828110": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Jealgora SO"
  },
  "828111": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Jharia Manbad SO"
  },
  "828113": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Katrasgarh SO"
  },
  "493195": {
    "state": "CHHATTISGARH",
    "district": "BALODA BAZAR",
    "office": "Hirmi SO"
  },
  "802207": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Piru SO"
  },
  "802208": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Sahar SO Bhojpur"
  },
  "802156": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Dhamar SO"
  },
  "802203": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Garhani SO"
  },
  "523245": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Pedarikatla S.O"
  },
  "574313": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Ishwaramangala S.O"
  },
  "530040": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Govt Dairy Farm S.O"
  },
  "530043": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Visalakshinagar S.O"
  },
  "530005": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Nausenabagh S.O"
  },
  "828203": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Kumardhubi SO"
  },
  "828116": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Kusunda SO"
  },
  "828305": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Mohuda SO"
  },
  "828129": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Moonidih SO"
  },
  "828205": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Nirsa Chatti SO"
  },
  "523270": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Kondepi S.O"
  },
  "848125": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Pusa SO"
  },
  "516214": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Chinnamandem S.O"
  },
  "516267": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Galiveedu S.O"
  },
  "516233": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Gopavaram Project Site S.O"
  },
  "516217": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Kalasapadu S.O"
  },
  "516503": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Kandimallayapalli S.O"
  },
  "517390": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Mulakalacheruvu R.S. S.O"
  },
  "517280": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Nimmanapalle S.O"
  },
  "517391": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Peddatippasamudram S.O"
  },
  "491227": {
    "state": "CHHATTISGARH",
    "district": "BALOD",
    "office": "Gurur SO"
  },
  "534003": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Westren Street S.O"
  },
  "848129": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Shambhupatti SO"
  },
  "848131": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Waini SO"
  },
  "848133": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Warish Nagar SO"
  },
  "524315": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Allur S.O"
  },
  "524004": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Vedayapalem S.O"
  },
  "524304": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Anumasamudrampeta S.O"
  },
  "524346": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Brahmadevam S.O"
  },
  "524003": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Ramalingapuram S.O"
  },
  "524306": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Duvvur S.O (Nellore)"
  },
  "524317": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Gandavaram S.O"
  },
  "524234": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Gumparlapadu S.O"
  },
  "530031": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Visakhapatnam Steel Project S.O"
  },
  "243001": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Sadar Bazar SO Bareilly"
  },
  "110074": {
    "state": "DELHI",
    "district": "SOUTH",
    "office": "Chattarpur SO"
  },
  "362263": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Bagdu SO"
  },
  "251001": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Rampuram SO"
  },
  "362140": {
    "state": "GUJARAT",
    "district": "GIR SOMNATH",
    "office": "Akolvadi SO"
  },
  "110073": {
    "state": "DELHI",
    "district": "SOUTH WEST",
    "office": "Ujwa S.O"
  },
  "110041": {
    "state": "DELHI",
    "district": "WEST",
    "office": "Nangloi S.O"
  },
  "110059": {
    "state": "DELHI",
    "district": "WEST",
    "office": "Uttam Nagar S.O"
  },
  "110087": {
    "state": "DELHI",
    "district": "WEST",
    "office": "Sunder Vihar S.O"
  },
  "110063": {
    "state": "DELHI",
    "district": "WEST",
    "office": "Paschim Vihar S.O"
  },
  "847409": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Phulparas SO"
  },
  "847238": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Rahika SO"
  },
  "365620": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Chital SO"
  },
  "365220": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Damnagar SO"
  },
  "847109": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Tulapatganj SO"
  },
  "313011": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Badgaon S.O"
  },
  "313003": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Udaipur Industrial Area S.O"
  },
  "365540": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Jafrabad SO Amreli"
  },
  "365550": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Dedan SO"
  },
  "365640": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Dhari SO"
  },
  "192201": {
    "state": "JAMMU AND KASHMIR",
    "district": "ANANTNAG",
    "office": "Achabal SO"
  },
  "782143": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Silghat S.O"
  },
  "782128": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Garajan Bazar S.O"
  },
  "782120": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Ambagan S.O"
  },
  "782144": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Baligaon S.O"
  },
  "782102": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Barhampur S.O"
  },
  "782122": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Batadraba S.O"
  },
  "782141": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Puranigudam S.O"
  },
  "782103": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Raha S.O"
  },
  "782429": {
    "state": "ASSAM",
    "district": "HOJAI",
    "office": "Jogijan Bazar S.O"
  },
  "782448": {
    "state": "ASSAM",
    "district": "WEST KARBI ANGLONG",
    "office": "Kheroni S.O"
  },
  "363040": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Dudhrej SO"
  },
  "782446": {
    "state": "ASSAM",
    "district": "HOJAI",
    "office": "Lanka S.O (Nagaon)"
  },
  "782447": {
    "state": "ASSAM",
    "district": "HOJAI",
    "office": "Lumding S.O"
  },
  "782442": {
    "state": "ASSAM",
    "district": "HOJAI",
    "office": "Sankardev Nagar S.O"
  },
  "785008": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Cinnamara S.O"
  },
  "785004": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Barbheta S.O"
  },
  "785610": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Furkating S.O"
  },
  "360576": {
    "state": "GUJARAT",
    "district": "PORBANDAR",
    "office": "Porbandar Birla Sagar SO"
  },
  "110018": {
    "state": "DELHI",
    "district": "WEST",
    "office": "Vishnu Garden S.O"
  },
  "362625": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Nanadia SO"
  },
  "362225": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Mangrol SO Junagadh"
  },
  "574219": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Jodumarga S.O"
  },
  "574221": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kadaba S.O (Dakshina Kannada)"
  },
  "574222": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kalladka S.O"
  },
  "574326": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kalleri S.O"
  },
  "802212": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Bikramganj SO"
  },
  "802219": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Rajpur SO Rohtas"
  },
  "821110": {
    "state": "BIHAR",
    "district": "KAIMUR (BHABUA)",
    "office": "Ramgarh SO Kaimur Bhabua"
  },
  "802220": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Sanjhauli SO"
  },
  "821113": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Takia Bazar SO"
  },
  "786147": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Rangagora S.O"
  },
  "786145": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Sripuria S.O"
  },
  "786179": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Tipong S.O"
  },
  "841202": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Basant SO"
  },
  "844127": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Turki SO"
  },
  "363423": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Panshina SO"
  },
  "363020": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Joravarnagar SO"
  },
  "363760": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Kharaghoda SO"
  },
  "363775": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Lakhtar SO"
  },
  "185121": {
    "state": "JAMMU AND KASHMIR",
    "district": "POONCH",
    "office": "Samote SO"
  },
  "185201": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAJOURI",
    "office": "Solki SO"
  },
  "185153": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAJOURI",
    "office": "Sunderbani SO"
  },
  "185212": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAJOURI",
    "office": "Thanamandi SO"
  },
  "185133": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAJOURI",
    "office": "Post Graduate College Rajouri SO"
  },
  "491336": {
    "state": "CHHATTISGARH",
    "district": "KABIRDHAM",
    "office": "Dashrangpur SO"
  },
  "495555": {
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "office": "Ujwal Nagar SO Bilaspur"
  },
  "495006": {
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "office": "Rajkishore Nagar"
  },
  "841209": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Fulwaria Tajpur SO"
  },
  "360030": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Kotda Sangani SO"
  },
  "517326": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Madanapalle Bazar S.O"
  },
  "784501": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Dekargaon S.O"
  },
  "784110": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Dhekiajuli S.O"
  },
  "784112": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Alisinga S.O"
  },
  "784184": {
    "state": "ASSAM",
    "district": "Biswanath",
    "office": "Gingia S.O"
  },
  "784168": {
    "state": "ASSAM",
    "district": "Biswanath",
    "office": "Gohpur S.O"
  },
  "784170": {
    "state": "ASSAM",
    "district": "Biswanath",
    "office": "Halem S.O"
  },
  "784178": {
    "state": "ASSAM",
    "district": "Biswanath",
    "office": "Kalabari S.O"
  },
  "784027": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Kaliabhomora S.O"
  },
  "495686": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Saragaon SO"
  },
  "844111": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Aniruddha Belsar SO"
  },
  "844103": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Anzanpeer Chok SO"
  },
  "844113": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Balukaram SO"
  },
  "844501": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Basudeopur Chandel SO"
  },
  "844503": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Bidupur Bazar SO"
  },
  "844502": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Bidupur Rs SO"
  },
  "844504": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Desari SO"
  },
  "844116": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Dumari SO Vaishali"
  },
  "844118": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Goraul SO"
  },
  "844102": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Hajipur IndArea SO"
  },
  "844505": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Jhandaha SO"
  },
  "507103": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Venkateshkhani S.O"
  },
  "507124": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Yellandu Colls S.O"
  },
  "507123": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Yellandu S.O"
  },
  "385560": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Un SO Banaskantha"
  },
  "385410": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Vadgam SO"
  },
  "385575": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Vav SO"
  },
  "495695": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Adbhar SO"
  },
  "495660": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Bamhni Bazar SO"
  },
  "495671": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Champa RS SO"
  },
  "801104": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "BIKRAM S.O"
  },
  "843113": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Patahi SO Muzaffarpur"
  },
  "782461": {
    "state": "ASSAM",
    "district": "KARBI ANGLONG",
    "office": "Manja S.O"
  },
  "782439": {
    "state": "ASSAM",
    "district": "HOJAI",
    "office": "Murazar Bazar S.O"
  },
  "782445": {
    "state": "ASSAM",
    "district": "HOJAI",
    "office": "Nilbagan S.O"
  },
  "785699": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Numaligarh Refinery Project S.O"
  },
  "518599": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Bethamcherla S.O"
  },
  "531083": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Pedagummuluru S.O"
  },
  "531028": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Kj Puram S.O"
  },
  "531085": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Kotauratla S.O"
  },
  "518206": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Cement Nagar S.O"
  },
  "518467": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "K.N.Puram S.O"
  },
  "516163": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Cuddapah Coop Sugars S.O"
  },
  "574217": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Guruvayanakere S.O"
  },
  "574218": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Guthigar S.O"
  },
  "574328": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kaniyur(Puttur) S.O"
  },
  "574198": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kokkada S.O"
  },
  "802202": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Agiaon Bazar SO"
  },
  "802201": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Agiaon SO"
  },
  "841286": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Bakerganj SO"
  },
  "841232": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Barhria SO"
  },
  "802352": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Akhagaon SO"
  },
  "802311": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Barahara SO"
  },
  "585325": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Yedrami S.O"
  },
  "502103": {
    "state": "TELANGANA",
    "district": "SIDDIPET",
    "office": "Nehru Road Town S.O"
  },
  "781029": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Basistha S.O"
  },
  "783323": {
    "state": "ASSAM",
    "district": "DHUBRI",
    "office": "Amco Road S.O"
  },
  "783394": {
    "state": "ASSAM",
    "district": "CHIRANG",
    "office": "Bengtal S.O"
  },
  "783324": {
    "state": "ASSAM",
    "district": "DHUBRI",
    "office": "Bidyapara S.O"
  },
  "585316": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Mahagaon (Kalaburagi) S.O"
  },
  "585236": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Nimbal S.O"
  },
  "585217": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Mashal S.O"
  },
  "494446": {
    "state": "CHHATTISGARH",
    "district": "BIJAPUR",
    "office": "Bhopalpatnam S.O"
  },
  "382245": {
    "state": "GUJARAT",
    "district": "BOTAD",
    "office": "Ranpur SO"
  },
  "494444": {
    "state": "CHHATTISGARH",
    "district": "BIJAPUR",
    "office": "Bijapur S.O"
  },
  "382465": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Fedra SO"
  },
  "841312": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Gariba Tola SO"
  },
  "495556": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Kharod SO"
  },
  "495115": {
    "state": "CHHATTISGARH",
    "district": "MUNGELI",
    "office": "Lormi SO"
  },
  "495551": {
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "office": "Masturi SO"
  },
  "571215": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Pollibetta S.O"
  },
  "571216": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Ponnampet S.O"
  },
  "571235": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Shanivarasanthe S.O"
  },
  "754005": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Barang S.O"
  },
  "382130": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Mandal SO Ahmedabad"
  },
  "382250": {
    "state": "GUJARAT",
    "district": "BOTAD",
    "office": "Polarpur SO"
  },
  "783134": {
    "state": "ASSAM",
    "district": "GOALPARA",
    "office": "Darrangiri S.O."
  },
  "495334": {
    "state": "CHHATTISGARH",
    "district": "MUNGELI",
    "office": "Mungeli SO"
  },
  "783301": {
    "state": "ASSAM",
    "district": "DHUBRI",
    "office": "Dhubri H.O"
  },
  "783122": {
    "state": "ASSAM",
    "district": "GOALPARA",
    "office": "Damra S.O"
  },
  "382140": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Rampura SO Ahmedabad"
  },
  "382110": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Sanand SO"
  },
  "382150": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Viramgam SO"
  },
  "382170": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Virochannagar SO"
  },
  "495445": {
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "office": "Katghora SO"
  },
  "495118": {
    "state": "CHHATTISGARH",
    "district": "Gaurella Pendra Marwahi",
    "office": "Marwahi SO"
  },
  "382449": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Jantanagar SO"
  },
  "495335": {
    "state": "CHHATTISGARH",
    "district": "MUNGELI",
    "office": "Patharia SO"
  },
  "382470": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Digvijaynagar SO"
  },
  "380060": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Sola SO"
  },
  "382225": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Dholka SO"
  },
  "382220": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Bavla Market Yard SO"
  },
  "382463": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Bhadiad SO"
  },
  "382255": {
    "state": "GUJARAT",
    "district": "BOTAD",
    "office": "Jalila SO"
  },
  "843126": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Saraiya Factory SO"
  },
  "843118": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Sarfuddinpur SO"
  },
  "843119": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Silout SO"
  },
  "783331": {
    "state": "ASSAM",
    "district": "DHUBRI",
    "office": "Gauripur S.O"
  },
  "783101": {
    "state": "ASSAM",
    "district": "GOALPARA",
    "office": "Baladmari S.O"
  },
  "783334": {
    "state": "ASSAM",
    "district": "DHUBRI",
    "office": "Golakganj S.O"
  },
  "783132": {
    "state": "ASSAM",
    "district": "GOALPARA",
    "office": "Jaleswar S.O"
  },
  "783126": {
    "state": "ASSAM",
    "district": "GOALPARA",
    "office": "Krishnai S.O"
  },
  "507201": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Yerrupalem S.O"
  },
  "507301": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Aswaraopet S.O"
  },
  "507306": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Dammapeta S.O"
  },
  "507166": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Julurpahad S.O"
  },
  "507316": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Peddireddigudem S.O"
  },
  "507302": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Penuballi S.O"
  },
  "382016": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Gandhinagar Sector 17 SO"
  },
  "382421": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Adalaj SO"
  },
  "382308": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Bahiyal SO"
  },
  "382305": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Dehgam SO"
  },
  "382423": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Kasturinagar SO"
  },
  "382610": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Pethapur SO"
  },
  "531075": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Lakkavaram S.O (Visakhapatnam)"
  },
  "531033": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Munagapaka S.O"
  },
  "531081": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Nakkapalle S.O"
  },
  "382481": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Chandlodia SO"
  },
  "382450": {
    "state": "GUJARAT",
    "district": "BOTAD",
    "office": "Barwala Ghelasha SO"
  },
  "382260": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Chaloda SO"
  },
  "382213": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Changodar SO"
  },
  "783129": {
    "state": "ASSAM",
    "district": "GOALPARA",
    "office": "Lakhipur S.O (Goalpara)"
  },
  "783125": {
    "state": "ASSAM",
    "district": "GOALPARA",
    "office": "Matia S.O"
  },
  "783130": {
    "state": "ASSAM",
    "district": "GOALPARA",
    "office": "Rangjuli S.O"
  },
  "783370": {
    "state": "ASSAM",
    "district": "KOKRAJHAR",
    "office": "Kokrajhar H.O"
  },
  "783336": {
    "state": "ASSAM",
    "district": "KOKRAJHAR",
    "office": "Bhowraguri S.O"
  },
  "783371": {
    "state": "ASSAM",
    "district": "DHUBRI",
    "office": "Chapar S.O"
  },
  "783391": {
    "state": "ASSAM",
    "district": "BONGAIGAON",
    "office": "Patiladaha S.O"
  },
  "783372": {
    "state": "ASSAM",
    "district": "CHIRANG",
    "office": "Basugaon S.O"
  },
  "531021": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Paravada S.O"
  },
  "835225": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Tamar SO"
  },
  "533462": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Karapa S.O"
  },
  "533463": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Tallarevu S.O"
  },
  "535280": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Moida S.O"
  },
  "535221": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Pedamajjipalem S.O"
  },
  "535002": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Kothapeta S.O (Vizianagaram)"
  },
  "802351": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Benwalia SO"
  },
  "802152": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Bihia SO"
  },
  "802312": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Chandawa SO"
  },
  "802223": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Charpokhari SO"
  },
  "802154": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Chaurasta Bihia SO"
  },
  "784182": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Naharbari S.O"
  },
  "784174": {
    "state": "ASSAM",
    "district": "Biswanath",
    "office": "Pabhoi S.O"
  },
  "784507": {
    "state": "ASSAM",
    "district": "UDALGURI",
    "office": "Mazbat S.O"
  },
  "784101": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Balipara S.O"
  },
  "784172": {
    "state": "ASSAM",
    "district": "Biswanath",
    "office": "Barangabari S.O"
  },
  "842004": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Umanagar SO"
  },
  "843108": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "PKolhua SO"
  },
  "847408": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Madhepur SO"
  },
  "783376": {
    "state": "ASSAM",
    "district": "KOKRAJHAR",
    "office": "Choraikhola S.O"
  },
  "783333": {
    "state": "ASSAM",
    "district": "DHUBRI",
    "office": "Dingdinga S.O"
  },
  "783347": {
    "state": "ASSAM",
    "district": "KOKRAJHAR",
    "office": "Dotma S.O"
  },
  "783345": {
    "state": "ASSAM",
    "district": "KOKRAJHAR",
    "office": "Fakiragram S.O"
  },
  "781134": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Kukurmara S.O"
  },
  "781104": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Kulhati S.O"
  },
  "781127": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Nagarbera S.O"
  },
  "826006": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Rajganj SO"
  },
  "847213": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Mdb Bara Bazar SO"
  },
  "847108": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Narahiya SO"
  },
  "843111": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Motipur SO"
  },
  "843129": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Narma SO"
  },
  "843112": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Paroo SO"
  },
  "524314": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Indukurpeta S.O"
  },
  "524307": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Karatampadu S.O"
  },
  "533016": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Turangi S.O"
  },
  "533260": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Velangi S.O"
  },
  "533428": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Addatigala S.O"
  },
  "802155": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Dalippur SO Bhojpur"
  },
  "574223": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kav S.O"
  },
  "821103": {
    "state": "BIHAR",
    "district": "KAIMUR (BHABUA)",
    "office": "Chainpur SO Kaimur Bhabua"
  },
  "821111": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Sheosagar SO"
  },
  "828204": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Mugma SO"
  },
  "783131": {
    "state": "ASSAM",
    "district": "SOUTH SALMARA MANCACHAR",
    "office": "Mankachar S.O"
  },
  "783127": {
    "state": "ASSAM",
    "district": "SOUTH SALMARA MANCACHAR",
    "office": "Salmara South S.O"
  },
  "783128": {
    "state": "ASSAM",
    "district": "SOUTH SALMARA MANCACHAR",
    "office": "Sukchar S.O (Dhubri)"
  },
  "533217": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Allavaram S.O"
  },
  "533214": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Ambajipeta S.O"
  },
  "533222": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Anatavaram S.O"
  },
  "533221": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Bandarlanka S.O"
  },
  "533212": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Katrenikona S.O"
  },
  "533220": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Kesanakurrupalem S.O"
  },
  "803211": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Athmalgola SO"
  },
  "803214": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Barh Rs SO"
  },
  "534442": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Kovvali S.O"
  },
  "524137": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Kovur Cutchery S.O"
  },
  "524312": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Marripadu S.O"
  },
  "524344": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Muthukur S.O"
  },
  "844114": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Bhagwanpur SO Vaishali"
  },
  "844115": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Chaksikandar SO"
  },
  "521184": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Magallu SO"
  },
  "524322": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Atmakur (NL) S.O"
  },
  "523114": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Linga Samudram S.O"
  },
  "523115": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Peda Pavani S.O"
  },
  "577228": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Tarikere S.O"
  },
  "577515": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Bagur S.O (Chitradurga)"
  },
  "577597": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Belagur S.O"
  },
  "577519": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Bharamasagara S.O"
  },
  "577541": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Sirigere S.O (Chitradurga)"
  },
  "577542": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Srirampura S.O"
  },
  "577502": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Station Road chitradurga S.O"
  },
  "523273": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Peridepi S.O"
  },
  "521190": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Penuganchiprolu S.O"
  },
  "521163": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Thotlavalluru S.O"
  },
  "521402": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Vatsavai S.O"
  },
  "521250": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Virankilock S.O"
  },
  "785102": {
    "state": "ASSAM",
    "district": "MAJULI",
    "office": "Dakhin Pat Satra S.O"
  },
  "786183": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Panitola S.O"
  },
  "786613": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Bamunbari S.O"
  },
  "786160": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Phillobari S.O"
  },
  "784165": {
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "office": "Dhalpur S.O"
  },
  "786157": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Chapakhowa S.O"
  },
  "786171": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Muliabari S.O"
  },
  "786189": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Dinjan S.O"
  },
  "786601": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Hoogrijan S.O"
  },
  "786188": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Jagun S.O"
  },
  "786152": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Kakapathar S.O"
  },
  "786158": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Kundil S.O"
  },
  "786182": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Ledo S.O"
  },
  "784179": {
    "state": "ASSAM",
    "district": "Biswanath",
    "office": "Bedeti S.O"
  },
  "784150": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Besseria S.O"
  },
  "784153": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Bihaguri S.O"
  },
  "784502": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Bindukuri S.O"
  },
  "784177": {
    "state": "ASSAM",
    "district": "Biswanath",
    "office": "Biswanathghat S.O"
  },
  "784167": {
    "state": "ASSAM",
    "district": "Biswanath",
    "office": "Borgong S.O"
  },
  "784111": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Darrang Panbari S.O"
  },
  "788720": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Kaliganj Bazar S.O"
  },
  "844119": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Ghataro SO"
  },
  "844117": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Dharhara SO Vaishali"
  },
  "495009": {
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "office": "Koni SO"
  },
  "533406": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Annavaram S.O"
  },
  "365645": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Bhader SO"
  },
  "788711": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Karimganj Bazar S.O"
  },
  "788719": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Kayasthagram S.O"
  },
  "788781": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Mahisashan S.O"
  },
  "788722": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Nilam Bazar S.O"
  },
  "788724": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Patharkandi S.O"
  },
  "788712": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Settlement Road S.O"
  },
  "788713": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Silchar Road S.O"
  },
  "788709": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Tillabazar S.O"
  },
  "784103": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Chariduar S.O"
  },
  "784105": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Ghoramari S.O"
  },
  "533211": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Mukteswaram S.O"
  },
  "533216": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Mummidivaram S.O"
  },
  "781011": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Mlg Rly Hqs S.O"
  },
  "533445": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Gollaprolu S.O"
  },
  "533435": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Jaggampeta S.O"
  },
  "533431": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Kirlampudi S.O"
  },
  "533407": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Kotananduru S.O"
  },
  "533447": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Kothapalli (U) S.O"
  },
  "533433": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Mallam S.O (East Godavari)"
  },
  "382321": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Chhala SO"
  },
  "382042": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "CRPF Campus G Nagar SO"
  },
  "382355": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Dabhoda SO"
  },
  "382028": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Gandhinagar Sector 28 SO"
  },
  "382426": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Koba SO"
  },
  "382007": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Gandhinagar Sector 8 SO"
  },
  "382010": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "New Sachivalaya Complex SO"
  },
  "784180": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Jamugurihat S.O"
  },
  "786181": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Margherita S.O"
  },
  "786151": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Doom Dooma S.O"
  },
  "786192": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Hijiguri S.O"
  },
  "786170": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Makum Junction S.O"
  },
  "786187": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Makum Pathar S.O"
  },
  "843117": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Rampur Hari SO"
  },
  "843116": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Kuahi SO"
  },
  "521456": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Ibrahimpatnam S.O (Krishna)"
  },
  "521165": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Lakshmana Nagar S.O"
  },
  "521101": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Gannavaram S.O"
  },
  "521175": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Jaggaiahpet S.O"
  },
  "524411": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Kota(NL) S.O"
  },
  "524123": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Kotapolur S.O"
  },
  "524403": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Mallam S.O (Nellore)"
  },
  "531105": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Sileru Project S.O"
  },
  "813205": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Ghogha SO"
  },
  "784189": {
    "state": "ASSAM",
    "district": "Biswanath",
    "office": "Karsontala S.O"
  },
  "784506": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Missamari S.O"
  },
  "784025": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Panchmile S.O"
  },
  "784505": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Rangapara S.O"
  },
  "784117": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Sirajuli S.O"
  },
  "784514": {
    "state": "ASSAM",
    "district": "DARRANG",
    "office": "Lalpul Bazar S.O"
  },
  "784144": {
    "state": "ASSAM",
    "district": "DARRANG",
    "office": "Pathorighat S.O"
  },
  "784508": {
    "state": "ASSAM",
    "district": "UDALGURI",
    "office": "Rowta S.O"
  },
  "784509": {
    "state": "ASSAM",
    "district": "UDALGURI",
    "office": "Udalguri S.O"
  },
  "781318": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Sarupeta S.O"
  },
  "781317": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Sorbhog S.O"
  },
  "781355": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Assam Syntex S.O"
  },
  "781303": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Banagram S.O"
  },
  "781340": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Banekuchi S.O"
  },
  "785688": {
    "state": "ASSAM",
    "district": "CHARAIDEO",
    "office": "Lakowah S.O"
  },
  "785698": {
    "state": "ASSAM",
    "district": "CHARAIDEO",
    "office": "Lakwah R.S. S.O"
  },
  "785670": {
    "state": "ASSAM",
    "district": "CHARAIDEO",
    "office": "Moranhat S.O"
  },
  "785692": {
    "state": "ASSAM",
    "district": "CHARAIDEO",
    "office": "Sapekhati S.O"
  },
  "785673": {
    "state": "ASSAM",
    "district": "CHARAIDEO",
    "office": "Sepon S.O"
  },
  "785686": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Simaluguri S.O"
  },
  "785689": {
    "state": "ASSAM",
    "district": "CHARAIDEO",
    "office": "Suffry S.O"
  },
  "785682": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Tamulichiga S.O"
  },
  "782425": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Chaparmukh S.O"
  },
  "782125": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Rupahi S.O"
  },
  "782139": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Salana S.O"
  },
  "530003": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Vidya Bhavan S.O"
  },
  "530051": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Sujatha Nagar S.O"
  },
  "530028": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Simhachalam S.O"
  },
  "533287": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Sithanagaram S.O"
  },
  "533105": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Weavers Colony S.O"
  },
  "533350": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "KUNAVARAM S.O."
  },
  "533342": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Anaparthy S.O"
  },
  "533307": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Angara S.O"
  },
  "577517": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Turuvanur S.O"
  },
  "577545": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Yerabally S.O"
  },
  "782142": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Bebejia S.O"
  },
  "782135": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Chapanalla S.O"
  },
  "781375": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Bangaon S.O (Nalbari)"
  },
  "781346": {
    "state": "ASSAM",
    "district": "BAKSA",
    "office": "Barama S.O"
  },
  "781333": {
    "state": "ASSAM",
    "district": "BAKSA",
    "office": "Barimakha S.O"
  },
  "781138": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Bartola S.O"
  },
  "781304": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Belsor S.O"
  },
  "781334": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Chowkbazar S.O (Nalbari)"
  },
  "781369": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Ghograpar S.O"
  },
  "781310": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Jagra S.O"
  },
  "781339": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Karia S.O"
  },
  "781360": {
    "state": "ASSAM",
    "district": "BAKSA",
    "office": "Kumarikata S.O"
  },
  "781337": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Milanpur S.O"
  },
  "524305": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Buchireddypalem S.O"
  },
  "524316": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Kodavaluru S.O"
  },
  "497101": {
    "state": "CHHATTISGARH",
    "district": "SURGUJA",
    "office": "Batouli SO"
  },
  "571214": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Napoklu S.O"
  },
  "495684": {
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "office": "Balco Nagar Korba SO"
  },
  "495447": {
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "office": "Banki Mongra SO"
  },
  "785667": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Konwarpur S.O"
  },
  "785669": {
    "state": "ASSAM",
    "district": "CHARAIDEO",
    "office": "Moran S.O"
  },
  "785684": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Namtidoll S.O"
  },
  "785685": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Nazira S.O"
  },
  "785674": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Nemuguri S.O"
  },
  "683104": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kalamassery SO"
  },
  "682504": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Mulavukad SO"
  },
  "682506": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Panangad SO Ernakulam"
  },
  "854112": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Amdabad SO"
  },
  "854101": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Ayodhyaganj Bazar SO"
  },
  "522415": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Gurazalla S.O"
  },
  "682308": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Puthencruz SO"
  },
  "682305": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Thiruvamkulam SO"
  },
  "782121": {
    "state": "ASSAM",
    "district": "MARIGAON",
    "office": "Bhuragaon S.O"
  },
  "682315": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kanjiramattom SO"
  },
  "682314": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Mulanthuruthy SO"
  },
  "785697": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "ONGC Colony S.O"
  },
  "785640": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Sivasagar H.O"
  },
  "785687": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Santak S.O"
  },
  "785671": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Nitaipukhuri S.O"
  },
  "785672": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Rajmai S.O"
  },
  "577556": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Anagodu S.O"
  },
  "577512": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Anaji S.O"
  },
  "577513": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Asagodu S.O"
  },
  "577514": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Bada S.O"
  },
  "577553": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Bilichodu S.O"
  },
  "577566": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Doddabathi S.O"
  },
  "577601": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Yantrapura Harihara S.O"
  },
  "577528": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Jagalur S.O"
  },
  "841404": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Bagaura SO"
  },
  "843334": {
    "state": "BIHAR",
    "district": "SHEOHAR",
    "office": "Piprarhi SO"
  },
  "843329": {
    "state": "BIHAR",
    "district": "SHEOHAR",
    "office": "Sheohar SO"
  },
  "782123": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Dhing S.O"
  },
  "843326": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Raipur SO Sitamarhi"
  },
  "843327": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Riga SO"
  },
  "843328": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Runnisaidpur SO"
  },
  "843302": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Sitamarhi Bazar SO"
  },
  "577516": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Bhanuvally S.O"
  },
  "843330": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Sonbersa SO"
  },
  "843331": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Sursand SO"
  },
  "843311": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Athri SO"
  },
  "843313": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Bairgania Bazar SO"
  },
  "533343": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Bikkavolu S.O"
  },
  "523335": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Ardhaveedu S.O"
  },
  "523334": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Besthavari  Peta S.O"
  },
  "523333": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Cumbum East S.O"
  },
  "523305": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Donakonda R.S. S.O"
  },
  "523330": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Dupadu S.O"
  },
  "523356": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Edavalli S.O"
  },
  "523327": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Erragondapalem S.O"
  },
  "531127": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Satyavaram S.O"
  },
  "533261": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Chelluru S.O"
  },
  "784114": {
    "state": "ASSAM",
    "district": "UDALGURI",
    "office": "Orang S.O"
  },
  "802132": {
    "state": "BIHAR",
    "district": "KAIMUR (BHABUA)",
    "office": "Noan SO"
  },
  "821311": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Rohtas SO"
  },
  "802221": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Surajpura SO"
  },
  "781126": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Mukalmua S.O"
  },
  "781368": {
    "state": "ASSAM",
    "district": "BAKSA",
    "office": "Nagrijuli S.O"
  },
  "781349": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Nizdhamdhama S.O"
  },
  "781312": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Rampur S.O (Nalbari)"
  },
  "788805": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Katigorah S.O"
  },
  "788804": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Katirail S.O"
  },
  "788025": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Arunachal S.O"
  },
  "788820": {
    "state": "ASSAM",
    "district": "DIMA HASAO",
    "office": "Haflong Ptc S.O"
  },
  "788819": {
    "state": "ASSAM",
    "district": "DIMA HASAO",
    "office": "Haflong S.O"
  },
  "788818": {
    "state": "ASSAM",
    "district": "DIMA HASAO",
    "office": "Harengajao S.O"
  },
  "788127": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Jarailtala Bazar S.O"
  },
  "788107": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Joypur Rajabazar S.O"
  },
  "788121": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Kabuganj Bazar S.O"
  },
  "788108": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Kumbhir S.O"
  },
  "821312": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Tilouthu SO"
  },
  "577511": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Adivala S.O"
  },
  "577558": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Aimangala S.O"
  },
  "577543": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Thallak S.O"
  },
  "841441": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Baghibazar SO"
  },
  "841405": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Barauli SO Gopalganj"
  },
  "841425": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Bathubazar SO"
  },
  "841426": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Bhore SO"
  },
  "382722": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Santej SO"
  },
  "497231": {
    "state": "CHHATTISGARH",
    "district": "SURAJPUR",
    "office": "Bhaiyathan SO"
  },
  "497235": {
    "state": "CHHATTISGARH",
    "district": "SURAJPUR",
    "office": "Bhatgaon Colly SO"
  },
  "788832": {
    "state": "ASSAM",
    "district": "DIMA HASAO",
    "office": "Langting S.O"
  },
  "788830": {
    "state": "ASSAM",
    "district": "DIMA HASAO",
    "office": "Mahur S.O"
  },
  "784523": {
    "state": "ASSAM",
    "district": "UDALGURI",
    "office": "Panerihat S.O"
  },
  "784528": {
    "state": "ASSAM",
    "district": "UDALGURI",
    "office": "Purani Tangla S.O"
  },
  "784521": {
    "state": "ASSAM",
    "district": "UDALGURI",
    "office": "Tangla S.O"
  },
  "518007": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "GPRE College S.O"
  },
  "518412": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Prathakota S.O"
  },
  "518217": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Ramalla Kota S.O"
  },
  "785690": {
    "state": "ASSAM",
    "district": "CHARAIDEO",
    "office": "Sonari S.O (Sibsagar)"
  },
  "577596": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Dharmapura S.O"
  },
  "802157": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Gajrajganj SO"
  },
  "531035": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Subbavaram S.O"
  },
  "531055": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Yellamanchili S.O"
  },
  "531111": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Chintapalli S.O"
  },
  "523357": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Giddalur S.O"
  },
  "523336": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Mohiddin Puram S.O"
  },
  "523367": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Mundlapadu S.O"
  },
  "494334": {
    "state": "CHHATTISGARH",
    "district": "KANKER",
    "office": "Kanker Kutchery S.O"
  },
  "494665": {
    "state": "CHHATTISGARH",
    "district": "KANKER",
    "office": "Antagarh S.O"
  },
  "494777": {
    "state": "CHHATTISGARH",
    "district": "KANKER",
    "office": "Bandecolony S.O"
  },
  "494669": {
    "state": "CHHATTISGARH",
    "district": "KANKER",
    "office": "Bhanupratappur S.O"
  },
  "782002": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Haiborgaon S.O"
  },
  "782003": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Itachali S.O"
  },
  "782136": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Jakhalabandha S.O"
  },
  "493448": {
    "state": "CHHATTISGARH",
    "district": "MAHASAMUND",
    "office": "Komakhan SO"
  },
  "518218": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Ulindakonda S.O"
  },
  "841508": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Bijaipur SO Gopalganj"
  },
  "574220": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kabaka S.O"
  },
  "574224": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Madanthyar S.O"
  },
  "518216": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Veldurthi S.O"
  },
  "781313": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Simlaguri S.O"
  },
  "781344": {
    "state": "ASSAM",
    "district": "BAKSA",
    "office": "Baganpara S.O"
  },
  "824123": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Kutumba SO"
  },
  "843314": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Bajpatti SO"
  },
  "843315": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Barharwa SO Sitamarhi"
  },
  "843316": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Belsand SO"
  },
  "843318": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Budhnagra Deorhi SO"
  },
  "843319": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Choraut SO"
  },
  "843320": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Pupari Bazar SO"
  },
  "577525": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Hadadi S.O"
  },
  "495449": {
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "office": "Pali SO Korba"
  },
  "841419": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Mirzapur SO Saran"
  },
  "841424": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Taraiya SO"
  },
  "841417": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Masrakh SO"
  },
  "803307": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Bhadaur SO Patna"
  },
  "521126": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Challapalli S.O"
  },
  "852133": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Janardanpur SO"
  },
  "847452": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Nirmali SO"
  },
  "783382": {
    "state": "ASSAM",
    "district": "BONGAIGAON",
    "office": "Jogighopa S.O"
  },
  "783392": {
    "state": "ASSAM",
    "district": "BONGAIGAON",
    "office": "Manikpur S.O (Bongaigaon)"
  },
  "783383": {
    "state": "ASSAM",
    "district": "BONGAIGAON",
    "office": "Salmara North S.O"
  },
  "781306": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Chamata S.O"
  },
  "781343": {
    "state": "ASSAM",
    "district": "BAKSA",
    "office": "Dhanbil S.O"
  },
  "781373": {
    "state": "ASSAM",
    "district": "BAKSA",
    "office": "Doomni S.O"
  },
  "781347": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Kamarkuchi S.O"
  },
  "781374": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Makhibaha S.O"
  },
  "781348": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Marowa S.O"
  },
  "781372": {
    "state": "ASSAM",
    "district": "BAKSA",
    "office": "Mussalpur S.O"
  },
  "788011": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Assam University S.O"
  },
  "391165": {
    "state": "GUJARAT",
    "district": "CHHOTAUDEPUR",
    "office": "Chhotaudepur SO"
  },
  "391152": {
    "state": "GUJARAT",
    "district": "CHHOTAUDEPUR",
    "office": "Gadhboriad SO"
  },
  "495554": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Pamgarh SO"
  },
  "495117": {
    "state": "CHHATTISGARH",
    "district": "Gaurella Pendra Marwahi",
    "office": "Pendra Road SO"
  },
  "384325": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Kheralu SO"
  },
  "384540": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Ladol SO"
  },
  "384412": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Modhera SO"
  },
  "384005": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "PANCHOT S.O"
  },
  "384560": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Sardarpur SO Mahesana"
  },
  "384335": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Sipor SO"
  },
  "384170": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Unjha SO"
  },
  "384355": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Vadnagar SO"
  },
  "384570": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Vijapur SO"
  },
  "787057": {
    "state": "ASSAM",
    "district": "DHEMAJI",
    "office": "Dhemaji S.O"
  },
  "384315": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Visnagar SO"
  },
  "532440": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Palakonda S.O"
  },
  "535527": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Pedabondapalli S.O"
  },
  "532443": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Seethampeta S.O"
  },
  "532461": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Seetharampuram Inam S.O"
  },
  "532460": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Veeraghattam S.O"
  },
  "574279": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kanyana S.O"
  },
  "843115": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Piar SO"
  },
  "842002": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Ramna SO Muzaffarpur"
  },
  "391135": {
    "state": "GUJARAT",
    "district": "CHHOTAUDEPUR",
    "office": "Bodeli SO"
  },
  "391170": {
    "state": "GUJARAT",
    "district": "CHHOTAUDEPUR",
    "office": "Kawant SO"
  },
  "391140": {
    "state": "GUJARAT",
    "district": "CHHOTAUDEPUR",
    "office": "Kosindra SO"
  },
  "391150": {
    "state": "GUJARAT",
    "district": "CHHOTAUDEPUR",
    "office": "Naswadi SO"
  },
  "391168": {
    "state": "GUJARAT",
    "district": "CHHOTAUDEPUR",
    "office": "Panvad SO"
  },
  "391160": {
    "state": "GUJARAT",
    "district": "CHHOTAUDEPUR",
    "office": "Pavijetpur SO"
  },
  "577005": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Sks Nagar Davanagere S.O"
  },
  "577006": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Vinobhanagara Extn DVG S.O"
  },
  "824208": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Madanpur SO AurangabadBH"
  },
  "824303": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Rajbari Kala BO"
  },
  "824301": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Nabinagar SO"
  },
  "824124": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Obra SO AurangabadBH"
  },
  "784154": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Ketekibari S.O"
  },
  "784102": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Lokra S.O"
  },
  "784173": {
    "state": "ASSAM",
    "district": "Biswanath",
    "office": "Mijikajan S.O"
  },
  "784169": {
    "state": "ASSAM",
    "district": "Biswanath",
    "office": "Howajan  S.O"
  },
  "784504": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Borjuli S.O"
  },
  "784176": {
    "state": "ASSAM",
    "district": "Biswanath",
    "office": "Chariali MDG"
  },
  "391156": {
    "state": "GUJARAT",
    "district": "CHHOTAUDEPUR",
    "office": "Tejgadh SO"
  },
  "391145": {
    "state": "GUJARAT",
    "district": "CHHOTAUDEPUR",
    "office": "Sankheda SO"
  },
  "783381": {
    "state": "ASSAM",
    "district": "BONGAIGAON",
    "office": "New Bongaigaon S.O"
  },
  "783389": {
    "state": "ASSAM",
    "district": "BONGAIGAON",
    "office": "Boitamari S.O"
  },
  "828121": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Sijua SO"
  },
  "828402": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Topchanchi SO"
  },
  "828115": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Khasjeena Gora SO"
  },
  "828117": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Kustore SO"
  },
  "813206": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Ishipur SO"
  },
  "824125": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Rafiganj SO"
  },
  "786159": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Sukriting S.O"
  },
  "848115": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Dighra SO"
  },
  "848205": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Hassanpur S Mill SO"
  },
  "848117": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Ilmasnagar SO"
  },
  "848134": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Jitwarpur SO"
  },
  "848302": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Kalyanpur Chowk SO"
  },
  "848160": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Kalyanpur SO Samastipur"
  },
  "848101": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Kashipur Samastipur SO"
  },
  "848301": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Kishanpur SO Samastipur"
  },
  "848122": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Madhopur Dighrua SO"
  },
  "848208": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Mangalgarh SO"
  },
  "848502": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Mohiuddin Nagar RS SO"
  },
  "848121": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Morwa SO"
  },
  "781353": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Gopalbazar S.O"
  },
  "781378": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Haribhanga S.O"
  },
  "781370": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Kaithalkuchi S.O"
  },
  "781351": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Kalag S.O"
  },
  "781341": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Kazipara S.O"
  },
  "788831": {
    "state": "ASSAM",
    "district": "DIMA HASAO",
    "office": "Maibong S.O"
  },
  "848211": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Narhan SO"
  },
  "848505": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "P Pur Halai"
  },
  "848504": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Patory SO"
  },
  "854330": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Kasba SO Purnia"
  },
  "534186": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Yandagandi S.O"
  },
  "534112": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Nallajerla S.O"
  },
  "854317": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Barsoighat SO"
  },
  "534342": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Chagallu S.O"
  },
  "534318": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Dondapudi S.O"
  },
  "534315": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Polavaram S.O"
  },
  "534302": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Samisragudem S.O"
  },
  "384265": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Patan City SO"
  },
  "384110": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Balisana SO"
  },
  "384220": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Chanasma SO"
  },
  "384225": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Dhinoj SO"
  },
  "384240": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Harij SO"
  },
  "521180": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Kanchikacharla S.O"
  },
  "521164": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Katuru S.O"
  },
  "521226": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "A.Konduru S.O"
  },
  "781350": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Sanekuchi S.O"
  },
  "781338": {
    "state": "ASSAM",
    "district": "NALBARI",
    "office": "Solmara S.O"
  },
  "784104": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Shalonibari S.O"
  },
  "786150": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Barhapjan S.O"
  },
  "786126": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Borguri S.O"
  },
  "533292": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Dosakayapalli S.O"
  },
  "533284": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Gangavaram S.O"
  },
  "533286": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Gokaram S.O"
  },
  "533126": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Kadiyam S.O"
  },
  "533102": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Konthamuru S.O"
  },
  "533289": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Korukonda S.O"
  },
  "533285": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Kothapalli S.O (East Godavari)"
  },
  "533294": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Rajanagaram S.O"
  },
  "533288": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Rampachodavaram S.O"
  },
  "786190": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Hansara S.O"
  },
  "785105": {
    "state": "ASSAM",
    "district": "MAJULI",
    "office": "Jengraimukh S.O"
  },
  "682306": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Eroor SO Ernakulam"
  },
  "682030": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kakkanad SO"
  },
  "521247": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Meduru S.O"
  },
  "521230": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Mylavaram S.O (Krishna)"
  },
  "134205": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "Morni S.O"
  },
  "522102": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Bapatla Engg College S.O"
  },
  "522311": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Chandole S.O"
  },
  "522310": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Appikatla S.O"
  },
  "522213": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Sangamjagarlamudi S.O"
  },
  "522257": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Vellaturu S.O"
  },
  "522261": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Vemuru S.O"
  },
  "522259": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Kanagala S.O (Guntur)"
  },
  "535214": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Ss Korukonda S.O"
  },
  "521181": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Juzzuru S.O"
  },
  "521246": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Kapileswarapuram S.O (Krishna)"
  },
  "521227": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Khambhampadu S.O"
  },
  "521228": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Kondapalli S.O"
  },
  "521457": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Kumaraswamy Raja Nagar S.O"
  },
  "521256": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Mantada S.O"
  },
  "521183": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Muppalla S.O (Krishna)"
  },
  "192305": {
    "state": "JAMMU AND KASHMIR",
    "district": "PULWAMA",
    "office": "Achan SO"
  },
  "361335": {
    "state": "GUJARAT",
    "district": "DEVBHUMI DWARKA",
    "office": "Dwarka SO"
  },
  "361320": {
    "state": "GUJARAT",
    "district": "DEVBHUMI DWARKA",
    "office": "Jamkalyanpur SO"
  },
  "361305": {
    "state": "GUJARAT",
    "district": "DEVBHUMI DWARKA",
    "office": "Khambhalia SO"
  },
  "495119": {
    "state": "CHHATTISGARH",
    "district": "Gaurella Pendra Marwahi",
    "office": "Pendra SO"
  },
  "384530": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Kukarwada SO"
  },
  "384465": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Langhnaj SO"
  },
  "384435": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Linch SO"
  },
  "384340": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Sudasana SO"
  },
  "384441": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Thol I E SO"
  },
  "800009": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Begampur SO Patna"
  },
  "800007": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Dental College SO"
  },
  "803203": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Alawalpur SO"
  },
  "534305": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Tadimalla S.O"
  },
  "534196": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Ch.Agraharam S.O"
  },
  "854103": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Daharia Molls SO"
  },
  "855105": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Durgaganj SO"
  },
  "521321": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Janardhanapuram S.O"
  },
  "521333": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Kaikalur S.O"
  },
  "521344": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Kalidindi S.O"
  },
  "521343": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Korukollu S.O"
  },
  "521345": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Mandavalli S.O"
  },
  "521323": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Moturu S.O"
  },
  "521325": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Mudinepalli S.O"
  },
  "520012": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Kamakotinagar S.O"
  },
  "805104": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Kadirganj SO"
  },
  "805106": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Kawakol SO"
  },
  "805109": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Nardiganj SO"
  },
  "805122": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Narhat SO"
  },
  "520007": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Industrial Estate S.O (Krishna)"
  },
  "521151": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Kankipadu S.O"
  },
  "521108": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Ramavarappadu S.O"
  },
  "521134": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Tadigadapa S.O"
  },
  "521245": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Akunuru S.O"
  },
  "521211": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Aukiripalli S.O"
  },
  "520015": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Azitnagar S.O"
  },
  "521178": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Chillakallu S.O"
  },
  "521229": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "G Konduru S.O"
  },
  "805121": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Nemdarganj SO"
  },
  "805123": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Orhanpur SO"
  },
  "805124": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Pakaribarwan SO"
  },
  "805125": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Rajauli SO"
  },
  "805126": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Rajhat SO"
  },
  "805127": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Sirdala SO"
  },
  "805129": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Tungi SO"
  },
  "805130": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Warisaliganj SO"
  },
  "805131": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Wazirganj SO Gaya"
  },
  "363435": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Kholadiyad SO"
  },
  "134203": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Naraingarh S.O"
  },
  "134201": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Jatwar S.O"
  },
  "783325": {
    "state": "ASSAM",
    "district": "DHUBRI",
    "office": "Jhagrarpar S.O"
  },
  "521340": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Pallevada S.O"
  },
  "835102": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Silli SO"
  },
  "533263": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Dangeru S.O"
  },
  "533262": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Draksharamam S.O"
  },
  "533341": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Dwarapudi S.O"
  },
  "533306": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Kotipalli S.O"
  },
  "533264": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Kutukuluru S.O"
  },
  "533305": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Pamarru S.O (East Godavari)"
  },
  "788004": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "G C College S.O"
  },
  "533340": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Tapeswaram S.O"
  },
  "533234": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Yeditha S.O"
  },
  "535501": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Parvatipuram H.O"
  },
  "533125": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Dowlaiswaram S.O"
  },
  "533124": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Industrial Estate S.O (East Godavari)"
  },
  "533295": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Maredumilli S.O"
  },
  "533293": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Torredu S.O"
  },
  "518533": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Velgode S.O"
  },
  "805107": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Kosi SO Nawada"
  },
  "805111": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Nawada Kutchery SO"
  },
  "521107": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Mustabad S.O (Krishna)"
  },
  "782411": {
    "state": "ASSAM",
    "district": "MARIGAON",
    "office": "Jagibhakatgaon S.O"
  },
  "782104": {
    "state": "ASSAM",
    "district": "MARIGAON",
    "office": "Jaluguti S.O"
  },
  "782413": {
    "state": "ASSAM",
    "district": "MARIGAON",
    "office": "Kagajnagar S.O"
  },
  "782127": {
    "state": "ASSAM",
    "district": "MARIGAON",
    "office": "Lahorighat S.O"
  },
  "782126": {
    "state": "ASSAM",
    "district": "MARIGAON",
    "office": "Moirabari S.O"
  },
  "782105": {
    "state": "ASSAM",
    "district": "MARIGAON",
    "office": "Morigaon S.O"
  },
  "785616": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Gatanga S.O"
  },
  "782440": {
    "state": "ASSAM",
    "district": "HOJAI",
    "office": "Daboka S.O"
  },
  "521104": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Nidamanuru S.O"
  },
  "520003": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Gandhinagaram S.O (Vijayawada)"
  },
  "521102": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Bacon Factory S.O"
  },
  "521182": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Chandarlapadu S.O"
  },
  "805112": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Parnawada SO"
  },
  "533233": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Alamuru S.O (East Godavari)"
  },
  "384229": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Lanva SO"
  },
  "824207": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Konch SO Gaya"
  },
  "824211": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Sherghati SO"
  },
  "384290": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Kakoshi SO"
  },
  "384255": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Kungher SO"
  },
  "824210": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Raniganj SO Gaya"
  },
  "521329": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Pedagonnuru S.O"
  },
  "521390": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Pedamaddali S.O"
  },
  "521326": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Rudrapaka S.O"
  },
  "521327": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Tamirisa S.O"
  },
  "521263": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Ventrapragada S.O"
  },
  "854104": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Gurubazar SO"
  },
  "854106": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Katihar Bmp Camp SO"
  },
  "854107": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Katihar Mill SO"
  },
  "855107": {
    "state": "BIHAR",
    "district": "KISHANGANJ",
    "office": "Kishanganj SO"
  },
  "360530": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Jamjodhpur Darbargadh SO"
  },
  "361007": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Gulabnagar SO"
  },
  "361011": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Hadiana SO"
  },
  "361130": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Jamwanthali SO"
  },
  "361250": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Jodia SO"
  },
  "361160": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Kalavad SO"
  },
  "361013": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Khandhera SO"
  },
  "533309": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Kapileswarapuram S.O (East Godavari)"
  },
  "533308": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Mandapeta Bazar S.O"
  },
  "533345": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Pandalapaka S.O"
  },
  "533256": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Ramachandrapuram Old Town S.O"
  },
  "533346": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Rayavaram S.O (East Godavari)"
  },
  "805128": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Tarwan SO"
  },
  "391110": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Dabhoi HO"
  },
  "391120": {
    "state": "GUJARAT",
    "district": "NARMADA",
    "office": "Tilakwada SO"
  },
  "391250": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Sadhli SO"
  },
  "788710": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Karimganj H.O"
  },
  "391107": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Thuwavi SO"
  },
  "391115": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Sinor SO"
  },
  "782124": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Juria S.O"
  },
  "782426": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Kampur S.O"
  },
  "782101": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Nonoi S.O"
  },
  "782427": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Kathiatoli S.O"
  },
  "785681": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Amguri Haloating S.O"
  },
  "785680": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Amguri S.O"
  },
  "785661": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Charing S.O"
  },
  "785662": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Demow S.O"
  },
  "782106": {
    "state": "ASSAM",
    "district": "MARIGAON",
    "office": "Charaibahi S.O"
  },
  "788006": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Link Road S.O (Cachar"
  },
  "517167": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Kothapalle S.O"
  },
  "517429": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Mogili Venkatagiri S.O"
  },
  "517127": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Murukambattu S.O"
  },
  "517132": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Nangamangalam S.O"
  },
  "517408": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Palamaner S.O"
  },
  "517126": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Penumur S.O"
  },
  "517124": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Puthalapattu S.O"
  },
  "517422": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Yadamari S.O"
  },
  "517370": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Beerangi Kothakota S.O"
  },
  "517351": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Burakayalakota S.O"
  },
  "785014": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Rajabari S.O"
  },
  "785636": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Selenghat S.O"
  },
  "785112": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Teok S.O"
  },
  "785630": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Titabor S.O"
  },
  "785691": {
    "state": "ASSAM",
    "district": "CHARAIDEO",
    "office": "Bhojo S.O"
  },
  "785683": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Jhanji S.O"
  },
  "523315": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Gajjalakonda S.O"
  },
  "523373": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Komarole S.O"
  },
  "533006": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Indrapalem S.O"
  },
  "521322": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Golvepalli (Zami) S.O"
  },
  "801505": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "P.SHARIF S.O"
  },
  "801109": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "NAUBATPUR SO"
  },
  "801110": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "PALIGANJ S.O"
  },
  "847305": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Madhwapur SO"
  },
  "805113": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Kashichak SO"
  },
  "805103": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Hasua SO"
  },
  "805108": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Lalbigha SO"
  },
  "521148": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Elamarru S.O"
  },
  "521261": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Mudunuru S.O"
  },
  "805105": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Katrisarai SO"
  },
  "848206": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Kundal SO Samastipur"
  },
  "848213": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Kuseshwar Asthan SO"
  },
  "854332": {
    "state": "BIHAR",
    "district": "ARARIA",
    "office": "Kuari SO"
  },
  "854333": {
    "state": "BIHAR",
    "district": "ARARIA",
    "office": "Madanpur SO Araria"
  },
  "532456": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Battili S.O"
  },
  "532445": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Burja S.O"
  },
  "532484": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Dusi Rs S.O"
  },
  "532459": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Hiramandalam S.O"
  },
  "532214": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Korasavada S.O"
  },
  "854331": {
    "state": "BIHAR",
    "district": "ARARIA",
    "office": "Kursakanta SO"
  },
  "533106": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Prakasamnagar S.O"
  },
  "824102": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "S S College SO"
  },
  "824129": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Rukundi Jhikatia SO"
  },
  "824115": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Sihari SO"
  },
  "824302": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Tandwa SO AurangabadBH"
  },
  "824103": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "War SO"
  },
  "848501": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Mohiuddin Nagar SO"
  },
  "521212": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Nunna S.O"
  },
  "521286": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Pedavutapalli S.O"
  },
  "521241": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Railway Wagon Work Shop S.O"
  },
  "521170": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Veerullapadu S.O"
  },
  "517419": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Narasingarayanipettah S.O"
  },
  "522111": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Karlapalem S.O"
  },
  "522262": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Kuchinapudi S.O"
  },
  "522315": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Machavaram S.O (Tenali)"
  },
  "522268": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Nagaram S.O (Guntur)"
  },
  "522314": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Nizampatnam S.O"
  },
  "522316": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Patsalatadiparru S.O"
  },
  "522329": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Pittalavanipalem S.O"
  },
  "522124": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Ponnur S.O"
  },
  "522317": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Stuvartpuram S.O"
  },
  "522318": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Tsunduru S.O"
  },
  "522211": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Angalakudur S.O"
  },
  "522256": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Bhattiprolu S.O"
  },
  "522330": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Duggirala S.O"
  },
  "843317": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Bhutahi SO"
  },
  "517403": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Ramapuram S.O (Chittoor)"
  },
  "517421": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Thugundram S.O"
  },
  "517599": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Vengalrajukuppam S.O"
  },
  "517319": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Chinnatippasamudram S.O"
  },
  "517257": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Chowdepalle S.O"
  },
  "517425": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Kuppam S.O"
  },
  "384430": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Santhal SO"
  },
  "384310": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Valam SO"
  },
  "384565": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Vasai Dabhala SO"
  },
  "841442": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Nagra SO Saran"
  },
  "824221": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Dumaria SO"
  },
  "802301": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Arrah Kutchey SO"
  },
  "841218": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Paiga SO"
  },
  "841421": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Sarhwara SO"
  },
  "845427": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Pachpakari SO"
  },
  "845457": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Patahi SO East Champaran"
  },
  "845431": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Raghunathpur Bazar SO"
  },
  "845428": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Pakari Dayal SO"
  },
  "845430": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Phenhara SO"
  },
  "845429": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Pipra Factory SO"
  },
  "845406": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Rajepur Champaran SO"
  },
  "518464": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Kodumur S.O"
  },
  "518411": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Konidela S.O"
  },
  "518405": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Midthur S.O"
  },
  "518004": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Prakash Nagar S.O"
  },
  "518401": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Nandikotkur bazar S.O"
  },
  "532427": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Budithi S.O"
  },
  "532432": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Jalumuru S.O"
  },
  "533210": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Bendamurlanka S.O"
  },
  "533241": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Mukkamala S.O"
  },
  "531060": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "S Rayavaram S.O"
  },
  "531032": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Thummapala S.O"
  },
  "531082": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Etikoppaka S.O"
  },
  "531029": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "G Madugula S.O"
  },
  "361280": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Kanalush SO"
  },
  "855108": {
    "state": "BIHAR",
    "district": "KISHANGANJ",
    "office": "Kishanganj Bazar SO"
  },
  "522325": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Amartaluru S.O"
  },
  "522301": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Anantavaram S.O"
  },
  "522264": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Chodayapalem S.O"
  },
  "522312": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Turumella S.O"
  },
  "534156": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Duvva S.O"
  },
  "534313": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Devarapalli S.O (West Godavari)"
  },
  "495553": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Nariyara SO"
  },
  "785693": {
    "state": "ASSAM",
    "district": "CHARAIDEO",
    "office": "Borhat S.O"
  },
  "782412": {
    "state": "ASSAM",
    "district": "MARIGAON",
    "office": "Dharamtul S.O"
  },
  "786007": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Barbaruah S.O"
  },
  "522308": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Emani S.O"
  },
  "522307": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Kolakaluru S.O"
  },
  "787035": {
    "state": "ASSAM",
    "district": "DHEMAJI",
    "office": "Gerukamukh S.O"
  },
  "787053": {
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "office": "Ghilamara S.O"
  },
  "787034": {
    "state": "ASSAM",
    "district": "DHEMAJI",
    "office": "Gogamukh S.O"
  },
  "782137": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Kuworitul S.O"
  },
  "782138": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Missa S.O"
  },
  "785664": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Gaurisagar S.O"
  },
  "534331": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Kakaraparru S.O"
  },
  "534329": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Kanuru S.O"
  },
  "534301": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Nidadavole O.T. S.O"
  },
  "785696": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Geleky S.O"
  },
  "533437": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Peddapuram S.O"
  },
  "533449": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Chebrolu S.O"
  },
  "533444": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Kathipudi S.O"
  },
  "533450": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Pithapuram S.O"
  },
  "515731": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Garladinne S.O"
  },
  "515004": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Ramnagar S.O (Ananthapur)"
  },
  "515722": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Jayalakshmipuram S.O (Ananthapur)"
  },
  "515761": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Kalyandurg S.O"
  },
  "515765": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Kambadur S.O"
  },
  "535557": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Balijipeta S.O"
  },
  "828131": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Lodna SO Dhanbad"
  },
  "828304": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Malkera SO"
  },
  "535573": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Bobbili Bazar S.O"
  },
  "535578": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Donkinavalasa S.O"
  },
  "535102": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Garbham S.O"
  },
  "515721": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Kandukur S.O"
  },
  "515711": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Kuderu S.O (Ananthapur)"
  },
  "515766": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Kundurpi S.O"
  },
  "515425": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Narapla S.O"
  },
  "515787": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Nuthimadugu S.O"
  },
  "515414": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Putlur S.O"
  },
  "847401": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Andhra SO"
  },
  "847222": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Arerhat SO"
  },
  "847224": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Baboobarhi SO"
  },
  "847102": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Basaith Chandpura SO"
  },
  "847225": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Basopatti SO"
  },
  "847223": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Benipatti SO"
  },
  "847212": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Bhowara SO"
  },
  "843131": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Tariyani Chowk SO"
  },
  "517417": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Chembakur S.O"
  },
  "517426": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Dravidian University S.O"
  },
  "517350": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Kurabalakota S.O"
  },
  "518468": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Pendekallu S.O"
  },
  "518598": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Rangapuram S.O"
  },
  "518003": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "SAP Camp kNL S.O"
  },
  "518010": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Vorvakallu S.O"
  },
  "518002": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Kurnool Medical College S.O"
  },
  "788002": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Malugram S.O"
  },
  "788099": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Matinagar S.O"
  },
  "788015": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Meherpur S.O"
  },
  "788115": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Narsingpur S.O"
  },
  "788098": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Pailapool S.O"
  },
  "788116": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Palonghat S.O"
  },
  "788005": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "C R Avenue S.O"
  },
  "788013": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Sonabarighat S.O"
  },
  "788119": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Sonaimukh S.O"
  },
  "788026": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Srikona S.O"
  },
  "788003": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Tarapur S.O (Cachar"
  },
  "788030": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Udarbond S.O"
  },
  "788931": {
    "state": "ASSAM",
    "district": "DIMA HASAO",
    "office": "Umrangshu S.O"
  },
  "785663": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Disangmukh S.O"
  },
  "785666": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Kaloogaon S.O"
  },
  "515767": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Shettur S.O"
  },
  "515435": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Singanamala S.O"
  },
  "515411": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Tadpatri S.O"
  },
  "824112": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Barun SO AurangabadBH"
  },
  "824113": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Bhakharua SO"
  },
  "847402": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Ghoghardiha SO"
  },
  "847226": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Jaynagar SO"
  },
  "847403": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Jhanjharpur RS SO"
  },
  "847229": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Kaluahi SO"
  },
  "847228": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Khajauli SO"
  },
  "848102": {
    "state": "BIHAR",
    "district": "SAMASTIPUR",
    "office": "Nauraga SO"
  },
  "523186": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Uppugundur S.O"
  },
  "523260": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Valaparla S.O"
  },
  "531020": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Ntpc Simhadri S.O"
  },
  "825322": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Bagodar SO"
  },
  "533432": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Prathipadu S.O (East Godavari)"
  },
  "533434": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Vetlapalem S.O"
  },
  "533483": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Y .Ramavaram S.O"
  },
  "533429": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Yeleswaram S.O"
  },
  "824143": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Daudnagar SO"
  },
  "824202": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Deo SO"
  },
  "847404": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Jhanjharpur SO"
  },
  "788009": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Rongpur S.O"
  },
  "784145": {
    "state": "ASSAM",
    "district": "DARRANG",
    "office": "Sipajhar S.O"
  },
  "384230": {
    "state": "GUJARAT",
    "district": "PATAN",
    "office": "Kamboi SO"
  },
  "801108": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "MANER S.O"
  },
  "384550": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Pilvai SO"
  },
  "785701": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Hahchara S.O"
  },
  "785665": {
    "state": "ASSAM",
    "district": "SIVASAGAR",
    "office": "Joysagar S.O"
  },
  "784164": {
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "office": "Dikrong S.O"
  },
  "787054": {
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "office": "Islamgaon S.O"
  },
  "533339": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Devipatnam S.O"
  },
  "784525": {
    "state": "ASSAM",
    "district": "UDALGURI",
    "office": "Kalaigaon S.O"
  },
  "784529": {
    "state": "ASSAM",
    "district": "DARRANG",
    "office": "Chapaichowka S.O"
  },
  "784116": {
    "state": "ASSAM",
    "district": "DARRANG",
    "office": "Dalgaon S.O"
  },
  "784147": {
    "state": "ASSAM",
    "district": "DARRANG",
    "office": "Deomornoi S.O"
  },
  "784148": {
    "state": "ASSAM",
    "district": "DARRANG",
    "office": "Duni S.O (Darrang"
  },
  "784510": {
    "state": "ASSAM",
    "district": "UDALGURI",
    "office": "Harisinga S.O"
  },
  "784115": {
    "state": "ASSAM",
    "district": "DARRANG",
    "office": "Kharupetiaghat S.O"
  },
  "394540": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Olpad SO"
  },
  "395005": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Rander SO"
  },
  "825314": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Ghatotand SO"
  },
  "825408": {
    "state": "JHARKHAND",
    "district": "CHATRA",
    "office": "Itkhori SO"
  },
  "825403": {
    "state": "JHARKHAND",
    "district": "CHATRA",
    "office": "Jori SO"
  },
  "825315": {
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "office": "Konardam SO"
  },
  "825404": {
    "state": "JHARKHAND",
    "district": "CHATRA",
    "office": "Pratappur SO Chatra"
  },
  "524124": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Sriharikota Range S.O"
  },
  "828142": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Tundi SO"
  },
  "533448": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Uppada S.O"
  },
  "788007": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Vivekananda Road S.O"
  },
  "784527": {
    "state": "ASSAM",
    "district": "UDALGURI",
    "office": "Atterikhat S.O"
  },
  "784190": {
    "state": "ASSAM",
    "district": "UDALGURI",
    "office": "Bhakatpara S.O"
  },
  "784526": {
    "state": "ASSAM",
    "district": "UDALGURI",
    "office": "Dimakuchi S.O"
  },
  "518221": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Peapully S.O"
  },
  "855117": {
    "state": "BIHAR",
    "district": "KISHANGANJ",
    "office": "Taiyabpur SO"
  },
  "855116": {
    "state": "BIHAR",
    "district": "KISHANGANJ",
    "office": "Thakurganj SO"
  },
  "855115": {
    "state": "BIHAR",
    "district": "KISHANGANJ",
    "office": "Sontha SO"
  },
  "534198": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Ganapavaram S.O (West Godavari)"
  },
  "824114": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Deohara SO"
  },
  "824203": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Goh SO"
  },
  "824120": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Haspura SO"
  },
  "824122": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Jakhim SO"
  },
  "824121": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Jamhor SO"
  },
  "385310": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Dhanera SO"
  },
  "384445": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Kalyanpura SO"
  },
  "384140": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Kamli SO"
  },
  "385566": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Dhima SO"
  },
  "784524": {
    "state": "ASSAM",
    "district": "UDALGURI",
    "office": "Hatigarh S.O (Darrang"
  },
  "784522": {
    "state": "ASSAM",
    "district": "UDALGURI",
    "office": "Khoirabari S.O"
  },
  "788031": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Salganga S.O"
  },
  "788010": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Silchar REC S.O"
  },
  "784146": {
    "state": "ASSAM",
    "district": "DARRANG",
    "office": "Dhula S.O"
  },
  "534145": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Madhavaram S.O (West Godavari)"
  },
  "534341": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Tallapudi S.O"
  },
  "515005": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Gandhibazar S.O (Ananthapur)"
  },
  "176061": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Ghuggar SO"
  },
  "176082": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Alampur SO Kangra"
  },
  "176125": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Baijnath SO Kangra"
  },
  "176073": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Bairhgat SO"
  },
  "176067": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Rajpur SO"
  },
  "518442": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Pamulapadu S.O"
  },
  "781328": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Baghmarabazar S.O"
  },
  "781315": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Barpeta Road S.O"
  },
  "781309": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Bhella S.O"
  },
  "781352": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Bhowanipur S.O"
  },
  "515465": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Yellanur S.O"
  },
  "515822": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Amidyaya S.O"
  },
  "515402": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Gooty R.S. S.O"
  },
  "515401": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Gooty S.O"
  },
  "515863": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Gummaghatta S.O"
  },
  "515774": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Kallur R.S. S.O"
  },
  "825406": {
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "office": "Chouparan SO"
  },
  "825302": {
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "office": "College More SO"
  },
  "825313": {
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "office": "Daroo SO"
  },
  "825418": {
    "state": "JHARKHAND",
    "district": "KODERMA",
    "office": "Domchanch Bazar SO"
  },
  "825402": {
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "office": "Ichak SO"
  },
  "825109": {
    "state": "JHARKHAND",
    "district": "KODERMA",
    "office": "Jainagar SO Koderma"
  },
  "825409": {
    "state": "JHARKHAND",
    "district": "KODERMA",
    "office": "Jhumri Telaiya SO"
  },
  "825410": {
    "state": "JHARKHAND",
    "district": "KODERMA",
    "office": "Kodarma SO"
  },
  "825303": {
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "office": "Korrah SO"
  },
  "825318": {
    "state": "JHARKHAND",
    "district": "KODERMA",
    "office": "Markacho SO"
  },
  "825319": {
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "office": "Reformatory School SO"
  },
  "825132": {
    "state": "JHARKHAND",
    "district": "KODERMA",
    "office": "Satgawan SO"
  },
  "387305": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Alina SO"
  },
  "387510": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Alindra Matar SO"
  },
  "387635": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Chhipdi SO"
  },
  "387110": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Ghodasar SO Kheda"
  },
  "387120": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Kanij SO"
  },
  "387620": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Antisar Gate Kpdvj SO"
  },
  "387630": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Kathlal SO"
  },
  "387640": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Lasundra SO"
  },
  "176083": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Bhawarna SO"
  },
  "781128": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Palashbari S.O"
  },
  "781136": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Pachim Samaria S.O"
  },
  "781354": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Rangia S.O"
  },
  "781103": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Soalkuchi S.O"
  },
  "781382": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Soneswar S.O"
  },
  "781131": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Rani S.O (Kamrup)"
  },
  "176088": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Chadhiar SO"
  },
  "176092": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Daroh SO"
  },
  "176086": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Khera SO"
  },
  "176098": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Lahru SO"
  },
  "176096": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Lambagaon SO"
  },
  "821104": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Chenari SO"
  },
  "821305": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Dalmianagar SO"
  },
  "802226": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Dawath SO"
  },
  "802213": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Dinara SO Rohtas"
  },
  "802215": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Garh Nokha SO"
  },
  "824127": {
    "state": "BIHAR",
    "district": "ARWAL",
    "office": "Kaler SO"
  },
  "387610": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Attarsumba SO"
  },
  "824220": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Dobhi SO"
  },
  "824205": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Gurua SO"
  },
  "824206": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Imamganj SO"
  },
  "802214": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Gorari SO"
  },
  "821106": {
    "state": "BIHAR",
    "district": "KAIMUR (BHABUA)",
    "office": "Hatta SO Kaimur Bhabua"
  },
  "821107": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Kargahar SO"
  },
  "821112": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Kochas SO"
  },
  "821108": {
    "state": "BIHAR",
    "district": "KAIMUR (BHABUA)",
    "office": "Kudra SO"
  },
  "788104": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Jirighat S.O"
  },
  "814114": {
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "office": "Deosang BT SO"
  },
  "174305": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Mehre SO"
  },
  "174309": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Bahina SO"
  },
  "174304": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Bani SO HamirpurHP"
  },
  "177024": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Bhareri SO"
  },
  "176041": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Bhota SO"
  },
  "176040": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Bijhari SO"
  },
  "787060": {
    "state": "ASSAM",
    "district": "DHEMAJI",
    "office": "Jonai S.O"
  },
  "176039": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Chakmoh SO"
  },
  "784113": {
    "state": "ASSAM",
    "district": "UDALGURI",
    "office": "Kopati S.O"
  },
  "383275": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Laxmipura Sabarkantha SO"
  },
  "801102": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "BELHAURI S.O"
  },
  "176103": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Panchrukhi SO"
  },
  "176115": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Paprola SO"
  },
  "176081": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Taragarh Kangra SO"
  },
  "176076": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Bhawana SO"
  },
  "176071": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Bhullanaso SO"
  },
  "176077": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Bir SO Kangra"
  },
  "176128": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Chobin SO"
  },
  "176101": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Dheera SO"
  },
  "176095": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Jaisinghpur SO Kangra"
  },
  "176094": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Jalag SO"
  },
  "494337": {
    "state": "CHHATTISGARH",
    "district": "KANKER",
    "office": "Charama S.O"
  },
  "494771": {
    "state": "CHHATTISGARH",
    "district": "KANKER",
    "office": "Chotekapsi S.O"
  },
  "383316": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Limbhoi SO"
  },
  "383251": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Lusadia SO"
  },
  "383345": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Malpur SO"
  },
  "383350": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Meghraj SO"
  },
  "841422": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Sahajitpur SO"
  },
  "841221": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Sitalpur SO"
  },
  "841101": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Sonepur SO Saran"
  },
  "841222": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Sutihar SO"
  },
  "841401": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Amnour SO"
  },
  "841402": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Aphar SO"
  },
  "841460": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Bhatha Sonho SO"
  },
  "841410": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Dumarshan Bangra SO"
  },
  "494447": {
    "state": "CHHATTISGARH",
    "district": "BIJAPUR",
    "office": "Awapalli S.O"
  },
  "494450": {
    "state": "CHHATTISGARH",
    "district": "BIJAPUR",
    "office": "Bhairamgarh S.O"
  },
  "821109": {
    "state": "BIHAR",
    "district": "KAIMUR (BHABUA)",
    "office": "Mohania SO"
  },
  "821310": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Nasriganj SO"
  },
  "802218": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Natwar SO"
  },
  "821306": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Darihat SO"
  },
  "821105": {
    "state": "BIHAR",
    "district": "KAIMUR (BHABUA)",
    "office": "Durgawati SO"
  },
  "801304": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Karaipersurai SO"
  },
  "803302": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Mokamachauk SO"
  },
  "841443": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Gaura SO Saran"
  },
  "841411": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Ishuwapur SO"
  },
  "821308": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Indrapuri SO"
  },
  "821309": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Kachhwa SO Rohtas"
  },
  "841414": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Khaira SO Saran"
  },
  "811212": {
    "state": "BIHAR",
    "district": "MUNGER",
    "office": "Dharhara SO Munger"
  },
  "811213": {
    "state": "BIHAR",
    "district": "MUNGER",
    "office": "Haweli Kharagpur SO"
  },
  "811214": {
    "state": "BIHAR",
    "district": "MUNGER",
    "office": "Sadar Bazar Jamalpur SO"
  },
  "801302": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Hilsa SO"
  },
  "801303": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Islampur SO Nalanda"
  },
  "534340": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Vegeswarapuram S.O"
  },
  "534111": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Ananthapallli S.O"
  },
  "388365": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Sarsa SO"
  },
  "393020": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Sajod SO"
  },
  "392035": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Sarbhan SO"
  },
  "392030": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Shuklatirth SO"
  },
  "388245": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Sevalia  Rs SO"
  },
  "393120": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Umalla SO"
  },
  "392140": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Vagra SO"
  },
  "393135": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Valia SO"
  },
  "388220": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Umreth SO"
  },
  "392025": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Samni SO"
  },
  "392180": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Sarod SO"
  },
  "392040": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Tankari SO"
  },
  "392240": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Tankaria SO"
  },
  "388215": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Thamna SO Anand"
  },
  "388250": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Thasra SO"
  },
  "133302": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "Kalka S.O"
  },
  "362120": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Sarsai SO"
  },
  "362205": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "ShapurS SO"
  },
  "362255": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Sherbaug SO"
  },
  "362150": {
    "state": "GUJARAT",
    "district": "GIR SOMNATH",
    "office": "Talala SO"
  },
  "362275": {
    "state": "GUJARAT",
    "district": "GIR SOMNATH",
    "office": "Sutrapada SO"
  },
  "787031": {
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "office": "Khelmati S.O"
  },
  "784160": {
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "office": "Laluk S.O"
  },
  "787051": {
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "office": "Lilabari AF S.O"
  },
  "787058": {
    "state": "ASSAM",
    "district": "DHEMAJI",
    "office": "Machkhowa S.O"
  },
  "787032": {
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "office": "Moidumia S.O"
  },
  "523117": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "P.C.Palli S.O"
  },
  "523228": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "P.G.Palli S.O"
  },
  "854312": {
    "state": "BIHAR",
    "district": "ARARIA",
    "office": "Araria RS SO"
  },
  "393050": {
    "state": "GUJARAT",
    "district": "NARMADA",
    "office": "Sagbara SO"
  },
  "393025": {
    "state": "GUJARAT",
    "district": "NARMADA",
    "office": "Selamba SO"
  },
  "387320": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Dabhan SO"
  },
  "388713": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Kakanpur SO"
  },
  "389330": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Kalol SO Panch Mahals"
  },
  "176063": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Majherna SO"
  },
  "176093": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Malkher SO"
  },
  "176102": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Maranda SO"
  },
  "176084": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Noura SO"
  },
  "176087": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Pahra SO"
  },
  "176091": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Sanghole SO"
  },
  "176085": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Sullah SO"
  },
  "176107": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Thural SO"
  },
  "494553": {
    "state": "CHHATTISGARH",
    "district": "DANTEWADA",
    "office": "Bacheli S.O"
  },
  "494222": {
    "state": "CHHATTISGARH",
    "district": "BASTAR",
    "office": "Bakawand S.O"
  },
  "494223": {
    "state": "CHHATTISGARH",
    "district": "BASTAR",
    "office": "Bastar S.O"
  },
  "494224": {
    "state": "CHHATTISGARH",
    "district": "BASTAR",
    "office": "Bhanpuri S.O"
  },
  "811102": {
    "state": "BIHAR",
    "district": "SHEIKHPURA",
    "office": "Mehus SO"
  },
  "811103": {
    "state": "BIHAR",
    "district": "SHEIKHPURA",
    "office": "Nimi SO"
  },
  "811105": {
    "state": "BIHAR",
    "district": "SHEIKHPURA",
    "office": "Sheikhpura R S SO"
  },
  "802216": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Koath SO"
  },
  "802217": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Meari Bazar SO"
  },
  "814120": {
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "office": "Ghormara SO"
  },
  "814133": {
    "state": "JHARKHAND",
    "district": "GODDA",
    "office": "Godda SO"
  },
  "841415": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Khodaibagh SO"
  },
  "360540": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Kharedi SO"
  },
  "854116": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Mahadevpur SO Katihar"
  },
  "854108": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Korha SO"
  },
  "854113": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Manihari SO"
  },
  "854114": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Pothia SO"
  },
  "854117": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Rosna SO"
  },
  "855113": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Salmari SO"
  },
  "854115": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Semapur Factory SO"
  },
  "855114": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Sonaili SO"
  },
  "811107": {
    "state": "BIHAR",
    "district": "SHEIKHPURA",
    "office": "Sirari SO"
  },
  "804403": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Belaganj SO"
  },
  "804407": {
    "state": "BIHAR",
    "district": "JEHANABAD",
    "office": "Hulashganj SO"
  },
  "491995": {
    "state": "CHHATTISGARH",
    "district": "KABIRDHAM",
    "office": "Kawardha Collectorate"
  },
  "825407": {
    "state": "JHARKHAND",
    "district": "KODERMA",
    "office": "Domchanch SO"
  },
  "811309": {
    "state": "BIHAR",
    "district": "LAKHISARAI",
    "office": "Kajra SO"
  },
  "811310": {
    "state": "BIHAR",
    "district": "LAKHISARAI",
    "office": "Kiulrs SO"
  },
  "811311": {
    "state": "BIHAR",
    "district": "LAKHISARAI",
    "office": "Lakhisarai SO"
  },
  "811104": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Sarmera S.O"
  },
  "803301": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Hathidah SO"
  },
  "811106": {
    "state": "BIHAR",
    "district": "LAKHISARAI",
    "office": "Surajgaraha SO"
  },
  "803107": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Asthawan SO"
  },
  "815312": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Bengabad SO"
  },
  "825106": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Dumri SO"
  },
  "815302": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Giridih  Town SO"
  },
  "815318": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Jamua SO Giridh"
  },
  "795114": {
    "state": "MANIPUR",
    "district": "IMPHAL EAST",
    "office": "Pngaei Yangdong S.O"
  },
  "795005": {
    "state": "MANIPUR",
    "district": "IMPHAL EAST",
    "office": "Porompat S.O"
  },
  "795008": {
    "state": "MANIPUR",
    "district": "IMPHAL WEST",
    "office": "Singjamei S.O"
  },
  "795104": {
    "state": "MANIPUR",
    "district": "SENAPATI",
    "office": "Tadubi S.O"
  },
  "795125": {
    "state": "MANIPUR",
    "district": "TAMENGLONG",
    "office": "Tamei S.O"
  },
  "795141": {
    "state": "MANIPUR",
    "district": "TAMENGLONG",
    "office": "Tamenglong S.O"
  },
  "522611": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Kavuru S.O"
  },
  "522234": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Nadendla S.O"
  },
  "522615": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Nekarikallu S.O"
  },
  "522660": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Nuzendla S.O"
  },
  "522649": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Pedakancherla S.O"
  },
  "521139": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Penamaluru S.O"
  },
  "782410": {
    "state": "ASSAM",
    "district": "MARIGAON",
    "office": "Jagiroad S.O"
  },
  "123411": {
    "state": "HARYANA",
    "district": "REWARI",
    "office": "Dahina SO"
  },
  "123301": {
    "state": "HARYANA",
    "district": "REWARI",
    "office": "Guriani SO"
  },
  "123103": {
    "state": "HARYANA",
    "district": "REWARI",
    "office": "Khol SO"
  },
  "785632": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Purana Titabor S.O"
  },
  "123106": {
    "state": "HARYANA",
    "district": "REWARI",
    "office": "Dharuhera SO"
  },
  "177118": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Bahanwin SO"
  },
  "177119": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Bumbloo SO"
  },
  "177028": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Kakkar SO"
  },
  "177040": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Kangoo SO"
  },
  "177025": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Kanjian SO"
  },
  "177027": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Kot SO HamirpurHP"
  },
  "177041": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Dhaneta SO"
  },
  "123302": {
    "state": "HARYANA",
    "district": "REWARI",
    "office": "Kosli SO"
  },
  "123101": {
    "state": "HARYANA",
    "district": "REWARI",
    "office": "Khori SO"
  },
  "177026": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Galore SO"
  },
  "174405": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Hareta SO"
  },
  "176048": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Jahu SO"
  },
  "177020": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Kuthera SO"
  },
  "177029": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Lambloo SO"
  },
  "177033": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Nadaun SO"
  },
  "811112": {
    "state": "BIHAR",
    "district": "LAKHISARAI",
    "office": "Piri Bazar SO"
  },
  "803120": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Asta SO"
  },
  "522529": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Phirangipuram S.O"
  },
  "522603": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Ravipadu S.O (Guntur)"
  },
  "522617": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Rompicherla S.O (Guntur)"
  },
  "522549": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Satuluru S.O"
  },
  "522647": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "NSP Colony S.O"
  },
  "522411": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Bellamkonda S.O"
  },
  "522414": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Dachpalle S.O"
  },
  "795116": {
    "state": "MANIPUR",
    "district": "JIRIBAM",
    "office": "Jiribam Bazar S.O"
  },
  "795117": {
    "state": "MANIPUR",
    "district": "CHURACHANDPUR",
    "office": "Saikot S.O"
  },
  "795139": {
    "state": "MANIPUR",
    "district": "CHURACHANDPUR",
    "office": "Singhat S.O"
  },
  "795101": {
    "state": "MANIPUR",
    "district": "KAKCHING",
    "office": "Sugnu S.O"
  },
  "795135": {
    "state": "MANIPUR",
    "district": "KAKCHING",
    "office": "Pallel S.O"
  },
  "795006": {
    "state": "MANIPUR",
    "district": "CHURACHANDPUR",
    "office": "New Lamka S.O"
  },
  "795136": {
    "state": "MANIPUR",
    "district": "IMPHAL WEST",
    "office": "Sekmai S.O"
  },
  "795159": {
    "state": "MANIPUR",
    "district": "NONEY",
    "office": "None S.O"
  },
  "795118": {
    "state": "MANIPUR",
    "district": "KANGPOKPI",
    "office": "Saikul S.O"
  },
  "795106": {
    "state": "MANIPUR",
    "district": "SENAPATI",
    "office": "Senapati S.O"
  },
  "795112": {
    "state": "MANIPUR",
    "district": "KANGPOKPI",
    "office": "T Waichong S.O"
  },
  "491222": {
    "state": "CHHATTISGARH",
    "district": "BALOD",
    "office": "Sikosa SO"
  },
  "494331": {
    "state": "CHHATTISGARH",
    "district": "KONDAGAON",
    "office": "Keshkal S.O"
  },
  "823311": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Atri SO"
  },
  "174312": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Jaure Amb SO"
  },
  "824231": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Bodhgaya SO"
  },
  "823003": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Buniyad Ganj SO"
  },
  "804404": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Chakand SO"
  },
  "824237": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Cherki SO"
  },
  "823004": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Civil Aerodram SO"
  },
  "824232": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Fatehpur SO Gaya"
  },
  "823002": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Gaya RS SO"
  },
  "824118": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Guraru Mills SO"
  },
  "824233": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Khizersarai SO"
  },
  "795147": {
    "state": "MANIPUR",
    "district": "NONEY",
    "office": "Nungba S.O"
  },
  "795126": {
    "state": "MANIPUR",
    "district": "BISHNUPUR",
    "office": "Bishnupur S.O (Bishnupur)"
  },
  "841406": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Basantpur SO Siwan"
  },
  "841408": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Bhagwanpur Hat SO"
  },
  "383462": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Kodiawada SO"
  },
  "795105": {
    "state": "MANIPUR",
    "district": "SENAPATI",
    "office": "Maram S.O"
  },
  "795144": {
    "state": "MANIPUR",
    "district": "UKHRUL",
    "office": "Somdal S.O"
  },
  "522657": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Vellatur S.O"
  },
  "522437": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Brahmanapalle S.O"
  },
  "802134": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Raghunathpur SO Buxar"
  },
  "522661": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Muppalla(VKD) S.O"
  },
  "522626": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Murikipudi S.O"
  },
  "815314": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Kharagdiha SO"
  },
  "815313": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Ganwan SO"
  },
  "825167": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Isri Bazar SO"
  },
  "841203": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Chainpur SO Siwan"
  },
  "841234": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Darauli SO"
  },
  "841233": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Daronda SO"
  },
  "841235": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Done SO"
  },
  "389220": {
    "state": "GUJARAT",
    "district": "Mahisagar",
    "office": "Kothamba SO"
  },
  "392011": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Zadeshwar SO"
  },
  "828403": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Chandrapura SO"
  },
  "829111": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Gomia SO"
  },
  "829112": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "IEGomia SO"
  },
  "829132": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Bhandaridah SO"
  },
  "829107": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Bokaro Thermal SO"
  },
  "815311": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Beniadih SO"
  },
  "824234": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Magadh University SO"
  },
  "824235": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Mow SO"
  },
  "824209": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Paraiya SO"
  },
  "387520": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Limbasi SO"
  },
  "841210": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Gangpur Siswan SO"
  },
  "493661": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Abhanpur SO"
  },
  "802135": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Simari SO"
  },
  "493225": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Kharora SO"
  },
  "493526": {
    "state": "CHHATTISGARH",
    "district": "BALODA BAZAR",
    "office": "Lawan SO"
  },
  "493445": {
    "state": "CHHATTISGARH",
    "district": "MAHASAMUND",
    "office": "Mahasamund SO"
  },
  "493111": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Mandhar Cement Factory SO"
  },
  "492101": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Mandir Hasod SO"
  },
  "493114": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Neora SO Raipur"
  },
  "493228": {
    "state": "CHHATTISGARH",
    "district": "BALODA BAZAR",
    "office": "Pallari SO"
  },
  "493551": {
    "state": "CHHATTISGARH",
    "district": "MAHASAMUND",
    "office": "Pithora SO"
  },
  "535522": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Mrutyunjayarayanagaram S.O"
  },
  "532462": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Neelanagaram S.O"
  },
  "389390": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Jambughoda SO"
  },
  "389115": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Morva Hadaf SO"
  },
  "389360": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Pavagadh SO"
  },
  "389120": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Sant Road SO"
  },
  "389210": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Shehera SO"
  },
  "389370": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Shivrajpur SO"
  },
  "388710": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Timba Road SO"
  },
  "389340": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Vejalpur SO"
  },
  "688006": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Avalukkunnu SO"
  },
  "688505": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Champakulam SO"
  },
  "688501": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Kainakary SO"
  },
  "688522": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Kalavoor SO"
  },
  "688506": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Kavalam SO"
  },
  "688538": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Mannancherry SO"
  },
  "688503": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Moncombu Thekkekara SO"
  },
  "688504": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Pulincunnu SO"
  },
  "800008": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Marufganj SO"
  },
  "814113": {
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "office": "Deoghar College SO"
  },
  "814142": {
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "office": "Jasidih SO"
  },
  "814157": {
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "office": "Dehijore SO"
  },
  "815351": {
    "state": "JHARKHAND",
    "district": "JAMTARA",
    "office": "Jamtara SO"
  },
  "523111": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Pa Padu S.O"
  },
  "523108": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Pamur S.O"
  },
  "176097": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Marera SO"
  },
  "176089": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Molag SO"
  },
  "174505": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Dhaned SO"
  },
  "177401": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Didwin SO"
  },
  "177042": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Jalari SO"
  },
  "123412": {
    "state": "HARYANA",
    "district": "REWARI",
    "office": "Dharan SO"
  },
  "370490": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Dumara SO"
  },
  "370445": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Gadhasisa SO"
  },
  "396051": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Amba Talat SO"
  },
  "396045": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Atgam SO"
  },
  "396020": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Atul SO"
  },
  "492015": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Mana Camp SO"
  },
  "389230": {
    "state": "GUJARAT",
    "district": "Mahisagar",
    "office": "Lunawada SO"
  },
  "370627": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Gaduli SO"
  },
  "370450": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Godhra SO"
  },
  "370240": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Gopalpuri SO"
  },
  "370410": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Gundala SO"
  },
  "370455": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Gundiyali SO"
  },
  "370465": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Kachchh Mandvi SO"
  },
  "389235": {
    "state": "GUJARAT",
    "district": "Mahisagar",
    "office": "Malekpur SO"
  },
  "388270": {
    "state": "GUJARAT",
    "district": "Mahisagar",
    "office": "Vardhari SO"
  },
  "825401": {
    "state": "JHARKHAND",
    "district": "CHATRA",
    "office": "Chatra SO Chatra"
  },
  "825312": {
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "office": "Bishungarh SO Hazaribag"
  },
  "852214": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Jadia SO"
  },
  "852111": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Jia Ram Raghopur SO"
  },
  "815315": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Mirzaganj SO"
  },
  "533005": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "APSP Camp S.O (East Godavari)"
  },
  "533344": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "G.Mamidada S.O"
  },
  "533468": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Gollapalem S.O"
  },
  "533461": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Coringa S.O"
  },
  "370415": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Kapaya SO"
  },
  "370430": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Kera SO"
  },
  "370510": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Khavda SO"
  },
  "370130": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Khedoi SO"
  },
  "370485": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Dahisara SO Kachchh"
  },
  "370630": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Daypar SO"
  },
  "370641": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Jakhau SO"
  },
  "370605": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "KotdaN SO"
  },
  "370645": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Kothara SO"
  },
  "370105": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Kukma SO"
  },
  "123027": {
    "state": "HARYANA",
    "district": "MAHENDRAGARH",
    "office": "Kanina SO"
  },
  "177007": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Chabutra SO"
  },
  "176109": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Jangal Beri SO"
  },
  "394510": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Bhatha SO"
  },
  "394550": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Dumas SO"
  },
  "394517": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Mora SO Surat"
  },
  "395009": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Ramnagar SO Surat"
  },
  "495446": {
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "office": "Hardi Bazar SO"
  },
  "495450": {
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "office": "Vikas Bhawan SO"
  },
  "781305": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Chenga S.O"
  },
  "781327": {
    "state": "ASSAM",
    "district": "BAKSA",
    "office": "Jalahghat S.O"
  },
  "781319": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Kalgachia S.O"
  },
  "781330": {
    "state": "ASSAM",
    "district": "BAKSA",
    "office": "Simla S.O"
  },
  "781308": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Mandia S.O"
  },
  "682021": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Thrikkakara SO"
  },
  "683501": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Udyogamandal SO"
  },
  "682008": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kannamali SO"
  },
  "683511": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Alangad SO"
  },
  "683101": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Aluva Bazar SO"
  },
  "683572": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Angamally SO"
  },
  "683585": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Athani SO Ernakulam"
  },
  "683578": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Chengamanad SO"
  },
  "683561": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Edathala SO"
  },
  "683574": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kalady SO"
  },
  "683575": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kanjoor SO"
  },
  "683579": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kurumassery SO"
  },
  "683581": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Manjapra SO"
  },
  "683594": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Puthenvelikkara SO"
  },
  "370475": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Laija SO"
  },
  "370670": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Khombhadi SO"
  },
  "370145": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Lakadia SO"
  },
  "370020": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Madhapar SO"
  },
  "370610": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Manjal SO"
  },
  "370030": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Mankuwa SO"
  },
  "370650": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Mothara SO"
  },
  "370421": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Mundra SO"
  },
  "394235": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Lajpore SO"
  },
  "394530": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Mor SO"
  },
  "852215": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Karjain Bazar SO"
  },
  "852112": {
    "state": "BIHAR",
    "district": "MADHEPURA",
    "office": "Kumarkhand SO"
  },
  "852113": {
    "state": "BIHAR",
    "district": "MADHEPURA",
    "office": "Madhepura MDG"
  },
  "852216": {
    "state": "BIHAR",
    "district": "SAHARSA",
    "office": "Mahishi SO"
  },
  "852217": {
    "state": "BIHAR",
    "district": "SAHARSA",
    "office": "Mangwar SO"
  },
  "533201": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Gandhi Bazar S.O (East Godavari)"
  },
  "533239": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Pulletikurru S.O"
  },
  "533213": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Samanasa S.O"
  },
  "533577": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Vilasa S.O"
  },
  "533235": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Atreyapuram S.O"
  },
  "532428": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Mukhalingam S.O"
  },
  "532421": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Narasannapeta Market S.O"
  },
  "532190": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "P.S.Puram S.O"
  },
  "532213": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Pathapatnam S.O"
  },
  "387130": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Mahemdavad SO"
  },
  "387340": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Mahisa SO"
  },
  "387335": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Mahudha SO"
  },
  "387530": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Matar SO"
  },
  "387540": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Navagam SO"
  },
  "825311": {
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "office": "Barkagaon SO"
  },
  "784513": {
    "state": "ASSAM",
    "district": "UDALGURI",
    "office": "Sapangaon S.O"
  },
  "495454": {
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "office": "Kusmunda Colliery SO"
  },
  "825323": {
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "office": "Barkatha SO"
  },
  "825336": {
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "office": "Charhi SO"
  },
  "825317": {
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "office": "BSF Meru SO"
  },
  "493331": {
    "state": "CHHATTISGARH",
    "district": "BALODA BAZAR",
    "office": "Rawan SO"
  },
  "571101": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Bannur S.O"
  },
  "493663": {
    "state": "CHHATTISGARH",
    "district": "DHAMTARI",
    "office": "Kurud SO"
  },
  "493662": {
    "state": "CHHATTISGARH",
    "district": "DHAMTARI",
    "office": "Magarlod SO"
  },
  "493888": {
    "state": "CHHATTISGARH",
    "district": "GARIYABAND",
    "office": "Mainpur SO"
  },
  "493778": {
    "state": "CHHATTISGARH",
    "district": "DHAMTARI",
    "office": "Nagri SO"
  },
  "492109": {
    "state": "CHHATTISGARH",
    "district": "GARIYABAND",
    "office": "Panduka SO"
  },
  "493992": {
    "state": "CHHATTISGARH",
    "district": "GARIYABAND",
    "office": "Phingeshwar SO"
  },
  "493885": {
    "state": "CHHATTISGARH",
    "district": "GARIYABAND",
    "office": "Rajim SO"
  },
  "845449": {
    "state": "BIHAR",
    "district": "PASHCHIM CHAMPARAN",
    "office": "Chanpatia Bazar SO"
  },
  "845450": {
    "state": "BIHAR",
    "district": "PASHCHIM CHAMPARAN",
    "office": "Chuhari SO"
  },
  "845451": {
    "state": "BIHAR",
    "district": "PASHCHIM CHAMPARAN",
    "office": "DKShikarpur SO"
  },
  "845103": {
    "state": "BIHAR",
    "district": "PASHCHIM CHAMPARAN",
    "office": "Harinagar SO"
  },
  "845459": {
    "state": "BIHAR",
    "district": "PASHCHIM CHAMPARAN",
    "office": "Jagdishpur SO West Champaran"
  },
  "845452": {
    "state": "BIHAR",
    "district": "PASHCHIM CHAMPARAN",
    "office": "Jogapatti SO"
  },
  "845453": {
    "state": "BIHAR",
    "district": "PASHCHIM CHAMPARAN",
    "office": "Lauriya SO"
  },
  "845104": {
    "state": "BIHAR",
    "district": "PASHCHIM CHAMPARAN",
    "office": "Madhubani SO"
  },
  "845306": {
    "state": "BIHAR",
    "district": "PASHCHIM CHAMPARAN",
    "office": "Mainatand SO"
  },
  "845454": {
    "state": "BIHAR",
    "district": "PASHCHIM CHAMPARAN",
    "office": "Majhaulia Rs SO"
  },
  "845105": {
    "state": "BIHAR",
    "district": "PASHCHIM CHAMPARAN",
    "office": "Naraipur SO"
  },
  "845455": {
    "state": "BIHAR",
    "district": "PASHCHIM CHAMPARAN",
    "office": "Narkaiaganj SO"
  },
  "845106": {
    "state": "BIHAR",
    "district": "PASHCHIM CHAMPARAN",
    "office": "Ramnagar SO West Champaran"
  },
  "591115": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Kittur S.O"
  },
  "591153": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "M.K.Hubballi S.F. S.O"
  },
  "591119": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Murgod S.O"
  },
  "532429": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Polaki S.O"
  },
  "491444": {
    "state": "CHHATTISGARH",
    "district": "RAJNANDGAON",
    "office": "Ghumka SO"
  },
  "491881": {
    "state": "CHHATTISGARH",
    "district": "RAJNANDGAON",
    "office": "Khairagarh Raj SO"
  },
  "495692": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Chandrapur SO Janjgirchampa"
  },
  "495688": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Dabhra SO"
  },
  "829114": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Jaridih Bazar SO"
  },
  "829104": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Bermo SO"
  },
  "825102": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Dhori SO"
  },
  "841509": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Gabhirar SO"
  },
  "829113": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Jarangdih Colliery SO"
  },
  "495690": {
    "state": "CHHATTISGARH",
    "district": "JANJGIR-CHAMPA",
    "office": "Jaijaipur SO"
  },
  "571440": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Kollegal Southern Extension S.O"
  },
  "491229": {
    "state": "CHHATTISGARH",
    "district": "RAJNANDGAON",
    "office": "Manpur SO"
  },
  "491666": {
    "state": "CHHATTISGARH",
    "district": "RAJNANDGAON",
    "office": "Mohla SO"
  },
  "570008": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Mysuru South S.O"
  },
  "570019": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Udayagiri S.O (Mysuru)"
  },
  "571102": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Bettadapura S.O"
  },
  "491559": {
    "state": "CHHATTISGARH",
    "district": "KABIRDHAM",
    "office": "Pandaria SO"
  },
  "497001": {
    "state": "CHHATTISGARH",
    "district": "SURGUJA",
    "office": "Ambikapur Town SO"
  },
  "497335": {
    "state": "CHHATTISGARH",
    "district": "KOREA",
    "office": "Baikunthpur SO"
  },
  "497119": {
    "state": "CHHATTISGARH",
    "district": "BALRAMPUR",
    "office": "Balrampur SO"
  },
  "835204": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Bundu SO"
  },
  "571103": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Bilikere S.O"
  },
  "570026": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Bogadi S.O"
  },
  "571617": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Chunchunakatte S.O"
  },
  "688561": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Ambalapuzha SO"
  },
  "688502": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Moncombu SO"
  },
  "688562": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Thakazhy SO"
  },
  "688002": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Thiruvampady Junction SO"
  },
  "688524": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Cherthala Cutcherry SO"
  },
  "688530": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Arthingal SO"
  },
  "688539": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Mayithara Market SO"
  },
  "571610": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Gavadagere S.O"
  },
  "571125": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Hampapura (H D Kote) S.O"
  },
  "571601": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Hampapura (K R Nagar) S.O"
  },
  "570003": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Note Mudran Nagar S.O"
  },
  "570018": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Belavadi S.O"
  },
  "571104": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Bylakuppe S.O"
  },
  "571114": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Heggadedevana Kote S.O"
  },
  "685586": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Karimkunnam SO"
  },
  "685590": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Kudayathur SO"
  },
  "685620": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Maraiyur SO"
  },
  "685616": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Mattuppatti SO"
  },
  "685612": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Munnar SO"
  },
  "685605": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Muthalakodam SO"
  },
  "685571": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Parathode SO Idukki"
  },
  "685566": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Rajakad SO"
  },
  "685582": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Kodikulam SO"
  },
  "685589": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Moolamattom SO"
  },
  "685587": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Muttom EK SO"
  },
  "571105": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Hunsur S.O"
  },
  "571116": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Kabini Colony S.O"
  },
  "571311": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Kadakola S.O"
  },
  "571187": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Kanagal S.O"
  },
  "571134": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Kattemalalavadi S.O"
  },
  "852122": {
    "state": "BIHAR",
    "district": "MADHEPURA",
    "office": "Murliganj SO"
  },
  "852123": {
    "state": "BIHAR",
    "district": "SAHARSA",
    "office": "Nauhatta SO"
  },
  "852124": {
    "state": "BIHAR",
    "district": "SAHARSA",
    "office": "Panchgachiya SO"
  },
  "852202": {
    "state": "BIHAR",
    "district": "SAHARSA",
    "office": "Saharsa Collec SO"
  },
  "571602": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Krishna Raja Nagar S.O"
  },
  "803109": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Giriak SO"
  },
  "854311": {
    "state": "BIHAR",
    "district": "ARARIA",
    "office": "Araria SO"
  },
  "854202": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Banmankhi SO"
  },
  "854316": {
    "state": "BIHAR",
    "district": "ARARIA",
    "office": "Bathnaha SO"
  },
  "571108": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Ravandur S.O"
  },
  "571604": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Saligrama S.O (Mysuru)"
  },
  "571121": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Sargur S.O"
  },
  "854318": {
    "state": "BIHAR",
    "district": "ARARIA",
    "office": "SRForbesganj SO"
  },
  "854201": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Banaili SO"
  },
  "854315": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Baisi SO"
  },
  "854334": {
    "state": "BIHAR",
    "district": "ARARIA",
    "office": "Maryganj SO"
  },
  "854304": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Purnea Chowk SO"
  },
  "854303": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Purnea Polyticnic SO"
  },
  "562120": {
    "state": "KARNATAKA",
    "district": "RAMANAGARA",
    "office": "Magadi S.O"
  },
  "562159": {
    "state": "KARNATAKA",
    "district": "RAMANAGARA",
    "office": "Ijoor Ramangaram S.O"
  },
  "562126": {
    "state": "KARNATAKA",
    "district": "RAMANAGARA",
    "office": "Sathanur S.O"
  },
  "562127": {
    "state": "KARNATAKA",
    "district": "RAMANAGARA",
    "office": "Solur S.O"
  },
  "562128": {
    "state": "KARNATAKA",
    "district": "RAMANAGARA",
    "office": "Sugganahalli S.O"
  },
  "562131": {
    "state": "KARNATAKA",
    "district": "RAMANAGARA",
    "office": "Thippasandra S.O"
  },
  "562162": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Madanayakanahalli S.O"
  },
  "561205": {
    "state": "KARNATAKA",
    "district": "BENGALURU RURAL",
    "office": "Melekote S.O"
  },
  "562122": {
    "state": "KARNATAKA",
    "district": "BENGALURU RURAL",
    "office": "Nandagudi S.O"
  },
  "562123": {
    "state": "KARNATAKA",
    "district": "BENGALURU RURAL",
    "office": "Nelamangala S.O"
  },
  "562130": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Tavarekere S.O (Bengaluru)"
  },
  "124412": {
    "state": "HARYANA",
    "district": "ROHTAK",
    "office": "Kahnaur SO"
  },
  "562121": {
    "state": "KARNATAKA",
    "district": "RAMANAGARA",
    "office": "Maralavadi S.O"
  },
  "835101": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Chotamuri SO"
  },
  "835234": {
    "state": "JHARKHAND",
    "district": "KHUNTI",
    "office": "Govindpur SO Ranchi"
  },
  "835209": {
    "state": "JHARKHAND",
    "district": "KHUNTI",
    "office": "Karra SO"
  },
  "835210": {
    "state": "JHARKHAND",
    "district": "KHUNTI",
    "office": "Khunti SO"
  },
  "835216": {
    "state": "JHARKHAND",
    "district": "KHUNTI",
    "office": "Murhu SO"
  },
  "834004": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Jharkhand Vidhan Sabha SO"
  },
  "834003": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Railway Colony Hatia SO"
  },
  "811201": {
    "state": "BIHAR",
    "district": "MUNGER",
    "office": "Lal Darwaza SO Munger"
  },
  "571130": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Yelwal S.O"
  },
  "124113": {
    "state": "HARYANA",
    "district": "ROHTAK",
    "office": "Kalanaur SO Rohtak"
  },
  "124112": {
    "state": "HARYANA",
    "district": "ROHTAK",
    "office": "Mehem SO"
  },
  "124022": {
    "state": "HARYANA",
    "district": "ROHTAK",
    "office": "Mokhra SO"
  },
  "124010": {
    "state": "HARYANA",
    "district": "ROHTAK",
    "office": "Police Training Center Sunaria SO"
  },
  "124303": {
    "state": "HARYANA",
    "district": "ROHTAK",
    "office": "Sanghi SO"
  },
  "562125": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Sarjapura S.O"
  },
  "562129": {
    "state": "KARNATAKA",
    "district": "BENGALURU RURAL",
    "office": "Sulebele S.O"
  },
  "801306": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Telhara SO Nalanda"
  },
  "124514": {
    "state": "HARYANA",
    "district": "ROHTAK",
    "office": "Lakhan Majra SO"
  },
  "124111": {
    "state": "HARYANA",
    "district": "ROHTAK",
    "office": "Madina SO"
  },
  "364521": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Jira SO"
  },
  "365650": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Khambha SO"
  },
  "365450": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Kunkavav SO"
  },
  "365430": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Lathi SO Amreli"
  },
  "365535": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Liliya SO"
  },
  "365460": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Lunidhar SO"
  },
  "365635": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Motasamdhiyala SO"
  },
  "365730": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Timbi S.O"
  },
  "365560": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Rajula SO"
  },
  "364515": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Savar SO"
  },
  "494449": {
    "state": "CHHATTISGARH",
    "district": "DANTEWADA",
    "office": "Dantewada S.O"
  },
  "591118": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "M.K.Hubballi S.O"
  },
  "688526": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Poochackal SO"
  },
  "688523": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Sethulekshmipuram SO"
  },
  "688527": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Thanneermukkom SO"
  },
  "688532": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Thuravoor SO"
  },
  "785007": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Jorhat Engg College S.O"
  },
  "785006": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Jorhat Reserch Lab S.O"
  },
  "785107": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Kakajan S.O"
  },
  "785108": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Kakilamukh S.O"
  },
  "785633": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Khorikotia S.O"
  },
  "785700": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Lahdoigarh Chariali S.O"
  },
  "785634": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Mariani S.O"
  },
  "688009": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Pazhaveedu SO"
  },
  "362135": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Sasan Gir SO"
  },
  "182313": {
    "state": "JAMMU AND KASHMIR",
    "district": "REASI",
    "office": "Arnas SO"
  },
  "182143": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAMBAN",
    "office": "Batote SO"
  },
  "182222": {
    "state": "JAMMU AND KASHMIR",
    "district": "DODA",
    "office": "Bhaderwah SO"
  },
  "182202": {
    "state": "JAMMU AND KASHMIR",
    "district": "DODA",
    "office": "Doda SO Doda"
  },
  "182121": {
    "state": "JAMMU AND KASHMIR",
    "district": "UDHAMPUR",
    "office": "Garhi SO Udhampur"
  },
  "182312": {
    "state": "JAMMU AND KASHMIR",
    "district": "REASI",
    "office": "Jyotipuram SO"
  },
  "182301": {
    "state": "JAMMU AND KASHMIR",
    "district": "REASI",
    "office": "Katra SO Udhampur"
  },
  "182201": {
    "state": "JAMMU AND KASHMIR",
    "district": "DODA",
    "office": "Khellani SO"
  },
  "182204": {
    "state": "JAMMU AND KASHMIR",
    "district": "KISHTWAR",
    "office": "Kishtwar SO"
  },
  "182315": {
    "state": "JAMMU AND KASHMIR",
    "district": "REASI",
    "office": "Mahore SO Udhampur"
  },
  "688537": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Eramallur SO"
  },
  "688003": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Sanathanapuram SO"
  },
  "370001": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Bhuj Darbargadh Chowk SO"
  },
  "370155": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Adesar SO"
  },
  "370205": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Adipur SO"
  },
  "370110": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Anjar SO"
  },
  "370427": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Baladia SO"
  },
  "370140": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Bhachau SO"
  },
  "370460": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Koday SO"
  },
  "852121": {
    "state": "BIHAR",
    "district": "MADHEPURA",
    "office": "Mathahi SO"
  },
  "852218": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Pipra Bazar SO"
  },
  "852125": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Pratapganj SO Supaul"
  },
  "852116": {
    "state": "BIHAR",
    "district": "MADHEPURA",
    "office": "Puraini Bazar SO"
  },
  "182205": {
    "state": "JAMMU AND KASHMIR",
    "district": "KISHTWAR",
    "office": "Palmar SO"
  },
  "185203": {
    "state": "JAMMU AND KASHMIR",
    "district": "REASI",
    "office": "Poni SO"
  },
  "182141": {
    "state": "JAMMU AND KASHMIR",
    "district": "UDHAMPUR",
    "office": "Chenani SO"
  },
  "125047": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "Agroha SO"
  },
  "125007": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "Azad Nagar Hisar SO"
  },
  "125121": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "BARWALA MANDI SO"
  },
  "125042": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "Bass SO"
  },
  "362630": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Manavadar SO"
  },
  "362130": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Visavadar SO"
  },
  "182124": {
    "state": "JAMMU AND KASHMIR",
    "district": "UDHAMPUR",
    "office": "Jaganoo SO"
  },
  "182142": {
    "state": "JAMMU AND KASHMIR",
    "district": "UDHAMPUR",
    "office": "Kud SO"
  },
  "683580": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Sreemoolanagaram SO"
  },
  "686665": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Elanji SO"
  },
  "686668": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kalloorkkad SO"
  },
  "682311": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kolenchery SO"
  },
  "686662": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Koothattukulam SO"
  },
  "686673": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Muvattupuzha Market SO"
  },
  "682301": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Tripunithura Fort SO"
  },
  "682307": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Udayamperoor SO"
  },
  "683519": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kaitharam SO"
  },
  "683562": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kizhakkambalam SO"
  },
  "683518": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Koonammavu SO"
  },
  "532430": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Priyagraharam S.O"
  },
  "781012": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Pandu S.O"
  },
  "683520": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Mannam Paravur SO"
  },
  "683577": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Mookkannur SO"
  },
  "683516": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Moothakunnam SO"
  },
  "683110": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Muppathadam SO"
  },
  "683102": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Union Christian College SO"
  },
  "686672": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Arakuzha SO"
  },
  "682316": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kunnackal SO"
  },
  "686669": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Mudavoor SO"
  },
  "123102": {
    "state": "HARYANA",
    "district": "REWARI",
    "office": "Kund SO"
  },
  "123303": {
    "state": "HARYANA",
    "district": "REWARI",
    "office": "Nahar SO"
  },
  "123035": {
    "state": "HARYANA",
    "district": "REWARI",
    "office": "Palhawas SO"
  },
  "123401": {
    "state": "HARYANA",
    "district": "REWARI",
    "office": "Model Town  Rewari SO"
  },
  "682310": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Vadavucode SO"
  },
  "182127": {
    "state": "JAMMU AND KASHMIR",
    "district": "UDHAMPUR",
    "office": "Majalta SO"
  },
  "182128": {
    "state": "JAMMU AND KASHMIR",
    "district": "UDHAMPUR",
    "office": "Majouri SO"
  },
  "182125": {
    "state": "JAMMU AND KASHMIR",
    "district": "UDHAMPUR",
    "office": "Mir SO"
  },
  "131001": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Sonipat Kty SO"
  },
  "182146": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAMBAN",
    "office": "Banihal SO"
  },
  "182148": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAMBAN",
    "office": "Chanderkot SO"
  },
  "362230": {
    "state": "GUJARAT",
    "district": "PORBANDAR",
    "office": "Madhavpur SO"
  },
  "131021": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Bahalgarh SO"
  },
  "182147": {
    "state": "JAMMU AND KASHMIR",
    "district": "DODA",
    "office": "Kastigarh SO"
  },
  "852212": {
    "state": "BIHAR",
    "district": "SAHARSA",
    "office": "Bangaon SO Saharsa"
  },
  "813102": {
    "state": "BIHAR",
    "district": "BANKA",
    "office": "Banka HO"
  },
  "683576": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Karukutty SO"
  },
  "683565": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kumarapuram SO Ernakulam"
  },
  "683513": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Paravur Market SO"
  },
  "854337": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Ranipatra SO"
  },
  "854306": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Sarsi SO"
  },
  "854203": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Barhara Kothi SO"
  },
  "854204": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Bhawanipur Rajdham SO"
  },
  "805132": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Dumrawan SO"
  },
  "805102": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Govindpur SO Nawada"
  },
  "805101": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Dhamul SO"
  },
  "854339": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Balua Bazar SO"
  },
  "852101": {
    "state": "BIHAR",
    "district": "MADHEPURA",
    "office": "Behariganj SO"
  },
  "803303": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Mokamaghat SO"
  },
  "781316": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Howly S.O"
  },
  "781321": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Mayanbari S.O"
  },
  "781311": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Nagaon Bazar S.O"
  },
  "383205": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Prantij SO"
  },
  "383270": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Radhiwad SO"
  },
  "383276": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Raigadh SO"
  },
  "383120": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Salal SO"
  },
  "383210": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Sonasan SO"
  },
  "383246": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Takatuka SO"
  },
  "383215": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Talod M Y SO"
  },
  "803221": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Pandarak SO"
  },
  "803306": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Samyagarh SO"
  },
  "801305": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Nagarnausa SO"
  },
  "803111": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Nalanda SO"
  },
  "533252": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Antarvedipalem S.O"
  },
  "781365": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Rangia R.S. S.O"
  },
  "533240": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "D.Gannavaram S.O"
  },
  "175132": {
    "state": "HIMACHAL PRADESH",
    "district": "LAHUL AND SPITI",
    "office": "Keylong HO"
  },
  "829121": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Peterbar SO"
  },
  "835214": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Mandar SO Ranchi"
  },
  "834012": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Buti Chowk S.O"
  },
  "835219": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Ormanjhi SO"
  },
  "835303": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Piskanagri SO"
  },
  "834009": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Ranchi Medical College SO"
  },
  "835222": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Ratu SO"
  },
  "175140": {
    "state": "HIMACHAL PRADESH",
    "district": "LAHUL AND SPITI",
    "office": "Gondhla SO"
  },
  "175139": {
    "state": "HIMACHAL PRADESH",
    "district": "LAHUL AND SPITI",
    "office": "Jahalman SO"
  },
  "175142": {
    "state": "HIMACHAL PRADESH",
    "district": "LAHUL AND SPITI",
    "office": "Udaipur SO HP Circle"
  },
  "175106": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Balichowki SO"
  },
  "175123": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Banjar SO"
  },
  "781132": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Rampur S.O (Kamrup)"
  },
  "781135": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Singra S.O"
  },
  "532426": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Saravakota S.O"
  },
  "532425": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Urlam S.O"
  },
  "532186": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Vengala Rao Colony S.O"
  },
  "532408": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Bontalakoduru S.O"
  },
  "532005": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Gujarathipeta S.O"
  },
  "532407": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "J.R.Puram S.O"
  },
  "532403": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Murapaka S.O"
  },
  "532168": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Ponduru S.O"
  },
  "494122": {
    "state": "CHHATTISGARH",
    "district": "SUKMA",
    "office": "Dornapal S.O"
  },
  "494441": {
    "state": "CHHATTISGARH",
    "district": "DANTEWADA",
    "office": "Geedam S.O"
  },
  "494556": {
    "state": "CHHATTISGARH",
    "district": "DANTEWADA",
    "office": "Kirandul S.O"
  },
  "494114": {
    "state": "CHHATTISGARH",
    "district": "SUKMA",
    "office": "Konta S.O"
  },
  "571603": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Mirle S.O"
  },
  "571107": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Periyapatna S.O"
  },
  "571189": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Rathnapuri Colony S.O"
  },
  "571106": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Hanagodu S.O"
  },
  "532409": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Pydibheemavaram S.O"
  },
  "532127": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Rajam S.O"
  },
  "532402": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "S.M.Puram S.O"
  },
  "532474": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Tilaru RS S.O"
  },
  "815317": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Tisri SO"
  },
  "815316": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Pachamba SO"
  },
  "825324": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Palounjia SO"
  },
  "182144": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAMBAN",
    "office": "Ramban SO"
  },
  "532401": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Arasavilli S.O"
  },
  "532406": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Calingapatnam S.O"
  },
  "532410": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Etcherla S.O"
  },
  "532405": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Gara S.O"
  },
  "825108": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Pirtand SO"
  },
  "365480": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Vadia SO"
  },
  "365456": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Vaghaniya SO"
  },
  "364525": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Vanda SO"
  },
  "124406": {
    "state": "HARYANA",
    "district": "ROHTAK",
    "office": "Kansala SO"
  },
  "124102": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Dujana SO"
  },
  "124103": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Jhajjar SO"
  },
  "124106": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Matanhail SO"
  },
  "175101": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Sultanpur SO Kullu"
  },
  "175103": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Bahang SO"
  },
  "124104": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Nehru College Jhajjar SO"
  },
  "124146": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Sahlawas SO"
  },
  "124108": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Machrauli SO"
  },
  "383230": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Umedgadh SO"
  },
  "683105": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Thottumughom SO"
  },
  "683522": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Vadakkekara SO"
  },
  "123021": {
    "state": "HARYANA",
    "district": "MAHENDRAGARH",
    "office": "Mandi Ateli SO"
  },
  "123029": {
    "state": "HARYANA",
    "district": "MAHENDRAGARH",
    "office": "Mohindergarh SO"
  },
  "688529": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Kadakkarapally SO"
  },
  "688531": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Pattanacaud SO"
  },
  "688540": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Thirumalabhagom SO"
  },
  "785110": {
    "state": "ASSAM",
    "district": "MAJULI",
    "office": "Majulibongaon S.O"
  },
  "123023": {
    "state": "HARYANA",
    "district": "MAHENDRAGARH",
    "office": "Nangal Chaudhry SO"
  },
  "123024": {
    "state": "HARYANA",
    "district": "MAHENDRAGARH",
    "office": "Satnali SO"
  },
  "811304": {
    "state": "BIHAR",
    "district": "SHEIKHPURA",
    "office": "Chewara SO"
  },
  "854325": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Garhbanaili SO"
  },
  "854328": {
    "state": "BIHAR",
    "district": "ARARIA",
    "office": "Jogbani SO"
  },
  "854329": {
    "state": "BIHAR",
    "district": "ARARIA",
    "office": "Jokihat SO"
  },
  "854335": {
    "state": "BIHAR",
    "district": "ARARIA",
    "office": "Narpatganj SO"
  },
  "854336": {
    "state": "BIHAR",
    "district": "ARARIA",
    "office": "Nawabganj SO Araria"
  },
  "781329": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Nityananda S.O"
  },
  "781325": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Bajali College S.O"
  },
  "781314": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Santinagar S.O (Barpeta)"
  },
  "781307": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Sarthebari S.O"
  },
  "781302": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Baharihat S.O"
  },
  "177501": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Parol SO"
  },
  "176111": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Patlander SO"
  },
  "177048": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Rangas SO"
  },
  "177038": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Sera SO"
  },
  "176110": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Sujanpur Tira SO"
  },
  "177023": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Tauni Devi SO"
  },
  "814155": {
    "state": "JHARKHAND",
    "district": "GODDA",
    "office": "Basantrai SO"
  },
  "781326": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Patacharkuchi S.O"
  },
  "847422": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Manigachi SO"
  },
  "383315": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Modasa SO"
  },
  "383340": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Sathamba SO"
  },
  "383355": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Shamlaji SO"
  },
  "383250": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Tintoi SO"
  },
  "383307": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Vadagam SO"
  },
  "854102": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Chopra Ram Nagar SO"
  },
  "854205": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Dhamdaha SO"
  },
  "683108": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Thottakkattukara SO"
  },
  "683517": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Varapuzha SO"
  },
  "174001": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Raura Sector Bilaspur SO"
  },
  "174024": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Auhar SO"
  },
  "174029": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Berthin SO"
  },
  "847405": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Kurso Nadiami SO"
  },
  "847407": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Lohna Road SO"
  },
  "847233": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Nehra SO"
  },
  "847423": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Putai SO"
  },
  "846002": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "SHMC SO"
  },
  "845413": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Bakarpur Jagat SO"
  },
  "845412": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Bara Chakia SO"
  },
  "845414": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Chaita SO"
  },
  "845302": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Chauradano SO"
  },
  "845415": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Chiraiya SO"
  },
  "845416": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Damodarpur SO"
  },
  "365455": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Motaankadiya SO"
  },
  "845417": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Dariapur SO East Champaran"
  },
  "845418": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Dhaka SO"
  },
  "845303": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Ghora Sahan SO"
  },
  "845419": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Gobindganj SO"
  },
  "845420": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Gulwara Madhuban SO"
  },
  "845422": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Harsiddhi SO"
  },
  "845423": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Hussaini SO"
  },
  "845440": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Jaitapur Laukaria SO"
  },
  "845424": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Kesharia SO"
  },
  "845304": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Kundwa Chainpur SO"
  },
  "845425": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Malahi SO"
  },
  "845458": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Manguraha SO"
  },
  "845426": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Mehsi SO"
  },
  "182161": {
    "state": "JAMMU AND KASHMIR",
    "district": "UDHAMPUR",
    "office": "Mantalai SO"
  },
  "385515": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Gadh SO"
  },
  "847230": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Khirhar SO"
  },
  "844112": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Baghi SO Muzaffarpur"
  },
  "843101": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Bakhra SO"
  },
  "843102": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Bariarpur SO Muzaffarpur"
  },
  "843127": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Birihma Bazar SO"
  },
  "843103": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Bochaha SO"
  },
  "843104": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Chandanpatti SO"
  },
  "131304": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Baroda SO"
  },
  "182320": {
    "state": "JAMMU AND KASHMIR",
    "district": "REASI",
    "office": "SMVDU SO"
  },
  "803113": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Nursarai SO"
  },
  "803114": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Parwalpur SO"
  },
  "803119": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Rahui SO"
  },
  "803116": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Rajgir SO"
  },
  "803216": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Ramchandrapur SO"
  },
  "803117": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Silao SO"
  },
  "843120": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Deoria SO Muzaffarpur"
  },
  "688541": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Pallippuram SO"
  },
  "364210": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Amargadh SO"
  },
  "364295": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Bhadrod SO"
  },
  "364050": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Bhandariya SO"
  },
  "364002": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Bhavnagar Takhteshwar SO"
  },
  "364710": {
    "state": "GUJARAT",
    "district": "BOTAD",
    "office": "Botad SO"
  },
  "362640": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Sardargadh SO"
  },
  "362240": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Shil SO"
  },
  "364530": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "Vijpadi SO"
  },
  "845301": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Adapur SO"
  },
  "825412": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Rajdhanwarf SO"
  },
  "825320": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Suriya SO"
  },
  "388255": {
    "state": "GUJARAT",
    "district": "Mahisagar",
    "office": "Vadasinor Town Vadasinor SO"
  },
  "845411": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Areraj SO"
  },
  "845315": {
    "state": "BIHAR",
    "district": "PURBI CHAMPARAN",
    "office": "Bhelwa Circle SO"
  },
  "394651": {
    "state": "GUJARAT",
    "district": "TAPI",
    "office": "Anumala SO"
  },
  "394317": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Baleshwar SO"
  },
  "394630": {
    "state": "GUJARAT",
    "district": "TAPI",
    "office": "Buhari SO"
  },
  "394635": {
    "state": "GUJARAT",
    "district": "TAPI",
    "office": "Dolvan SO"
  },
  "394670": {
    "state": "GUJARAT",
    "district": "TAPI",
    "office": "Fort Songadh SO"
  },
  "394633": {
    "state": "GUJARAT",
    "district": "TAPI",
    "office": "Gadat SO Tapi"
  },
  "394710": {
    "state": "GUJARAT",
    "district": "DANG",
    "office": "Ahwadangs SO"
  },
  "829144": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Phusro Bazar SO"
  },
  "835325": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Nagjua SO"
  },
  "835217": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Neori Vikas Vidyalaya SO"
  },
  "177006": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Kashmir SO"
  },
  "176049": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Maharal SO"
  },
  "365541": {
    "state": "GUJARAT",
    "district": "AMRELI",
    "office": "UTCL Kovaya SO"
  },
  "176042": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Mair SO"
  },
  "177001": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Gandhi Chowk Hamirpur SO"
  },
  "177601": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Awah Devi SO"
  },
  "177044": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Bara SO HamirpurHP"
  },
  "176045": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Bhoranj SO"
  },
  "177022": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Uhal SO"
  },
  "396521": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Chikhli SO Navsari"
  },
  "396540": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Fadvel SO"
  },
  "396040": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Khergam SO"
  },
  "396560": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Rankuva SO"
  },
  "396060": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Rumla SO"
  },
  "396590": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Unai SO"
  },
  "396580": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Vansda SO"
  },
  "396406": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Abrama SO"
  },
  "396310": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Amalsad SO"
  },
  "854326": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Gulabbagh SO"
  },
  "394310": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Gangadhara RS SO"
  },
  "396510": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Anaval SO"
  },
  "394690": {
    "state": "GUJARAT",
    "district": "TAPI",
    "office": "Bajipura SO"
  },
  "394140": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Bodhan SO Surat"
  },
  "370015": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Kachchh University DSO"
  },
  "370405": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Bhujpur SO"
  },
  "370435": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Bidada SO"
  },
  "370135": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Adhoi SO"
  },
  "370160": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Bhimasar SO"
  },
  "362570": {
    "state": "THE DADRA AND NAGAR HAVELI AND DAMAN AND DIU",
    "district": "DIU",
    "office": "Wanakbara SO"
  },
  "125011": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "BSF Hisar SO"
  },
  "360570": {
    "state": "GUJARAT",
    "district": "PORBANDAR",
    "office": "Ranakandorana SO"
  },
  "843322": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Majhaulia Estate SO"
  },
  "843332": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Majorganj SO"
  },
  "843323": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Manikchowk SO"
  },
  "394305": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Chalthan SO"
  },
  "496223": {
    "state": "CHHATTISGARH",
    "district": "JASHPUR",
    "office": "Kansabel SO"
  },
  "497449": {
    "state": "CHHATTISGARH",
    "district": "KOREA",
    "office": "Chirimiri Colly SO"
  },
  "497339": {
    "state": "CHHATTISGARH",
    "district": "KOREA",
    "office": "Churcha Colly SO"
  },
  "497778": {
    "state": "CHHATTISGARH",
    "district": "KOREA",
    "office": "Janakpur SO"
  },
  "497559": {
    "state": "CHHATTISGARH",
    "district": "KOREA",
    "office": "Korea Colly SO"
  },
  "497224": {
    "state": "CHHATTISGARH",
    "district": "BALRAMPUR",
    "office": "Kusmi SO"
  },
  "497442": {
    "state": "CHHATTISGARH",
    "district": "KOREA",
    "office": "Manendragarh SO"
  },
  "497223": {
    "state": "CHHATTISGARH",
    "district": "SURAJPUR",
    "office": "Pratappur SO Surguja"
  },
  "497118": {
    "state": "CHHATTISGARH",
    "district": "BALRAMPUR",
    "office": "Rajpur SIJ SO"
  },
  "497220": {
    "state": "CHHATTISGARH",
    "district": "BALRAMPUR",
    "office": "Ramanujganj SO"
  },
  "497333": {
    "state": "CHHATTISGARH",
    "district": "SURAJPUR",
    "office": "Ramanujnagar SO"
  },
  "497225": {
    "state": "CHHATTISGARH",
    "district": "BALRAMPUR",
    "office": "Wadrafnagar SO"
  },
  "497447": {
    "state": "CHHATTISGARH",
    "district": "KOREA",
    "office": "West Jhagrakhand Colly SO"
  },
  "497117": {
    "state": "CHHATTISGARH",
    "district": "SURGUJA",
    "office": "Udaipur SO"
  },
  "497226": {
    "state": "CHHATTISGARH",
    "district": "SURAJPUR",
    "office": "Bishrampur SO Surguja"
  },
  "497331": {
    "state": "CHHATTISGARH",
    "district": "KOREA",
    "office": "Patna SO"
  },
  "388370": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Vadod SO"
  },
  "123028": {
    "state": "HARYANA",
    "district": "MAHENDRAGARH",
    "office": "Nangal Sirohi SO"
  },
  "396412": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Bori Falia SO"
  },
  "396360": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Gandevi SO"
  },
  "396418": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Gurukulsupa SO"
  },
  "174311": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Salauni SO"
  },
  "174201": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Bhakra Dam SO"
  },
  "174034": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Geharwin SO"
  },
  "174021": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Ghumarwin SO"
  },
  "174003": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Harlog SO"
  },
  "174028": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Hatwar SO"
  },
  "174033": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Jukhala SO"
  },
  "174035": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Kalol SO Bilaspur HP"
  },
  "174026": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Kuthera BLP SO"
  },
  "174027": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Lehri Sarail SO"
  },
  "174030": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Tallai SO"
  },
  "174036": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "NTPC Jamthal SO"
  },
  "174013": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Barmana SO"
  },
  "174002": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Bassi Kehloor SO"
  },
  "174015": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Behal SO"
  },
  "177301": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Basaral SO"
  },
  "785015": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Korokatoly S.O"
  },
  "785635": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Nakachari S.O"
  },
  "396325": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Antalia SO"
  },
  "396110": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Bigri SO"
  },
  "396570": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Digendranagar SO"
  },
  "177045": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Rail SO"
  },
  "847429": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Kusothar SO"
  },
  "688535": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Arookutty SO"
  },
  "688582": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Sreenarayanapuram SO"
  },
  "785106": {
    "state": "ASSAM",
    "district": "MAJULI",
    "office": "Kamalabari S.O"
  },
  "804454": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "NADAUL S.O"
  },
  "804452": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "MASAURHI S.O"
  },
  "841407": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Bishunpura SO"
  },
  "841427": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Garhmanjha SO"
  },
  "841428": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Gopalganj College SO"
  },
  "841436": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Hathwa SO"
  },
  "843121": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "DACollege SO"
  },
  "843105": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Dholi SO"
  },
  "843107": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Geyaspur SO"
  },
  "843123": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Jaintpur Estate SO"
  },
  "843360": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Jajuar SO"
  },
  "843109": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Kanti SO"
  },
  "843124": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Kathaiya SO"
  },
  "843321": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Katra SO Muzaffarpur"
  },
  "844120": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Kurhani SO"
  },
  "843125": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Kurnowl SO"
  },
  "842003": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "MIT SO"
  },
  "843128": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Minapur SO"
  },
  "383320": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Sardoi SO"
  },
  "383421": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Chitroda SO"
  },
  "383225": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Davad SO"
  },
  "383305": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Harsol SO"
  },
  "383430": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Idar Town SO"
  },
  "383110": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Jadar SO"
  },
  "383440": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Kadiadra SO"
  },
  "841413": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Jamobazar SO"
  },
  "841437": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Kateya SO"
  },
  "841501": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Kuchaikote SO"
  },
  "841438": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Mirganj SO"
  },
  "843333": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Nanpur SO"
  },
  "843324": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Parihar SO"
  },
  "843325": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Parsauni SO"
  },
  "492112": {
    "state": "CHHATTISGARH",
    "district": "MAHASAMUND",
    "office": "Sankra SO Mahasamund"
  },
  "383255": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Khedbrahma SO"
  },
  "841412": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Jalalpur Bazar SO"
  },
  "841212": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Jogia SO"
  },
  "841213": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Kopa Samhota SO"
  },
  "841215": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Maker SO"
  },
  "841313": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Manjhi SO"
  },
  "841316": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Naini SO Saran"
  },
  "841216": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Naraon SO"
  },
  "841224": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Panditpur SO"
  },
  "841219": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Parsa SO"
  },
  "363660": {
    "state": "GUJARAT",
    "district": "MORBI",
    "office": "Dahisara SO Rajkot"
  },
  "363630": {
    "state": "GUJARAT",
    "district": "MORBI",
    "office": "Jetpar M SO"
  },
  "360022": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "KOTHARIA SO Rajkot"
  },
  "785704": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Ongc Jorhat S.O"
  },
  "363670": {
    "state": "GUJARAT",
    "district": "MORBI",
    "office": "Maliya Miyana SO"
  },
  "363641": {
    "state": "GUJARAT",
    "district": "MORBI",
    "office": "Morbi MDG SO"
  },
  "363642": {
    "state": "GUJARAT",
    "district": "MORBI",
    "office": "Morbi Lal Baug SO"
  },
  "360110": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Paddhari SO"
  },
  "821301": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Akorhi Bazar SO"
  },
  "802211": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Babhnaul SO"
  },
  "821304": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Baulia SO"
  },
  "496225": {
    "state": "CHHATTISGARH",
    "district": "JASHPUR",
    "office": "Kunkuri SO"
  },
  "496113": {
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "office": "Lailunga SO"
  },
  "496220": {
    "state": "CHHATTISGARH",
    "district": "JASHPUR",
    "office": "Ludeg SO"
  },
  "497229": {
    "state": "CHHATTISGARH",
    "district": "SURAJPUR",
    "office": "Surajpur SO"
  },
  "496661": {
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "office": "Kharsia SO"
  },
  "496100": {
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "office": "Kondatarai SO"
  },
  "497116": {
    "state": "CHHATTISGARH",
    "district": "SURGUJA",
    "office": "Lakhanpur SO Surguja"
  },
  "360550": {
    "state": "GUJARAT",
    "district": "PORBANDAR",
    "office": "Ranavav SO"
  },
  "389180": {
    "state": "GUJARAT",
    "district": "DOHAD",
    "office": "Limdi SO"
  },
  "389140": {
    "state": "GUJARAT",
    "district": "DOHAD",
    "office": "Limkheda SO"
  },
  "496118": {
    "state": "CHHATTISGARH",
    "district": "JASHPUR",
    "office": "Pathalgaon SO"
  },
  "496440": {
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "office": "Pussore SO"
  },
  "496115": {
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "office": "Rajpur RIH SO"
  },
  "496445": {
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "office": "Sarangarh SO"
  },
  "496554": {
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "office": "Saria SO"
  },
  "496107": {
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "office": "Tamnar SO"
  },
  "497114": {
    "state": "CHHATTISGARH",
    "district": "SURGUJA",
    "office": "Pratapgarh SO"
  },
  "497111": {
    "state": "CHHATTISGARH",
    "district": "SURGUJA",
    "office": "Sitapur SO"
  },
  "175133": {
    "state": "HIMACHAL PRADESH",
    "district": "LAHUL AND SPITI",
    "office": "Lote SO Lahul  Spiti"
  },
  "136034": {
    "state": "HARYANA",
    "district": "KAITHAL",
    "office": "Chika S.O"
  },
  "360003": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Rajkot Marketing Yard SO"
  },
  "360002": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Rajkot Vivekanandnagar SO"
  },
  "360021": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Rajkot Metoda Gidc SO"
  },
  "360025": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Sardhar SO"
  },
  "360450": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Bhayavadar SO"
  },
  "360452": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Chitravad SO"
  },
  "364005": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Bhavnagar Anandnagar SO"
  },
  "364004": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Bhavnagar Chitra SO"
  },
  "383245": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Bhiloda SO"
  },
  "383317": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Dadhalia SO"
  },
  "383330": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Demai SO"
  },
  "383310": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Dhansura SO"
  },
  "383335": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Gabat SO"
  },
  "844122": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Mahuwa SO"
  },
  "388306": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Vasad SO"
  },
  "394125": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Hathuran SO"
  },
  "394112": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "GIPCL SO"
  },
  "394110": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Kim SO"
  },
  "394120": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Kosamba RS SO"
  },
  "394410": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Mota Miya Mangrol SO"
  },
  "394130": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Sayan SO"
  },
  "396409": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Alipore SO"
  },
  "136042": {
    "state": "HARYANA",
    "district": "KAITHAL",
    "office": "Fatehpur S.O (Kaithal)"
  },
  "136027": {
    "state": "HARYANA",
    "district": "KAITHAL",
    "office": "Siwan Gate Kaithal S.O"
  },
  "126113": {
    "state": "HARYANA",
    "district": "JIND",
    "office": "Pillukhera S.O"
  },
  "126112": {
    "state": "HARYANA",
    "district": "JIND",
    "office": "Safidon City S.O"
  },
  "136156": {
    "state": "HARYANA",
    "district": "KURUKSHETRA",
    "office": "Babain S.O"
  },
  "136030": {
    "state": "HARYANA",
    "district": "KURUKSHETRA",
    "office": "Gumthala Garhu S.O"
  },
  "136129": {
    "state": "HARYANA",
    "district": "KURUKSHETRA",
    "office": "Ismailabad S.O"
  },
  "136130": {
    "state": "HARYANA",
    "district": "KURUKSHETRA",
    "office": "Jhansa S.O"
  },
  "493776": {
    "state": "CHHATTISGARH",
    "district": "DHAMTARI",
    "office": "Rudri SO"
  },
  "591110": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Hirekumbi S.O"
  },
  "591173": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Yallammahill S.O"
  },
  "591114": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Katkol S.O"
  },
  "591117": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Manoli S.O"
  },
  "591130": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Salahalli S.O"
  },
  "591126": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Saundatti S.O"
  },
  "591127": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Sureban S.O"
  },
  "841503": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Nechwajalapur SO"
  },
  "829123": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Right Bank Tenughat SO"
  },
  "829127": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Sunday Bazar SO"
  },
  "829209": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Ray SO"
  },
  "396415": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Dabhel SO"
  },
  "396530": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Degam SO"
  },
  "396450": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Eru Ac SO"
  },
  "396350": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Gadat SO Navsari"
  },
  "174017": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Jejwin SO"
  },
  "174031": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Jhandutta SO"
  },
  "174004": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Kandraur SO"
  },
  "174310": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Naina Devi SO"
  },
  "174012": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Panjgain SO"
  },
  "174011": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Swarghat SO"
  },
  "391125": {
    "state": "GUJARAT",
    "district": "CHHOTAUDEPUR",
    "office": "Bahadarpur SO Vadodara"
  },
  "800012": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "DIGHA S.O"
  },
  "803202": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "KHUSRUPUR SO"
  },
  "396380": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Devsar SO"
  },
  "801103": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "BIHTA S.O"
  },
  "803201": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "FATWA S.O"
  },
  "804451": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "HAZRAT SAIN SO"
  },
  "801503": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "B R Centre S.O"
  },
  "800002": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "ANISABAD S.O"
  },
  "801111": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "SADISOPUR S.O"
  },
  "801506": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "SAHAYNAGAR S.O"
  },
  "800030": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Purvi laxmi nagar SO"
  },
  "801105": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "KHAGAUL S.O"
  },
  "383220": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Ilol SO"
  },
  "493558": {
    "state": "CHHATTISGARH",
    "district": "MAHASAMUND",
    "office": "Saraipali SO"
  },
  "493559": {
    "state": "CHHATTISGARH",
    "district": "BALODA BAZAR",
    "office": "Sarsiwa SO"
  },
  "493101": {
    "state": "CHHATTISGARH",
    "district": "BALODA BAZAR",
    "office": "Simga SO"
  },
  "492013": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Sunder Nagar SO"
  },
  "493229": {
    "state": "CHHATTISGARH",
    "district": "BALODA BAZAR",
    "office": "Watgan SO"
  },
  "360405": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Jamkandorna SO"
  },
  "673593": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Ambalavayal SO"
  },
  "673122": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Kalpetta North SO"
  },
  "673596": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Kenichira SO"
  },
  "673591": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Meenangadi SO"
  },
  "673579": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Pulpalli SO"
  },
  "673592": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Sulthan Bathery SO"
  },
  "395004": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Katargam SO"
  },
  "395010": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Bombay Market SO"
  },
  "394210": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Udhnagam SO"
  },
  "394421": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Mosali SO"
  },
  "175138": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Babeli SO"
  },
  "394155": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Ghala SO"
  },
  "394163": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Godsamba SO"
  },
  "394335": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Kadod SO"
  },
  "394360": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Kakrapar SO"
  },
  "394180": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Kamrej SO"
  },
  "585322": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Ratkal S.O"
  },
  "582111": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Abbigeri S.O"
  },
  "582112": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Bellatti S.O"
  },
  "582113": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Dambal S.O"
  },
  "110094": {
    "state": "DELHI",
    "district": "NORTH EAST",
    "office": "Gokal Puri SO"
  },
  "110090": {
    "state": "DELHI",
    "district": "NORTH EAST",
    "office": "Karawal Nagar SO"
  },
  "496330": {
    "state": "CHHATTISGARH",
    "district": "JASHPUR",
    "office": "Manora SO Jashpur"
  },
  "496245": {
    "state": "CHHATTISGARH",
    "district": "JASHPUR",
    "office": "Lawakera SO"
  },
  "496336": {
    "state": "CHHATTISGARH",
    "district": "JASHPUR",
    "office": "Sanna SO"
  },
  "496227": {
    "state": "CHHATTISGARH",
    "district": "JASHPUR",
    "office": "Tapkara SO"
  },
  "136020": {
    "state": "HARYANA",
    "district": "KAITHAL",
    "office": "Dhand S.O"
  },
  "192233": {
    "state": "JAMMU AND KASHMIR",
    "district": "KULGAM",
    "office": "Damhal Hanji Pora SO"
  },
  "192302": {
    "state": "JAMMU AND KASHMIR",
    "district": "PULWAMA",
    "office": "Hawl SO"
  },
  "192231": {
    "state": "JAMMU AND KASHMIR",
    "district": "KULGAM",
    "office": "Kulgam SO"
  },
  "192301": {
    "state": "JAMMU AND KASHMIR",
    "district": "PULWAMA",
    "office": "Pulwama SO"
  },
  "192122": {
    "state": "JAMMU AND KASHMIR",
    "district": "ANANTNAG",
    "office": "Anantnag City SO"
  },
  "192124": {
    "state": "JAMMU AND KASHMIR",
    "district": "ANANTNAG",
    "office": "Bijbehara SO"
  },
  "192211": {
    "state": "JAMMU AND KASHMIR",
    "district": "ANANTNAG",
    "office": "Dooru SO"
  },
  "192202": {
    "state": "JAMMU AND KASHMIR",
    "district": "ANANTNAG",
    "office": "Kokarnag SO"
  },
  "192126": {
    "state": "JAMMU AND KASHMIR",
    "district": "ANANTNAG",
    "office": "Phalgam SO"
  },
  "192221": {
    "state": "JAMMU AND KASHMIR",
    "district": "ANANTNAG",
    "office": "Qazigund SO"
  },
  "192129": {
    "state": "JAMMU AND KASHMIR",
    "district": "ANANTNAG",
    "office": "S K Gund"
  },
  "136035": {
    "state": "HARYANA",
    "district": "KAITHAL",
    "office": "Guhla S.O"
  },
  "126114": {
    "state": "HARYANA",
    "district": "JIND",
    "office": "Shamlo Kalan S.O"
  },
  "126115": {
    "state": "HARYANA",
    "district": "JIND",
    "office": "Uchana S.O"
  },
  "126152": {
    "state": "HARYANA",
    "district": "JIND",
    "office": "Dhanoda Kalan S.O"
  },
  "670646": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Kartikulam SO"
  },
  "686667": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Pampakuda SO"
  },
  "686664": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Piravom SO"
  },
  "686671": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Pothanicaud SO"
  },
  "686663": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Ramamangalam SO"
  },
  "686670": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Vazhakulam SO"
  },
  "686681": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Chelad Junction SO"
  },
  "683544": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Koovappady SO"
  },
  "683549": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Asamannoor SO"
  },
  "360465": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Derdi Kumbaji S.O"
  },
  "360410": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Dhoraji SO"
  },
  "583102": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Ballari Cowl Bazar S.O"
  },
  "125048": {
    "state": "HARYANA",
    "district": "FATEHABAD",
    "office": "Badopal SO"
  },
  "192210": {
    "state": "JAMMU AND KASHMIR",
    "district": "ANANTNAG",
    "office": "Dialgam"
  },
  "192101": {
    "state": "JAMMU AND KASHMIR",
    "district": "ANANTNAG",
    "office": "Sarnal SO"
  },
  "192125": {
    "state": "JAMMU AND KASHMIR",
    "district": "ANANTNAG",
    "office": "Martand SO"
  },
  "192303": {
    "state": "JAMMU AND KASHMIR",
    "district": "SHOPIAN",
    "office": "Shopin SO"
  },
  "561201": {
    "state": "KARNATAKA",
    "district": "RAMANAGARA",
    "office": "Veeregowdanadoddi S.O"
  },
  "562164": {
    "state": "KARNATAKA",
    "district": "BENGALURU RURAL",
    "office": "Avathi S.O"
  },
  "132039": {
    "state": "HARYANA",
    "district": "KARNAL",
    "office": "Assandh S.O"
  },
  "132054": {
    "state": "HARYANA",
    "district": "KARNAL",
    "office": "Garhi Birbal S.O"
  },
  "132114": {
    "state": "HARYANA",
    "district": "KARNAL",
    "office": "Gharunda S.O"
  },
  "132036": {
    "state": "HARYANA",
    "district": "KARNAL",
    "office": "Jundla S.O"
  },
  "132037": {
    "state": "HARYANA",
    "district": "KARNAL",
    "office": "Madhuban PTC S.O"
  },
  "132157": {
    "state": "HARYANA",
    "district": "KARNAL",
    "office": "Nigdhu S.O"
  },
  "132024": {
    "state": "HARYANA",
    "district": "KARNAL",
    "office": "Nissing S.O"
  },
  "132023": {
    "state": "HARYANA",
    "district": "KARNAL",
    "office": "S.S. Kunjpura S.O"
  },
  "125051": {
    "state": "HARYANA",
    "district": "FATEHABAD",
    "office": "Rattia SO"
  },
  "125120": {
    "state": "HARYANA",
    "district": "FATEHABAD",
    "office": "Tohana SO"
  },
  "125044": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "Satroad Khurd SO"
  },
  "125113": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "Uklana Mandi SO"
  },
  "125055": {
    "state": "HARYANA",
    "district": "SIRSA",
    "office": "Begu Road Sirsa SO"
  },
  "125078": {
    "state": "HARYANA",
    "district": "SIRSA",
    "office": "Baragudha SO"
  },
  "492099": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Tatibandh SO"
  },
  "360050": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Jasdan SO"
  },
  "785009": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Na Ali Dhekiajuli S.O"
  },
  "670645": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Mananthavady SO"
  },
  "670721": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Panamaram SO"
  },
  "673124": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "KAMBALAKKAD SO"
  },
  "673577": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Meppadi SO"
  },
  "843114": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Patepur SO"
  },
  "394655": {
    "state": "GUJARAT",
    "district": "TAPI",
    "office": "Kapura SO"
  },
  "394240": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Karchelia SO"
  },
  "394380": {
    "state": "GUJARAT",
    "district": "TAPI",
    "office": "Kukurmunda SO"
  },
  "394340": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Madhi SO"
  },
  "394250": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Mahuva SO Surat"
  },
  "394160": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Mandvi SR SO"
  },
  "394345": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Mota SO"
  },
  "394370": {
    "state": "GUJARAT",
    "district": "TAPI",
    "office": "Nijhar SO"
  },
  "394715": {
    "state": "GUJARAT",
    "district": "DANG",
    "office": "Pimpri SO"
  },
  "394716": {
    "state": "GUJARAT",
    "district": "DANG",
    "office": "Subir SO"
  },
  "394720": {
    "state": "GUJARAT",
    "district": "DANG",
    "office": "Saputara SO"
  },
  "394330": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Orna SO"
  },
  "394352": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Puni SO"
  },
  "394365": {
    "state": "GUJARAT",
    "district": "TAPI",
    "office": "Raniamba SO"
  },
  "132046": {
    "state": "HARYANA",
    "district": "KARNAL",
    "office": "Salwan S.O"
  },
  "132116": {
    "state": "HARYANA",
    "district": "KARNAL",
    "office": "Taroari Mandi S.O"
  },
  "132122": {
    "state": "HARYANA",
    "district": "PANIPAT",
    "office": "Atta S.O"
  },
  "132107": {
    "state": "HARYANA",
    "district": "PANIPAT",
    "office": "Israna S.O"
  },
  "132113": {
    "state": "HARYANA",
    "district": "PANIPAT",
    "office": "Madlauda S.O"
  },
  "132104": {
    "state": "HARYANA",
    "district": "PANIPAT",
    "office": "Panipat Khadi Ashram S.O"
  },
  "132140": {
    "state": "HARYANA",
    "district": "PANIPAT",
    "office": "Panipat Refinary S.O"
  },
  "132105": {
    "state": "HARYANA",
    "district": "PANIPAT",
    "office": "Panipat Thermal Project S.O"
  },
  "132102": {
    "state": "HARYANA",
    "district": "PANIPAT",
    "office": "Patti Kalyana S.O"
  },
  "132101": {
    "state": "HARYANA",
    "district": "PANIPAT",
    "office": "Samalkha S.O"
  },
  "132040": {
    "state": "HARYANA",
    "district": "KARNAL",
    "office": "Ballah S.O"
  },
  "132041": {
    "state": "HARYANA",
    "district": "KARNAL",
    "office": "Indri Town S.O"
  },
  "132001": {
    "state": "HARYANA",
    "district": "KARNAL",
    "office": "Sector 4 Karnal S.O"
  },
  "132022": {
    "state": "HARYANA",
    "district": "KARNAL",
    "office": "Kunjpura S.O"
  },
  "132117": {
    "state": "HARYANA",
    "district": "KARNAL",
    "office": "Nilokheri GIP S.O"
  },
  "132108": {
    "state": "HARYANA",
    "district": "PANIPAT",
    "office": "Panipat Beas Project S.O"
  },
  "132106": {
    "state": "HARYANA",
    "district": "PANIPAT",
    "office": "Panipat NFL S.O"
  },
  "803115": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Pawapuri SO"
  },
  "580011": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Dharwad High Court S.O"
  },
  "580007": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Dharwad Kalyan Nagar S.O"
  },
  "580114": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Dhumwad S.O"
  },
  "581105": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Garag S.O"
  },
  "581204": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Kalghatagi S.O"
  },
  "801112": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "LAI S.O"
  },
  "803118": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Sohsarai SO"
  },
  "496551": {
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "office": "Baramkela SO"
  },
  "496665": {
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "office": "Chhal SO"
  },
  "496116": {
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "office": "Dharamjaigarh SO"
  },
  "496111": {
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "office": "Gharghoda SO"
  },
  "496450": {
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "office": "Hardi SO Raigarh"
  },
  "360020": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Kasturbadham SO"
  },
  "683541": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Keezhillam SO"
  },
  "673633": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Ramanattukara SO"
  },
  "673661": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Mavoor SO Kozhikode"
  },
  "673005": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "East Hill SO"
  },
  "360023": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "KUVADAVA SO"
  },
  "785111": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Neamatighat S.O"
  },
  "192306": {
    "state": "JAMMU AND KASHMIR",
    "district": "PULWAMA",
    "office": "Rajpora"
  },
  "562163": {
    "state": "KARNATAKA",
    "district": "BENGALURU RURAL",
    "office": "Nagadenahalli S.O"
  },
  "582102": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Gadag Betgeri S.O"
  },
  "132145": {
    "state": "HARYANA",
    "district": "PANIPAT",
    "office": "Neoltha S.O"
  },
  "394350": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Sarbhon SO"
  },
  "394320": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Sevni SO"
  },
  "394375": {
    "state": "GUJARAT",
    "district": "TAPI",
    "office": "Uchchhal SO"
  },
  "394150": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Kathor SO"
  },
  "492008": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "WRSColony SO"
  },
  "387370": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Uttarsanda SO"
  },
  "360004": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Mavdi NDTSO"
  },
  "360485": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Amarnagar S.O"
  },
  "360040": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Atkot SO"
  },
  "174023": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Dadhol SO"
  },
  "174032": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Namhol SO"
  },
  "391130": {
    "state": "GUJARAT",
    "district": "CHHOTAUDEPUR",
    "office": "Bhatpur SO"
  },
  "442905": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Rajura (M) S.O"
  },
  "394445": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Umarpada SO"
  },
  "580112": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Morab S.O"
  },
  "582201": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Annegeri Market S.O"
  },
  "394315": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Palsana SO Surat"
  },
  "394170": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Tadkeshwar SO"
  },
  "389265": {
    "state": "GUJARAT",
    "district": "Mahisagar",
    "office": "Malvan SO"
  },
  "388640": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Undel SO"
  },
  "387375": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Vadtal SO"
  },
  "388580": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Virsad SO"
  },
  "389110": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Mora SO Panch Mahals"
  },
  "389130": {
    "state": "GUJARAT",
    "district": "DOHAD",
    "office": "Piplod SO Dahod"
  },
  "389260": {
    "state": "GUJARAT",
    "district": "Mahisagar",
    "office": "Santrampur SO"
  },
  "389232": {
    "state": "GUJARAT",
    "district": "Mahisagar",
    "office": "Bakor SO"
  },
  "389190": {
    "state": "GUJARAT",
    "district": "DOHAD",
    "office": "Sukhsar SO"
  },
  "389341": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Adadra SO"
  },
  "389310": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Delol SO"
  },
  "389320": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Derol R S SO"
  },
  "585326": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Aurad (B) S.O"
  },
  "585328": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Bhalki S.O"
  },
  "585411": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Bhatambra S.O"
  },
  "585402": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Bidar G.N.Jhira S.O"
  },
  "585403": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Siddharudh Math Area S.O"
  },
  "585412": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Chitguppa S.O"
  },
  "585413": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Halbarga S.O"
  },
  "582103": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Gadag Mulgund Naka S.O"
  },
  "582203": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Holealur S.O"
  },
  "582205": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Hulkoti S.O"
  },
  "582115": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Lakkundi S.O"
  },
  "582114": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Gajendragad S.O"
  },
  "582204": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Hombal S.O"
  },
  "587201": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Badami S.O"
  },
  "587111": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Bagalkot Alokudyog S.O"
  },
  "587103": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Bagalkot Navanagar S.O"
  },
  "822126": {
    "state": "JHARKHAND",
    "district": "PALAMU",
    "office": "Satbarwa SO"
  },
  "580023": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Hubballi Keshwapur S.O"
  },
  "581195": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Koliwad S.O"
  },
  "581113": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Kundgol S.O"
  },
  "582208": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Navalgund S.O"
  },
  "580024": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Old Hubballi S.O"
  },
  "581117": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Saunshi S.O"
  },
  "382445": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Vatva Industrial Estate SO"
  },
  "360320": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Gomta SO"
  },
  "193101": {
    "state": "JAMMU AND KASHMIR",
    "district": "BARAMULLA",
    "office": "Baramulla H.O"
  },
  "193201": {
    "state": "JAMMU AND KASHMIR",
    "district": "BARAMULLA",
    "office": "Sopore S.O"
  },
  "673575": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Pozhuthana SO"
  },
  "394430": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Vankal SO"
  },
  "395013": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Sarthana SO"
  },
  "394405": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Velachha SO"
  },
  "394440": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Zankhvav SO"
  },
  "391105": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Chandod SO"
  },
  "395012": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Limbayat SO"
  },
  "171204": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Kiari SO"
  },
  "171202": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Kotkhai SO"
  },
  "193123": {
    "state": "JAMMU AND KASHMIR",
    "district": "BARAMULLA",
    "office": "Uri S.O"
  },
  "122102": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Bhondsi SO"
  },
  "122506": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Farrukh Nagar SO"
  },
  "122505": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Garhi Harsaru SO"
  },
  "583137": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Teligi S.O"
  },
  "583224": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Thambrahalli S.O"
  },
  "821302": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Amjhore Camp SO"
  },
  "587115": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Bevur S.O (Bagalkot)"
  },
  "587202": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Gudur S.O (Bagalkot)"
  },
  "585329": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Hoodgi S.O"
  },
  "585416": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Hulsoor S.O"
  },
  "585211": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Chittapur S.O"
  },
  "573210": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Hallymysore S.O"
  },
  "496224": {
    "state": "CHHATTISGARH",
    "district": "JASHPUR",
    "office": "Bagicha SO"
  },
  "496331": {
    "state": "CHHATTISGARH",
    "district": "JASHPUR",
    "office": "Jashpurnagar SO"
  },
  "382320": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Sadra SO"
  },
  "382422": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Uvarsad SO"
  },
  "382725": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Kalol Industrial Estate SO"
  },
  "382810": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Charada SO"
  },
  "382845": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Mansa SO Gandhi Nagar"
  },
  "382735": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Nardipur SO"
  },
  "382740": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Pansar SO"
  },
  "585214": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Gurmitkal S.O"
  },
  "585317": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Malkhed S.O"
  },
  "585318": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Mudhol (Kalaburagi) S.O"
  },
  "585309": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Gogi S.O"
  },
  "585218": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Nalwar S.O"
  },
  "585327": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Basavakalyan S.O"
  },
  "585215": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Hunasgi S.O"
  },
  "585216": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Kembhavi S.O"
  },
  "585224": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Shorapur Town S.O"
  },
  "585290": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Kumbarpeth S.O"
  },
  "585319": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Naikal S.O"
  },
  "585418": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Dubalgundi S.O"
  },
  "585414": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Hallikhed (B) S.O"
  },
  "585415": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Hallikhed SF S.O"
  },
  "494221": {
    "state": "CHHATTISGARH",
    "district": "BASTAR",
    "office": "Asna S.O"
  },
  "171217": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Kupvi SO"
  },
  "171216": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Mandal SO Shimla"
  },
  "176043": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Ladraur SO"
  },
  "176044": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Mundkhar SO"
  },
  "176108": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Bhaleth SO"
  },
  "171007": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Mashobra SO"
  },
  "171213": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Narkanda SO"
  },
  "171210": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Nerwa SO"
  },
  "844508": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Raghopur SO"
  },
  "844123": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Prataptand SO"
  },
  "801113": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "NEORA S.O"
  },
  "844124": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Rajapakar SO"
  },
  "587203": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Guledgudd S.O"
  },
  "587112": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Amingad S.O"
  },
  "833102": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "Chakradharpur SO"
  },
  "591129": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Yargatti S.O"
  },
  "844509": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Sahdei Buzurg SO"
  },
  "844125": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Sarai SO"
  },
  "844126": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Singhara SO"
  },
  "843106": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Gidha SO"
  },
  "843122": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Hardi SO Muzaffarpur"
  },
  "573217": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Kandali S.O"
  },
  "573128": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Kattaya S.O"
  },
  "573129": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Kenchammanahosakote S.O"
  },
  "573130": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Konanur S.O"
  },
  "573212": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Mosale Hosahalli S.O"
  },
  "573218": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Palya S.O"
  },
  "573133": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Ramanathapura S.O"
  },
  "573136": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Keralapura S.O"
  },
  "833106": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "Chiria SO"
  },
  "833103": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "Goilkera SO"
  },
  "829128": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Swang Colliery SO"
  },
  "832302": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Dhalbhumgarh SO"
  },
  "394185": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Kamrej Char Rasta SO"
  },
  "585210": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Kurkunta C.F S.O"
  },
  "581206": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Uppinabetageri S.O"
  },
  "581107": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Gudgeri S.O"
  },
  "581209": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Hebsur S.O"
  },
  "580028": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Hubballi Bankapur Chowki S.O"
  },
  "841214": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Kopa Bazar SO"
  },
  "384001": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Mahesana JSM SO"
  },
  "110093": {
    "state": "DELHI",
    "district": "NORTH EAST",
    "office": "Housing Complex Loni Road SO"
  },
  "585320": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Nidgunda S.O"
  },
  "490042": {
    "state": "CHHATTISGARH",
    "district": "DURG",
    "office": "Kumhari SO"
  },
  "490036": {
    "state": "CHHATTISGARH",
    "district": "DURG",
    "office": "Nandini SO"
  },
  "491111": {
    "state": "CHHATTISGARH",
    "district": "DURG",
    "office": "Patan SO Durg"
  },
  "491107": {
    "state": "CHHATTISGARH",
    "district": "DURG",
    "office": "Utai SO"
  },
  "756060": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Sergarh S.O"
  },
  "756045": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Soro RS SO"
  },
  "573134": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Sakleshpur S.O"
  },
  "573219": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Salagame S.O"
  },
  "384455": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Ambaliasan SO"
  },
  "384410": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Balol SO"
  },
  "384120": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Bhandu SO"
  },
  "384450": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Dangarwa SO"
  },
  "384460": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Jagudan SO"
  },
  "841223": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Mohamadpur SO"
  },
  "841220": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Parsagarh SO"
  },
  "581201": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Amminabhavi S.O"
  },
  "580006": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Dharwad M J Nagar S.O"
  },
  "580118": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Hulkoppa S.O"
  },
  "413603": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Andora S.O"
  },
  "413504": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Bhoom S.O"
  },
  "413604": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Dalimb S.O"
  },
  "415014": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Tarale S.O"
  },
  "581207": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Aralikatti S.O"
  },
  "581196": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Mishrikoti S.O"
  },
  "796261": {
    "state": "MIZORAM",
    "district": "SAITUAL",
    "office": "Saitual S.O"
  },
  "796181": {
    "state": "MIZORAM",
    "district": "SERCHHIP",
    "office": "Serchhip S.O"
  },
  "389365": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Ghoghmba SO"
  },
  "389002": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Godhra Bhuravav SO"
  },
  "389350": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Halol SO"
  },
  "389175": {
    "state": "GUJARAT",
    "district": "DOHAD",
    "office": "Sanjeli SO"
  },
  "573226": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Boovanahalli S.O"
  },
  "573220": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Shanthigrama S.O"
  },
  "573137": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Yeslur S.O"
  },
  "192304": {
    "state": "JAMMU AND KASHMIR",
    "district": "PULWAMA",
    "office": "Kakapora"
  },
  "562132": {
    "state": "KARNATAKA",
    "district": "BENGALURU RURAL",
    "office": "Tyamagondlu S.O"
  },
  "562135": {
    "state": "KARNATAKA",
    "district": "BENGALURU RURAL",
    "office": "Vijayapura S.O"
  },
  "389154": {
    "state": "GUJARAT",
    "district": "DOHAD",
    "office": "Katwara SO"
  },
  "125101": {
    "state": "HARYANA",
    "district": "SIRSA",
    "office": "Chautala SO"
  },
  "125110": {
    "state": "HARYANA",
    "district": "SIRSA",
    "office": "Chopta Nathu Sari SO"
  },
  "125049": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "Sisai SO Hisar"
  },
  "394246": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Sugar Factory Bamania SO"
  },
  "454010": {
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "office": "Mandu S.O"
  },
  "181133": {
    "state": "JAMMU AND KASHMIR",
    "district": "SAMBA",
    "office": "Bari Brahmna SO"
  },
  "181132": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Bishnah SO"
  },
  "181143": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Gurah Salathia SO"
  },
  "181101": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Miran Sahib SO"
  },
  "181145": {
    "state": "JAMMU AND KASHMIR",
    "district": "SAMBA",
    "office": "Purmandal SO"
  },
  "181102": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "RSPura SO"
  },
  "180011": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Greater Kailash SO"
  },
  "184121": {
    "state": "JAMMU AND KASHMIR",
    "district": "SAMBA",
    "office": "Samba Adda SO"
  },
  "184120": {
    "state": "JAMMU AND KASHMIR",
    "district": "SAMBA",
    "office": "Vijaypur SO"
  },
  "181201": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Akhnoor SO"
  },
  "110053": {
    "state": "DELHI",
    "district": "NORTH EAST",
    "office": "Jafrabad SO East Delhi"
  },
  "110049": {
    "state": "DELHI",
    "district": "SOUTH",
    "office": "Andrewsganj SO"
  },
  "110014": {
    "state": "DELHI",
    "district": "SOUTH",
    "office": "Jungpura SO"
  },
  "841305": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Revelganj SO"
  },
  "394105": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Utran Power House SO"
  },
  "171207": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Rohru SO"
  },
  "171224": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Summer Kot SO"
  },
  "752038": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Siko S.O"
  },
  "752021": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Singipur S.O"
  },
  "752023": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Tangi S.O"
  },
  "670644": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Thalappuzha SO"
  },
  "670731": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Vellamunda SO"
  },
  "364265": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Gheti SO"
  },
  "364110": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Gogha SO"
  },
  "364510": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Jesar SO"
  },
  "364070": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Koliyak SO"
  },
  "364290": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Mahuva SO Bhavnagar"
  },
  "364280": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Motakhuntavada SO"
  },
  "364760": {
    "state": "GUJARAT",
    "district": "BOTAD",
    "office": "Ningala SO"
  },
  "364270": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Palitana SR SO"
  },
  "673019": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Pantheerankavu SO"
  },
  "673004": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Calicut City SO"
  },
  "193504": {
    "state": "JAMMU AND KASHMIR",
    "district": "GANDERBAL",
    "office": "Safapora S.O"
  },
  "193223": {
    "state": "JAMMU AND KASHMIR",
    "district": "KUPWARA",
    "office": "Sogam S.O"
  },
  "193501": {
    "state": "JAMMU AND KASHMIR",
    "district": "BANDIPORA",
    "office": "Sonawari S.O"
  },
  "193225": {
    "state": "JAMMU AND KASHMIR",
    "district": "KUPWARA",
    "office": "Tangdhar S.O"
  },
  "193224": {
    "state": "JAMMU AND KASHMIR",
    "district": "KUPWARA",
    "office": "TREHGAM S.O"
  },
  "673581": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Vatuvanchal SO"
  },
  "364275": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Parvadi SO"
  },
  "364313": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Ratanpur Bhal SO"
  },
  "364230": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Sanosara SO"
  },
  "364240": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Sihor SO"
  },
  "122107": {
    "state": "HARYANA",
    "district": "NUH",
    "office": "Nuh SO"
  },
  "122508": {
    "state": "HARYANA",
    "district": "NUH",
    "office": "Punhana SO"
  },
  "122105": {
    "state": "HARYANA",
    "district": "NUH",
    "office": "Tauru SO"
  },
  "305005": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Crpf Ajmer S.O"
  },
  "305003": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Hmt Ajmer Dtso S.O"
  },
  "305021": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Karel S.O"
  },
  "305022": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Pushkar S.O"
  },
  "370615": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Nakhatrana SO"
  },
  "370655": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Naliya SO"
  },
  "370620": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Netra SO"
  },
  "370425": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Patri SO"
  },
  "370165": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Rahpar SO"
  },
  "370625": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Ravapar SO"
  },
  "370150": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Samkhiyali SO"
  },
  "370601": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Shyamji Krishna Varma Nagar SO"
  },
  "370660": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Tera SO"
  },
  "370665": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Virani SO"
  },
  "370675": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Vithon SO"
  },
  "583103": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Ballari Parvathi Nagar S.O"
  },
  "583111": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Chellakurki S.O"
  },
  "583112": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Deogiri S.O"
  },
  "583113": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Emmiganur S.O"
  },
  "583130": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Gudekota S.O"
  },
  "583114": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Hatcholi S.O"
  },
  "583152": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Ballari Thermal Power Station S.O"
  },
  "370040": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Sukhpar SO"
  },
  "384415": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Becharaji SO"
  },
  "384360": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Dharoi DSC SO"
  },
  "144702": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Shahkot SO"
  },
  "144044": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "SIDHWAN R S SO"
  },
  "144036": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Bilga SO"
  },
  "802164": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Sandesh SO"
  },
  "802165": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Shahpurpatti SO"
  },
  "583115": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Kudathini S.O"
  },
  "583155": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Kolur S.O"
  },
  "110047": {
    "state": "DELHI",
    "district": "SOUTH",
    "office": "Arjungarh SO"
  },
  "110080": {
    "state": "DELHI",
    "district": "SOUTH",
    "office": "Talimabad SO"
  },
  "110076": {
    "state": "DELHI",
    "district": "SOUTH",
    "office": "Sarita Vihar SO"
  },
  "185154": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Chowki Choura SO"
  },
  "670612": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Anjarakandy SO"
  },
  "181131": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Arnia SO"
  },
  "180010": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Gangyal SO"
  },
  "364720": {
    "state": "GUJARAT",
    "district": "BOTAD",
    "office": "Paliyad SO"
  },
  "122502": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Khalilpur SO"
  },
  "110036": {
    "state": "DELHI",
    "district": "NORTH",
    "office": "Alipur SO"
  },
  "110039": {
    "state": "DELHI",
    "district": "NORTH",
    "office": "Bawana SO"
  },
  "110081": {
    "state": "DELHI",
    "district": "NORTH WEST",
    "office": "Kanjhawla SO"
  },
  "110040": {
    "state": "DELHI",
    "district": "NORTH",
    "office": "NARELA TOWN"
  },
  "110035": {
    "state": "DELHI",
    "district": "NORTH WEST",
    "office": "INDERLOK SO"
  },
  "110085": {
    "state": "DELHI",
    "district": "NORTH WEST",
    "office": "Rohini Sector 16 PO"
  },
  "571201": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Madikeri Dist. Offices Complex S.O"
  },
  "571211": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Ammathi S.O"
  },
  "571212": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Cheyandane S.O"
  },
  "571213": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Gonikoppal S.O"
  },
  "585304": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Bijaspur S.O"
  },
  "585237": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Kodekal S.O"
  },
  "585315": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Madhwar S.O"
  },
  "573202": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Vidyanagar (Hassan) S.O"
  },
  "571219": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Balele S.O"
  },
  "571247": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Bhagamandala S.O"
  },
  "571248": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Chettalli S.O"
  },
  "122504": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Haillymandi SO"
  },
  "144632": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "Chachoki SO"
  },
  "144037": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Pasla SO"
  },
  "144043": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "SARIH SO"
  },
  "144626": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "Gnqc Sultanpur SO"
  },
  "181111": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Dablehar SO"
  },
  "180003": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Industrial Estate SO Jammu"
  },
  "587114": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Belur S.O (Bagalkot)"
  },
  "756047": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Turigaria S.O"
  },
  "756030": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Amarda Road S.O"
  },
  "756026": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Baliapal S.O"
  },
  "756038": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Bhograi S.O"
  },
  "756079": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Dahamunda S.O"
  },
  "756036": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Dehurda S.O"
  },
  "144603": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "PTU Campus Kapurthala SO"
  },
  "144622": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "Bholath SO"
  },
  "144407": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "DOMELI SO"
  },
  "144405": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "Narur SO"
  },
  "144411": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "University Campus Nanak Nagri SO"
  },
  "171212": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Matiana SO"
  },
  "496005": {
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "office": "JSPL Patrapali SO"
  },
  "380059": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Thaltej SO"
  },
  "571249": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Hudikeri S.O"
  },
  "571232": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Kudige S.O"
  },
  "571234": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Kushalnagar S.O"
  },
  "571250": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Kutta S.O"
  },
  "571251": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Madapura S.O"
  },
  "571252": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Murnad S.O"
  },
  "573117": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Doddamettikurke S.O"
  },
  "573118": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Dudda R S S.O"
  },
  "573119": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Gandasi S.O"
  },
  "171006": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Sanjauli SO"
  },
  "441225": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Saoli S.O"
  },
  "171221": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Kawar SO"
  },
  "171219": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Shoghi SO"
  },
  "442906": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Segaon S.O (Chandrapur)"
  },
  "442503": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Shivjinagar S.O"
  },
  "441222": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Sindewahi S.O"
  },
  "442504": {
    "state": "MAHARASHTRA",
    "district": "GADCHIROLI",
    "office": "Sironcha S.O"
  },
  "441221": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Talodhi Balapur S.O"
  },
  "122004": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Narsinghpur SO"
  },
  "122017": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Palam Vihar SO Gurgaon"
  },
  "587102": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Gaddankeri Cross S.O"
  },
  "752063": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Bhapur S.O (Nayagarh)"
  },
  "415109": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Umbraj S.O"
  },
  "415506": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Vaduj S.O"
  },
  "415124": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Vidyanagar Karad S.O"
  },
  "415115": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Yashvantnagar S.O"
  },
  "415020": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Anewadi S.O"
  },
  "413524": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Nalegaon S.O"
  },
  "413521": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Nilanga S.O"
  },
  "413527": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Renapur S.O"
  },
  "412804": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Bavdhan S.O"
  },
  "415504": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Diskal Mol S.O"
  },
  "412802": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Khandala Bavada S.O"
  },
  "415021": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Kinhai S.O"
  },
  "415501": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Koregaon City S.O"
  },
  "415514": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Kudal S.O (Satara)"
  },
  "415114": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Supane S.O"
  },
  "110030": {
    "state": "DELHI",
    "district": "SOUTH",
    "office": "Paryavaran Complex SO"
  },
  "110068": {
    "state": "DELHI",
    "district": "SOUTH",
    "office": "Ignou SO"
  },
  "125054": {
    "state": "HARYANA",
    "district": "SIRSA",
    "office": "Bahaudin SO"
  },
  "766111": {
    "state": "ODISHA",
    "district": "NUAPADA",
    "office": "Boden S.O"
  },
  "415537": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Adarki BK S.O"
  },
  "415518": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Apshinge S.O"
  },
  "415503": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Budh S.O"
  },
  "181141": {
    "state": "JAMMU AND KASHMIR",
    "district": "SAMBA",
    "office": "Ramgarh SO Jammu"
  },
  "181123": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Bantalab SO"
  },
  "181122": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Bhalwal SO"
  },
  "766002": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Bhawanipatna G.Chowk S.O"
  },
  "766020": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Biswanathpur S.O"
  },
  "761016": {
    "state": "ODISHA",
    "district": "GAJAPATI",
    "office": "R.Udayagiri S.O"
  },
  "761213": {
    "state": "ODISHA",
    "district": "GAJAPATI",
    "office": "Rayagada S.O"
  },
  "761201": {
    "state": "ODISHA",
    "district": "GAJAPATI",
    "office": "Station Road Paralakhemundi S.O"
  },
  "360590": {
    "state": "GUJARAT",
    "district": "PORBANDAR",
    "office": "Bagvadar SO"
  },
  "362620": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Bantwa SO"
  },
  "360579": {
    "state": "GUJARAT",
    "district": "PORBANDAR",
    "office": "Bokhira SO"
  },
  "122503": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Pataudi SO"
  },
  "122103": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Sohna SO"
  },
  "123001": {
    "state": "HARYANA",
    "district": "MAHENDRAGARH",
    "office": "Narnaul Kty SO"
  },
  "362650": {
    "state": "GUJARAT",
    "district": "PORBANDAR",
    "office": "Kutiyana S.O"
  },
  "362015": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Timbavadi SO"
  },
  "362610": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "VanthaliS SO"
  },
  "125004": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "Ha U Hisar SO"
  },
  "125033": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "T C Hansi SO"
  },
  "125052": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "Mandi Adampur SO"
  },
  "125005": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "Modle Town Hisar SO"
  },
  "181224": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Dansal SO"
  },
  "363655": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Amran SO"
  },
  "361240": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Balambha SO"
  },
  "844128": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Vaishali SO"
  },
  "383410": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Badoli SO"
  },
  "384421": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Jhotana SO"
  },
  "384305": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Kada SO Mahesana"
  },
  "383260": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Akrund SO"
  },
  "383325": {
    "state": "GUJARAT",
    "district": "ARVALLI",
    "office": "Bayad SO"
  },
  "144042": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Shankar SO"
  },
  "144625": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "Sidhwan Dona SO"
  },
  "144311": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "DHESIAN KAHNA SO"
  },
  "144033": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "JANDIALA SO"
  },
  "573121": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Halebeedu S.O"
  },
  "573122": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Haranahalli S.O"
  },
  "573125": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Javagal S.O"
  },
  "573144": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Kanakatte S.O"
  },
  "573131": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Nuggihalli S.O"
  },
  "361012": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Chela SO"
  },
  "361210": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Dhrol SO"
  },
  "361120": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Dhuvav SO"
  },
  "361306": {
    "state": "GUJARAT",
    "district": "DEVBHUMI DWARKA",
    "office": "Bhadthar SO"
  },
  "415505": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Khatav S.O"
  },
  "415530": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Kisanveernagar S.O"
  },
  "392110": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Amod SO"
  },
  "413544": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Shirur Anantpal S.O"
  },
  "413531": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Ramnagar Latur S.O"
  },
  "125037": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "Nalwa SO"
  },
  "125039": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "Narnaund SO"
  },
  "110061": {
    "state": "DELHI",
    "district": "SOUTH WEST",
    "office": "Bijwasan SO"
  },
  "110037": {
    "state": "DELHI",
    "district": "NEW DELHI",
    "office": "Gurgaon Road SO"
  },
  "110070": {
    "state": "DELHI",
    "district": "NEW DELHI",
    "office": "Vasant Kunj SO"
  },
  "110072": {
    "state": "DELHI",
    "district": "SOUTH WEST",
    "office": "CRPF Jharoda Kalan S.O"
  },
  "110043": {
    "state": "DELHI",
    "district": "SOUTH WEST",
    "office": "Arjun Park PO"
  },
  "125111": {
    "state": "HARYANA",
    "district": "FATEHABAD",
    "office": "Bhuna SO"
  },
  "370115": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "New Dudhai SO"
  },
  "123501": {
    "state": "HARYANA",
    "district": "REWARI",
    "office": "Bawal SO"
  },
  "305205": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Raj Garh (Ajmer) S.O"
  },
  "305206": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Saradhana S.O"
  },
  "122104": {
    "state": "HARYANA",
    "district": "NUH",
    "office": "Ferozepur Jhirka SO"
  },
  "122108": {
    "state": "HARYANA",
    "district": "NUH",
    "office": "Nagina SO Gurgaon"
  },
  "305023": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Gagwana S.O"
  },
  "454335": {
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "office": "Nisarpur S.O"
  },
  "454116": {
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "office": "Rajgarh (Dhar) S.O"
  },
  "454111": {
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "office": "Sardarpur S.O (Dhar)"
  },
  "391761": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Rustampura SO Vadodara"
  },
  "391520": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Samlaya R S SO"
  },
  "391530": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Sandasal SO"
  },
  "391770": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Savli SO"
  },
  "391101": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Sevasi SO"
  },
  "391760": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Vaghodia SO"
  },
  "391445": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Ranu SO"
  },
  "766032": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Karlamunda S.O"
  },
  "766028": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Ampani S.O"
  },
  "793108": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Cherrapunjee S.O"
  },
  "793109": {
    "state": "MEGHALAYA",
    "district": "WEST JAINTIA HILLS",
    "office": "Dawki S.O"
  },
  "793110": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Pynursla S.O"
  },
  "305002": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Ie Makhu Pura Ajmer S.O"
  },
  "441217": {
    "state": "MAHARASHTRA",
    "district": "GADCHIROLI",
    "office": "Vairagadh S.O"
  },
  "442916": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Korpana SO"
  },
  "442907": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Warora S.O"
  },
  "442918": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Pombhurna S.O"
  },
  "413517": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Udgirganj S.O"
  },
  "413530": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Nitoor S.O"
  },
  "393041": {
    "state": "GUJARAT",
    "district": "NARMADA",
    "office": "Ambawadi SO Bharuch"
  },
  "393105": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Bhalod SO Vadodara"
  },
  "431522": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Pangaon S.O (Latur)"
  },
  "413514": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Shirur Tajband S.O"
  },
  "393002": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Ankleshwar IE SO"
  },
  "393001": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Ankleshwar SO"
  },
  "573135": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Shravanabelagola S.O"
  },
  "573225": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Agriculture College Campus Dly S.O"
  },
  "573213": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Alur S.O (Hassan)"
  },
  "573102": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Arkalgud S.O"
  },
  "573214": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Ballupet S.O"
  },
  "573215": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Bikkodu S.O"
  },
  "573127": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Bykere S.O"
  },
  "573120": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Gorur S.O"
  },
  "573216": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Hagare S.O"
  },
  "392130": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Dahej SO"
  },
  "392020": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Dayadra SO"
  },
  "391810": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Gajera SO"
  },
  "388307": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Kantharia SO"
  },
  "388325": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Karamsad SO"
  },
  "388340": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Mogar SO"
  },
  "388560": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Napa SO"
  },
  "388350": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Napad SO"
  },
  "393040": {
    "state": "GUJARAT",
    "district": "NARMADA",
    "office": "Dediapada SO"
  },
  "413582": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Anandnagar S.O (Osmanabad)"
  },
  "413506": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Bembli S.O"
  },
  "793150": {
    "state": "MEGHALAYA",
    "district": "WEST JAINTIA HILLS",
    "office": "Jowai S.O"
  },
  "793200": {
    "state": "MEGHALAYA",
    "district": "EAST JAINTIA HILLS",
    "office": "Khliehriat S.O"
  },
  "793210": {
    "state": "MEGHALAYA",
    "district": "EAST JAINTIA HILLS",
    "office": "Lumshnong S.O"
  },
  "793021": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Madanriting S.O"
  },
  "793114": {
    "state": "MEGHALAYA",
    "district": "SOUTH WEST KHASI HILLS",
    "office": "Mawkyrwat S.O"
  },
  "793121": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Mawphlang S.O"
  },
  "793120": {
    "state": "MEGHALAYA",
    "district": "WEST KHASI HILLS",
    "office": "Mairang S.O"
  },
  "125106": {
    "state": "HARYANA",
    "district": "FATEHABAD",
    "office": "Dharsul Kalan SO"
  },
  "362560": {
    "state": "GUJARAT",
    "district": "GIR SOMNATH",
    "office": "Una SO"
  },
  "573123": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Hethur S.O"
  },
  "573211": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Holenarsipur S.O"
  },
  "491340": {
    "state": "CHHATTISGARH",
    "district": "BEMETARA",
    "office": "Nandghat SO"
  },
  "491337": {
    "state": "CHHATTISGARH",
    "district": "BEMETARA",
    "office": "Nawagarh SO Durg"
  },
  "491993": {
    "state": "CHHATTISGARH",
    "district": "BEMETARA",
    "office": "Saja SO"
  },
  "175040": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Dharampur SO Mandi"
  },
  "175006": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Gagal SO"
  },
  "175036": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Gurkotha SO"
  },
  "175049": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Jamni SO"
  },
  "175015": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Joginder Nagar SO"
  },
  "175003": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Kotli SO"
  },
  "394325": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Umbhel SO"
  },
  "394640": {
    "state": "GUJARAT",
    "district": "TAPI",
    "office": "Valod SO"
  },
  "394248": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Valvada SO"
  },
  "305024": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Maday S.O"
  },
  "360480": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Paneli SO"
  },
  "360070": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Mengni SO"
  },
  "360330": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Moviya SO"
  },
  "360375": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Navagadh SO"
  },
  "360325": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Sultanpur S.O"
  },
  "360440": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Supedi SO"
  },
  "360490": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Upleta Lati Plot SO"
  },
  "360380": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Virpur SO"
  },
  "193301": {
    "state": "JAMMU AND KASHMIR",
    "district": "BARAMULLA",
    "office": "Rohama S.O"
  },
  "571231": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Kodlipet S.O"
  },
  "342602": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Bilara SO"
  },
  "342312": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Chadi SO"
  },
  "342314": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Dechu SO"
  },
  "342308": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Khichan SO"
  },
  "573165": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Hanbalu S.O"
  },
  "342604": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Borunda SO"
  },
  "573141": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Didaga S.O"
  },
  "394620": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Vankaner SR SO"
  },
  "394355": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Varad SO"
  },
  "394650": {
    "state": "GUJARAT",
    "district": "TAPI",
    "office": "Vyara RS SO"
  },
  "444101": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Akot S.O"
  },
  "441204": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Umred Project S.O"
  },
  "441108": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Bori S.O (Nagpur)"
  },
  "441401": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Kanhan Pipri S.O"
  },
  "396230": {
    "state": "THE DADRA AND NAGAR HAVELI AND DAMAN AND DIU",
    "district": "DADRA AND NAGAR HAVELI",
    "office": "Silvassa SO"
  },
  "175032": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Chauntra SO"
  },
  "175005": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Kataula SO"
  },
  "573124": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Hirisave S.O"
  },
  "573126": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Jaya Chamaraja Pura S.O"
  },
  "573164": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Lalanakere S.O"
  },
  "573101": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Arehalli S.O"
  },
  "573113": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Basavapatna S.O (Hassan)"
  },
  "573142": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Doddamagge S.O"
  },
  "342801": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Dunara SO"
  },
  "342029": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Soyla PO"
  },
  "342037": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Lavera Baori SO"
  },
  "342302": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Lohawat SO"
  },
  "342802": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Luni SO"
  },
  "342305": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Mathania SO"
  },
  "342303": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Osian SO"
  },
  "175014": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Drubbal SO"
  },
  "175007": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Gopalpur SO Mandi"
  },
  "396035": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Valsad IE SO"
  },
  "394730": {
    "state": "GUJARAT",
    "district": "DANG",
    "office": "Waghai SO"
  },
  "396125": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Killa Pardi SO"
  },
  "396126": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Nanapondha SO"
  },
  "396067": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Kaprada SO"
  },
  "396065": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Nanivahiyal SO"
  },
  "396145": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Pardi Paria SO"
  },
  "175016": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Ladbharole SO"
  },
  "121106": {
    "state": "HARYANA",
    "district": "PALWAL",
    "office": "Hodal SO"
  },
  "121105": {
    "state": "HARYANA",
    "district": "PALWAL",
    "office": "Aurangabad SO Faridabad"
  },
  "144035": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Partappura SO"
  },
  "144032": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Samrai SO"
  },
  "144633": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "SARHALI SO"
  },
  "333704": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Mandawa S.O"
  },
  "333705": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "C.R. Mukundgarh S.O"
  },
  "362265": {
    "state": "GUJARAT",
    "district": "GIR SOMNATH",
    "office": "Veraval SO"
  },
  "125050": {
    "state": "HARYANA",
    "district": "FATEHABAD",
    "office": "Nai Mandi Fatehabad SO"
  },
  "110010": {
    "state": "DELHI",
    "district": "NEW DELHI",
    "office": "Dhaula Kuan SO"
  },
  "110045": {
    "state": "DELHI",
    "district": "SOUTH WEST",
    "office": "Mahavir Enclave"
  },
  "110077": {
    "state": "DELHI",
    "district": "SOUTH WEST",
    "office": "Raj Nagar   II S.O"
  },
  "110071": {
    "state": "DELHI",
    "district": "SOUTH WEST",
    "office": "Qutub Vihar SO"
  },
  "110075": {
    "state": "DELHI",
    "district": "SOUTH WEST",
    "office": "Dwarka Sec-6 S.O"
  },
  "415527": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Kuroli Sidheshwar S.O"
  },
  "413518": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Wadhona S.O"
  },
  "413529": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Wadwal Nagnath S.O"
  },
  "360510": {
    "state": "GUJARAT",
    "district": "DEVBHUMI DWARKA",
    "office": "Bhanvad SO"
  },
  "361315": {
    "state": "GUJARAT",
    "district": "DEVBHUMI DWARKA",
    "office": "Bhatia SO"
  },
  "391745": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Sokhda SO"
  },
  "391775": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Tundav SO"
  },
  "392310": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Valan SO"
  },
  "761211": {
    "state": "ODISHA",
    "district": "GAJAPATI",
    "office": "Uppalada S.O"
  },
  "394680": {
    "state": "GUJARAT",
    "district": "TAPI",
    "office": "Ukai Dam SO"
  },
  "396055": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Ronvel SO"
  },
  "396155": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Sarigam SO"
  },
  "396165": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Solsumba SO"
  },
  "396185": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Udvada RS SO"
  },
  "396007": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Valsad Sugar Factory SO"
  },
  "110091": {
    "state": "DELHI",
    "district": "EAST",
    "office": "Trilok Puri SO"
  },
  "361110": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Aliabada SO"
  },
  "361006": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Khodiyar Colony SO"
  },
  "360520": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Dhrafa SO"
  },
  "110044": {
    "state": "DELHI",
    "district": "South East",
    "office": "Meethapur SO"
  },
  "333053": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Ponkh S.O"
  },
  "331026": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Tamkore S.O"
  },
  "333307": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Udaipurwati S.O"
  },
  "121101": {
    "state": "HARYANA",
    "district": "FARIDABAD",
    "office": "Tigaon SO"
  },
  "122101": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Badshahpur SO"
  },
  "122413": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Bhorakalan SO"
  },
  "122003": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Gurgaon Sector 45 SO"
  },
  "122414": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Nanukalan SO"
  },
  "583117": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Moka S.O"
  },
  "583154": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Karur SO"
  },
  "583121": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Siruguppa S.O"
  },
  "583122": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Tekkalakota S.O"
  },
  "583123": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Toranagallu S.O"
  },
  "583125": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Arasikere S.O"
  },
  "583104": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Sanjay Gandhi Nagar S.O"
  },
  "305012": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Mss Hatundi S.O"
  },
  "673595": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Cheeral SO"
  },
  "673123": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Chundale SO"
  },
  "383240": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Bamna SO"
  },
  "752030": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Balugaon Bazar Nd S.O"
  },
  "144620": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "Sheikhupur SO Kapurthala"
  },
  "144606": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "Talwandi Chaudharian SO"
  },
  "144628": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "Thatha Jadid SO"
  },
  "583116": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Kurugodu S.O"
  },
  "583119": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Lakshmipura Sandur S.O"
  },
  "583120": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Sirigere S.O(Ballari)"
  },
  "125053": {
    "state": "HARYANA",
    "district": "FATEHABAD",
    "office": "Bhattu Kalan SO"
  },
  "182122": {
    "state": "JAMMU AND KASHMIR",
    "district": "UDHAMPUR",
    "office": "Ramnagar SO Udhampur"
  },
  "362310": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Vadal SO"
  },
  "583124": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Yeshwantnagar S.O(Ballari)"
  },
  "802316": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Sinha SO"
  },
  "574323": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Manchi S.O"
  },
  "574253": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Mani S.O"
  },
  "574228": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Mundaje S.O"
  },
  "125006": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "Hisar Cantt SO"
  },
  "125038": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "Khanda Kheri SO"
  },
  "125133": {
    "state": "HARYANA",
    "district": "FATEHABAD",
    "office": "Jakhal Mandi SO"
  },
  "144403": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "RANIPUR SO"
  },
  "144034": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Bundala SO Jalandhar"
  },
  "384135": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Brahmanwada SO"
  },
  "384520": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Gerita Kolavda RS SO"
  },
  "360006": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Rajkot Bhomeswar NDT SO"
  },
  "333042": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Nansagate Nawalgarh S.O"
  },
  "333041": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Nua S.O"
  },
  "333308": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Parasrampura S.O"
  },
  "333801": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Saraisurpura S.O"
  },
  "580009": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Dharwad Sattur S.O"
  },
  "580005": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Dharwad U A S S.O"
  },
  "580025": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Hubballi Navanagar S.O"
  },
  "442919": {
    "state": "MAHARASHTRA",
    "district": "GADCHIROLI",
    "office": "Mulchera SO"
  },
  "451001": {
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "office": "Khargone Tawnhall S.O"
  },
  "171003": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "AGPO SO"
  },
  "171225": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Baghi SO Shimla"
  },
  "171226": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Balag SO"
  },
  "171018": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Basanatpur SO"
  },
  "171220": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Bagain SO"
  },
  "171208": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Chirgaon SO Shimla"
  },
  "171211": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Chopal SO"
  },
  "171012": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Dhalli SO"
  },
  "171103": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Dhami SO"
  },
  "171209": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Fagu SO Shimla"
  },
  "171206": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Hatkoti SO"
  },
  "171019": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Jalog SO"
  },
  "171214": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Jangla SO"
  },
  "171205": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Jubbal SO"
  },
  "415019": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Angapur Vandan S.O"
  },
  "793004": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Laban S.O"
  },
  "793160": {
    "state": "MEGHALAYA",
    "district": "EAST JAINTIA HILLS",
    "office": "Ladrymbai S.O"
  },
  "793113": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Mawsynram S.O"
  },
  "393125": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Dehali SO"
  },
  "834010": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Namkum SO"
  },
  "171222": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Sandhu SO"
  },
  "171005": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Summerhill SO"
  },
  "673576": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Vythiri SO"
  },
  "673029": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Tiruvannur Nada SO"
  },
  "389380": {
    "state": "GUJARAT",
    "district": "DOHAD",
    "office": "Devgadh Baria SO"
  },
  "125112": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "Pabra SO"
  },
  "110038": {
    "state": "DELHI",
    "district": "NEW DELHI",
    "office": "A F Rajokari SO"
  },
  "110078": {
    "state": "DELHI",
    "district": "SOUTH WEST",
    "office": "GGSIP University S.O"
  },
  "388345": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Mogri SO"
  },
  "388210": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Ode SO"
  },
  "388360": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Samarkha SO"
  },
  "425416": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Khandbara S.O"
  },
  "425419": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Khapar S.O"
  },
  "425444": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Mandana S.O"
  },
  "425432": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Mhasawad S.O (Nandurbar)"
  },
  "425452": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Molgi S.O"
  },
  "425412": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Nandurbar Bazar S.O"
  },
  "171014": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Ghanahatti SO"
  },
  "131409": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Bhainswal Kalan SO"
  },
  "131302": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Butana SO"
  },
  "131039": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Engg College Muthal SO"
  },
  "131408": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Farmana SO"
  },
  "131101": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Ganaur City SO"
  },
  "131301": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Mini Sectt Gohana"
  },
  "131028": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Industrial Estate Kundli SO"
  },
  "131024": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Juan SO"
  },
  "362268": {
    "state": "GUJARAT",
    "district": "GIR SOMNATH",
    "office": "Prabhas Patan SO"
  },
  "360545": {
    "state": "GUJARAT",
    "district": "PORBANDAR",
    "office": "Adityana SO"
  },
  "122006": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Railwary Road SO"
  },
  "123034": {
    "state": "HARYANA",
    "district": "MAHENDRAGARH",
    "office": "Bawania SO"
  },
  "360035": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Lodhika SO"
  },
  "361230": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Balachadi SO"
  },
  "361140": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Digvijay Gram SO"
  },
  "360045": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Vasavad S.O"
  },
  "360055": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Vinchhiya SO"
  },
  "131022": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Bhatgaon SO Sonipat"
  },
  "131023": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Jakhauli SO"
  },
  "110020": {
    "state": "DELHI",
    "district": "SOUTH",
    "office": "Okhla Industrial Estate SO"
  },
  "361170": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Lalpur SO Jamnagar"
  },
  "361220": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Latipur SO"
  },
  "361162": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Nikava SO"
  },
  "360531": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Satapar S.O"
  },
  "361345": {
    "state": "GUJARAT",
    "district": "DEVBHUMI DWARKA",
    "office": "Mithapur SO Jamnagar"
  },
  "361325": {
    "state": "GUJARAT",
    "district": "DEVBHUMI DWARKA",
    "office": "Raval SO"
  },
  "361010": {
    "state": "GUJARAT",
    "district": "DEVBHUMI DWARKA",
    "office": "Vadinar SO"
  },
  "360515": {
    "state": "GUJARAT",
    "district": "DEVBHUMI DWARKA",
    "office": "Verad SO"
  },
  "184144": {
    "state": "JAMMU AND KASHMIR",
    "district": "KATHUA",
    "office": "Dialachak SO"
  },
  "184141": {
    "state": "JAMMU AND KASHMIR",
    "district": "SAMBA",
    "office": "Ghagwal SO"
  },
  "184142": {
    "state": "JAMMU AND KASHMIR",
    "district": "KATHUA",
    "office": "Hiranagar SO"
  },
  "184102": {
    "state": "JAMMU AND KASHMIR",
    "district": "KATHUA",
    "office": "Ie Kathua SO"
  },
  "184152": {
    "state": "JAMMU AND KASHMIR",
    "district": "KATHUA",
    "office": "Lakhanpur SO Kathua"
  },
  "184202": {
    "state": "JAMMU AND KASHMIR",
    "district": "KATHUA",
    "office": "Mahanpur SO"
  },
  "184104": {
    "state": "JAMMU AND KASHMIR",
    "district": "KATHUA",
    "office": "Mini Sectt Kathua SO"
  },
  "184151": {
    "state": "JAMMU AND KASHMIR",
    "district": "KATHUA",
    "office": "Parole SO"
  },
  "184145": {
    "state": "JAMMU AND KASHMIR",
    "district": "KATHUA",
    "office": "Rajpura SO Kathua"
  },
  "184148": {
    "state": "JAMMU AND KASHMIR",
    "district": "KATHUA",
    "office": "Sanjimore SO"
  },
  "180012": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Meghdoot Bhawan"
  },
  "182311": {
    "state": "JAMMU AND KASHMIR",
    "district": "REASI",
    "office": "District office Complex Reasi SO"
  },
  "182203": {
    "state": "JAMMU AND KASHMIR",
    "district": "DODA",
    "office": "Thathri SO"
  },
  "182221": {
    "state": "JAMMU AND KASHMIR",
    "district": "DODA",
    "office": "Udrana SO"
  },
  "125102": {
    "state": "HARYANA",
    "district": "SIRSA",
    "office": "Ellenabad SO"
  },
  "125103": {
    "state": "HARYANA",
    "district": "SIRSA",
    "office": "Goriwala SO"
  },
  "125201": {
    "state": "HARYANA",
    "district": "SIRSA",
    "office": "Kalanwali SO"
  },
  "573201": {
    "state": "KARNATAKA",
    "district": "HASSAN",
    "office": "Gandhibazar S.O (Hassan)"
  },
  "496334": {
    "state": "CHHATTISGARH",
    "district": "JASHPUR",
    "office": "Duldula SO"
  },
  "496242": {
    "state": "CHHATTISGARH",
    "district": "JASHPUR",
    "office": "Farsabahar SO"
  },
  "496338": {
    "state": "CHHATTISGARH",
    "district": "JASHPUR",
    "office": "Gholeng SO"
  },
  "382650": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Unava  Balva SO"
  },
  "110088": {
    "state": "DELHI",
    "district": "NORTH",
    "office": "Shalimar Bagh SO North West Delhi"
  },
  "110086": {
    "state": "DELHI",
    "district": "NORTH WEST",
    "office": "Sultanpuri F Block SO"
  },
  "110082": {
    "state": "DELHI",
    "district": "NORTH",
    "office": "Khera Kalan SO"
  },
  "110042": {
    "state": "DELHI",
    "district": "NORTH",
    "office": "Samai Pur SO"
  },
  "110084": {
    "state": "DELHI",
    "district": "CENTRAL",
    "office": "Sant Nagar SO"
  },
  "134008": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Durga Nagar S.O"
  },
  "134007": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Geeta Nagri S.O"
  },
  "382835": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Lodra SO"
  },
  "382855": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Pundhara SO"
  },
  "345001": {
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "office": "Jaisalmer Collectorate SO"
  },
  "756002": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Sunhat S.O"
  },
  "756085": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Chandaneswar S.O"
  },
  "756022": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Darada S.O"
  },
  "396191": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Vapi SO"
  },
  "394230": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Sachin SO"
  },
  "395007": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "SVR College SO"
  },
  "394107": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Amroli SO"
  },
  "173101": {
    "state": "HIMACHAL PRADESH",
    "district": "SIRMAUR",
    "office": "Rajgarh Siramur SO"
  },
  "173023": {
    "state": "HIMACHAL PRADESH",
    "district": "SIRMAUR",
    "office": "Sangrah SO"
  },
  "396220": {
    "state": "THE DADRA AND NAGAR HAVELI AND DAMAN AND DIU",
    "district": "DAMAN",
    "office": "Moti Daman SO"
  },
  "454774": {
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "office": "Pithampur Sector III S.O"
  },
  "394245": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Zervavra SO"
  },
  "394652": {
    "state": "GUJARAT",
    "district": "TAPI",
    "office": "Panwadi SO"
  },
  "175102": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Bhutti SO"
  },
  "175136": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Haripur SO Kullu"
  },
  "175143": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Jagatsukh SO"
  },
  "175105": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Jaree SO"
  },
  "175129": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Katrain SO"
  },
  "345027": {
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "office": "Fatehgarh SO"
  },
  "827010": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "BSCity RS SO"
  },
  "828134": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Chandan Kiyari SO"
  },
  "827013": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Garga Check Post SO"
  },
  "829301": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Jaina SO"
  },
  "827302": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Kasmar SO"
  },
  "828306": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Nawagarh SO Dhanbad"
  },
  "828201": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Baliapur SO"
  },
  "828101": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Bansjora SO"
  },
  "136117": {
    "state": "HARYANA",
    "district": "KAITHAL",
    "office": "Kalayat S.O"
  },
  "134118": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "Barwala S.O (Panchkula)"
  },
  "110033": {
    "state": "DELHI",
    "district": "NORTH",
    "office": "Adrash Nagar SO"
  },
  "752082": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Bahadajhola S.O"
  },
  "752089": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Banigochha S.O"
  },
  "752024": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Chandapur S.O (Nayagarh)"
  },
  "752084": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Daspalla S.O"
  },
  "126102": {
    "state": "HARYANA",
    "district": "JIND",
    "office": "Jind Punjabi Bazar S.O"
  },
  "577301": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Bhadravathi New Model Colony S.O"
  },
  "577245": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Barandur S.O"
  },
  "577243": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Anaveri S.O"
  },
  "173024": {
    "state": "HIMACHAL PRADESH",
    "district": "SIRMAUR",
    "office": "Sarahan SO"
  },
  "756028": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Rupsa S.O"
  },
  "828301": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Bhaga SO"
  },
  "828303": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Bhojudih SO"
  },
  "828302": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Bhowra SO"
  },
  "828202": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Chirkunda SO"
  },
  "175141": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Garsa SO"
  },
  "396130": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Maroli Sanjan SO"
  },
  "125104": {
    "state": "HARYANA",
    "district": "SIRSA",
    "office": "Dabwali Town SO"
  },
  "125077": {
    "state": "HARYANA",
    "district": "SIRSA",
    "office": "Odhan SO"
  },
  "125076": {
    "state": "HARYANA",
    "district": "SIRSA",
    "office": "Rania SO"
  },
  "125060": {
    "state": "HARYANA",
    "district": "SIRSA",
    "office": "Sikander Pur SO"
  },
  "125075": {
    "state": "HARYANA",
    "district": "SIRSA",
    "office": "Siri Jiwan Nagar SO"
  },
  "125058": {
    "state": "HARYANA",
    "district": "SIRSA",
    "office": "Ding SO"
  },
  "574203": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Nehrunagar(Puttur DK) S.O"
  },
  "574325": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Nekkilady(34) S.O"
  },
  "574229": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Nellyadi S.O"
  },
  "574230": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Nettana S.O"
  },
  "574231": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Panemangalore S.O"
  },
  "574232": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Panja S.O"
  },
  "389382": {
    "state": "GUJARAT",
    "district": "DOHAD",
    "office": "Dhanpur SO"
  },
  "389146": {
    "state": "GUJARAT",
    "district": "DOHAD",
    "office": "Dudhia SO"
  },
  "425418": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Navapur S.O"
  },
  "413510": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Murud S.O"
  },
  "388225": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Dakor SO"
  },
  "388335": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Kunjrav SO"
  },
  "424302": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Kusumba S.O"
  },
  "424311": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Mohadi Laling S.O"
  },
  "425404": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Nardana S.O"
  },
  "424318": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Naval Nagar S.O"
  },
  "424303": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Ner S.O"
  },
  "424305": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Nizampur S.O (Dhule)"
  },
  "388265": {
    "state": "GUJARAT",
    "district": "Mahisagar",
    "office": "Pandva SO"
  },
  "396235": {
    "state": "THE DADRA AND NAGAR HAVELI AND DAMAN AND DIU",
    "district": "DADRA AND NAGAR HAVELI",
    "office": "Naroli SO"
  },
  "396140": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Phansa SO"
  },
  "388235": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Timbana Muvada SO"
  },
  "184205": {
    "state": "JAMMU AND KASHMIR",
    "district": "KATHUA",
    "office": "Ramkot SO Kathua"
  },
  "361008": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Patel Colony SO"
  },
  "110095": {
    "state": "DELHI",
    "district": "SHAHDARA",
    "office": "GTB Hospital SO"
  },
  "110096": {
    "state": "DELHI",
    "district": "EAST",
    "office": "Mayur Vihar PhIII SO"
  },
  "384515": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Gavada SO"
  },
  "143102": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Ajnala SO"
  },
  "582202": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Belvanki S.O"
  },
  "586129": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Tangadgi S.O"
  },
  "151103": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Rampura Mandi SO"
  },
  "151108": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Salabatpura SO"
  },
  "151401": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Sangat SO"
  },
  "194101": {
    "state": "LADAKH",
    "district": "LEH LADAKH",
    "office": "Leh City S.O"
  },
  "194104": {
    "state": "LADAKH",
    "district": "LEH LADAKH",
    "office": "Chuglamsar S.O"
  },
  "194107": {
    "state": "LADAKH",
    "district": "LEH LADAKH",
    "office": "SASPOL S.O"
  },
  "194401": {
    "state": "LADAKH",
    "district": "LEH LADAKH",
    "office": "Diskit S.O"
  },
  "194103": {
    "state": "LADAKH",
    "district": "KARGIL",
    "office": "Kargil S.O"
  },
  "194102": {
    "state": "LADAKH",
    "district": "KARGIL",
    "office": "Drass S.O"
  },
  "586215": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Tamba S.O"
  },
  "586216": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Telgi S.O"
  },
  "795138": {
    "state": "MANIPUR",
    "district": "THOUBAL",
    "office": "Thoubal S.O"
  },
  "173029": {
    "state": "HIMACHAL PRADESH",
    "district": "SIRMAUR",
    "office": "Sataun SO"
  },
  "173027": {
    "state": "HIMACHAL PRADESH",
    "district": "SIRMAUR",
    "office": "Shillai SO"
  },
  "173031": {
    "state": "HIMACHAL PRADESH",
    "district": "SIRMAUR",
    "office": "Dhualakuan"
  },
  "173032": {
    "state": "HIMACHAL PRADESH",
    "district": "SIRMAUR",
    "office": "Haripurdhar"
  },
  "173212": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "RR Solan SO"
  },
  "173208": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Arki SO"
  },
  "173205": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Baddi SO"
  },
  "173217": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Chail SO Solan"
  },
  "171009": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Kasumpti SO"
  },
  "491665": {
    "state": "CHHATTISGARH",
    "district": "RAJNANDGAON",
    "office": "Ambagarh Chowki SO"
  },
  "795115": {
    "state": "MANIPUR",
    "district": "JIRIBAM",
    "office": "Gularthol S.O"
  },
  "396430": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Kharel SO"
  },
  "396436": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Maroli Bazar SO"
  },
  "396460": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Panar SO"
  },
  "396466": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Satem SO"
  },
  "396463": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Sisodra SO"
  },
  "800020": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "KSector SO"
  },
  "382640": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Sardhav SO"
  },
  "382721": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Kalol Gandhi Road SO"
  },
  "396170": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Umargam SO"
  },
  "396030": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Hanuman Bhagda SO"
  },
  "424119": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "C.T. Mill Road S.O"
  },
  "425002": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "M.J.College Jalgaon S.O"
  },
  "425402": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Marwad S.O"
  },
  "425116": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Mhasawad S.O (Jalgaon)"
  },
  "425115": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Nandra Pachora S.O"
  },
  "425103": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Paldhi S.O"
  },
  "389172": {
    "state": "GUJARAT",
    "district": "DOHAD",
    "office": "Fatepura SO Dahod"
  },
  "793119": {
    "state": "MEGHALAYA",
    "district": "WEST KHASI HILLS",
    "office": "Nongstoin S.O"
  },
  "793126": {
    "state": "MEGHALAYA",
    "district": "WEST KHASI HILLS",
    "office": "Riangdo Bazar S.O"
  },
  "794115": {
    "state": "MEGHALAYA",
    "district": "SOUTH WEST GARO HILLS",
    "office": "Ampati S.O"
  },
  "794102": {
    "state": "MEGHALAYA",
    "district": "SOUTH GARO HILLS",
    "office": "Baghmara S.O"
  },
  "793012": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Mawpat S.O"
  },
  "793022": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Nehu S.O"
  },
  "841217": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Nayagaon SO"
  },
  "854327": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Jalalgarh SO"
  },
  "574234": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Sampaje S.O"
  },
  "574235": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Sathya Sai Vihar S.O"
  },
  "574237": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Siddakatte S.O"
  },
  "591102": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Bailhongal H.O"
  },
  "591104": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Belvadi S.O"
  },
  "591147": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Deshnur S.O"
  },
  "793009": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Nonglyer S.O"
  },
  "793151": {
    "state": "MEGHALAYA",
    "district": "WEST JAINTIA HILLS",
    "office": "Thadlaskein S.O"
  },
  "793161": {
    "state": "MEGHALAYA",
    "district": "WEST JAINTIA HILLS",
    "office": "Amlarem S.O"
  },
  "425104": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Pimpri Khurd S.O"
  },
  "345034": {
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "office": "Khoohri SO"
  },
  "345031": {
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "office": "Lathi SO Jaisalmer"
  },
  "345033": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Mohangarh SO Jaisalmer"
  },
  "756044": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Gopalpur S.O (Balasore)"
  },
  "756027": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Haldipada S.O"
  },
  "756048": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Khaira S.O (Baleswar)"
  },
  "756043": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Khantapada S.O"
  },
  "756059": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Kupari S.O"
  },
  "181206": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Dumana SO"
  },
  "388230": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Kalsar SO"
  },
  "413523": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Kingaon S.O"
  },
  "445302": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Akhada Ward(Pandharkawada) S.O"
  },
  "445306": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Parwa S.O"
  },
  "445305": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Patanbori S.O"
  },
  "445204": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Pusad S.O"
  },
  "445402": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Ralegaon S.O"
  },
  "445307": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Sindhola Mines S.O"
  },
  "445215": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Soot Girni S.O"
  },
  "756056": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Kuruda S.O"
  },
  "756020": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Mitrapur S.O"
  },
  "756003": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Motiganj S.O (Baleswar)"
  },
  "756049": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Oupada S.O"
  },
  "756058": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Raj Berhampur S.O"
  },
  "756040": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Nilgiri College S.O"
  },
  "756021": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Rasalpur S.O"
  },
  "756019": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Remuna S.O"
  },
  "756041": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Sajanagarh S.O"
  },
  "756025": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Chandipur S.O"
  },
  "345024": {
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "office": "Bhaniyana SO"
  },
  "482001": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Napier Town S.O"
  },
  "482004": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Kanchanpur S.O (Jabalpur)"
  },
  "794106": {
    "state": "MEGHALAYA",
    "district": "SOUTH WEST GARO HILLS",
    "office": "Mahendraganj S.O (West Garo Hills)"
  },
  "794107": {
    "state": "MEGHALAYA",
    "district": "SOUTH GARO HILLS",
    "office": "Nangwalbibra S.O"
  },
  "591109": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Hirebagewadi S.O"
  },
  "591111": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Hosur S.O (Belagavi)"
  },
  "345028": {
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "office": "Nachana SO"
  },
  "490024": {
    "state": "CHHATTISGARH",
    "district": "DURG",
    "office": "Jamul Cement Works SO"
  },
  "591112": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Itagi S.O"
  },
  "148025": {
    "state": "PUNJAB",
    "district": "SANGRUR",
    "office": "Sherpur SO"
  },
  "148028": {
    "state": "PUNJAB",
    "district": "SANGRUR",
    "office": "Sunam Kty S.O"
  },
  "574238": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Subramanya S.O"
  },
  "574239": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Sullia S.O"
  },
  "574241": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Uppinangady S.O"
  },
  "574324": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Vamadapadavu S.O"
  },
  "574243": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Vittal S.O"
  },
  "574265": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Vogga S.O"
  },
  "574274": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kallamundkur S.O"
  },
  "802210": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Udawant Nagar SO"
  },
  "802166": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Umraonganj SO"
  },
  "445206": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Umarkhed S.O"
  },
  "445308": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Wadki S.O"
  },
  "466651": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Shyampur S.O (Sehore)"
  },
  "177114": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Bankhandi SO"
  },
  "177103": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Dhaliara SO"
  },
  "177108": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Garli SO"
  },
  "176033": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Guler SO"
  },
  "396150": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Sanjan SO"
  },
  "396385": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Untdi SO"
  },
  "176031": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Jawalamukhi SO"
  },
  "176030": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Khundian SO"
  },
  "424310": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Kasara S.O (Dhule)"
  },
  "172104": {
    "state": "HIMACHAL PRADESH",
    "district": "KINNAUR",
    "office": "Tapri SO"
  },
  "793102": {
    "state": "MEGHALAYA",
    "district": "RI BHOI",
    "office": "Nongpoh S.O"
  },
  "793103": {
    "state": "MEGHALAYA",
    "district": "RI BHOI",
    "office": "Umiam S.O"
  },
  "793116": {
    "state": "MEGHALAYA",
    "district": "RI BHOI",
    "office": "Bhoirymbong S.O"
  },
  "794101": {
    "state": "MEGHALAYA",
    "district": "WEST GARO HILLS",
    "office": "Araimile S.O"
  },
  "794103": {
    "state": "MEGHALAYA",
    "district": "WEST GARO HILLS",
    "office": "Barengapara S.O"
  },
  "794005": {
    "state": "MEGHALAYA",
    "district": "WEST GARO HILLS",
    "office": "Dobasipara S.O"
  },
  "794104": {
    "state": "MEGHALAYA",
    "district": "WEST GARO HILLS",
    "office": "Fulbari S.O (West Garo Hills)"
  },
  "794105": {
    "state": "MEGHALAYA",
    "district": "WEST GARO HILLS",
    "office": "Garobadha S.O"
  },
  "794002": {
    "state": "MEGHALAYA",
    "district": "WEST GARO HILLS",
    "office": "Lower Chandmari S.O"
  },
  "802112": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Brahampur SO"
  },
  "591106": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Bidi S.O"
  },
  "148109": {
    "state": "PUNJAB",
    "district": "BARNALA",
    "office": "Sanghera SO"
  },
  "148103": {
    "state": "PUNJAB",
    "district": "BARNALA",
    "office": "Shaina SO"
  },
  "148100": {
    "state": "PUNJAB",
    "district": "BARNALA",
    "office": "Tallewal SO"
  },
  "148108": {
    "state": "PUNJAB",
    "district": "BARNALA",
    "office": "Tapa SO"
  },
  "802111": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Arak SO"
  },
  "802102": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Buxar Jail SO"
  },
  "793104": {
    "state": "MEGHALAYA",
    "district": "RI BHOI",
    "office": "Sumer S.O"
  },
  "793105": {
    "state": "MEGHALAYA",
    "district": "RI BHOI",
    "office": "Umsning S.O"
  },
  "193502": {
    "state": "JAMMU AND KASHMIR",
    "district": "BANDIPORA",
    "office": "Bandipora S.O"
  },
  "193505": {
    "state": "JAMMU AND KASHMIR",
    "district": "BANDIPORA",
    "office": "Aloosa S.O"
  },
  "841225": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Pratappur SO Saran"
  },
  "841301": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Mauna SO"
  },
  "423502": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Abhona S.O"
  },
  "423402": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Andarsul S.O"
  },
  "423101": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Chandwad S.O"
  },
  "423201": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Dabhadi S.O"
  },
  "423102": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Devla S.O"
  },
  "182126": {
    "state": "JAMMU AND KASHMIR",
    "district": "UDHAMPUR",
    "office": "Roan SO"
  },
  "182145": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAMBAN",
    "office": "Ramsu SO"
  },
  "394520": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Variav SO"
  },
  "171004": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Ambedkarchowk SO"
  },
  "754018": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Bramhansailo S.O"
  },
  "754001": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Fulnakhara S.O"
  },
  "754003": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Govindpur S.O (Cuttack)"
  },
  "754105": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Kasarda S.O"
  },
  "754002": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Sundargram S.O"
  },
  "754206": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "MAHANGA S.O"
  },
  "754209": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "ASURESWAR S.O"
  },
  "796184": {
    "state": "MIZORAM",
    "district": "SERCHHIP",
    "office": "N. Vanlaiphai S.O"
  },
  "796161": {
    "state": "MIZORAM",
    "district": "AIZAWL",
    "office": "Thingsulthliah S.O"
  },
  "796091": {
    "state": "MIZORAM",
    "district": "KOLASIB",
    "office": "Bilkhawthlir S.O"
  },
  "796017": {
    "state": "MIZORAM",
    "district": "AIZAWL",
    "office": "Zemabawk S.O"
  },
  "796186": {
    "state": "MIZORAM",
    "district": "SERCHHIP",
    "office": "Thenzawl S.O"
  },
  "796009": {
    "state": "MIZORAM",
    "district": "AIZAWL",
    "office": "Vaivakawn S.O"
  },
  "193303": {
    "state": "JAMMU AND KASHMIR",
    "district": "BARAMULLA",
    "office": "Dangiwacha S.O"
  },
  "193503": {
    "state": "JAMMU AND KASHMIR",
    "district": "BANDIPORA",
    "office": "Gurez S.O"
  },
  "193221": {
    "state": "JAMMU AND KASHMIR",
    "district": "KUPWARA",
    "office": "Handwara S.O"
  },
  "193222": {
    "state": "JAMMU AND KASHMIR",
    "district": "KUPWARA",
    "office": "Kupwara S.O"
  },
  "193302": {
    "state": "JAMMU AND KASHMIR",
    "district": "KUPWARA",
    "office": "Langate S.O"
  },
  "796101": {
    "state": "MIZORAM",
    "district": "KOLASIB",
    "office": "Vairengte S.O"
  },
  "796691": {
    "state": "MIZORAM",
    "district": "LUNGLEI",
    "office": "Zotlang S.O"
  },
  "796470": {
    "state": "MIZORAM",
    "district": "MAMIT",
    "office": "Kawrthah S.O"
  },
  "841409": {
    "state": "BIHAR",
    "district": "GOPALGANJ",
    "office": "Dighwdubauli SO"
  },
  "574259": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Panaje S.O"
  },
  "574240": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "S.D.M.C.Ujire S.O"
  },
  "394641": {
    "state": "GUJARAT",
    "district": "TAPI",
    "office": "Vedchhi SO"
  },
  "802115": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Chaugai SO"
  },
  "802114": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Chausa SO Buxar"
  },
  "802116": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Churamanpur SO"
  },
  "802117": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Dhansoi SO"
  },
  "802118": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Dulahpur SO"
  },
  "802122": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Hitawarajpur SO"
  },
  "802123": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Itarhi SO"
  },
  "802125": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Kesath SO"
  },
  "802126": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Koran Sarai SO"
  },
  "802128": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Manoharpur SO Buxar"
  },
  "802129": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Nawanagar SO Buxar"
  },
  "802131": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Niazipur SO"
  },
  "802130": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Nimej SO"
  },
  "444511": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Alegaon S.O"
  },
  "444507": {
    "state": "MAHARASHTRA",
    "district": "WASHIM",
    "office": "Ansing S.O"
  },
  "465001": {
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "office": "Shajapur Kutchery S.O"
  },
  "465223": {
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "office": "Akodia S.O"
  },
  "465226": {
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "office": "Barodia Kumaria S.O"
  },
  "802133": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Purana Bhojpur SO"
  },
  "754007": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Dompara S.O"
  },
  "754009": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Kalapathar S.O"
  },
  "574233": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Punjalkatte S.O"
  },
  "465335": {
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "office": "Jamner S.O (Shajapur)"
  },
  "465337": {
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "office": "Kalapipal S.O"
  },
  "444302": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Balapur S.O"
  },
  "444401": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Barshitakli S.O"
  },
  "444102": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Borgaon Manju S.O"
  },
  "444110": {
    "state": "MAHARASHTRA",
    "district": "WASHIM",
    "office": "Kamargaon S.O (Washim)"
  },
  "444105": {
    "state": "MAHARASHTRA",
    "district": "WASHIM",
    "office": "Gurumandir Karanja S.O"
  },
  "444405": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Mahan S.O"
  },
  "444503": {
    "state": "MAHARASHTRA",
    "district": "WASHIM",
    "office": "Malegaon S.O"
  },
  "577527": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Hosadurga S.O"
  },
  "802119": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Dumraon SO"
  },
  "802136": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Dumraon Textiles SO"
  },
  "444106": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Mana S.O"
  },
  "754203": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "KENDUPATNA S.O"
  },
  "754006": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Mundali Colony S.O"
  },
  "754004": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Niali S.O"
  },
  "444403": {
    "state": "MAHARASHTRA",
    "district": "WASHIM",
    "office": "Mangrulpir S.O"
  },
  "444409": {
    "state": "MAHARASHTRA",
    "district": "WASHIM",
    "office": "Asegaon S.O"
  },
  "444111": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Dahihanda S.O"
  },
  "444004": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Kaulkhed S.O"
  },
  "444103": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Hiwarkhed Ruprao S.O"
  },
  "444104": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Krishinagar Akola S.O"
  },
  "797115": {
    "state": "NAGALAND",
    "district": "DIMAPUR",
    "office": "Artc S.O"
  },
  "798618": {
    "state": "NAGALAND",
    "district": "MOKOKCHUNG",
    "office": "Tuli S.O"
  },
  "797105": {
    "state": "NAGALAND",
    "district": "KOHIMA",
    "office": "Chiechama S.O"
  },
  "798620": {
    "state": "NAGALAND",
    "district": "ZUNHEBOTO",
    "office": "Zunheboto S.O"
  },
  "798603": {
    "state": "NAGALAND",
    "district": "MON",
    "office": "Champang S.O"
  },
  "797108": {
    "state": "NAGALAND",
    "district": "PHEK",
    "office": "Phek S.O"
  },
  "797104": {
    "state": "NAGALAND",
    "district": "PHEK",
    "office": "Chozuba S.O"
  },
  "491338": {
    "state": "CHHATTISGARH",
    "district": "BEMETARA",
    "office": "Khamaria SO Durg"
  },
  "444404": {
    "state": "MAHARASHTRA",
    "district": "WASHIM",
    "office": "Manora S.O (Washim)"
  },
  "444107": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Murtizapur S.O"
  },
  "444117": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Mundgaon S.O"
  },
  "444311": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Nimba S.O"
  },
  "444501": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Patur S.O"
  },
  "465441": {
    "state": "MADHYA PRADESH",
    "district": "AGAR MALWA",
    "office": "Agar Malwa S.O"
  },
  "465230": {
    "state": "MADHYA PRADESH",
    "district": "AGAR MALWA",
    "office": "Kanad S.O"
  },
  "797107": {
    "state": "NAGALAND",
    "district": "PHEK",
    "office": "Pfutsero S.O"
  },
  "852106": {
    "state": "BIHAR",
    "district": "SAHARSA",
    "office": "Chapraon SO"
  },
  "852107": {
    "state": "BIHAR",
    "district": "SAHARSA",
    "office": "Dhabauli SO"
  },
  "852105": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Bhaptiyahi Bazar SO"
  },
  "852114": {
    "state": "BIHAR",
    "district": "MADHEPURA",
    "office": "Budhma SO"
  },
  "854340": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Birpur SO Supaul"
  },
  "852213": {
    "state": "BIHAR",
    "district": "MADHEPURA",
    "office": "Chausa SO Madhepura"
  },
  "465445": {
    "state": "MADHYA PRADESH",
    "district": "AGAR MALWA",
    "office": "Nalkheda S.O"
  },
  "465220": {
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "office": "Kalisindh S.O"
  },
  "454001": {
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "office": "Dhar Collectorate S.O"
  },
  "465550": {
    "state": "MADHYA PRADESH",
    "district": "AGAR MALWA",
    "office": "Barode S.O"
  },
  "122051": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Nsg Camp Manesar SO"
  },
  "802127": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Murar SO"
  },
  "577529": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Kondlahalli S.O"
  },
  "577531": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Malladihalli S.O"
  },
  "577554": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Mallappanahalli S.O"
  },
  "577532": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Maradihalli S.O"
  },
  "577533": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Mathodu S.O"
  },
  "577535": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Molakalmuru S.O"
  },
  "577536": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Nayakanahatti S.O"
  },
  "802113": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Barkarajpur SO"
  },
  "802103": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Buxar Gajadhar Ganj SO"
  },
  "445304": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Wani S.O"
  },
  "754204": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "KUANPAL S.O"
  },
  "754293": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Lemalo S.O"
  },
  "754207": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "NISCHINTAKOILI S.O"
  },
  "754202": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "SALIPUR S.O"
  },
  "754221": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "SUNGRA S.O"
  },
  "586111": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Agarkhed S.O"
  },
  "586201": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Almatti  Damsite S.O"
  },
  "586202": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Almel S.O"
  },
  "586112": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Atharga S.O"
  },
  "586113": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Bableshwar S.O"
  },
  "415122": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Wing S.O"
  },
  "445106": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Sawali Sadoba S.O"
  },
  "415515": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Bhuinj S.O"
  },
  "835302": {
    "state": "JHARKHAND",
    "district": "LOHARDAGA",
    "office": "Lohardaga Bazar SO"
  },
  "835232": {
    "state": "JHARKHAND",
    "district": "GUMLA",
    "office": "Nawagarh SO Gumla"
  },
  "822119": {
    "state": "JHARKHAND",
    "district": "LATEHAR",
    "office": "Mahuwadand SO"
  },
  "415536": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Kenjal S.O"
  },
  "193109": {
    "state": "JAMMU AND KASHMIR",
    "district": "BARAMULLA",
    "office": "WAGOORA S.O"
  },
  "193103": {
    "state": "JAMMU AND KASHMIR",
    "district": "BARAMULLA",
    "office": "Khawaja Bagh S.O"
  },
  "193108": {
    "state": "JAMMU AND KASHMIR",
    "district": "BARAMULLA",
    "office": "Kreeri S.O"
  },
  "364135": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Pithalpur SO"
  },
  "364250": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Songadh SO"
  },
  "174315": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Mehatpur SO Una"
  },
  "177210": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Nehri Nauranga SO"
  },
  "177207": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Pandogha SO"
  },
  "177209": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Saloh SO"
  },
  "174301": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Santokhgarh SO"
  },
  "465110": {
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "office": "Berchha S.O"
  },
  "176036": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Kohala SO"
  },
  "177034": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Pirsaluhi SO"
  },
  "177111": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Qusba Kotla SO"
  },
  "177043": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Rakkar SO"
  },
  "176501": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Sansarpur Terrace SO"
  },
  "177105": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Thore SO"
  },
  "177112": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Tipri SO"
  },
  "176001": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Kangra HO"
  },
  "176054": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Baroh SO"
  },
  "176021": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Bharmar SO"
  },
  "176038": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Daulatpur SO Kangra"
  },
  "176025": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Dhameta SO"
  },
  "176209": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Gaggal SO"
  },
  "176023": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Jawali SO"
  },
  "802120": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Dumari SO Buxar"
  },
  "465106": {
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "office": "Maksi S.O"
  },
  "465116": {
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "office": "Polai Kalan S.O"
  },
  "465227": {
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "office": "Salsalai S.O"
  },
  "465333": {
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "office": "Shujalpur  City S.O"
  },
  "176314": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Sultanpur SO"
  },
  "176312": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Sundla SO"
  },
  "793018": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Neigrihms S.O"
  },
  "794108": {
    "state": "MEGHALAYA",
    "district": "NORTH GARO HILLS",
    "office": "Resubelpara S.O"
  },
  "794110": {
    "state": "MEGHALAYA",
    "district": "EAST GARO HILLS",
    "office": "Rongjeng S.O"
  },
  "171102": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Darla SO"
  },
  "177213": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Gondpur Banera SO"
  },
  "177220": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Haroli SO"
  },
  "174308": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Lathiani SO"
  },
  "174319": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Marwari SO"
  },
  "177208": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Panjawar SO"
  },
  "174503": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Pubowal SO"
  },
  "177039": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Sohari SO"
  },
  "174321": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Thanakalan SO"
  },
  "177211": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Thathal SO"
  },
  "173209": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Dharampur SO Solan"
  },
  "173221": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Domehar SO"
  },
  "173225": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Jubbar SO"
  },
  "173229": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Kumarhatti SO"
  },
  "173207": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Kunihar SO"
  },
  "394326": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Vav Kathodara SO"
  },
  "441104": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Mauda S.O"
  },
  "396135": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Nargol SO"
  },
  "396195": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Vapi IE SO"
  },
  "465339": {
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "office": "Khokra Kalan S.O"
  },
  "174101": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Nalagarh SO"
  },
  "173223": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Oachghat SO"
  },
  "177206": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Oel SO Una"
  },
  "174507": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Tahliwal SO"
  },
  "577213": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Channnagiri Town S.O"
  },
  "384130": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Kahoda SO"
  },
  "844506": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Mahnar SO"
  },
  "843110": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Kumar Bajitpur SO"
  },
  "844121": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Lalganj Vaishali SO"
  },
  "844507": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Mahnar Road Rs SO"
  },
  "176047": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Nagrota Bagwan SO"
  },
  "176027": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Nagrota Surian SO"
  },
  "176208": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Rait SO"
  },
  "466120": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Siddikganj S.O"
  },
  "177106": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Dadasiba SO"
  },
  "176502": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Ghamroor SO"
  },
  "176028": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Haripur SO"
  },
  "177117": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Muhal SO"
  },
  "177104": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Nehran Pukhar SO"
  },
  "835230": {
    "state": "JHARKHAND",
    "district": "GUMLA",
    "office": "Noadih SO"
  },
  "835220": {
    "state": "JHARKHAND",
    "district": "GUMLA",
    "office": "Palkot SO"
  },
  "835223": {
    "state": "JHARKHAND",
    "district": "SIMDEGA",
    "office": "Simdega SO"
  },
  "835226": {
    "state": "JHARKHAND",
    "district": "SIMDEGA",
    "office": "Thethaitangar SO"
  },
  "193122": {
    "state": "JAMMU AND KASHMIR",
    "district": "BARAMULLA",
    "office": "Boniyar S.O"
  },
  "193121": {
    "state": "JAMMU AND KASHMIR",
    "district": "BARAMULLA",
    "office": "Pattan S.O"
  },
  "793115": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Sohiong S.O"
  },
  "835202": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Bero SO"
  },
  "835205": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Brambe SO"
  },
  "835301": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Itki SO"
  },
  "834006": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Ranchi Veterinary College SO"
  },
  "181202": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Jourian SO"
  },
  "577537": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Obalapura S.O"
  },
  "577538": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Parasurampura S.O"
  },
  "577539": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Ramagiri S.O (Chitradurga)"
  },
  "571313": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Zilla Adalitha Bhavan S.O"
  },
  "571439": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Hanur S.O"
  },
  "571127": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Haradanahalli S.O"
  },
  "571117": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Kagalavadi S.O"
  },
  "571443": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Kamakerai S.O"
  },
  "571442": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Mamballi S.O"
  },
  "571444": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Ramapuram Ghat S.O"
  },
  "571342": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Ramasamudra S.O (Chamrajnagar)"
  },
  "571124": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "T Narasipura S.O"
  },
  "571441": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Yelandur S.O"
  },
  "181221": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Jagti Migrant Township S.O"
  },
  "181203": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Khour SO"
  },
  "181121": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Paloura SO"
  },
  "181207": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Pargwal SO"
  },
  "180002": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Talab Tillo SO"
  },
  "184206": {
    "state": "JAMMU AND KASHMIR",
    "district": "KATHUA",
    "office": "Bani SO Kathua"
  },
  "184143": {
    "state": "JAMMU AND KASHMIR",
    "district": "KATHUA",
    "office": "Barwal SO"
  },
  "184201": {
    "state": "JAMMU AND KASHMIR",
    "district": "KATHUA",
    "office": "Basoli SO"
  },
  "193402": {
    "state": "JAMMU AND KASHMIR",
    "district": "BARAMULLA",
    "office": "Tangmarg SO"
  },
  "184204": {
    "state": "JAMMU AND KASHMIR",
    "district": "KATHUA",
    "office": "Billawar SO"
  },
  "143108": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Attari Rd Check Post SO"
  },
  "143202": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Baba Bakala SO"
  },
  "143203": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Butala SO"
  },
  "143201": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Beas SO"
  },
  "143103": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Chamiari SO"
  },
  "802209": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Tarari SO"
  },
  "571110": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Gargeshwari S.O"
  },
  "571120": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Old Sosale S.O"
  },
  "586204": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Bardol S.O (Vijayapura(KAR))"
  },
  "586203": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Basavan Bagewadi S.O"
  },
  "586108": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Vijayapura Amc S.O"
  },
  "583285": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Hiresindogi S.O"
  },
  "583238": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Bhagyanagar S.O (Koppal)"
  },
  "585227": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Mannakhelli S.O"
  },
  "585419": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Matala S.O"
  },
  "126111": {
    "state": "HARYANA",
    "district": "JIND",
    "office": "Alewa S.O"
  },
  "756134": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Ada S.O"
  },
  "132115": {
    "state": "HARYANA",
    "district": "PANIPAT",
    "office": "Hathwala S.O"
  },
  "585445": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "KOHINOOR SO"
  },
  "585437": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Mudbi S.O"
  },
  "585443": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Mudhol (B) S.O"
  },
  "585444": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Nittur S.O"
  },
  "585331": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Rajeshwar S.O"
  },
  "585421": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Santhpur S.O"
  },
  "585436": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Thanna Kushnoor S.O"
  },
  "829208": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Mc Cluskiganj SO"
  },
  "177107": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Pragpur SO"
  },
  "176032": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Tihri SO"
  },
  "176053": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Fatehpur SO Kangra"
  },
  "586209": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Indi S.O"
  },
  "586205": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Chadchan S.O"
  },
  "586104": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Vijayapura Railway Station S.O"
  },
  "586103": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "B.L.D.E.A Campus SO"
  },
  "586114": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Bijjargi S.O"
  },
  "586206": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Devangaon S.O"
  },
  "586115": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Devar Hippargi S.O"
  },
  "752017": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Kanas S.O"
  },
  "180017": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Majeen SO"
  },
  "181204": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Pallanwala SO"
  },
  "361310": {
    "state": "GUJARAT",
    "district": "DEVBHUMI DWARKA",
    "office": "Salaya SO"
  },
  "686102": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Perunna SO"
  },
  "686103": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Vazhappally West SO"
  },
  "176026": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Lanj SO"
  },
  "833214": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "Hatgamaria SO"
  },
  "752002": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Puri Station Road S.O"
  },
  "752014": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Sakhigopal S.O"
  },
  "752046": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Satasankha S.O"
  },
  "583278": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Dotihal S.O"
  },
  "583227": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Gangavati Julynagar S.O"
  },
  "583228": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Ginigera S.O"
  },
  "583281": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Hanamsagar S.O"
  },
  "583280": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Hanumanhal S.O"
  },
  "767019": {
    "state": "ODISHA",
    "district": "SONEPUR",
    "office": "Binka S.O"
  },
  "822122": {
    "state": "JHARKHAND",
    "district": "PALAMU",
    "office": "Panki SO Palamau"
  },
  "822110": {
    "state": "JHARKHAND",
    "district": "PALAMU",
    "office": "Raj Chainpur SO"
  },
  "835224": {
    "state": "JHARKHAND",
    "district": "GUMLA",
    "office": "Sisai SO Gumla"
  },
  "835233": {
    "state": "JHARKHAND",
    "district": "GUMLA",
    "office": "Toto SO"
  },
  "756115": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "B T Pur S.O"
  },
  "148023": {
    "state": "PUNJAB",
    "district": "MALERKOTLA",
    "office": "Malerkotla SO"
  },
  "148019": {
    "state": "PUNJAB",
    "district": "MALERKOTLA",
    "office": "Jitwal Kalan SO"
  },
  "148106": {
    "state": "PUNJAB",
    "district": "BARNALA",
    "office": "Longowal SO"
  },
  "148104": {
    "state": "PUNJAB",
    "district": "BARNALA",
    "office": "Mehal Kalan SO"
  },
  "148020": {
    "state": "PUNJAB",
    "district": "MALERKOTLA",
    "office": "Sandhaur SO"
  },
  "571122": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Talakad S.O"
  },
  "577526": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Holalkere S.O"
  },
  "829204": {
    "state": "JHARKHAND",
    "district": "LATEHAR",
    "office": "Chhipadohar SO"
  },
  "834002": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Ashok Nagar SO Ranchi"
  },
  "793005": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Upper Shillong S.O"
  },
  "389160": {
    "state": "GUJARAT",
    "district": "DOHAD",
    "office": "Freelandganj SO"
  },
  "445002": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Zillla Parishad (Yavatmal) S.O"
  },
  "445324": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Zari Jamni S.O"
  },
  "389155": {
    "state": "GUJARAT",
    "district": "DOHAD",
    "office": "Garbada SO"
  },
  "389152": {
    "state": "GUJARAT",
    "district": "DOHAD",
    "office": "Jesawada SO"
  },
  "389170": {
    "state": "GUJARAT",
    "district": "DOHAD",
    "office": "Jhalod SO"
  },
  "389250": {
    "state": "GUJARAT",
    "district": "Mahisagar",
    "office": "Diwda Colony SO"
  },
  "799143": {
    "state": "TRIPURA",
    "district": "South Tripura",
    "office": "Manubazar S.O"
  },
  "799115": {
    "state": "TRIPURA",
    "district": "Sepahijala",
    "office": "Melaghar S.O"
  },
  "799145": {
    "state": "TRIPURA",
    "district": "South Tripura",
    "office": "Sabroom S.O"
  },
  "799144": {
    "state": "TRIPURA",
    "district": "South Tripura",
    "office": "Santirbazar S.O"
  },
  "362222": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Agatrai SO"
  },
  "360421": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Moti Marad SO"
  },
  "360430": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Patanvav SO"
  },
  "396439": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Matvad SO"
  },
  "414005": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Ahmednagar R.S. S.O"
  },
  "414305": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Alkuti S.O"
  },
  "333012": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Titanwar S.O"
  },
  "144526": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Mehandpur SO"
  },
  "144525": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Sahiba SO"
  },
  "144417": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Aur SO"
  },
  "144505": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Banga SO"
  },
  "413702": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Belwandi S.O"
  },
  "414503": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Bodhegaon S.O"
  },
  "414201": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Chichondi Patil S.O"
  },
  "414607": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Ghodegaon S.O (Ahmed Nagar)"
  },
  "173235": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Dhundan SO"
  },
  "414002": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Ahmednagar Camp S.O"
  },
  "577204": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Marketyard APMC Shivamogga S.O"
  },
  "577425": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Nagara Shimoga SO"
  },
  "828307": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Nudkhurkee SO"
  },
  "829205": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Khalari SO"
  },
  "413601": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Tuljapur S.O"
  },
  "413503": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Vashi S.O (Osmanabad)"
  },
  "413405": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Yedshi S.O"
  },
  "413525": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Yermala S.O"
  },
  "767018": {
    "state": "ODISHA",
    "district": "SONEPUR",
    "office": "Birmaharajpur S.O"
  },
  "767023": {
    "state": "ODISHA",
    "district": "SONEPUR",
    "office": "Dungripali S.O"
  },
  "587204": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Kaladgi S.O"
  },
  "587301": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Jamkhandi  B.S.R. S.O"
  },
  "587117": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Galagali S.O"
  },
  "587119": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Hunnur S.O"
  },
  "587122": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Lokapur S.O"
  },
  "587312": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Mahalingpur S.O"
  },
  "587313": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Mudhol Extension S.O"
  },
  "587314": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Rabkavi Town S.O"
  },
  "587330": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Savalagi S.O"
  },
  "587315": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Terdal S.O"
  },
  "829207": {
    "state": "JHARKHAND",
    "district": "LATEHAR",
    "office": "Latehar Rsso SO"
  },
  "388260": {
    "state": "GUJARAT",
    "district": "Mahisagar",
    "office": "Birpur SO Kheda"
  },
  "388520": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Bamangam SO"
  },
  "767022": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Agalpur S.O"
  },
  "767040": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Banganmura S.O"
  },
  "767026": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Belpara S.O"
  },
  "767048": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Bhainsa S.O (Balangir)"
  },
  "767065": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Chandanbhati S.O"
  },
  "767024": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Churapali S.O"
  },
  "767029": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Deogaon S.O (Balangir)"
  },
  "767061": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Duduka S.O"
  },
  "767046": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Gudvella S.O"
  },
  "767038": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Harisankar Road S.O"
  },
  "767067": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Jarasingha S.O"
  },
  "767027": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Jogimunda S.O"
  },
  "388530": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Bhadran SO"
  },
  "388205": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Bhalej SO"
  },
  "388130": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Boria SO Anand"
  },
  "388540": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Borsad SO"
  },
  "388320": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Chikhodra SO"
  },
  "752045": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Gabakunda S.O"
  },
  "175001": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Purani Mandi SO"
  },
  "175121": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Aut SO"
  },
  "175033": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Baldwara SO"
  },
  "175004": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Bhambla SO"
  },
  "583283": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Kanakgiri S.O"
  },
  "583229": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Karatgi S.O"
  },
  "583230": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Kinhal S.O"
  },
  "583232": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Kuknoor S.O"
  },
  "583277": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Kusthagi Kut S.O"
  },
  "587155": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Kulgeri Cross S.O"
  },
  "587207": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Rampur S.O (Bagalkot)"
  },
  "587124": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Sulebhavi S.O"
  },
  "587104": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Bagalkot UHS Campus S.O"
  },
  "587113": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Belagali S.O"
  },
  "828114": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Katras Bazar SO"
  },
  "414606": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Chanda S.O"
  },
  "414103": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Jamgaon S.O"
  },
  "814146": {
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "office": "Palojori SO"
  },
  "396433": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Khadsupa Boarding SO"
  },
  "587116": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Bilgi S.O (Bagalkot)"
  },
  "799131": {
    "state": "TRIPURA",
    "district": "Sepahijala",
    "office": "Sonamura S.O"
  },
  "793112": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Shella S.O"
  },
  "793010": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Laitkor Peak S.O"
  },
  "587121": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Konnur S.O (Bagalkot)"
  },
  "756122": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Akhuapada S.O"
  },
  "756116": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Arnapal S.O"
  },
  "686541": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kangazha SO"
  },
  "686544": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Karikkattoor SO"
  },
  "686533": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kuzhimattom SO"
  },
  "686543": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Manimala SO"
  },
  "686542": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Nedumkunnam SO"
  },
  "686536": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Perumpanachy SO"
  },
  "686532": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Sachivothamapuram SO"
  },
  "686539": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Thottakadu SO"
  },
  "686535": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Thuruthy SO"
  },
  "686538": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Vakathanam SO"
  },
  "686503": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Anikad SO"
  },
  "686540": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Karukachal SO"
  },
  "686105": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Thrickodithanam SO"
  },
  "396469": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Ugat SO"
  },
  "396475": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Vesma SO"
  },
  "814148": {
    "state": "JHARKHAND",
    "district": "DUMKA",
    "office": "Raghunathpur SO Dumka"
  },
  "814102": {
    "state": "JHARKHAND",
    "district": "DUMKA",
    "office": "Ramgarah SO"
  },
  "816118": {
    "state": "JHARKHAND",
    "district": "DUMKA",
    "office": "Shikaripara SO"
  },
  "173025": {
    "state": "HIMACHAL PRADESH",
    "district": "SIRMAUR",
    "office": "Paonta Sahib SO"
  },
  "414504": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Balamtakali S.O"
  },
  "754107": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Alanahat S.O"
  },
  "754102": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Anakhia S.O"
  },
  "754108": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Balikuda S.O"
  },
  "148035": {
    "state": "PUNJAB",
    "district": "SANGRUR",
    "office": "Dirba SO"
  },
  "148002": {
    "state": "PUNJAB",
    "district": "SANGRUR",
    "office": "H R Sangrur SO"
  },
  "148034": {
    "state": "PUNJAB",
    "district": "SANGRUR",
    "office": "Ladda SO"
  },
  "148031": {
    "state": "PUNJAB",
    "district": "SANGRUR",
    "office": "Lehragaga SO"
  },
  "148033": {
    "state": "PUNJAB",
    "district": "SANGRUR",
    "office": "Moonak SO"
  },
  "148027": {
    "state": "PUNJAB",
    "district": "SANGRUR",
    "office": "Pakki Khanauri SO"
  },
  "184203": {
    "state": "JAMMU AND KASHMIR",
    "district": "KATHUA",
    "office": "Bhaddu SO"
  },
  "814110": {
    "state": "JHARKHAND",
    "district": "DUMKA",
    "office": "Shivpahar SO"
  },
  "396472": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Vedchha SO"
  },
  "816108": {
    "state": "JHARKHAND",
    "district": "SAHEBGANJ",
    "office": "Rajmahal SO"
  },
  "816109": {
    "state": "JHARKHAND",
    "district": "SAHEBGANJ",
    "office": "Sahibganj College SO"
  },
  "816129": {
    "state": "JHARKHAND",
    "district": "SAHEBGANJ",
    "office": "Taljhari SO"
  },
  "816116": {
    "state": "JHARKHAND",
    "district": "SAHEBGANJ",
    "office": "Tinpahar RS SO"
  },
  "173218": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Diggal SO"
  },
  "828125": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Sonardih SO"
  },
  "431701": {
    "state": "MAHARASHTRA",
    "district": "HINGOLI",
    "office": "Akhada Balapur S.O"
  },
  "454441": {
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "office": "Amjhera S.O"
  },
  "173204": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Kasauli SO"
  },
  "144504": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Behram SO"
  },
  "144502": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Dosanjh Kalan SO"
  },
  "144518": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Garcha SO"
  },
  "144515": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Jadla SO"
  },
  "144512": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Kahma SO"
  },
  "144501": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Kultham SO"
  },
  "144510": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Ladhana Jhikka SO"
  },
  "431507": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Ashti S.O (Jalna)"
  },
  "822113": {
    "state": "JHARKHAND",
    "district": "PALAMU",
    "office": "Chhatarpur SO"
  },
  "828112": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Jamadoba SO"
  },
  "827009": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Sector IX SO"
  },
  "828104": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Bhuli SO"
  },
  "756023": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Singla S.O"
  },
  "756087": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Lakhananath S.O"
  },
  "144516": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Langroya SO"
  },
  "144416": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Apra SO"
  },
  "144418": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Bara Pind SO"
  },
  "144409": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Goraya SO"
  },
  "144024": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Kukar Pind SO"
  },
  "442605": {
    "state": "MAHARASHTRA",
    "district": "GADCHIROLI",
    "office": "Gadchiroli S.O"
  },
  "442604": {
    "state": "MAHARASHTRA",
    "district": "GADCHIROLI",
    "office": "Ghot S.O"
  },
  "442505": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Ghugus Colliery S.O"
  },
  "442702": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Gondpipri S.O"
  },
  "442709": {
    "state": "MAHARASHTRA",
    "district": "GADCHIROLI",
    "office": "Kamlapur S.O (Gadchiroli)"
  },
  "395008": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "A K Road SO"
  },
  "363421": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Limbdi SO"
  },
  "363510": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Muli SO"
  },
  "363320": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Rajsitapur SO"
  },
  "363430": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Sayla SO Surendra Nagar"
  },
  "363427": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Shiyani SO"
  },
  "363530": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Thangadh SO"
  },
  "363755": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Zinzuwada SO"
  },
  "363351": {
    "state": "GUJARAT",
    "district": "MORBI",
    "office": "Mayurnagar SO"
  },
  "685501": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Elappara SO"
  },
  "685514": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Erattayar SO"
  },
  "791001": {
    "state": "ARUNACHAL PRADESH",
    "district": "WEST SIANG",
    "office": "Along S.O"
  },
  "791120": {
    "state": "ARUNACHAL PRADESH",
    "district": "LOWER SUBANSIRI",
    "office": "Ziro S.O"
  },
  "175128": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Raison SO"
  },
  "175134": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Sainj SO"
  },
  "144524": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Saroa SO"
  },
  "144509": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Khankhana SO"
  },
  "686691": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kothamangalam SO Ernakulam"
  },
  "683545": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kuruppampady SO"
  },
  "683556": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Valayanchirangara SO"
  },
  "683546": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Vengoor SO"
  },
  "173213": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Chambaghat SO"
  },
  "174103": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Barotiwala SO"
  },
  "194105": {
    "state": "LADAKH",
    "district": "KARGIL",
    "office": "Baroo S.O"
  },
  "305801": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Marble Ind. Area Kishangarh S.O"
  },
  "177212": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Ghanari SO"
  },
  "177031": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Raipur SO Una"
  },
  "177219": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Sunkali SO"
  },
  "816117": {
    "state": "JHARKHAND",
    "district": "PAKUR",
    "office": "Pakuria SO"
  },
  "822102": {
    "state": "JHARKHAND",
    "district": "PALAMU",
    "office": "Daltonganj College SO"
  },
  "822115": {
    "state": "JHARKHAND",
    "district": "PALAMU",
    "office": "Haidar Nagar SO"
  },
  "822131": {
    "state": "JHARKHAND",
    "district": "PALAMU",
    "office": "Harihar Ganj SO Palamau"
  },
  "822116": {
    "state": "JHARKHAND",
    "district": "PALAMU",
    "office": "Japla SO"
  },
  "822118": {
    "state": "JHARKHAND",
    "district": "PALAMU",
    "office": "Lesliganj SO"
  },
  "829206": {
    "state": "JHARKHAND",
    "district": "LATEHAR",
    "office": "Latehar Hsgii SO"
  },
  "363765": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Patdi SO"
  },
  "363440": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Sudamada SO"
  },
  "363110": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Vana SO"
  },
  "363030": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Wadhwancity SO"
  },
  "148107": {
    "state": "PUNJAB",
    "district": "BARNALA",
    "office": "Handiaya SO"
  },
  "415727": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Karji S.O"
  },
  "415640": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Khavati S.O"
  },
  "415709": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Khed (RTG) S.O"
  },
  "415604": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Kherdi S.O"
  },
  "415203": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Mandangad S.O"
  },
  "822128": {
    "state": "JHARKHAND",
    "district": "GARHWA",
    "office": "Ramna SO Garhwa"
  },
  "444704": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Chandur Bazar S.O"
  },
  "444803": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Daryapur Town S.O"
  },
  "444717": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Dhamangaon Gadhi S.O"
  },
  "444702": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Dharni S.O"
  },
  "444719": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Kalamkhar S.O"
  },
  "388305": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Adas SO"
  },
  "388510": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Anklav SO"
  },
  "833101": {
    "state": "JHARKHAND",
    "district": "SARAIKELA KHARSAWAN",
    "office": "Amda SO"
  },
  "415702": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Margatamhane S.O"
  },
  "415641": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Niwali (CPN) S.O"
  },
  "444809": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Karajgaon S.O"
  },
  "444808": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Pathrot S.O"
  },
  "444813": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Semadoh S.O"
  },
  "444723": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Sirajgaon Band S.O"
  },
  "444706": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Yeoda S.O"
  },
  "177113": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Chanour SO"
  },
  "176055": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Thill SO"
  },
  "799105": {
    "state": "TRIPURA",
    "district": "Gomati",
    "office": "Kakraban S.O"
  },
  "799013": {
    "state": "TRIPURA",
    "district": "Gomati",
    "office": "Matabari S.O"
  },
  "444005": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Jatharpeth Akola S.O"
  },
  "175013": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Barot SO"
  },
  "175050": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Marhi SO"
  },
  "175008": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Ner Chowk SO"
  },
  "791113": {
    "state": "ARUNACHAL PRADESH",
    "district": "PAPUM PARE",
    "office": "Ram Krishna Mission S.O"
  },
  "175023": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Rewalsar SO"
  },
  "175052": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Saigaloo SO"
  },
  "175034": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Samaila SO"
  },
  "176090": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Sandhole SO"
  },
  "175024": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Sarkaghat SO"
  },
  "175026": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Tihra SO"
  },
  "175027": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Baggi SO"
  },
  "175002": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Bhojpur SO Mandi"
  },
  "175029": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Gohar SO"
  },
  "175126": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Shamshi SO"
  },
  "560077": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Dr. Shivarama Karanth Nagar S.O"
  },
  "686534": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Neelamperoor SO"
  },
  "799153": {
    "state": "TRIPURA",
    "district": "South Tripura",
    "office": "Radhanagar S.O (West Tripura)"
  },
  "799132": {
    "state": "TRIPURA",
    "district": "Sepahijala",
    "office": "Kathalia S.O"
  },
  "756166": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Balikhanda S.O"
  },
  "756138": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Aradi S.O"
  },
  "756137": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Asurali S.O"
  },
  "362020": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Bhesan SO"
  },
  "362110": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Bilkha SO"
  },
  "362250": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Chorvad SO"
  },
  "362037": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Dolatpara SO"
  },
  "560056": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Bnagalore Viswavidalaya S.O"
  },
  "560076": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "JP Nagar VIII phase S.O"
  },
  "560083": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Bannerghatta S.O"
  },
  "799150": {
    "state": "TRIPURA",
    "district": "South Tripura",
    "office": "Rajnagar S.O (South Tripura)"
  },
  "752032": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Parikudgarh SO"
  },
  "587316": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Sameerwadi S.O"
  },
  "144511": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Dosanjh Khurd SO"
  },
  "144506": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Mahil Gailan SO"
  },
  "146105": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Mahilpur SO"
  },
  "144531": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Moranwali SO"
  },
  "146107": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Paldi SO Hoshiarpur"
  },
  "146022": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Piplanwala SO"
  },
  "146111": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Purhiran SO"
  },
  "146112": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Rajpur Bhayan SO"
  },
  "144528": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Rampur Bilron SO"
  },
  "144529": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Saila Khurd SO"
  },
  "144532": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Samundra SO"
  },
  "144105": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Sham Chaurasi SO"
  },
  "146109": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Tuto Mazara SO"
  },
  "396240": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Karad Daman Project SO"
  },
  "175021": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Bhangrotu SO"
  },
  "454660": {
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "office": "Badnawar S.O"
  },
  "454221": {
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "office": "Bagh S.O"
  },
  "454552": {
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "office": "Dhamnod S.O"
  },
  "454449": {
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "office": "Dharampuri S.O"
  },
  "454665": {
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "office": "Kanwan S.O"
  },
  "454331": {
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "office": "Kukshi S.O"
  },
  "682007": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kumbalangi SO"
  },
  "682509": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Nayarambalam SO"
  },
  "683547": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Mudikkal SO"
  },
  "686693": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Nellimattam SO"
  },
  "686692": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Thrikkariyoor SO"
  },
  "303006": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Madhorajpura SO"
  },
  "454446": {
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "office": "Manawar S.O"
  },
  "175104": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Larenkelo SO"
  },
  "175131": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Manali SO Kullu"
  },
  "685512": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Anakkara SO Idukki"
  },
  "685602": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Idukki Colony SO"
  },
  "685606": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Kanjikuzhi  Idukki SO"
  },
  "686545": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Nedungadappally SO"
  },
  "192401": {
    "state": "JAMMU AND KASHMIR",
    "district": "ANANTNAG",
    "office": "Srigufwaea SO"
  },
  "192212": {
    "state": "JAMMU AND KASHMIR",
    "district": "ANANTNAG",
    "office": "Verinaag SO"
  },
  "192123": {
    "state": "JAMMU AND KASHMIR",
    "district": "PULWAMA",
    "office": "Tral SO"
  },
  "833221": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "Barajamda SO"
  },
  "685515": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Kattappana South SO"
  },
  "685601": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Kulamavu SO"
  },
  "685509": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Kumily SO"
  },
  "685604": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Murickassery SO"
  },
  "685535": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Viswanathapuram SO"
  },
  "685553": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Nedumkandam SO"
  },
  "685531": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Peermade SO"
  },
  "685532": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Peruvanthanam SO"
  },
  "685554": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Udumbanchola SO"
  },
  "685505": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Upputhara SO"
  },
  "685503": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Vagamon SO"
  },
  "685551": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Vandanmettu SO"
  },
  "685533": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Vandiperiyar SO"
  },
  "685561": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Adimali SO"
  },
  "685565": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Chithirapuram SO"
  },
  "685613": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Devikulam SO"
  },
  "685588": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Kalayanthani SO"
  },
  "685562": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Kallarkutty SO"
  },
  "685581": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Karimannoor SO"
  },
  "136119": {
    "state": "HARYANA",
    "district": "KURUKSHETRA",
    "office": "R.E.C.K. S.O"
  },
  "303009": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Mozmabad SO"
  },
  "303348": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Naraina SO"
  },
  "303005": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Phagi SO"
  },
  "173215": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Kandaghat SO"
  },
  "443002": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Chaitanya Wadi S.O"
  },
  "443401": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Chandur Biswa S.O"
  },
  "443201": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Chikhli S.O (Buldhana)"
  },
  "577540": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Rampura S.O (Chitradurga)"
  },
  "571320": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Cowdalli S.O"
  },
  "571115": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Santhemaranahalli S.O"
  },
  "571457": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Tibetan Settlement S.O"
  },
  "571109": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Begur S.O"
  },
  "571111": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Gundlupet S.O"
  },
  "756139": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Arsa S.O"
  },
  "576117": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Kukkundur S.O"
  },
  "574226": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Mithabail S.O"
  },
  "574107": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Miyar S.O"
  },
  "574197": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kodangallu S.O"
  },
  "574108": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Muniyal S.O"
  },
  "574109": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Naravi S.O"
  },
  "754109": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Debidol S.O"
  },
  "442507": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "H.L.C. S.O"
  },
  "441209": {
    "state": "MAHARASHTRA",
    "district": "GADCHIROLI",
    "office": "Kurkheda S.O"
  },
  "144020": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Jamsher SO"
  },
  "146021": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Sadhu Ashram SO"
  },
  "146106": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Nangal Kalan SO"
  },
  "388110": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Anand Agri Inst  Anand SO"
  },
  "444807": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Chikhaldara S.O"
  },
  "136132": {
    "state": "HARYANA",
    "district": "KURUKSHETRA",
    "office": "Ladwa S.O"
  },
  "136131": {
    "state": "HARYANA",
    "district": "KURUKSHETRA",
    "office": "Pipli S.O"
  },
  "136135": {
    "state": "HARYANA",
    "district": "KURUKSHETRA",
    "office": "Shahabad(M) S.O"
  },
  "136136": {
    "state": "HARYANA",
    "district": "KURUKSHETRA",
    "office": "Thol S.O"
  },
  "797003": {
    "state": "NAGALAND",
    "district": "KOHIMA",
    "office": "Kohima Village S.O"
  },
  "798625": {
    "state": "NAGALAND",
    "district": "LONGLENG",
    "office": "Longleng S.O"
  },
  "583284": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Mudhol S.O"
  },
  "583226": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Alawandi S.O"
  },
  "583287": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Irkalgad S.O"
  },
  "583237": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Bewoor S.O"
  },
  "587311": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Banahatti Somaarpeth S.O"
  },
  "574110": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Nitte S.O"
  },
  "574114": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Sanur S.O"
  },
  "574236": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Shirthady S.O"
  },
  "574227": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Moodbidri S.O"
  },
  "574244": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Palli S.O"
  },
  "574242": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Venur S.O"
  },
  "591304": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Athani Bazar S.O"
  },
  "591248": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Aigali S.O"
  },
  "591212": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Anantpur S.O"
  },
  "591220": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Harugeri S.O"
  },
  "591303": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Ainapur S.O"
  },
  "571128": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Harave S.O"
  },
  "583135": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Kudligi S.O"
  },
  "583222": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Mariammanahalli S.O"
  },
  "583136": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Oojein S.O"
  },
  "583223": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Papinayakanahalli S.O"
  },
  "443102": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Datala S.O"
  },
  "443106": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Dhad S.O"
  },
  "799113": {
    "state": "TRIPURA",
    "district": "Gomati",
    "office": "Tepania S.O"
  },
  "587206": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Kerur S.O"
  },
  "192232": {
    "state": "JAMMU AND KASHMIR",
    "district": "KULGAM",
    "office": "Yaripora SO"
  },
  "193411": {
    "state": "JAMMU AND KASHMIR",
    "district": "Budgam",
    "office": "Beerwah SO"
  },
  "191111": {
    "state": "JAMMU AND KASHMIR",
    "district": "Budgam",
    "office": "Budgam SO"
  },
  "124508": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Bahadurgarh Mandi SO"
  },
  "124505": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Assaudha SO"
  },
  "124105": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Badli SO Jhajjar"
  },
  "124504": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Charra SO"
  },
  "124404": {
    "state": "HARYANA",
    "district": "ROHTAK",
    "office": "Hassangarh SO"
  },
  "124501": {
    "state": "HARYANA",
    "district": "ROHTAK",
    "office": "Sampla SO"
  },
  "124142": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Bahu SO"
  },
  "191113": {
    "state": "JAMMU AND KASHMIR",
    "district": "Budgam",
    "office": "Chadoora SO"
  },
  "191112": {
    "state": "JAMMU AND KASHMIR",
    "district": "Budgam",
    "office": "Charsharief SO"
  },
  "193401": {
    "state": "JAMMU AND KASHMIR",
    "district": "Budgam",
    "office": "Magam SO"
  },
  "795113": {
    "state": "MANIPUR",
    "district": "IMPHAL WEST",
    "office": "CRPF Camp Langjing S.O"
  },
  "795001": {
    "state": "MANIPUR",
    "district": "IMPHAL WEST",
    "office": "Imphal Bazar S.O"
  },
  "795103": {
    "state": "MANIPUR",
    "district": "KAKCHING",
    "office": "Kakching S.O"
  },
  "833203": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "Jagannathpur SO"
  },
  "833215": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "Jhinkpani SO"
  },
  "833104": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "Manoharpur SO West Singhbhum"
  },
  "833218": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "Noamundi Bazar SO"
  },
  "833105": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "Sonua SO"
  },
  "832101": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Baharagora SO"
  },
  "146108": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Sarhala Kalan SO"
  },
  "390019": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Ajwa Road SO"
  },
  "816110": {
    "state": "JHARKHAND",
    "district": "SAHEBGANJ",
    "office": "Pathna SO"
  },
  "390022": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Harni Colony SO"
  },
  "390014": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Makarpura SO"
  },
  "390004": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Pratapnagar SO Vadodara"
  },
  "391780": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Bhadarwa SO"
  },
  "415715": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Khopi S.O"
  },
  "415708": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Lavel S.O"
  },
  "415722": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Lote S.O (Ratnagiri)"
  },
  "415608": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Makhajan S.O"
  },
  "796581": {
    "state": "MIZORAM",
    "district": "Hnahthial",
    "office": "Thingsai S.O"
  },
  "796190": {
    "state": "MIZORAM",
    "district": "AIZAWL",
    "office": "Aibawk S.O"
  },
  "796007": {
    "state": "MIZORAM",
    "district": "AIZAWL",
    "office": "Chandmary S.O"
  },
  "796111": {
    "state": "MIZORAM",
    "district": "AIZAWL",
    "office": "Darlawn S.O"
  },
  "796070": {
    "state": "MIZORAM",
    "district": "KOLASIB",
    "office": "Kawnpui S.O"
  },
  "415202": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Latwan S.O"
  },
  "415607": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Nandgaon (CPN) S.O"
  },
  "415716": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Palgad S.O"
  },
  "415214": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Panderi S.O"
  },
  "415701": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Rampur S.O (Ratnagiri)"
  },
  "415606": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Sawarda S.O"
  },
  "415628": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Shiral S.O"
  },
  "560099": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Bommasandra Industrial Estate S.O"
  },
  "362002": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Junagadh Joshipura SO"
  },
  "362220": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Keshod SO"
  },
  "362227": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Kevadra SO"
  },
  "190015": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Natipora SO"
  },
  "192121": {
    "state": "JAMMU AND KASHMIR",
    "district": "PULWAMA",
    "office": "Pampore SO"
  },
  "124411": {
    "state": "HARYANA",
    "district": "ROHTAK",
    "office": "Anwal SO"
  },
  "124021": {
    "state": "HARYANA",
    "district": "ROHTAK",
    "office": "Asthal Bohar SO"
  },
  "191201": {
    "state": "JAMMU AND KASHMIR",
    "district": "GANDERBAL",
    "office": "Ganderbal"
  },
  "191202": {
    "state": "JAMMU AND KASHMIR",
    "district": "GANDERBAL",
    "office": "Kangan SO"
  },
  "191131": {
    "state": "JAMMU AND KASHMIR",
    "district": "GANDERBAL",
    "office": "Tulmulla SO"
  },
  "560064": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Yelahanka Satellite Town S.O"
  },
  "362215": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Lushala SO"
  },
  "362245": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Malia Hatina SO"
  },
  "362260": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Mendarda SO"
  },
  "362510": {
    "state": "GUJARAT",
    "district": "GIR SOMNATH",
    "office": "Delvada SO"
  },
  "362565": {
    "state": "GUJARAT",
    "district": "GIR SOMNATH",
    "office": "Dhokadva SO"
  },
  "362710": {
    "state": "GUJARAT",
    "district": "GIR SOMNATH",
    "office": "Ghantvad SO"
  },
  "362530": {
    "state": "GUJARAT",
    "district": "GIR SOMNATH",
    "office": "Girgadhda SO"
  },
  "443206": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Deulgaon Mahi S.O"
  },
  "443204": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Deulgaon Raja S.O"
  },
  "391740": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Chhani SO Vadodara"
  },
  "391244": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Choranda SO"
  },
  "391774": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Desar SO"
  },
  "391510": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Jarod SO"
  },
  "362720": {
    "state": "GUJARAT",
    "district": "GIR SOMNATH",
    "office": "Kodinar SO"
  },
  "362550": {
    "state": "GUJARAT",
    "district": "GIR SOMNATH",
    "office": "Sanakhda SO"
  },
  "560060": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Kengeri S.O"
  },
  "362030": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "RanpurS SO"
  },
  "798612": {
    "state": "NAGALAND",
    "district": "TUENSANG",
    "office": "Tuensang S.O"
  },
  "798616": {
    "state": "NAGALAND",
    "district": "TUENSANG",
    "office": "Longkhim S.O"
  },
  "136043": {
    "state": "HARYANA",
    "district": "KAITHAL",
    "office": "Pai S.O"
  },
  "136026": {
    "state": "HARYANA",
    "district": "KAITHAL",
    "office": "Pundri S.O"
  },
  "136033": {
    "state": "HARYANA",
    "district": "KAITHAL",
    "office": "Siwan S.O"
  },
  "136021": {
    "state": "HARYANA",
    "district": "KAITHAL",
    "office": "Kaul S.O"
  },
  "685507": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Ayyappancoil SO"
  },
  "685552": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Kallar SO"
  },
  "685609": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Thankamany SO"
  },
  "396215": {
    "state": "THE DADRA AND NAGAR HAVELI AND DAMAN AND DIU",
    "district": "DAMAN",
    "office": "Daman IE SO"
  },
  "396210": {
    "state": "THE DADRA AND NAGAR HAVELI AND DAMAN AND DIU",
    "district": "DAMAN",
    "office": "Daman SO"
  },
  "792122": {
    "state": "ARUNACHAL PRADESH",
    "district": "CHANGLANG",
    "office": "Miao S.O"
  },
  "175130": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Naggar SO"
  },
  "396105": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Bhilad SO"
  },
  "396193": {
    "state": "THE DADRA AND NAGAR HAVELI AND DAMAN AND DIU",
    "district": "DADRA AND NAGAR HAVELI",
    "office": "Dadra SO"
  },
  "396050": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Dharampur SO Valsad"
  },
  "396375": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Dungri SO Valsad"
  },
  "303338": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Phulera SO"
  },
  "303124": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "HINGONIA S.O"
  },
  "303603": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Renwal SO"
  },
  "175012": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Padhar SO"
  },
  "175124": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Pandoh SO"
  },
  "175042": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Rakhoh SO"
  },
  "175025": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Sajao Pipluso SO"
  },
  "396120": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Khatalwada SO"
  },
  "797006": {
    "state": "NAGALAND",
    "district": "KOHIMA",
    "office": "Jakhama S.O"
  },
  "481778": {
    "state": "MADHYA PRADESH",
    "district": "DINDORI",
    "office": "Samnapur S.O"
  },
  "481990": {
    "state": "MADHYA PRADESH",
    "district": "DINDORI",
    "office": "Shahpura Niwas S.O"
  },
  "194106": {
    "state": "LADAKH",
    "district": "LEH LADAKH",
    "office": "Khalsi S.O"
  },
  "362011": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Majevadi SO"
  },
  "391210": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Kandari SO"
  },
  "391450": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Karkhadi SO"
  },
  "391220": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Kayavahron SO"
  },
  "391330": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Koyali SO"
  },
  "391421": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Masar Road SO"
  },
  "391240": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Miyagam Karjan SO"
  },
  "391430": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Mobha Road SO"
  },
  "391440": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Padra SO"
  },
  "391243": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "POR SO"
  },
  "391350": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Ranoli SO Vadodara"
  },
  "793008": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Phudmawri S.O"
  },
  "793006": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Rynjah S.O"
  },
  "793015": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Smit S.O"
  },
  "799142": {
    "state": "TRIPURA",
    "district": "South Tripura",
    "office": "Muhuripur S.O"
  },
  "415724": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Shringartali S.O"
  },
  "390009": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Ongc Col SO"
  },
  "144419": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Dayalpur SO Jalandhar"
  },
  "390010": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "MI Estate SO"
  },
  "854338": {
    "state": "BIHAR",
    "district": "SUPAUL",
    "office": "Bhimnagar Bairrage SO"
  },
  "798614": {
    "state": "NAGALAND",
    "district": "MOKOKCHUNG",
    "office": "Chuchuyimlang S.O"
  },
  "798627": {
    "state": "NAGALAND",
    "district": "ZUNHEBOTO",
    "office": "Lumami S.O"
  },
  "798613": {
    "state": "NAGALAND",
    "district": "MOKOKCHUNG",
    "office": "Chantongia S.O"
  },
  "791123": {
    "state": "ARUNACHAL PRADESH",
    "district": "PAPUM PARE",
    "office": "Banderdewa S.O"
  },
  "686106": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Changanacherry Industrialnagar SO"
  },
  "686104": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kurisummoodu SO"
  },
  "686546": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Madappally SO"
  },
  "829210": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Dakra Colliery SO"
  },
  "483001": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Barela S.O"
  },
  "454773": {
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "office": "Dehri Ghata Billod S.O"
  },
  "577215": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Hodikere S.O"
  },
  "577115": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Bhadra Reservoir Project S.O"
  },
  "577302": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Bhadravathi Paper Town S.O"
  },
  "331803": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Kalubas S.O"
  },
  "585302": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Alund S.O"
  },
  "277205": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Dubey Chhapra SO"
  },
  "797106": {
    "state": "NAGALAND",
    "district": "DIMAPUR",
    "office": "Medziphema S.O"
  },
  "481996": {
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "office": "Sijhora S.O"
  },
  "481768": {
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "office": "Chiraidongri S.O"
  },
  "481664": {
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "office": "Ghughri S.O"
  },
  "481776": {
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "office": "Nainpur S.O"
  },
  "481885": {
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "office": "Niwas S.O"
  },
  "481662": {
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "office": "Padariyanarayan Ganj S.O"
  },
  "481666": {
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "office": "Beejadandi S.O"
  },
  "481665": {
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "office": "Maharajpur S.O (Mandla)"
  },
  "481663": {
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "office": "Mohgaon S.O"
  },
  "472001": {
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "office": "Tikamgarh City S.O"
  },
  "481668": {
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "office": "Pindrai S.O"
  },
  "281204": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Raya SO"
  },
  "281306": {
    "state": "UTTAR PRADESH",
    "district": "HATHRAS",
    "office": "Sadabad SO"
  },
  "281307": {
    "state": "UTTAR PRADESH",
    "district": "HATHRAS",
    "office": "Sahpau SO"
  },
  "281123": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Sonkh SO"
  },
  "691536": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kadakkal SO"
  },
  "691509": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kuzhimathicaud SO"
  },
  "691541": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Madathara SO"
  },
  "691531": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Pulamon SO"
  },
  "691507": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Puthurkollam SO"
  },
  "691532": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Valakom SO"
  },
  "691560": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kalayapuram SO"
  },
  "691521": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kulakada SO"
  },
  "571490": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Mahadeshwara Malai S.O"
  },
  "571126": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Hangala S.O"
  },
  "574211": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Bantval S.O"
  },
  "574212": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Bellare S.O"
  },
  "574214": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Belthangady S.O"
  },
  "574201": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Court Hill(Puttur) S.O"
  },
  "591305": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Bellad Bagewadi S.O"
  },
  "591254": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Daddi S.O"
  },
  "591309": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Hukeri S.O"
  },
  "591224": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Kalloli S.O"
  },
  "591225": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Kanagala S.O (Belagavi)"
  },
  "591310": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Kulgod S.O"
  },
  "591233": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Mamadapur S.O"
  },
  "591101": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Ankalgi S.O"
  },
  "591312": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Mudalgi S.O"
  },
  "591340": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Nerli S.O"
  },
  "591236": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Nidasoshi S.O"
  },
  "591122": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Pachhapur S.O"
  },
  "591313": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Sankeshwar S.O"
  },
  "591306": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Ghataprabha RS S.O"
  },
  "796015": {
    "state": "MIZORAM",
    "district": "AIZAWL",
    "office": "Tlangnuam S.O"
  },
  "796014": {
    "state": "MIZORAM",
    "district": "AIZAWL",
    "office": "Bawngkawn S.O"
  },
  "796081": {
    "state": "MIZORAM",
    "district": "KOLASIB",
    "office": "Kolasib S.O"
  },
  "796571": {
    "state": "MIZORAM",
    "district": "Hnahthial",
    "office": "Hnahthial S.O"
  },
  "796321": {
    "state": "MIZORAM",
    "district": "CHAMPHAI",
    "office": "Champhai S.O"
  },
  "796710": {
    "state": "MIZORAM",
    "district": "LUNGLEI",
    "office": "Bunghmun S.O"
  },
  "796770": {
    "state": "MIZORAM",
    "district": "LUNGLEI",
    "office": "Chawngte S.O"
  },
  "796751": {
    "state": "MIZORAM",
    "district": "LUNGLEI",
    "office": "Tlabung S.O"
  },
  "685511": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Kanchiyar SO"
  },
  "685615": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Ellapatti SO"
  },
  "136044": {
    "state": "HARYANA",
    "district": "KAITHAL",
    "office": "Rajound S.O"
  },
  "560034": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Koramangala I Block S.O"
  },
  "133205": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Adhoya S.O"
  },
  "133201": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Barara S.O"
  },
  "133102": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Kesri S.O"
  },
  "133004": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Kuldeep Nagar S.O"
  },
  "133203": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Mullana S.O"
  },
  "133104": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Saha S.O"
  },
  "133206": {
    "state": "HARYANA",
    "district": "YAMUNANAGAR",
    "office": "Sarawan S.O"
  },
  "175019": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Purana Nagar SO"
  },
  "175035": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Bagsaid SO"
  },
  "175125": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Bhuntar SO"
  },
  "175045": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Chail Chowk SO"
  },
  "175028": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Chachiot SO"
  },
  "175030": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Dehar SO"
  },
  "175031": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Jaidevi SO"
  },
  "175047": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Janjehli SO"
  },
  "175011": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Karsog SO"
  },
  "135106": {
    "state": "HARYANA",
    "district": "YAMUNANAGAR",
    "office": "Bhudkalan S.O"
  },
  "135102": {
    "state": "HARYANA",
    "district": "YAMUNANAGAR",
    "office": "Bilaspur (Yamunanagar) S.O"
  },
  "136128": {
    "state": "HARYANA",
    "district": "KURUKSHETRA",
    "office": "Pehowa S.O"
  },
  "135101": {
    "state": "HARYANA",
    "district": "YAMUNANAGAR",
    "office": "Buriya S.O"
  },
  "135103": {
    "state": "HARYANA",
    "district": "YAMUNANAGAR",
    "office": "Chhachrauli S.O"
  },
  "135003": {
    "state": "HARYANA",
    "district": "YAMUNANAGAR",
    "office": "Jagadhri Town S.O"
  },
  "135002": {
    "state": "HARYANA",
    "district": "YAMUNANAGAR",
    "office": "Jagdhari Work Shop S.O"
  },
  "133103": {
    "state": "HARYANA",
    "district": "YAMUNANAGAR",
    "office": "Mustafabad S.O (Yamuna Nagar)"
  },
  "135133": {
    "state": "HARYANA",
    "district": "YAMUNANAGAR",
    "office": "Radaur S.O"
  },
  "133204": {
    "state": "HARYANA",
    "district": "YAMUNANAGAR",
    "office": "Sadhaura S.O"
  },
  "135004": {
    "state": "HARYANA",
    "district": "YAMUNANAGAR",
    "office": "Thermal Colony Yamuna Nagar S.O"
  },
  "185131": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAJOURI",
    "office": "Rajouri HO"
  },
  "185155": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAJOURI",
    "office": "Bhawani SO"
  },
  "185233": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAJOURI",
    "office": "Budhal SO"
  },
  "695501": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Balaramapuram SO"
  },
  "695123": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Aralumoodu SO"
  },
  "695132": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Chenkal SO"
  },
  "695524": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kanjiramkulam SO"
  },
  "689126": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Ala SO Alappuzha"
  },
  "689511": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Cheriyanadu SO"
  },
  "689124": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Kallisserry SO"
  },
  "689533": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Aranmula SO"
  },
  "689612": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Ayroor North SO"
  },
  "689611": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Ayroor South SO"
  },
  "689531": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Koipuram SO"
  },
  "689614": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kottathoor SO"
  },
  "185211": {
    "state": "JAMMU AND KASHMIR",
    "district": "POONCH",
    "office": "Dharamsal Mendhar SO"
  },
  "682508": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Ochanthuruth SO"
  },
  "682006": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Palluruthy SO"
  },
  "242221": {
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR",
    "office": "Jalalabad SO Shahjahanpur"
  },
  "194109": {
    "state": "LADAKH",
    "district": "KARGIL",
    "office": "Mulbek S.O"
  },
  "194302": {
    "state": "LADAKH",
    "district": "KARGIL",
    "office": "Padum S.O"
  },
  "194301": {
    "state": "LADAKH",
    "district": "KARGIL",
    "office": "Sankoo S.O"
  },
  "194303": {
    "state": "LADAKH",
    "district": "KARGIL",
    "office": "Panikhar S.O"
  },
  "676508": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Valakolam SO"
  },
  "676552": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Valancheri SO"
  },
  "242223": {
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR",
    "office": "Kant SO"
  },
  "242303": {
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR",
    "office": "Khera Bajhera SO"
  },
  "242305": {
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR",
    "office": "Khudaganj SO"
  },
  "242405": {
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR",
    "office": "Khutar SO"
  },
  "390012": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Atladara SO"
  },
  "391310": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Bajwa SO"
  },
  "391410": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Bhaily SO"
  },
  "391340": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Nandesari Ind Estate SO"
  },
  "591221": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Hebbal S.O"
  },
  "591107": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Hidkal Dam S.O"
  },
  "583268": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Pragathinagar S.O"
  },
  "583279": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Tavargera S.O"
  },
  "583235": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Mukkumpi BO"
  },
  "583236": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Yelburga S.O"
  },
  "586130": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Tikota S.O"
  },
  "582116": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Lakshmeshwar S.O"
  },
  "582117": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Mulgund S.O"
  },
  "582118": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Mundargi S.O"
  },
  "582119": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Naregal S.O"
  },
  "582207": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Nargund S.O"
  },
  "582209": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Ron S.O"
  },
  "582120": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Shiratti S.O"
  },
  "582211": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Sudi S.O"
  },
  "795122": {
    "state": "MANIPUR",
    "district": "KANGPOKPI",
    "office": "Kalapahar S.O"
  },
  "795149": {
    "state": "MANIPUR",
    "district": "THOUBAL",
    "office": "Yairipok S.O"
  },
  "212201": {
    "state": "UTTAR PRADESH",
    "district": "KAUSHAMBI",
    "office": "Bharwari SO Kaushambi"
  },
  "212202": {
    "state": "UTTAR PRADESH",
    "district": "KAUSHAMBI",
    "office": "Chail SO Kaushambi"
  },
  "212203": {
    "state": "UTTAR PRADESH",
    "district": "KAUSHAMBI",
    "office": "Charwa SO"
  },
  "212206": {
    "state": "UTTAR PRADESH",
    "district": "KAUSHAMBI",
    "office": "Karari SO"
  },
  "221104": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Chaubeypur SO"
  },
  "221112": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "CHIRAIGAON SO"
  },
  "221101": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Cholapur SO"
  },
  "185132": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAJOURI",
    "office": "Jawaharnagar SO Rajauri"
  },
  "232105": {
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "office": "Dhanapur SO"
  },
  "232106": {
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "office": "Kamalpur SO"
  },
  "262123": {
    "state": "UTTAR PRADESH",
    "district": "PILIBHIT",
    "office": "Jograjpur SO"
  },
  "362315": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Choki SO"
  },
  "185202": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAJOURI",
    "office": "Kalakot SO"
  },
  "185156": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAJOURI",
    "office": "Kangri SO"
  },
  "185152": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAJOURI",
    "office": "Lamberi SO"
  },
  "185102": {
    "state": "JAMMU AND KASHMIR",
    "district": "POONCH",
    "office": "Mandi SO"
  },
  "185151": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAJOURI",
    "office": "Naushera SO"
  },
  "185101": {
    "state": "JAMMU AND KASHMIR",
    "district": "POONCH",
    "office": "Poonch SO"
  },
  "135021": {
    "state": "HARYANA",
    "district": "YAMUNANAGAR",
    "office": "Khirzrabad  East S.O"
  },
  "185135": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAJOURI",
    "office": "Darhal Malkan SO"
  },
  "627152": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Mundradaippu SO"
  },
  "627356": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Munnirpallam SO"
  },
  "627108": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Nanguneri SO"
  },
  "627502": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Padmaneri SO"
  },
  "415602": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Shirgaon (CPN) S.O"
  },
  "574285": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Alankar S.O"
  },
  "574210": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Aryapu S.O"
  },
  "388315": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Bakrol SO"
  },
  "835218": {
    "state": "JHARKHAND",
    "district": "LATEHAR",
    "office": "Netarhat SO"
  },
  "124109": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Dhakla SO"
  },
  "124107": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Dighal SO"
  },
  "191121": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Brein"
  },
  "190006": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Kashmir University"
  },
  "127307": {
    "state": "HARYANA",
    "district": "CHARKI DADRI",
    "office": "Achina SO"
  },
  "127308": {
    "state": "HARYANA",
    "district": "CHARKI DADRI",
    "office": "Badhara SO"
  },
  "127312": {
    "state": "HARYANA",
    "district": "CHARKI DADRI",
    "office": "Nihalgard PO"
  },
  "127025": {
    "state": "HARYANA",
    "district": "CHARKI DADRI",
    "office": "Baund SO"
  },
  "190008": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Jawahar Nagar"
  },
  "185234": {
    "state": "JAMMU AND KASHMIR",
    "district": "RAJOURI",
    "office": "Baba Ghulam Shah Badshah University SO"
  },
  "691512": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Odanavattom SO"
  },
  "691566": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Pallickalkottarakara SO"
  },
  "691537": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Pooyapally SO"
  },
  "691538": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Vettikavala SO"
  },
  "281205": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Surir SO"
  },
  "481880": {
    "state": "MADHYA PRADESH",
    "district": "DINDORI",
    "office": "Dindori S.O (Dindori)"
  },
  "481882": {
    "state": "MADHYA PRADESH",
    "district": "DINDORI",
    "office": "Gadasarai S.O"
  },
  "481883": {
    "state": "MADHYA PRADESH",
    "district": "DINDORI",
    "office": "Bajag S.O"
  },
  "481884": {
    "state": "MADHYA PRADESH",
    "district": "DINDORI",
    "office": "Gorakhpur S.O"
  },
  "481661": {
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "office": "Padaw Mandla S.O"
  },
  "175037": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Cholthra SO"
  },
  "175010": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Churag SO"
  },
  "242226": {
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR",
    "office": "M Ashram SO"
  },
  "242301": {
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR",
    "office": "Miranpur Katra SO"
  },
  "242407": {
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR",
    "office": "Nigohi SO"
  },
  "242401": {
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR",
    "office": "Powayan SO"
  },
  "673315": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Atholi SO"
  },
  "673612": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Balusseri SO"
  },
  "673306": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Edakulam  Koyilandi SO"
  },
  "673524": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Meppayur SO"
  },
  "695503": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Dhanuvachapuram SO"
  },
  "689542": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Eraviperoor SO"
  },
  "689547": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kumbanadu SO"
  },
  "689546": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Othera SO"
  },
  "591227": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Kaujalgi S.O"
  },
  "591344": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Khangaon S.O"
  },
  "591218": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Lolsur S.O"
  },
  "591314": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Sankeshwar Sugar Factory S.O"
  },
  "591243": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Thana Hattargi S.O"
  },
  "591136": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Yadwad S.O"
  },
  "190011": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Noushara SO"
  },
  "191101": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Pantha Chowk SO"
  },
  "190017": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Parimpora SO"
  },
  "190003": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Khanyar SO"
  },
  "124401": {
    "state": "HARYANA",
    "district": "ROHTAK",
    "office": "Bhalaut SO"
  },
  "124202": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Dubaldhan SO"
  },
  "281404": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Shergarh SO Mathura"
  },
  "281206": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Sonai SO Mathura"
  },
  "638311": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Ammapettai SO"
  },
  "691543": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kaithacode SO"
  },
  "691535": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Nilamel SO"
  },
  "691540": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Veliyam SO"
  },
  "127111": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Bapora SO"
  },
  "833216": {
    "state": "JHARKHAND",
    "district": "SARAIKELA KHARSAWAN",
    "office": "Kharsawangarh SO"
  },
  "833219": {
    "state": "JHARKHAND",
    "district": "SARAIKELA KHARSAWAN",
    "office": "Seraikella SO"
  },
  "833220": {
    "state": "JHARKHAND",
    "district": "SARAIKELA KHARSAWAN",
    "office": "Sini SO"
  },
  "636903": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Harur S.O"
  },
  "636803": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Indur S.O"
  },
  "635303": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Kadathur S.O"
  },
  "635202": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Kambainallore S.O"
  },
  "636804": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Laligam S.O"
  },
  "636806": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Marandahalli S.O"
  },
  "635305": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Morappur S.O"
  },
  "636807": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Nallampalli S.O"
  },
  "636808": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Palacode S.O"
  },
  "636812": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Panjapalli S.O"
  },
  "124506": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Mandothi SO"
  },
  "682554": {
    "state": "LAKSHADWEEP",
    "district": "LAKSHADWEEP DISTRICT",
    "office": "Chetlat S.O"
  },
  "193404": {
    "state": "JAMMU AND KASHMIR",
    "district": "BARAMULLA",
    "office": "Kunzer SO"
  },
  "583234": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Munirabad RS S.O"
  },
  "636905": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Pappireddipatti S.O"
  },
  "636809": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Paupparapatti S.O"
  },
  "636810": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Pennagaram S.O"
  },
  "635205": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Periyanahalli S.O"
  },
  "636811": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Perumbalai S.O"
  },
  "636906": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Tirtamalai S.O"
  },
  "635651": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Pudupettai S.O"
  },
  "635655": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Matrapalli S.O"
  },
  "635602": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Tirupattur Bazaar S.O"
  },
  "635653": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Vengalapuram S.O"
  },
  "211012": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Bamrauli SO"
  },
  "585303": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Andola S.O"
  },
  "585305": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Chandapur S.O (Kalaburagi)"
  },
  "585306": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Chimmanchod S.O"
  },
  "585307": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Chincholi S.O"
  },
  "585308": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Farhatabad S.O"
  },
  "390003": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Chemical Industries SO"
  },
  "583134": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Kottur S.O(Ballari)"
  },
  "627133": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Mahendragiri SO"
  },
  "627127": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Kuttapuli SO"
  },
  "627151": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Maruthakulam SO"
  },
  "627354": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Mulaikaraipatti SO"
  },
  "627355": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Munanjipatti SO"
  },
  "574202": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Darbe(Puttur) S.O"
  },
  "574248": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Doddathota S.O"
  },
  "577520": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Bheemasamudra S.O"
  },
  "630411": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Sarakeni SO"
  },
  "577521": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Bidarakere S.O"
  },
  "577518": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Bndurga S.O"
  },
  "577522": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Challakere Bazar S.O"
  },
  "577524": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Doddasiddavvanahalli S.O"
  },
  "577557": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "H.D.Pura S.O"
  },
  "577546": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Hariyabbe S.O"
  },
  "585103": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "GB Bahamanipura S.O"
  },
  "585105": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "GB Ggh S.O"
  },
  "585104": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "GB Darga S.O"
  },
  "585301": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Afjalpur S.O"
  },
  "628201": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Ammanpuram S.O"
  },
  "628202": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Arumuganeri S.O"
  },
  "628151": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Autoor S.O"
  },
  "628205": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Kayamozhi S.O"
  },
  "628206": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Kulasekarapatnam S.O"
  },
  "628704": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Satankulam S.O"
  },
  "628809": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Seydunganallur S.O"
  },
  "628802": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Siruthondanallur S.O"
  },
  "334202": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Sinthal S.O"
  },
  "689545": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Thadiyur SO"
  },
  "689544": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Vennikulam SO"
  },
  "689583": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kallooppara SO"
  },
  "689582": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kaviyoor SO"
  },
  "480661": {
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "office": "Seoni City S.O"
  },
  "689122": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Angadical Chengannur SO"
  },
  "689532": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Edayarnmula SO"
  },
  "689548": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Pullad SO"
  },
  "689543": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Puramattom SO"
  },
  "638656": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Cholakkadai Street SO"
  },
  "638657": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Ellisnagar SO"
  },
  "638701": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Kangayam SO"
  },
  "638661": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Kolathupalayam SO"
  },
  "638673": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Kolinjivadi SO"
  },
  "190019": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Bagh Mehtab SO"
  },
  "190018": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Bemina SO"
  },
  "191103": {
    "state": "JAMMU AND KASHMIR",
    "district": "PULWAMA",
    "office": "Khrew SO"
  },
  "124201": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Beri SO"
  },
  "583282": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Sriramnagar S.O (Koppal)"
  },
  "577599": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Hiriyur  Sugar Factory S.O"
  },
  "577598": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Hiriyur S.O"
  },
  "574216": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Dharmasthala S.O"
  },
  "586116": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Dhavalgi S.O"
  },
  "586207": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Halsangi S.O"
  },
  "571404": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Acetate Town S.O"
  },
  "581356": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Tergaon S.O"
  },
  "581358": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Yekkambi S.O"
  },
  "586117": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Horti S.O"
  },
  "586208": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Huvin Hippargi S.O"
  },
  "586119": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Kannur S.O"
  },
  "415634": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "RGPPL Anjanvel S.O"
  },
  "577101": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Vijayapuram S.O (Chikkamagaluru)"
  },
  "577547": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Ajjampura S.O"
  },
  "577111": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Aldur S.O"
  },
  "577113": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Banakal S.O"
  },
  "244221": {
    "state": "UTTAR PRADESH",
    "district": "AMROHA",
    "office": "Amroha Shahi Chabutra SO"
  },
  "134202": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Shahzadpur S.O."
  },
  "581351": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Gudeangadi S.O"
  },
  "581361": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Hadinbal S.O"
  },
  "581333": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Hiregutti S.O"
  },
  "581320": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Bhatkal S.O"
  },
  "581323": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Chandavar S.O"
  },
  "581384": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Gersoppa Jyothinagar S.O"
  },
  "585287": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Bheemarayanagudi S.O"
  },
  "628622": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Thathankulam S.O"
  },
  "143416": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Patti SO Tarn Taran"
  },
  "143414": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Sarai Amant Khan SO"
  },
  "143302": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Sur Singh SO"
  },
  "143118": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Vairowal SO"
  },
  "758029": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Dhenkikote S.O"
  },
  "758027": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Ghatagaon S.O"
  },
  "143410": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Sarhali SO Tarn Taran"
  },
  "758025": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Kushaleswar S.O"
  },
  "563138": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Yeldur S.O"
  },
  "758023": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Hadagarh S.O"
  },
  "758028": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Harichandanpur S.O"
  },
  "758083": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Hatadihi S.O"
  },
  "691516": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Karingannur SO"
  },
  "691510": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Oyur SO"
  },
  "481879": {
    "state": "MADHYA PRADESH",
    "district": "DINDORI",
    "office": "Shahpur S.O (Dindori)"
  },
  "586210": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Kolhar S.O (Vijayapura(KAR))"
  },
  "586120": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Korwar S.O"
  },
  "586121": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Kudgi S.O"
  },
  "586211": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Lachyan S.O"
  },
  "586123": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Moratgi S.O"
  },
  "586212": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Muddebiahl S.O"
  },
  "586124": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Nalatwad S.O"
  },
  "586213": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Nidgundi S.O"
  },
  "586217": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Salotgi S.O"
  },
  "682507": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Mundamveli SO"
  },
  "676304": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Vengara MLP SO"
  },
  "676317": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Velimukku SO"
  },
  "673304": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Chemancheri SO"
  },
  "673526": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Kayanna SO"
  },
  "194202": {
    "state": "LADAKH",
    "district": "LEH LADAKH",
    "office": "NYOMA MUD"
  },
  "194201": {
    "state": "LADAKH",
    "district": "LEH LADAKH",
    "office": "Thiksay S.O"
  },
  "758084": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Jagamohanpur S.O"
  },
  "758034": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Joda S.O"
  },
  "758044": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Karanjia S.O (Kendujhar)"
  },
  "758040": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Kiriburu Hill Top S.O"
  },
  "758014": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Naranpur S.O"
  },
  "144039": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Nurmahal SO"
  },
  "758022": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Fakirpur S.O"
  },
  "758015": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Ghasipura S.O"
  },
  "560091": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Herohalli S.O"
  },
  "562106": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Anekal S.O"
  },
  "562157": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Bettahalsur S.O"
  },
  "562110": {
    "state": "KARNATAKA",
    "district": "BENGALURU RURAL",
    "office": "Devanahalli S.O"
  },
  "416519": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Mangaon S.O (Sindhudurg)"
  },
  "586125": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Sarwad S.O"
  },
  "587118": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Hungund S.O"
  },
  "587154": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Ilkal  Alampurpet S.O"
  },
  "581359": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Yellapur S.O"
  },
  "591231": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Konnur S.O (Belagavi)"
  },
  "562111": {
    "state": "KARNATAKA",
    "district": "BENGALURU RURAL",
    "office": "Dobbespet S.O"
  },
  "561203": {
    "state": "KARNATAKA",
    "district": "BENGALURU RURAL",
    "office": "Dodballapura Bazar S.O"
  },
  "673616": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Chelannur SO"
  },
  "673010": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Karaparamba SO"
  },
  "673572": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Kotuvalli SO"
  },
  "673323": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "ULLIYERI SO"
  },
  "673307": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Kollam SO"
  },
  "673527": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Koorachundu SO"
  },
  "673310": {
    "state": "PUDUCHERRY",
    "district": "MAHE",
    "office": "Mahe SO"
  },
  "673571": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Kunnamangalam SO"
  },
  "673604": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Kutaranni SO"
  },
  "673602": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Mokkam SO"
  },
  "673601": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Nit  Campus PoKozhikode SO"
  },
  "673582": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Omasseri SO"
  },
  "673586": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Puduppadi SO"
  },
  "673573": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Tamaracheri SO"
  },
  "673603": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Tiruvambadi SO"
  },
  "673015": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Beypore SO"
  },
  "673008": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Calicut Medical College SO"
  },
  "673614": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Naduvannur SO"
  },
  "577116": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Birur S.O"
  },
  "577180": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Chowlahiriyur S.O"
  },
  "577121": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Hirebyle S.O"
  },
  "577122": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Javali S.O"
  },
  "577102": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Chikkamagaluru ZP S.O"
  },
  "577548": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Kadur S.O"
  },
  "574260": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Adyanadka S.O"
  },
  "574314": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Aranthodu S.O"
  },
  "272124": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Mahson SO"
  },
  "172001": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Padam Nagar SO Shimla"
  },
  "172027": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Baragaon SO Shimla"
  },
  "172101": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Jeori SO"
  },
  "172201": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Jhakri SO"
  },
  "673528": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Peruvannamuzhi SO"
  },
  "673620": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Quilandibazar SO"
  },
  "673317": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Thalakolathur SO"
  },
  "673106": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Chorode SO"
  },
  "673507": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Kakkattil SO"
  },
  "673506": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Kallachi SO"
  },
  "242127": {
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR",
    "office": "R B Kalan SO"
  },
  "585228": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Shahabad S.O (Kalaburagi)"
  },
  "585213": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Station Ghanagapur S.O"
  },
  "585324": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Sulahpeth S.O"
  },
  "342310": {
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "office": "Nokh SO"
  },
  "345025": {
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "office": "Phalsund SO"
  },
  "345021": {
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "office": "Pokaran City SO"
  },
  "571314": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Hullahalli S.O"
  },
  "272175": {
    "state": "UTTAR PRADESH",
    "district": "SANT KABEER NAGAR",
    "office": "Khalilabad Bus Stand SO"
  },
  "272173": {
    "state": "UTTAR PRADESH",
    "district": "SANT KABEER NAGAR",
    "office": "Maghar SO"
  },
  "272172": {
    "state": "UTTAR PRADESH",
    "district": "SANT KABEER NAGAR",
    "office": "Mahuli SO"
  },
  "272271": {
    "state": "UTTAR PRADESH",
    "district": "SANT KABEER NAGAR",
    "office": "Menhdawal SO"
  },
  "571315": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Hura S.O (Mysuru)"
  },
  "571118": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Kalale S.O"
  },
  "591131": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Pariswad S.O"
  },
  "591125": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Sampgaon S.O"
  },
  "591156": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Bhutaramanahatti S.O"
  },
  "591108": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Hindalga S.O"
  },
  "673513": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Kavilampara SO"
  },
  "673508": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Kuttiadi SO"
  },
  "638702": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Kundadam SO"
  },
  "638106": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Mulanur SO"
  },
  "638706": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Sankarandampalayam SO"
  },
  "638703": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Udhiyur SO"
  },
  "638111": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Vellakoil SO"
  },
  "689506": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Pandanad SO"
  },
  "689573": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Edathua SO"
  },
  "689123": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Puthencavu SO"
  },
  "695542": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Aryanad SO"
  },
  "695572": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kattakada SO"
  },
  "695574": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kuttichal SO"
  },
  "695541": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Nedumangad SO"
  },
  "695568": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Panavoor SO"
  },
  "695573": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Peyad SO"
  },
  "695012": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Poojapura Junction SO"
  },
  "171201": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Theog SO"
  },
  "171203": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Tikkar SO"
  },
  "171011": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Totu SO"
  },
  "173001": {
    "state": "HIMACHAL PRADESH",
    "district": "SIRMAUR",
    "office": "Katcha Tank Nahan SO"
  },
  "816101": {
    "state": "JHARKHAND",
    "district": "SAHEBGANJ",
    "office": "Barharwa SO Sahibganj"
  },
  "758079": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Janghira S.O"
  },
  "758031": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Jhumpura S.O"
  },
  "561204": {
    "state": "KARNATAKA",
    "district": "BENGALURU RURAL",
    "office": "Doddabelavangala S.O"
  },
  "562114": {
    "state": "KARNATAKA",
    "district": "BENGALURU RURAL",
    "office": "Hoskote S.O"
  },
  "686514": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Koottickal SO"
  },
  "581411": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Tibetan Colony S.O"
  },
  "586128": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Sindgi S.O"
  },
  "586214": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Talikoti S.O"
  },
  "571811": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Chunchanahalli S.O"
  },
  "571423": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Kikkeri S.O"
  },
  "571807": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Kirangoor S.O"
  },
  "571426": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Krishnarajapete S.O"
  },
  "571427": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Kyathanahalli S.O"
  },
  "571431": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Melukote S.O"
  },
  "571432": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Nagamangala S.O"
  },
  "571434": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Pandavapura S.O"
  },
  "587125": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Ilkal S.O"
  },
  "587120": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Kamatgi S.O"
  },
  "144819": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "IBRAHIMWAL"
  },
  "563147": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "BUDIKOTE SO"
  },
  "563126": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Dalasanur S.O"
  },
  "563129": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Kamasamudra S.O"
  },
  "758002": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Keonjhar Atopur S.O"
  },
  "673104": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Nut Street SO"
  },
  "673501": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Orkatteri SO"
  },
  "673509": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Parakkadavu SO"
  },
  "673522": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Payyoli SO"
  },
  "673105": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Puduppanam SO"
  },
  "673611": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Kakkoti SO"
  },
  "673580": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Kotancheritamaracheri SO"
  },
  "345023": {
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "office": "Ramdeora SO"
  },
  "133005": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Babyal S.O"
  },
  "133202": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Dhin S.O"
  },
  "134109": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "Panchkula Sector 8 S.O"
  },
  "134204": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "Raipur Rani S.O"
  },
  "762029": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Gumagarh S.O"
  },
  "762022": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Kalinga S.O"
  },
  "762012": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Khajuripada S.O"
  },
  "762105": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Kothagarh S.O"
  },
  "673585": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Narikkuni SO"
  },
  "695026": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Poonthura SO"
  },
  "695027": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Thiruvallom SO"
  },
  "695006": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Tirumala SO Thiruvananthapuram"
  },
  "695013": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Vattiyoorkavu SO"
  },
  "695551": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Vithura SO"
  },
  "638660": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Koduvoi SO"
  },
  "689510": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Puliyoor SO"
  },
  "689594": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Chengaroor SO"
  },
  "689102": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kavumbhagom SO"
  },
  "689581": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kunnamthanam SO"
  },
  "641653": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Annur SO"
  },
  "641104": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Karamadai SO"
  },
  "638105": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Muthur SO"
  },
  "641665": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Pallikalipalayam SO"
  },
  "560074": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Kumbalagodu S.O"
  },
  "560105": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Jigani S.O"
  },
  "560116": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Kaggalipura P.O"
  },
  "679308": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Naduvattom SO"
  },
  "232101": {
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "office": "Patelnagar SO"
  },
  "212204": {
    "state": "UTTAR PRADESH",
    "district": "KAUSHAMBI",
    "office": "Daranagar SO Allahabad"
  },
  "212104": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Bharatganj SO"
  },
  "212111": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Dandupur SO"
  },
  "212106": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Jari Bazar SO"
  },
  "212107": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Jasra SO"
  },
  "212301": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Karchhana SO"
  },
  "211007": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Agriculture Institute SO"
  },
  "127311": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Neemariwali PO"
  },
  "562160": {
    "state": "KARNATAKA",
    "district": "RAMANAGARA",
    "office": "Channapatna Bazar S.O"
  },
  "562108": {
    "state": "KARNATAKA",
    "district": "RAMANAGARA",
    "office": "Bevur S.O (Ramanagar)"
  },
  "562109": {
    "state": "KARNATAKA",
    "district": "RAMANAGARA",
    "office": "Bidadi S.O"
  },
  "562112": {
    "state": "KARNATAKA",
    "district": "RAMANAGARA",
    "office": "Harohalli S.O"
  },
  "562138": {
    "state": "KARNATAKA",
    "district": "RAMANAGARA",
    "office": "Honganur S.O"
  },
  "581334": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Prabhatnagar S.O"
  },
  "581335": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Hosad S.O"
  },
  "232104": {
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "office": "Chandauli SO"
  },
  "221011": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Dafi SO"
  },
  "221005": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Assi SO"
  },
  "221116": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Kaithi SO"
  },
  "232111": {
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "office": "Naugarh SO"
  },
  "591345": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Jamboti S.O"
  },
  "591143": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Kadoli S.O"
  },
  "591302": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Khanapur SO Belagavi"
  },
  "591301": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Londa S.O"
  },
  "591120": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Nandgad S.O"
  },
  "590014": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Peeranwadi S.O"
  },
  "590020": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Suvarna Soudha Belagavi S.O"
  },
  "591128": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Uchgaon S.O"
  },
  "590018": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "VTU Campus Belagavi S.O"
  },
  "591123": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Ramdurg H.O"
  },
  "571312": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Kavalande S.O"
  },
  "635654": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Sundarampalli S.O"
  },
  "635751": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Vaniyambadi S.O"
  },
  "571129": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Nagarle S.O"
  },
  "571119": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Tagadur S.O"
  },
  "571302": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Thandavapura S.O"
  },
  "591121": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Nesargi S.O"
  },
  "591103": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Balekundri S.O"
  },
  "590005": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Belagavi M. Vadgaon S.O"
  },
  "590015": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Kanabargi S.O"
  },
  "591346": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Hudli"
  },
  "141412": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Daheru SO"
  },
  "591124": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Sambra S.O"
  },
  "635652": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Vishamangalam S.O"
  },
  "762109": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Kurtamgarh S.O"
  },
  "762027": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Linepada S.O"
  },
  "762102": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Nuagaon S.O (Kandhamal)"
  },
  "762112": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Paburia S.O"
  },
  "762011": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Phiringia S.O"
  },
  "762101": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Raikia S.O"
  },
  "762106": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Sarangada S.O"
  },
  "832404": {
    "state": "JHARKHAND",
    "district": "SARAIKELA KHARSAWAN",
    "office": "Chowka SO"
  },
  "209743": {
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "office": "Khimseypur SO"
  },
  "209504": {
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "office": "Manjhana SO"
  },
  "209652": {
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "office": "Neebkarori SO"
  },
  "695527": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kovalam SO Thiruvananthapuram"
  },
  "695043": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kudappanakunnu SO"
  },
  "695571": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Malayinkil SO"
  },
  "695020": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Nemom SO"
  },
  "695562": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Pacha SO"
  },
  "695561": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Pazhakutty SO"
  },
  "695563": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Peringamala SO"
  },
  "695575": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Poovachal SO"
  },
  "758081": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Machhagarh S.O"
  },
  "758036": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Matkambeda S.O"
  },
  "144703": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Nangal Ambian SO"
  },
  "144806": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Pattar Kalan SO"
  },
  "571316": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Kuderu S.O (Chamrajnagar)"
  },
  "571123": {
    "state": "KARNATAKA",
    "district": "CHAMARAJANAGARA",
    "office": "Tirukanambi S.O"
  },
  "591307": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Gokak Fort S.O"
  },
  "127032": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Bawani Khera SO"
  },
  "127028": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Behl SO"
  },
  "127027": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Chang SO"
  },
  "127035": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Jamalpur SO Bhiwani"
  },
  "127030": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Jui Khurd SO"
  },
  "127029": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Kairu SO"
  },
  "127114": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Kharak Kalan SO"
  },
  "127201": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Loharu SO"
  },
  "127309": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Manheru SO"
  },
  "127043": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Rodhan SO"
  },
  "127031": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Tigrana SO"
  },
  "833217": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "Noamundi SO"
  },
  "833202": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "Tata College Chaibasa SO"
  },
  "832301": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Chakulia SO"
  },
  "832303": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Ghatsila SO"
  },
  "832102": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Jadugoda Mines SO"
  },
  "835103": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Tatisilway SO"
  },
  "835227": {
    "state": "JHARKHAND",
    "district": "KHUNTI",
    "office": "Torpa SO"
  },
  "835221": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Tupudana SO"
  },
  "211008": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Naini SO"
  },
  "636902": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Eachambadi S.O"
  },
  "636805": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Mallupatti S.O"
  },
  "636904": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Menisi S.O"
  },
  "591232": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Madbhavi S.O"
  },
  "591235": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Mugalkhod S.O"
  },
  "591240": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Satti S.O"
  },
  "591265": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Telsang S.O"
  },
  "591316": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Ugarkhurd S.O"
  },
  "591211": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Akol S.O"
  },
  "591213": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Ankali S.O"
  },
  "591214": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Bedkihal S.O"
  },
  "591215": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Benadi S.O"
  },
  "591201": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Chikodi Bazar S.O"
  },
  "591222": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Kabbur S.O"
  },
  "140506": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Dappar Ad SO"
  },
  "140507": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Derabassi SO"
  },
  "140501": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Lalru SO"
  },
  "754112": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Bentakar S.O"
  },
  "127026": {
    "state": "HARYANA",
    "district": "CHARKI DADRI",
    "office": "Birhi Kalan SO"
  },
  "127306": {
    "state": "HARYANA",
    "district": "CHARKI DADRI",
    "office": "Charkhi Dadri City SO"
  },
  "127022": {
    "state": "HARYANA",
    "district": "CHARKI DADRI",
    "office": "Chiriya SO"
  },
  "127310": {
    "state": "HARYANA",
    "district": "CHARKI DADRI",
    "office": "Jhojhu SO"
  },
  "127042": {
    "state": "HARYANA",
    "district": "CHARKI DADRI",
    "office": "Sanwar SO Bhiwani"
  },
  "560090": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Chikkabanavara S.O"
  },
  "560089": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Hessarghatta Lake S.O"
  },
  "562107": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Attibele S.O"
  },
  "563101": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Kolar Hospital Circle S.O"
  },
  "563157": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "VEMAGAL SO"
  },
  "563130": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Malur S.O"
  },
  "563163": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Chikkathirupathi S.O"
  },
  "563139": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Masthi S.O"
  },
  "572129": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Gokula Extn Koratagere S.O"
  },
  "572107": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "M C Campus Tumakuru S.O"
  },
  "572132": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "P. W. D. Colony (Madhugiri) S.O"
  },
  "816120": {
    "state": "JHARKHAND",
    "district": "SAHEBGANJ",
    "office": "Borio SO"
  },
  "816105": {
    "state": "JHARKHAND",
    "district": "PAKUR",
    "office": "Kotalpokhar SO"
  },
  "813208": {
    "state": "JHARKHAND",
    "district": "SAHEBGANJ",
    "office": "Mirzachowki SO"
  },
  "832304": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Mahulia SO"
  },
  "831012": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "MGM Medical College SO"
  },
  "832104": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Mosabani Mines SO"
  },
  "832105": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Patamda SO"
  },
  "832106": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Rakha Copper Project SO"
  },
  "831002": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Tatanagar SO"
  },
  "173022": {
    "state": "HIMACHAL PRADESH",
    "district": "SIRMAUR",
    "office": "Dadahu SO"
  },
  "173030": {
    "state": "HIMACHAL PRADESH",
    "district": "SIRMAUR",
    "office": "Kala Amb SO"
  },
  "173104": {
    "state": "HIMACHAL PRADESH",
    "district": "SIRMAUR",
    "office": "Nohra SO"
  },
  "173233": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Patta SO"
  },
  "173214": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Solan Brewery SO"
  },
  "173206": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Subathu SO"
  },
  "173234": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Waknaghat SO"
  },
  "177110": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Chintpurni SO"
  },
  "814118": {
    "state": "JHARKHAND",
    "district": "DUMKA",
    "office": "Basukinathdham SO"
  },
  "814158": {
    "state": "JHARKHAND",
    "district": "DUMKA",
    "office": "Guhiajori SO"
  },
  "816104": {
    "state": "JHARKHAND",
    "district": "PAKUR",
    "office": "Hiranpur SO"
  },
  "814141": {
    "state": "JHARKHAND",
    "district": "DUMKA",
    "office": "Jarmundi SO"
  },
  "762019": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Sankarakhole S.O"
  },
  "762010": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Tikabali S.O"
  },
  "762107": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Tumudibandha S.O"
  },
  "209501": {
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "office": "Nawabganj SO Farrukhabad"
  },
  "762020": {
    "state": "ODISHA",
    "district": "BOUDH",
    "office": "Harabhanga S.O"
  },
  "762023": {
    "state": "ODISHA",
    "district": "BOUDH",
    "office": "Jhadrajing S.O"
  },
  "762017": {
    "state": "ODISHA",
    "district": "BOUDH",
    "office": "Kantamal S.O"
  },
  "762016": {
    "state": "ODISHA",
    "district": "BOUDH",
    "office": "Manamunda S.O"
  },
  "754100": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Biribati S.O"
  },
  "753011": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Gopalpur S.O (Cuttack)"
  },
  "581363": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Ambikanagar S.O"
  },
  "581315": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Aminalli S.O"
  },
  "581322": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Bilgi S.O (Uttara Kannada)"
  },
  "581329": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Haliyal S.O"
  },
  "627104": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Idindakarai SO"
  },
  "627501": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Kalakad SO"
  },
  "627353": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Kizhanatham SO"
  },
  "627107": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Mavadi SO"
  },
  "577523": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Chickjajur S.O"
  },
  "172021": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Nankhari SO"
  },
  "172022": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Nogli SO"
  },
  "574122": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Bajegoli S.O"
  },
  "576112": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Hebri S.O"
  },
  "574129": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Kanthavara S.O"
  },
  "574101": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Ajekar S.O"
  },
  "574102": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Bailur S.O"
  },
  "581331": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Heggarni S.O"
  },
  "581336": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Hulekal S.O"
  },
  "571415": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Arakere S.O"
  },
  "571445": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Devalapura S.O (Mandya)"
  },
  "571477": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Ganjam S.O"
  },
  "571435": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Pandavapura R S S.O"
  },
  "762013": {
    "state": "ODISHA",
    "district": "BOUDH",
    "office": "Purunakatak S.O"
  },
  "832401": {
    "state": "JHARKHAND",
    "district": "SARAIKELA KHARSAWAN",
    "office": "Chandil SO"
  },
  "342001": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Siwanchi Gate SO"
  },
  "175038": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Nihri SO"
  },
  "175046": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Pangna SO"
  },
  "175017": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Slapper SO"
  },
  "175018": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Sunder Nagar1 SO"
  },
  "175009": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Tattapani SO"
  },
  "175048": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Thunag SO"
  },
  "828401": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Gomoh SO"
  },
  "814103": {
    "state": "JHARKHAND",
    "district": "DUMKA",
    "office": "Kathikund SO"
  },
  "173021": {
    "state": "HIMACHAL PRADESH",
    "district": "SIRMAUR",
    "office": "Majra SO Sirmaur"
  },
  "173220": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Parwanoo SO"
  },
  "174102": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Ramshahar SO"
  },
  "176311": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Mehla SO"
  },
  "176321": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Nakror SO"
  },
  "176319": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Pukhri SO"
  },
  "176320": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Salooni SO"
  },
  "176207": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Sihunta SO"
  },
  "814166": {
    "state": "JHARKHAND",
    "district": "JAMTARA",
    "office": "Fatehpur SO Jamtara"
  },
  "176301": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Bakloh SO"
  },
  "176308": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "BHALEI SO"
  },
  "176316": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Bhanjraru Tissa"
  },
  "176315": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Bharmour SO"
  },
  "176302": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Chowari SO"
  },
  "176326": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Holi SO"
  },
  "176309": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Garola SO"
  },
  "176318": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Hardaspura SO"
  },
  "342014": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Pal SO"
  },
  "581327": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Haldipur S.O"
  },
  "581330": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Hegde S.O"
  },
  "581332": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Herwatta S.O"
  },
  "345026": {
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "office": "Sankra SO Jaisalmer"
  },
  "628623": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Thenthiruperai S.O"
  },
  "832108": {
    "state": "JHARKHAND",
    "district": "SARAIKELA KHARSAWAN",
    "office": "Gamharia SO"
  },
  "832107": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Sundarnagar SO"
  },
  "832403": {
    "state": "JHARKHAND",
    "district": "SARAIKELA KHARSAWAN",
    "office": "Tiruldih SO"
  },
  "562149": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Bagalur S.O (Bengaluru)"
  },
  "686508": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kalaketty SO"
  },
  "686511": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kunnam Vechoochira SO"
  },
  "686513": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Mundakayam SO"
  },
  "686512": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Parathode SO Kottayam"
  },
  "686506": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Ponkunnam SO"
  },
  "628621": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Puthukudi S.O"
  },
  "272153": {
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTH NAGAR",
    "office": "Basantpur BO"
  },
  "176323": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Killar Pangi SO"
  },
  "176325": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Samleu SO"
  },
  "814119": {
    "state": "JHARKHAND",
    "district": "DUMKA",
    "office": "Kurwa SO"
  },
  "816106": {
    "state": "JHARKHAND",
    "district": "PAKUR",
    "office": "Maheshpur Raj SO"
  },
  "814144": {
    "state": "JHARKHAND",
    "district": "DUMKA",
    "office": "Massanjore SO"
  },
  "174303": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "DisttCourt Una SO"
  },
  "177203": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Amb SO"
  },
  "174307": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Bangana SO"
  },
  "177109": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Bharwain SO"
  },
  "174316": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Bhera SO"
  },
  "177204": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Daulatpurchowk SO"
  },
  "174306": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Dehlan SO"
  },
  "176601": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Dulehar SO"
  },
  "177201": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Gagret SO"
  },
  "673525": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Perampra SO"
  },
  "175039": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Jachh SO"
  },
  "134102": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "Pinjore S.O"
  },
  "172026": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Anni SO"
  },
  "172032": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Chowai SO"
  },
  "172023": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Nirmand SO"
  },
  "172107": {
    "state": "HIMACHAL PRADESH",
    "district": "KINNAUR",
    "office": "Reckong Peo HO"
  },
  "172105": {
    "state": "HIMACHAL PRADESH",
    "district": "KINNAUR",
    "office": "Karcham SO"
  },
  "172111": {
    "state": "HIMACHAL PRADESH",
    "district": "KINNAUR",
    "office": "Pooh SO"
  },
  "172116": {
    "state": "HIMACHAL PRADESH",
    "district": "KINNAUR",
    "office": "Ribba SO"
  },
  "577555": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Godabanahal S.O"
  },
  "673574": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Unnikulam SO"
  },
  "673308": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Chombala SO"
  },
  "673502": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Edacheri SO"
  },
  "682303": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Ambalamedu SO"
  },
  "682312": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Chottanikkara SO"
  },
  "695010": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Sasthamangalam SO"
  },
  "590010": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Belagavi Nehru Nagar S.O"
  },
  "686520": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Chirakadavu SO"
  },
  "686509": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Erumely SO"
  },
  "686522": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Koorali SO"
  },
  "695543": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Vellanad SO"
  },
  "689112": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Chathankary SO"
  },
  "686547": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Chunkapara SO"
  },
  "689586": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Ezhumattoor SO"
  },
  "689587": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Keezhvaipur SO"
  },
  "689615": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kottanad SO"
  },
  "689549": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Maramon SO"
  },
  "689613": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Theodical SO"
  },
  "689113": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Azhiyadathuchira SO"
  },
  "695512": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kuvalassery SO"
  },
  "695526": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Pulluvila SO"
  },
  "695525": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Puvar SO"
  },
  "686518": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Koovapally SO"
  },
  "560087": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Vartur S.O"
  },
  "560117": {
    "state": "KARNATAKA",
    "district": "BENGALURU RURAL",
    "office": "Doddadunnasandra S.O"
  },
  "586118": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Kalkeri S.O"
  },
  "121004": {
    "state": "HARYANA",
    "district": "FARIDABAD",
    "office": "Ballabgarh SO"
  },
  "121107": {
    "state": "HARYANA",
    "district": "PALWAL",
    "office": "Hassanpur SO"
  },
  "121103": {
    "state": "HARYANA",
    "district": "PALWAL",
    "office": "Hathin SO"
  },
  "160101": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Manimajra SO"
  },
  "160003": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Aerodrome SO"
  },
  "586122": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Mangoli S.O"
  },
  "586127": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Shivangi S.O"
  },
  "673102": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Madappalli College SO"
  },
  "673504": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Nadapuram SO"
  },
  "673503": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Purameri SO"
  },
  "673541": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Thiruvallur SO"
  },
  "673613": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Nanminda SO"
  },
  "171301": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Sunni Bhajji SO"
  },
  "590008": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Udyambag S.O"
  },
  "232118": {
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "office": "Sahabganj SO Chandauli"
  },
  "831004": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Telco Plaza Market SO"
  },
  "832112": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Boram SO"
  },
  "833204": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "JMP Chowk SO"
  },
  "345022": {
    "state": "RAJASTHAN",
    "district": "JAISALMER",
    "office": "Ramgarh SO Jaisalmer"
  },
  "584123": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Manvi S.O"
  },
  "584202": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Matmari S.O"
  },
  "584126": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Mosarkal S.O"
  },
  "628204": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Kayalpatnam S.O"
  },
  "585330": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Humnabad S.O"
  },
  "585417": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Kamalnagar S.O"
  },
  "585226": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Kamthana S.O"
  },
  "686510": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Mukkoottuthara SO"
  },
  "686502": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Pampady SO"
  },
  "127041": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Mundhal Khurd SO"
  },
  "585353": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "Maniknagar S.O"
  },
  "591230": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Kokatnur S.O"
  },
  "591234": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Mangsuli S.O"
  },
  "481998": {
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "office": "Anjania S.O"
  },
  "581111": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Hirekerur S.O"
  },
  "581213": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Hosaritti S.O"
  },
  "581126": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Hulgur S.O"
  },
  "581123": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Kumarapattanam S.O"
  },
  "581210": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Masur S.O (Haveri)"
  },
  "581115": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Ranebennur Extn S.O"
  },
  "572105": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Maralur S.O"
  },
  "572133": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Medigeshi S.O"
  },
  "572106": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Northren Extension S.O"
  },
  "572135": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "P N Halli S.O"
  },
  "572136": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Palavalli S.O"
  },
  "563125": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Chintamani Bazar S.O"
  },
  "563162": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Deshihalli Bangarpet S.O"
  },
  "563127": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Devarayasamudra S.O"
  },
  "563161": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Gownipalli S.O"
  },
  "636352": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Thoppur S.O"
  },
  "636701": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Dharmapuri South S.O"
  },
  "581116": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Rattihalli S.O"
  },
  "581148": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Sangur S.O"
  },
  "581118": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Savanur S.O"
  },
  "581237": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Kadkol S.O"
  },
  "581205": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Shiggaon S.O"
  },
  "581120": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Tilavalli S.O"
  },
  "481995": {
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "office": "Bhuabichhia S.O"
  },
  "481672": {
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "office": "Chabi S.O"
  },
  "281121": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Loi Bazar SO"
  },
  "172106": {
    "state": "HIMACHAL PRADESH",
    "district": "KINNAUR",
    "office": "Sangla SO"
  },
  "209651": {
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "office": "Mohamdabad SO"
  },
  "835201": {
    "state": "JHARKHAND",
    "district": "SIMDEGA",
    "office": "Bano SO"
  },
  "835228": {
    "state": "JHARKHAND",
    "district": "SIMDEGA",
    "office": "Biru SO"
  },
  "835235": {
    "state": "JHARKHAND",
    "district": "SIMDEGA",
    "office": "Gotra SO"
  },
  "835211": {
    "state": "JHARKHAND",
    "district": "SIMDEGA",
    "office": "Kolebira SO"
  },
  "591263": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Bhoj S.O"
  },
  "591217": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Chinchali S.O"
  },
  "591226": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Karoshi S.O"
  },
  "591228": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Khadaklat S.O"
  },
  "591311": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Kudchi S.O"
  },
  "591237": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Nipani S.O"
  },
  "591238": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Pattankudi S.O"
  },
  "835212": {
    "state": "JHARKHAND",
    "district": "SIMDEGA",
    "office": "Kurdeg SO"
  },
  "835213": {
    "state": "JHARKHAND",
    "district": "LOHARDAGA",
    "office": "Kuru SO"
  },
  "211011": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Rajrooppur SO"
  },
  "212205": {
    "state": "UTTAR PRADESH",
    "district": "KAUSHAMBI",
    "office": "Kara SO"
  },
  "762026": {
    "state": "ODISHA",
    "district": "BOUDH",
    "office": "Sarsara S.O"
  },
  "835229": {
    "state": "JHARKHAND",
    "district": "GUMLA",
    "office": "Basia SO"
  },
  "835203": {
    "state": "JHARKHAND",
    "district": "GUMLA",
    "office": "Bharno SO"
  },
  "835231": {
    "state": "JHARKHAND",
    "district": "GUMLA",
    "office": "Bishunpur SO"
  },
  "835206": {
    "state": "JHARKHAND",
    "district": "GUMLA",
    "office": "Chainpur SO Gumla"
  },
  "835208": {
    "state": "JHARKHAND",
    "district": "GUMLA",
    "office": "Ghaghra SO"
  },
  "127046": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Siwani SO"
  },
  "127040": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Tosham SO"
  },
  "487330": {
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "office": "Barman S.O"
  },
  "487770": {
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "office": "Chichli S.O"
  },
  "487334": {
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "office": "Dobhi S.O (M.P Circle)"
  },
  "560073": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Nagasandra S.O (Bengaluru)"
  },
  "431718": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Karadkhed S.O"
  },
  "431808": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Karkheli S.O"
  },
  "431804": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Kinwat S.O"
  },
  "172024": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Kingal SO"
  },
  "172029": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Kumarsain SO"
  },
  "172102": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Sarahan BSR SO"
  },
  "172030": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Thanedhar SO"
  },
  "172114": {
    "state": "HIMACHAL PRADESH",
    "district": "LAHUL AND SPITI",
    "office": "Kaza SO"
  },
  "172117": {
    "state": "HIMACHAL PRADESH",
    "district": "LAHUL AND SPITI",
    "office": "Sagnam SO"
  },
  "172113": {
    "state": "HIMACHAL PRADESH",
    "district": "LAHUL AND SPITI",
    "office": "Tabo SO"
  },
  "172108": {
    "state": "HIMACHAL PRADESH",
    "district": "KINNAUR",
    "office": "Kalpa SO"
  },
  "172118": {
    "state": "HIMACHAL PRADESH",
    "district": "KINNAUR",
    "office": "Katgaon SO"
  },
  "172112": {
    "state": "HIMACHAL PRADESH",
    "district": "KINNAUR",
    "office": "Liyo SO"
  },
  "172109": {
    "state": "HIMACHAL PRADESH",
    "district": "KINNAUR",
    "office": "Moorang SO"
  },
  "182101": {
    "state": "JAMMU AND KASHMIR",
    "district": "UDHAMPUR",
    "office": "Udhampur District Court SO"
  },
  "131305": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Kanyagurukul Khanpur SO"
  },
  "131402": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Kharkhauda SO"
  },
  "431742": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Kurula S.O"
  },
  "431708": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Loha S.O"
  },
  "431721": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Mahore S.O (Nanded)"
  },
  "431805": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Mandvi S.O (Nanded)"
  },
  "686585": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Chengalam SO"
  },
  "686555": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Devagiri SO"
  },
  "686521": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Pampady South SO"
  },
  "686515": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Pulickakavala SO"
  },
  "686519": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Thekkethukavala SO"
  },
  "686501": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Velloor SO"
  },
  "562117": {
    "state": "KARNATAKA",
    "district": "RAMANAGARA",
    "office": "Kanakapura S.O"
  },
  "562119": {
    "state": "KARNATAKA",
    "district": "RAMANAGARA",
    "office": "Kodihalli S.O"
  },
  "561101": {
    "state": "KARNATAKA",
    "district": "RAMANAGARA",
    "office": "Kudur S.O"
  },
  "326036": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Raipur S.O (Jhalawar)"
  },
  "326035": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Sarola S.O"
  },
  "131027": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Murthal SO"
  },
  "131029": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "PSRai SO"
  },
  "131102": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Purkhas SO"
  },
  "131403": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Rohat SO Sonipat"
  },
  "560068": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Bommanahalli S.O (Bengaluru)"
  },
  "679501": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Panamanna SO"
  },
  "679336": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Vallapuzha SO"
  },
  "560082": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Udaypura S.O"
  },
  "131306": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Mundlana SO"
  },
  "131103": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "Nahri SO"
  },
  "173211": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Saproon SO"
  },
  "281006": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Refinery Nagar SO"
  },
  "581119": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Tumminakatti S.O"
  },
  "581198": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Motebennur S.O"
  },
  "342309": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Peelwa SO"
  },
  "142037": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Badhni Kalan SO"
  },
  "142038": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Baghapurana SO"
  },
  "232107": {
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "office": "Ramgarh SO Chandauli"
  },
  "221008": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Ram Nagar Pac SO"
  },
  "232120": {
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "office": "Sadalpura SO"
  },
  "142039": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Bilaspur Moga SO"
  },
  "142011": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Dala SO"
  },
  "142053": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Dhudike SO"
  },
  "142048": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Ghall Kalan SO"
  },
  "581338": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Kadtoka S.O"
  },
  "581314": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Ankola S.O"
  },
  "581316": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Aversa S.O"
  },
  "581306": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Habbuwada S.O"
  },
  "581328": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Halge S.O"
  },
  "581339": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Kadwad S.O"
  },
  "581302": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Karwar Baitkhol S.O"
  },
  "581308": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Karwar Naval Base S.O"
  },
  "581345": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Majali S.O"
  },
  "581352": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Sadashivgad S.O"
  },
  "581353": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Shetgeri S.O"
  },
  "581357": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Vandige S.O"
  },
  "581319": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Bankikodla S.O"
  },
  "585291": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Rajankollur S.O"
  },
  "581326": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Gokarn S.O"
  },
  "584125": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Mudgal S.O"
  },
  "584102": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Raichur Mukram Gunj S.O"
  },
  "584104": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Raichur UAS S.O"
  },
  "584127": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Rodalbanda S.O"
  },
  "584170": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Shaktinagar S.O (Raichur)"
  },
  "584128": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Sindhanur S.O"
  },
  "584132": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Turvihal S.O"
  },
  "584134": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Yeramarus S.O"
  },
  "584124": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Maski S.O"
  },
  "581402": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Sirsi Market S.O"
  },
  "160014": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Dadu Majra Colony SO"
  },
  "326501": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Shrichhattarpur S.O"
  },
  "627109": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Panagudi SO"
  },
  "627652": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Ittamozhi SO"
  },
  "627106": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Kudankulam SO"
  },
  "630713": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Suranam SO"
  },
  "574213": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Belvai S.O"
  },
  "577145": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Bukkambudhi S.O"
  },
  "577146": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Kalasapura S.O"
  },
  "272171": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Lalganj Basti SO"
  },
  "574104": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Karkala West S.O"
  },
  "174302": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Dhussara SO"
  },
  "816103": {
    "state": "JHARKHAND",
    "district": "DUMKA",
    "office": "Benagaria SO"
  },
  "577130": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Mallandur S.O"
  },
  "577131": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Mallenahalli S.O"
  },
  "577132": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Mudigere S.O"
  },
  "577133": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Mugthihalli S.O"
  },
  "577182": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Panchanahalli S.O"
  },
  "577136": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Sangameshwarapete S.O"
  },
  "577138": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Singatagere S.O"
  },
  "577137": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Santaveri S.O"
  },
  "577550": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Sollapura S.O"
  },
  "577126": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Koppa H.O"
  },
  "172110": {
    "state": "HIMACHAL PRADESH",
    "district": "KINNAUR",
    "office": "Speelo SO"
  },
  "172002": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Arsu SO"
  },
  "172025": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Dalash SO"
  },
  "172033": {
    "state": "HIMACHAL PRADESH",
    "district": "KULLU",
    "office": "Nither SO"
  },
  "799101": {
    "state": "TRIPURA",
    "district": "Gomati",
    "office": "Amarpur S.O (South Tripura)"
  },
  "799114": {
    "state": "TRIPURA",
    "district": "Gomati",
    "office": "Gakulpur S.O"
  },
  "799125": {
    "state": "TRIPURA",
    "district": "Gomati",
    "office": "Garjee S.O"
  },
  "799104": {
    "state": "TRIPURA",
    "district": "Gomati",
    "office": "Jatanbari S.O"
  },
  "176303": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Banikhet SO"
  },
  "174314": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Chowki Maniar SO"
  },
  "814145": {
    "state": "JHARKHAND",
    "district": "DUMKA",
    "office": "Nonihat SO"
  },
  "816107": {
    "state": "JHARKHAND",
    "district": "PAKUR",
    "office": "Pakur RS SO"
  },
  "673523": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Payyoli Angadi SO"
  },
  "673529": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Tikkoti SO"
  },
  "673521": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Iringal SO"
  },
  "695505": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Vellarada SO"
  },
  "638672": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Dalavoipatnam SO"
  },
  "638451": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Bhavanisagar SO"
  },
  "638108": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Nathakadayur SO"
  },
  "641103": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Irugur SO"
  },
  "682313": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Arakunnam SO"
  },
  "682027": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "ChittoorEkm SO"
  },
  "563131": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Mulbagal S.O"
  },
  "563132": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Nangli S.O"
  },
  "563120": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Oorgaum S.O"
  },
  "563134": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Rayalpadu S.O"
  },
  "563122": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "ROBERTSONPET MDG"
  },
  "326513": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Sunel S.O"
  },
  "325202": {
    "state": "RAJASTHAN",
    "district": "BARAN",
    "office": "Anta S.O"
  },
  "325223": {
    "state": "RAJASTHAN",
    "district": "BARAN",
    "office": "Atone S.O"
  },
  "325218": {
    "state": "RAJASTHAN",
    "district": "BARAN",
    "office": "ATRU S.O"
  },
  "325205": {
    "state": "RAJASTHAN",
    "district": "BARAN",
    "office": "Krishi Upaj Mandi Baran S.O"
  },
  "487551": {
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "office": "Jawaharganj Gadarwara S.O"
  },
  "487118": {
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "office": "Gotegaon S.O"
  },
  "487114": {
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "office": "Karakbel S.O"
  },
  "563135": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Srinivaspur S.O"
  },
  "563103": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Tamaka S.O"
  },
  "563136": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Tayalur S.O"
  },
  "563137": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Tekal S.O"
  },
  "176324": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Gehra SO"
  },
  "487221": {
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "office": "Kareli S.O"
  },
  "487555": {
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "office": "Kaudia S.O"
  },
  "325222": {
    "state": "RAJASTHAN",
    "district": "BARAN",
    "office": "Bohat S.O"
  },
  "325220": {
    "state": "RAJASTHAN",
    "district": "BARAN",
    "office": "Chhabra S.O"
  },
  "560049": {
    "state": "KARNATAKA",
    "district": "BENGALURU RURAL",
    "office": "Virgonagar S.O"
  },
  "325207": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Bapawar S.O"
  },
  "326520": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Aditya Nagar S.O"
  },
  "325214": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Ayana S.O"
  },
  "828106": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Dhansar SO"
  },
  "584103": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Raichur Patel Road S.O"
  },
  "142056": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Gholia Khurd SO"
  },
  "326518": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Chechat S.O"
  },
  "444906": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Warud S.O"
  },
  "172031": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Kotgarh SO"
  },
  "172115": {
    "state": "HIMACHAL PRADESH",
    "district": "KINNAUR",
    "office": "Bhaba Nagar SO"
  },
  "799157": {
    "state": "TRIPURA",
    "district": "South Tripura",
    "office": "Anandapur S.O (South Tripura)"
  },
  "444908": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Jarud S.O"
  },
  "444806": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Achalpur City S.O"
  },
  "444705": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Surji  (Anjangaon) S.O"
  },
  "641401": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Kangayampalayam SO"
  },
  "695564": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Karakulam SO"
  },
  "695002": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Karamana SO"
  },
  "142040": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Butter SO"
  },
  "673009": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Malaparamba SO"
  },
  "673012": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Marikunnu SO"
  },
  "673309": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Azhiyur SO"
  },
  "631301": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Ammavarikuppam S.O"
  },
  "799155": {
    "state": "TRIPURA",
    "district": "South Tripura",
    "office": "Beloniya S.O"
  },
  "799103": {
    "state": "TRIPURA",
    "district": "Sepahijala",
    "office": "Bishramganj S.O"
  },
  "799156": {
    "state": "TRIPURA",
    "district": "South Tripura",
    "office": "Hrishyamukh S.O"
  },
  "577179": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Balehole S.O"
  },
  "577112": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Balehonnur S.O"
  },
  "577114": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Basarikatte S.O"
  },
  "577120": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Hariharapura S.O"
  },
  "577124": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Kalasa S.O"
  },
  "577127": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Kudregundi S.O"
  },
  "577134": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Narasimharajapura S.O"
  },
  "577139": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Sringeri S.O"
  },
  "133101": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Bihta S.O (Ambala)"
  },
  "584129": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Sirwar S.O"
  },
  "577168": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Uddeboranahalli S.O"
  },
  "577140": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Yagati S.O"
  },
  "577123": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Jayapura S.O"
  },
  "631302": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Erumbi S.O"
  },
  "602021": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Ikkadu S.O"
  },
  "631203": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Kadambathur S.O"
  },
  "631206": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Madduru S.O"
  },
  "631207": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Pallipat S.O"
  },
  "631402": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Perambakkam S.O"
  },
  "601102": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Periapalayam S.O"
  },
  "631208": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Podaturpeta S.O"
  },
  "602023": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Poondi S.O"
  },
  "631211": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Saraswathinagar S.O"
  },
  "695521": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Vizhinjam SO"
  },
  "695504": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Karakonam SO"
  },
  "431806": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Mudkhed Station S.O"
  },
  "431719": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Mukramabad S.O"
  },
  "431715": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Mukhed S.O"
  },
  "581318": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Banavasi S.O"
  },
  "581121": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Castlerock S.O"
  },
  "581325": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Channammacircle S.O"
  },
  "587205": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Katageri S.O"
  },
  "140201": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Mubarakpur SO Patiala"
  },
  "695125": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Ottasekharamangalam SO"
  },
  "171013": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Mehli SO"
  },
  "695124": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Perumkadavila SO"
  },
  "695506": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Uchakada SO"
  },
  "695523": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Venganur SO"
  },
  "563128": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Kaiwara S.O"
  },
  "563146": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Murugamale S.O"
  },
  "144631": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "Nangal Lubana SO"
  },
  "121003": {
    "state": "HARYANA",
    "district": "FARIDABAD",
    "office": "Mathura Road Faridabad SO"
  },
  "602024": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Tiruninravur Rs S.O"
  },
  "602025": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Tirur Cpt S.O"
  },
  "631209": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Tiruttanieast S.O"
  },
  "631210": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Tiruvelangadu S.O"
  },
  "602026": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Uttukottai S.O"
  },
  "631202": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Athimanjeripeta S.O"
  },
  "631205": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Kg Kandigai S.O"
  },
  "602002": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Manavalanagar S.O"
  },
  "561202": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Pavagada S.O"
  },
  "581103": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Alnavar S.O"
  },
  "577175": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Devanur S.O"
  },
  "768029": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Barpali S.O"
  },
  "768030": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Bhatli S.O"
  },
  "768104": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Bheden S.O"
  },
  "768045": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Bhukta S.O"
  },
  "768032": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Bijepur S.O"
  },
  "768052": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Dunguri Lsq Colony Campus S.O"
  },
  "768037": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Gaisilet S.O"
  },
  "768034": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Ghess S.O"
  },
  "768042": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Jharbandh S.O"
  },
  "768048": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Laumunda S.O"
  },
  "584135": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Yeramarus Camp S.O"
  },
  "584133": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Yergera S.O"
  },
  "581112": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Karajagi S.O (Haveri)"
  },
  "581211": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Medleri S.O"
  },
  "581110": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Haveri R.N. S.O"
  },
  "581102": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Akkialur S.O"
  },
  "481771": {
    "state": "MADHYA PRADESH",
    "district": "MANDLA",
    "office": "Bamni S.O"
  },
  "581202": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Bankapur S.O"
  },
  "581203": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Bommanahalli S.O (Haveri)"
  },
  "581106": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Byadgi N.N. S.O"
  },
  "581193": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Dhundashi S.O"
  },
  "581208": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Halageri S.O"
  },
  "581104": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Hangal S.O"
  },
  "581109": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Haunsabhavi S.O"
  },
  "342301": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Phalodi Sadar Bazar SO"
  },
  "585222": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Sedam S.O"
  },
  "768050": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Mandosil S.O"
  },
  "768035": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Melchhamunda S.O"
  },
  "768039": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Paikmal S.O"
  },
  "768036": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Rajborasamber S.O"
  },
  "577160": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Magundi S.O"
  },
  "577144": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Rangenahalli S.O"
  },
  "563133": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Narasapura S.O"
  },
  "563121": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Oorgaumpet S.O"
  },
  "752061": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Baghamari S.O"
  },
  "572175": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Puravara S.O"
  },
  "572104": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Siddaganga Mutt S.O"
  },
  "695009": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Manacaud SO"
  },
  "585225": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Wadi S.O (Kalaburagi)"
  },
  "581317": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Asnoti S.O"
  },
  "581396": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Kadra S.O"
  },
  "581400": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Kaiga S.O"
  },
  "581301": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Karwar Market S.O"
  },
  "585321": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Ramasamudra S.O (Yadgir)"
  },
  "585220": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Rangampeth S.O"
  },
  "585323": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Sagar S.O"
  },
  "581337": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Idgundi S.O"
  },
  "757038": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Thakurmunda S.O"
  },
  "757053": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Tiring S.O"
  },
  "591287": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Kothali S.O"
  },
  "591317": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Raibag S.O"
  },
  "591241": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Saundalga S.O"
  },
  "585221": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Saidapur S.O (Yadgir)"
  },
  "585223": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Shahapur Town S.O"
  },
  "284403": {
    "state": "UTTAR PRADESH",
    "district": "LALITPUR",
    "office": "Lalitpur Railway Station SO"
  },
  "284402": {
    "state": "UTTAR PRADESH",
    "district": "LALITPUR",
    "office": "Banpur SO Lalitpur"
  },
  "284122": {
    "state": "UTTAR PRADESH",
    "district": "LALITPUR",
    "office": "Bansi SO Lalitpur"
  },
  "284123": {
    "state": "UTTAR PRADESH",
    "district": "LALITPUR",
    "office": "Barh SO Lalitpur"
  },
  "284124": {
    "state": "UTTAR PRADESH",
    "district": "LALITPUR",
    "office": "Jakhaura SO"
  },
  "284405": {
    "state": "UTTAR PRADESH",
    "district": "LALITPUR",
    "office": "Mahroni SO"
  },
  "480555": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Damua S.O"
  },
  "480449": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Eklehra S.O"
  },
  "480224": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Harrai S.O"
  },
  "480551": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Junnardeo S.O"
  },
  "480108": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Lodhikheda S.O"
  },
  "480105": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Mohgaon Haveli S.O"
  },
  "160002": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Ram Darbar SO"
  },
  "160036": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Sector 40 Chandigarh SO"
  },
  "571455": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Chinakurali S.O"
  },
  "591244": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Yaksamba S.O"
  },
  "695502": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Parassala SO"
  },
  "695133": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Tirupuram SO"
  },
  "121002": {
    "state": "HARYANA",
    "district": "FARIDABAD",
    "office": "Faridabad Sector 16 SO"
  },
  "757036": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Tato S.O"
  },
  "591216": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Borgaon S.O (Belagavi)"
  },
  "591239": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Sadalga S.O"
  },
  "431709": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Naigaon S.O (Nanded)"
  },
  "431743": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Niwgha S.O"
  },
  "431723": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Shahapur S.O (Nanded)"
  },
  "431736": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Shankarnagar S.O"
  },
  "431711": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Kundalwadi S.O"
  },
  "313704": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Sayra S.O"
  },
  "581365": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Ganeshgudi S.O"
  },
  "752120": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "NUAPALAMHAT S.O"
  },
  "313903": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Semari S.O"
  },
  "313001": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Udaipur Surajpole S.O"
  },
  "577129": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Lingadahalli S.O"
  },
  "577549": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Sivane S.O"
  },
  "313601": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Vallabhnagar S.O (Udaipur)"
  },
  "686504": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Vazhoor SO"
  },
  "313206": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Sanwar S.O (Udaipur)"
  },
  "313902": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Sarara S.O"
  },
  "313904": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Chawand S.O"
  },
  "431707": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Osmannagar S.O (Nanded)"
  },
  "431731": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Sagroli S.O"
  },
  "682024": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Edapally SO"
  },
  "673638": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Kondotti SO"
  },
  "673641": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Kuzhimanna SO"
  },
  "676542": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Mampad SO"
  },
  "679333": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Manimooly SO"
  },
  "676122": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Manjeri College SO"
  },
  "676525": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Kalikavu SO"
  },
  "676123": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Karuvambram SO"
  },
  "676523": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Karuvarakundu SO"
  },
  "577117": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "C.R.Station S.O"
  },
  "799141": {
    "state": "TRIPURA",
    "district": "South Tripura",
    "office": "Jolaibari S.O"
  },
  "250341": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "Dabathwa SO"
  },
  "250221": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "Daurala SO"
  },
  "250404": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "Hastinapur SO"
  },
  "250104": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "Kithore SO"
  },
  "577135": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Sakrepatna S.O"
  },
  "480557": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Newton Chikhali S.O"
  },
  "480334": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Pandhurna S.O"
  },
  "301001": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "H.B.Colony Alwar S.O"
  },
  "301028": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Bahadurpur S.O"
  },
  "301021": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Barodameo S.O"
  },
  "301414": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Dhigawara S.O"
  },
  "301413": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Garhi Sawai Ram S.O"
  },
  "321605": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Kathumar S.O"
  },
  "321606": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Kherli S.O"
  },
  "301405": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Kishan Garh Bass S.O"
  },
  "585355": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Wadgera S.O"
  },
  "585202": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Yadgiri Station S.O"
  },
  "577426": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Ripponpet S.O"
  },
  "680721": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Pariyaram SO Thrissur"
  },
  "680722": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Potta SO"
  },
  "680733": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Poyya SO"
  },
  "680303": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Varandarappilly SO"
  },
  "680688": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Aripalam SO"
  },
  "679303": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Pattambi SO"
  },
  "680687": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Chentrappinni SO"
  },
  "250004": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "L L R M Medcollege SO"
  },
  "250401": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "Mawana SO"
  },
  "250406": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "Parikshitgarh SO"
  },
  "250223": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "Sakoti Tanda SO"
  },
  "250342": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "CBSardhana SO"
  },
  "250344": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "Sarurpur Khurd SO"
  },
  "250002": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "SGMandi SO"
  },
  "250626": {
    "state": "UTTAR PRADESH",
    "district": "BAGHPAT",
    "office": "Baleni SO"
  },
  "250501": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "Jani SO"
  },
  "245206": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "Kharkhauda SO"
  },
  "250205": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "Mohiuddinpur SO"
  },
  "250222": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "Lawar SO"
  },
  "250106": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "Machhara SO"
  },
  "176313": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Kakira SO"
  },
  "160102": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Mauli Jagran SO"
  },
  "591315": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Shedbal S.O"
  },
  "591242": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Shirguppi S.O"
  },
  "313901": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Zawar Mines S.O"
  },
  "313024": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Zinc Smelter S.O"
  },
  "832402": {
    "state": "JHARKHAND",
    "district": "SARAIKELA KHARSAWAN",
    "office": "Kandra SO Seraikelakharsawan"
  },
  "793101": {
    "state": "MEGHALAYA",
    "district": "RI BHOI",
    "office": "Byrnihat S.O"
  },
  "680724": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kuttichira SO"
  },
  "680734": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kuzhur SO"
  },
  "680311": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Melur SO Thrissur"
  },
  "680305": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Nellayithrissur SO"
  },
  "680310": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Parappukkara SO"
  },
  "680301": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Pudukad SO"
  },
  "680561": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Cherpu SO"
  },
  "680568": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Edamuttam SO"
  },
  "680703": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Edathuruthy SO"
  },
  "680666": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Eriyad SO"
  },
  "680125": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Irinjalakuda North SO"
  },
  "680683": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kallettumkara SO"
  },
  "680308": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Koratti SO"
  },
  "480441": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Parasia S.O"
  },
  "480109": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Piplanarayanwar S.O"
  },
  "480331": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Saori Bazaar S.O"
  },
  "480106": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Sausar S.O"
  },
  "480337": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Seoni Sausar S.O"
  },
  "680732": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Malathrissur SO"
  },
  "680699": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Pady SO"
  },
  "680304": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Palappilly SO"
  },
  "768103": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Remunda S.O"
  },
  "273016": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Shivpurinewcolony SO"
  },
  "273213": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Sikriganj SO"
  },
  "273308": {
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "office": "Sonauli S.O"
  },
  "273406": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Unwal SO"
  },
  "273407": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Uruwa Bazar SO"
  },
  "273002": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "A.P.Station S.O"
  },
  "273155": {
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "office": "Anandnagar S.O  Maharajganj"
  },
  "273405": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Barhi S.O Gorakhpur"
  },
  "273306": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Bhathat S.O"
  },
  "273302": {
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "office": "Bhitauli Bazar S.O"
  },
  "273157": {
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "office": "Bribgemanganj S.O"
  },
  "273158": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Campierganj S.O"
  },
  "273201": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Chauri Chaura S.O"
  },
  "695126": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Perumpazhuthoor SO"
  },
  "631212": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Poonimangadu S.O"
  },
  "604202": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Gingee MDG"
  },
  "604210": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Illodu SO"
  },
  "604102": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Kiliyanur SO Villupuram"
  },
  "604302": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Kutteripattu SO"
  },
  "631204": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Kanakammachatram S.O"
  },
  "631213": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Ponpadi Rs S.O"
  },
  "631303": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Ramakrishnarajupeta S.O"
  },
  "631201": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Arungolam S.O"
  },
  "480223": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Singodi S.O"
  },
  "480559": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Tamia S.O"
  },
  "480338": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Teegaon S.O"
  },
  "480107": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Umaranala S.O"
  },
  "799251": {
    "state": "TRIPURA",
    "district": "North Tripura",
    "office": "Chandrapur S.O (North Tripura)"
  },
  "799207": {
    "state": "TRIPURA",
    "district": "Khowai",
    "office": "Chebri S.O"
  },
  "487661": {
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "office": "Sainkheda S.O (Narsinghpur)"
  },
  "487441": {
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "office": "Sihora S.O (Narsinghpur)"
  },
  "487110": {
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "office": "Singhpur S.O (Narsinghpur)"
  },
  "461001": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "Hoshangabad City S.O"
  },
  "461661": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "Babai S.O (Hoshangabad)"
  },
  "325221": {
    "state": "RAJASTHAN",
    "district": "BARAN",
    "office": "Chhipa Barod S.O"
  },
  "176306": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "BATHRI BAZAR SO"
  },
  "783133": {
    "state": "ASSAM",
    "district": "GOALPARA",
    "office": "Rajapara S.O"
  },
  "799290": {
    "state": "TRIPURA",
    "district": "Unakoti",
    "office": "Fatikroy S.O"
  },
  "799282": {
    "state": "TRIPURA",
    "district": "Unakoti",
    "office": "Gournagar SO"
  },
  "627862": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Virasigamani S.O"
  },
  "627851": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Alangulam S.O"
  },
  "627852": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Ayikudi S.O"
  },
  "571253": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Siddapura Kodagu S.O"
  },
  "571236": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Somwarpet S.O"
  },
  "768049": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Jamla S.O"
  },
  "273209": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Sahajanwa SO"
  },
  "487337": {
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "office": "Sagoni Tendukheda S.O"
  },
  "487881": {
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "office": "Sali Choka Road S.O"
  },
  "326517": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Morak S.O"
  },
  "571217": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Srimangala S.O"
  },
  "571237": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Suntikoppa S.O"
  },
  "571254": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Thithimathi S.O"
  },
  "571218": {
    "state": "KARNATAKA",
    "district": "KODAGU",
    "office": "Virajpet S.O"
  },
  "581360": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Angadi S.O (Uttara Kannada)"
  },
  "680518": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Agalad SO"
  },
  "470661": {
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "office": "Damoh R S S.O"
  },
  "691306": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Anchal SO"
  },
  "691533": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Ayur SO"
  },
  "691307": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Edamon SO"
  },
  "691322": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Elampal SO"
  },
  "691312": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Eroor SO Kollam"
  },
  "691309": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kalthuruthy SO"
  },
  "691310": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kulathupuzha SO"
  },
  "250402": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "Mawana Factory SO"
  },
  "250502": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "Rasulpur Rohta SO"
  },
  "464001": {
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "office": "Vidisha S.A.T.I. S.O"
  },
  "793106": {
    "state": "MEGHALAYA",
    "district": "SOUTH WEST KHASI HILLS",
    "office": "Balat S.O"
  },
  "627758": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Vasudevanallur S.O"
  },
  "689695": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Pathanapuram SO"
  },
  "689696": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Piravanthur SO"
  },
  "486441": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Baikunthpur S.O"
  },
  "481335": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Rampaily S.O"
  },
  "486669": {
    "state": "MADHYA PRADESH",
    "district": "SIDHI",
    "office": "Madwas S.O"
  },
  "486445": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Semariya S.O"
  },
  "689694": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kalanjoor SO"
  },
  "481449": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Tirodi S.O"
  },
  "481105": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Ukwa S.O"
  },
  "572137": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Sira S.O"
  },
  "572139": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Tavarekere S.O (Tumakuru)"
  },
  "572138": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Tovinakere S.O"
  },
  "572140": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Urdigere S.O"
  },
  "572211": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Ammasandra S.O"
  },
  "572111": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Amruthur S.O"
  },
  "572213": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Chandrashekarapura S.O"
  },
  "572117": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Chelur S.O (Tumakuru)"
  },
  "572215": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Dandinashivara S.O"
  },
  "572216": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Gubbi Bazar S.O"
  },
  "561207": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Bagepalli S.O"
  },
  "794111": {
    "state": "MEGHALAYA",
    "district": "EAST GARO HILLS",
    "office": "Williamnagar S.O"
  },
  "209402": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Sarsaul SO"
  },
  "281305": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Mahaban SO"
  },
  "281202": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Mant SO"
  },
  "281005": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Mathura Refinery SO"
  },
  "281203": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Nauhjhil SO"
  },
  "680102": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Ariyannur SO"
  },
  "680506": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Chavakkad SO"
  },
  "680101": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Guruvayur SO"
  },
  "680517": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kanippayur SO"
  },
  "680519": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Karikkad SO"
  },
  "680501": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kecheri SO"
  },
  "680523": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kizhur SO"
  },
  "245101": {
    "state": "UTTAR PRADESH",
    "district": "HAPUR",
    "office": "Gyan Lok Hapur SO"
  },
  "680505": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kottappadi SO"
  },
  "680512": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Orumanayur SO"
  },
  "680542": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Pazhanji SO"
  },
  "680104": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Thaikkad SO"
  },
  "831001": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Civil Court SO"
  },
  "481331": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Waraseoni S.O"
  },
  "486881": {
    "state": "MADHYA PRADESH",
    "district": "SINGRAULI",
    "office": "Jiawan S.O"
  },
  "444720": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Brahmanwada Thadi S.O"
  },
  "325216": {
    "state": "RAJASTHAN",
    "district": "BARAN",
    "office": "Kishan Ganj S.O"
  },
  "325215": {
    "state": "RAJASTHAN",
    "district": "BARAN",
    "office": "Mangrol S.O"
  },
  "325219": {
    "state": "RAJASTHAN",
    "district": "BARAN",
    "office": "Salpura S.O"
  },
  "325217": {
    "state": "RAJASTHAN",
    "district": "BARAN",
    "office": "Shahabad S.O (Baran)"
  },
  "325224": {
    "state": "RAJASTHAN",
    "district": "BARAN",
    "office": "Kelwara S.O"
  },
  "560048": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Mahadevapura S.O"
  },
  "560092": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Sahakaranagar S.O"
  },
  "680563": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Ammadam SO"
  },
  "680641": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Anthikad SO"
  },
  "680651": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Mannuthy SO"
  },
  "680541": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "MundurTC SO"
  },
  "680751": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Nadathara SO"
  },
  "680306": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Ollur SO"
  },
  "680652": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Pattikkad TC SO"
  },
  "680014": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "PuthurThrissur SO"
  },
  "680005": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Thrissur East SO"
  },
  "680614": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Vatanappally SO"
  },
  "680586": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Chelakkara SO"
  },
  "679531": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Cheruthuruthy SO"
  },
  "679532": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Desamangalam SO"
  },
  "680584": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Erumapetty SO"
  },
  "680604": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Maruthancode SO"
  },
  "680581": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Mulagunnathukavu SO"
  },
  "680601": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Velur Thrissur SO"
  },
  "680623": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "WadakkancheriThrissur RS SO"
  },
  "326519": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Ram Ganj Mandi S.O"
  },
  "325204": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Sultanpur S.O"
  },
  "325001": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Kaithun S.O"
  },
  "325601": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Sangod S.O"
  },
  "325203": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Simlia S.O"
  },
  "324008": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Thermal Colony Kota S.O"
  },
  "326530": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Suket S.O"
  },
  "670571": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Alakode SO"
  },
  "670632": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Chemperi SO"
  },
  "670511": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Cherupuzha SO"
  },
  "670334": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Ezhome SO"
  },
  "670142": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Karimbam SO"
  },
  "670521": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Karivellur SO"
  },
  "670309": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kunhimangalam SO"
  },
  "325206": {
    "state": "RAJASTHAN",
    "district": "BARAN",
    "office": "Siswali S.O"
  },
  "273203": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Brahmpur S.O Gorakhpur"
  },
  "583127": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Chigatere S.O"
  },
  "583126": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Chikkajogihalli S.O"
  },
  "324010": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Engineering College Kota S.O"
  },
  "680511": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Chittattukara SO"
  },
  "680602": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Mattom SO"
  },
  "680522": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Paluvai SO"
  },
  "680508": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Puvathur SO"
  },
  "679562": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Vadakkekad SO"
  },
  "680027": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kanimangalam SO"
  },
  "680006": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kuriachira SO"
  },
  "680007": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kurkancheri SO"
  },
  "680028": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kuruchikkara SO"
  },
  "680617": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Manalur SO"
  },
  "680552": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Parappur SO"
  },
  "691508": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kunnicode SO"
  },
  "691522": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Pattazhy SO"
  },
  "691332": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Punalur Paper Mills SO"
  },
  "691308": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Thenmala SO"
  },
  "678682": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Anjumoorthy SO"
  },
  "678510": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Ayalur SO"
  },
  "678702": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Coyalmanna SO"
  },
  "678543": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kavasseri SO"
  },
  "680653": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Peechi SO"
  },
  "680012": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Pullazhi SO"
  },
  "680010": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Viyyur SO"
  },
  "680589": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Enkakad SO"
  },
  "670306": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Mathamangalam Bazar SO"
  },
  "670563": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Parassinikadavu SO"
  },
  "670502": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Pariyaramkannur SO"
  },
  "670307": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kokkanisseri SO"
  },
  "670633": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Payyavur SO"
  },
  "670631": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Sreekandapuram SO"
  },
  "670694": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Champad SO"
  },
  "678686": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kannambra SO"
  },
  "678506": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kollengode SO"
  },
  "678684": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kilakkancheri SO"
  },
  "678571": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Mathur PG SO"
  },
  "678703": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Melarcode SO"
  },
  "678508": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Nemmara SO"
  },
  "670672": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Chokli SO"
  },
  "670663": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Etakkad SO"
  },
  "670703": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Iritty SO"
  },
  "670642": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kadirurtly SO"
  },
  "670674": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kelakam SO"
  },
  "670706": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kiliyanthara SO"
  },
  "670643": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kuthuparamba SO"
  },
  "670702": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Mattanur SO"
  },
  "670692": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Panoor SO"
  },
  "670691": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Pathayakunnu SO"
  },
  "670704": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Payam SO"
  },
  "670673": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Peravoor SO"
  },
  "464573": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Dehgaon S.O"
  },
  "464221": {
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "office": "Ganjbasoda S.O"
  },
  "464220": {
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "office": "Gulabganj S.O"
  },
  "464331": {
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "office": "Gyraspur S.O"
  },
  "464226": {
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "office": "Khamkheda S.O"
  },
  "464224": {
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "office": "Kurwai S.O"
  },
  "464114": {
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "office": "Lateri S.O"
  },
  "464258": {
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "office": "Nateran S.O"
  },
  "209863": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Bara SO Unnao"
  },
  "471301": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Gulganj S.O"
  },
  "471111": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Harpalpur S.O"
  },
  "471315": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Ishanagar S.O"
  },
  "471510": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Jujhar Nagar S.O"
  },
  "471001": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Panna Naka Chhatarpur S.O"
  },
  "471311": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Badamalehara S.O"
  },
  "581101": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Adur S.O (Haveri)"
  },
  "581128": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Agadi S.O"
  },
  "581108": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Guttal S.O"
  },
  "577428": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Shiralakoppa S.O"
  },
  "577429": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Sorab S.O"
  },
  "577433": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Togarsi S.O"
  },
  "577434": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Ulavi S.O"
  },
  "577411": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Agumbe S.O"
  },
  "250103": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "I E Partapur SO"
  },
  "679576": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Edapal SO"
  },
  "679582": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "KaladiMLP SO"
  },
  "679591": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Kokkur SO"
  },
  "679571": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Kuttippuram SO"
  },
  "679573": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Tavanur SO"
  },
  "679579": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Veliankode SO"
  },
  "676102": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Bettath Pudiangadi SO"
  },
  "673314": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Kadalundinagaram SO"
  },
  "670353": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "CRPF Camp Aravanchal SO"
  },
  "671531": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Anandashrama SO"
  },
  "671316": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Bekal Fort SO"
  },
  "671318": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Bekal SO"
  },
  "671326": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Chittarikkal SO"
  },
  "671314": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Nileshwar SO"
  },
  "301604": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Govind Garh Alwar S.O"
  },
  "464337": {
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "office": "Pathari S.O (Vidisha)"
  },
  "464113": {
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "office": "Pipalkheda S.O"
  },
  "464111": {
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "office": "Shamshabad S.O (Vidisha)"
  },
  "464228": {
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "office": "Sironj City S.O"
  },
  "462101": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Dillod S.O"
  },
  "671312": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Padne SO"
  },
  "671533": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Parappa SO"
  },
  "671534": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Vellarikundu SO"
  },
  "671532": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Rajapuram SO"
  },
  "671310": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Trikarpur SO"
  },
  "671541": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Changala SO"
  },
  "577225": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Saualanga S.O"
  },
  "577432": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Thirthahalli Town S.O"
  },
  "577203": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Vidyanagar Shivamogga S.O"
  },
  "581199": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Belagalapete S.O."
  },
  "577202": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Shivamogga Doddapete S.O"
  },
  "577226": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Tudur S.O"
  },
  "577414": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Arga S.O"
  },
  "577211": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Ayanur S.O"
  },
  "577415": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Devangi S.O"
  },
  "577214": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Hithla S.O"
  },
  "577216": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Holalur S.O"
  },
  "577436": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Humcha S.O"
  },
  "471105": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Bamitha S.O"
  },
  "463111": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Lalariya S.O"
  },
  "462120": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Nazirabad S.O"
  },
  "464993": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Obedullaganj S.O"
  },
  "462044": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Suraj Nagar S.O"
  },
  "679584": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Kanhiramukku SO"
  },
  "679580": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Perumbadappu SO"
  },
  "676305": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Abdurahiman Nagar SO"
  },
  "676319": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Chettipadi SO"
  },
  "691333": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Tholicode SO"
  },
  "604304": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Mailam SO"
  },
  "604303": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Markanum SO"
  },
  "604204": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Melmalayanur SO"
  },
  "604307": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Saram  Tindivanam  SO"
  },
  "604153": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Sathyamangalam SO"
  },
  "689692": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Payyanamon SO"
  },
  "689711": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Ranny Perinad SO"
  },
  "689673": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Rannypazhavangadi SO"
  },
  "689667": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Seethathode SO"
  },
  "691552": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kadambanad SO"
  },
  "691555": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kodumon SO"
  },
  "689503": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kulanada SO"
  },
  "604203": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Melolakkur SO"
  },
  "604205": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Minambur SO"
  },
  "604152": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Nallanpillaipetral SO"
  },
  "604305": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Olakkur SO"
  },
  "604306": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Rettanai SO"
  },
  "604208": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Valathi SO"
  },
  "689653": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kumbazhamuri SO"
  },
  "689676": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Makkapuzha SO"
  },
  "689678": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Mylapra Town SO"
  },
  "689647": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Omallurkla SO"
  },
  "689672": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Ranny SO"
  },
  "689699": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Thannithode SO"
  },
  "689662": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Vadasserikara SO"
  },
  "689656": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Vallicode Kottayam SO"
  },
  "691524": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Elamannur SO"
  },
  "689625": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Elavanthitta SO"
  },
  "691526": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Enathu SO"
  },
  "689693": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Koodal SO"
  },
  "676501": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Edarikode SO"
  },
  "323001": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Bundi H.O"
  },
  "413515": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Ahmedpur S.O (Latur)"
  },
  "413522": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Aurad Shahajani S.O"
  },
  "413520": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Ausa S.O"
  },
  "413511": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Borgaon S.O (Latur)"
  },
  "413513": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Chakur S.O"
  },
  "413519": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Deoni S.O"
  },
  "458220": {
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "office": "Sarwania Maharaj S.O"
  },
  "458228": {
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "office": "Singoli S.O"
  },
  "457661": {
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "office": "Jhabua Collectorate S.O"
  },
  "457887": {
    "state": "MADHYA PRADESH",
    "district": "ALIRAJPUR",
    "office": "Alirajpur S.O"
  },
  "457770": {
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "office": "Bamnia S.O"
  },
  "431713": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Tamsa S.O"
  },
  "431605": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Ashoknagar S.O (Nanded)"
  },
  "583128": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Choranur S.O"
  },
  "583129": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Devalapura S.O(Ballari)"
  },
  "583212": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Hagaribommanahalli S.O"
  },
  "583213": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Halavagalu S.O"
  },
  "583214": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Hampasagara S.O"
  },
  "583239": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Hampi S.O"
  },
  "583131": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Harapanahalli S.O"
  },
  "583216": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Hirehadagali S.O"
  },
  "583217": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Holalu S.O"
  },
  "583218": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Hosahalli S.O"
  },
  "583201": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Hosapete Ranipet S.O"
  },
  "583220": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Ittigi S.O"
  },
  "583221": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Kamalapura S.O"
  },
  "583211": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Chitwadgi S.O"
  },
  "464661": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Sanchi S.O"
  },
  "678706": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Vandali SO"
  },
  "678005": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Chokkanathapuram SO"
  },
  "678003": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kalpathi SO"
  },
  "678631": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kongad SO"
  },
  "678651": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Malampuzha Dam SO"
  },
  "678642": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Mannur SO Palakkad"
  },
  "678006": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Pallipuram PG SO"
  },
  "678101": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Chittur PG SO"
  },
  "678502": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Ettanur SO"
  },
  "678501": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Koduvayur SO"
  },
  "678551": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kotambu SO"
  },
  "678555": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kozhinjampara SO"
  },
  "678557": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kozhipara SO"
  },
  "678102": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Tattamangalam South SO"
  },
  "678534": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Vandithavalam SO"
  },
  "572212": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Banasandra S.O"
  },
  "572114": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Biligere S.O"
  },
  "572214": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Chikkanayakanahalli S.O"
  },
  "563124": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Chelur S.O (Kolar)"
  },
  "562101": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "SUBBARAYANAPET S.O"
  },
  "561206": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Dn Palya S.O"
  },
  "561208": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Gauribidanur Bzr S.O"
  },
  "561209": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Gudibanda S.O (Kolar)"
  },
  "561210": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Hossur S.O"
  },
  "561211": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "MANCHENAHALLI S.O"
  },
  "562102": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Melur S.O (Kolar)"
  },
  "562103": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Nandi S.O (Kolar)"
  },
  "561212": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Pathapalya S.O"
  },
  "562104": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Peresandra S.O"
  },
  "562105": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Sidlaghatta S.O"
  },
  "561213": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Thondebhavi S.O"
  },
  "561228": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Vatadahosahalli S.O"
  },
  "422502": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Bhagur S.O"
  },
  "422201": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Chandori S.O"
  },
  "422401": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Devlali S.O"
  },
  "422402": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Ghoti S.O"
  },
  "451228": {
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "office": "Kasrawad S.O"
  },
  "451224": {
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "office": "Maheshwar S.O"
  },
  "451115": {
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "office": "Dariya Mahal S.O"
  },
  "451221": {
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "office": "Mandleshwar S.O"
  },
  "451881": {
    "state": "MADHYA PRADESH",
    "district": "BARWANI",
    "office": "Khetia S.O"
  },
  "451556": {
    "state": "MADHYA PRADESH",
    "district": "BARWANI",
    "office": "Anjad S.O"
  },
  "451551": {
    "state": "MADHYA PRADESH",
    "district": "BARWANI",
    "office": "Barwani S.O"
  },
  "451449": {
    "state": "MADHYA PRADESH",
    "district": "BARWANI",
    "office": "Julwania S.O"
  },
  "451332": {
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "office": "Jhirnia S.O"
  },
  "451113": {
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "office": "Bedia S.O"
  },
  "451331": {
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "office": "Bhikangaon S.O"
  },
  "451441": {
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "office": "Bistan S.O"
  },
  "451335": {
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "office": "Gogawa S.O"
  },
  "413532": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Jalkot S.O"
  },
  "413581": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "JJJKSSK Nalegaon S.O"
  },
  "413607": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Kasarsirsi S.O"
  },
  "678572": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kottayi SO"
  },
  "678721": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kuttanur SO"
  },
  "678544": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Palampalakode SO"
  },
  "678688": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Pallavur SO"
  },
  "678573": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Paruthipulli SO"
  },
  "678574": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Peringottukurussi SO"
  },
  "678545": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Pudiyankam SO"
  },
  "678687": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Puthucode SO"
  },
  "678722": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Tolanur SO"
  },
  "678683": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Vadakkancherry MBR SO"
  },
  "678641": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Keralasseri SO"
  },
  "678613": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Mankarai SO"
  },
  "678004": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Nurani SO"
  },
  "678612": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Parli PG SO"
  },
  "678007": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Chandranagar SO"
  },
  "678622": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Elapulli SO"
  },
  "678621": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kanjikode SO"
  },
  "678701": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kannadi SO"
  },
  "678556": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Menonpara SO"
  },
  "678553": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Nallepilly SO"
  },
  "678552": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Polpulli SO"
  },
  "678103": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Thekkegramam SO"
  },
  "471405": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Bijawar S.O"
  },
  "471318": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Buxwaha S.O"
  },
  "690538": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Arinallur SO"
  },
  "691583": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Chavara SO"
  },
  "690519": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Mynagappally SO"
  },
  "690523": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Thazhava SO"
  },
  "284404": {
    "state": "UTTAR PRADESH",
    "district": "LALITPUR",
    "office": "Madawra SO"
  },
  "284406": {
    "state": "UTTAR PRADESH",
    "district": "LALITPUR",
    "office": "Narahat SO"
  },
  "560067": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Kadugodi S.O"
  },
  "560037": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Doddanekkundi SO"
  },
  "691502": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "East Kallada SO"
  },
  "691602": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kanjavely SO"
  },
  "691579": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Karamcode SO"
  },
  "691574": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Parippally SO"
  },
  "691601": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Perinad SO"
  },
  "691005": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "T K M College SO"
  },
  "691020": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Thattamala SO"
  },
  "691511": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Vellimon SO"
  },
  "691520": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Cheppara SO"
  },
  "691559": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Chithara SO"
  },
  "691505": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Ezhukone SO"
  },
  "460001": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Betul Ganj S.O"
  },
  "460110": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Athanair S.O"
  },
  "460004": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Betul Bazaar S.O"
  },
  "301019": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Bhiwari Ind. Area. Alwar S.O"
  },
  "301018": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Khazuri Bass S.O"
  },
  "301702": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Kotkassim S.O"
  },
  "799271": {
    "state": "TRIPURA",
    "district": "North Tripura",
    "office": "Dasdabazar S.O"
  },
  "799256": {
    "state": "TRIPURA",
    "district": "North Tripura",
    "office": "Tripura Damcherra S.O"
  },
  "799262": {
    "state": "TRIPURA",
    "district": "North Tripura",
    "office": "Churaibari S.O"
  },
  "799286": {
    "state": "TRIPURA",
    "district": "Dhalai",
    "office": "Halahali S.O"
  },
  "799266": {
    "state": "TRIPURA",
    "district": "Dhalai",
    "office": "Kanchancherra"
  },
  "460220": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Bhainsdehi S.O"
  },
  "460553": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Amla Depot S.O"
  },
  "460551": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Amla S.O"
  },
  "471525": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Chandla S.O"
  },
  "471101": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Chandra Nagar S.O"
  },
  "281504": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Radhakund SO"
  },
  "471313": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Ghaura S.O"
  },
  "471515": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Laundi S.O"
  },
  "471606": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Khajuraho S.O"
  },
  "471516": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Gaurihar S.O"
  },
  "471501": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Maharajpur S.O"
  },
  "471201": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Nowgong S.O"
  },
  "471625": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Rajnagar S.O"
  },
  "471408": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Satai S.O"
  },
  "577223": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Nyamthi S.O"
  },
  "577551": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Basavapatna S.O (Davangere)"
  },
  "577230": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Chilur S.O"
  },
  "577217": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Honnali S.O"
  },
  "577219": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Kundur S.O"
  },
  "581321": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Belekeri S.O"
  },
  "581324": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Chendiye S.O"
  },
  "572141": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Y N Hoskote S.O"
  },
  "572102": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Someswarapuram S.O"
  },
  "422403": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Igatpuri S.O"
  },
  "422113": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Ind. Est. Malegaon Sinnar S.O"
  },
  "422606": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Nandurshingote S.O"
  },
  "422102": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Nashik Road Camp S.O"
  },
  "422210": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Saykheda S.O"
  },
  "422103": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Sinnar S.O"
  },
  "689664": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Malayalapuzha Eram SO"
  },
  "689646": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Mallasseri SO"
  },
  "689671": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Mylapra SO"
  },
  "689642": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Naranganam SO"
  },
  "486666": {
    "state": "MADHYA PRADESH",
    "district": "SIDHI",
    "office": "Majauli S.O"
  },
  "486775": {
    "state": "MADHYA PRADESH",
    "district": "SIDHI",
    "office": "Rampur Naikin S.O"
  },
  "486892": {
    "state": "MADHYA PRADESH",
    "district": "SINGRAULI",
    "office": "Gorbi S.O"
  },
  "488441": {
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "office": "Amanganj S.O"
  },
  "488333": {
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "office": "Devendra Nagar S.O"
  },
  "488222": {
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "office": "Dharampur S.O"
  },
  "488050": {
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "office": "Kakrehti S.O"
  },
  "488001": {
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "office": "Panna Collectrate S.O"
  },
  "488446": {
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "office": "Pawai S.O"
  },
  "488448": {
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "office": "Shahnagar S.O"
  },
  "689698": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Vakayar SO"
  },
  "691331": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Valacode SO"
  },
  "486333": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Dhera S.O"
  },
  "451770": {
    "state": "MADHYA PRADESH",
    "district": "BARWANI",
    "office": "Pansemal S.O"
  },
  "477001": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Housing Colony Bhind S.O"
  },
  "477332": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Akoda S.O"
  },
  "477449": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Alampur S.O (Bhind"
  },
  "477227": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Amayan S.O"
  },
  "477446": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Aswar S.O"
  },
  "477111": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Attair S.O"
  },
  "477566": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Barhi S.O (Bhind"
  },
  "474006": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "Morar Town S.O"
  },
  "475002": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "Behat S.O (Gwalior"
  },
  "474005": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "Gwalior Residency S.O"
  },
  "475330": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "Mohna S.O"
  },
  "472010": {
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "office": "Badagaon S.O"
  },
  "472111": {
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "office": "Baldeogarh S.O"
  },
  "690547": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Prayar SO"
  },
  "403802": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Baina S.O"
  },
  "403714": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Chandor S.O"
  },
  "403710": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Cortalim S.O"
  },
  "403509": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Anjuna S.O"
  },
  "403503": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Assonora S.O"
  },
  "460554": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Bordehi S.O"
  },
  "460330": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Chicholi S.O"
  },
  "460663": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Dunawa S.O"
  },
  "577231": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Kanivebilichi S.O"
  },
  "577422": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Konandur S.O"
  },
  "577220": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Mandagadde S.O"
  },
  "577424": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Megaravalli S.O"
  },
  "577222": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Nidige S.O"
  },
  "600047": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Tambaram Sanatorium SO"
  },
  "600045": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Tambaram West SO"
  },
  "600044": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Radhanagar SO Kanchipuram"
  },
  "600073": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Gowriwakkam SO"
  },
  "600059": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Christian College Tambaram SO"
  },
  "600063": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Srinivasanagar SO Kanchipuram"
  },
  "601301": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Padappai SO"
  },
  "484001": {
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "office": "Shahdol Gharola S.O"
  },
  "606902": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Devikapuram SO"
  },
  "606908": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Kadaladi SO Tiruvannamalai"
  },
  "606702": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Kanji SO"
  },
  "606904": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Mandakolathur SO"
  },
  "606752": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Mangalam SO Tiruvannamalai"
  },
  "606703": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Melpallipattu SO"
  },
  "606802": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Nayudumangalam SO"
  },
  "606704": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Pachal SO Tiruvannamalai"
  },
  "606710": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Paramanandal SO"
  },
  "761055": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Bissmagiri S.O"
  },
  "761042": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Bomokei S.O"
  },
  "761012": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Digapahandi Tahasil Colony S.O"
  },
  "760010": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Engineering School S.O"
  },
  "761009": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Girisola S.O"
  },
  "761008": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Kanisi Hat S.O."
  },
  "761002": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Gopalpur S.O (Ganjam)"
  },
  "760003": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Gosaninuagam S.O"
  },
  "761005": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Jaradagada S.O"
  },
  "761209": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Khariaguda S.O"
  },
  "761054": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Ballipada S.O"
  },
  "760002": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Premnagar S.O (Ganjam)"
  },
  "760007": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Berhampur University S.O"
  },
  "450445": {
    "state": "MADHYA PRADESH",
    "district": "BURHANPUR",
    "office": "Shahpur (Nimar) S.O"
  },
  "670701": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Nirmalagiri SO"
  },
  "670661": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Palayad SO"
  },
  "670107": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Eranholi SO"
  },
  "670651": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kottiyur SO"
  },
  "670105": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Nettur SO Kannur"
  },
  "670675": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Peringathur SO"
  },
  "670741": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Pinarayi SO"
  },
  "761010": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Chikiti S.O"
  },
  "761006": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Jayantipur S.O"
  },
  "761100": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Kukudakhandi S.O"
  },
  "761001": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Nimakhandi S.O"
  },
  "761011": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Nuapada S.O"
  },
  "761007": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Padmanavapur S.O"
  },
  "761004": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Patrapur S.O"
  },
  "761014": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Pudamari S.O"
  },
  "761037": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Surangi S.O"
  },
  "761026": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Ganjam S.O"
  },
  "761041": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Badakharida S.O"
  },
  "670705": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Ulikkal SO"
  },
  "670649": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Ummenchira SO"
  },
  "670102": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Temple Gate SO"
  },
  "670693": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Thuvakunnu SO"
  },
  "670650": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Chittariparamba SO"
  },
  "464240": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Bamora R.S S.O"
  },
  "422104": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Wavi S.O"
  },
  "422010": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Ambad A.S. S.O"
  },
  "422202": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Dindori S.O (Nashik)"
  },
  "422203": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Girnara S.O"
  },
  "461221": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "Banapura S.O"
  },
  "670581": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Chepparapadava SO"
  },
  "670562": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kalliasseri SO"
  },
  "670582": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Naduvil SO"
  },
  "670308": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Ramanthali SO"
  },
  "671313": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Chervathur SO"
  },
  "671311": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Elambachi SO"
  },
  "671351": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Thuruthi SO"
  },
  "671319": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Udma SO"
  },
  "470441": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Malthone S.O"
  },
  "470119": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Rahatgarh S.O"
  },
  "470227": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Rehli S.O"
  },
  "470004": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Sagar Makronia Camp S.O"
  },
  "470339": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Shahgarh S.O (Sagar)"
  },
  "470120": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Sihora S.O (Sagar)"
  },
  "691311": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Channapettah SO"
  },
  "680587": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Pazhayannur SO"
  },
  "488442": {
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "office": "Simariya S.O"
  },
  "488443": {
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "office": "Raipura S.O"
  },
  "488220": {
    "state": "MADHYA PRADESH",
    "district": "PANNA",
    "office": "Ajaigarh S.O"
  },
  "486341": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Deotalab S.O"
  },
  "431807": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Umri S.O"
  },
  "486448": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Sirmour S.O"
  },
  "691553": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kadambanad South SO"
  },
  "481001": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Balaghat City S.O"
  },
  "451220": {
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "office": "Karhi S.O"
  },
  "457882": {
    "state": "MADHYA PRADESH",
    "district": "ALIRAJPUR",
    "office": "Bhabhra S.O"
  },
  "457990": {
    "state": "MADHYA PRADESH",
    "district": "ALIRAJPUR",
    "office": "Jobat S.O"
  },
  "457772": {
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "office": "Khawasa S.O (Jhabua)"
  },
  "457779": {
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "office": "Meghnagar S.O"
  },
  "457773": {
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "office": "Petlawad S.O"
  },
  "457775": {
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "office": "Raipuria S.O"
  },
  "465693": {
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "office": "Machalpur S.O"
  },
  "457001": {
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "office": "Ratlam Stn.Road S.O"
  },
  "465667": {
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "office": "Kurawar S.O (Rajgarh)"
  },
  "477447": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Daboh S.O"
  },
  "477116": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Gohad S.O"
  },
  "477660": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Gormi S.O"
  },
  "477445": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Lahar S.O"
  },
  "460225": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Khedisaoligarh S.O"
  },
  "460668": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Masod S.O"
  },
  "460661": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Multai S.O"
  },
  "460449": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Pathakheda S.O"
  },
  "460666": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Rai Amla S.O"
  },
  "460557": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Sainkheda S.O (Betul)"
  },
  "460440": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Shahpur S.O (Betul)"
  },
  "690573": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Alumkadavu SO"
  },
  "480001": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Gualbra Chhindwara S.O"
  },
  "480221": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Amarwara S.O"
  },
  "480111": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Bichhua S.O"
  },
  "480110": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Chand S.O"
  },
  "480115": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Chourai S.O"
  },
  "450221": {
    "state": "MADHYA PRADESH",
    "district": "BURHANPUR",
    "office": "Nepanagar S.O"
  },
  "470221": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Surkhi S.O"
  },
  "283104": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "Bah SO"
  },
  "475682": {
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "office": "Seondha S.O"
  },
  "606803": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Polur Town SO"
  },
  "606706": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Sathanurdam SO"
  },
  "606611": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Somasipadi SO"
  },
  "606603": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Sriramanashramam SO"
  },
  "606707": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Tandarampattu SO"
  },
  "606708": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Tanipadi SO"
  },
  "606709": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Thukkapettai SO"
  },
  "606753": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Vanapuram SO"
  },
  "606604": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Vengikkal SO"
  },
  "606754": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Vettavalam SO"
  },
  "606751": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Kalasapakkam SO"
  },
  "680585": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Varavur SO"
  },
  "679563": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Nhamanghat SO"
  },
  "680507": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Pavaratty SO"
  },
  "680103": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Puthanpalli SO"
  },
  "680510": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Venkitangu SO"
  },
  "680620": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Arimpur SO"
  },
  "680003": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Ayyanthole SO"
  },
  "680004": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Poothole SO"
  },
  "680551": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Puranattukara SO"
  },
  "680569": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Talikulam SO"
  },
  "680619": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Trithallur SO"
  },
  "604601": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Kilpennathur SO"
  },
  "606806": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Pavithiram SO"
  },
  "632101": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Anaikattu S.O"
  },
  "632055": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Ariyur S.O (Vellore)"
  },
  "632113": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Cholavaram S.O"
  },
  "606705": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Pudupalayam SO Tiruvannamalai"
  },
  "475671": {
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "office": "Unnao S.O"
  },
  "476332": {
    "state": "MADHYA PRADESH",
    "district": "SHEOPUR",
    "office": "Bijaipur S.O (Sheopur"
  },
  "476134": {
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "office": "Dimni S.O"
  },
  "476221": {
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "office": "Joura S.O"
  },
  "476355": {
    "state": "MADHYA PRADESH",
    "district": "SHEOPUR",
    "office": "Karhal S.O (Sheopur"
  },
  "476224": {
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "office": "Kelaras S.O"
  },
  "476554": {
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "office": "Khadiahar S.O"
  },
  "476115": {
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "office": "Porsa S.O"
  },
  "690536": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Vadakkumthala East SO"
  },
  "691573": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Adichanallur SO"
  },
  "691302": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Bhoothakulam SO"
  },
  "691578": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kalluvathukkal SO"
  },
  "691003": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kavanad SO"
  },
  "691501": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kundara SO"
  },
  "691577": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Mukathala SO"
  },
  "691503": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Mulavana SO"
  },
  "691021": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Pattathanam SO"
  },
  "691534": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Chadayamangalam SO"
  },
  "691557": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Chengamanad Jn SO"
  },
  "690542": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Athinad North SO"
  },
  "691584": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Chavara South SO"
  },
  "690544": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kulasekharapuram SO"
  },
  "691576": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kannanallur SO"
  },
  "691571": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kottiyam SO"
  },
  "691334": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Nedungolam SO"
  },
  "691010": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Vadakkevila SO"
  },
  "691500": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "West Kallada SO"
  },
  "577232": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Bejjavalli S.O"
  },
  "679106": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kondazhi SO"
  },
  "680590": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kumaranellur TC SO"
  },
  "680583": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Mullurkkara SO"
  },
  "680588": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Thiruvilwamala SO"
  },
  "680596": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Thrissur Medical College SO"
  },
  "680543": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kadavallur SO"
  },
  "680544": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kattakampal SO"
  },
  "679561": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Punnayurkulam SO"
  },
  "680008": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Cherur SO"
  },
  "670143": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Pattuvam SO"
  },
  "321206": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Janoothar S.O"
  },
  "321205": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Nagar S.O (Bharatpur)"
  },
  "678593": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Tachampara SO"
  },
  "679514": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Thiruvazhiyode SO"
  },
  "679522": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Vaniamkulam SO"
  },
  "679309": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Vilayur SO"
  },
  "679533": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Koottanad"
  },
  "678598": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Pottasseri SO"
  },
  "679307": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Pulasseri SO"
  },
  "679122": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "S G Press SO"
  },
  "679121": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Shornur SO"
  },
  "679513": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Srikrishnapuram SO"
  },
  "679102": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Thottakkara SO"
  },
  "679502": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Trikkatiri SO"
  },
  "679534": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Trithala SO"
  },
  "678632": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Pulappatta SO"
  },
  "321204": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Pahari S.O (Bharatpur)"
  },
  "321202": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Penghore S.O"
  },
  "321642": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Sarsena S.O"
  },
  "321024": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Sikri S.O"
  },
  "313604": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Kanore S.O"
  },
  "761132": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Mujjagada S.O"
  },
  "761122": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Nimina S.O"
  },
  "761140": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Tanarada S.O"
  },
  "761131": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Kullada S.O"
  },
  "793111": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Cherrabazar S.O"
  },
  "457888": {
    "state": "MADHYA PRADESH",
    "district": "ALIRAJPUR",
    "office": "Sondwa S.O"
  },
  "457777": {
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "office": "Thandla S.O"
  },
  "458441": {
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "office": "Neemuch Victoria Barracks S.O"
  },
  "686651": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Anthinad SO"
  },
  "686574": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Arunapuram SO"
  },
  "686578": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Bharananganam SO"
  },
  "686121": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Erattupetta SO"
  },
  "686571": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kadaplamattom SO"
  },
  "686572": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kidangoor SO"
  },
  "686582": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Poonjar Thekkekara SO"
  },
  "686577": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Poovarani SO"
  },
  "686604": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kaduthuruthy SO"
  },
  "686611": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kallara SO Kottayam"
  },
  "686144": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kudavechoor SO"
  },
  "686608": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kulasekharamangalam SO"
  },
  "686633": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kuravilangadu SO"
  },
  "457993": {
    "state": "MADHYA PRADESH",
    "district": "JHABUA",
    "office": "Ranapur S.O"
  },
  "465685": {
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "office": "Boda S.O"
  },
  "465689": {
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "office": "Chhapiheda S.O"
  },
  "471411": {
    "state": "MADHYA PRADESH",
    "district": "CHHATARPUR",
    "office": "Gadimalehara S.O"
  },
  "476229": {
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "office": "Sabalgarh S.O"
  },
  "476339": {
    "state": "MADHYA PRADESH",
    "district": "SHEOPUR",
    "office": "Sheopur Baroda S.O"
  },
  "476337": {
    "state": "MADHYA PRADESH",
    "district": "SHEOPUR",
    "office": "Sheopur S.O"
  },
  "314001": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Dungarpur Gapsagar S.O"
  },
  "314037": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Antri S.O (Dungarpur)"
  },
  "475336": {
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "office": "Salon B. S.O"
  },
  "475685": {
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "office": "Sonagir S.O"
  },
  "475673": {
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "office": "Tharet S.O"
  },
  "314021": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Aspur S.O"
  },
  "314023": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Bankora S.O"
  },
  "328001": {
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "office": "Udaibhan Ganj Dholpur SO"
  },
  "474020": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "Maharajpura A.F. S.O"
  },
  "475005": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "Tekanpur S.O"
  },
  "328031": {
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "office": "Barauli SO Dholpur"
  },
  "328021": {
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "office": "Bari Rs SO"
  },
  "328023": {
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "office": "Basai Nabab SO"
  },
  "283201": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "Barhan SO"
  },
  "283113": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "Bhadrauli SO"
  },
  "282005": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "YAMUNA KINARA  SO"
  },
  "283202": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "Etmadpur"
  },
  "283111": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "Fatehabad"
  },
  "480887": {
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "office": "Adegaon S.O"
  },
  "480771": {
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "office": "Ari S.O"
  },
  "480882": {
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "office": "Bandol S.O"
  },
  "480667": {
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "office": "Barghat S.O"
  },
  "480888": {
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "office": "Dhuma S.O"
  },
  "480999": {
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "office": "Kahani S.O"
  },
  "480990": {
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "office": "Kanhiwada S.O"
  },
  "480994": {
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "office": "Keolari S.O"
  },
  "480991": {
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "office": "Khairapalari S.O"
  },
  "480880": {
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "office": "Korai S.O"
  },
  "480886": {
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "office": "Lakhnadon S.O"
  },
  "473880": {
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "office": "Narwar S.O (Shivpuri"
  },
  "473995": {
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "office": "Pichhore S.O"
  },
  "462022": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Anand Nagar S.O (Bhopal)"
  },
  "462030": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Bairagarh S.O"
  },
  "403703": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Cuncolim S.O"
  },
  "403706": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Curchorem S.O"
  },
  "403705": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Quepem S.O"
  },
  "403704": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Sanguem S.O"
  },
  "403723": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Velim S.O"
  },
  "403702": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Canacona S.O"
  },
  "403410": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Collem S.O"
  },
  "403707": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Navelim S.O"
  },
  "465679": {
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "office": "Khilchipur S.O"
  },
  "465687": {
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "office": "Khujner S.O"
  },
  "762028": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Chakapada S.O"
  },
  "762002": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Contractorpada S.O"
  },
  "762104": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Daringbadiso S.O"
  },
  "762100": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "G.Udayagiri S.O"
  },
  "425428": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Boradi S.O"
  },
  "686636": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Monippally SO"
  },
  "686613": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Muttuchira SO"
  },
  "462036": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Gandhi Nagar (Bhopal) S.O"
  },
  "462038": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "M.L. Nagar S.O"
  },
  "462010": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Nishatpura S.O"
  },
  "462042": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Kolar Road S.O"
  },
  "462047": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Misord S.O"
  },
  "462026": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "University S.O (Bhopal)"
  },
  "679575": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Nannamukku SO"
  },
  "679578": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Vattamkulam SO"
  },
  "321405": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Band Baretha SO"
  },
  "321403": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Banshi Paharpur SO"
  },
  "314031": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Bhiluda S.O"
  },
  "678681": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kunisseri SO"
  },
  "678507": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Muthalamada SO"
  },
  "678542": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Perinkulam SO"
  },
  "678611": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Edathara SO"
  },
  "678009": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kallekulangara SO"
  },
  "678592": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Mundur Palakkad SO"
  },
  "678594": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Muttikulangara SO"
  },
  "678731": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Puduppariyaram SO"
  },
  "480996": {
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "office": "Ugli S.O"
  },
  "470669": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Shahpur Magrone S.O"
  },
  "686146": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Padinjarekkara SO"
  },
  "686610": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Peruva SO"
  },
  "686606": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Thirumani Venkita Puram SO"
  },
  "686143": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Udayanapuram SO"
  },
  "686587": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Vayala SO"
  },
  "686562": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Athirampuzha SO"
  },
  "686015": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Aymanam SO"
  },
  "686631": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Ettumanur SO"
  },
  "686008": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Gandhi Nagar SO Kottayam"
  },
  "686632": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kanakari SO"
  },
  "686020": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kiliroor North SO"
  },
  "686017": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kudamaloor SO"
  },
  "686563": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kumarakom SO"
  },
  "686019": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Manarcaudu SO"
  },
  "686013": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Nattakom SO"
  },
  "686014": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Olessa SO"
  },
  "686011": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Puthupalli SO"
  },
  "455001": {
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "office": "Dewas Radhaganj S.O"
  },
  "689513": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Nariapuram SO"
  },
  "673631": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Feroke Pettah SO"
  },
  "673016": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Kuthiravattom SO"
  },
  "673007": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Mankavu SO"
  },
  "676553": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Kadampuzha SO"
  },
  "462046": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Mandideep S.O"
  },
  "463106": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Berasia Bhopal S.O"
  },
  "673632": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Farook College SO"
  },
  "679574": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Mookkuthala SO"
  },
  "679586": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Ponani South SO"
  },
  "563114": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Bangarpet S.O"
  },
  "671317": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Kalnad SO"
  },
  "671124": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Kudlu SO"
  },
  "671321": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Kumbla SO"
  },
  "671323": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Manjeshwar SO"
  },
  "690505": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Charumoodu SO"
  },
  "690507": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Cheppaud SO"
  },
  "690534": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Chunakara SO"
  },
  "690514": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Haripad SO"
  },
  "690535": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Kandallur SO"
  },
  "690516": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Karthikappally SO"
  },
  "690517": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Karuvatta SO"
  },
  "690533": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Krishnapuram SO Alappuzha"
  },
  "690506": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Muthukulam South SO"
  },
  "690503": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Pallickal SO"
  },
  "690527": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Puthuppally SO"
  },
  "690105": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Chennithala SO"
  },
  "690106": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Chettikulangara SO"
  },
  "563113": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Andersonpet S.O"
  },
  "759026": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Anlabereni S.O"
  },
  "624101": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Kodaikanal SO"
  },
  "624212": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Perumbarai SO"
  },
  "624103": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Kodaikanal Observatory SO"
  },
  "624206": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Kodairoad RS SO"
  },
  "679357": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Anamangad SO"
  },
  "679340": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Cherukara SO"
  },
  "676519": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Downhill SO"
  },
  "670641": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Ponniam West SO"
  },
  "581145": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Chalageri S.O"
  },
  "689624": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Ennakkad SO"
  },
  "690110": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Kallumala SO"
  },
  "690101": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Mavelikara Cutcherry SO"
  },
  "689505": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Mulakuzha SO"
  },
  "689520": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Pennukkara SO"
  },
  "671542": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Muliyar SO"
  },
  "671543": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Mulleria SO"
  },
  "671348": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Paivalike SO"
  },
  "671552": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Perla SO"
  },
  "671322": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Uppala SO"
  },
  "671123": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Vidyanagar SO Kasargod"
  },
  "591247": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Chikodi Sugar Factory S.O"
  },
  "591229": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Kognoli S.O"
  },
  "610102": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Kamalapuram S.O (Tiruvarur)"
  },
  "576211": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Basrur SO"
  },
  "576214": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Byndoor SO"
  },
  "576217": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Hanglur SO"
  },
  "576283": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Hattiangadi SO"
  },
  "576219": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Khambadakone SO"
  },
  "576222": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Koteshwara SO"
  },
  "576257": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Kumbhashi SO"
  },
  "576227": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Shankaranarayana SO"
  },
  "576229": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Siddapura Udupi SO"
  },
  "425407": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Chimthana S.O"
  },
  "425415": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Akkalkuwa S.O"
  },
  "425442": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Borad S.O"
  },
  "425417": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Chinchpada S.O"
  },
  "425414": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Dhadgaon S.O"
  },
  "466001": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Sehore City S.O"
  },
  "466665": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Ahmedpur S.O (Sehore)"
  },
  "466116": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Ashta S.O"
  },
  "466448": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Baktara S.O"
  },
  "466111": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Bilkisganj S.O"
  },
  "466661": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Doraha S.O (Sehore)"
  },
  "458669": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Kachnara Flag S.O"
  },
  "458389": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Laduna S.O"
  },
  "458002": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Mandsaur Fort S.O"
  },
  "458558": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Nahargarh S.O"
  },
  "678554": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Nattukal SO"
  },
  "678532": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Pattancheri SO"
  },
  "303604": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Sambhar Lake HO"
  },
  "303602": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Badhal SO"
  },
  "303901": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Chaksu SO"
  },
  "303904": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Chittora Renwal SO"
  },
  "303008": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Dudu SO"
  },
  "303328": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Jobner SO"
  },
  "303706": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Kalwad SO"
  },
  "303007": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Bagru SO"
  },
  "422214": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Vaitarna Nagar S.O"
  },
  "450116": {
    "state": "MADHYA PRADESH",
    "district": "EAST NIMAR",
    "office": "Naya Harsud S.O"
  },
  "450551": {
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "office": "Nimarkhedi S.O"
  },
  "450661": {
    "state": "MADHYA PRADESH",
    "district": "EAST NIMAR",
    "office": "Pandhana S.O"
  },
  "450114": {
    "state": "MADHYA PRADESH",
    "district": "EAST NIMAR",
    "office": "Punasa S.O"
  },
  "450337": {
    "state": "MADHYA PRADESH",
    "district": "EAST NIMAR",
    "office": "Rustampur S.O"
  },
  "480884": {
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "office": "Chhapara S.O"
  },
  "480881": {
    "state": "MADHYA PRADESH",
    "district": "SEONI",
    "office": "Khawasa S.O (Seoni)"
  },
  "486446": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Beeda S.O"
  },
  "344701": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Shiv S.O"
  },
  "284136": {
    "state": "UTTAR PRADESH",
    "district": "LALITPUR",
    "office": "Matatila SO"
  },
  "460443": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Ghoradongari S.O"
  },
  "460665": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Prabhat Pattan S.O"
  },
  "690574": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Manappally North SO"
  },
  "691585": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Mukundapuram SO"
  },
  "691582": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Neendakara SO"
  },
  "690526": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Ochira SO"
  },
  "690524": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Thevalakkara SO"
  },
  "690528": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Vavvakkavu SO"
  },
  "691011": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Eravipuram SO"
  },
  "691004": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kilikollur SO"
  },
  "691015": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Mangad SO"
  },
  "691303": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Mayyanad SO"
  },
  "762014": {
    "state": "ODISHA",
    "district": "BOUDH",
    "office": "Mallisahi S.O"
  },
  "762015": {
    "state": "ODISHA",
    "district": "BOUDH",
    "office": "Bounsoni S.O"
  },
  "431606": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "SRTMU Nanded S.O"
  },
  "413516": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Killari S.O"
  },
  "583219": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Huvinahadagali S.O"
  },
  "583132": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Kampli S.O"
  },
  "756111": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Ranital S.O (Bhadrak)"
  },
  "576230": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Tallur SO Udupi"
  },
  "403524": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Arambol S.O"
  },
  "756126": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Simulia S.O"
  },
  "770002": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Rangadhipa S.O"
  },
  "770020": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Sankara S.O"
  },
  "770014": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Subdega S.O"
  },
  "443104": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Dhamangaon Badhe S.O"
  },
  "443112": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Dharangaon S.O (Buldhana)"
  },
  "443402": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Jalgaon S.O"
  },
  "443101": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Malkapur City S.O"
  },
  "443103": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Motala S.O"
  },
  "443404": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Nandura S.O"
  },
  "443202": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Sakhar Kherda S.O"
  },
  "425114": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Neri BK S.O"
  },
  "425107": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Chopda S.O"
  },
  "424208": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Fattepur S.O"
  },
  "576235": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Trasi SO"
  },
  "576233": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Vandse SO"
  },
  "752109": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Astarang"
  },
  "752105": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Balanga SO"
  },
  "752118": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Bangurigaon"
  },
  "752110": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Gop"
  },
  "770033": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Damdapara S.O"
  },
  "770038": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Bonaigarh S.O"
  },
  "770051": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Kenaveta S.O"
  },
  "770044": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Khuntgaon S.O"
  },
  "770039": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Kuarmunda S.O"
  },
  "416511": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Banda S.O (Sindhudurg)"
  },
  "416518": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Shiroda S.O (Sindhudurg)"
  },
  "344033": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Sindhari S.O"
  },
  "424207": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Wakadi S.O"
  },
  "424206": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Jamner S.O"
  },
  "424204": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Shendurni S.O"
  },
  "770074": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Talsara S.O"
  },
  "770011": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Ujalpur S.O"
  },
  "770072": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Zincnagar S.O"
  },
  "756121": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Manjuri Road S.O"
  },
  "768105": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Jujumura S.O"
  },
  "768119": {
    "state": "ODISHA",
    "district": "DEOGARH",
    "office": "Purunagarh S.O"
  },
  "752100": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Balakati S.O"
  },
  "752101": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Balianta S.O"
  },
  "752102": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Balipatna S.O"
  },
  "752103": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Banamalipur S.O"
  },
  "751003": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Baramunda Colony S.O"
  },
  "751019": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Dumduma Housing Board Colony S.O"
  },
  "422112": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "I.A. Musalgaon Sinnar S.O"
  },
  "466115": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Ichawar S.O"
  },
  "466221": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Jawar S.O (Sehore)"
  },
  "466114": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Kotri S.O (Sehore)"
  },
  "466331": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Nasrllaganj S.O"
  },
  "466446": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Rehti S.O"
  },
  "466554": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Shahganj S.O (Sehore)"
  },
  "424002": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Dhule Jaihind Colony S.O"
  },
  "424004": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Dhule Market Yard S.O"
  },
  "424006": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Dhule Midc S.O"
  },
  "422204": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Harsul S.O"
  },
  "422007": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Industrial Estate S.O (Nashik)"
  },
  "413208": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Kurduvadi S.O"
  },
  "413209": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Madha S.O"
  },
  "768106": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Rairakhol S.O"
  },
  "768109": {
    "state": "ODISHA",
    "district": "DEOGARH",
    "office": "Reamal S.O"
  },
  "679504": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Vellinezhi SO"
  },
  "680671": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Edavilangu SO"
  },
  "680667": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kottappuram SO"
  },
  "679304": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Thiruvegapura SO"
  },
  "480447": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "Chandametta S.O"
  },
  "577205": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Gopala Extension S.O"
  },
  "476228": {
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "office": "Pahadgarh S.O"
  },
  "413306": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Mahud S.O"
  },
  "303908": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Kotkhawada SO"
  },
  "581341": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Karki S.O"
  },
  "424005": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Dhule Vidya Nagari S.O"
  },
  "425408": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Dondaicha S.O"
  },
  "680594": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kaniyarkod SO"
  },
  "680689": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Perambrathrissur SO"
  },
  "680121": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Irinjalakuda Mkt SO"
  },
  "680681": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kaipamangalam SO"
  },
  "680664": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Srinngapuram SO"
  },
  "756181": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Madhabnagar S.O"
  },
  "756132": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Motto S.O"
  },
  "756164": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Naikanidihi S.O"
  },
  "756167": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Paliabindha S.O"
  },
  "756131": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Pirahatbazar S.O"
  },
  "756135": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Randiahat S.O"
  },
  "424301": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Fagana S.O"
  },
  "424307": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Kapadna S.O"
  },
  "465677": {
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "office": "Suthalia S.O"
  },
  "465691": {
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "office": "Zeerapur S.O"
  },
  "425403": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Betawad S.O"
  },
  "756123": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Sabrang S.O"
  },
  "756130": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Tihidi S.O"
  },
  "768102": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Larambha S.O"
  },
  "458226": {
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "office": "Ratangarh S.O"
  },
  "416525": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Deulwada Nerur S.O"
  },
  "416512": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Dodamarg S.O"
  },
  "752011": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Brahmagiri S.O"
  },
  "752010": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Panaspada S.O"
  },
  "752012": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Chandanpur S.O"
  },
  "752015": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Delang S.O"
  },
  "576210": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Barkur SO"
  },
  "576213": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Brahmavara SO"
  },
  "576215": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Cherkadi SO"
  },
  "576113": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Hiriadka SO"
  },
  "576218": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Hungarcutta SO"
  },
  "576234": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Kokkarne SO"
  },
  "576221": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Kota SO"
  },
  "576223": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Mandarthi SO"
  },
  "576107": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Parkala SO"
  },
  "424205": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Pahur S.O"
  },
  "678008": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Palakkad Engineering College SO"
  },
  "678661": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Parambikulam SO"
  },
  "679338": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "KolathurMLP SO"
  },
  "323026": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Dablana S.O"
  },
  "323024": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Baranaya Gaon S.O"
  },
  "323802": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Dei S.O"
  },
  "323301": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Kapren S.O"
  },
  "323616": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Karwar S.O"
  },
  "624211": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Pattiveeranpatti SO"
  },
  "624707": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Sembatti SO"
  },
  "624215": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Silukkuvarpatti SO"
  },
  "624708": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Sithayankottai SO"
  },
  "624216": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Tandigudi SO"
  },
  "624219": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Vilampatti SO"
  },
  "624220": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Viruveedu SO"
  },
  "624612": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Ambilikai SO"
  },
  "624613": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Ayakudi SO"
  },
  "624614": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Chatrapatti SO Dindigul"
  },
  "422004": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Meri Colony S.O"
  },
  "422207": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Ojhar T.S. S.O"
  },
  "422003": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Kalaram Mandir S.O"
  },
  "422208": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Peint S.O"
  },
  "422302": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Sukena S.O"
  },
  "464334": {
    "state": "MADHYA PRADESH",
    "district": "VIDISHA",
    "office": "Tyonda S.O"
  },
  "303509": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Manpur SO Dausa"
  },
  "303505": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Nangal Rajawatan SO"
  },
  "303506": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Paparda SO"
  },
  "303510": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Ramgarh Pachwara SO"
  },
  "321612": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Paota Dausa SO"
  },
  "321613": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Rasidpur SO"
  },
  "303326": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Sikandra SO Dausa"
  },
  "303508": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Sikrai SO"
  },
  "303302": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Toonga SO"
  },
  "678012": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Vadakanthara SO"
  },
  "678623": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kanjikode West SO"
  },
  "678503": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Pudunagaram SO"
  },
  "678671": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Thenkurussi SO"
  },
  "678624": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Walayar Dam SO"
  },
  "670671": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Paral SO"
  },
  "486771": {
    "state": "MADHYA PRADESH",
    "district": "SIDHI",
    "office": "Churhat S.O"
  },
  "486675": {
    "state": "MADHYA PRADESH",
    "district": "SIDHI",
    "office": "Bahri S.O"
  },
  "689514": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kidangannur SO"
  },
  "572119": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Handanakere S.O"
  },
  "581362": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Kumta Kanara College Road S.O"
  },
  "581344": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Madangeri S.O"
  },
  "581348": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Manki S.O"
  },
  "581354": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Shirali S.O"
  },
  "584111": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Deodurga S.O"
  },
  "584113": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Gabbur S.O"
  },
  "584140": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Gunjahalli S.O"
  },
  "584115": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Hutti S.O"
  },
  "584143": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Jawalgera S.O"
  },
  "584138": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Balaganur S.O"
  },
  "572218": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Huliyar S.O"
  },
  "572123": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Huliyur Durga S.O"
  },
  "422013": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Sawarkar Nagar S.O"
  },
  "670103": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Tiruvangad SO"
  },
  "584167": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Dhadesugur S.O"
  },
  "584139": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Gurgunta S.O"
  },
  "584116": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Jalahalli S.O"
  },
  "584118": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Kallur S.O (Raichur)"
  },
  "577430": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Talaguppa S.O"
  },
  "577431": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Thagarthi S.O"
  },
  "584136": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Kalmala S.O"
  },
  "768006": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Remed S.O"
  },
  "768200": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Sasan Rs S.O"
  },
  "754110": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Borikina S.O"
  },
  "754139": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Ersama S.O"
  },
  "754106": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Kaduapada S.O"
  },
  "754136": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Kanakpur S.O"
  },
  "303507": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Sainthal SO"
  },
  "584120": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Kowthal S.O"
  },
  "584122": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Lingasugur S.O"
  },
  "584203": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Kurdi S.O"
  },
  "581421": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Kaikini S.O"
  },
  "581342": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Kasarkod S.O"
  },
  "581343": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Kumta Kutchery S.O"
  },
  "770040": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Lahunipara S.O"
  },
  "770036": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Bisra S.O"
  },
  "323023": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Hindoli S.O"
  },
  "323613": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Indergarh S.O (Bundi)"
  },
  "431602": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Shivajinagar S.O (Nanded)"
  },
  "457885": {
    "state": "MADHYA PRADESH",
    "district": "ALIRAJPUR",
    "office": "Katthiwada S.O"
  },
  "413250": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Mahisgaon S.O"
  },
  "581423": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Melin Idgunji S.O"
  },
  "581440": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Mirjan S.O"
  },
  "581350": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Murdeshwar S.O"
  },
  "572228": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Kandikere S.O"
  },
  "572126": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Kempanahalli S.O"
  },
  "572130": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "K R S Agrahara Kunigal S.O"
  },
  "572221": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Mayasandra S.O"
  },
  "572222": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Mooganayakana Kote S.O"
  },
  "686005": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Thazhathangady SO"
  },
  "686584": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Cherpunkal SO"
  },
  "686583": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kidangoor South SO"
  },
  "686635": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Marangattupally SO"
  },
  "686652": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Melukavumattom SO"
  },
  "572134": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Nagasandra S.O (Tumakuru)"
  },
  "572224": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Nonavinakere S.O"
  },
  "572225": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Sampige S.O"
  },
  "572226": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Settikere S.O"
  },
  "572201": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "K R Extn Tiptur S.O"
  },
  "572227": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Turuvekere S.O"
  },
  "572112": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Badavanahalli S.O"
  },
  "572115": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Bukkapatna S.O"
  },
  "563159": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Burudugunte S.O"
  },
  "563123": {
    "state": "KARNATAKA",
    "district": "CHIKKABALLAPURA",
    "office": "Batlahalli S.O"
  },
  "624704": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Idayakottai SO"
  },
  "759128": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Banarpal S.O"
  },
  "759146": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Igit Sarang S.O"
  },
  "759125": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Athamallik S.O"
  },
  "759129": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Bantala S.O"
  },
  "759124": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Chhendipada S.O"
  },
  "679321": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Angadipuram SO"
  },
  "673505": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Tuneri SO"
  },
  "673517": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Valayam SO"
  },
  "673542": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Villyappalli SO"
  },
  "473775": {
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "office": "Pohari S.O"
  },
  "473781": {
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "office": "Rannod S.O"
  },
  "450001": {
    "state": "MADHYA PRADESH",
    "district": "EAST NIMAR",
    "office": "Ghaspura Khandwa S.O"
  },
  "450110": {
    "state": "MADHYA PRADESH",
    "district": "EAST NIMAR",
    "office": "Bir S.O (East Nimar)"
  },
  "450771": {
    "state": "MADHYA PRADESH",
    "district": "EAST NIMAR",
    "office": "Chhegaon Makhan S.O"
  },
  "450117": {
    "state": "MADHYA PRADESH",
    "district": "EAST NIMAR",
    "office": "Khalwa S.O"
  },
  "450112": {
    "state": "MADHYA PRADESH",
    "district": "EAST NIMAR",
    "office": "Mundi S.O"
  },
  "686586": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Moonnilavu SO"
  },
  "686579": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Plassanal SO"
  },
  "686581": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Poonjar SO"
  },
  "686573": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Puliyannoor SO"
  },
  "686576": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Ramapuram Bazar SO"
  },
  "686580": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Teekoy SO"
  },
  "686612": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Njizhoor SO"
  },
  "686634": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Ozhavur SO"
  },
  "686605": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Thalayolaparambu SO"
  },
  "754162": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Kolar S.O"
  },
  "754141": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "IOCL(Paradeep) S.O"
  },
  "754119": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Machhagaon S.O"
  },
  "754104": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Nalibar S.O"
  },
  "403713": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Majorda S.O"
  },
  "403708": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Colva S.O"
  },
  "403718": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Loutolim S.O"
  },
  "754111": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Biridiroad S.O"
  },
  "754135": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Krishnanandapur S.O"
  },
  "403508": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Aldona S.O"
  },
  "770021": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Sargipali S.O"
  },
  "415803": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Pali (RTG) S.O"
  },
  "415616": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Pawas S.O"
  },
  "475686": {
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "office": "Baroni Datia S.O"
  },
  "441903": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Adyar S.O (Bhandara)"
  },
  "441122": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Industrial Area Butibori S.O"
  },
  "440023": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Dattawadi S.O"
  },
  "441914": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Andhalgaon S.O"
  },
  "441906": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Bhandara Of S.O"
  },
  "441905": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Bhandara Road S.O"
  },
  "441805": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Dighori S.O"
  },
  "441908": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Konda Kosra S.O"
  },
  "686603": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Manjoor SO"
  },
  "686607": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Thalayazham SO"
  },
  "686564": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Ayarkunnam SO"
  },
  "686003": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kottayam West SO"
  },
  "415517": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Surur S.O"
  },
  "415528": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Taradgaon S.O"
  },
  "415011": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Vaduth S.O"
  },
  "415526": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Vathar BK S.O"
  },
  "415524": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Vathar S.O"
  },
  "769043": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Jalda S.O"
  },
  "752116": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Birtung"
  },
  "752113": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Brahmakundi"
  },
  "416513": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Aronda S.O"
  },
  "441803": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Lakhandur S.O"
  },
  "441804": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Lakhni S.O"
  },
  "441924": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Pahela S.O"
  },
  "455116": {
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "office": "Tonkhurd S.O"
  },
  "475335": {
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "office": "Bhandair S.O"
  },
  "416521": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Kadaval S.O"
  },
  "416531": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Kalmist S.O"
  },
  "416520": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Kudal S.O (Sindhudurg)"
  },
  "754153": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "GARADPUR S.O"
  },
  "576212": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Belve SO"
  },
  "412803": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Wai S.O"
  },
  "576282": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Hosangadi SO"
  },
  "576231": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Tekkatte SO"
  },
  "576232": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Uppunda SO"
  },
  "576115": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Kemmannu SO"
  },
  "576105": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Santhekatte SO"
  },
  "576226": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Sasthan SO"
  },
  "416702": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Rajapur S.O (Ratnagiri)"
  },
  "415613": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Saitavada S.O"
  },
  "415611": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Sangmeshwar S.O"
  },
  "415629": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Shirgaon (RTG) S.O"
  },
  "606905": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Santhavasal SO"
  },
  "606804": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Tandarai SO"
  },
  "759103": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Dera S.O"
  },
  "759143": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Hakimpada S.O"
  },
  "759132": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Hulurisinga S.O"
  },
  "572217": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Honnavalli S.O"
  },
  "572219": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Kadaba S.O (Tumakuru)"
  },
  "572220": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Kallur S.O (Tumakuru)"
  },
  "563116": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Bethamangala S.O"
  },
  "759141": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Bagedia S.O"
  },
  "483225": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Sihora(MP) S.O"
  },
  "483440": {
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "office": "Sleemnabad S.O"
  },
  "483332": {
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "office": "Umaria Pan S.O"
  },
  "686516": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Meenadom SO"
  },
  "686004": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Muttambalam SO"
  },
  "686012": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Pakkil SO"
  },
  "690548": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Kumarapuram SO Alappuzha"
  },
  "486226": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Chak S.O"
  },
  "486556": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Dabhaura S.O"
  },
  "690513": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Nangiarkulangara SO"
  },
  "690504": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Nooranad SO"
  },
  "690531": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Puthiyavila SO"
  },
  "671121": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Kasaragod R S SO"
  },
  "671324": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Mangalpady SO"
  },
  "671551": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Perdala SO"
  },
  "769042": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Jhirpani S.O"
  },
  "769009": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Rourkela - 9 S.O"
  },
  "770041": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Barsuan S.O"
  },
  "473662": {
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "office": "T.C.Karera S.O"
  },
  "673303": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Elathur SO Kozhikode"
  },
  "770043": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Gurundia S.O"
  },
  "770031": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Kalunga S.O"
  },
  "416303": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Bhilavadi S.O"
  },
  "416403": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Dhalgaon S.O"
  },
  "416404": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Jath S.O"
  },
  "416405": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Kavathe Mahankal S.O"
  },
  "770034": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "KANSBAHAL"
  },
  "416514": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Satarda S.O"
  },
  "431705": {
    "state": "MAHARASHTRA",
    "district": "HINGOLI",
    "office": "Aundha Nagnath S.O"
  },
  "431512": {
    "state": "MAHARASHTRA",
    "district": "HINGOLI",
    "office": "Basmathnagar Town S.O"
  },
  "431204": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Ambad S.O"
  },
  "431212": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Ankush Nagar S.O"
  },
  "431202": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Badnapur S.O"
  },
  "673014": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Guruvayurappan College SO"
  },
  "673003": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Kallaikozhikode SO"
  },
  "473101": {
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "office": "Aroun S.O"
  },
  "473105": {
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "office": "Bamori S.O"
  },
  "473115": {
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "office": "Binaganj S.O"
  },
  "759117": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Kaniha S.O"
  },
  "759118": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Khamar S.O"
  },
  "759127": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Kishoreganj S.O"
  },
  "759130": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Kosala S.O"
  },
  "759123": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "P.T.C.,Angul S.O"
  },
  "624615": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Kalayamputhur SO"
  },
  "472339": {
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "office": "Digoda S.O"
  },
  "472118": {
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "office": "Jatara S.O"
  },
  "465697": {
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "office": "Sarangpur S.O"
  },
  "465680": {
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "office": "Talen S.O"
  },
  "431110": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Raghunath Nagar S.O (Aurangabad)"
  },
  "431116": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Shivar S.O"
  },
  "759119": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Pallahara S.O"
  },
  "759126": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Rajkishorenagar S.O"
  },
  "759105": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Rengali Dam Site S.O"
  },
  "759100": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Talcher S.O"
  },
  "472115": {
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "office": "Khargapur S.O"
  },
  "472005": {
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "office": "Kundeshwar S.O"
  },
  "472331": {
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "office": "Lidhora S.O"
  },
  "472101": {
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "office": "Mohangarh S.O"
  },
  "472221": {
    "state": "MADHYA PRADESH",
    "district": "TIKAMGARH",
    "office": "Palera S.O"
  },
  "474001": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "Shinde Ki Chhawani S.O"
  },
  "475001": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "Antri S.O (Gwalior"
  },
  "475220": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "Bhitarwar S.O"
  },
  "606601": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Kalnagar SO"
  },
  "606805": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Turinjapuram SO"
  },
  "606907": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Vadamadimangalam SO"
  },
  "606906": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Vilvarani SO"
  },
  "606808": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Kattampoondi SO"
  },
  "423701": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Vaijapur Town S.O"
  },
  "431133": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Waluj S.O"
  },
  "431154": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Shendra MIDC Area S.O"
  },
  "690515": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Thrikkunnapuzha SO"
  },
  "690501": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Vallikunnam SO"
  },
  "689508": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Kodukulanji SO"
  },
  "689622": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Mannar SO"
  },
  "690102": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Thazhakara SO"
  },
  "690107": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Thekkekara SO"
  },
  "487001": {
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "office": "Narsinghpur H.O"
  },
  "690508": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Keerikad SO"
  },
  "690529": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Padanilam SO"
  },
  "690104": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Cherukole SO"
  },
  "689504": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Karakkad SO"
  },
  "690509": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Kollakadavu SO"
  },
  "466445": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Budhni T.N. S.O"
  },
  "670305": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Vengarakannur SO"
  },
  "312624": {
    "state": "RAJASTHAN",
    "district": "PRATAPGARH",
    "office": "Peepalkhunt S.O"
  },
  "475110": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "Dabra S.O"
  },
  "474010": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "Moti Jheel S.O"
  },
  "577218": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Kerebilichi S.O"
  },
  "577221": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Nallur S.O (Davangere)"
  },
  "577552": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Santhebennur S.O"
  },
  "577227": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Holehonner S.O"
  },
  "577229": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Kawalgundi S.O"
  },
  "577233": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Kudligere S.O"
  },
  "577401": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Sagar Market Road S.O"
  },
  "577412": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Anandapuram S.O (Shivamogga)"
  },
  "577413": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Anavatti S.O"
  },
  "327605": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Luharia S.O"
  },
  "327602": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Sajjan Garh S.O"
  },
  "327025": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Talwara S.O"
  },
  "466125": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Maina S.O"
  },
  "431114": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Bhokardan S.O"
  },
  "450331": {
    "state": "MADHYA PRADESH",
    "district": "BURHANPUR",
    "office": "Shahbazar Burhanpur S.O"
  },
  "450881": {
    "state": "MADHYA PRADESH",
    "district": "EAST NIMAR",
    "office": "Jaswadi S.O"
  },
  "422211": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Surgana S.O"
  },
  "422212": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Trimbak S.O"
  },
  "422213": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Trimbak Vidya Mandir S.O"
  },
  "422215": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Vani S.O"
  },
  "443203": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Sindkhed Raja S.O"
  },
  "412205": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Khed Shivapur Baug S.O"
  },
  "412216": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Koregaon Bhima S.O"
  },
  "410510": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Loni Dhamani S.O"
  },
  "412219": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Madhukarnagar Patas S.O"
  },
  "410401": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Lonavala Bazar S.O"
  },
  "410503": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Manchar S.O"
  },
  "412220": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Midc Ranjangaon Ganpati S.O"
  },
  "410504": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Narayangaon S.O"
  },
  "412213": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Nasrapur S.O"
  },
  "412211": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Nhavare S.O"
  },
  "431206": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Jaffrabad S.O"
  },
  "431213": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Jalna Railway Station S.O"
  },
  "416516": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Vengurla Camp S.O"
  },
  "770048": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Koira S.O"
  },
  "769003": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Sector - 7 S.O"
  },
  "416411": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Ranjani S.O (Sangli)"
  },
  "416418": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Salgare S.O"
  },
  "416412": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Sankh S.O"
  },
  "416311": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Savlaj S.O"
  },
  "416419": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Shirdhon S.O"
  },
  "416312": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Tasgaon M.D.G S.O"
  },
  "327026": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Mahidam S.O"
  },
  "577453": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Avinahalli S.O"
  },
  "577417": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Honnesara S.O"
  },
  "759145": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Nalconagar S.O"
  },
  "676521": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Pandikkad SO"
  },
  "679332": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Pookkottumpadam SO"
  },
  "679339": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Vaniyambalam SO"
  },
  "691551": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Manakala SO"
  },
  "689501": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Pandalam Medical Mission SO"
  },
  "690522": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Sooranad SO"
  },
  "689674": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Angadi SO Pathanamthitta"
  },
  "689643": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Elanthur SO"
  },
  "689675": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Ettichuvadu SO"
  },
  "413120": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Nimgaon Ketki S.O"
  },
  "412218": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Malthan S.O"
  },
  "680566": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Nattika SO"
  },
  "680682": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Puthenchira SO"
  },
  "680567": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Valapad SO"
  },
  "680662": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Vellangallur SO"
  },
  "680711": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Karuvannur SO"
  },
  "680702": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kattoor SO"
  },
  "680123": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Konathukunnu SO"
  },
  "680668": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kothaparamba SO"
  },
  "680564": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Pazhuvil SO"
  },
  "680697": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Thazhekkad SO"
  },
  "680562": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Urakam SO"
  },
  "678581": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Agali SO Palakkad"
  },
  "678601": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Alanallur SO"
  },
  "679536": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Chalisseri SO"
  },
  "679503": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Cherpalcheri SO"
  },
  "679511": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Chunangad SO"
  },
  "678596": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kalladikode SO"
  },
  "678595": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Karakurissi SO"
  },
  "402101": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Ambet SO"
  },
  "402302": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Birwadi SO"
  },
  "431117": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Ajantha S.O"
  },
  "431150": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Banoti S.O"
  },
  "431113": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Bharadi S.O"
  },
  "689649": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kadammanitta SO"
  },
  "689648": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kaipattur SO"
  },
  "689691": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Konny SO"
  },
  "486006": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Chorahata S.O"
  },
  "695103": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Avanavancherry SO"
  },
  "695310": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Ayroorvarkala SO"
  },
  "695311": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Edava SO"
  },
  "695605": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kallambalam SO"
  },
  "695601": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kilmanur SO"
  },
  "695602": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Madavoorpallickal SO"
  },
  "695610": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Mithirmala SO"
  },
  "695609": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Pangode SO"
  },
  "695584": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Pothencode SO"
  },
  "695612": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Pulimath SO"
  },
  "695303": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Puthencurichy SO"
  },
  "461990": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "Bankhedi S.O"
  },
  "461116": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "Dolaria S.O"
  },
  "461331": {
    "state": "MADHYA PRADESH",
    "district": "HARDA",
    "office": "Harda S.O"
  },
  "416549": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Konalkatta Colony S.O"
  },
  "574103": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Hejmadi SO"
  },
  "574106": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Kaup SO"
  },
  "576102": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Kunjibettu SO"
  },
  "576122": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Pangala SO"
  },
  "576247": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Gujjadi SO"
  },
  "576224": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Navunda SO"
  },
  "679506": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Karalmanna SO"
  },
  "678633": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Katambazhipuram SO"
  },
  "679523": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kavalappara SO"
  },
  "679337": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kulukkallur SO"
  },
  "754113": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Naugaonhat S.O"
  },
  "403709": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Curtorim S.O"
  },
  "403728": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Loliem S.O"
  },
  "770015": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Balisankara S.O"
  },
  "410208": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Taloja A.V. S.O"
  },
  "400702": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Uran S.O"
  },
  "410206": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Panvel City S.O"
  },
  "577418": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Hosanagar S.O"
  },
  "577419": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Jade S.O"
  },
  "577435": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Jog Falls S.O"
  },
  "577421": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Kargal Colony S.O"
  },
  "577452": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Nittur S.O (Shivamogga)"
  },
  "577427": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Shikaripur S.O"
  },
  "400707": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Jnpt S.O"
  },
  "410201": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Karjat S.O (Raigarh(MH))"
  },
  "400704": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "N.S.Karanja S.O"
  },
  "410101": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Neral S.O"
  },
  "410220": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Patalganga S.O"
  },
  "770016": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Bargaon (Sundergarh) S.O"
  },
  "770075": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Hemgir Road S.O"
  },
  "577224": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Sasvehalli S.O"
  },
  "576106": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Krodashrama SO"
  },
  "576108": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Malpe SO"
  },
  "457114": {
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "office": "Alote S.O"
  },
  "695586": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "StXaviers College SO"
  },
  "695614": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Thattathumala SO"
  },
  "695606": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Vamanapuram SO"
  },
  "695141": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Varkala SO"
  },
  "695615": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Vembayam SO"
  },
  "695607": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Venjaramoodu SO"
  },
  "695312": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Melvettoor SO"
  },
  "695021": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Karikkakom SO"
  },
  "695581": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Karyavattom SO"
  },
  "695011": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Thiruvananthapuram  Medical College SO"
  },
  "483775": {
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "office": "Vijayraghavgarh S.O"
  },
  "450332": {
    "state": "MADHYA PRADESH",
    "district": "BURHANPUR",
    "office": "Khaknar S.O"
  },
  "422601": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Akole S.O"
  },
  "413714": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Ashvi BK S.O"
  },
  "413738": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Ashvi Kd S.O"
  },
  "413737": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Babhleshwar S.O"
  },
  "413739": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Vadala Mahadeo S.O"
  },
  "487225": {
    "state": "MADHYA PRADESH",
    "district": "NARSINGHPUR",
    "office": "Amgaon Bada S.O"
  },
  "632010": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Abdullapuram S.O"
  },
  "458883": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Shamgarh S.O"
  },
  "416704": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Pachal S.O (Ratnagiri)"
  },
  "415801": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Sakharpa S.O"
  },
  "402308": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Bhira SO RaigarhMH"
  },
  "402403": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Borlipanchatan SO"
  },
  "752121": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Bamanal"
  },
  "576124": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Perdur SO"
  },
  "576120": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Moodubelle SO"
  },
  "574111": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Padubidri SO"
  },
  "574117": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Uchila SO"
  },
  "321615": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Pathena S.O"
  },
  "461111": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "Itarsi S.O"
  },
  "461115": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "NYC Itarsi S.O"
  },
  "461775": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "Mangalwara Piparia S.O"
  },
  "574119": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Yermal SO"
  },
  "577416": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Harnahalli S.O"
  },
  "577423": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Kumsi S.O"
  },
  "581129": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Jagalbet S.O"
  },
  "581340": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Kansur S.O"
  },
  "581412": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Kirwatti S.O"
  },
  "581346": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Malgi S.O"
  },
  "581347": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Manchikeri S.O"
  },
  "581349": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Mundgod S.O"
  },
  "581450": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Neggu S.O"
  },
  "581403": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Nilekani S.O"
  },
  "485775": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Amarpatan S.O"
  },
  "485226": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Birsinghpur S.O"
  },
  "485221": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Jaitwara S.O"
  },
  "485551": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Jaso S.O"
  },
  "485778": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Kathaha S.O"
  },
  "485666": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Kothi S.O (Satna)"
  },
  "485334": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "M G  G V chitrakoot S.O"
  },
  "485113": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Madhogarh S.O (Satna)"
  },
  "485771": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Maihar S.O"
  },
  "485331": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Majhgawan S.O"
  },
  "461223": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "Seoni Malwa S.O"
  },
  "415643": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Watul S.O"
  },
  "461771": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "Sohagpur R.S. S.O"
  },
  "461551": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "Tawa Nagar S.O"
  },
  "461228": {
    "state": "MADHYA PRADESH",
    "district": "HARDA",
    "office": "Timarni S.O"
  },
  "670595": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Edayannur SO"
  },
  "670621": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kadachira SO"
  },
  "670592": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Koodali SO"
  },
  "670602": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Mayyil SO"
  },
  "670331": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Mottammal SO"
  },
  "670622": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Mundalur SO"
  },
  "756129": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Ghanteswar S.O"
  },
  "756163": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Guamal S.O"
  },
  "770037": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Lathikata S.O"
  },
  "576225": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Saligrama SO Udupi"
  },
  "576103": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Ambalapadi SO"
  },
  "574105": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "KatapadiUdupi SO"
  },
  "574113": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Pilar SO Udupi"
  },
  "574115": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Shankarapura SO"
  },
  "574116": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Shirva SO"
  },
  "431703": {
    "state": "MAHARASHTRA",
    "district": "HINGOLI",
    "office": "Goregaon S.O (Hingoli)"
  },
  "466113": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Amlaha S.O"
  },
  "466118": {
    "state": "MADHYA PRADESH",
    "district": "SEHORE",
    "office": "Metwada S.O"
  },
  "431513": {
    "state": "MAHARASHTRA",
    "district": "HINGOLI",
    "office": "Hingoli S.O"
  },
  "441907": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Gobarwahi S.O"
  },
  "441910": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Pauni S.O"
  },
  "441909": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Mohadi S.O"
  },
  "441110": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Hingna S.O"
  },
  "422222": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Ycm Open Univesity S.O"
  },
  "572116": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Channakeshavapura S.O"
  },
  "624210": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Pannaikadu SO"
  },
  "691556": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Nedumon SO"
  },
  "690520": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Poruvazhy SO"
  },
  "690561": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Sooranad North SO"
  },
  "624610": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Balasamudram SO Dindigul"
  },
  "412201": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Loni Kalbhor S.O"
  },
  "413115": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Malegaon BK S.O"
  },
  "413802": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Midc Kurkumbh S.O"
  },
  "412307": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Manjari Farm S.O"
  },
  "412304": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Morgaon S.O"
  },
  "572223": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Nittur S.O (Tumakuru)"
  },
  "695008": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Vallakkadavoo SO"
  },
  "695122": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Amaravila SO"
  },
  "695102": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Alamcode SO"
  },
  "695304": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Chirayinkeezhu SO"
  },
  "695306": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kadakkavur SO"
  },
  "695608": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kallara SO Thiruvananthapuram"
  },
  "695104": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kizhuvalam SO"
  },
  "481111": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Baihar S.O"
  },
  "481102": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Bharveli S.O"
  },
  "481051": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Birsa S.O"
  },
  "481332": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Budbuda S.O"
  },
  "473551": {
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "office": "Collectorate Bhawan Shiv S.O"
  },
  "481117": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Garhi S.O (Balaghat)"
  },
  "481226": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Hatta S.O (Balaghat)"
  },
  "481224": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Karanja S.O (Balaghat)"
  },
  "481445": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Katangi S.O (Balaghat)"
  },
  "481337": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Khairlanji S.O"
  },
  "481115": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Kirnapur S.O"
  },
  "481441": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Lalbarra S.O"
  },
  "481551": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Lamta S.O"
  },
  "695144": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Moongode SO"
  },
  "695603": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Navaikulam SO"
  },
  "695307": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Nedunganda SO"
  },
  "695604": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Pallickal Kilimanur SO"
  },
  "695305": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Perunguzhi SO"
  },
  "695145": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Sreenivasapuram SO"
  },
  "695583": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kulathur SO Thiruvananthapuram"
  },
  "695024": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Thiruvananthapuram  Pettah SO"
  },
  "695028": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Vattappara SO"
  },
  "689641": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kozhencherry College SO"
  },
  "691554": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Parakode SO"
  },
  "689663": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Chittar SO"
  },
  "689621": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Niranam SO"
  },
  "689104": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Valanjavattom SO"
  },
  "481222": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Lanji S.O"
  },
  "481116": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Malanjkhand S.O"
  },
  "481556": {
    "state": "MADHYA PRADESH",
    "district": "BALAGHAT",
    "office": "Paraswada S.O"
  },
  "431509": {
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "office": "Jintur S.O"
  },
  "431702": {
    "state": "MAHARASHTRA",
    "district": "HINGOLI",
    "office": "Kalamnuri S.O"
  },
  "431508": {
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "office": "Bori S.O (Parbhani)"
  },
  "431521": {
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "office": "Daithana S.O"
  },
  "431514": {
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "office": "Gangakhed S.O"
  },
  "431505": {
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "office": "Manwath Town S.O"
  },
  "431402": {
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "office": "Mau Parbhani S.O"
  },
  "431720": {
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "office": "Palam S.O"
  },
  "461441": {
    "state": "MADHYA PRADESH",
    "district": "HARDA",
    "office": "Khirkiyan R.S. S.O"
  },
  "572142": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Yediyur S.O (Tumakuru)"
  },
  "572113": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Baragur S.O"
  },
  "572118": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Gulur S.O"
  },
  "572120": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Hebbur S.O"
  },
  "572121": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Holavanahalli S.O"
  },
  "422006": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Upnagar S.O"
  },
  "422105": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "TP Station Eklahre S.O"
  },
  "572122": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Honnudike S.O"
  },
  "572124": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Ittakadibbanahalli S.O"
  },
  "689571": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Neerattupuram SO"
  },
  "689572": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Thalavady SO"
  },
  "431504": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Mantha S.O"
  },
  "431501": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Partur S.O"
  },
  "689590": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Veliyanadu SO"
  },
  "482003": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Medical College S.O (Jabalpur)"
  },
  "482002": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Lordganj S.O"
  },
  "486550": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Govindgarh S.O (Rewa)"
  },
  "486553": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Gurh S.O"
  },
  "486335": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Hanumana S.O"
  },
  "483105": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Katangi S.O (Jabalpur)"
  },
  "483110": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Kundam S.O"
  },
  "483220": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Panagar S.O (Jabalpur)"
  },
  "483113": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Patan S.O (Jabalpur)"
  },
  "581186": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Joida S.O"
  },
  "581355": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Siddapur S.O"
  },
  "581401": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Sirsi Courts S.O"
  },
  "416402": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Daphalapur S.O"
  },
  "482021": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "R.F.R.C. S.O"
  },
  "483119": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Shahpura (Jabalpur) S.O"
  },
  "482008": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Vidyut Nagar S.O (Jabalpur)"
  },
  "483501": {
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "office": "Katni R.S. S.O"
  },
  "483773": {
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "office": "Badwara S.O"
  },
  "486223": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Jawa S.O"
  },
  "486450": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Jaypee Nagar S.O"
  },
  "461668": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "Semri Harchand S.O"
  },
  "690572": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Kareelakulangara SO"
  },
  "690512": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Pallipad SO"
  },
  "690108": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Kunnam SO Alappuzha"
  },
  "690558": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Mankamkuzhy SO"
  },
  "689509": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Venmony SO"
  },
  "670504": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Pilathara SO"
  },
  "416407": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Malgaon S.O"
  },
  "402114": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Bagmandla SO"
  },
  "402203": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Chaul SO"
  },
  "485774": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Nadan S.O"
  },
  "485446": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Nagod S.O"
  },
  "485881": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Ramnagar S.O (Satna)"
  },
  "415719": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Talavali S.O"
  },
  "416523": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Parula S.O"
  },
  "416522": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Pat S.O"
  },
  "416529": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Talavade S.O"
  },
  "416550": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Kudal Audyogik Samuha S.O"
  },
  "431209": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Ghansawangi S.O"
  },
  "444709": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Dhamangaon Town S.O"
  },
  "444902": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Gurukunj Ashram S.O"
  },
  "670009": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Azhikode SO"
  },
  "670006": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Chovva SO"
  },
  "670591": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Eachur SO"
  },
  "670593": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Irukkur SO"
  },
  "686561": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Mannanam SO"
  },
  "686601": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Neendoor SO"
  },
  "313038": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Jhallara S.O"
  },
  "670613": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Mowancheri SO"
  },
  "670561": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Pappinisseri SO"
  },
  "670303": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Payangadi SO"
  },
  "571416": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Basaralu S.O"
  },
  "571417": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Belakavadi S.O"
  },
  "571419": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Besagarahalli S.O"
  },
  "571422": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Bharathinagar S.O"
  },
  "571403": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Guthal Colony S.O"
  },
  "571475": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Hadli S.O"
  },
  "571446": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Keragodu S.O"
  },
  "571476": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Kestur S.O"
  },
  "571424": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Kiragavalu S.O"
  },
  "571425": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Koppa mandya S.O"
  },
  "571478": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Kottatti S.O"
  },
  "571428": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Maddur S.O (Mandya)"
  },
  "571430": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Malavalli Extn S.O"
  },
  "571433": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Nidaghatta S.O"
  },
  "571463": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Purigali S.O"
  },
  "571402": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Sugar Town S.O"
  },
  "571405": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "V C Farm S.O"
  },
  "571605": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Akkihebbal S.O"
  },
  "571448": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Balagangadaranathnagar S.O"
  },
  "571606": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Belagola S.O"
  },
  "571802": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Bindiganavile S.O"
  },
  "486117": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Katra S.O (Rewa)"
  },
  "486111": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Mangawan S.O"
  },
  "486123": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Manikwar S.O"
  },
  "486331": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Mauganj S.O"
  },
  "486338": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Raghunathganj S.O"
  },
  "486114": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Raipur Karchulion S.O"
  },
  "486005": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Rewa Bansagar Coloney S.O"
  },
  "483330": {
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "office": "Bahori Band S.O"
  },
  "483331": {
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "office": "Bakal S.O"
  },
  "770070": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Tunmura S.O"
  },
  "400708": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Airoli S.O"
  },
  "400706": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Nerul Sec 48 S.O"
  },
  "415711": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Vakavali S.O"
  },
  "415208": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Veshvi S.O"
  },
  "415612": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Tilak Memorial (RTG) S.O"
  },
  "410221": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Ongc Complex,panvel S.O"
  },
  "410207": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Rasayani S.O"
  },
  "410203": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Khopoli S.O"
  },
  "770076": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Basundhara S.O"
  },
  "679552": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kumaranellur SO"
  },
  "679301": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Lakkidi SO"
  },
  "678583": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Mannarkad College SO"
  },
  "678582": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Mannarkkad SO"
  },
  "679335": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Nellaya SO"
  },
  "461110": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "Powarkheda S.O"
  },
  "721232": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Khirpai SO"
  },
  "721149": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Madpur SO"
  },
  "721156": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Marhtala SO"
  },
  "444802": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Kholapur S.O"
  },
  "444711": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Mangrul Dastgir S.O"
  },
  "444905": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Morshi S.O"
  },
  "412801": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Shirval S.O"
  },
  "679123": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Ganeshgiri SO"
  },
  "679313": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kalladipatta SO"
  },
  "680571": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kilakkummuri SO"
  },
  "680669": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Methala SO"
  },
  "680663": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Pullut SO"
  },
  "680701": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Thanissery SO"
  },
  "678591": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kanhirapuzha SO"
  },
  "679521": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Manisseri SO"
  },
  "679103": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Palappuram SO"
  },
  "770022": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Dharuadihi S.O"
  },
  "770024": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Gopalpur S.O (Sundergarh)"
  },
  "770013": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Hemgir S.O"
  },
  "472337": {
    "state": "MADHYA PRADESH",
    "district": "Niwari",
    "office": "Jeron S.O"
  },
  "472442": {
    "state": "MADHYA PRADESH",
    "district": "Niwari",
    "office": "Niwari S.O"
  },
  "472246": {
    "state": "MADHYA PRADESH",
    "district": "Niwari",
    "office": "Orchha S.O"
  },
  "472336": {
    "state": "MADHYA PRADESH",
    "district": "Niwari",
    "office": "Prithvipur S.O"
  },
  "472447": {
    "state": "MADHYA PRADESH",
    "district": "Niwari",
    "office": "Teharka S.O"
  },
  "637401": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Andagalur S.O"
  },
  "636301": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Attanur S.O"
  },
  "637403": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Gurusamipalayam S.O"
  },
  "636202": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Mangalapuram S.O"
  },
  "636451": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Chamrajpet S.O (Salem)"
  },
  "415107": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Targaon S.O"
  },
  "415116": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Vathar Kiroli S.O"
  },
  "415022": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Vennanagar S.O"
  },
  "571812": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Bukkinakere S.O"
  },
  "571436": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Santhebachahalli S.O"
  },
  "483770": {
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "office": "Barhi S.O (Katni)"
  },
  "483222": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Gosalpur S.O"
  },
  "483880": {
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "office": "Kymore S.O"
  },
  "483336": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Majholi S.O"
  },
  "283114": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "JAITPUR SO"
  },
  "283126": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "KHANDAULI SO"
  },
  "473249": {
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "office": "Bajranggarh S.O"
  },
  "473118": {
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "office": "Chachauda S.O"
  },
  "473222": {
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "office": "Kumbhraj S.O"
  },
  "473287": {
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "office": "Maksudangarh S.O"
  },
  "571421": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Halagur S.O"
  },
  "571450": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Keelara S.O"
  },
  "636354": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Danishpet S.O"
  },
  "637502": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Elampillai S.O"
  },
  "473113": {
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "office": "Myana S.O"
  },
  "679330": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Nilambur RS SO"
  },
  "679329": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Nilambur SO"
  },
  "673637": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Pulikkal SO"
  },
  "572125": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Kallambella S.O"
  },
  "572127": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Kodigenahalli S.O"
  },
  "572128": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Kora S.O (Tumakuru)"
  },
  "423303": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Jaikheda S.O"
  },
  "423501": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Kalwan S.O"
  },
  "450991": {
    "state": "MADHYA PRADESH",
    "district": "EAST NIMAR",
    "office": "Jawar S.O (East Nimar)"
  },
  "450051": {
    "state": "MADHYA PRADESH",
    "district": "EAST NIMAR",
    "office": "Kharkalan S.O"
  },
  "413216": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Akkalkot S.O"
  },
  "770073": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Kirei S.O"
  },
  "768108": {
    "state": "ODISHA",
    "district": "DEOGARH",
    "office": "Deogarh S.O (Debagarh)"
  },
  "770019": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Kundukela S.O"
  },
  "770018": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Kutra S.O"
  },
  "770012": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Lephripara S.O"
  },
  "770017": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Rajgangpur S.O"
  },
  "415729": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Welneshwar S.O"
  },
  "415519": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Nagthane S.O"
  },
  "415513": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Pachvad S.O"
  },
  "412805": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Panchgani S.O"
  },
  "415013": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Parali S.O"
  },
  "415523": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Kolki S.O (Satara)"
  },
  "415525": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Pimpode BK S.O"
  },
  "444708": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Nandgaon Khandeshwar S.O"
  },
  "571429": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Shivapura Maddur S.O"
  },
  "571418": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Bellur S.O"
  },
  "752085": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Gania S.O"
  },
  "721260": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Neradeul SO"
  },
  "721140": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Pingla SO"
  },
  "574143": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Farangipet S.O"
  },
  "574144": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Ganjimat S.O"
  },
  "574151": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kinnikambla S.O"
  },
  "574153": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kurnad S.O"
  },
  "574199": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Mangalagangothri S.O"
  },
  "575007": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Padil S.O"
  },
  "575029": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Pedamale S.O"
  },
  "577544": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Thyavanige S.O"
  },
  "574141": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Aikala S.O"
  },
  "574142": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Bajpe S.O"
  },
  "570010": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "PTC Campus S.O"
  },
  "283123": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "PINAHAT"
  },
  "282007": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "SUBJI MANDI SO"
  },
  "282006": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "INDUSTRIAL ESTATE SO"
  },
  "282009": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "COD SO"
  },
  "283101": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "Achhnera SO"
  },
  "283102": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "Akola SO"
  },
  "415610": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Kasba S.O (Ratnagiri)"
  },
  "415620": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Khalgaon S.O"
  },
  "415617": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Kotawada S.O"
  },
  "416701": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Lanja S.O"
  },
  "415639": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Kuvarbav S.O"
  },
  "415806": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Nata S.O"
  },
  "416705": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Oni S.O"
  },
  "444915": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Yawali S.O"
  },
  "444901": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Nandgaon Peth S.O"
  },
  "689103": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kuttapuzha SO"
  },
  "689108": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Peringara SO"
  },
  "473110": {
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "office": "Ruthiyai S.O"
  },
  "688011": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Alappuzha Mullackal SO"
  },
  "444707": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Nerpingalai S.O"
  },
  "444710": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Talegaon Dashasar S.O"
  },
  "444903": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Tiosa S.O"
  },
  "444801": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Walgaon S.O"
  },
  "473885": {
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "office": "Badarwas S.O"
  },
  "473585": {
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "office": "Bamorkalan S.O"
  },
  "473793": {
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "office": "Berad S.O"
  },
  "473665": {
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "office": "Dinara S.O (Shivpuri"
  },
  "473774": {
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "office": "Jagatpur S.O (Shivpuri"
  },
  "283105": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "BV Bichpuri SO"
  },
  "445109": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Akola Bazar S.O"
  },
  "445103": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Arni S.O"
  },
  "445101": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Babhulgaon S.O"
  },
  "415502": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Pusegaon S.O"
  },
  "415511": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Rahimatpur S.O"
  },
  "415522": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Sakharwadi S.O"
  },
  "415003": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Sangamnagar Satara S.O"
  },
  "415002": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Shahupuri Satara S.O"
  },
  "415010": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Satararoad S.O"
  },
  "415209": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Bahule S.O"
  },
  "415520": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Chaphal S.O"
  },
  "224001": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Lalbagh SO"
  },
  "224225": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Achhora SO"
  },
  "224121": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Amaniganj SO"
  },
  "575023": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Someshwar Uchil S.O"
  },
  "575028": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Vamanjoor S.O"
  },
  "282002": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "BM Khan SO"
  },
  "283110": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "Fatehpur Sikri"
  },
  "756128": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Gujidarada S.O"
  },
  "756118": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Kothar S.O"
  },
  "752092": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Godipada S.O"
  },
  "752025": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Gopalpur S.O (Nayagarh)"
  },
  "752068": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Itamati S.O"
  },
  "752077": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Khandapadagarh S.O"
  },
  "752090": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Kural S.O"
  },
  "767039": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Kantabanji S.O"
  },
  "416626": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Hadi S.O"
  },
  "752078": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Kantilo S.O"
  },
  "423202": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "G.S.S.K. S.O"
  },
  "416709": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Sagave S.O"
  },
  "415802": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Shiposhi S.O"
  },
  "752093": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Madhyakhand S.O"
  },
  "415508": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Dahivadi S.O"
  },
  "415211": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Daulat Nagar S.O (Satara)"
  },
  "415112": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Dhebewadi S.O"
  },
  "415540": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Gondavale BK S.O"
  },
  "415507": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Katarkhatav S.O"
  },
  "415103": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Kole S.O (Satara)"
  },
  "465669": {
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "office": "Narsinghgarh S.O"
  },
  "574146": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Haleangady S.O"
  },
  "574154": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Mulki S.O"
  },
  "575030": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Katipalla S.O"
  },
  "574150": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kinnigoli S.O"
  },
  "575014": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Surathkal S.O"
  },
  "224123": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Ramkot SO"
  },
  "224126": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Baragaon RS SO"
  },
  "224127": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Barun SO Ambedkar Nagar"
  },
  "224202": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Bharatkund SO"
  },
  "412312": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Veer S.O"
  },
  "412212": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Velhe S.O"
  },
  "413114": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Walchandnagar S.O"
  },
  "412214": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Yavat S.O"
  },
  "412107": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Panshet S.O"
  },
  "412108": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Paud S.O"
  },
  "412115": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Pirangut S.O"
  },
  "465683": {
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "office": "Pachore S.O"
  },
  "402303": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Poladpur SO"
  },
  "402108": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Poynad SO"
  },
  "402208": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "RCF Thal SO"
  },
  "402116": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Roha AV SO"
  },
  "416401": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Arag S.O"
  },
  "416409": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Mhaisal S.O"
  },
  "402109": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Roha SO"
  },
  "445201": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Bori Arab S.O"
  },
  "445202": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Darwha S.O"
  },
  "445207": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Dhanki S.O (Yavatmal)"
  },
  "445203": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Digras S.O"
  },
  "445230": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Fulsavangi S.O"
  },
  "445301": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Ghatanji S.O"
  },
  "445001": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Awdhutwadi (Yavatma)l S.O"
  },
  "445209": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Issapur S.O"
  },
  "445105": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Jawala S.O (Yavatmal)"
  },
  "445401": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Kalamb S.O (Yavatmal)"
  },
  "413725": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Takalibhan S.O"
  },
  "413720": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Tilaknagar S.O (Ahmed Nagar)"
  },
  "422611": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Talegaon Dighe S.O"
  },
  "762018": {
    "state": "ODISHA",
    "district": "BOUDH",
    "office": "Ghantapada S.O"
  },
  "224116": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Bhilsar SO"
  },
  "224204": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Bikapur SO"
  },
  "224209": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Chaurebazar SO"
  },
  "224135": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Darshan Nagar SO"
  },
  "224189": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Deorhi SO"
  },
  "314801": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Bichhiwara S.O"
  },
  "314030": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Chikhli S.O (Dungarpur)"
  },
  "314035": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Chitri S.O"
  },
  "314036": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Damdi S.O"
  },
  "475661": {
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "office": "Datia Rajgarh S.O"
  },
  "224141": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Goshaiganj SO"
  },
  "224208": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Harringtonganj SO"
  },
  "224228": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Inayatnagar SO"
  },
  "224206": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Khajurahat SO"
  },
  "342311": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Aau SO"
  },
  "342901": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Asop SO"
  },
  "636204": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Panamarathupatti S.O"
  },
  "636006": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Salem Pension Lines S.O"
  },
  "331304": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Taranagar S.O"
  },
  "331022": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Ratangarh RS S.O"
  },
  "412104": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Rajewadi S.O"
  },
  "410505": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Rajgurunagar S.O"
  },
  "412209": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Ranjangaon Ganpati S.O"
  },
  "412301": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Sopannagar S.O"
  },
  "410516": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Shinoli S.O"
  },
  "412210": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Shirur S.O (Pune)"
  },
  "413116": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Shivnagar S.O"
  },
  "412204": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Supa S.O (Pune)"
  },
  "410506": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Talegaon Dabhade S.O"
  },
  "412208": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Talegaon Dhamdhere S.O"
  },
  "410507": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Talegaon G H S.O"
  },
  "412202": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Urulikanchan S.O"
  },
  "412402": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Vada S.O (Pune)"
  },
  "412103": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Vadgaon Nimbalkar S.O"
  },
  "412106": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Vadgaon S.O (Pune)"
  },
  "412305": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Valha S.O"
  },
  "412311": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Parinche S.O"
  },
  "410512": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Peth S.O (Pune)"
  },
  "636111": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Seshanchavadi S.O"
  },
  "636122": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Sukkampatti S.O"
  },
  "636308": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Veerapandi Salem S.O"
  },
  "636601": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Yercaud S.O"
  },
  "636602": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Ondikadai S.O"
  },
  "752013": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Basudevpur S.O (Puri)"
  },
  "752016": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Berboi S.O"
  },
  "752094": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Mahipur S.O"
  },
  "752079": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Mandhatapur S.O"
  },
  "752070": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Nayagarh Bazar S.O"
  },
  "752083": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Nuagaon S.O (Nayagarh)"
  },
  "679327": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Tuvvur SO"
  },
  "679328": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Wandoor SO"
  },
  "464551": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Raisen H.O"
  },
  "676551": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Kalpakancheri SO"
  },
  "676504": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Kodurmalabar SO"
  },
  "636404": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Gonur S.O"
  },
  "636501": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Jalakantapuram S.O"
  },
  "636351": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Kadayampatti S.O"
  },
  "636309": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Kamalapuram S.O (Salem)"
  },
  "636012": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Karuppur S.O"
  },
  "636303": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Kolathur (Salem)S.O"
  },
  "412308": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Phursungi S.O"
  },
  "412412": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Pimpalwandi S.O (Pune)"
  },
  "676503": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Kottakkal SO"
  },
  "676562": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Kuttayi SO"
  },
  "636452": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Madayankuttai S.O"
  },
  "636458": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Mallikundam S.O"
  },
  "636011": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Govt. College Of Engg S.O"
  },
  "636302": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Kachakaranur S.O"
  },
  "636009": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Leigh Bazaar S.O"
  },
  "752081": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Odagaon S.O"
  },
  "752026": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Rajranpur S.O"
  },
  "752065": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Rajsunakhala S.O"
  },
  "752080": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Sarankul S.O"
  },
  "752091": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Satpatna S.O"
  },
  "415510": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Aundh S.O"
  },
  "147004": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "TIET SO"
  },
  "401405": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Satpati S.O"
  },
  "331501": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Bidasar S.O"
  },
  "331502": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Chhapar S.O"
  },
  "413401": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Subhash Nagar Barshi S.O"
  },
  "442001": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "MGIHU S.O"
  },
  "442307": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Wadner S.O"
  },
  "764045": {
    "state": "ODISHA",
    "district": "MALKANGIRI",
    "office": "Malkangiri S.O"
  },
  "764044": {
    "state": "ODISHA",
    "district": "MALKANGIRI",
    "office": "Mathili S.O"
  },
  "445210": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Lohi S.O"
  },
  "445205": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Mahagaon (Yavatmal) S.O"
  },
  "445303": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Maregaon Road S.O"
  },
  "415312": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Kaledhon S.O"
  },
  "415539": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Malkapur Karad S.O"
  },
  "415205": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Malharpeth Karad S.O"
  },
  "415106": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Masur S.O (Satara)"
  },
  "415102": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Mayani S.O"
  },
  "415538": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Mhasurne S.O"
  },
  "415509": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Mhasvad S.O"
  },
  "686602": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kaipuzha SO"
  },
  "686016": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kumaranalloor SO"
  },
  "721144": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Sabang SO"
  },
  "721160": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Radhamohanpur SO"
  },
  "721242": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Ramjibanpur SO"
  },
  "721253": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Satbankura SO"
  },
  "721146": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Sekendari SO"
  },
  "321601": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Halena S.O"
  },
  "670005": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kakkat SO"
  },
  "670604": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kannadiparamba SO"
  },
  "415207": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Koyna S.O"
  },
  "415105": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Ogalewadi S.O"
  },
  "415111": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Ond S.O"
  },
  "486115": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Garh S.O"
  },
  "486440": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Laxmanpur S.O (Rewa)"
  },
  "486340": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Naigarhi S.O"
  },
  "486447": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Patehara S.O"
  },
  "416506": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Halkarni S.O"
  },
  "416207": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Ispurli S.O"
  },
  "416210": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Kadgaon Gargoti S.O"
  },
  "416216": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Kagal S.O"
  },
  "147102": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "Ghagga SO"
  },
  "147021": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "Guruteghbahadurgarh SO"
  },
  "147201": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "Nabha SO"
  },
  "333026": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Chirawa Town S.O"
  },
  "333027": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Ardawata S.O"
  },
  "333501": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Babai S.O (Jhujhunu)"
  },
  "442904": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Neri S.O"
  },
  "441215": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Pathari S.O (Chandrapur)"
  },
  "441212": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Rajoli S.O (Chandrapur)"
  },
  "413409": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Agalgaon S.O"
  },
  "413214": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Angar S.O"
  },
  "413226": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Chapalgaon S.O"
  },
  "413220": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Dudhani S.O"
  },
  "413406": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Gaudgaon S.O"
  },
  "484224": {
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "office": "Anuppur S.O"
  },
  "484776": {
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "office": "Bansagar S.O"
  },
  "761017": {
    "state": "ODISHA",
    "district": "GAJAPATI",
    "office": "Chandragiri S.O"
  },
  "761215": {
    "state": "ODISHA",
    "district": "GAJAPATI",
    "office": "Garabandha S.O"
  },
  "761207": {
    "state": "ODISHA",
    "district": "GAJAPATI",
    "office": "Gumma S.O Gajapati"
  },
  "761210": {
    "state": "ODISHA",
    "district": "GAJAPATI",
    "office": "Gurandi S.O"
  },
  "761206": {
    "state": "ODISHA",
    "district": "GAJAPATI",
    "office": "Kashinagar S.O Gajapati"
  },
  "761208": {
    "state": "ODISHA",
    "district": "GAJAPATI",
    "office": "Kharada S.O"
  },
  "761015": {
    "state": "ODISHA",
    "district": "GAJAPATI",
    "office": "Mohana S.O."
  },
  "761212": {
    "state": "ODISHA",
    "district": "GAJAPATI",
    "office": "Narayanapur S.O (Gajapati)"
  },
  "761214": {
    "state": "ODISHA",
    "district": "GAJAPATI",
    "office": "Nuagada S.O"
  },
  "761217": {
    "state": "ODISHA",
    "district": "GAJAPATI",
    "office": "Odava S.O"
  },
  "679535": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Peringode SO"
  },
  "680686": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Perinjanam SO"
  },
  "679305": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Pallipuram SO Palakkad"
  },
  "678762": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Perimbadari SO"
  },
  "679302": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "PerurOPM SO"
  },
  "415206": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Patan S.O (Satara)"
  },
  "415512": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Pusesavali S.O"
  },
  "415108": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Shivnagar S.O"
  },
  "342023": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Balesar SO"
  },
  "342027": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Banar SO"
  },
  "342307": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Bap SO"
  },
  "342605": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Bhavi SO"
  },
  "413215": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Hotgi S.O"
  },
  "413253": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Kamati Khurd S.O"
  },
  "413219": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Karajagi S.O (Solapur)"
  },
  "413217": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Maindargi S.O"
  },
  "413221": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Mandrup S.O"
  },
  "413410": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Manegaon S.O"
  },
  "413213": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Bazarpeth Mohol S.O"
  },
  "413227": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Nagansur S.O"
  },
  "413222": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Nanaj S.O (Solapur)"
  },
  "413403": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Pangaon S.O (Solapur)"
  },
  "413404": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Pangri S.O"
  },
  "413248": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Pennur S.O"
  },
  "413324": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Shetphal S.O"
  },
  "413224": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Nai Zindagi S.O"
  },
  "413002": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Mangalwar Peth S.O (Solapur)"
  },
  "413008": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "SRPF Camp Solapur S.O"
  },
  "486003": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Rewa APSU S.O"
  },
  "458116": {
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "office": "Kukdeshwar S.O"
  },
  "458113": {
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "office": "Mahagarh S.O"
  },
  "670012": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kannur Thana SO"
  },
  "670601": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kolacherry SO"
  },
  "690103": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Thattarambalam SO"
  },
  "342603": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Bhopalgarh SO"
  },
  "151210": {
    "state": "PUNJAB",
    "district": "SRI MUKTSAR SAHIB",
    "office": "Alamwala SO"
  },
  "152115": {
    "state": "PUNJAB",
    "district": "SRI MUKTSAR SAHIB",
    "office": "Bhaika Khera SO"
  },
  "152031": {
    "state": "PUNJAB",
    "district": "SRI MUKTSAR SAHIB",
    "office": "Doda SO Muktsar"
  },
  "152101": {
    "state": "PUNJAB",
    "district": "SRI MUKTSAR SAHIB",
    "office": "Gidderbaha SO"
  },
  "344035": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Kavas S.O"
  },
  "333023": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Bagar S.O"
  },
  "333502": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Buhana S.O"
  },
  "333024": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Islampur S.O (Jhujhunu)"
  },
  "333033": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Jakhod S.O"
  },
  "147202": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "Bhadson SO"
  },
  "450554": {
    "state": "MADHYA PRADESH",
    "district": "EAST NIMAR",
    "office": "Mandhata Omkareshwar S.O"
  },
  "413255": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Midc Chincholi S.O"
  },
  "143402": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Police Lines Tarn Taran SO"
  },
  "758017": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Rajanagar S.O"
  },
  "758047": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Remuli S.O"
  },
  "758016": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Saharpada S.O"
  },
  "758043": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Sainkul S.O"
  },
  "758076": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Sirigida S.O"
  },
  "758045": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Udayapur S.O"
  },
  "416218": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Kapshi S.O"
  },
  "689595": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Ramankary SO"
  },
  "482056": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Bargi Nagar S.O"
  },
  "679554": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kudallur SO"
  },
  "403507": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Mapusa S.O"
  },
  "403004": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Nio Dona Paula S.O"
  },
  "403510": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Parra S.O"
  },
  "403512": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Pernem S.O"
  },
  "690540": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kunnathur East SO"
  },
  "690521": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Sasthamcottah SO"
  },
  "403511": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Saligao S.O"
  },
  "403505": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Sanquelim S.O"
  },
  "403506": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Valpoi S.O"
  },
  "141127": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Koom Kalan SO"
  },
  "416120": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Dattanagar S.O"
  },
  "416107": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Dattawad S.O"
  },
  "416138": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Kabnur SO"
  },
  "416109": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Hatkalangada S.O"
  },
  "416209": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Gargoti S.O"
  },
  "770023": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Lanjiberna S.O"
  },
  "403107": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Marcela S.O"
  },
  "403401": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Ponda S.O"
  },
  "403406": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Tisca S.O"
  },
  "416507": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Karve S.O"
  },
  "331504": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Gogasar S.O"
  },
  "331518": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Lalgarh S.O (Churu)"
  },
  "331505": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Parihara S.O (Churu)"
  },
  "331802": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Rajaldesar Bazar S.O"
  },
  "482051": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Bargi S.O"
  },
  "483053": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Bheraghat S.O"
  },
  "482005": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Ranjhi Azad Nagar S.O"
  },
  "331506": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Salasar S.O"
  },
  "331517": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Sandwa S.O"
  },
  "495001": {
    "state": "CHHATTISGARH",
    "district": "BILASPUR",
    "office": "Bilaspur Kutchery BilaspurCGHSO"
  },
  "688005": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Alappuzha Medical College SO"
  },
  "688007": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Alappuzha North SO"
  },
  "689109": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Tiruvanvandur SO"
  },
  "485112": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Babupur S.O"
  },
  "581187": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Kumbarwada S.O"
  },
  "415805": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Jaitapur S.O"
  },
  "415609": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Kadwai S.O"
  },
  "344801": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Padru S.O"
  },
  "344027": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Parlu S.O"
  },
  "151205": {
    "state": "PUNJAB",
    "district": "FARIDKOT",
    "office": "Baja Khana SO"
  },
  "151213": {
    "state": "PUNJAB",
    "district": "FARIDKOT",
    "office": "Harindra Nagar Faridkot SO"
  },
  "151202": {
    "state": "PUNJAB",
    "district": "FARIDKOT",
    "office": "Jaitu SO"
  },
  "151204": {
    "state": "PUNJAB",
    "district": "FARIDKOT",
    "office": "Kotkapura SO"
  },
  "344502": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Ramsar S.O (Barmer)"
  },
  "344012": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Ranigaon S.O"
  },
  "344021": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Samdari S.O"
  },
  "344708": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Sanawara S.O"
  },
  "695301": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kaniyapuram SO"
  },
  "695004": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Pattom Palace SO"
  },
  "695309": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Anjengo SO"
  },
  "695313": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kudavur SO"
  },
  "695146": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Palayamkunnu SO"
  },
  "695589": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Santhigiri SO"
  },
  "695143": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Vadasserikonam SO"
  },
  "689502": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Thumpamon SO"
  },
  "689677": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Chellakkad SO"
  },
  "689585": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Mallappally West SO"
  },
  "689110": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Podiyadi SO"
  },
  "224183": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Saidahi SO"
  },
  "224186": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Sikandarpur SO Ambedkar Nagar"
  },
  "224227": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Surapur SO"
  },
  "224190": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Tanda Tehseel SO"
  },
  "402202": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Revdanda SO"
  },
  "416524": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Walaval S.O"
  },
  "416420": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Soni S.O"
  },
  "670007": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Thottada SO"
  },
  "670594": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Varam SO"
  },
  "670011": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Chirakkal SO"
  },
  "670003": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kannur City SO"
  },
  "670611": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Mamba SO"
  },
  "721136": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Lowada SO"
  },
  "721166": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Lutunia SO"
  },
  "689541": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Vallamkulam SO"
  },
  "691525": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Thattayil SO"
  },
  "759104": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Chainpal Colony S.O"
  },
  "673017": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Chevayur SO"
  },
  "676561": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "MangalamMLP SO"
  },
  "676528": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Othukkungal SO"
  },
  "676303": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Parpanangadi SO"
  },
  "676106": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Ponmundam SO"
  },
  "676302": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "TanurMBR SO"
  },
  "676320": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Tayyalingal SO"
  },
  "676103": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Thalakkadathur SO"
  },
  "676105": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Thekkummuri SO"
  },
  "676301": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Tirunavaya SO"
  },
  "676306": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Tirurangadi Bazar SO"
  },
  "676311": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Moonniyur SO"
  },
  "676502": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Paravanna SO"
  },
  "458110": {
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "office": "Manasa S.O"
  },
  "458118": {
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "office": "Rampura S.O (Neemuch)"
  },
  "444804": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Purna Nagar S.O"
  },
  "415615": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Malgund S.O"
  },
  "413412": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Tulsidas Nagar S.O"
  },
  "413402": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Vairag S.O"
  },
  "441223": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Nawargaon S.O"
  },
  "764040": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Machhkund S.O"
  },
  "444907": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Shendurjana Ghat S.O"
  },
  "410202": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Khalapur S.O"
  },
  "570028": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Alanahalli S.O"
  },
  "495677": {
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "office": "Korba HO"
  },
  "758020": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Salapada S.O"
  },
  "758018": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Suakati S.O"
  },
  "758030": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Swampatna S.O"
  },
  "758026": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Talapada S.O"
  },
  "758019": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Telkoi S.O"
  },
  "143111": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Khilchian SO"
  },
  "143022": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Kot Mit Singh SO"
  },
  "143601": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Majitha SO"
  },
  "758021": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Anandapur College S.O"
  },
  "758038": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Baneikala S.O"
  },
  "758035": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Sundara Shiv Mandir S.O"
  },
  "758080": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Bhagamunda S.O"
  },
  "758041": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Champua S.O"
  },
  "673640": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Vazhakkad SO"
  },
  "673636": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Tenhipalam SO"
  },
  "473111": {
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "office": "N.F.L.Vijaipur S.O"
  },
  "473226": {
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "office": "Raghogarh S.O"
  },
  "689650": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Cherukole Kozhencherri SO"
  },
  "689668": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Churulicode SO"
  },
  "689106": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kuttur SO Pathanamthitta"
  },
  "689105": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Manjady Jn SO"
  },
  "412110": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Theur S.O"
  },
  "412207": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Vagholi S.O"
  },
  "412215": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Varvand S.O"
  },
  "410501": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Chakan S.O"
  },
  "413801": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "S R P F Daund S.O"
  },
  "412101": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Dehu Road Cantt S.O"
  },
  "410509": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Dimbhe Colony S.O"
  },
  "412408": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Ghodegaon S.O (Pune)"
  },
  "411025": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "I.A.T S.O"
  },
  "413106": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Indapur Bazar S.O"
  },
  "412303": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Jejuri S.O"
  },
  "410502": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Junnar S.O"
  },
  "576101": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Mission Compound SO KARNATAKA CIRCLE"
  },
  "574118": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Udyavara SO"
  },
  "581453": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Ramnagar S.O (Uttara Kannada)"
  },
  "445323": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Mohda S.O"
  },
  "445211": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Mulawa S.O"
  },
  "445102": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Ner Parsopant S.O"
  },
  "413715": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Belapur S.O"
  },
  "445110": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "Mahagaon Kasba S.O"
  },
  "412404": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Kadus S.O"
  },
  "410515": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Kalamb S.O (Pune)"
  },
  "410405": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Kamshet S.O"
  },
  "412203": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Kedgaon S.O (Pune)"
  },
  "442102": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Sewagram S.O"
  },
  "590006": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Bhagyanagar S.O (Belagavi)"
  },
  "590001": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Belagavi H.O"
  },
  "591113": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Kakati S.O"
  },
  "758078": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Dhanurjaypur S.O"
  },
  "624801": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Ayyalur SO"
  },
  "624005": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Balakrishnapurampudur SO"
  },
  "144801": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Kartarpur SO"
  },
  "144629": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Lohian SO"
  },
  "314402": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Dhambola S.O"
  },
  "314804": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Kanba S.O"
  },
  "152025": {
    "state": "PUNJAB",
    "district": "SRI MUKTSAR SAHIB",
    "office": "Bariwala SO"
  },
  "576111": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Belmannu S.O"
  },
  "757026": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Barsahi S.O"
  },
  "757074": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Basipitha S.O"
  },
  "757025": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Betnoti S.O"
  },
  "757087": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Brundaban Chandrapur S.O"
  },
  "410511": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Shiroli B K S.O"
  },
  "412306": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Someshwarnagar S.O"
  },
  "575015": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kavur S.O"
  },
  "575013": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kulur S.O"
  },
  "576121": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Mundkur S.O"
  },
  "575010": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Panambur S.O"
  },
  "574509": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Permude S.O"
  },
  "344044": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Siwana S.O"
  },
  "344037": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Swau Padamsingh S.O"
  },
  "590016": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Belagavi Shivaji Nagar S.O"
  },
  "590019": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Belagavi Vishweswaraih Nagar S.O"
  },
  "768027": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Attabira S.O"
  },
  "768038": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Bardol S.O (Bargarh)"
  },
  "583101": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Ballari H.O"
  },
  "344501": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Gadra Road S.O"
  },
  "344031": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Gudamalani S.O"
  },
  "344026": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Kalyanpur S.O (Barmer)"
  },
  "500045": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Yousufguda S.O"
  },
  "500004": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Khairatabad H.O"
  },
  "500033": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Jubilee Hills S.O"
  },
  "500082": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Somajiguda S.O"
  },
  "500028": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Shantinagar S.O"
  },
  "147005": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "Majithia Enclave SO"
  },
  "331507": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Sujangarh S.O"
  },
  "147203": {
    "state": "PUNJAB",
    "district": "FATEHGARH SAHIB",
    "office": "Amloh SO"
  },
  "416143": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "ICO Spinning Mills S.O"
  },
  "416101": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Jaysingpur S.O"
  },
  "416114": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Kodoli S.O"
  },
  "458339": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Malhargarh S.O"
  },
  "458553": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Narayangarh S.O (Mandsaur)"
  },
  "148022": {
    "state": "PUNJAB",
    "district": "MALERKOTLA",
    "office": "Amargarh SO"
  },
  "148017": {
    "state": "PUNJAB",
    "district": "SANGRUR",
    "office": "Bhalwan SO"
  },
  "148026": {
    "state": "PUNJAB",
    "district": "SANGRUR",
    "office": "Bhawanigarh SO"
  },
  "148029": {
    "state": "PUNJAB",
    "district": "SANGRUR",
    "office": "Cheema SO"
  },
  "148030": {
    "state": "PUNJAB",
    "district": "SANGRUR",
    "office": "Chhajli SO"
  },
  "148024": {
    "state": "PUNJAB",
    "district": "SANGRUR",
    "office": "Sr Dhuri SO"
  },
  "403110": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Corlim IE S.O"
  },
  "403104": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Neura S.O"
  },
  "403105": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Pale S.O"
  },
  "623513": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Chitharkottai SO"
  },
  "623514": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Devipattinam SO"
  },
  "623515": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Ervadi SO"
  },
  "623516": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Irumeni SO"
  },
  "623517": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Kilakarai SO"
  },
  "623519": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Mandapam Camp SO"
  },
  "623308": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Mangalakudi SO"
  },
  "623403": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Nambuthalai SO"
  },
  "334001": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Rani Bazar S.O (Rajasthan Circle)"
  },
  "575018": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Derlakatte S.O"
  },
  "574145": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Gurpur S.O"
  },
  "575022": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kotekar S.O"
  },
  "575017": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Permannur S.O"
  },
  "314027": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Khadagda S.O"
  },
  "136118": {
    "state": "HARYANA",
    "district": "KURUKSHETRA",
    "office": "Kurukshetra H.O"
  },
  "136134": {
    "state": "HARYANA",
    "district": "KURUKSHETRA",
    "office": "Mohri S.O"
  },
  "757014": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Chandua Ashram S.O"
  },
  "757018": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Chitrada S.O"
  },
  "587331": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "HIPPARGI SO"
  },
  "151507": {
    "state": "PUNJAB",
    "district": "MANSA",
    "office": "Sardulgarh SO"
  },
  "151302": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Talwandi Sabo SO"
  },
  "151501": {
    "state": "PUNJAB",
    "district": "MANSA",
    "office": "Bareta SO"
  },
  "151005": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Railway Colony SO Bathinda"
  },
  "151206": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Bhagta Bhai SO"
  },
  "151508": {
    "state": "PUNJAB",
    "district": "MANSA",
    "office": "Bhaini Bagha SO"
  },
  "151504": {
    "state": "PUNJAB",
    "district": "MANSA",
    "office": "Bhikhi SO"
  },
  "151101": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Bhucho Mandi SO"
  },
  "757021": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Deuli S.O"
  },
  "757075": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Dukura S.O"
  },
  "757082": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Garhdeulia S.O"
  },
  "757023": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Garia S.O (Mayurbhanj)"
  },
  "757086": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Jharpokharia S.O"
  },
  "757093": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Joka S.O (Mayurbhanj)"
  },
  "623521": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Pamban SO"
  },
  "623523": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Periyapattinam SO"
  },
  "484774": {
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "office": "Beohari S.O"
  },
  "484110": {
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "office": "Burhar S.O"
  },
  "484660": {
    "state": "MADHYA PRADESH",
    "district": "UMARIA",
    "office": "Chandia S.O"
  },
  "637201": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Chittalandur S.O"
  },
  "637202": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Elachipalayam S.O"
  },
  "637213": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Jedarpalayam S.O"
  },
  "637203": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Kandampalayam S.O"
  },
  "637204": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Kapilamalai S.O"
  },
  "637214": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Koottapalli S.O"
  },
  "637205": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Kumaramangalam S.O"
  },
  "623537": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Pottagavayal SO"
  },
  "623525": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Rajasingamangalam SO"
  },
  "623503": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Ramanathapuram Collectorate SO"
  },
  "623538": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Sanaveli SO"
  },
  "623528": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Sikkal SO Ramanathapuram"
  },
  "623532": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Thiruppullani SO"
  },
  "623531": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Tirupalaikudi SO"
  },
  "623407": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Tiruvadanai SO"
  },
  "623530": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Toruvalur SO"
  },
  "623534": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Uchipuli SO"
  },
  "623533": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Uthirakosamangai SO"
  },
  "623504": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Velipattanam SO"
  },
  "403403": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Piedade S.O"
  },
  "403513": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Colvale S.O"
  },
  "403108": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Goa  velha S.O"
  },
  "403530": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Onda I.E. S.O"
  },
  "314401": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Obri S.O"
  },
  "314011": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Paldeval S.O"
  },
  "314406": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Peeth S.O"
  },
  "314038": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Punjpur S.O"
  },
  "314034": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Ramgarh S.O (Dungarpur)"
  },
  "334305": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Bajju S.O"
  },
  "334021": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Chhatararh S.O"
  },
  "334801": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Deshnoke S.O"
  },
  "334303": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Diyatra S.O"
  },
  "575008": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Konchady S.O"
  },
  "416111": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Kumbhoj S.O"
  },
  "416106": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Kurundwad S.O"
  },
  "416104": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Narsobawadi S.O"
  },
  "416103": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Shirol S.O"
  },
  "416112": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Vadgaon S.O (Kolhapur)"
  },
  "416205": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Kale S.O (Kolhapur)"
  },
  "416001": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Kolhapur RS S.O"
  },
  "416230": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Kotoli S.O"
  },
  "575019": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kulai S.O"
  },
  "490001": {
    "state": "CHHATTISGARH",
    "district": "DURG",
    "office": "Sector 2 Bhilai SO"
  },
  "144701": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Malsian SO"
  },
  "144041": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Mehatpur SO Jalandhar"
  },
  "144040": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "DGNakoder SO"
  },
  "343030": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Joojani S.O"
  },
  "343049": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Kagmala S.O"
  },
  "343042": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Mandwala S.O"
  },
  "689107": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Muthoor SO"
  },
  "689589": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Punnavely SO"
  },
  "314022": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Sabla S.O"
  },
  "689588": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Vaipur SO"
  },
  "601103": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Vengal S.O"
  },
  "605101": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Auroville SO"
  },
  "605104": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Kottakuppam SO"
  },
  "605014": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "Pondicherry University SO"
  },
  "605007": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "Ariyankuppam SO"
  },
  "758032": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Ukhunda S.O"
  },
  "758085": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Banspal S.O"
  },
  "758086": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Bamebari S.O."
  },
  "758087": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Pandapada S.O"
  },
  "147104": {
    "state": "PUNJAB",
    "district": "FATEHGARH SAHIB",
    "office": "Chinarthal Kalan SO"
  },
  "140406": {
    "state": "PUNJAB",
    "district": "FATEHGARH SAHIB",
    "office": "RR Sirhind SO"
  },
  "403114": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Reis Magos S.O"
  },
  "403404": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Mardol S.O"
  },
  "590011": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Hindawadi S.O"
  },
  "590017": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Belagavi MalMaruti Extension S.O"
  },
  "141126": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Sri Bhaini Sahib SO"
  },
  "403115": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Cundaim I.E. S.O"
  },
  "403517": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Siolim S.O"
  },
  "314024": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Padwa S.O (Dungarpur)"
  },
  "140408": {
    "state": "PUNJAB",
    "district": "FATEHGARH SAHIB",
    "office": "Chunni Kalan SO"
  },
  "307501": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Abu S.O"
  },
  "307026": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Aburoad S.O"
  },
  "307032": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "BHARJA S.O"
  },
  "307511": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Anadra S.O"
  },
  "307031": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Binanigram S.O"
  },
  "307512": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Dantrai S.O"
  },
  "307801": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Jawal S.O"
  },
  "307019": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Jkpuram S.O"
  },
  "307802": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Kalandari S.O"
  },
  "307513": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Mandar S.O (Sirohi)"
  },
  "495452": {
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "office": "Deepika Project Korba"
  },
  "495444": {
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "office": "Dhelwadih"
  },
  "224133": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Dabha Samer SO"
  },
  "422308": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "K.K.Nagar S.O (Nashik)"
  },
  "331503": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Charwas S.O"
  },
  "757052": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Jugpura S.O"
  },
  "757040": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Kaptipada S.O"
  },
  "757019": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Khunta S.O"
  },
  "151502": {
    "state": "PUNJAB",
    "district": "MANSA",
    "office": "Budhlada SO"
  },
  "151201": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Goniana Mandi SO"
  },
  "151506": {
    "state": "PUNJAB",
    "district": "MANSA",
    "office": "Jhunir SO"
  },
  "151510": {
    "state": "PUNJAB",
    "district": "MANSA",
    "office": "Joga SO"
  },
  "124001": {
    "state": "HARYANA",
    "district": "ROHTAK",
    "office": "Rohtak HO"
  },
  "321023": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Jurhera S.O"
  },
  "321022": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Kamanlsg S.O"
  },
  "321201": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Kumher S.O"
  },
  "321602": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Nadbai Town S.O"
  },
  "416203": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Hupari S.O"
  },
  "623522": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Panaikulam SO"
  },
  "795128": {
    "state": "MANIPUR",
    "district": "CHURACHANDPUR",
    "office": "Churachandpur S.O"
  },
  "231305": {
    "state": "UTTAR PRADESH",
    "district": "MIRZAPUR",
    "office": "Narainpur SO Mirzapur"
  },
  "490026": {
    "state": "CHHATTISGARH",
    "district": "DURG",
    "office": "I E Bhilai SO"
  },
  "151208": {
    "state": "PUNJAB",
    "district": "FARIDKOT",
    "office": "Bargari SO"
  },
  "344043": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Mokalsar S.O"
  },
  "415104": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Kale S.O (Satara)"
  },
  "341516": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Dhankoli S.O"
  },
  "341304": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Jaswantgarh S.O"
  },
  "341318": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Khunkhuna S.O"
  },
  "341508": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "S.R. Kuchamancity S.O"
  },
  "341519": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Kukanwali S.O"
  },
  "458468": {
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "office": "Nayagaon C F S.O"
  },
  "209745": {
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "office": "Roshnabad SO"
  },
  "209747": {
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "office": "Sakrawa SO"
  },
  "209735": {
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "office": "Sarai Prayag SO"
  },
  "413304": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Mahadawar( Pandharpur) S.O"
  },
  "413101": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Akluj S.O"
  },
  "413212": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Bhimanagar S.O"
  },
  "413322": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Bhosa (M) S.O"
  },
  "413309": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Jawala S.O (Solapur)"
  },
  "413202": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Jeur S.O (Solapur)"
  },
  "413302": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Karkam S.O"
  },
  "413203": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Karmala S.O"
  },
  "209727": {
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "office": "Saraimira SO"
  },
  "209728": {
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "office": "Saurikh SO"
  },
  "457555": {
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "office": "Bajna S.O (Ratlam)"
  },
  "457441": {
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "office": "Bilpank S.O"
  },
  "457226": {
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "office": "Jaora S.O"
  },
  "457340": {
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "office": "KALUKHEDA S.O"
  },
  "457119": {
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "office": "Kharwa kalan S.O"
  },
  "457222": {
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "office": "Namli S.O"
  },
  "457331": {
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "office": "Piploda S.O"
  },
  "457336": {
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "office": "Ringnod S.O"
  },
  "457550": {
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "office": "Sailana S.O"
  },
  "224235": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "UPSS Mill SO"
  },
  "490011": {
    "state": "CHHATTISGARH",
    "district": "DURG",
    "office": "New Khursipar Bhilai SO"
  },
  "410513": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Chas S.O (Pune)"
  },
  "412109": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Dehu S.O"
  },
  "410402": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Ins Shivaji Lonavale S.O"
  },
  "575011": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Baikampady S.O"
  },
  "637503": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Mallasamudram S.O"
  },
  "637206": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Nadandai S.O"
  },
  "638008": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Pallipalayamagraharam S.O"
  },
  "637207": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Paramathi S.O"
  },
  "637208": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Paundamangalam S.O"
  },
  "637209": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Seetharamapalayam S.O"
  },
  "484116": {
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "office": "Amai Colliery S.O"
  },
  "522101": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Bapatla H.O"
  },
  "484440": {
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "office": "Bijuri S.O"
  },
  "457333": {
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "office": "Sukheda S.O"
  },
  "457118": {
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "office": "Tal S.O"
  },
  "465661": {
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "office": "Rajgarh Bus Stand S.O"
  },
  "333001": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Jhunjhunu Court S.O"
  },
  "341503": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Degana S.O"
  },
  "757083": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Bhimda S.O"
  },
  "416528": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Industrial Area Pinguli S.O"
  },
  "413006": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Ashok Chowk S.O"
  },
  "331025": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Alsisar S.O"
  },
  "333021": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Baragaon (Jhunjhunu)S.O"
  },
  "333303": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Chirana S.O"
  },
  "333701": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Churiajitgarh S.O"
  },
  "333011": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Dhanuri S.O"
  },
  "333707": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Doomra S.O"
  },
  "333305": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Jakhal S.O"
  },
  "422305": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Vinchur S.O"
  },
  "416110": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Bahubali S.O"
  },
  "416146": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Parvati Industrial Estate S.O"
  },
  "416121": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "R K Nagar Ichalkaranji S.O"
  },
  "416108": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Takali S.O"
  },
  "416231": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Dudhganganagar S.O"
  },
  "416005": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Gur Market Yard S.O"
  },
  "144624": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "Nadala SO"
  },
  "416105": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Ganeshwadi S.O (Kolhapur)"
  },
  "607402": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "Bahoor SO"
  },
  "605004": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "Mudaliarpet SO"
  },
  "605106": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "Nettapakkam SO"
  },
  "605010": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "Reddiarpalayam SO"
  },
  "605009": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "Thattanchavady SO"
  },
  "641663": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Mangalam SO"
  },
  "641664": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Palladam SO"
  },
  "641607": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Tirupur East SO"
  },
  "641606": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Vijayapuram SO"
  },
  "143119": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Mattewal SO"
  },
  "758082": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Brahmanipal S.O"
  },
  "413223": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Kem S.O"
  },
  "451447": {
    "state": "MADHYA PRADESH",
    "district": "BARWANI",
    "office": "Rajpur Barwani S.O"
  },
  "451666": {
    "state": "MADHYA PRADESH",
    "district": "BARWANI",
    "office": "Sendhwa S.O"
  },
  "416102": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Nandani S.O"
  },
  "416113": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Tatyasaheb Kore Nagar SO"
  },
  "344703": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Rawatsar S.O (Barmer)"
  },
  "458664": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Piplia S.O"
  },
  "124507": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Bahadurgarh HO"
  },
  "124141": {
    "state": "HARYANA",
    "district": "JHAJJAR",
    "office": "Power Plant Jharli SO"
  },
  "484444": {
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "office": "Jamuna Colliery S.O"
  },
  "484334": {
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "office": "Kotma S.O"
  },
  "637101": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Idappadi S.O"
  },
  "623536": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Perungulam SO Ramanathapuram"
  },
  "623524": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Pudumadam SO"
  },
  "623526": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Rameswaram SO"
  },
  "623409": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Tondi SO"
  },
  "623315": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Vellayapuram SO"
  },
  "583153": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Shankar Hill Town Colony S.O."
  },
  "148102": {
    "state": "PUNJAB",
    "district": "BARNALA",
    "office": "Bhadaur SO Sangrur"
  },
  "403103": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Shiroda S.O (South Goa)"
  },
  "637102": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Konganapuram S.O"
  },
  "637107": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Poolampatti S.O"
  },
  "637303": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Sankari West S.O"
  },
  "637302": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Sankaridrug.R.S S.O"
  },
  "637301": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Sankaridrug S.O"
  },
  "638183": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Komarapalayam S.O"
  },
  "484330": {
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "office": "Jaithari S.O"
  },
  "484881": {
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "office": "Rajendragram S.O"
  },
  "484886": {
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "office": "Amarkantak S.O"
  },
  "484887": {
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "office": "Igntu Amarkantak S.O."
  },
  "484336": {
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "office": "Kotma Colliery S.O"
  },
  "484447": {
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "office": "Amadand S.O"
  },
  "484551": {
    "state": "MADHYA PRADESH",
    "district": "UMARIA",
    "office": "Birsinghpur Pali S.O"
  },
  "484770": {
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "office": "Gohparu S.O"
  },
  "484771": {
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "office": "Jaisinghnagar S.O"
  },
  "484669": {
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "office": "Jaitpur S.O (Shahdol)"
  },
  "124513": {
    "state": "HARYANA",
    "district": "ROHTAK",
    "office": "Nindana SO"
  },
  "484665": {
    "state": "MADHYA PRADESH",
    "district": "UMARIA",
    "office": "Manpur S.O (Umaria)"
  },
  "484555": {
    "state": "MADHYA PRADESH",
    "district": "UMARIA",
    "office": "Nowrozabad S.O"
  },
  "679512": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Ambalapara SO"
  },
  "679505": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Chalavara SO"
  },
  "458775": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Bhanpura S.O"
  },
  "458778": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Bhensoda Mandi S.O"
  },
  "458667": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Dalauda S.O"
  },
  "414609": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Bhanashivara S.O"
  },
  "413716": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Deolali Pravara S.O"
  },
  "422620": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Ghargaon S.O"
  },
  "413718": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Harigaon S.O"
  },
  "413717": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Karegaon Factory S.O"
  },
  "413710": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Kolhar S.O (Ahmed Nagar)"
  },
  "423602": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Kolpewadi S.O"
  },
  "423601": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Kopargaon S.O"
  },
  "422610": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Kotul S.O"
  },
  "414604": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Kukana S.O"
  },
  "414603": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Nevasa S.O"
  },
  "678597": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Karimba SO"
  },
  "679306": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Melepattambi SO"
  },
  "262001": {
    "state": "UTTAR PRADESH",
    "district": "PILIBHIT",
    "office": "Station Road Pilibhit SO"
  },
  "400021": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "New Yogakshema SO"
  },
  "484117": {
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "office": "Amlai Paper Mills S.O"
  },
  "413721": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Padhegaon S.O"
  },
  "413707": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Puntamba S.O"
  },
  "423107": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Rahata S.O"
  },
  "413706": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Rahuri Factory S.O"
  },
  "231211": {
    "state": "UTTAR PRADESH",
    "district": "MIRZAPUR",
    "office": "Lalganj Mirzapur SO"
  },
  "231215": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Rajpur SO Sonbhadra"
  },
  "231213": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Ram Garh SO"
  },
  "795102": {
    "state": "MANIPUR",
    "district": "CHANDEL",
    "office": "Chakpikarong S.O"
  },
  "795127": {
    "state": "MANIPUR",
    "district": "CHANDEL",
    "office": "Chandel S.O"
  },
  "457339": {
    "state": "MADHYA PRADESH",
    "district": "RATLAM",
    "office": "Dhodhar RS S.O"
  },
  "148105": {
    "state": "PUNJAB",
    "district": "BARNALA",
    "office": "Dhanaula SO"
  },
  "630551": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Kalayarkoil SO"
  },
  "637210": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Solasiramani S.O"
  },
  "321407": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Chhonkarwara Kalan S.O"
  },
  "313322": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Khamnore S.O"
  },
  "313327": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Koaria S.O"
  },
  "313323": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Kotharia S.O (Rajsamand)"
  },
  "313328": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Kuraj S.O"
  },
  "313301": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Nathdwara S.O"
  },
  "313706": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Bambora S.O"
  },
  "758046": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Turumunga S.O"
  },
  "799269": {
    "state": "TRIPURA",
    "district": "North Tripura",
    "office": "Jampui S.O"
  },
  "799261": {
    "state": "TRIPURA",
    "district": "North Tripura",
    "office": "Kadamtala S.O (North Tripura)"
  },
  "465449": {
    "state": "MADHYA PRADESH",
    "district": "AGAR MALWA",
    "office": "Soyat Kalan S.O"
  },
  "465447": {
    "state": "MADHYA PRADESH",
    "district": "AGAR MALWA",
    "office": "Susner S.O"
  },
  "441304": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Narkher S.O"
  },
  "441305": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Paradsinga S.O"
  },
  "341515": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Harsore S.O"
  },
  "341305": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Koliya S.O"
  },
  "341517": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Ladariya S.O"
  },
  "341306": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Rahugate Ladnun S.O"
  },
  "341507": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Maroth S.O"
  },
  "341506": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Maulasar S.O"
  },
  "341533": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Mithri S.O"
  },
  "637304": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Thannirpandalpalayam S.O"
  },
  "637103": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Mc Donalds Choultry S.O"
  },
  "641669": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Sultanpet SO"
  },
  "414505": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Vridheshwar SSK S.O"
  },
  "451225": {
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "office": "Piplya Buzurg S.O"
  },
  "451111": {
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "office": "Sanawad S.O"
  },
  "451442": {
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "office": "Segaon S.O (West Nimar)"
  },
  "451440": {
    "state": "MADHYA PRADESH",
    "district": "KHARGONE",
    "office": "Un S.O (West Nimar)"
  },
  "307803": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Ramseen S.O"
  },
  "343040": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Raniwara S.O"
  },
  "343041": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Sanchore S.O"
  },
  "343022": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Sayla S.O (Jalor)"
  },
  "343024": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Siana S.O"
  },
  "343021": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Ummedabad S.O"
  },
  "343048": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Vadgaon S.O (Jalor)"
  },
  "410406": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Pawananagar S.O"
  },
  "314026": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Galiakot S.O"
  },
  "314028": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Punali S.O"
  },
  "301411": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Tizara S.O"
  },
  "301023": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Vijay Mandir S.O"
  },
  "301701": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Bahror H.O"
  },
  "301401": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Ajerka S.O"
  },
  "341509": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Nawacity Lsg S.O"
  },
  "341316": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Nimbijodhan S.O"
  },
  "341319": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Toshina S.O"
  },
  "484446": {
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "office": "Rajnagar Colliery S.O"
  },
  "141117": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Sihar SO"
  },
  "756114": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Bant S.O"
  },
  "144404": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Ajnoha SO"
  },
  "641667": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Pongalur SO"
  },
  "641604": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Tirupur Bazaar SO"
  },
  "500018": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Vivekananda Nagar Colony S.O"
  },
  "500081": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Cyberabad S.O"
  },
  "500096": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Film Nagar S.O"
  },
  "500041": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Raj Bhawan S.O"
  },
  "500034": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Banjara Hills S.O"
  },
  "151503": {
    "state": "PUNJAB",
    "district": "MANSA",
    "office": "Boha SO"
  },
  "151111": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Ghtp Lehra Mohabbat SO"
  },
  "151002": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Gndtp Bathinda SO"
  },
  "756113": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Barapada S.O"
  },
  "756112": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Barikpur Bazar S.O"
  },
  "756125": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Basudevpur College S.O"
  },
  "756168": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Betada S.O"
  },
  "756120": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Bhandari Pokhari S.O"
  },
  "756165": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Brahmanigaon S.O"
  },
  "756133": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Chandbali Bazar S.O"
  },
  "756101": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Bhadrak R S S.O"
  },
  "756171": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Dhamara S.O"
  },
  "756117": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Dhamnagar S.O"
  },
  "756119": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Dhusuri S.O"
  },
  "756127": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Dolasahi S.O"
  },
  "756162": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Eram S.O"
  },
  "756124": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Ertal S.O"
  },
  "148018": {
    "state": "PUNJAB",
    "district": "MALERKOTLA",
    "office": "Bagrian SO"
  },
  "641605": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Veerapandi SO"
  },
  "641662": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Kuppusamynaidupuram SO"
  },
  "641666": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Perumanallur SO"
  },
  "641602": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Tirupur North SO"
  },
  "506013": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Laxmipur  S.O"
  },
  "344705": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Gunga S.O"
  },
  "332709": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "NPKhandela SO"
  },
  "332602": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Khatushyamjika SO"
  },
  "332603": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Mahroli SO"
  },
  "332711": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Maonda RS SO"
  },
  "332713": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Nimkathana Town SO"
  },
  "332718": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Patan SO Sikar"
  },
  "332404": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Ringas Town SO"
  },
  "332719": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Thoi SO"
  },
  "465674": {
    "state": "MADHYA PRADESH",
    "district": "RAJGARH",
    "office": "Biaora S.O"
  },
  "413705": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Rahuri S.O"
  },
  "422604": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Rajur S.O"
  },
  "413719": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Ranjangaon Kd S.O"
  },
  "413708": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Sakarwadi S.O"
  },
  "422622": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Sakur S.O"
  },
  "422605": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Ganeshnagar S.O (Sangamner)"
  },
  "341001": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Nagaurcity S.O"
  },
  "341501": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Badu S.O (Nagaur)"
  },
  "333032": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Bhorki S.O"
  },
  "333022": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Gudhagorjika S.O"
  },
  "623404": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Pandugudi SO"
  },
  "623406": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Sundarapandiapattinam SO"
  },
  "623529": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Thangachimadam SO"
  },
  "590009": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Belagavi Records MLI S.O"
  },
  "590003": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Belagavi Shahapur S.O"
  },
  "402404": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Diveagar SO"
  },
  "402103": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Goregaon SO RaigarhMH"
  },
  "402401": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Janjira Murud SO"
  },
  "402304": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Kolad SO"
  },
  "341317": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Ratau S.O"
  },
  "422602": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Bota S.O"
  },
  "413723": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Changdeonagar S.O"
  },
  "423604": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Chasnali S.O"
  },
  "423607": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Dhamori S.O"
  },
  "422603": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Dhandharphal S.O"
  },
  "413712": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Pravaranagar S.O"
  },
  "413722": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Rahuri MPKV S.O"
  },
  "333302": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Chhapoli S.O"
  },
  "331028": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Malsisar S.O"
  },
  "636104": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Belur S.O (Salem)"
  },
  "636105": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Gangavalli S.O"
  },
  "636107": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Malliakarai S.O"
  },
  "636108": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Narasingapuram S.O (Salem)"
  },
  "636109": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Pethanaickenpalayam S.O"
  },
  "636141": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Pudupet S.O(ATUR)"
  },
  "636112": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Talaivasal S.O"
  },
  "636113": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Thammampatti S.O"
  },
  "636114": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Thumbal S.O"
  },
  "636121": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Vadachennimalai S.O"
  },
  "636115": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Valapady S.O"
  },
  "636116": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Viraganur S.O"
  },
  "636117": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Yethapur S.O"
  },
  "313603": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Bhinder S.O (Udaipur)"
  },
  "441105": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Parseoni S.O"
  },
  "441106": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Ramtek S.O"
  },
  "799277": {
    "state": "TRIPURA",
    "district": "Unakoti",
    "office": "Panichowkibazar S.O"
  },
  "441303": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Mowad S.O"
  },
  "441113": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Patansaongi S.O"
  },
  "456665": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Tarana S.O"
  },
  "453001": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Betma S.O"
  },
  "453220": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Gautampura S.O"
  },
  "452020": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Kasturbagram S.O"
  },
  "453115": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Depalpur S.O"
  },
  "413703": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Visapur S.O (Ahmed Nagar)"
  },
  "451660": {
    "state": "MADHYA PRADESH",
    "district": "BARWANI",
    "office": "Thikari S.O"
  },
  "148021": {
    "state": "PUNJAB",
    "district": "MALERKOTLA",
    "office": "Ahmedgarh sO"
  },
  "148101": {
    "state": "PUNJAB",
    "district": "BARNALA",
    "office": "Barnala Kty SO"
  },
  "630602": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Idaikattur SO"
  },
  "630702": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Ilayangudi SO"
  },
  "756144": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Basantia S.O (Bhadrak)"
  },
  "583105": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Ballari Jnanasagara S.O"
  },
  "313804": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Chhani S.O (Udaipur)"
  },
  "313022": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Dabok S.O"
  },
  "313330": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Lawa Sardargarh S.O"
  },
  "313329": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Railmagra S.O"
  },
  "313342": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "T F Kankroli S.O"
  },
  "422608": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Sangamner SK S.O"
  },
  "423603": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Shinganapur S.O"
  },
  "458880": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Garoth S.O"
  },
  "676307": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Tanalur SO"
  },
  "676510": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Randathani SO"
  },
  "676108": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Triprangode SO"
  },
  "679324": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Mankada SO"
  },
  "679326": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Melattur SO Malappuram"
  },
  "676506": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Kottilangadi SO"
  },
  "676507": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Makkaraparamba SO"
  },
  "673642": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Mongam SO"
  },
  "332742": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Mandha Surera SO"
  },
  "332712": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Mundru SO"
  },
  "332714": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Sirohi SO"
  },
  "490009": {
    "state": "CHHATTISGARH",
    "district": "DURG",
    "office": "Sector 8 Bhilai SO"
  },
  "453112": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Gandhinagar S.O (Indore)"
  },
  "453111": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Hatod S.O"
  },
  "465113": {
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "office": "Sundersi S.O"
  },
  "465118": {
    "state": "MADHYA PRADESH",
    "district": "SHAJAPUR",
    "office": "AWANTIPUR BARODIYA"
  },
  "441502": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Mohpa S.O"
  },
  "458895": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Degaon Mali S.O"
  },
  "458771": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Gandhi Sagar S.O"
  },
  "413206": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Kettur II S.O"
  },
  "413317": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Khardi S.O"
  },
  "413315": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Bhosa (K) S.O"
  },
  "483504": {
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "office": "Katni Ordinance Factory S.O"
  },
  "486661": {
    "state": "MADHYA PRADESH",
    "district": "SIDHI",
    "office": "Sidhi Collectorate S.O"
  },
  "486776": {
    "state": "MADHYA PRADESH",
    "district": "SIDHI",
    "office": "Bharatpur S.O (Sidhi)"
  },
  "486670": {
    "state": "MADHYA PRADESH",
    "district": "SIDHI",
    "office": "Sihawal S.O"
  },
  "403006": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Ribandar S.O"
  },
  "484661": {
    "state": "MADHYA PRADESH",
    "district": "UMARIA",
    "office": "Umaria S.O"
  },
  "484664": {
    "state": "MADHYA PRADESH",
    "district": "UMARIA",
    "office": "Bandhavgarh National Park S.O"
  },
  "676509": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Munduparmba SO"
  },
  "679325": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Pattikkad SO"
  },
  "673639": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Areacode SO"
  },
  "673634": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Chelembra SO"
  },
  "679334": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Chungathara SO"
  },
  "679322": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Perintalmanna SO"
  },
  "679323": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Pulamanthole SO"
  },
  "673645": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Cheruvayur SO"
  },
  "679331": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Edakkaranilambur SO"
  },
  "676541": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Edavanna SO"
  },
  "307043": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Palri M S.O"
  },
  "637215": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Kuchipalayam S.O"
  },
  "638181": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Pothanur S.O"
  },
  "495455": {
    "state": "CHHATTISGARH",
    "district": "KORBA",
    "office": "Balgi Project Korba SO"
  },
  "343039": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Malwara S.O"
  },
  "442201": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Arvi S.O (Wardha)"
  },
  "442202": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Ashti S.O (Wardha)"
  },
  "442101": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Deoli S.O (Wardha)"
  },
  "464665": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Badi S.O"
  },
  "464672": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Bamhori S.O"
  },
  "464668": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Bareli S.O"
  },
  "679341": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Talekode SO"
  },
  "413736": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Loni Bk S.O"
  },
  "637501": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Attayampatti S.O"
  },
  "636008": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Kannankurichi S.O"
  },
  "636201": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Dasanaickenpatti S.O"
  },
  "636119": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Puthiragoundampalayam S.O"
  },
  "636110": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Sendarapatti S.O"
  },
  "636004": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Marakkadai S.O"
  },
  "636103": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Ayodhiyapattinam S.O"
  },
  "636138": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Karumanthurai S.O"
  },
  "636015": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Narayananagar S.O"
  },
  "636010": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Kondalampatti S.O"
  },
  "636139": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Koottathupatti S.O"
  },
  "636203": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Mullur S.O"
  },
  "636142": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Mullukurichi S.O"
  },
  "642112": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Kurichikottai S.O"
  },
  "642113": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Madathukulam S.O"
  },
  "642122": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Pulankinar S.O"
  },
  "642206": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Pulavadi S.O"
  },
  "642207": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Pungamuthur S.O"
  },
  "441107": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Saoner S.O"
  },
  "441306": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Sawargaon S.O"
  },
  "301402": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Bansur S.O"
  },
  "301022": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Thanagazi S.O"
  },
  "476001": {
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "office": "Morena City S.O"
  },
  "343001": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Jalore V.D.C. S.O"
  },
  "307029": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Ahore S.O"
  },
  "476111": {
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "office": "Ambah Ganj S.O"
  },
  "476219": {
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "office": "Baghchini S.O"
  },
  "500038": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Vengal Rao Nagar S.O"
  },
  "797112": {
    "state": "NAGALAND",
    "district": "DIMAPUR",
    "office": "Dimapur S.O"
  },
  "797111": {
    "state": "NAGALAND",
    "district": "WOKHA",
    "office": "Wokha S.O"
  },
  "797103": {
    "state": "NAGALAND",
    "district": "DIMAPUR",
    "office": "Chumukedima S.O"
  },
  "797118": {
    "state": "NAGALAND",
    "district": "DIMAPUR",
    "office": "Signal Village"
  },
  "797117": {
    "state": "NAGALAND",
    "district": "DIMAPUR",
    "office": "Circular Road S.O"
  },
  "797116": {
    "state": "NAGALAND",
    "district": "DIMAPUR",
    "office": "Dimapur Bazar S.O"
  },
  "798611": {
    "state": "NAGALAND",
    "district": "KIPHIRE",
    "office": "Kiphire S.O"
  },
  "797002": {
    "state": "NAGALAND",
    "district": "KOHIMA",
    "office": "Kohima Science College S.O"
  },
  "403502": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Tivim S.O"
  },
  "583118": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "D T Ship S.O"
  },
  "583275": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Vidyanagar S.O(Ballari)"
  },
  "423605": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Pohegaon S.O"
  },
  "209503": {
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "office": "Shamsabad SO Farrukhabad"
  },
  "209729": {
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "office": "Sikanderpur SO Kannauj"
  },
  "209731": {
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "office": "Talgram SO"
  },
  "209734": {
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "office": "Thathia SO"
  },
  "209732": {
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "office": "Tirwa SO"
  },
  "209738": {
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "office": "Umarda SO"
  },
  "402209": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Kurul RCF Colony SO"
  },
  "402301": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Mahad SO"
  },
  "402104": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Mangaon SO RaigarhMH"
  },
  "402105": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Mhasla SO"
  },
  "402309": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Midc Mahad SO"
  },
  "402305": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Nate SO"
  },
  "402120": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Nizampur SO RaigarhMH"
  },
  "410205": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Pali SO RaigarhMH"
  },
  "402107": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Pen SO"
  },
  "151106": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Bhai Rupa SO"
  },
  "230401": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Kohdaur SO"
  },
  "230204": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Kunda"
  },
  "230132": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Lalganj"
  },
  "477117": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Malanpur S.O"
  },
  "477222": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Mau S.O"
  },
  "477557": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Mehgoun S.O"
  },
  "477441": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Mihona S.O"
  },
  "477105": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Nai Zameen Bhind S.O"
  },
  "477555": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Phoop S.O"
  },
  "477335": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Raun S.O"
  },
  "756182": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Dungura S.O"
  },
  "452016": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Indore Kanadia Road S.O"
  },
  "477333": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Sagra S.O (Bhind"
  },
  "477331": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Umri S.O (Bhind"
  },
  "441203": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Umred S.O"
  },
  "456222": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Baledi S.O"
  },
  "456771": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Barnagar S.O"
  },
  "456313": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Bhatpachlana S.O"
  },
  "456331": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Birlagram  Nagda S.O"
  },
  "456550": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Ghattia S.O"
  },
  "424102": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Patonda S.O"
  },
  "424202": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Varkhedi S.O"
  },
  "425420": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Amalgaon S.O"
  },
  "425401": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Amalner S.O (Jalgaon)"
  },
  "425003": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Audyogik Vasahat Jalgaon S.O"
  },
  "425105": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Dharangaon S.O"
  },
  "464570": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Sultanganj SO"
  },
  "464881": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Begumganj S.O"
  },
  "464774": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Deori S.O (Raisen)"
  },
  "464884": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Gairatganj S.O"
  },
  "464990": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Goharganj S.O"
  },
  "464671": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Khargone S.O"
  },
  "464776": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Panjra S.O"
  },
  "464651": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Salamatpur Mandi S.O"
  },
  "464886": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Silwani S.O"
  },
  "464986": {
    "state": "MADHYA PRADESH",
    "district": "RAISEN",
    "office": "Sultanpur S.O (Raisen)"
  },
  "453441": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Mhow S.O"
  },
  "453331": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Rao S.O"
  },
  "490006": {
    "state": "CHHATTISGARH",
    "district": "DURG",
    "office": "Sector 5 Bhilai SO"
  },
  "685619": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Santhanpara SO"
  },
  "312022": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Bassi S.O (Chittorgarh)"
  },
  "312023": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Begun S.O"
  },
  "323307": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Bhabhanagar S.O"
  },
  "312024": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Bhadsaura S.O"
  },
  "230403": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Madhoganj SO"
  },
  "230402": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Mandhata SO"
  },
  "230135": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Patti"
  },
  "230002": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Pratapgarh City SO"
  },
  "230121": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "PDCHAURAHA SO"
  },
  "230304": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Raniganj SO"
  },
  "230138": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Saifabad SO"
  },
  "230139": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Sangipur SO"
  },
  "230141": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Sangramgarh SO"
  },
  "486882": {
    "state": "MADHYA PRADESH",
    "district": "SINGRAULI",
    "office": "Chitrangi S.O"
  },
  "486889": {
    "state": "MADHYA PRADESH",
    "district": "SINGRAULI",
    "office": "Singrauli Colliery S.O"
  },
  "486886": {
    "state": "MADHYA PRADESH",
    "district": "SINGRAULI",
    "office": "Waidhan S.O"
  },
  "486887": {
    "state": "MADHYA PRADESH",
    "district": "SINGRAULI",
    "office": "Amlori Project S.O"
  },
  "470001": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Sagar Gopalganj S.O"
  },
  "470021": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Bamora S.O"
  },
  "470335": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Banda Belai S.O"
  },
  "470442": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Bandri S.O"
  },
  "442301": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Hinganghat Town S.O"
  },
  "442203": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Karanja S.O (Wardha)"
  },
  "442106": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Kharangna S.O"
  },
  "442306": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Nachangaon S.O"
  },
  "442302": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Pulgaon S.O"
  },
  "212601": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Fatehpur Court SO"
  },
  "212631": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Amauli SO"
  },
  "343032": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Bagoda S.O"
  },
  "343025": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Bagra S.O"
  },
  "421402": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Dhasai S.O"
  },
  "421201": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Tilaknagar S.O (Thane)"
  },
  "421602": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Kasara S.O (Thane)"
  },
  "421306": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Ganeshwadi S.O (Thane)"
  },
  "421403": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Kinholi S.O"
  },
  "421503": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Kulgaon S.O"
  },
  "421401": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Murbad S.O"
  },
  "421103": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Shahad S.O"
  },
  "421601": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Shahapur S.O (Thane)"
  },
  "400608": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Balkum S.O"
  },
  "421302": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Dandekarwadi S.O"
  },
  "333304": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Jhajhar S.O"
  },
  "331030": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Mahansar S.O"
  },
  "323304": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Bhenshroadgarh S.O"
  },
  "312204": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Bhoopal sagar S.O"
  },
  "312614": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Binota S.O"
  },
  "312604": {
    "state": "RAJASTHAN",
    "district": "PRATAPGARH",
    "office": "Chhoti Sadari S.O"
  },
  "312619": {
    "state": "RAJASTHAN",
    "district": "PRATAPGARH",
    "office": "Dalot S.O"
  },
  "312616": {
    "state": "RAJASTHAN",
    "district": "PRATAPGARH",
    "office": "Dhamotar  S.O"
  },
  "312402": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Doongla S.O"
  },
  "312901": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Gangrar S.O"
  },
  "312201": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Gosunda S.O"
  },
  "312202": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Kapasan S.O"
  },
  "453771": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Manglia S.O"
  },
  "453661": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Manpur S.O (Indore)"
  },
  "453551": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Sanwer S.O"
  },
  "275306": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "KOIRIYAPAR SO"
  },
  "275102": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "INDARA"
  },
  "275305": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "KOPAGANJ SO"
  },
  "402117": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Morba SO"
  },
  "402106": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Nagothane SO"
  },
  "402122": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Sai SO"
  },
  "402110": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Shriwardhan SO"
  },
  "402111": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Tala SO RaigarhMH"
  },
  "402112": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Talashet SO"
  },
  "402306": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Varandh SO"
  },
  "402307": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Vinhere SO"
  },
  "402113": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Walwati SO"
  },
  "476444": {
    "state": "MADHYA PRADESH",
    "district": "MORENA",
    "office": "Banmore S.O"
  },
  "476335": {
    "state": "MADHYA PRADESH",
    "district": "SHEOPUR",
    "office": "Beerpur S.O"
  },
  "230306": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Suwansa SO"
  },
  "421301": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Subhash Road S.O (Thane)"
  },
  "230404": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Vishwanathganj SO"
  },
  "230133": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "PIRTHIGANJ BAZAR SO"
  },
  "230503": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Kishunganj SO"
  },
  "230134": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Oraiyadeeh SO"
  },
  "221603": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "Madhu Ban SO"
  },
  "221602": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "MARYADPUR SO"
  },
  "276403": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "Mohammadabad Gohana Chowk SO"
  },
  "221706": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "Ratan Pura SO"
  },
  "276405": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "Walid Pur SO"
  },
  "275103": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "Kushmaur SO"
  },
  "442304": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Allipur S.O (Wardha)"
  },
  "758037": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Bolani S.O"
  },
  "416526": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Koulage S.O"
  },
  "416508": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Kowad S.O"
  },
  "416204": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Kuditre S.O"
  },
  "416503": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Mahagaon (Kolhapur) S.O"
  },
  "415101": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Malkapur S.O (Kolhapur)"
  },
  "416223": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Mhasve S.O"
  },
  "455227": {
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "office": "Bagli S.O"
  },
  "455111": {
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "office": "Balgarh S.O"
  },
  "455115": {
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "office": "Bhonrasa S.O"
  },
  "441214": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Sirsi S.O (Nagpur)"
  },
  "416122": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "MIDC Shiroli S.O"
  },
  "416219": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Murgud S.O"
  },
  "416504": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Nesari S.O"
  },
  "416551": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Nool S.O"
  },
  "416202": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Pattankodoli S.O"
  },
  "416118": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Rukadi S.O"
  },
  "416235": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Sadashivnagar S.O"
  },
  "416214": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Sarud S.O"
  },
  "416215": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Shahuwadi S.O"
  },
  "416232": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Sidhnerli S.O"
  },
  "416220": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Uttur S.O"
  },
  "421605": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Manda S.O"
  },
  "400612": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Mumbra S.O"
  },
  "421204": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Manpada S.O"
  },
  "421505": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Netaji Bazar S.O"
  },
  "470051": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Bilahra Raja S.O"
  },
  "470113": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Bina Bazaria S.O"
  },
  "470226": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Deori Nadipar S.O"
  },
  "470228": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Dhana S.O"
  },
  "470232": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Garhakota Nadipar S.O"
  },
  "470223": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Gaurjhamar S.O"
  },
  "470125": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Jaisinagar S.O"
  },
  "470115": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Jaruakheda S.O"
  },
  "470337": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Karrapur S.O"
  },
  "421312": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Kudus S.O"
  },
  "146110": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Kot Abdul Khaliq SO"
  },
  "144519": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Kotfathui SO"
  },
  "416221": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Walwa Bk S.O"
  },
  "470235": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Kesli S.O"
  },
  "470118": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Khimlasa S.O"
  },
  "606204": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Pukkiravari S.O"
  },
  "606205": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Rishivandiyam S.O"
  },
  "606401": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Sankarapuram (Villupuram) S.O"
  },
  "606206": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Tiyagadrug S.O"
  },
  "606107": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Ulundurpet S.O"
  },
  "606207": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Vadakkanandal S.O"
  },
  "271825": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Barnapur SO"
  },
  "415605": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Markandi S.O"
  },
  "415726": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Abaloli S.O"
  },
  "484113": {
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "office": "Venkatnagar S.O"
  },
  "604505": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Vallam Arni SO"
  },
  "604408": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Vandavasi SO"
  },
  "604410": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Vembakkam SO"
  },
  "606901": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Adamangalam SO"
  },
  "606755": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Avur SO"
  },
  "230136": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Sagra SO"
  },
  "230142": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Shitlaganj SO"
  },
  "284303": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Moth SO"
  },
  "284306": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Poonchh SO"
  },
  "284419": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Raksa SO"
  },
  "284205": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Ranipur SO Jhansi"
  },
  "284003": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Sipri Bazar SO"
  },
  "284206": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Tori Fatehpur SO"
  },
  "636014": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Kamaraj Nagar Colony S.O"
  },
  "642205": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Pedappampatti S.O"
  },
  "636101": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Aragalur S.O"
  },
  "636106": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Karipatti S.O"
  },
  "284204": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Mauranipur Bus Stand SO"
  },
  "284304": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Samthar SO"
  },
  "284128": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Bundelkhand University SO"
  },
  "151505": {
    "state": "PUNJAB",
    "district": "MANSA",
    "office": "Mansa SO Mansa"
  },
  "275307": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "Semari Jamal Pur SO"
  },
  "276306": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "Suraj Pur SO"
  },
  "402115": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Upper Tudil SO"
  },
  "458990": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Sitamau S.O"
  },
  "458888": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Suwasara Mandi S.O"
  },
  "470117": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Khurai City S.O"
  },
  "470880": {
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "office": "Tendukheda S.O"
  },
  "470664": {
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "office": "Bandakpur S.O"
  },
  "470673": {
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "office": "Batiagarh S.O"
  },
  "470775": {
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "office": "Hatta Bazariya S.O"
  },
  "470881": {
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "office": "Jabera S.O"
  },
  "470675": {
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "office": "Narsingarh S.O"
  },
  "475675": {
    "state": "MADHYA PRADESH",
    "district": "DATIA",
    "office": "Indergarh S.O (Datia"
  },
  "636140": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Odayapatti S.O"
  },
  "642204": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Komaralingam S.O"
  },
  "642111": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Krishnapuram S.O (Coimbatore)"
  },
  "636118": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Ulipuram S.O"
  },
  "485115": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Rampur Baghelan S.O"
  },
  "485111": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Ramvan S.O"
  },
  "470663": {
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "office": "Nohata S.O"
  },
  "470666": {
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "office": "Pathariya S.O"
  },
  "470672": {
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "office": "Bansa Tarkheda S.O"
  },
  "412409": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Otur S.O"
  },
  "412403": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Pabal S.O"
  },
  "413110": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Pandare S.O"
  },
  "458556": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Budha S.O"
  },
  "416413": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Umadi S.O"
  },
  "416414": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Wanlsswadi S.O"
  },
  "416415": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Willingdon College Sangli S.O"
  },
  "415401": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Aitawade BK S.O"
  },
  "416301": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Ashte S.O"
  },
  "415301": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Atpadi S.O"
  },
  "416302": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Bagani S.O"
  },
  "485772": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Sarlanagar S.O"
  },
  "485447": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Singhpur S.O (Satna)"
  },
  "485441": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Sohawal S.O"
  },
  "485661": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Unchehara S.O"
  },
  "231219": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Obra SO Sonbhadra"
  },
  "642132": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Valavadi S.O"
  },
  "321001": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Anahgatebharatpur S.O"
  },
  "415402": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Bilashi S.O"
  },
  "416304": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Budhgaon S.O"
  },
  "415305": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Kadepur S.O"
  },
  "610205": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Tirunellikaval S.O"
  },
  "402126": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Pipenagar SO"
  },
  "416314": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Visapur S.O (Sangli)"
  },
  "415412": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Chikurde S.O"
  },
  "415303": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Devrashtra S.O"
  },
  "415315": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Dighanchi S.O"
  },
  "415304": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Kadegaon S.O"
  },
  "402102": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Dasgaon SO"
  },
  "402402": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Dighi SO"
  },
  "757055": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Amarda S.O"
  },
  "757100": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Bahanada Sathilo S.O"
  },
  "685618": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Surianalle SO"
  },
  "685595": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Udumbannur SO"
  },
  "455223": {
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "office": "Hatpipliya S.O"
  },
  "232102": {
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "office": "Baburi SO"
  },
  "232103": {
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "office": "Chakia SO"
  },
  "415603": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Alore S.O"
  },
  "455332": {
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "office": "Kannod S.O"
  },
  "455440": {
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "office": "Kantaphod S.O"
  },
  "455221": {
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "office": "Karnawad S.O"
  },
  "455336": {
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "office": "Khategaon S.O"
  },
  "343023": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Dhansa S.O"
  },
  "621701": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Ambapur SO"
  },
  "402204": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Nagaon SO"
  },
  "609704": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Tirukannapuram S.O"
  },
  "610204": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Tirukuvalai S.O"
  },
  "455339": {
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "office": "Nemawar S.O"
  },
  "455459": {
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "office": "Satwas S.O"
  },
  "455118": {
    "state": "MADHYA PRADESH",
    "district": "DEWAS",
    "office": "Sonkutch S.O"
  },
  "424203": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Pimpalgaon S.O"
  },
  "425102": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Bhadli BK S.O"
  },
  "756046": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Anantapur S.O (Baleswar)"
  },
  "685583": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Vazhithala SO"
  },
  "685563": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Vellathooval SO"
  },
  "685608": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Vengallur SO"
  },
  "685585": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Thodupuzha East SO"
  },
  "685614": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Talliar SO"
  },
  "685607": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Vannapuram SO"
  },
  "209749": {
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "office": "Yaqutganj SO"
  },
  "458330": {
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "office": "Jawad S.O"
  },
  "458336": {
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "office": "Jeeran S.O"
  },
  "416201": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Panhala S.O"
  },
  "485114": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Sagmania S.O"
  },
  "485005": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Satna Birla Vikas S.O"
  },
  "307030": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Gudabalotan S.O"
  },
  "343027": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Hadecha S.O"
  },
  "307515": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Jaswantpura S.O"
  },
  "764052": {
    "state": "ODISHA",
    "district": "MALKANGIRI",
    "office": "Chitrakonda S.O"
  },
  "764072": {
    "state": "ODISHA",
    "district": "NABARANGPUR",
    "office": "Dabugam S.O"
  },
  "764002": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Jeypore(K) R.S. S.O"
  },
  "441207": {
    "state": "MAHARASHTRA",
    "district": "GADCHIROLI",
    "office": "Desaiganj S.O"
  },
  "442606": {
    "state": "MAHARASHTRA",
    "district": "GADCHIROLI",
    "office": "Dhanora S.O"
  },
  "623518": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Mandapam SO"
  },
  "431102": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Ellora S.O"
  },
  "431109": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Gangapur (Aurangabad MH) S.O"
  },
  "431103": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Kannad S.O"
  },
  "475115": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "Pichhore Gird S.O"
  },
  "327604": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Barodia S.O"
  },
  "327603": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Chhinch S.O"
  },
  "327021": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Ganoda S.O"
  },
  "327022": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Garhi S.O (Banswara)"
  },
  "327023": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Ghatol S.O"
  },
  "613602": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Budalur S.O"
  },
  "613001": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "TJ Busstand S.O"
  },
  "613201": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Kalyanapuram S.O"
  },
  "613202": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Kandiyur S.O"
  },
  "613303": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Kurungulam Melpathi S.O"
  },
  "613501": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Mariammancoil S.O"
  },
  "613502": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Pundi TJ S.O"
  },
  "613402": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Sengipatti S.O"
  },
  "613103": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Thiruppanthuruthi S.O"
  },
  "613204": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Thiruvaiyaru S.O"
  },
  "613104": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Tirukattupalli East S.O"
  },
  "613009": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Thanjavur West S.O"
  },
  "613101": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Nadukaveri S.O"
  },
  "613105": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Poondi TPL S.O"
  },
  "613005": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Raja Serfoji Govt College S.O"
  },
  "613504": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Saliamangalam S.O"
  },
  "613004": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Thanjavur Medical College S.O"
  },
  "613006": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Thanjavur Pandt Colony S.O"
  },
  "613203": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Thillaisthanam S.O"
  },
  "412102": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Nira R S S.O"
  },
  "413132": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Palasdeo S.O"
  },
  "425303": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Adavad S.O"
  },
  "425304": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Bhalod S.O (Jalgaon)"
  },
  "425310": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Bodwad S.O"
  },
  "425201": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Bhusawal Kutchery S.O"
  },
  "425503": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Faizpur S.O"
  },
  "425507": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Khirdi S.O"
  },
  "425504": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Khiroda S.O"
  },
  "425327": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Kurha kakoda S.O"
  },
  "425524": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "M.S.S.K.Faizpur S.O"
  },
  "425306": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Old Muktainagar S.O"
  },
  "425309": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Nashirabad S.O"
  },
  "425506": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Nimbhora S.O"
  },
  "425508": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Raver S.O"
  },
  "425307": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Deepnagar S.O"
  },
  "425311": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Kurha S.O"
  },
  "613102": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Thogur S.O"
  },
  "613401": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Tirumalaisamudram East S.O"
  },
  "613403": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Vallam TJ S.O"
  },
  "613003": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Vennar Bank S.O"
  },
  "613002": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Karuntattankudi S.O"
  },
  "613007": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "TJ Co operative Housing Colony S.O"
  },
  "768228": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Kesaibahal S.O"
  },
  "768227": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Kusumi S.O"
  },
  "768214": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Laida S.O"
  },
  "768212": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Rengali SO"
  },
  "431101": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Khuldabad S.O"
  },
  "423702": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Lasur Station S.O"
  },
  "431118": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Phardapur S.O"
  },
  "431112": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Sillod S.O"
  },
  "431135": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Sillod Sakhar Karkhana S.O"
  },
  "421603": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Bhatsanagar S.O"
  },
  "421102": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Mohone S.O"
  },
  "144623": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "Kala Sanghian SO"
  },
  "143109": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Chogawan SO"
  },
  "768110": {
    "state": "ODISHA",
    "district": "DEOGARH",
    "office": "Barkote S.O"
  },
  "425302": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Sakali S.O"
  },
  "794109": {
    "state": "MEGHALAYA",
    "district": "WEST GARO HILLS",
    "office": "Tikrikilla S.O"
  },
  "761151": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Asura Bandha S.O"
  },
  "766019": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Koksara S.O"
  },
  "766102": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Madanpur Rampur S.O"
  },
  "766023": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Mahichala S.O"
  },
  "766026": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Mukhiguda S.O"
  },
  "766110": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Narla Road S.O"
  },
  "413314": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Kole S.O (Solapur)"
  },
  "442704": {
    "state": "MAHARASHTRA",
    "district": "GADCHIROLI",
    "office": "Ettapalli S.O"
  },
  "766100": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Narla S.O"
  },
  "766103": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Parla S.O"
  },
  "766029": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Sosia S.O"
  },
  "425203": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Bhusawal Ordnance Factory S.O"
  },
  "470771": {
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "office": "Hindoriya S.O"
  },
  "470772": {
    "state": "MADHYA PRADESH",
    "district": "DAMOH",
    "office": "Patera S.O"
  },
  "431131": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Majalgaon S.O"
  },
  "431125": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Naiknoor S.O"
  },
  "431515": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Parli Vaijinath S.O"
  },
  "414204": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Patoda S.O (Beed)"
  },
  "413229": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Pimpalwandi S.O (Beed)"
  },
  "414205": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Rajuri Navgan S.O"
  },
  "413249": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Shirur S.O (Beed)"
  },
  "431129": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Talkhed S.O"
  },
  "327034": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Jolana S.O"
  },
  "327027": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Khamera S.O"
  },
  "327801": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Kushalgarh S.O"
  },
  "431130": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Umapur S.O"
  },
  "431530": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Vssk Pangri S.O"
  },
  "431144": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Wadwani S.O"
  },
  "764005": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Jayanagar S.O (Koraput)"
  },
  "764041": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Jolaput S.O"
  },
  "764028": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Dasamanthpur S.O"
  },
  "764058": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Kotpad S.O"
  },
  "680741": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Annamanada SO"
  },
  "680731": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Ashtamichira SO"
  },
  "680312": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Chengallur SO"
  },
  "680309": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kinfra Park Koratti SO"
  },
  "680302": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Alagappanagar SO"
  },
  "680684": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kodakara SO"
  },
  "322001": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Adarsh Nagar SO Sawai Madhopur"
  },
  "224181": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Ram Nagar SO Ambedkar Nagar"
  },
  "321611": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Todabhim SO"
  },
  "768222": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Kuchinda S.O"
  },
  "768107": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Jamankira S.O"
  },
  "768234": {
    "state": "ODISHA",
    "district": "JHARSUGUDA",
    "office": "Itps Banaharpali S.O"
  },
  "768202": {
    "state": "ODISHA",
    "district": "JHARSUGUDA",
    "office": "K.M. Road Jharsuguda S.O"
  },
  "431120": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Soegaon S.O"
  },
  "431008": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Harsool S.O"
  },
  "756033": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Hatigarh S.O (Baleswar)"
  },
  "756086": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Jaleswar Railway Station S.O"
  },
  "756081": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Jamsuli S.O"
  },
  "756035": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Kamarda S.O"
  },
  "756034": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Nampo S.O"
  },
  "756024": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Nangaleswar S.O"
  },
  "431124": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Kille Dharur S.O"
  },
  "756083": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Pratappur S.O (Baleswar)"
  },
  "756051": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Avana S.O"
  },
  "756042": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Bahanaga S.O"
  },
  "756029": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Basta S.O"
  },
  "756055": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Chakabarahapur S.O"
  },
  "756080": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Irda S.O"
  },
  "312602": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Bhadesar S.O"
  },
  "312404": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Bohera S.O"
  },
  "301714": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Bahror Jat S.O"
  },
  "301406": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Malakhera S.O"
  },
  "301024": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Narainpur S.O (Alwar)"
  },
  "301025": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Nogaon S.O"
  },
  "797120": {
    "state": "NAGALAND",
    "district": "KOHIMA",
    "office": "P.R.Hill S.O"
  },
  "207002": {
    "state": "UTTAR PRADESH",
    "district": "ETAH",
    "office": "Aruna Nagar SO"
  },
  "798615": {
    "state": "NAGALAND",
    "district": "MOKOKCHUNG",
    "office": "Impur S.O"
  },
  "277001": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "TDCollege SO"
  },
  "636502": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Tharamangalam S.O"
  },
  "636503": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Tholasampatti S.O"
  },
  "327601": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Bagidora S.O"
  },
  "312603": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Nikumbh S.O"
  },
  "312027": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Mandfia S.O"
  },
  "312620": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Mangrol S.O (Chittorgarh)"
  },
  "312021": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Cement Factory S.O"
  },
  "327606": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Kalinjara S.O"
  },
  "768213": {
    "state": "ODISHA",
    "district": "JHARSUGUDA",
    "office": "Kolabira S.O"
  },
  "768005": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Dhanupali S.O"
  },
  "768112": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Gourpali S.O"
  },
  "442705": {
    "state": "MAHARASHTRA",
    "district": "GADCHIROLI",
    "office": "Aheri S.O"
  },
  "442703": {
    "state": "MAHARASHTRA",
    "district": "GADCHIROLI",
    "office": "Allapalli S.O"
  },
  "442914": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Anandwan S.O"
  },
  "441208": {
    "state": "MAHARASHTRA",
    "district": "GADCHIROLI",
    "office": "Armori S.O"
  },
  "442707": {
    "state": "MAHARASHTRA",
    "district": "GADCHIROLI",
    "office": "Ashti S.O (Gadchiroli)"
  },
  "768113": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Dhama S.O"
  },
  "768121": {
    "state": "ODISHA",
    "district": "DEOGARH",
    "office": "Gohira Dam Site S.O"
  },
  "442701": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Ballarpur S.O"
  },
  "442917": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Awalpur Cement Project S.O"
  },
  "441226": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Bembal S.O"
  },
  "442902": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Bhadrawati S.O"
  },
  "442710": {
    "state": "MAHARASHTRA",
    "district": "GADCHIROLI",
    "office": "Bhamragadh S.O"
  },
  "764076": {
    "state": "ODISHA",
    "district": "NABARANGPUR",
    "office": "Jharigam S.O"
  },
  "764047": {
    "state": "ODISHA",
    "district": "MALKANGIRI",
    "office": "Kalimela S.O"
  },
  "764075": {
    "state": "ODISHA",
    "district": "NABARANGPUR",
    "office": "Kodinga S.O"
  },
  "794003": {
    "state": "MEGHALAYA",
    "district": "WEST GARO HILLS",
    "office": "Dadengiri S.O"
  },
  "766037": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Thuamul Rampur S.O"
  },
  "766011": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Utkela S.O"
  },
  "766031": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Risida S.O"
  },
  "766101": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Rupra Road S.O"
  },
  "794114": {
    "state": "MEGHALAYA",
    "district": "SOUTH GARO HILLS",
    "office": "Rongra S.O"
  },
  "444203": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Shegaon S.O"
  },
  "761109": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Badagada S.O"
  },
  "766106": {
    "state": "ODISHA",
    "district": "NUAPADA",
    "office": "Komna S.O"
  },
  "766105": {
    "state": "ODISHA",
    "district": "NUAPADA",
    "office": "Nawapara Tanwat S.O"
  },
  "761116": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Bhetonoi S.O"
  },
  "761107": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Dharakote S.O"
  },
  "341021": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Basni S.O"
  },
  "621702": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Ambil SO"
  },
  "621704": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Ariyalur Ariyalur SO"
  },
  "770035": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Purnapani S.O"
  },
  "621703": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Angarai SO"
  },
  "621719": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Asaveerankudikadu SO"
  },
  "757104": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Bahanada S.O"
  },
  "757028": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Baisinga S.O"
  },
  "757032": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Bangriposi S.O"
  },
  "610001": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Tiruvarur North S.O"
  },
  "423109": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Shirdi S.O"
  },
  "431211": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Kumbhar Pimpalgaon S.O"
  },
  "431207": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Ranjani S.O (Jalna)"
  },
  "431132": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Shivna S.O"
  },
  "431208": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Tembhurni S.O (Jalna)"
  },
  "431214": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Ramnagar S.O"
  },
  "635802": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Ambur S.O"
  },
  "795140": {
    "state": "MANIPUR",
    "district": "IMPHAL WEST",
    "office": "Tulihal S.O"
  },
  "795148": {
    "state": "MANIPUR",
    "district": "THOUBAL",
    "office": "Wangjing S.O"
  },
  "632601": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Dharanampet S.O"
  },
  "635803": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Gudiyattam RS S.O"
  },
  "632201": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Kilvayathinankuppam S.O"
  },
  "635804": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Madanur S.O"
  },
  "635806": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Melalathur S.O"
  },
  "764061": {
    "state": "ODISHA",
    "district": "NABARANGPUR",
    "office": "Kosagumuda S.O"
  },
  "764077": {
    "state": "ODISHA",
    "district": "NABARANGPUR",
    "office": "Chandahandi S.O"
  },
  "764078": {
    "state": "ODISHA",
    "district": "NABARANGPUR",
    "office": "Dongerbheja S.O"
  },
  "233304": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Saidpur SO Ghazipur"
  },
  "275205": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Shadiabad SO"
  },
  "232332": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Tarighat SO"
  },
  "232333": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Satramganj Bazar SO"
  },
  "143107": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Distillery Khasa SO"
  },
  "143009": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Fatahpur SO"
  },
  "143113": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Fatehpur Rajputan SO"
  },
  "230137": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Sahebganj SO"
  },
  "637505": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Vennandur S.O"
  },
  "603101": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Athurchengalpattu SO"
  },
  "603401": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Chunampet SO"
  },
  "603202": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Guduvancheri SO"
  },
  "603102": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Kalpakkam SO"
  },
  "632603": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Paradarami S.O"
  },
  "632602": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Gudiyattam South S.O"
  },
  "343028": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "Modran S.O"
  },
  "766016": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Golamunda S.O"
  },
  "766027": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Lanjigarh S.O"
  },
  "444204": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Sonala S.O"
  },
  "603303": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Karunguli SO"
  },
  "603203": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Kattankolathur SO"
  },
  "603305": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Kuvathur SO"
  },
  "799254": {
    "state": "TRIPURA",
    "district": "North Tripura",
    "office": "Halflongcherra S.O"
  },
  "799203": {
    "state": "TRIPURA",
    "district": "Khowai",
    "office": "Kalyanpur S.O (West Tripura)"
  },
  "799270": {
    "state": "TRIPURA",
    "district": "North Tripura",
    "office": "Kanchanpur S.O (North Tripura)"
  },
  "799201": {
    "state": "TRIPURA",
    "district": "Khowai",
    "office": "Khowai S.O"
  },
  "799260": {
    "state": "TRIPURA",
    "district": "North Tripura",
    "office": "Panisagar S.O"
  },
  "799253": {
    "state": "TRIPURA",
    "district": "North Tripura",
    "office": "Rajbari S.O"
  },
  "799205": {
    "state": "TRIPURA",
    "district": "Khowai",
    "office": "Teliamura S.O"
  },
  "795009": {
    "state": "MANIPUR",
    "district": "IMPHAL WEST",
    "office": "Wangoi S.O"
  },
  "795142": {
    "state": "MANIPUR",
    "district": "UKHRUL",
    "office": "Ukhrul S.O"
  },
  "609504": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Sannanallur S.O"
  },
  "610106": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Thappalampuliyur S.O"
  },
  "610207": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Valivalam S.O"
  },
  "415306": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Kargani S.O"
  },
  "416306": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Kavalapur S.O"
  },
  "415308": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Kharsundi S.O"
  },
  "416308": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Kirloskarwadi S.O"
  },
  "416436": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Kupwad MIDC Area S.O"
  },
  "766108": {
    "state": "ODISHA",
    "district": "NUAPADA",
    "office": "Sinhapalli S.O"
  },
  "425505": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Chinawal S.O"
  },
  "790106": {
    "state": "ARUNACHAL PRADESH",
    "district": "TAWANG",
    "office": "Lumla S.O"
  },
  "791103": {
    "state": "ARUNACHAL PRADESH",
    "district": "EAST SIANG",
    "office": "Hill Top S.O"
  },
  "791119": {
    "state": "ARUNACHAL PRADESH",
    "district": "LOWER SUBANSIRI",
    "office": "Ranga Nadi Project S.O"
  },
  "790104": {
    "state": "ARUNACHAL PRADESH",
    "district": "TAWANG",
    "office": "Tawang S.O"
  },
  "792001": {
    "state": "ARUNACHAL PRADESH",
    "district": "LOHIT",
    "office": "Tezu S.O"
  },
  "603302": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Cheyur SO Kanchipuram"
  },
  "603313": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Chithamur SO"
  },
  "603201": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Elapakkam SO"
  },
  "603304": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Kudapakkam SO"
  },
  "603306": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Senguntharpettai SO"
  },
  "603104": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Mamallapuram SO"
  },
  "791104": {
    "state": "ARUNACHAL PRADESH",
    "district": "EAST SIANG",
    "office": "Mebo S.O"
  },
  "791118": {
    "state": "ARUNACHAL PRADESH",
    "district": "KRA DAADI",
    "office": "Palin S.O"
  },
  "791102": {
    "state": "ARUNACHAL PRADESH",
    "district": "EAST SIANG",
    "office": "Pasighat S.O"
  },
  "790102": {
    "state": "ARUNACHAL PRADESH",
    "district": "EAST KAMENG",
    "office": "Seppa S.O"
  },
  "799285": {
    "state": "TRIPURA",
    "district": "Dhalai",
    "office": "Kamalpur S.O (Dhalai)"
  },
  "614903": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Madukkur S.O"
  },
  "143301": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Chabhal SO"
  },
  "143408": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Chohla Sahib SO"
  },
  "143411": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Dhotian SO"
  },
  "143407": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Fatehabad SO Amritsar"
  },
  "143412": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Harike SO"
  },
  "143304": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Kacha Pacca SO"
  },
  "143149": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Jandiala RS SO"
  },
  "143502": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Kathunangal SO"
  },
  "614701": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Adirampattinam S.O"
  },
  "614901": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Alathur S.O"
  },
  "614902": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Kottaitheru S.O"
  },
  "799288": {
    "state": "TRIPURA",
    "district": "Unakoti",
    "office": "Kanchanbari S.O"
  },
  "799264": {
    "state": "TRIPURA",
    "district": "Unakoti",
    "office": "Kumarghat S.O"
  },
  "799275": {
    "state": "TRIPURA",
    "district": "Dhalai",
    "office": "Manughat S.O"
  },
  "799279": {
    "state": "TRIPURA",
    "district": "Unakoti",
    "office": "Paiturbazar S.O"
  },
  "799263": {
    "state": "TRIPURA",
    "district": "Unakoti",
    "office": "Pecharthal S.O"
  },
  "799278": {
    "state": "TRIPURA",
    "district": "Dhalai",
    "office": "Salema S.O"
  },
  "799284": {
    "state": "TRIPURA",
    "district": "Dhalai",
    "office": "Sarma S.O"
  },
  "799280": {
    "state": "TRIPURA",
    "district": "Unakoti",
    "office": "Sonamukhi S.O (North Tripura)"
  },
  "792105": {
    "state": "ARUNACHAL PRADESH",
    "district": "NAMSAI",
    "office": "Mahadevpur S.O (Lohit)"
  },
  "792103": {
    "state": "ARUNACHAL PRADESH",
    "district": "NAMSAI",
    "office": "Namsai S.O"
  },
  "792110": {
    "state": "ARUNACHAL PRADESH",
    "district": "LOWER DIBANG VALLEY",
    "office": "Roing S.O"
  },
  "614802": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Kuruvikarambai S.O"
  },
  "614615": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Aladikkumulai S.O"
  },
  "143303": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Bhikhiwind SO"
  },
  "143406": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Kang SO"
  },
  "756039": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Kakhra S.O"
  },
  "301027": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Pratap Garh S.O (Alwar)"
  },
  "301408": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Rajgarh (Alwar) S.O"
  },
  "301415": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Rajpur S.O (Alwar)"
  },
  "301030": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Matasya Ind. Area S.O"
  },
  "321633": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Mauj Pur S.O"
  },
  "442403": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Babupeth S.O"
  },
  "764085": {
    "state": "ODISHA",
    "district": "NABARANGPUR",
    "office": "Khatiguda S.O"
  },
  "768215": {
    "state": "ODISHA",
    "district": "JHARSUGUDA",
    "office": "Laikera S.O"
  },
  "768226": {
    "state": "ODISHA",
    "district": "JHARSUGUDA",
    "office": "Panchgaon S.O"
  },
  "676517": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Pookkottur SO"
  },
  "143305": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Khalra SO"
  },
  "143419": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Khem Karan SO"
  },
  "143409": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Naushehra Pannuan SO"
  },
  "614623": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Avanam S.O"
  },
  "143204": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "DBJSingh SO"
  },
  "143422": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Goindwal SO"
  },
  "143114": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Mehta Chowk SO"
  },
  "143101": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Raja Sansi SO"
  },
  "143603": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Ramdass SO"
  },
  "143112": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Rayya SO"
  },
  "143116": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Tarsika SO"
  },
  "483990": {
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "office": "Rithi S.O"
  },
  "483442": {
    "state": "MADHYA PRADESH",
    "district": "KATNI",
    "office": "Niwar S.O"
  },
  "483334": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Saroli Majhgawan S.O"
  },
  "143501": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Verka SO"
  },
  "143115": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Jandiala Guru SO"
  },
  "143415": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Kairon SO"
  },
  "143117": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Khadoor Sahib SO"
  },
  "624710": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Vedasandur SO"
  },
  "143205": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Sathiala SO"
  },
  "143008": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Sjs Avenue SO"
  },
  "416234": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "MIDC Gokul Shirgaon S.O"
  },
  "143413": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Bundala SO Amritsar"
  },
  "415302": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Bhavaninagar S.O (Sangli)"
  },
  "415413": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Borgaon S.O (Sangli)"
  },
  "416315": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Dudhgaon S.O"
  },
  "610109": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Pulivalam S.O (Tiruvarur)"
  },
  "610004": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Tiruvarur Collectorate S.O"
  },
  "610005": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Tiruvarur Central University"
  },
  "415403": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Kameri S.O"
  },
  "415307": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Khanapur S.O (Sangli)"
  },
  "415405": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Kokrud S.O"
  },
  "416309": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Kundal S.O (Sangli)"
  },
  "415309": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Lengare S.O"
  },
  "415310": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Mahuli S.O (Sangli)"
  },
  "416408": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Manerajuri S.O"
  },
  "416310": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Palus S.O"
  },
  "415407": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Peth S.O (Sangli)"
  },
  "416605": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Chouke S.O"
  },
  "416614": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Achara S.O"
  },
  "416628": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Ambrad S.O"
  },
  "416632": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Jambhavade S.O"
  },
  "416612": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Jamsande S.O"
  },
  "416602": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Kankavli S.O"
  },
  "416603": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Kasal S.O"
  },
  "416604": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Katta S.O"
  },
  "415404": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Kasegaon S.O"
  },
  "415414": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "S S K Sakharale S.O"
  },
  "415408": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Shirala S.O"
  },
  "415311": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Vite S.O"
  },
  "416313": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Walwa S.O"
  },
  "415415": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Warnavati Vasahat S.O"
  },
  "768221": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Bamra S.O"
  },
  "415637": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Ambed Budruk S.O"
  },
  "416712": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Devadhe S.O"
  },
  "415804": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Devrukh S.O"
  },
  "768220": {
    "state": "ODISHA",
    "district": "JHARSUGUDA",
    "office": "Bagdehi S.O"
  },
  "416608": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Masura S.O"
  },
  "416804": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Padel S.O"
  },
  "768224": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Garposh S.O"
  },
  "768211": {
    "state": "ODISHA",
    "district": "JHARSUGUDA",
    "office": "Bandhbahal Colony S.O"
  },
  "416707": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Adivare S.O"
  },
  "416713": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Bhoo S.O"
  },
  "415619": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Hatkhamba S.O"
  },
  "768217": {
    "state": "ODISHA",
    "district": "JHARSUGUDA",
    "office": "Belpahar Rs S.O"
  },
  "624802": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Vadamadurai SO"
  },
  "422205": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Khedgaon S.O (Nashik)"
  },
  "422306": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Lasalgaon S.O"
  },
  "423105": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Malegaon Camp S.O"
  },
  "423104": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Manmad Shiwaji Chouk S.O"
  },
  "423403": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Nagarsul S.O"
  },
  "423204": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Nampur S.O"
  },
  "423106": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Nandgaon S.O"
  },
  "423212": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Nimgaon S.O"
  },
  "422303": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Niphad S.O"
  },
  "423301": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Satana Market S.O"
  },
  "424109": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Naydongri S.O"
  },
  "422209": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Pimpalgaon Baswant S.O"
  },
  "423108": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Ravalgaon S.O"
  },
  "415807": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Devale S.O"
  },
  "415626": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Gavkhadi S.O"
  },
  "768216": {
    "state": "ODISHA",
    "district": "JHARSUGUDA",
    "office": "Sr Brajarjanagar SO"
  },
  "423208": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Saundana S.O"
  },
  "423302": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Taharabad S.O"
  },
  "768025": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Gosala Chowk S.O"
  },
  "761111": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Nuagam S.O"
  },
  "761013": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Pattapur S.O"
  },
  "761103": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Pitala S.O"
  },
  "761106": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Seragada S.O"
  },
  "415406": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Nerla S.O"
  },
  "415409": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Urun Islampur S.O"
  },
  "415410": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Wategaon S.O"
  },
  "415411": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Yelur S.O"
  },
  "423110": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Umrana S.O"
  },
  "423117": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Vadali Bhoi S.O"
  },
  "423206": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Vadner Malegaon S.O"
  },
  "423213": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Lakhamapur S.O"
  },
  "423203": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Malegaon Nayapura Ward S.O"
  },
  "761108": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Surada S.O"
  },
  "761125": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Badakodanda S.O"
  },
  "761117": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Ballipadar S.O"
  },
  "799009": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Agartala Aerodrome S.O"
  },
  "799004": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Agartala College S.O"
  },
  "799003": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Arundhutinagar S.O"
  },
  "799045": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Birendranagar S.O"
  },
  "799102": {
    "state": "TRIPURA",
    "district": "Sepahijala",
    "office": "Bishalgarh S.O"
  },
  "322234": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Kheda SO"
  },
  "322249": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Langra SO"
  },
  "322251": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Mandrail SO"
  },
  "431205": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Wadigodri S.O"
  },
  "431152": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "SAWANGI BAZAR S.O"
  },
  "791105": {
    "state": "ARUNACHAL PRADESH",
    "district": "UPPER SIANG",
    "office": "Tuting S.O"
  },
  "791002": {
    "state": "ARUNACHAL PRADESH",
    "district": "UPPER SIANG",
    "office": "Yingkiong S.O"
  },
  "301026": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Ramgarh S.O (Alwar)"
  },
  "301409": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Reni S.O"
  },
  "301035": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Ronijathan S.O"
  },
  "301410": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Tehla S.O"
  },
  "416613": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Devgad S.O"
  },
  "416620": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Kalsuli S.O"
  },
  "416703": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Kharepatan S.O"
  },
  "416630": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Naringre S.O"
  },
  "416811": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Phanasgaon S.O"
  },
  "416601": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Phondaghat S.O"
  },
  "416616": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Ramgad S.O"
  },
  "416609": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Sangve S.O"
  },
  "416610": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Shirgaon S.O"
  },
  "416812": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Sindhudurgnagari MDG S.O"
  },
  "416611": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Talebazar S.O"
  },
  "416801": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Talera S.O (Sindhudurg)"
  },
  "416813": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Umbarde S.O"
  },
  "416805": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Vada S.O (Sindhudurg)"
  },
  "416810": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Vaibhavwadi S.O"
  },
  "603105": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Manambathi SO"
  },
  "798604": {
    "state": "NAGALAND",
    "district": "MOKOKCHUNG",
    "office": "Mongkholemba S.O"
  },
  "473660": {
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "office": "Karera S.O"
  },
  "486220": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Teonthar S.O"
  },
  "798601": {
    "state": "NAGALAND",
    "district": "MOKOKCHUNG",
    "office": "Mokokchung S.O"
  },
  "797113": {
    "state": "NAGALAND",
    "district": "DIMAPUR",
    "office": "New Nepaligaon S.O"
  },
  "797109": {
    "state": "NAGALAND",
    "district": "KOHIMA",
    "office": "Tseminyu S.O"
  },
  "636457": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Vanavasi S.O"
  },
  "637504": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Vembadithalam S.O"
  },
  "798621": {
    "state": "NAGALAND",
    "district": "MON",
    "office": "Mon S.O"
  },
  "798622": {
    "state": "NAGALAND",
    "district": "MON",
    "office": "Naginimora S.O"
  },
  "798602": {
    "state": "NAGALAND",
    "district": "MON",
    "office": "Tizit S.O"
  },
  "301707": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Tapukara S.O"
  },
  "797004": {
    "state": "NAGALAND",
    "district": "KOHIMA",
    "office": "New Sectt Complex S.O"
  },
  "797101": {
    "state": "NAGALAND",
    "district": "PEREN",
    "office": "Peren S.O"
  },
  "797110": {
    "state": "NAGALAND",
    "district": "PEREN",
    "office": "Zalukie S.O"
  },
  "641654": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Ranganathapuram SO"
  },
  "764043": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Boipariguda S.O"
  },
  "323022": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Namana S.O"
  },
  "323614": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Sumerganj Mandi S.O"
  },
  "323021": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Talera S.O (Bundi)"
  },
  "323025": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Umar S.O"
  },
  "303806": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Samod SO"
  },
  "303807": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Udaipuria SO"
  },
  "303102": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Virat Nagar SO"
  },
  "303903": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Shivdaspura SO"
  },
  "303103": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Shahpura HO"
  },
  "303002": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Achrol SO"
  },
  "303601": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Amarsar SO"
  },
  "303001": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Andhi SO"
  },
  "303702": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Chomu SO"
  },
  "303804": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Etwa Bhopji SO"
  },
  "303701": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Jahota SO"
  },
  "303704": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Jaitpura I A SO"
  },
  "303109": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Jamwaramgarh SO"
  },
  "473990": {
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "office": "Khaniyadhana S.O"
  },
  "473670": {
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "office": "Manpura S.O"
  },
  "473770": {
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "office": "Kolaras S.O"
  },
  "473865": {
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "office": "Magroni S.O"
  },
  "332031": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Koodan SO"
  },
  "332311": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Nayama Bazar Lachhmangarh SO"
  },
  "332025": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Losal Bazar SO"
  },
  "332026": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Nechhwa SO"
  },
  "332402": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Palsana SO Sikar"
  },
  "332312": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Patoda SO Sikar"
  },
  "332041": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Phagalwa SO"
  },
  "332027": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Piprali SO"
  },
  "331024": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Ramgarh Shekhawati SO"
  },
  "332403": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Ranoli SO Sikar"
  },
  "332304": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Rolsabsar SO"
  },
  "332305": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Sadinsar SO"
  },
  "332030": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Singrawat SO"
  },
  "332307": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Tihawali SO"
  },
  "332715": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Surani Bazar Srimadhopur SO"
  },
  "322220": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Shrimahaveerji SO"
  },
  "322252": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Suroth SO"
  },
  "322701": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Bhagwatgarh SO"
  },
  "322023": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Bonli SO"
  },
  "322034": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Chakeri SO"
  },
  "322702": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Chauth Ka Barwara SO"
  },
  "322213": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Gudhachandraji SO"
  },
  "322216": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Kemri SO Karauli"
  },
  "322255": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Kurgaon SO"
  },
  "322033": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Malarna R S SO"
  },
  "322025": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Khandar SO"
  },
  "322215": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Nadoti SO"
  },
  "322203": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Narauli Dang SO"
  },
  "322218": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Sapotara SO"
  },
  "322219": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Wazirpur SO"
  },
  "322230": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Hindaun City SO"
  },
  "304001": {
    "state": "RAJASTHAN",
    "district": "TONK",
    "office": "Tonk Raj H.O"
  },
  "304023": {
    "state": "RAJASTHAN",
    "district": "TONK",
    "office": "Aligarh S.O (Tonk)"
  },
  "304501": {
    "state": "RAJASTHAN",
    "district": "TONK",
    "office": "Avikanagar S.O"
  },
  "304022": {
    "state": "RAJASTHAN",
    "district": "TONK",
    "office": "Banasthali Vidya Peeth S.O"
  },
  "304804": {
    "state": "RAJASTHAN",
    "district": "TONK",
    "office": "Deoli Bazar S.O"
  },
  "304504": {
    "state": "RAJASTHAN",
    "district": "TONK",
    "office": "Diggi S.O"
  },
  "304026": {
    "state": "RAJASTHAN",
    "district": "TONK",
    "office": "Nagarfort S.O"
  },
  "304802": {
    "state": "RAJASTHAN",
    "district": "TONK",
    "office": "Duni S.O (Tonk)"
  },
  "304025": {
    "state": "RAJASTHAN",
    "district": "TONK",
    "office": "Jhilai S.O"
  },
  "304503": {
    "state": "RAJASTHAN",
    "district": "TONK",
    "office": "Lambaharisingh S.O"
  },
  "304502": {
    "state": "RAJASTHAN",
    "district": "TONK",
    "office": "Malpura S.O"
  },
  "322238": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Balghat SO"
  },
  "322236": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Dhindora SO"
  },
  "321610": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Ghatabalaji SO"
  },
  "322254": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Ghonsla SO"
  },
  "322243": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Kailadevi SO"
  },
  "322242": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Masalpur SO"
  },
  "322201": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Gangapur HO"
  },
  "680317": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kallur SO Thrissur"
  },
  "276125": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Bankat SO"
  },
  "416534": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Sukalwadi S.O"
  },
  "322703": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Isharda SO"
  },
  "322211": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Bamanwas SO"
  },
  "322202": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Mahukala SO"
  },
  "322205": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Piloda SO"
  },
  "322214": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Piplai SO"
  },
  "322024": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Khirni SO"
  },
  "614723": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Mallipattinam S.O"
  },
  "614904": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Melauluvur S.O"
  },
  "322029": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Kundera SO"
  },
  "322030": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Malrna Chaur SO"
  },
  "322028": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Malrna Doongar SO"
  },
  "613205": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Vediapuram S.O"
  },
  "768111": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Godbhaga S.O"
  },
  "768115": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Gondturum S.O"
  },
  "768040": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Tora S.O"
  },
  "322026": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Phalodi Quarry SO"
  },
  "322027": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Soorwal SO"
  },
  "322204": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Shahar SO"
  },
  "761120": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Baragam S.O"
  },
  "761119": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "B D Sahi Bellagunhta S.O"
  },
  "761118": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Buguda S.O"
  },
  "614602": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Nadimuthunagar S.O"
  },
  "614906": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Nattuchalai S.O"
  },
  "614625": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Orattanad S.O"
  },
  "614803": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Ottangadu S.O"
  },
  "764046": {
    "state": "ODISHA",
    "district": "MALKANGIRI",
    "office": "Khairaput S.O"
  },
  "764088": {
    "state": "ODISHA",
    "district": "NABARANGPUR",
    "office": "Turudihi"
  },
  "764049": {
    "state": "ODISHA",
    "district": "NABARANGPUR",
    "office": "Anchalgumma S.O"
  },
  "764051": {
    "state": "ODISHA",
    "district": "MALKANGIRI",
    "office": "Balimela S.O"
  },
  "414113": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Kharwandi Kasar S.O"
  },
  "413728": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Kolgaon S.O"
  },
  "414101": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Mandavgan S.O"
  },
  "414401": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Mirajgaon S.O"
  },
  "414501": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Miri S.O"
  },
  "413205": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Nanaj S.O (Ahmed Nagar)"
  },
  "414111": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "MIDC (ANR) S.O"
  },
  "485773": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Amadara S.O"
  },
  "485001": {
    "state": "MADHYA PRADESH",
    "district": "SATNA",
    "office": "Satna Tikuria Tola S.O"
  },
  "623706": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Pambur SO"
  },
  "623608": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Parthibanur SO"
  },
  "623115": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Perunali SO"
  },
  "623120": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Sayalgudi SO"
  },
  "623712": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Tiruvarangam SO"
  },
  "623707": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Paramakudi Bazaar SO"
  },
  "623708": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Peraiyur SO Ramanathapuram"
  },
  "332701": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Ajitgarh Amarsar SO"
  },
  "332601": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Baya SO"
  },
  "623711": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Teriruveli SO"
  },
  "799015": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Narayanpur Bazar SO"
  },
  "761141": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Gallery S.O"
  },
  "761123": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Gangapur (Ganjam) S.O"
  },
  "636003": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Ammapettai Bazaar S.O"
  },
  "635805": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Mailpatti S.O"
  },
  "632203": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Melmayil S.O"
  },
  "635808": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Oomerabad S.O"
  },
  "416806": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Vijaydurg S.O"
  },
  "761124": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Gobara S.O"
  },
  "761121": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Jagannath Prasad S.O"
  },
  "761133": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Jillundi S.O"
  },
  "761143": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Karachulli S.O"
  },
  "761146": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Burupada S.O"
  },
  "322212": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Garhmoran SO"
  },
  "790001": {
    "state": "ARUNACHAL PRADESH",
    "district": "WEST KAMENG",
    "office": "Bomdila S.O"
  },
  "799204": {
    "state": "TRIPURA",
    "district": "Dhalai",
    "office": "Kulaibazar S.O"
  },
  "799287": {
    "state": "TRIPURA",
    "district": "Dhalai",
    "office": "Manikbhander S.O"
  },
  "635810": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Pernambut S.O"
  },
  "632209": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Ruhsa Campus S.O"
  },
  "635813": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Valathoor S.O"
  },
  "632604": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Erthangal S.O"
  },
  "795132": {
    "state": "MANIPUR",
    "district": "IMPHAL WEST",
    "office": "Mayang Imphal S.O"
  },
  "795133": {
    "state": "MANIPUR",
    "district": "BISHNUPUR",
    "office": "Moirang S.O"
  },
  "795011": {
    "state": "MANIPUR",
    "district": "BISHNUPUR",
    "office": "Ningthoukhong SO"
  },
  "303801": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Kaladera SO"
  },
  "303803": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Khejroli SO"
  },
  "303108": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Kotputli SO"
  },
  "303905": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Watika SO"
  },
  "303119": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Bhabroo SO"
  },
  "303120": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Gathwadi SO"
  },
  "414302": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Parner S.O"
  },
  "414102": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Pathardi S.O"
  },
  "414403": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Rashin S.O"
  },
  "414502": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Shevgaon S.O"
  },
  "413701": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Shrigonda S.O"
  },
  "413726": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Shrigonda SSK S.O"
  },
  "441206": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Bramhapuri S.O"
  },
  "322704": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Shiwar SO"
  },
  "768219": {
    "state": "ODISHA",
    "district": "JHARSUGUDA",
    "office": "Lakhanpur S.O Jharsuguda"
  },
  "768225": {
    "state": "ODISHA",
    "district": "JHARSUGUDA",
    "office": "Rampur Colliery S.O"
  },
  "627110": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Parappadi SO"
  },
  "627654": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Pettaikulam SO"
  },
  "627111": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Radhapuram SO"
  },
  "766104": {
    "state": "ODISHA",
    "district": "NUAPADA",
    "office": "Khariar Road S.O"
  },
  "766107": {
    "state": "ODISHA",
    "district": "NUAPADA",
    "office": "Khariar  Pattnaik Para S.O"
  },
  "635811": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Thuthipattu S.O"
  },
  "635812": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Vadapudupet S.O"
  },
  "635701": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Alangayam S.O"
  },
  "635801": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Ambalur S.O"
  },
  "635702": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Andiappanur S.O"
  },
  "635754": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Jaffarabad S.O"
  },
  "635851": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Jolarpettai S.O"
  },
  "635901": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Kandili S.O"
  },
  "635852": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Natrampalli S.O"
  },
  "635752": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Newtown Vaniyambadi S.O"
  },
  "635853": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Pakkirithakka S.O"
  },
  "795010": {
    "state": "MANIPUR",
    "district": "IMPHAL EAST",
    "office": "Lamlong S.O"
  },
  "413107": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Malsiras S.O"
  },
  "413305": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Mangalvedha S.O"
  },
  "413319": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Marwade S.O"
  },
  "413301": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Modnimb S.O"
  },
  "799289": {
    "state": "TRIPURA",
    "district": "Dhalai",
    "office": "Ambassa S.O"
  },
  "799281": {
    "state": "TRIPURA",
    "district": "Unakoti",
    "office": "Baburbazar S.O"
  },
  "799273": {
    "state": "TRIPURA",
    "district": "Dhalai",
    "office": "Chailengta S.O"
  },
  "442603": {
    "state": "MAHARASHTRA",
    "district": "GADCHIROLI",
    "office": "Chamorshi S.O"
  },
  "614626": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Pappanad S.O"
  },
  "423401": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Yeola Kutcheri Road S.O"
  },
  "423205": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Zodga S.O"
  },
  "614804": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Peravurni S.O"
  },
  "795145": {
    "state": "MANIPUR",
    "district": "KAMJONG",
    "office": "Litan S.O"
  },
  "795131": {
    "state": "MANIPUR",
    "district": "TENGNOUPAL",
    "office": "Moreh S.O"
  },
  "635814": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Shanankuppam S.O"
  },
  "635710": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Mittur S.O"
  },
  "233228": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Tajpur Dehma SO"
  },
  "641659": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Karumathampatti SO"
  },
  "792111": {
    "state": "ARUNACHAL PRADESH",
    "district": "LOHIT",
    "office": "Sunpura S.O"
  },
  "341520": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Besroli S.O"
  },
  "341502": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Borawar S.O"
  },
  "341505": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Makrana Rs S.O"
  },
  "341022": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Deh S.O"
  },
  "341504": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Gachhipura S.O"
  },
  "151509": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Maur Mandi SO"
  },
  "151102": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Nathana SO"
  },
  "151104": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Phul SO"
  },
  "151301": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Raman SO"
  },
  "641670": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Karavalur SO"
  },
  "638459": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Punjai Puliampatti SO"
  },
  "641652": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Anuppapalayam SO"
  },
  "641305": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Mahadevapuram SO"
  },
  "641697": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Pogalur SO"
  },
  "641113": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Seeliyur SO"
  },
  "641302": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Sirumugai SO"
  },
  "641668": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Somanur SO"
  },
  "641402": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Sulur SO"
  },
  "442402": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Pathanpura S.O"
  },
  "442404": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Chandrapur TPS S.O"
  },
  "442908": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Chandur S.O (Chandrapur)"
  },
  "442903": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Chimur S.O"
  },
  "332702": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Danta SO"
  },
  "332705": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Ganeshwar SO"
  },
  "413711": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Songaon S.O"
  },
  "431121": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Pachod S.O"
  },
  "431107": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Paithan S.O"
  },
  "431148": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Paithan Sakhar Karkhana S.O"
  },
  "423703": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Parsoda S.O"
  },
  "431111": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Phulmbri S.O"
  },
  "431104": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Pishore S.O"
  },
  "413218": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Wagadari S.O"
  },
  "431704": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Ardhapur S.O"
  },
  "431750": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Malegaon S.O"
  },
  "431745": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Barad S.O"
  },
  "431746": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Barul S.O"
  },
  "431801": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Bhokar S.O"
  },
  "431710": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Biloli S.O"
  },
  "431810": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Bodhadi S.O"
  },
  "431603": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Cidco Nanded S.O"
  },
  "431717": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Degloor Town S.O"
  },
  "431809": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Dharmabad S.O"
  },
  "431722": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Gadga S.O"
  },
  "431811": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Gokunda S.O"
  },
  "431712": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Hadgaon S.O"
  },
  "762103": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Nuasahi S.O"
  },
  "762021": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Bamunigaon S.O (Kandhamal)"
  },
  "762110": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Barakhama S.O"
  },
  "313201": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Khemli S.O"
  },
  "313602": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Kheroda S.O"
  },
  "313803": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Kherwara S.O"
  },
  "307025": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Kotra S.O (Udaipur)"
  },
  "313703": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Kurawar S.O (Udaipur)"
  },
  "313203": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Mavli Jn. S.O"
  },
  "313031": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Nai S.O"
  },
  "332317": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Roru Badi SO"
  },
  "332028": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Sihot Badi SO"
  },
  "765025": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "Padmapur S.O"
  },
  "765029": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "Ramanaguda S.O"
  },
  "765002": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "Rayagada S.F. S.O"
  },
  "765018": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "Therubali S.O"
  },
  "313702": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Jhadol (P) S.O"
  },
  "313708": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Nandeshma S.O"
  },
  "769004": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Jail Road S.O (Sundergarh)"
  },
  "639005": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Thanthonimalai S.O"
  },
  "151105": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Mehraj SO"
  },
  "638501": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Anthiyur SO"
  },
  "638301": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Bhavani Cutcherry SO"
  },
  "638504": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Guruvareddiyur SO"
  },
  "638312": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Jambai SO"
  },
  "635815": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Kethandapatti Sugar Mills S.O"
  },
  "635807": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Minnur S.O"
  },
  "635703": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Jamanamarathur S.O"
  },
  "795007": {
    "state": "MANIPUR",
    "district": "SENAPATI",
    "office": "Karong S.O"
  },
  "795004": {
    "state": "MANIPUR",
    "district": "IMPHAL WEST",
    "office": "Lamphelpat S.O"
  },
  "301403": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Harsauli S.O"
  },
  "321607": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Laxman Garh S.O"
  },
  "301020": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Barrod S.O"
  },
  "301709": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Gandala S.O"
  },
  "301412": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Harsora S.O"
  },
  "301427": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Karni Kot S.O"
  },
  "301404": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Khairthal S.O"
  },
  "791110": {
    "state": "ARUNACHAL PRADESH",
    "district": "PAPUM PARE",
    "office": "Naharlagun S.O"
  },
  "795129": {
    "state": "MANIPUR",
    "district": "KANGPOKPI",
    "office": "Kangpokpi S.O"
  },
  "795146": {
    "state": "MANIPUR",
    "district": "IMPHAL WEST",
    "office": "Lamsang S.O"
  },
  "795002": {
    "state": "MANIPUR",
    "district": "IMPHAL WEST",
    "office": "Mantripukhri S.O"
  },
  "795107": {
    "state": "MANIPUR",
    "district": "KANGPOKPI",
    "office": "Motbung S.O"
  },
  "795130": {
    "state": "MANIPUR",
    "district": "THOUBAL",
    "office": "Lilong S.O"
  },
  "795003": {
    "state": "MANIPUR",
    "district": "IMPHAL WEST",
    "office": "Manipur University S.O"
  },
  "796891": {
    "state": "MIZORAM",
    "district": "LAWNGTLAI",
    "office": "Lawngtlai S.O"
  },
  "796701": {
    "state": "MIZORAM",
    "district": "LUNGLEI",
    "office": "Lunglei S.O"
  },
  "796441": {
    "state": "MIZORAM",
    "district": "MAMIT",
    "office": "Mamit S.O"
  },
  "796431": {
    "state": "MIZORAM",
    "district": "MAMIT",
    "office": "Phaileng S.O"
  },
  "796501": {
    "state": "MIZORAM",
    "district": "MAMIT",
    "office": "Reiek S.O"
  },
  "643005": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Indunagar S.O"
  },
  "643239": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Konnachal S.O"
  },
  "301713": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Jakhrana S.O"
  },
  "301703": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Majari Kalan S.O"
  },
  "332405": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Shishu SO"
  },
  "332042": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Tatanwa SO"
  },
  "332703": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Danta Ramgarh SO"
  },
  "795134": {
    "state": "MANIPUR",
    "district": "BISHNUPUR",
    "office": "Nambol S.O"
  },
  "635854": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Pachur S.O"
  },
  "642103": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Ambarampalayam S.O"
  },
  "642104": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Anaimalai S.O"
  },
  "642106": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Cinchona S.O"
  },
  "416305": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Digraj Kasaba S.O"
  },
  "621801": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Andimadam SO"
  },
  "792101": {
    "state": "ARUNACHAL PRADESH",
    "district": "DIBANG VALLEY",
    "office": "Anini S.O"
  },
  "792131": {
    "state": "ARUNACHAL PRADESH",
    "district": "LONGDING",
    "office": "Longding S.O"
  },
  "643220": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Mangorange S.O"
  },
  "643226": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Newhope S.O"
  },
  "643237": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Sandynallah S.O"
  },
  "643002": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Stone House Hill S.O"
  },
  "643241": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Uppatti S.O"
  },
  "796005": {
    "state": "MIZORAM",
    "district": "AIZAWL",
    "office": "Kulikawn S.O"
  },
  "796370": {
    "state": "MIZORAM",
    "district": "SERCHHIP",
    "office": "Lungdar S.O"
  },
  "796290": {
    "state": "MIZORAM",
    "district": "SAITUAL",
    "office": "Ngopa S.O"
  },
  "796012": {
    "state": "MIZORAM",
    "district": "AIZAWL",
    "office": "Ramhlun S.O"
  },
  "796421": {
    "state": "MIZORAM",
    "district": "AIZAWL",
    "office": "Lengpui Airport S.O"
  },
  "764081": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Lamtaput S.O"
  },
  "414602": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Vadalamission S.O"
  },
  "414006": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Vahannagar S.O"
  },
  "638116": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Kanjikovil SO"
  },
  "638107": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Nasiyanur SO"
  },
  "638314": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Olagadam SO"
  },
  "638052": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Perundurai SO"
  },
  "638315": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Sakthinagar SO"
  },
  "638057": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Tudupathi SO"
  },
  "638751": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Uttukuli SO"
  },
  "638056": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Vijayamangalam SO"
  },
  "638101": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Arachalur SO"
  },
  "638752": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Uttukuli Rs SO"
  },
  "638115": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Avalpundurai SO"
  },
  "638051": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Chennimalai SO"
  },
  "638151": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Kodumudi SO"
  },
  "638104": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Modakurichi SO"
  },
  "638154": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Pasur SO"
  },
  "638109": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Sivagiri SO Erode"
  },
  "638009": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Surampatti SO"
  },
  "638152": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Unjalur SO"
  },
  "332411": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Baori SO"
  },
  "630410": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Ulagampatti S.O"
  },
  "630212": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Viramathi S.O"
  },
  "628901": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Ariyanayagipuram S.O"
  },
  "628902": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Ettaiyapuram S.O"
  },
  "630502": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Singampunari S.O"
  },
  "628712": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Eppodumvendran S.O"
  },
  "628714": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Kadambur S.O (Tuticorin)"
  },
  "628952": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Kayathar S.O"
  },
  "629801": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Aloor S.O"
  },
  "629301": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Aralvaymoli S.O"
  },
  "629851": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Azhakiapandipuram S.O"
  },
  "629852": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Bhoothapandy S.O"
  },
  "629001": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Vadiveeswaram S.O"
  },
  "629251": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Colachel Port S.O"
  },
  "629501": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Eathamozhi S.O"
  },
  "767028": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Khaprakhol S.O"
  },
  "767066": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Kholan S.O"
  },
  "767020": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Loisingha S.O"
  },
  "767037": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Muribahal S.O"
  },
  "767041": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "P.Rampur S.O"
  },
  "767025": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Patnagarh S.O"
  },
  "767002": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Rajendra College S.O (Balangir)"
  },
  "767032": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Saintala S.O"
  },
  "757084": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Kostha S.O"
  },
  "757029": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Krushnachandrapur S.O"
  },
  "757105": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Kuchei S.O"
  },
  "757030": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Kuliana S.O"
  },
  "757081": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Kumbharmundakata S.O"
  },
  "757085": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Kushalda S.O"
  },
  "757092": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Kusumbandi S.O"
  },
  "757107": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Laxmiposi S.O"
  },
  "757017": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Mantri S.O"
  },
  "757020": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Moroda S.O"
  },
  "757073": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Nalagaja S.O"
  },
  "757077": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Nudadiha S.O"
  },
  "757103": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Pratappur S.O (Mayurbhanj)"
  },
  "757102": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Puruna Baripada S.O"
  },
  "757027": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Kuamara S.O"
  },
  "757101": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Radho S.O"
  },
  "757016": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Rasgovindpur S.O"
  },
  "757106": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Salchua S.O"
  },
  "757024": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Sankerko S.O"
  },
  "757051": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Saraskana S.O"
  },
  "757079": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Sarat S.O"
  },
  "764087": {
    "state": "ODISHA",
    "district": "MALKANGIRI",
    "office": "Lachipeta S.O"
  },
  "764056": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Borigumma S.O"
  },
  "763008": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Damanjodi S.O"
  },
  "765013": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Laxmipur (Koraput) S.O"
  },
  "758013": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Raisuan S.O"
  },
  "152023": {
    "state": "PUNJAB",
    "district": "FIROZEPUR",
    "office": "Mamdot SO"
  },
  "152028": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Manawan SO"
  },
  "152033": {
    "state": "PUNJAB",
    "district": "FAZILKA",
    "office": "Mandi Amin Ganj SO"
  },
  "152132": {
    "state": "PUNJAB",
    "district": "FAZILKA",
    "office": "Maujgarh SO"
  },
  "142060": {
    "state": "PUNJAB",
    "district": "FIROZEPUR",
    "office": "Mudki SO"
  },
  "628908": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Kilairal S.O"
  },
  "628502": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Lakshmipuram S.O (Tuticorin)"
  },
  "628904": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Nagalapuram S.O (Tuticorin)"
  },
  "301407": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Mandawar S.O (Alwar)"
  },
  "301704": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Mandhan S.O"
  },
  "301706": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Shahjahanpur S.O"
  },
  "301708": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Kutina S.O"
  },
  "301705": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Neemrana S.O"
  },
  "152122": {
    "state": "PUNJAB",
    "district": "FAZILKA",
    "office": "Nihal Khera SO"
  },
  "152004": {
    "state": "PUNJAB",
    "district": "FIROZEPUR",
    "office": "SBS Engg Colleger Ferozpeur SO"
  },
  "152005": {
    "state": "PUNJAB",
    "district": "FIROZEPUR",
    "office": "Sherkhan Wala SO"
  },
  "142050": {
    "state": "PUNJAB",
    "district": "FIROZEPUR",
    "office": "Talwandi Bhai SO"
  },
  "142047": {
    "state": "PUNJAB",
    "district": "FIROZEPUR",
    "office": "Zira SO"
  },
  "152118": {
    "state": "PUNJAB",
    "district": "FAZILKA",
    "office": "Sitto SO"
  },
  "331701": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Sidhmukh S.O"
  },
  "765024": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "Ukkamba S.O"
  },
  "799035": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Ranirbazar S.O"
  },
  "799130": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Sekerkote S.O"
  },
  "799212": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Sidhai S.O"
  },
  "766036": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Borda S.O"
  },
  "766017": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Charbahal S.O"
  },
  "766015": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Dharamgarh S.O"
  },
  "757031": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Shirsa S.O"
  },
  "757049": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Shyamakhunta S.O"
  },
  "757022": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Suliapada S.O"
  },
  "757003": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Takatpur S.O"
  },
  "143507": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Aliwal SO"
  },
  "143511": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Bhagowal SO"
  },
  "143604": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Dera Baba Nanak SO"
  },
  "143605": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Dhianpur SO"
  },
  "757041": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Udala S.O"
  },
  "757047": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Badampahar S.O"
  },
  "757054": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Bahalda Rd RS S.O"
  },
  "757046": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Bahalda S.O"
  },
  "757048": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Bijatala S.O"
  },
  "757033": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Bisoi S.O"
  },
  "757042": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Gorumahisani S.O"
  },
  "757050": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Hatbadra S.O"
  },
  "757045": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Jamda S.O (Mayurbhanj)"
  },
  "757034": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Jashipur S.O"
  },
  "757037": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Karanjia Golei S.O"
  },
  "757091": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Khairi Jashipur S.O"
  },
  "795150": {
    "state": "MANIPUR",
    "district": "SENAPATI",
    "office": "Mao S.O"
  },
  "795124": {
    "state": "MANIPUR",
    "district": "BISHNUPUR",
    "office": "Loktak Project S.O"
  },
  "624202": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Batlagundu Bazar SO"
  },
  "624204": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Iyyampalayam SO"
  },
  "624619": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Oddanchatram SO"
  },
  "624308": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Vembarpatti SO"
  },
  "624201": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Ammayanaickanur SO"
  },
  "624621": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Pappampatti SO"
  },
  "144410": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "P T S Phillaur SO"
  },
  "144102": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Adampur Doaba SO"
  },
  "635809": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Pallikonda S.O"
  },
  "431741": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Hanegaon S.O"
  },
  "431802": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Himayatnagar S.O"
  },
  "431803": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Islapur S.O"
  },
  "431716": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Jamb B K S.O"
  },
  "431714": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Kandhar S.O"
  },
  "762030": {
    "state": "ODISHA",
    "district": "BOUDH",
    "office": "Baghiabahal S.O"
  },
  "762024": {
    "state": "ODISHA",
    "district": "BOUDH",
    "office": "Biranarasinghpur S.O"
  },
  "431215": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Rajur"
  },
  "313906": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Ogna S.O"
  },
  "313204": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Palana Khurd S.O"
  },
  "321026": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Kanjoli Line S.O"
  },
  "321028": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Kherli Gadasia S.O"
  },
  "321021": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Jaghina S.O"
  },
  "321301": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Pichuna S.O"
  },
  "321025": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Rareh S.O"
  },
  "321303": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Sewar S.O"
  },
  "321302": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Uchain S.O"
  },
  "321203": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Deeg H.O"
  },
  "321614": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Akhaigarh S.O"
  },
  "321409": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Ballabhgarh S.O"
  },
  "321406": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Bhusawar S.O"
  },
  "757035": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Raruan S.O"
  },
  "144301": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Alawalpur SO Jalandhar"
  },
  "144021": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Basti Bawa Khel SO"
  },
  "144201": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Bhogpur SO Jalandhar"
  },
  "144025": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Jandu Singha SO"
  },
  "757039": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Sukruli S.O"
  },
  "627719": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Tiruvengadam S.O"
  },
  "627760": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Athuvazhi S.O"
  },
  "628552": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Kalugumalai S.O"
  },
  "627753": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Karivalamvandanallur S.O"
  },
  "627754": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Kuruvikulam S.O"
  },
  "792055": {
    "state": "ARUNACHAL PRADESH",
    "district": "CHANGLANG",
    "office": "Vijoynagar S.O"
  },
  "790116": {
    "state": "ARUNACHAL PRADESH",
    "district": "WEST KAMENG",
    "office": "Tenga Market S.O"
  },
  "431151": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Andhari S.O"
  },
  "431134": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Badod Bazar S.O"
  },
  "431136": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Bajaj Nagar Midc Waluj S.O"
  },
  "431105": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Bidkingaon S.O"
  },
  "431007": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Airport, Chikalthana S.O"
  },
  "431147": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Chincholi Limbaji S.O"
  },
  "431115": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Deogaon Rangari S.O"
  },
  "413228": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Valsang S.O"
  },
  "766018": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Jaipatna S.O"
  },
  "766014": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Junagarh S.O"
  },
  "766013": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Kalampur S.O"
  },
  "766012": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Kesinga S.O"
  },
  "799011": {
    "state": "TRIPURA",
    "district": "Sepahijala",
    "office": "Jampuijala SO"
  },
  "766118": {
    "state": "ODISHA",
    "district": "NUAPADA",
    "office": "Duajhar S.O"
  },
  "765020": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "Muniguda S.O"
  },
  "206253": {
    "state": "UTTAR PRADESH",
    "district": "ETAWAH",
    "office": "Basrehar SO"
  },
  "206242": {
    "state": "UTTAR PRADESH",
    "district": "ETAWAH",
    "office": "Bharthana SO"
  },
  "796901": {
    "state": "MIZORAM",
    "district": "SAIHA",
    "office": "Saiha S.O"
  },
  "638112": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Vadamugam Vellode SO"
  },
  "638004": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Veerappanchatram SO"
  },
  "638502": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Athani SO Erode"
  },
  "638503": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Dasappagoundenpudur SO"
  },
  "638110": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Getticheyur SO"
  },
  "638476": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Gobichettipalayam South SO"
  },
  "638505": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Kallipatti SO"
  },
  "431002": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Aurangabad Cantonment S.O"
  },
  "642154": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Gandhinagar S.O (Pollachi)"
  },
  "642203": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Kaniyur S.O"
  },
  "642202": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Jakkarpalayam S.O"
  },
  "642109": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Kinathukadavoo S.O"
  },
  "642110": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Kovilpalayam S.O"
  },
  "642002": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Mahalinga Puram S.O"
  },
  "642117": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Mudis S.O"
  },
  "642001": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "N.G.M College S.O"
  },
  "413704": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Vambori S.O"
  },
  "414106": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Tisgaon S.O"
  },
  "642120": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Negamam S.O"
  },
  "642123": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Samathur S.O"
  },
  "642125": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Sholayar Nagar S.O"
  },
  "642004": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Uthukuli Zamin S.O"
  },
  "642127": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Valparai S.O"
  },
  "144804": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "Dhilwan SO"
  },
  "144026": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Lambra SO"
  },
  "144101": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Patara SO Jalandhar"
  },
  "144630": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Bopa Rai Kalan SO Jalandhar"
  },
  "144805": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "CRPF Campus Sarai Khas SO"
  },
  "761031": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Beguniapada S.O"
  },
  "624307": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Vellodu SO"
  },
  "414105": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Sonai S.O (Ahmed Nagar)"
  },
  "414301": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Supa S.O (Ahmed Nagar)"
  },
  "414304": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Takali Dhokeshwar S.O"
  },
  "413109": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Natepute S.O"
  },
  "796320": {
    "state": "MIZORAM",
    "district": "CHAMPHAI",
    "office": "S.Khawbung S.O"
  },
  "642005": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Zamin Muthur S.O"
  },
  "642107": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Gomangalam S.O"
  },
  "642101": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Aliyar Nagar S.O"
  },
  "638453": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Karattadipalayam SO"
  },
  "638454": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Kasipalayam SO Erode"
  },
  "638455": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Kavindapadi SO"
  },
  "638456": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Kolappalur SO Erode"
  },
  "797114": {
    "state": "NAGALAND",
    "district": "PHEK",
    "office": "Meluri S.O"
  },
  "638102": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Chittode SO"
  },
  "636455": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Omalur S.O"
  },
  "638316": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Vasavi College SO"
  },
  "638402": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Rangasamudram SO"
  },
  "638401": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Sathyamangalam Bazaar SO"
  },
  "638461": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Talavadi SO"
  },
  "627953": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Melanilithanallur S.O"
  },
  "627755": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Mullikulam S.O"
  },
  "627855": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Puliyangudi S.O"
  },
  "627857": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Serndamangalam S.O"
  },
  "627757": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Sivagiri S.O (Tirunelveli)"
  },
  "627860": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Uthumalai S.O"
  },
  "629702": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Kanniyakumari S.O"
  },
  "767068": {
    "state": "ODISHA",
    "district": "SONEPUR",
    "office": "Lachhipur S.O"
  },
  "629701": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Agasteeswaram S.O"
  },
  "629204": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Ammandivilai S.O"
  },
  "144022": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Urban Estate SO Jalandhar"
  },
  "144106": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Adda Kathar SO"
  },
  "144002": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Basti Sheikh SO"
  },
  "144302": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Beas Pind SO"
  },
  "144513": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Musapur SO"
  },
  "628905": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Pudur S.O"
  },
  "628720": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Turaiyur S.O"
  },
  "792056": {
    "state": "ARUNACHAL PRADESH",
    "district": "CHANGLANG",
    "office": "Bordumsa S.O"
  },
  "792120": {
    "state": "ARUNACHAL PRADESH",
    "district": "CHANGLANG",
    "office": "Changlang S.O"
  },
  "790105": {
    "state": "ARUNACHAL PRADESH",
    "district": "TAWANG",
    "office": "Jang S.O"
  },
  "144514": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Nawanshahar Mandi SO"
  },
  "144503": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Pharala SO"
  },
  "799007": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Dhaleswar S.O"
  },
  "799210": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Kamalghat S.O"
  },
  "799008": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Khayerpur S.O"
  },
  "799006": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Kunjaban S.O"
  },
  "799211": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Mohanpur S.O (West Tripura)"
  },
  "144517": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Rahon SO"
  },
  "147105": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "Patran SO"
  },
  "147101": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "Samana SO"
  },
  "144421": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Sahlon SO"
  },
  "144621": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "Begowal SO"
  },
  "144802": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "Jagatjit Nagar SO"
  },
  "144004": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Industrial Town SO"
  },
  "144103": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Adampur AD SO"
  },
  "144104": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Daroli Kalan SO"
  },
  "799012": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Salbagan S.O"
  },
  "629201": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Asaripallam S.O"
  },
  "629401": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Azhakappapuram S.O"
  },
  "629203": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Friday Market S.O"
  },
  "629502": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Ganapathipuram S.O"
  },
  "792130": {
    "state": "ARUNACHAL PRADESH",
    "district": "TIRAP",
    "office": "Khonsa S.O"
  },
  "790003": {
    "state": "ARUNACHAL PRADESH",
    "district": "WEST KAMENG",
    "office": "Rupa S.O"
  },
  "790114": {
    "state": "ARUNACHAL PRADESH",
    "district": "WEST KAMENG",
    "office": "Bhalukpong S.O"
  },
  "791122": {
    "state": "ARUNACHAL PRADESH",
    "district": "UPPER SUBANSIRI",
    "office": "Daporijo S.O"
  },
  "416615": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Mithbav S.O"
  },
  "431137": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Bihamandwa S.O"
  },
  "642130": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Karamalai Bazaar S.O"
  },
  "642003": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Makkinaicken Patti S.O"
  },
  "641202": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Vadasithur S.O"
  },
  "642129": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Vettaikaran Pudur S.O"
  },
  "642007": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Angalakurichi S.O"
  },
  "313905": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Jhadol (S) S.O"
  },
  "415313": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Takari S.O"
  },
  "313324": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Kankroli H.O"
  },
  "313341": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Barar S.O"
  },
  "305921": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Bhim S.O"
  },
  "313332": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Charbhuja Road S.O"
  },
  "325602": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Kanwas S.O"
  },
  "325201": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Digod S.O"
  },
  "325004": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Itawa S.O"
  },
  "326529": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Khairabad S.O (Kota)"
  },
  "326023": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Jhalara Patan City S.O"
  },
  "326038": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Khanpur S.O"
  },
  "144303": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Kala Bakra SO"
  },
  "144003": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Model Town Jalandhar SO"
  },
  "144508": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Naura SO"
  },
  "312401": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Bansi S.O (Chittorgarh)"
  },
  "312403": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Barisadari S.O"
  },
  "311604": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Mandalgarh S.O"
  },
  "311026": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Mod Ka Nimbahera S.O"
  },
  "311202": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Pander S.O"
  },
  "638002": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Erode Railway Colony SO"
  },
  "638153": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Ganapathipalayam SO"
  },
  "638007": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Cauvery Railway Station SO"
  },
  "638005": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Peria Agraharam SO"
  },
  "628721": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Vanaramutti S.O"
  },
  "627951": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Devarkulam S.O"
  },
  "638460": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Savakattupalayam SO"
  },
  "232331": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Zamania RS SO"
  },
  "232329": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Zamania SO"
  },
  "233305": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "ZANGIPUR SO"
  },
  "331001": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Churu Collectorate S.O"
  },
  "331411": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Bhanipura S.O"
  },
  "331029": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Dudhwakhara S.O"
  },
  "331305": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Hamirwas S.O"
  },
  "628907": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Vilathikulam S.O"
  },
  "334302": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Sri Kolayat Ji S.O"
  },
  "331811": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Sudsar S.O"
  },
  "334022": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Udasar S.O"
  },
  "334802": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Himatsar S.O"
  },
  "334601": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Jamsar S.O"
  },
  "334602": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Kalu S.O"
  },
  "334023": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Khajuwala S.O"
  },
  "334201": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Napasar S.O"
  },
  "334803": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Nokha S.O"
  },
  "334804": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Panchoo S.O"
  },
  "334603": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Lunkaransar S.O"
  },
  "334604": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Mahajan S.O"
  },
  "331801": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Momasar S.O"
  },
  "643003": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Lovedale S.O"
  },
  "643223": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Masinagudi S.O"
  },
  "643225": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Nellakotta S.O"
  },
  "796310": {
    "state": "MIZORAM",
    "district": "KHAWZAWL",
    "office": "Khawzawl S.O"
  },
  "222127": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Baderi SO"
  },
  "222125": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Badlapur SO"
  },
  "222201": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Balwarganj SO"
  },
  "222162": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Barsathi SO"
  },
  "792129": {
    "state": "ARUNACHAL PRADESH",
    "district": "TIRAP",
    "office": "Deomali S.O"
  },
  "790101": {
    "state": "ARUNACHAL PRADESH",
    "district": "WEST KAMENG",
    "office": "Dirang S.O"
  },
  "791101": {
    "state": "ARUNACHAL PRADESH",
    "district": "LEPARADA",
    "office": "Basar S.O (West Siang)"
  },
  "790002": {
    "state": "ARUNACHAL PRADESH",
    "district": "WEST KAMENG",
    "office": "Kalaktang S.O"
  },
  "606104": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Mangalam (SA) S.O"
  },
  "606108": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Mangalur S.O"
  },
  "606109": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Sirupakkam S.O"
  },
  "606302": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Nallur S.O (Cuddalore)"
  },
  "606111": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Pennadam R.S. S.O"
  },
  "606105": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Pennadam S.O"
  },
  "606303": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Toludur S.O"
  },
  "796410": {
    "state": "MIZORAM",
    "district": "AIZAWL",
    "office": "Sairang S.O"
  },
  "326037": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Manohar Thana S.O"
  },
  "326512": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Pach Pahar S.O"
  },
  "313333": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Charbhuja S.O"
  },
  "313211": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Dariba S.O"
  },
  "313202": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Delwara S.O"
  },
  "222126": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "RAJA BAZAR SO JAUNPUR"
  },
  "222144": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Baraipar SO"
  },
  "222128": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Bazar Neorhia SO"
  },
  "222133": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Gaurabadshahpur SO"
  },
  "331301": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Rampura Beri S.O"
  },
  "331023": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Sadulpur S.O"
  },
  "331402": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Pulasar S.O"
  },
  "303712": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Govindgarh SO Jaipur"
  },
  "250619": {
    "state": "UTTAR PRADESH",
    "district": "BAGHPAT",
    "office": "Sarurpur Kalan SO"
  },
  "331021": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Ratan Nagar S.O"
  },
  "140412": {
    "state": "PUNJAB",
    "district": "FATEHGARH SAHIB",
    "office": "Bassi SO"
  },
  "141411": {
    "state": "PUNJAB",
    "district": "FATEHGARH SAHIB",
    "office": "Bhari SO"
  },
  "141801": {
    "state": "PUNJAB",
    "district": "FATEHGARH SAHIB",
    "office": "Khamano Kalan SO"
  },
  "147301": {
    "state": "PUNJAB",
    "district": "FATEHGARH SAHIB",
    "office": "Mandigobindgarh IT SO"
  },
  "140405": {
    "state": "PUNJAB",
    "district": "FATEHGARH SAHIB",
    "office": "Sangatpur Sodhian SO"
  },
  "140802": {
    "state": "PUNJAB",
    "district": "FATEHGARH SAHIB",
    "office": "Sanghol SO"
  },
  "144212": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Budhipind SO"
  },
  "144207": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Garhdiwala SO"
  },
  "144221": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Hajipur SO"
  },
  "144208": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Hariana SO"
  },
  "144209": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Janauri SO"
  },
  "144223": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Kamahi Devi SO"
  },
  "146116": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Kandhala Jattan SO"
  },
  "144305": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Khudda SO"
  },
  "144202": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Miani SO"
  },
  "144211": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Mukerian SO"
  },
  "144214": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Tanda Ram Sahai SO"
  },
  "144204": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Urmar SO"
  },
  "146023": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Bajwara SO"
  },
  "627761": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Panaiyur S.O"
  },
  "140602": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "Manakpur SO"
  },
  "146113": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Bulhowal SO"
  },
  "144222": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Datarpur SO"
  },
  "144206": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Dholbaha SO"
  },
  "146101": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Barian  Kalan SO"
  },
  "146102": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Bassi Kalan SO"
  },
  "222129": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Chandwak SO"
  },
  "222132": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Fatehganj SO Jaunpur"
  },
  "223103": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Saraimohiddin SO"
  },
  "606304": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Veppur (SA) S.O"
  },
  "607804": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Oomangalam S.O"
  },
  "144523": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Binewal SO"
  },
  "144520": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Binjon SO"
  },
  "144530": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Jaijon SO"
  },
  "307001": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Sirohi Sarupvilas S.O"
  },
  "144422": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Urapar SO"
  },
  "147006": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "RGNUL Punjab Patiala SO"
  },
  "140701": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "Kauli SO"
  },
  "140417": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "Shambhu SO"
  },
  "144521": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Balachaur SO"
  },
  "144522": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Kathagrh SO"
  },
  "606106": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Tittagudi S.O"
  },
  "623701": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Emaneswaram SO"
  },
  "623703": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Kadaladi SO Ramanathapuram"
  },
  "623603": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Kamudi SO"
  },
  "623604": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Kottaimedu SO"
  },
  "623605": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Mandalamanickam SO"
  },
  "623704": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Mudukulathur SO"
  },
  "623601": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Abiramam SO"
  },
  "623401": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Anandur SO"
  },
  "331302": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Sahwa S.O"
  },
  "331303": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Sankhu Fort S.O"
  },
  "331403": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Sardarshahar S.O"
  },
  "422304": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Ugaon S.O"
  },
  "423111": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Vadner Bhairav S.O"
  },
  "201009": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Ghaziabad City SO"
  },
  "332001": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Mochiwara SO"
  },
  "332401": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Balaran SO"
  },
  "332303": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Beswa SO"
  },
  "332302": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Dhandhan SO"
  },
  "332301": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Sikaria BazarFatehpur SO"
  },
  "332318": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Jajod SO Lachhmangarh"
  },
  "332023": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Khoor SO"
  },
  "623527": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Chathirakudi SO"
  },
  "623705": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Nainarkoil SO"
  },
  "623135": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Kannirajapuram SO"
  },
  "332406": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Kochhore SO"
  },
  "627764": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Rayagiri S.O"
  },
  "332021": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Bajajgram SO"
  },
  "332316": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Beedasar SO"
  },
  "332002": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Dhod SO"
  },
  "415730": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Ambavali S.O"
  },
  "415621": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Bharane S.O"
  },
  "415720": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Burondi S.O"
  },
  "311407": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Phulia Kalan S.O"
  },
  "311203": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Piplund S.O"
  },
  "311802": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Pur S.O (Bhilwara)"
  },
  "314025": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Sagwara S.O"
  },
  "314403": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Simalwara S.O"
  },
  "314029": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Thakarda S.O"
  },
  "314032": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Saroda S.O"
  },
  "146114": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Nandachaur SO"
  },
  "146115": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Pajjodeotta SO"
  },
  "146104": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Bihala SO"
  },
  "146024": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Factory Area Chohal SO"
  },
  "792102": {
    "state": "ARUNACHAL PRADESH",
    "district": "NAMSAI",
    "office": "Chowkham S.O"
  },
  "792121": {
    "state": "ARUNACHAL PRADESH",
    "district": "CHANGLANG",
    "office": "Jairampur S.O (Changlang)"
  },
  "791112": {
    "state": "ARUNACHAL PRADESH",
    "district": "PAPUM PARE",
    "office": "Doimukh S.O"
  },
  "792104": {
    "state": "ARUNACHAL PRADESH",
    "district": "ANJAW",
    "office": "Hayuliang S.O"
  },
  "791121": {
    "state": "ARUNACHAL PRADESH",
    "district": "PAPUM PARE",
    "office": "Kimin S.O"
  },
  "456770": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Kanasia S.O"
  },
  "456224": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Khachraud S.O"
  },
  "456668": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Makdone S.O"
  },
  "414306": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Nighoj S.O"
  },
  "642201": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Gudimangalam S.O"
  },
  "761003": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Bhatakumarada S.O"
  },
  "761027": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Humma S.O"
  },
  "761029": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Khallikote RS S.O"
  },
  "441224": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Mul S.O"
  },
  "441205": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Nagbhid S.O"
  },
  "473331": {
    "state": "MADHYA PRADESH",
    "district": "ASHOKNAGAR",
    "office": "Subash Ganj Ashoknagar S.O"
  },
  "761030": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Khallikote S.O"
  },
  "761032": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Kodala Tahasil Colony S.O"
  },
  "761045": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Matikhalo S.O"
  },
  "761105": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Polosara S.O"
  },
  "761019": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Pratapur S.O (Ganjam)"
  },
  "761018": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Purushottampur S.O"
  },
  "761028": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Rambha S.O"
  },
  "621313": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Thogaimalai S.O"
  },
  "621314": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Thuvarankurichi S.O"
  },
  "639120": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Vaiganallur S.O"
  },
  "621312": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Thiagesaralai S.O"
  },
  "306119": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Khod S.O"
  },
  "441614": {
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "office": "Gondia City S.O"
  },
  "441801": {
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "office": "Goregaon S.O (Gondia)"
  },
  "441702": {
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "office": "Navegaon Bandh S.O"
  },
  "441807": {
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "office": "Sadak Arjuni S.O"
  },
  "441806": {
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "office": "Soundad S.O"
  },
  "441911": {
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "office": "Tirora S.O"
  },
  "411033": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Chinchwadgaon S.O"
  },
  "411048": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "N I B M S.O"
  },
  "413207": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Amalner S.O (Beed)"
  },
  "431517": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "YCC Ambajogai S. O"
  },
  "473446": {
    "state": "MADHYA PRADESH",
    "district": "ASHOKNAGAR",
    "office": "Chanderi S.O"
  },
  "473335": {
    "state": "MADHYA PRADESH",
    "district": "ASHOKNAGAR",
    "office": "Esagarh S.O"
  },
  "473443": {
    "state": "MADHYA PRADESH",
    "district": "ASHOKNAGAR",
    "office": "Mungaoli S.O"
  },
  "473332": {
    "state": "MADHYA PRADESH",
    "district": "ASHOKNAGAR",
    "office": "Naisarai S.O"
  },
  "473444": {
    "state": "MADHYA PRADESH",
    "district": "ASHOKNAGAR",
    "office": "Sehrai S.O"
  },
  "473330": {
    "state": "MADHYA PRADESH",
    "district": "ASHOKNAGAR",
    "office": "Shadora S.O"
  },
  "431523": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Ambasakhar S.O"
  },
  "414203": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Ashti S.O (Beed)"
  },
  "456443": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Mehidpur S.O"
  },
  "456335": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Nagda  Town S.O"
  },
  "456664": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Narwar S.O (Ujjain)"
  },
  "144533": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Asron S.O"
  },
  "334402": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Udairamsar S.O"
  },
  "628503": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "K.R.Nagar S.O"
  },
  "456337": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Piploda  Baghla S.O"
  },
  "456661": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Tajpur S.O (Ujjain)"
  },
  "456003": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Ujjain  Bherugarh S.O"
  },
  "456006": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Ujjain  City S.O"
  },
  "441201": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Bhiwapur S.O"
  },
  "441301": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Jalalkheda S.O"
  },
  "799002": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Ramnagar S.O (West Tripura)"
  },
  "413308": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Nazara S.O"
  },
  "413252": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Ropla ( Kvd ) S.O"
  },
  "413111": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Sadashivenagar S.O"
  },
  "413307": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Sangola S.O"
  },
  "413112": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Shreepur S.O"
  },
  "306302": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Jaitaran S.O"
  },
  "635116": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Royakottah S.O"
  },
  "635206": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Pochampalli S.O (Krishnagiri)"
  },
  "635115": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Ramapuram S.O (Dharmapuri)"
  },
  "635306": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Samalpatti R.S S.O"
  },
  "635307": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Singarapettai S.O"
  },
  "635118": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Thally S.O"
  },
  "635117": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Shoolagiri S.O"
  },
  "441302": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Katol S.O"
  },
  "444407": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Pinjar S.O"
  },
  "444506": {
    "state": "MAHARASHTRA",
    "district": "WASHIM",
    "office": "Risod S.O"
  },
  "444003": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Shivaji Park Akola S.O"
  },
  "444504": {
    "state": "MAHARASHTRA",
    "district": "WASHIM",
    "office": "Shirpur S.O"
  },
  "444006": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Tajnapeth Akola S.O"
  },
  "444108": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Telhara S.O (Akola)"
  },
  "444109": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Vidyutnagar Paras S.O"
  },
  "444505": {
    "state": "MAHARASHTRA",
    "district": "WASHIM",
    "office": "Washim City S.O"
  },
  "441501": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Midc Kalmeshwar S.O"
  },
  "761043": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Pandia S.O"
  },
  "761035": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Sumandala S.O"
  },
  "326034": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Pirawa S.O"
  },
  "631304": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Vanganur S.O"
  },
  "202123": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Gonda SO"
  },
  "202134": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Gangiri SO"
  },
  "202135": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Gomat SO"
  },
  "204212": {
    "state": "UTTAR PRADESH",
    "district": "HATHRAS",
    "office": "Hasayan SO"
  },
  "204102": {
    "state": "UTTAR PRADESH",
    "district": "HATHRAS",
    "office": "Hathras Jn RS SO"
  },
  "203001": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Krishananagar SO"
  },
  "204101": {
    "state": "UTTAR PRADESH",
    "district": "HATHRAS",
    "office": "Nayaganj Hathras SO"
  },
  "605102": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Kandamangalam SO"
  },
  "306303": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Nimaj S.O"
  },
  "306307": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Pipliya Kalan S.O"
  },
  "306421": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Rohat S.O (Pali)"
  },
  "306708": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Sanderao S.O"
  },
  "306102": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Sendra S.O"
  },
  "306305": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Kushalpura S.O"
  },
  "306304": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Raipur  Marwar S.O"
  },
  "306104": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Sojat S.O"
  },
  "767017": {
    "state": "ODISHA",
    "district": "SONEPUR",
    "office": "Spinning Mills S.O"
  },
  "767016": {
    "state": "ODISHA",
    "district": "SONEPUR",
    "office": "Tarbha S.O"
  },
  "767062": {
    "state": "ODISHA",
    "district": "SONEPUR",
    "office": "Ullunda S.O"
  },
  "143525": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Marara SO"
  },
  "143520": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Sohal SO"
  },
  "304021": {
    "state": "RAJASTHAN",
    "district": "TONK",
    "office": "Newai S.O"
  },
  "304803": {
    "state": "RAJASTHAN",
    "district": "TONK",
    "office": "Panwar S.O"
  },
  "304505": {
    "state": "RAJASTHAN",
    "district": "TONK",
    "office": "Todarai Singh S.O"
  },
  "303303": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Collectorate Dausa SO"
  },
  "303313": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Bandikui Mandi SO"
  },
  "303305": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Banskho SO"
  },
  "303301": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Bassi chak SO"
  },
  "642102": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Amaravathi Nagar S.O"
  },
  "312601": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Nimbahera S.O"
  },
  "312606": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Kanera S.O"
  },
  "444510": {
    "state": "MAHARASHTRA",
    "district": "WASHIM",
    "office": "Rithad S.O"
  },
  "444402": {
    "state": "MAHARASHTRA",
    "district": "WASHIM",
    "office": "Shelubazar S.O"
  },
  "635207": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Uttangarai S.O"
  },
  "635121": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Veppanapalli S.O"
  },
  "635119": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Uddanapalli S.O"
  },
  "431518": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Bansorala S.O"
  },
  "431153": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Beed ST Stand S.O"
  },
  "431126": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Chousala S.O"
  },
  "431128": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Dindrood S.O"
  },
  "431127": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Gevrai S.O"
  },
  "414202": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Kada S.O (Beed)"
  },
  "411062": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Rupeenagar S.O"
  },
  "325009": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Khatoli S.O"
  },
  "325208": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Gadepan S.O"
  },
  "302012": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Khatipura S.O"
  },
  "143530": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Tibri SO"
  },
  "306902": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Sumerpur Krishi Upaj Mandi S.O"
  },
  "441916": {
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "office": "Salekasa S.O"
  },
  "414208": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Kadasakhar S.O"
  },
  "431123": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Kaij S.O"
  },
  "638003": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Karungalpalayam SO"
  },
  "635120": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Varattanapalli S.O"
  },
  "144527": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Garhshanker SO"
  },
  "140601": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Banur SO"
  },
  "140702": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "Ghanaur SO"
  },
  "144224": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Bhambotar SO"
  },
  "144213": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Bhanowal SO"
  },
  "642133": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Sethumadai S.O"
  },
  "642134": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Somandurai S.O"
  },
  "642105": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Water Falls Estate S.O"
  },
  "201015": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Hindon Nagar SO"
  },
  "201002": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Vivekanand Nagar SO"
  },
  "201102": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Loni SO"
  },
  "643215": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Ketti S.O"
  },
  "643224": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Naduvattam S.O"
  },
  "144028": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Chitti SO"
  },
  "221505": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Hanumanganj SO"
  },
  "212503": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Holagarh SO"
  },
  "212401": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Janghai Bazar SO"
  },
  "604207": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Vellimedupettai SO"
  },
  "605201": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Ananthapuram SO"
  },
  "605202": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Anniyur SO"
  },
  "605301": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Kanai SO"
  },
  "444701": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Badnera Town S.O"
  },
  "444904": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Chandur Railway S.O"
  },
  "605401": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Kandamanadi SO"
  },
  "144030": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Padhiana SO"
  },
  "207003": {
    "state": "UTTAR PRADESH",
    "district": "ETAH",
    "office": "Brahm Sajiwan SO"
  },
  "431142": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Kesapuri Camp S.O"
  },
  "222146": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Kutir Chakkey SO"
  },
  "222148": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Leorua SO"
  },
  "222143": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Machhali Shahar SO"
  },
  "767021": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Salebhata S.O"
  },
  "767035": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Sindhekela S.O"
  },
  "767033": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Titilagarh S.O"
  },
  "767030": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Tusra S.O"
  },
  "767071": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Puintala S.O"
  },
  "302013": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Road No 5 Vkia S.O"
  },
  "431519": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Ghatnandur S.O"
  },
  "431143": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "JBSSK GADI S.O"
  },
  "312206": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Pahuna S.O"
  },
  "312605": {
    "state": "RAJASTHAN",
    "district": "PRATAPGARH",
    "office": "Pratap garh S.O (Chittorgarh)"
  },
  "302029": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Sanganer Bazar S.O"
  },
  "302041": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Bindayaka S.O."
  },
  "415015": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Limbgove S.O"
  },
  "415521": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Lonand S.O"
  },
  "412806": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Mahableshwar S.O"
  },
  "412401": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Arvi S.O (Pune)"
  },
  "412406": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Avasari BK S.O"
  },
  "413133": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Baramati MIDC S.O"
  },
  "413102": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Baramati Court S.O"
  },
  "413103": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Bawada S.O"
  },
  "413105": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Bhigwan R S S.O"
  },
  "412206": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Bhor S.O"
  },
  "412411": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Ala S.O (Pune)"
  },
  "412105": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Alandi Devachi S.O"
  },
  "313331": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Deogarh S.O (Rajsamand)"
  },
  "635102": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Anchetty S.O"
  },
  "635103": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Bagalur S.O (Krishnagiri)"
  },
  "635104": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Barugur S.O"
  },
  "635105": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Berigai S.O"
  },
  "635107": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Denkanikotta S.O"
  },
  "635110": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Hosur Cattle Farm S.O"
  },
  "635126": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Hosur Indl. Complex S.O"
  },
  "635109": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Hosur East S.O"
  },
  "635130": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Kumudepalli SO"
  },
  "635304": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Kallavi S.O"
  },
  "635112": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Kaveripattinam S.O (Krishnagiri)"
  },
  "635113": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Kelamangalam S.O"
  },
  "635002": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Krishnagiri Indl. Estate S.O"
  },
  "415706": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Dabhol S.O"
  },
  "415712": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Dapoli S.O"
  },
  "415714": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Anjarla S.O"
  },
  "415012": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Medha S.O"
  },
  "312623": {
    "state": "RAJASTHAN",
    "district": "PRATAPGARH",
    "office": "Rathajana S.O"
  },
  "312613": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Sawa S.O"
  },
  "312612": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Shambhupura S.O"
  },
  "311024": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Railagaon S.O"
  },
  "311803": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Raipur S.O (Bhilwara)"
  },
  "311804": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Raja Ji Ka Kareda S.O"
  },
  "311030": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Rupaheli S.O"
  },
  "311806": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Sahada S.O"
  },
  "311404": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Kundgate Shahpura S.O"
  },
  "628903": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Kulathur (TVL) S.O"
  },
  "331031": {
    "state": "RAJASTHAN",
    "district": "CHURU",
    "office": "Satra S.O"
  },
  "628722": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Kurukkuchalai S.O"
  },
  "628718": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Pasuvandanai S.O"
  },
  "627713": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Ilyarasanendal S.O"
  },
  "332024": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Katrathal SO"
  },
  "332315": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Khuri Badi SO"
  },
  "142054": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Kokri Kalan SO"
  },
  "413108": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Malinagar S.O"
  },
  "456441": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Jharda S.O"
  },
  "413310": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Piliv S.O"
  },
  "413251": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Sade S.O"
  },
  "413211": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Tembhurni S.O (Solapur)"
  },
  "413113": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Velapur S.O"
  },
  "142046": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Patto Hira Singh SO"
  },
  "756037": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Fulbani S.O"
  },
  "456440": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Mehidpur  Road S.O"
  },
  "456776": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Runija S.O"
  },
  "456221": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Unhel S.O"
  },
  "311204": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Shambhugarh S.O"
  },
  "311011": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Suwana S.O"
  },
  "327001": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Banswara Mahi Colony S.O"
  },
  "638812": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Chengapalli SO"
  },
  "202125": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Harduaganj SO"
  },
  "604201": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Avalurpet SO"
  },
  "311403": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Mandal S.O (Bhilwara)"
  },
  "207401": {
    "state": "UTTAR PRADESH",
    "district": "ETAH",
    "office": "Marehara SO"
  },
  "207247": {
    "state": "UTTAR PRADESH",
    "district": "ETAH",
    "office": "Aliganj SO Etah"
  },
  "207301": {
    "state": "UTTAR PRADESH",
    "district": "ETAH",
    "office": "Awagarh SO"
  },
  "207248": {
    "state": "UTTAR PRADESH",
    "district": "ETAH",
    "office": "Dhumri SO"
  },
  "207302": {
    "state": "UTTAR PRADESH",
    "district": "ETAH",
    "office": "Jalesar SO"
  },
  "207241": {
    "state": "UTTAR PRADESH",
    "district": "ETAH",
    "office": "Amanpur SO"
  },
  "207124": {
    "state": "UTTAR PRADESH",
    "district": "Kasganj",
    "office": "Bilram SO"
  },
  "207242": {
    "state": "UTTAR PRADESH",
    "district": "Kasganj",
    "office": "Gunjdundwara SO"
  },
  "415004": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "MIDC Satara S.O"
  },
  "431506": {
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "office": "Pathri S.O"
  },
  "425406": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Shindkheda S.O"
  },
  "425405": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Shirpur S.O"
  },
  "424309": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Songir S.O"
  },
  "425427": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Vikharan (Shirpur) S.O"
  },
  "473445": {
    "state": "MADHYA PRADESH",
    "district": "ASHOKNAGAR",
    "office": "Bahadurpur S.O"
  },
  "473440": {
    "state": "MADHYA PRADESH",
    "district": "ASHOKNAGAR",
    "office": "Piprai S.O"
  },
  "304801": {
    "state": "RAJASTHAN",
    "district": "TONK",
    "office": "Peeplu S.O"
  },
  "304024": {
    "state": "RAJASTHAN",
    "district": "TONK",
    "office": "Uniara S.O"
  },
  "415718": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Dhamanand S.O"
  },
  "415703": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Guhagar S.O"
  },
  "412405": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Avsari KH S.O"
  },
  "412410": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Belha S.O"
  },
  "413104": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Bhavaninagar S.O (Pune)"
  },
  "628906": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Vembar S.O"
  },
  "332029": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Ganeri SO"
  },
  "444502": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Vadegaon S.O"
  },
  "411015": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Vishrantwadi S.O"
  },
  "411057": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Maan S.O"
  },
  "411047": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Lohogaon S.O"
  },
  "411036": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Mundhva AV S.O"
  },
  "411017": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Pimpri Waghire S.O"
  },
  "207125": {
    "state": "UTTAR PRADESH",
    "district": "ETAH",
    "office": "Mirehachi SO"
  },
  "207122": {
    "state": "UTTAR PRADESH",
    "district": "ETAH",
    "office": "Nidholi Kalan SO"
  },
  "207120": {
    "state": "UTTAR PRADESH",
    "district": "ETAH",
    "office": "Pilua SO"
  },
  "207121": {
    "state": "UTTAR PRADESH",
    "district": "ETAH",
    "office": "Sakeet SO"
  },
  "638462": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Vemandampalayam SO"
  },
  "207249": {
    "state": "UTTAR PRADESH",
    "district": "ETAH",
    "office": "Jaithra SO"
  },
  "327031": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Anandpuri S.O (Banswara)"
  },
  "327032": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Arthuna S.O"
  },
  "424105": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Bhadgaon S.O"
  },
  "425113": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Bahadarpur S.O (Jalgaon)"
  },
  "425109": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Erandol S.O"
  },
  "424103": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Kajgaon S.O (Jalgaon)"
  },
  "425110": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Kasoda S.O"
  },
  "424107": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Khedgaon S.O (Jalgaon)"
  },
  "140413": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Gharuan SO"
  },
  "140301": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Kharar SO Rupnagar"
  },
  "140109": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Khizrabad West SO"
  },
  "140103": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Kurali SO"
  },
  "140307": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Landran SO"
  },
  "413130": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Bhigwan S.O"
  },
  "425305": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Varangaon S.O"
  },
  "424106": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Mehunbare S.O"
  },
  "424104": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Nagardeola S.O"
  },
  "424201": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Vivekanand nagar Pachora S.O"
  },
  "425111": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Parola SO"
  },
  "756084": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Dhansimulia S.O"
  },
  "224153": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Khandasa SO"
  },
  "224205": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Khapradih SO"
  },
  "224158": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Kuchera SO"
  },
  "224207": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Majurddinpur SO"
  },
  "224117": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Mawai SO"
  },
  "224161": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Maya SO"
  },
  "224118": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Meermau SO"
  },
  "224164": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Milkipur SO"
  },
  "425301": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Yawal S.O"
  },
  "425108": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Akulkheda S.O"
  },
  "425502": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Savda S.O"
  },
  "425308": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Varangaon Ord.Factory S.O"
  },
  "761115": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Gunthapada S.O"
  },
  "415710": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Furus S.O"
  },
  "415728": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Hedavi S.O"
  },
  "473001": {
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "office": "Guna Bazar S.O"
  },
  "322241": {
    "state": "RAJASTHAN",
    "district": "KARAULI",
    "office": "Phoota Kot Karauli SO"
  },
  "312207": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Singhpur S.O (Chittorgarh)"
  },
  "312625": {
    "state": "RAJASTHAN",
    "district": "PRATAPGARH",
    "office": "Dhariawad S.O"
  },
  "411014": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Viman nagar S.O"
  },
  "140118": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Anand Pur Sahib SO"
  },
  "140111": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Bela SO Rupnagar"
  },
  "145101": {
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "office": "Mirthal SO"
  },
  "145001": {
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "office": "Pathankot SO"
  },
  "145023": {
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "office": "Sujanpur SO Gurdaspur"
  },
  "140133": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Bhanupali SO"
  },
  "140112": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Chamkaur Sahib SO"
  },
  "140126": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Fertilizer Factory Nangal SO"
  },
  "140123": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Ganugwal SO"
  },
  "140113": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Nuhon Colony Ropar SO"
  },
  "224201": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Motinagar SO"
  },
  "224119": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Patranga RS SO"
  },
  "224171": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Purah SO"
  },
  "224203": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Rampur Bhagan SO"
  },
  "224120": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Rudauli SO"
  },
  "140115": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Kiratpur Sahib SO"
  },
  "140116": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Kotla Power House SO"
  },
  "140102": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Lutheri SO"
  },
  "140108": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Mian Pur SO"
  },
  "140124": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Nangal Township SO"
  },
  "140128": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "DUMEWAL SO"
  },
  "313325": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Kelwara S.O"
  },
  "431537": {
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "office": "Pedgaon S.O"
  },
  "144406": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Baddon SO"
  },
  "146103": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Bham SO"
  },
  "424308": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Shirud S.O"
  },
  "635122": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Alapatti S.O"
  },
  "224188": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Sohawal RS SO"
  },
  "224195": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Tikari SO"
  },
  "334808": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Pugal S.O"
  },
  "312203": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Rashmi S.O"
  },
  "323306": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Vikram Nagar S.O"
  },
  "147103": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "Sanaur SO"
  },
  "144803": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Dialpur SO"
  },
  "305901": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Shahpura Mohalla( Beawar ) S.O"
  },
  "305631": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "RAMGARH S.O"
  },
  "305621": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Bandanwara S.O"
  },
  "305926": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Barakhera S.O"
  },
  "305401": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Bhwani Khera S.O"
  },
  "305624": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Bijainagar S.O"
  },
  "305630": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Jamola S.O"
  },
  "305207": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Jethana S.O"
  },
  "305923": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Lotiyana S.O"
  },
  "305203": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Mangliawas S.O"
  },
  "311606": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Shyampura S. O."
  },
  "344001": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Barmer PR S.O"
  },
  "142032": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Bassian SO"
  },
  "142036": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Galib Kalan SO"
  },
  "141107": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Halwara SO"
  },
  "142031": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Hathur SO"
  },
  "142029": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Jodhan SO"
  },
  "142030": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Kamalpura SO"
  },
  "142022": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Lalton Kalan SO"
  },
  "142027": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Ayali Kalan SO"
  },
  "142021": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Baddowal SO"
  },
  "141422": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Bopa Rai Kalan SO Ludhiana"
  },
  "141101": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Dakha Mandi SO"
  },
  "141102": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Dakha SO"
  },
  "222139": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Khetasarai SO"
  },
  "223104": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Khuthan SO"
  },
  "752031": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Banpur  S.O (Khorda)"
  },
  "752062": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Begunia S.O"
  },
  "752066": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Bolagarh S.O"
  },
  "752034": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Gangadharpur S.O"
  },
  "752020": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Jankia S.O"
  },
  "752054": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Janla S.O"
  },
  "344034": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Baitu S.O"
  },
  "344022": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Balotra SB S.O"
  },
  "344702": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Chohtan S.O"
  },
  "224172": {
    "state": "UTTAR PRADESH",
    "district": "FIROZABAD",
    "office": "Rasulabad SO"
  },
  "752050": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Rajabazar Nd S.O"
  },
  "411021": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Armament S.O"
  },
  "411023": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "N.D.A. Khadakwasla S.O"
  },
  "411046": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Katraj S.O"
  },
  "442406": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "MIDC (P) S.O"
  },
  "635108": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Elathagiri S.O"
  },
  "635106": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Chaparthi S.O"
  },
  "635111": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Karimangalam S.O"
  },
  "140603": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Zirakpur SO"
  },
  "306912": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Tagatgarh S.O"
  },
  "425112": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Deogaon S.O (Jalgaon)"
  },
  "424108": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Hirapur S.O"
  },
  "140125": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Pratap Nagar Nangal SO"
  },
  "145025": {
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "office": "Malakpur SO"
  },
  "143534": {
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "office": "Taragarh Gurdaspur SO"
  },
  "140110": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Sialba Majri SO"
  },
  "140308": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Sohana SO"
  },
  "635101": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Krishnagiri Project S.O"
  },
  "635114": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Mathagondapalli S.O"
  },
  "635203": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Mathur S.O (Dharmapuri)"
  },
  "635204": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Nagarasampatti S.O"
  },
  "635123": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Pannandur S.O"
  },
  "221503": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Handia SO"
  },
  "767045": {
    "state": "ODISHA",
    "district": "SONEPUR",
    "office": "Sonepur Rampur S.O"
  },
  "141015": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Mundian Kalan SO"
  },
  "141007": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Eros Bajra Road SO"
  },
  "441809": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Pohra S.O"
  },
  "441802": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Sakoli S.O"
  },
  "441902": {
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "office": "Amgaon S.O"
  },
  "441701": {
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "office": "Arjuni Morgaon S.O"
  },
  "441901": {
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "office": "Deori S.O (Gondia)"
  },
  "441601": {
    "state": "MAHARASHTRA",
    "district": "GONDIA",
    "office": "Gondia Bazar S.O"
  },
  "142035": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Mallah SO"
  },
  "626119": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Sankaralingapuram SO"
  },
  "626124": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Sivakasi West SO"
  },
  "626135": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Srivilliputhur Court Complex SO"
  },
  "626125": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Madavarvilagam SO"
  },
  "626126": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Sundarapandiam SO"
  },
  "626131": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Vembakottai SO"
  },
  "626201": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Elayirampannai SO"
  },
  "764057": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Bhairabsinghpur S.O"
  },
  "752035": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Gambharimunda S.O"
  },
  "752027": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Kuhuri S.O"
  },
  "752018": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Narangarh S.O"
  },
  "441915": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Sihora S.O (Bhandara)"
  },
  "441912": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Tumsar S.O"
  },
  "791125": {
    "state": "ARUNACHAL PRADESH",
    "district": "LOWER SIANG",
    "office": "Likabali S.O"
  },
  "752019": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Nirakarpur S.O"
  },
  "752057": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "P N College S.O"
  },
  "752056": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Pallahat S.O"
  },
  "752064": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Pichikuli S.O"
  },
  "245301": {
    "state": "UTTAR PRADESH",
    "district": "HAPUR",
    "office": "Dhaulana SO"
  },
  "201003": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Meerut Road SO"
  },
  "441404": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Kamthi Colliery S.O"
  },
  "624004": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Dindigul Collectorate SO"
  },
  "624702": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Eriyodu SO"
  },
  "624302": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Ambathurai RS SO"
  },
  "624703": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Guziliamparai SO"
  },
  "624706": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Kovilur SO"
  },
  "624303": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "NPanjampatti SO"
  },
  "144216": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Talwara Township SO"
  },
  "604301": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Brahmadesam SO Villupuram"
  },
  "232330": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Usia SO"
  },
  "140127": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "New Nangram SO"
  },
  "140117": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Nurpur Bedi SO"
  },
  "140119": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Takhatgarh SO"
  },
  "145026": {
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "office": "Narot Jailmal Singh SO"
  },
  "604154": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Velur SA SO"
  },
  "605110": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "Villiyanur SO"
  },
  "212502": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Soraon SO"
  },
  "212405": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Ugrasen Pur SO"
  },
  "425409": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Shahada S.O"
  },
  "425413": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Taloda S.O"
  },
  "425423": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Vadali S.O (Nandurbar)"
  },
  "425426": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Visarwadi S.O"
  },
  "425421": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Thalner S.O"
  },
  "431541": {
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "office": "Rampuri BK S.O"
  },
  "431516": {
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "office": "Sonpeth S.O"
  },
  "431511": {
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "office": "Purna S.O"
  },
  "431536": {
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "office": "Ranisawargaon S.O"
  },
  "431503": {
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "office": "Sailu S.O"
  },
  "431502": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Satona S.O"
  },
  "431542": {
    "state": "MAHARASHTRA",
    "district": "HINGOLI",
    "office": "Sengaon S.O"
  },
  "145029": {
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "office": "Shahpur Kandi Township SO"
  },
  "767060": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Turekela S.O"
  },
  "306001": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Marwar Jn. H.O"
  },
  "761104": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Gopinath Patna S.O"
  },
  "305623": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Masuda S.O"
  },
  "305204": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Pisangan S.O"
  },
  "305925": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Rajiawas S.O"
  },
  "305622": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Bhinai S.O"
  },
  "305625": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Jalia  II S.O"
  },
  "305927": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Kabra S.O"
  },
  "305202": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Kharwa S.O"
  },
  "637406": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Namagiripettai S.O"
  },
  "637407": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Pudupatti S.O (Salem)"
  },
  "637408": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Rasipuram S.O"
  },
  "637412": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Singalandapuram S.O"
  },
  "207123": {
    "state": "UTTAR PRADESH",
    "district": "Kasganj",
    "office": "Kasganj RS SO"
  },
  "207402": {
    "state": "UTTAR PRADESH",
    "district": "Kasganj",
    "office": "Neoli SO"
  },
  "207243": {
    "state": "UTTAR PRADESH",
    "district": "Kasganj",
    "office": "Patiali SO"
  },
  "207244": {
    "state": "UTTAR PRADESH",
    "district": "ETAH",
    "office": "Raja Ka Rampur SO"
  },
  "416211": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Parite S.O"
  },
  "416212": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Radhanagari S.O"
  },
  "413210": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Pimpelner S.O"
  },
  "764011": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Kolab Nagar S.O"
  },
  "142045": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Manoke SO"
  },
  "142003": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Moga Kty SO"
  },
  "142055": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Nihal Singh Wala SO"
  },
  "224229": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Kumarganj SO"
  },
  "224234": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Mahboobganj SO"
  },
  "441102": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Khaperkheda S.O"
  },
  "441202": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Kuhi S.O"
  },
  "441210": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Mandhal S.O"
  },
  "761101": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Kanchuru S.O"
  },
  "761102": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Hinjilicut S.O"
  },
  "761144": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Konkarada S.O"
  },
  "761114": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Mundamarai S.O"
  },
  "444303": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Kelanagar S.O"
  },
  "603106": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Orakattupettai SO"
  },
  "603107": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Salavakkam SO"
  },
  "207245": {
    "state": "UTTAR PRADESH",
    "district": "Kasganj",
    "office": "Sahawar SO"
  },
  "636453": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Mecheri S.O"
  },
  "636304": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Muthunaickenpatti S.O"
  },
  "636305": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Pannapatti S.O"
  },
  "636403": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Raman Nagar S.O"
  },
  "636306": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Sinnappampatti S.O"
  },
  "636307": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Sivadapuram S.O"
  },
  "641658": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Karadibavi SO"
  },
  "641671": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Kettanur SO"
  },
  "416011": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Sane Guruji Vasahat S.O"
  },
  "416236": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "5 Star MIDC Kagal S.O"
  },
  "144306": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Bhangala SO"
  },
  "144210": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Bhunga SO"
  },
  "224182": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Raunahi SO"
  },
  "224284": {
    "state": "UTTAR PRADESH",
    "district": "AYODHYA",
    "office": "Shahganj SO"
  },
  "610105": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Nannilam Cutchery S.O"
  },
  "629002": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Maravankudiyiruppu S.O"
  },
  "629202": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Muttom S.O"
  },
  "629802": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Neyyoor S.O"
  },
  "629602": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Puthalam S.O"
  },
  "629704": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Suchindrum S.O"
  },
  "629901": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Thazhakudy S.O"
  },
  "629302": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Thovalai S.O"
  },
  "629003": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Vetturnimadam S.O"
  },
  "629152": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Idaikkode S.O"
  },
  "629101": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Kaliyal S.O"
  },
  "629158": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Kattathurai S.O"
  },
  "629160": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Kollangodu S.O"
  },
  "628716": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Nalatinputhur S.O"
  },
  "630202": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Ariyakudi S.O"
  },
  "332722": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Jajod SO Srimadhopur"
  },
  "332707": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Jharli SO"
  },
  "333514": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Jasrapur S.O"
  },
  "333030": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Kajara S.O"
  },
  "202121": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Akrabad S.O"
  },
  "605501": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "Tirukkanur SO"
  },
  "605109": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Vanur SO"
  },
  "233221": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Aurihar SO"
  },
  "275201": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Bahadurganj"
  },
  "605111": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Tiruchitambalam SO"
  },
  "604101": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Akshipakkam SO"
  },
  "604151": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Alampoondi SO"
  },
  "333503": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Kolihan Nagar S.O"
  },
  "333034": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Kuharwas S.O"
  },
  "333035": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Narhar S.O"
  },
  "333515": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Pacheri Badi S.O"
  },
  "302022": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Sitapura Industrial Area S.O"
  },
  "333031": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "V.V. Pilani S.O"
  },
  "333504": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Kcpt Khetri Nagar S.O"
  },
  "333025": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Mandrella S.O"
  },
  "416505": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Ajara S.O"
  },
  "416229": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Ambewadi S.O (Kolhapur)"
  },
  "416213": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Bambavada S.O"
  },
  "416208": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Bidri S.O"
  },
  "416509": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Chandgad S.O"
  },
  "416501": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Dundage S.O"
  },
  "416502": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Gadhinglaj S.O"
  },
  "416206": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Gaganbavada S.O"
  },
  "629161": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Kulasekharam S.O"
  },
  "629163": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Kuzhithurai S.O"
  },
  "629164": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Manalikarai S.O"
  },
  "629165": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Marthandam Bridge S.O"
  },
  "629166": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Mekkamandapam S.O"
  },
  "629168": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Pacode S.O"
  },
  "629169": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Palliyadi S.O"
  },
  "629174": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Thiruvithancode S.O"
  },
  "610203": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Ponnirai S.O"
  },
  "629252": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Manavalakurichi S.O"
  },
  "629403": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Mayiladi S.O"
  },
  "629004": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Nagercoil Industrial Estate S.O"
  },
  "629159": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Palapalam S.O"
  },
  "629601": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Parakkai S.O"
  },
  "629180": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Villukuri S.O"
  },
  "629151": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Arumanai S.O"
  },
  "629153": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Kaliakkavilai S.O"
  },
  "431510": {
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "office": "Yeldari S.O"
  },
  "431540": {
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "office": "Zari S.O"
  },
  "424306": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Pimpalner S.O"
  },
  "424304": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Sakri (Dhule) S.O"
  },
  "425422": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Prakasha S.O"
  },
  "425424": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Purushottam Nagar S.O"
  },
  "425411": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Ranala S.O"
  },
  "425410": {
    "state": "MAHARASHTRA",
    "district": "NANDURBAR",
    "office": "Sarangkheda S.O"
  },
  "632511": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Sakkaramallur SO"
  },
  "632512": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Timiri SO"
  },
  "631102": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Sholingur SO"
  },
  "632516": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Vennampalle SO"
  },
  "632501": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Ammoor SO"
  },
  "632503": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Arcot West SO"
  },
  "632506": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Kalavai SO"
  },
  "632404": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Karai SO"
  },
  "629157": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Karinkal S.O"
  },
  "629193": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Keezhkulam S.O"
  },
  "629167": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Mulagumoodu S.O"
  },
  "629170": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Palukal S.O"
  },
  "305601": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Nasirabad H.O"
  },
  "305415": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Baghera S.O"
  },
  "305406": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Junia S.O"
  },
  "305405": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Kadera S.O"
  },
  "305402": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Ramsar S.O (Ajmer)"
  },
  "305627": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Tantoti S.O"
  },
  "305924": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Todgarh S.O"
  },
  "305412": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Fathegarh S.O"
  },
  "305408": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "PARA S.O"
  },
  "306021": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Auwa S.O"
  },
  "143529": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Tibber SO"
  },
  "341510": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Merta City S.O"
  },
  "632507": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Kavanur SO"
  },
  "632508": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Kaveripak SO"
  },
  "632518": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Pennagar SO"
  },
  "632517": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Ratnagiri Kilminnal SO"
  },
  "231223": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Beej Pur SO"
  },
  "231303": {
    "state": "UTTAR PRADESH",
    "district": "MIRZAPUR",
    "office": "Bijaipur SO Mirzapur"
  },
  "231312": {
    "state": "UTTAR PRADESH",
    "district": "MIRZAPUR",
    "office": "Chilh SO"
  },
  "231304": {
    "state": "UTTAR PRADESH",
    "district": "MIRZAPUR",
    "office": "Chunar SO"
  },
  "231206": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Churk SO"
  },
  "231207": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Dalla SO"
  },
  "231208": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Dudhi SO"
  },
  "631151": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Takkolam SO"
  },
  "413507": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Kallam S.O"
  },
  "413608": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Lohara S.O"
  },
  "413623": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Malumbra S.O"
  },
  "413605": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Murum S.O"
  },
  "413602": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Naldurg S.O"
  },
  "415023": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Mahimangad S.O"
  },
  "624003": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Nagalnagar SO"
  },
  "624401": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Natham Koilpatti SO"
  },
  "624620": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Palayam SO"
  },
  "624622": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Reddiarchatram SO"
  },
  "624402": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Samudrapatti SO"
  },
  "624304": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Sanarpatti SO"
  },
  "624306": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Siluvathur SO"
  },
  "624709": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Tadicombu SO"
  },
  "201010": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Kaushambi SO"
  },
  "152116": {
    "state": "PUNJAB",
    "district": "FAZILKA",
    "office": "Krishna Nagari Abohar SO"
  },
  "152124": {
    "state": "PUNJAB",
    "district": "FAZILKA",
    "office": "Arniwala Sheikh Subhan SO"
  },
  "401301": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Agashi S.O"
  },
  "401202": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Vasai Road E S.O"
  },
  "401201": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Bassein S.O"
  },
  "401501": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Boisar S.O"
  },
  "233229": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "BARACHAWAR SO"
  },
  "630303": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Devakottai Extension S.O"
  },
  "630302": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Devakottai West S.O"
  },
  "630103": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Kanadukathan S.O"
  },
  "630311": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Periyakarai S.O"
  },
  "630201": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "A.Thekkur S.O"
  },
  "630501": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "CVmangalam S.O"
  },
  "630206": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Kunnakudi S.O"
  },
  "630307": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Managiri S.O"
  },
  "630207": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Nachiapuram S.O"
  },
  "630405": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Nerkuppai S.O"
  },
  "630208": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "O.Siruvayal S.O"
  },
  "630108": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Puduvayal S.O"
  },
  "630309": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Pulidipatti S.O"
  },
  "305026": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Thanwala S.O"
  },
  "341031": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Padukallan S.O"
  },
  "140306": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Manauli SO"
  },
  "140901": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Mullanpur SO"
  },
  "233231": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "BHAWARKOL SO"
  },
  "233307": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "BHIMAPAR SO"
  },
  "233300": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "BIRNO SO"
  },
  "233306": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Deokali SO"
  },
  "232336": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Dharhni SO"
  },
  "232326": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Dildarnagar SO"
  },
  "631551": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Balchettychatram S.O"
  },
  "631502": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Sankaramutt S.O"
  },
  "641655": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Cheyur SO"
  },
  "641687": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Iduvampalayam SO"
  },
  "609603": {
    "state": "PUDUCHERRY",
    "district": "KARAIKAL",
    "office": "Nedungadu S.O"
  },
  "609607": {
    "state": "PUDUCHERRY",
    "district": "KARAIKAL",
    "office": "Tirunallar S.O"
  },
  "611104": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Kilvelur S.O"
  },
  "622507": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Tirumayam S.O"
  },
  "341512": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Parbatsar S.O"
  },
  "140114": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Bharatgarh SO"
  },
  "632509": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Melvisharam SO"
  },
  "142057": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Samadh Bhai SO"
  },
  "332706": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Guhala SO"
  },
  "332721": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Gurara SO"
  },
  "608002": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Annamalai University S.O"
  },
  "608501": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "B.Mutlur S.O"
  },
  "608601": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Bhuvanagiri S.O"
  },
  "305922": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Jawaja S.O"
  },
  "403101": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Betim S.O"
  },
  "403504": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Bicholim S.O"
  },
  "403516": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Calangute S.O"
  },
  "415713": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Harnai S.O"
  },
  "403523": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Carona S.O"
  },
  "623502": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Achunthanvayal SO"
  },
  "623402": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Chinnakeeramangalam SO"
  },
  "632405": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Mukundarayapuram SO"
  },
  "632515": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Tiruvalam SO"
  },
  "632318": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Valapandal SO"
  },
  "632521": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Vilapakkam SO"
  },
  "632513": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Walajapet SO"
  },
  "231210": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Ghorawal SO"
  },
  "413606": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Omerga S.O"
  },
  "413502": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Paranda S.O"
  },
  "413528": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Shiradhon S.O"
  },
  "413505": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Sonari S.O (Osmanabad)"
  },
  "608301": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Kattumannarkoil S.O"
  },
  "608602": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Keerapalayam S.O"
  },
  "608102": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Killai S.O"
  },
  "608303": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Lalpet S.O"
  },
  "607802": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Neyveli 2 S.O"
  },
  "608701": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Palayamkottai(CDL) S.O"
  },
  "607805": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Perperiyankuppam S.O"
  },
  "413509": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Ter S.O"
  },
  "413508": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Dhoki S.O"
  },
  "413534": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Ieet S.O"
  },
  "140101": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Morinda SO"
  },
  "312205": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Akola S.O (Chittorgarh)"
  },
  "312025": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Senthi S.O"
  },
  "332746": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Shimala S.O"
  },
  "333516": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Singhana S.O"
  },
  "142042": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Dharamkot SO"
  },
  "401602": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Dahanu Road S.O"
  },
  "401603": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Jawhar S.O"
  },
  "401403": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Manor S.O"
  },
  "401604": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Mokhada S.O"
  },
  "401203": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Sopara S.O"
  },
  "401606": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Talasari S.O"
  },
  "401502": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Tarapur S.O (Thane)"
  },
  "603301": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Acharapakkam SO"
  },
  "603307": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Orathy SO"
  },
  "603308": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Padalam SO"
  },
  "603312": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Pavunjur SO"
  },
  "603309": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Polambakkam SO"
  },
  "603405": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Ponvilainthakalathur SO"
  },
  "603108": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Sembakkam SO"
  },
  "603204": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Singaperumalkoil SO"
  },
  "603310": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Thozhupedu SO"
  },
  "603110": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Tiruporur SO"
  },
  "603111": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Venpakkam SO"
  },
  "403515": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Candolim S.O"
  },
  "623512": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Alagankulam SO"
  },
  "271831": {
    "state": "UTTAR PRADESH",
    "district": "SHRAVASTI",
    "office": "Bhinga SO"
  },
  "606701": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Chengam SO"
  },
  "637104": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Thevur S.O (Namakkal)"
  },
  "637105": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Vellandivalasai S.O"
  },
  "643209": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Emerald S.O"
  },
  "643212": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Gudalur Bazaar S.O"
  },
  "643211": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Gudalur Nilgiris S.O"
  },
  "401102": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Umbarpada S.O"
  },
  "401204": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Vajreshwari S.O"
  },
  "401103": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Vangaon S.O"
  },
  "401303": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Virar S.O"
  },
  "421303": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Wada S.O"
  },
  "152022": {
    "state": "PUNJAB",
    "district": "FIROZEPUR",
    "office": "Guruharsahai SO"
  },
  "152121": {
    "state": "PUNJAB",
    "district": "FAZILKA",
    "office": "Khui Khera SO"
  },
  "152128": {
    "state": "PUNJAB",
    "district": "FAZILKA",
    "office": "Khuiyan Server SO"
  },
  "142044": {
    "state": "PUNJAB",
    "district": "FIROZEPUR",
    "office": "Makhu SO"
  },
  "152021": {
    "state": "PUNJAB",
    "district": "FIROZEPUR",
    "office": "Mallanwala SO"
  },
  "335024": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Gajsinghpur S.O"
  },
  "335025": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Ganeshgarh S.O"
  },
  "335707": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Gharsana S.O"
  },
  "335708": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "RAWLA S.O"
  },
  "335711": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Mandi Gharsana S.O"
  },
  "305802": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Kishangarh City S.O"
  },
  "305814": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Roopnagar S.O"
  },
  "305025": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Srinagar S.O (Ajmer)"
  },
  "305816": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Tiloniya S.O"
  },
  "305815": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Salemabad S.O"
  },
  "335901": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Hindumalkote S.O"
  },
  "335702": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Jetsar S.O"
  },
  "335027": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Kesrisinghpur S.O"
  },
  "624002": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Begampur SO Dindigul"
  },
  "624705": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Kannivadi SO"
  },
  "624711": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Kasipalayam SO Dindigul"
  },
  "285001": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Orai Railway Station SO"
  },
  "202280": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Atrauli S.O"
  },
  "275202": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Dullahpur SO"
  },
  "233222": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Gangauli SO"
  },
  "605203": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Kanjanur SO"
  },
  "232340": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Deoria SO Ghazipur"
  },
  "624403": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Sendurai SO Dindigul"
  },
  "400607": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Sandozbaugh S.O"
  },
  "401701": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Bordi S.O"
  },
  "401503": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Chinchani S.O"
  },
  "401601": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Dahanu S.O"
  },
  "444126": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Adgaon Bk S.O"
  },
  "441112": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Kelod S.O"
  },
  "311408": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Upreda S.O"
  },
  "311025": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Hamirgarh S.O"
  },
  "311201": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Jahazpur S.O"
  },
  "311605": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Kachola S.O"
  },
  "311023": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Kothian S.O"
  },
  "311603": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Kotri S.O (Bhilwara)"
  },
  "643004": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Fernhill S.O"
  },
  "637020": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Valayapatti S.O (Namakkal)"
  },
  "637212": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Velagoundampatti S.O"
  },
  "614302": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Tirukkarugavur S.O"
  },
  "614303": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Vadakkumangudi S.O"
  },
  "626103": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Erichanatham SO"
  },
  "626149": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Maharajapuram SO"
  },
  "626203": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Sattur SO"
  },
  "626205": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Uppathur SO"
  },
  "626002": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Virudhunagar Collectorate SO"
  },
  "611105": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Kuthur S.O"
  },
  "611106": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Manjakollai S.O"
  },
  "609604": {
    "state": "PUDUCHERRY",
    "district": "KARAIKAL",
    "office": "Neravy S.O"
  },
  "611108": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Sikkal S.O (Nagapattinam)"
  },
  "611109": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Thevur S.O (Nagapattinam)"
  },
  "609702": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Tirumarugal S.O"
  },
  "441101": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Khapa S.O"
  },
  "441111": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Koradi Tps S.O"
  },
  "401607": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Kasa S.O"
  },
  "142058": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Kishanpura SO Moga"
  },
  "142043": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Kot Ise Khan SO"
  },
  "416010": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Phulewadi S.O"
  },
  "416013": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "R K Nagar S.O (Kolhapur)"
  },
  "441913": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Tumsar Road S.O"
  },
  "141108": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Pakhowal SO"
  },
  "141109": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Raekot SO"
  },
  "142033": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Sidhwan Bet SO"
  },
  "142024": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Sidhwan Khurd SO"
  },
  "142025": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Sowaddi SO"
  },
  "141121": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Behlolpur SO"
  },
  "313207": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Gilund S.O"
  },
  "313321": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Goanguda S.O"
  },
  "313334": {
    "state": "RAJASTHAN",
    "district": "RAJSAMAND",
    "office": "Kelwa S.O (Rajsamand)"
  },
  "341513": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Riyan S.O"
  },
  "341029": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Sribalaji S.O"
  },
  "332716": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Sefragunwar S.O"
  },
  "333028": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Sultana S.O"
  },
  "341514": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Ren S.O"
  },
  "341027": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Rol S.O"
  },
  "421311": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Saravali S.O"
  },
  "401101": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Bhayander West S.O"
  },
  "416552": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "DSF Halkarni S.O"
  },
  "416119": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Gandhinagar S.O (Kolhapur)"
  },
  "274405": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Rampur SO"
  },
  "274204": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Rudrapur SO"
  },
  "274509": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Salaempur SO"
  },
  "335801": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "Dabli Rathan S.O"
  },
  "335504": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "Gogameri S.O"
  },
  "335802": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "Goluwala S.O"
  },
  "335513": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "Hanumangarh Town S.O"
  },
  "335502": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "Kalana S.O"
  },
  "335523": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "Nohar S.O"
  },
  "333029": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Surajgarh S.O"
  },
  "638103": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Kunnathur SO Erode"
  },
  "636030": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Mohan Nagar S.O (Salem)"
  },
  "636454": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Nangavalli S.O"
  },
  "141421": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Doraha SO Ludhiana"
  },
  "141206": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Ghawaddi SO"
  },
  "141116": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Gill SO"
  },
  "141414": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Issru SO"
  },
  "141112": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Kohara SO"
  },
  "141119": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Maloudh SO"
  },
  "141416": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Payal SO"
  },
  "626189": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Sivakasi East SO"
  },
  "626128": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Thayilpatti SO"
  },
  "626130": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Tiruthangal SO"
  },
  "626140": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Sevalpatti SO"
  },
  "141104": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "KCG Sudhar SO"
  },
  "626005": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Amathur SO"
  },
  "626109": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Mallanginar SO"
  },
  "626202": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Nenmeni SO"
  },
  "637410": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Vaiyappamalai S.O"
  },
  "638182": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Velur (Namakkal) S.O"
  },
  "643102": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Coonoor RS S.O"
  },
  "285205": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Navin Mandi Konch SO"
  },
  "285125": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Kuthond SO"
  },
  "312626": {
    "state": "RAJASTHAN",
    "district": "PRATAPGARH",
    "office": "Parsola S.O"
  },
  "413624": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Kati S.O"
  },
  "643217": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Kotagiri S.O"
  },
  "643214": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Kattabettu S.O"
  },
  "643219": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Kundah Bridge S.O"
  },
  "637409": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Sendamangalam S.O"
  },
  "637021": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Varagur S.O"
  },
  "425501": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Thorgavan S.O"
  },
  "333036": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Tibabasai S.O"
  },
  "335803": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "Pilibangan S.O"
  },
  "335524": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "Rawatsar S.O (Hanumangarh)"
  },
  "335501": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "Bhadra S.O"
  },
  "335511": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "Channibari S.O"
  },
  "231313": {
    "state": "UTTAR PRADESH",
    "district": "MIRZAPUR",
    "office": "Jigna RS SO"
  },
  "231309": {
    "state": "UTTAR PRADESH",
    "district": "MIRZAPUR",
    "office": "Kubari Patehara SO"
  },
  "231225": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Anpara Tps SO"
  },
  "231205": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Chopan SO"
  },
  "335503": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "Dabri S.O"
  },
  "401401": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Kelwa S.O (Thane)"
  },
  "401504": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Tarapur App S.O"
  },
  "442104": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Seloo S.O"
  },
  "152117": {
    "state": "PUNJAB",
    "district": "FAZILKA",
    "office": "Balluana SO"
  },
  "152003": {
    "state": "PUNJAB",
    "district": "FIROZEPUR",
    "office": "Canal Colony Ferozepur SO"
  },
  "152123": {
    "state": "PUNJAB",
    "district": "FAZILKA",
    "office": "Gandhi Nagar Fazilka SO"
  },
  "152020": {
    "state": "PUNJAB",
    "district": "FAZILKA",
    "office": "Railway Road Mandi  Ladhuka"
  },
  "152002": {
    "state": "PUNJAB",
    "district": "FIROZEPUR",
    "office": "Ferozepur City SO"
  },
  "142052": {
    "state": "PUNJAB",
    "district": "FIROZEPUR",
    "office": "Ferozeshah SO"
  },
  "401208": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Vasai East IE S.O"
  },
  "401605": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Vikramgad S.O"
  },
  "604206": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Vallam SO"
  },
  "602105": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Sriperumbudur S.O"
  },
  "444301": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Amdapur S.O"
  },
  "443308": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Dusarbid S.O"
  },
  "443304": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Janephal S.O"
  },
  "443302": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Lonar S.O"
  },
  "443301": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Mehkar S.O"
  },
  "443403": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Pimpalgaon Kale S.O"
  },
  "444202": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Sangrampur S.O (Buldhana)"
  },
  "765019": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "Bissamcuttack S.O"
  },
  "641603": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Gandhinagar SO"
  },
  "232327": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Gahmar SO"
  },
  "631553": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Edayarpakkam S.O"
  },
  "631561": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Enathur S.O"
  },
  "631603": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Magaral S.O"
  },
  "603403": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Manampathi S.O"
  },
  "608306": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Ayangudi S.O"
  },
  "608001": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Chidambaram East S.O"
  },
  "441103": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Kondhali S.O"
  },
  "285126": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Madhogarh SO Jalaun"
  },
  "603319": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Melmaruvathur SO"
  },
  "603314": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Malaivaiyavur SO"
  },
  "152024": {
    "state": "PUNJAB",
    "district": "FAZILKA",
    "office": "Jalalabad W SO"
  },
  "413526": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Pargaon S.O"
  },
  "341030": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Tarnau S.O"
  },
  "765033": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "Dambasora S.O"
  },
  "626204": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Ramasamy Raja Nagar SO"
  },
  "626003": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Virudhunagar Industrial Estate SO"
  },
  "142023": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Mann SO"
  },
  "609608": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Kollapuram S.O"
  },
  "629173": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Thengapattanam S.O"
  },
  "629177": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Tiruvattar S.O"
  },
  "611103": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Kilaiyur (Tiruvarur) S.O"
  },
  "611003": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Nagapattinam Collectorate S.O"
  },
  "611002": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Nagore South S.O"
  },
  "609609": {
    "state": "PUDUCHERRY",
    "district": "KARAIKAL",
    "office": "Kottuchery S.O"
  },
  "143602": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Fatehgarh Churian SO"
  },
  "143514": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Ghoman SO"
  },
  "143506": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Govt Poly Tech Batala SO"
  },
  "752060": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Bajpur S.O"
  },
  "638457": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Kurumandur SO"
  },
  "638458": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Nambiyur SO"
  },
  "638506": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Thuckanaickenpalayam SO"
  },
  "764036": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Semiliguda S.O"
  },
  "764014": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Narayanpatna S.O"
  },
  "764021": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Omp Line S.O"
  },
  "764038": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Padwa S.O (Koraput)"
  },
  "764039": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Pottangi S.O"
  },
  "442305": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Samudrapur S.O"
  },
  "413201": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Jamkhed S.O"
  },
  "323602": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Kesoraipatan Sugar Factoy S.O"
  },
  "323803": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Khatkar S.O"
  },
  "323603": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Lakheri S.O"
  },
  "323801": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Nainwan S.O"
  },
  "752022": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Kaluparaghat S.O"
  },
  "231314": {
    "state": "UTTAR PRADESH",
    "district": "MIRZAPUR",
    "office": "Jamua SO Mirzapur"
  },
  "231501": {
    "state": "UTTAR PRADESH",
    "district": "MIRZAPUR",
    "office": "Kachhwa SO Mirzapur"
  },
  "285223": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Kotra SO Jalaun"
  },
  "285130": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Madaripur SO"
  },
  "608302": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Komaratchi S.O"
  },
  "608201": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Orathur S.O"
  },
  "143513": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Kala Afgana SO"
  },
  "143518": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Naushera Majja Singh SO"
  },
  "143512": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Kalanaur SO Gurdaspur"
  },
  "143516": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Qadian SO"
  },
  "143515": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Srihargobindpur SO"
  },
  "143517": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Bhattian SO"
  },
  "143526": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Dorangla SO"
  },
  "143527": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Harchowal SO"
  },
  "313205": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Fatehnagar S.O (Udaipur)"
  },
  "313705": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Gogunda S.O"
  },
  "313026": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Intali Khera S.O"
  },
  "261501": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Behjam SO"
  },
  "262901": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Bhira SO Kheri"
  },
  "243601": {
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "office": "Police Line SO Budaun"
  },
  "243631": {
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "office": "Allapur SO"
  },
  "243632": {
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "office": "Asafpur SO"
  },
  "243633": {
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "office": "Bilsi SO"
  },
  "335065": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "Manaksar S.O"
  },
  "411045": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "N.I.A. S.O"
  },
  "414402": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Karjat S.O (Ahmed Nagar)"
  },
  "413204": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Kharda S.O"
  },
  "764063": {
    "state": "ODISHA",
    "district": "NABARANGPUR",
    "office": "Mirganiguda S.O"
  },
  "764059": {
    "state": "ODISHA",
    "district": "NABARANGPUR",
    "office": "Nabarangpur S.O"
  },
  "764071": {
    "state": "ODISHA",
    "district": "NABARANGPUR",
    "office": "Papadahandi S.O"
  },
  "764074": {
    "state": "ODISHA",
    "district": "NABARANGPUR",
    "office": "Raighar S.O"
  },
  "764070": {
    "state": "ODISHA",
    "district": "NABARANGPUR",
    "office": "Tentulikhunti S.O"
  },
  "764073": {
    "state": "ODISHA",
    "district": "NABARANGPUR",
    "office": "Umerkote S.O"
  },
  "143528": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Kahnuwan SO"
  },
  "622301": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Alangudi S.O"
  },
  "614617": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Ammapattinam S.O"
  },
  "754134": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "TYANDAKURA S.O"
  },
  "613701": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Ammayappan S.O"
  },
  "610101": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Kangalanchery S.O"
  },
  "610202": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Mavoor S.O (Tiruvarur)"
  },
  "642108": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Iyerpadi S.O"
  },
  "145022": {
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "office": "Dunera SO"
  },
  "342902": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Gotan S.O"
  },
  "341023": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Jael S.O"
  },
  "341518": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Jasnagar S.O"
  },
  "341028": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Khajwana S.O"
  },
  "341025": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Khinwsar S.O"
  },
  "142028": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Threeke SO"
  },
  "141118": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Dehlon SO"
  },
  "141419": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Ghudani Kalan SO"
  },
  "141204": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Ghungrana SO"
  },
  "303315": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Bewai SO"
  },
  "303501": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Bhandarej SO"
  },
  "752108": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Kakatpur"
  },
  "611110": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Tirupundi S.O"
  },
  "609703": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Tittachery S.O"
  },
  "611111": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Vailankanni S.O"
  },
  "611112": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Vettaikaraniruppu S.O"
  },
  "610201": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Kachanam S.O"
  },
  "632102": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Kaniyambadi S.O"
  },
  "643202": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Aruvankadu S.O"
  },
  "614208": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Sundaraperumalkoil S.O"
  },
  "612804": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Valangaman S.O"
  },
  "304507": {
    "state": "RAJASTHAN",
    "district": "TONK",
    "office": "Nasirda S.O"
  },
  "141417": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Rahawan SO"
  },
  "141123": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Ramgarh SO Ludhiana"
  },
  "606209": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Vellimalai S.O"
  },
  "141202": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Gujjarwal SO"
  },
  "627412": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Alwarkurichi SO"
  },
  "765026": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "Gudari S.O"
  },
  "765017": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "J.K.Pur Bazar S.O"
  },
  "443303": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Dongaon S.O"
  },
  "444312": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "G.S.College Khamgaon S.O"
  },
  "335037": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Lalgarh Jatan S.O"
  },
  "335001": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Mandi Sriganganagar S.O"
  },
  "335038": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Mirzewala S.O"
  },
  "335039": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Mukalawa S.O"
  },
  "335040": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Nizampura S.O"
  },
  "401107": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Mira S.O"
  },
  "401106": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Uttan S.O"
  },
  "624616": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Kallimandayam SO"
  },
  "624712": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Markkampatti SO"
  },
  "624618": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Narikalpatti SO"
  },
  "335041": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Padampur S.O"
  },
  "614703": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Kunnalur S.O"
  },
  "614704": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Mutupet S.O"
  },
  "614711": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Pamani TTP S.O"
  },
  "614706": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Udayamarthandapuram S.O"
  },
  "614715": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Vilakudi S.O"
  },
  "142041": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Bhinder SO Firozpur"
  },
  "614613": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Tamarankottai S.O"
  },
  "614628": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Tiruchitrambalam S.O"
  },
  "614614": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Tiruvonam S.O"
  },
  "614905": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Vadaseri S.O"
  },
  "614716": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Kattimodu S.O"
  },
  "444201": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Paturda S.O"
  },
  "444306": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Pimpalgaon Raja S.O"
  },
  "765021": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "Ambadola S.O"
  },
  "764062": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "Bikrampur S.O"
  },
  "765022": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "Marathiguda S.O"
  },
  "765016": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "K.Singhpur S.O"
  },
  "765015": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "Kashipur S.O"
  },
  "630306": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Kallupatti S.O (Sivaganga)"
  },
  "630106": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Kottaiyur S.O"
  },
  "142002": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Purana Moga SO"
  },
  "274808": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Chakara Gosai SO"
  },
  "274807": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "SANT VINOBA MARG SO"
  },
  "641021": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Coimbatore Industrial Estate SO"
  },
  "641105": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Madukkarai SO"
  },
  "641016": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Ondipudur SO"
  },
  "641032": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Othakkalmandapam SO"
  },
  "243720": {
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "office": "Bisauli SO"
  },
  "243635": {
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "office": "Dataganj SO"
  },
  "614714": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Takattur S.O"
  },
  "614712": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Talanayar Agraharam S.O"
  },
  "759020": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Balimi S.O"
  },
  "759015": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Bhapur S.O (Dhenkanal)"
  },
  "759017": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Bhuban S.O"
  },
  "759013": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Dhenkanal R S S.O"
  },
  "759025": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Gadasila S.O"
  },
  "759016": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Gondiapatna S.O"
  },
  "759022": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Hindol S.O"
  },
  "759018": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Kamakhyanagar S.O"
  },
  "632006": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Virudhambattu S.O"
  },
  "632107": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Guruvarajapalayam S.O"
  },
  "632013": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Konavattam S.O"
  },
  "632202": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Latteri S.O"
  },
  "632103": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Odugathur S.O"
  },
  "632009": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Sathuvachari Extension S.O"
  },
  "632059": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "TAMILNADU INDUSTRIAL EXPLOSIVES LTD"
  },
  "632002": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Thorapadi S.O"
  },
  "632105": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Ussoor S.O"
  },
  "632204": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Vaduganthangal S.O"
  },
  "643213": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Katary S.O"
  },
  "643216": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Kil Kotagiri S.O"
  },
  "444002": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Rpts Akola S.O"
  },
  "313701": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Phalasia S.O"
  },
  "313802": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Rishabhdeo S.O"
  },
  "313027": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Salumber S.O"
  },
  "313801": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Parsad S.O"
  },
  "643236": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Kotada Estate S.O"
  },
  "141415": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Jarg SO"
  },
  "141125": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Kakrala Kalan SO"
  },
  "141113": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Katani Kalan SO"
  },
  "141205": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Latala SO"
  },
  "141115": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Machhiwara SO"
  },
  "141203": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Narangwal SO"
  },
  "141418": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Rampur SO Ludhiana"
  },
  "141120": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Sanehwal SO"
  },
  "612301": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Pullabudangudi S.O"
  },
  "614210": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Valoothoor S.O"
  },
  "754142": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Paradip S.O"
  },
  "605751": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Ariyur S.O (Villupuram)"
  },
  "605802": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Kadambur S.O (Villupuram)"
  },
  "605766": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Santhapettai S.O"
  },
  "605759": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Manampoondi S.O"
  },
  "607204": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Tirunavalur S.O"
  },
  "606003": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Budamur S.O"
  },
  "606103": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Kammapuram S.O"
  },
  "754140": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Rahama S.O"
  },
  "754138": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Tiran S.O"
  },
  "754160": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Manijanga S.O"
  },
  "759028": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Kankadahad S.O"
  },
  "759014": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Mahimagadi S.O"
  },
  "759023": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Marthapur S.O"
  },
  "759024": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Mathakargola S.O"
  },
  "759039": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Badasuanlo S.O"
  },
  "607107": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Perangiyur S.O"
  },
  "605803": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Sithalingamadam S.O"
  },
  "627413": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Brahmadesam SO Tirunelveli"
  },
  "627415": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Kadayam SO"
  },
  "243505": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Shahi SO"
  },
  "209214": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Bidhnoo SO"
  },
  "603109": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Tirukalikundram SO"
  },
  "603311": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Zamin Endathur SO"
  },
  "603209": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Maraimalai Nagar SO"
  },
  "603002": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Gundurchengalpattu SO"
  },
  "285201": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Ait SO"
  },
  "414303": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Kanhur S.O"
  },
  "764037": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Nandapur S.O"
  },
  "759027": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Govindpur S.O (Dhenkanal)"
  },
  "759019": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Hindol Road R.S. S.O"
  },
  "759121": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Meramandali S.O"
  },
  "759029": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Mahabirod S.O"
  },
  "759120": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Parjang S.O"
  },
  "759021": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Rasol S.O"
  },
  "754132": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Raghunathpur S.O (Jagatsinghapur)"
  },
  "627602": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Pappagudi SO"
  },
  "627425": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Vickramasingapuram SO"
  },
  "627416": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Kallidaikurichi SO"
  },
  "627421": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Manimuthar Project SO"
  },
  "627601": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Mukkudal SO"
  },
  "627427": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Nalumukku SO"
  },
  "625531": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Theni S.O"
  },
  "625534": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Veerapandi S.O (Theni)"
  },
  "603406": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Uttiramerur S.O"
  },
  "631605": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Walajabad S.O"
  },
  "631601": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Ayyampettai S.O"
  },
  "603402": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Kaliyampoondi S.O"
  },
  "631552": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Karaipettai S.O"
  },
  "631606": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Palayaseevaram S.O"
  },
  "631604": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Thenneri S.O"
  },
  "602108": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Pannur S.O (Kanchipuram)"
  },
  "764003": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Prasadraopeta S.O"
  },
  "764027": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Bandhugam S.O"
  },
  "414701": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Kashti S.O"
  },
  "764086": {
    "state": "ODISHA",
    "district": "MALKANGIRI",
    "office": "Saradhapalli S.O"
  },
  "243634": {
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "office": "Binawar SO"
  },
  "160047": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Sector 47 Chandigarh SO"
  },
  "243723": {
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "office": "Islamnagar SO"
  },
  "243636": {
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "office": "Kachhla SO"
  },
  "243724": {
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "office": "Rudain SO"
  },
  "243638": {
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "office": "Sahaswan SO"
  },
  "326001": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Collectorate Jhalawar S.O"
  },
  "326033": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Aklera S.O"
  },
  "326021": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Asnawar S.O"
  },
  "326022": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Bakani S.O"
  },
  "326502": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Bhawanimandi S.O"
  },
  "326515": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Chaumahla S.O"
  },
  "326514": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Dag S.O"
  },
  "326516": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Gangdhar S.O"
  },
  "326039": {
    "state": "RAJASTHAN",
    "district": "JHALAWAR",
    "office": "Ghatoli S.O"
  },
  "243751": {
    "state": "UTTAR PRADESH",
    "district": "SAMBHAL",
    "office": "Babrala SO"
  },
  "285202": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Ata SO"
  },
  "285121": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Bangra SO"
  },
  "285203": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Baoni Estate SO"
  },
  "285122": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Dakore SO"
  },
  "285124": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Jagammanpur SO"
  },
  "285123": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Jalaun SO"
  },
  "314404": {
    "state": "RAJASTHAN",
    "district": "DUNGARPUR",
    "office": "Vikasnagar S.O (Dungarpur)"
  },
  "625706": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Tirumangalam SO"
  },
  "625301": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Alagarkoil SO"
  },
  "625020": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Ma Rajaji Hospital SO"
  },
  "625101": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Karungalakudi SO"
  },
  "625102": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Kilavalavu SO"
  },
  "625103": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Kottampatti SO"
  },
  "625014": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Madurai North SO"
  },
  "625105": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Melavlavu SO"
  },
  "625107": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Othakadai SO"
  },
  "625122": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Therkutheru SO"
  },
  "627453": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Pattamadai SO"
  },
  "627120": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Anuvijay Township SO"
  },
  "627423": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Pottalpudur SO"
  },
  "627424": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Ravanasamudram SO"
  },
  "605801": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Ariyalur (Villupuram) S.O"
  },
  "605754": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Manalurpet S.O"
  },
  "606110": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Karuvepilankurichi S.O"
  },
  "754137": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Tirtol S.O"
  },
  "605752": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Arakandanallur S.O"
  },
  "605701": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Kandachipuram S.O"
  },
  "605755": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Mogaiyur S.O"
  },
  "607209": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Periyasevalai S.O"
  },
  "607203": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Tiruvennainallur S.O"
  },
  "627417": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Karaikurichi SO Tirunelveli"
  },
  "627426": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Viravanallur SO"
  },
  "627351": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Burkitmanagaram SO"
  },
  "627112": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Samugarengapuram SO"
  },
  "627113": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Terkukallikulam SO"
  },
  "627114": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Terkukarungulam SO"
  },
  "627115": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Tirukurungudi SO"
  },
  "627657": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Tisayanvillai SO"
  },
  "627116": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Vadakangulam SO"
  },
  "627118": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Vijayanarayanam SO"
  },
  "627008": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Gandhinagar SO Tirunelveli"
  },
  "627352": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Gangaikondan SO"
  },
  "627201": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Manur SO"
  },
  "627007": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Perumalpuram SO"
  },
  "627359": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Rajavallipuram SO"
  },
  "627357": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Sankarnagar SO"
  },
  "627604": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Suttamally SO"
  },
  "627358": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Tachanallur SO"
  },
  "627101": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Dalapathisamudram SO"
  },
  "627102": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Dohnavur SO"
  },
  "627651": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Idayangudi SO"
  },
  "627117": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Vallioor Perundunilayam SO"
  },
  "335051": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Raisinghnagar S.O"
  },
  "625529": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Sindhupatti S.O"
  },
  "625532": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Usilampatti Pettai S.O"
  },
  "625537": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Uthappanayakanur S.O"
  },
  "143606": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Chetanpura SO"
  },
  "143105": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Chheharta SO"
  },
  "614612": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Perumagalur S.O"
  },
  "611101": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Adiakkamangalam S.O"
  },
  "609701": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Enangudi S.O"
  },
  "609605": {
    "state": "PUDUCHERRY",
    "district": "KARAIKAL",
    "office": "Thalatheru S.O"
  },
  "609606": {
    "state": "PUDUCHERRY",
    "district": "KARAIKAL",
    "office": "Tirumalairayanpattinam S.O"
  },
  "610003": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Kidarankondan S.O"
  },
  "614616": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Arantangi Fort S.O"
  },
  "614801": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Arasarkulam S.O"
  },
  "622201": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Arimalam S.O"
  },
  "614630": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Attani S.O"
  },
  "622501": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Cauvery Nagar S.O"
  },
  "613301": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Ghandarvakottai S.O"
  },
  "622302": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Karambakudi S.O"
  },
  "609003": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Mayiladuthurai R.S S.O"
  },
  "609203": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Nidur S.O"
  },
  "609307": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Porayar S.O"
  },
  "609308": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Sankaranpandal S.O"
  },
  "609118": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Solasakkaranallur S.O"
  },
  "609313": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Tarangambadi S.O"
  },
  "609102": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Anaikaranchatram S.O"
  },
  "609104": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Kadavasal S.O"
  },
  "609105": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Kaveripattinam S.O (Nagapattinam)"
  },
  "609106": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Mangamadam S.O"
  },
  "609108": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Puthur (SRK) S.O"
  },
  "609114": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Tiruvengadu S.O"
  },
  "609117": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Vaithiswarankoil S.O"
  },
  "627010": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Industrial Colony Pettai SO"
  },
  "305629": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Champaneri S.O"
  },
  "614707": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Ayakkarambalam Ii Sethi S.O"
  },
  "614806": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Kariyapattinam S.O"
  },
  "614808": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Kuruvapulam S.O"
  },
  "614809": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Topputhurai S.O"
  },
  "614702": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Idaiyur S.O"
  },
  "144507": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Mokandpur SO"
  },
  "335703": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Ramsinghpur S.O"
  },
  "625108": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Thumbaipatti SO"
  },
  "625110": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Tiruvadur SO"
  },
  "332708": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Kanwat Town SO"
  },
  "335061": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Ridmalsar S.O"
  },
  "335062": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Sadulshahar S.O"
  },
  "335704": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Sribijaynagar S.O"
  },
  "625536": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "T.Subbulapuram S.O"
  },
  "625605": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Tamarakulam S.O"
  },
  "625603": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Vadugapatti S.O"
  },
  "625562": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Varadharajnagar S.O"
  },
  "143504": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Chawinda Devi SO"
  },
  "609115": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Varisapathu Vadagal S.O"
  },
  "609601": {
    "state": "PUDUCHERRY",
    "district": "KARAIKAL",
    "office": "Ambagarathur S.O"
  },
  "609602": {
    "state": "PUDUCHERRY",
    "district": "KARAIKAL",
    "office": "Karaikal S.O"
  },
  "614624": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Keeramangalam S.O"
  },
  "622202": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Kilanilai S.O"
  },
  "622401": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Koppanapatti S.O"
  },
  "614619": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Kottaipattinam S.O"
  },
  "622504": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Kulathur S.O (Pudukkottai)"
  },
  "622402": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Kulipirai S.O"
  },
  "622515": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Mathur Ind. Estate S.O"
  },
  "614621": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Mimisal S.O"
  },
  "622103": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Muckanamalaipatti S.O"
  },
  "622404": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Nachandupatti S.O"
  },
  "625006": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Tirunagar SO"
  },
  "625707": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Villur SO"
  },
  "625017": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Anaiyur SO"
  },
  "625009": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Ma Munichalai Road SO"
  },
  "625104": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Madurai Agricultural College SO"
  },
  "625106": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Karuthapuliyanpatti SO"
  },
  "625201": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Silaiman SO"
  },
  "625109": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Vellalur SO"
  },
  "628701": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Anandapuram S.O (Tuticorin)"
  },
  "628801": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Eral S.O"
  },
  "628653": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Kommadikottai S.O"
  },
  "628616": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Mukuperi S.O"
  },
  "628619": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Padmanabamangalam S.O"
  },
  "152113": {
    "state": "PUNJAB",
    "district": "SRI MUKTSAR SAHIB",
    "office": "Lambi SO"
  },
  "625535": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Yelumalai S.O"
  },
  "625527": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Sedapatti S.O"
  },
  "416004": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Shivaji University S.O"
  },
  "152107": {
    "state": "PUNJAB",
    "district": "SRI MUKTSAR SAHIB",
    "office": "Malout SO"
  },
  "152026": {
    "state": "PUNJAB",
    "district": "SRI MUKTSAR SAHIB",
    "office": "Muktsar SO"
  },
  "151207": {
    "state": "PUNJAB",
    "district": "FARIDKOT",
    "office": "Panj Grain Kalan SO"
  },
  "152032": {
    "state": "PUNJAB",
    "district": "SRI MUKTSAR SAHIB",
    "office": "Rupana SO"
  },
  "152114": {
    "state": "PUNJAB",
    "district": "SRI MUKTSAR SAHIB",
    "office": "Tappa Khera SO"
  },
  "628703": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Padukkapathu S.O"
  },
  "332710": {
    "state": "RAJASTHAN",
    "district": "SIKAR",
    "office": "Khachariawas SO"
  },
  "285204": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Kalpi SO"
  },
  "636013": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Salem Steel Plant S.O"
  },
  "335073": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Srikaranpur S.O"
  },
  "335705": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Sardargarh S.O"
  },
  "335804": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Suratgarh S.O"
  },
  "401304": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Nirmal S.O (Thane)"
  },
  "401207": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Papdi S.O"
  },
  "210341": {
    "state": "UTTAR PRADESH",
    "district": "HAMIRPUR",
    "office": "Ingohta SO"
  },
  "629703": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Kottaram S.O"
  },
  "629402": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Marungoor S.O"
  },
  "629803": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Neyyoor West S.O"
  },
  "629804": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Thickanamcode S.O"
  },
  "629162": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Kappukadu S.O"
  },
  "622203": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Perungalur S.O"
  },
  "622005": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Pudukkottai Collectorate S.O"
  },
  "305201": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Govind Garh S.O"
  },
  "243123": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "PACDso SO"
  },
  "243303": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Ram Nagar SO Bareilly"
  },
  "622505": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Ramachandrapuram S.O (Pudukkottai)"
  },
  "243722": {
    "state": "UTTAR PRADESH",
    "district": "SAMBHAL",
    "office": "Gunnaur SO"
  },
  "243727": {
    "state": "UTTAR PRADESH",
    "district": "SAMBHAL",
    "office": "Rajpura SO Budaun"
  },
  "643221": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Melur Nilgiris S.O"
  },
  "632007": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Katpadi S.O"
  },
  "632058": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Pennathur S.O"
  },
  "632106": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "S.L.R. Sanatorium S.O"
  },
  "632014": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Vellore Institute Of Technology S.O"
  },
  "632104": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Virinjipuram S.O"
  },
  "210423": {
    "state": "UTTAR PRADESH",
    "district": "MAHOBA",
    "office": "Jaitpur SO Mahoba"
  },
  "210424": {
    "state": "UTTAR PRADESH",
    "district": "MAHOBA",
    "office": "Kabrai SO"
  },
  "210504": {
    "state": "UTTAR PRADESH",
    "district": "MAHOBA",
    "office": "Khanna SO"
  },
  "210425": {
    "state": "UTTAR PRADESH",
    "district": "MAHOBA",
    "office": "Kharela SO"
  },
  "210505": {
    "state": "UTTAR PRADESH",
    "district": "HAMIRPUR",
    "office": "Kurara SO"
  },
  "210427": {
    "state": "UTTAR PRADESH",
    "district": "MAHOBA",
    "office": "Mahoba SO"
  },
  "608502": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Parangipettai S.O"
  },
  "151212": {
    "state": "PUNJAB",
    "district": "FARIDKOT",
    "office": "Sadiq SO"
  },
  "630107": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Pallattur S.O"
  },
  "307022": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Pindwara S.O"
  },
  "307028": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Posalia S.O"
  },
  "307514": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Reodar S.O"
  },
  "307510": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Shantivan S.O"
  },
  "335805": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "STPS Suratgarh S.O"
  },
  "335002": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Udyog Vihar S.O"
  },
  "630312": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Puliyal S.O"
  },
  "630104": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Kandanur S.O"
  },
  "630205": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Kilasevalpatti S.O"
  },
  "285128": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Hadrukh SO"
  },
  "629809": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Karankad S.O"
  },
  "629154": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Kanjampuram S.O"
  },
  "607403": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "Kirumambakkam"
  },
  "629175": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Padmanabhapuram Fort S.O"
  },
  "641035": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Saravanampatti SO"
  },
  "641107": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Sarkarsamakulam SO"
  },
  "641028": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Sowripalayam SO"
  },
  "641110": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Vaiyampalayam SO"
  },
  "641112": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Amritanagar SO"
  },
  "641048": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Kalapatti SO"
  },
  "641023": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Podanur SO"
  },
  "641062": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Sinniampalayam SO"
  },
  "641101": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Alandurai SO"
  },
  "641019": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Coimbatore Press Colony SO"
  },
  "641114": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Karunyanagar SO"
  },
  "641031": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Narasimhanaickenpalayam SO"
  },
  "641010": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Perur SO Coimbatore"
  },
  "764055": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Ambaguda S.O"
  },
  "641007": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "SBInstitute SO"
  },
  "641109": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Thondamuthur SO"
  },
  "635301": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Bommidi S.O"
  },
  "635302": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Buddireddipatti S.O"
  },
  "635201": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Barur S.O"
  },
  "231212": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Amwar SO"
  },
  "414601": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Jeur S.O (Ahmed Nagar)"
  },
  "307024": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Rohida S.O"
  },
  "765023": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "Kujendri S.O"
  },
  "222135": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Gulzarganj SO"
  },
  "222136": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Jalalpur SO Jaunpur"
  },
  "632114": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Sathyamangalam (Vellore)S.O"
  },
  "632011": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "T.B. Sanatorium S.O"
  },
  "303003": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Med SO"
  },
  "303805": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Morija SO"
  },
  "303105": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Nareda SO"
  },
  "303106": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "PaotaJaipur SO"
  },
  "303107": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Pragpura SO"
  },
  "303110": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Rajnauta SO"
  },
  "311301": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Asind S.O"
  },
  "311302": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Badnore S.O"
  },
  "632502": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Anvardhikhanpet SO"
  },
  "632505": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Banavaram SO"
  },
  "631004": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Ekhunagar SO"
  },
  "629171": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Pudukadai S.O"
  },
  "629172": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "S.T.Mankad S.O"
  },
  "611102": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Andanapettai S.O"
  },
  "306306": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Chandawal S.O"
  },
  "622101": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Annavasal S.O"
  },
  "622102": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Illuppur S.O"
  },
  "609001": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Mayiladuthurai South S.O"
  },
  "609309": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Sembanarkoil S.O"
  },
  "609312": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Tirukkalachery S.O"
  },
  "609314": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Vadakarai S.O (Nagapattinam)"
  },
  "609101": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Achalpuram S.O"
  },
  "632520": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Melpadi SO"
  },
  "632510": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Minnal SO"
  },
  "631051": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Namali SO"
  },
  "631052": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Panapakkam SO"
  },
  "632514": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Ponnai SO"
  },
  "203412": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Siyana SO"
  },
  "203398": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Uncha Gaon SO"
  },
  "203131": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Khurja HO"
  },
  "203397": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Chhatary SO"
  },
  "203392": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Danpur SO Bulandshahr"
  },
  "203393": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Debai SO"
  },
  "262903": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Nighasan SO"
  },
  "262725": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Oel SO Kheri"
  },
  "609201": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Ilanthope S.O"
  },
  "609107": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Melaiyur TVG S.O"
  },
  "609109": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Sattanathapuram S.O"
  },
  "609111": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Sirkali Thenpathi S.O"
  },
  "609113": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Tirumullaivasal S.O"
  },
  "609112": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Tirupungur S.O"
  },
  "305404": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Kekri S.O"
  },
  "305628": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Nagola S.O"
  },
  "305407": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Sawar S.O"
  },
  "311402": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Bagore S.O"
  },
  "311401": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Banera S.O"
  },
  "311601": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Bigod S.O"
  },
  "311602": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Bijolian S.O"
  },
  "630101": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Attangudi S.O"
  },
  "630105": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Kothamangalam S.O (Sivaganga)"
  },
  "630314": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Shanmuganathapuram S.O"
  },
  "627011": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Palayankottai High Grounds SO"
  },
  "627012": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Manonmaniam Sundaranar Univers SO"
  },
  "627001": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Viraraghavapuram SO"
  },
  "613601": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Alakkudi S.O"
  },
  "630554": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Mangalam SO Sivaganga"
  },
  "630709": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Pudur Ilayangudi SO"
  },
  "630609": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Rajagambiram SO"
  },
  "630710": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Salaigramam SO"
  },
  "307023": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Sarupganj S.O"
  },
  "307027": {
    "state": "RAJASTHAN",
    "district": "SIROHI",
    "office": "Sheoganj S.O (Sirohi)"
  },
  "609205": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Tiruvalaputhur S.O"
  },
  "609116": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Valluvakudi S.O"
  },
  "203129": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Karora SO"
  },
  "203132": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Khurja  Jn  RS SO"
  },
  "203396": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Pahasu SO"
  },
  "203399": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Ramghat SO Bulandshahr"
  },
  "212307": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Khain SO"
  },
  "212306": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Koraon SO"
  },
  "212208": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Manauri SO"
  },
  "203002": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "AgSchool SO"
  },
  "203390": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Anupshahr SO"
  },
  "203402": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Bb  Nagar SO"
  },
  "203403": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Bugrasi SO"
  },
  "203408": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Gulaothi SO"
  },
  "203206": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Industrial Estate Sikandrabad SO"
  },
  "203394": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Jahangirabad SO Bulandshahr"
  },
  "614807": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Kodiakkarai S.O"
  },
  "614810": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Vedaraniam S.O"
  },
  "335512": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "Hanumangarh Jn. Court S.O"
  },
  "144029": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Moron SO"
  },
  "222002": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Pukhta Sarai SO"
  },
  "222138": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Kajgaon SO Jaunpur"
  },
  "222142": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Kerakat SO"
  },
  "637019": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Sellappampatti S.O"
  },
  "637411": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Semmedu S.O"
  },
  "605402": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Kedar SO"
  },
  "605103": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Koliyanur SO"
  },
  "605302": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Mambazhapattu SO"
  },
  "605601": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Mundiyambakkam SO"
  },
  "605107": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Pallineliyanur SO"
  },
  "605651": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Periyathatchur SO"
  },
  "605108": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Valavanur SO"
  },
  "608704": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Pinnalur S.O"
  },
  "151209": {
    "state": "PUNJAB",
    "district": "FARIDKOT",
    "office": "Sandhwan SO"
  },
  "630001": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Muthupatnam S.O"
  },
  "628612": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Alwartirunagari S.O"
  },
  "628613": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Asirvathapuram S.O"
  },
  "303104": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Manoharpur SO Jaipur"
  },
  "250611": {
    "state": "UTTAR PRADESH",
    "district": "BAGHPAT",
    "office": "Nai Mandi Baraut SO"
  },
  "250601": {
    "state": "UTTAR PRADESH",
    "district": "BAGHPAT",
    "office": "Agarwal Mandi SO"
  },
  "250606": {
    "state": "UTTAR PRADESH",
    "district": "BAGHPAT",
    "office": "Aminagar Sarai SO"
  },
  "250620": {
    "state": "UTTAR PRADESH",
    "district": "BAGHPAT",
    "office": "Bamnauli SO"
  },
  "250345": {
    "state": "UTTAR PRADESH",
    "district": "BAGHPAT",
    "office": "Binauli SO"
  },
  "250617": {
    "state": "UTTAR PRADESH",
    "district": "BAGHPAT",
    "office": "Chhaprauli SO"
  },
  "638054": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Siruvalur SO"
  },
  "638055": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Tingalur SO"
  },
  "203405": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Khanpur SO Bulandshahr"
  },
  "203391": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "KSC Mill  Anupshahr SO"
  },
  "203407": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Lakhaoti SO"
  },
  "641201": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Chettipalayam SO"
  },
  "641006": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Ganapathy SO"
  },
  "641029": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Gnanambika Mills SO"
  },
  "641047": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Jothipuram SO"
  },
  "203201": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Dankaur SO"
  },
  "203202": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Gurukul  Sikandrabad SO"
  },
  "203141": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Jahangirpur SO"
  },
  "203135": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Jewar SO"
  },
  "203203": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Kakore SO"
  },
  "203155": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Thora SO"
  },
  "641111": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Vellalore SO"
  },
  "641046": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Bharathiyar University SO"
  },
  "641030": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Kavundampalayam Colony SO"
  },
  "641020": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Sri Ramakrishna Vidyalaya SO"
  },
  "641108": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Tadagam SO"
  },
  "203411": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Saidpur SO Bulandshahr"
  },
  "203205": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Sikandrabad SO Bulandshahr"
  },
  "271201": {
    "state": "UTTAR PRADESH",
    "district": "BALRAMPUR",
    "office": "Balrampur Degree College SO"
  },
  "631003": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Jothinagar SO"
  },
  "632531": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Ocheri SO"
  },
  "631002": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Palanipet SO"
  },
  "636704": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Annasagaram S.O"
  },
  "605756": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Thapovanam S.O"
  },
  "271821": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Bisheswarganj SO"
  },
  "614203": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Kabistalam S.O"
  },
  "614204": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Pandaravadai S.O"
  },
  "614206": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Pasupathikoil S.O"
  },
  "630559": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Periakottai SO"
  },
  "250615": {
    "state": "UTTAR PRADESH",
    "district": "BAGHPAT",
    "office": "Dhikauli SO"
  },
  "250622": {
    "state": "UTTAR PRADESH",
    "district": "BAGHPAT",
    "office": "Doghat SO"
  },
  "250101": {
    "state": "UTTAR PRADESH",
    "district": "BAGHPAT",
    "office": "Rly Road Khekra SO"
  },
  "250625": {
    "state": "UTTAR PRADESH",
    "district": "BAGHPAT",
    "office": "Tikri SO"
  },
  "303511": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Didwana SO"
  },
  "303304": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Dubbi SO"
  },
  "303502": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Geejgarh SO"
  },
  "303323": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Gudha Katla SO"
  },
  "322240": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Kherla SO"
  },
  "303325": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Kundal SO Dausa"
  },
  "303503": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Lalsot SO"
  },
  "303004": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Lawain SO"
  },
  "321609": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Mahwa Road SO"
  },
  "321608": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Mahwa SO"
  },
  "603003": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Vallam SO"
  },
  "638313": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Kugalur SO"
  },
  "303504": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Mandawari SO"
  },
  "764042": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Onukadeli S.O"
  },
  "636813": {
    "state": "TAMIL NADU",
    "district": "DHARMAPURI",
    "office": "Biliyanur Agraharam S.O"
  },
  "228171": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Akhandnagar SO"
  },
  "203209": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Rabupura SO"
  },
  "203389": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Narora SO"
  },
  "629176": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Thuthur S.O"
  },
  "629178": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Udayamarthandam S.O"
  },
  "621220": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Thoramangalam S.O"
  },
  "151211": {
    "state": "PUNJAB",
    "district": "SRI MUKTSAR SAHIB",
    "office": "Mandi Killianwali SO"
  },
  "152112": {
    "state": "PUNJAB",
    "district": "SRI MUKTSAR SAHIB",
    "office": "Ram Nagar SO Muktsar"
  },
  "608304": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Reddiyur S.O"
  },
  "608702": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Sethiathope S.O"
  },
  "608305": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "T.Nedunjeri S.O"
  },
  "607101": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Anathur S.O"
  },
  "607003": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Cuddalore Port S.O"
  },
  "607103": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Kadambuliyur S.O"
  },
  "601201": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Gummidipundi SO"
  },
  "600053": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Prithivipakkam SO"
  },
  "601203": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Minjur SO"
  },
  "600120": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "North Chennai Thermal PP SO"
  },
  "601205": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Pulicat SO"
  },
  "600052": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Padianallur SO"
  },
  "600067": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Sholavaram SO"
  },
  "610104": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Manakkal Ayyampet S.O"
  },
  "609403": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Kollumangudi S.O"
  },
  "222161": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Mariahun Bazar SO"
  },
  "222165": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Meerganj SO Jaunpur"
  },
  "222170": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Muftiganj SO"
  },
  "222202": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Mungra Badshahpur SO"
  },
  "222109": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Naupedwa SO"
  },
  "223102": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Patti Narendra SO"
  },
  "222003": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Purvanchal Vishwa Vidyalaya SO"
  },
  "222105": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Ramdayalganj SO"
  },
  "222203": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Rampur SO Jaunpur"
  },
  "203401": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Aurangabad SO Bulandshahr"
  },
  "212213": {
    "state": "UTTAR PRADESH",
    "district": "KAUSHAMBI",
    "office": "Mahgaon SO"
  },
  "609503": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Punthottam S.O"
  },
  "609405": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Peralam S.O"
  },
  "622502": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Keeranur S.O"
  },
  "622209": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Kilanilaikottai S.O"
  },
  "622503": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Konapet S.O"
  },
  "614629": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Ponbethi S.O"
  },
  "639202": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Chinnadharapuram S.O"
  },
  "614622": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Silattur S.O"
  },
  "614805": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Subramaniapuram S.O (Pudukkottai)"
  },
  "614618": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Tirupperunthurai S.O"
  },
  "210428": {
    "state": "UTTAR PRADESH",
    "district": "HAMIRPUR",
    "office": "Majhagawan SO"
  },
  "210506": {
    "state": "UTTAR PRADESH",
    "district": "HAMIRPUR",
    "office": "Muskara SO"
  },
  "210429": {
    "state": "UTTAR PRADESH",
    "district": "MAHOBA",
    "office": "Panwari SO"
  },
  "210422": {
    "state": "UTTAR PRADESH",
    "district": "HAMIRPUR",
    "office": "Jaria SO Hamirpur"
  },
  "622303": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Tiruvarankulam S.O"
  },
  "622304": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Vadakadu S.O"
  },
  "622411": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Valayapatti S.O (Pudukkottai)"
  },
  "622104": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Vayalogam S.O"
  },
  "621316": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Viralimalai S.O"
  },
  "306105": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Bar S.O"
  },
  "306709": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Dlf Rabriyawas S.O"
  },
  "306422": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Gundoj S.O"
  },
  "639136": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Kagtithapuram S.O"
  },
  "639109": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Moolapatti S.O"
  },
  "621307": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Manjampatti S.O"
  },
  "639108": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Mayanur S.O"
  },
  "639110": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Nungavaram S.O"
  },
  "222141": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Saraiharakhu SO"
  },
  "223101": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Shahganj SO Jaunpur"
  },
  "627414": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Cheranmahadevi SO"
  },
  "627418": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Kila Ambur SO"
  },
  "614403": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Kovilvenni S.O"
  },
  "754133": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Tarpur S.O"
  },
  "621308": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Palakurichi S.O"
  },
  "639119": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Panjapatti S.O"
  },
  "243637": {
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "office": "Kakrala SO"
  },
  "224122": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Bus Station Akbarpur SO"
  },
  "262902": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Pallia SO"
  },
  "262904": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Sampurna Nagar SO"
  },
  "262907": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Semra SO Kheri"
  },
  "262805": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Sikandrabad SO Kheri"
  },
  "262906": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Tikunia SO"
  },
  "242021": {
    "state": "UTTAR PRADESH",
    "district": "SAMBHAL",
    "office": "IA Babrala SO"
  },
  "212651": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Husainganj SO Fatehpur"
  },
  "212654": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Jamraon SO"
  },
  "212655": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Khaga Town SO"
  },
  "212657": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Khajuha SO"
  },
  "212656": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Khakhreru SO"
  },
  "212658": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Kishanpur SO Fatehpur"
  },
  "250609": {
    "state": "UTTAR PRADESH",
    "district": "BAGHPAT",
    "office": "Baghpat SO"
  },
  "250621": {
    "state": "UTTAR PRADESH",
    "district": "BAGHPAT",
    "office": "Baoli SO"
  },
  "250623": {
    "state": "UTTAR PRADESH",
    "district": "BAGHPAT",
    "office": "Kishanpur Baral SO"
  },
  "607112": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Kilkavarappattu S.O"
  },
  "607301": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Kullanchavadi S.O"
  },
  "607302": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Kurinjipadi S.O"
  },
  "607104": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Melpattambakkam S.O"
  },
  "607105": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Nellikkuppam S.O"
  },
  "311801": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Gangapur (Bhilwara) S.O"
  },
  "621310": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Puthanatham S.O"
  },
  "621311": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Tharagampatti S.O"
  },
  "612901": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Gangaikondacholapuram SO"
  },
  "621802": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Jayamkondacholapuram SO"
  },
  "621653": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Kallagam SO"
  },
  "621651": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Kallakudi TR SO"
  },
  "621705": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Kallankurichi SO"
  },
  "621803": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Kallathur Thandalai SO"
  },
  "621706": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Kattur Puvalur SO"
  },
  "608901": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Kavarapalayam SO"
  },
  "621707": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Kilapaluvur SO"
  },
  "612902": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Kodalikaruppur SO"
  },
  "203409": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Sarai  Chhabila SO"
  },
  "203150": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Shahkarinagar SO"
  },
  "203395": {
    "state": "UTTAR PRADESH",
    "district": "BULANDSHAHR",
    "office": "Shikarpur SO Bulandshahr"
  },
  "210426": {
    "state": "UTTAR PRADESH",
    "district": "MAHOBA",
    "office": "Kulpahar SO"
  },
  "210507": {
    "state": "UTTAR PRADESH",
    "district": "HAMIRPUR",
    "office": "Ragaul SO"
  },
  "621709": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Mathur SO Ariyalur"
  },
  "612903": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Minsuritti SO"
  },
  "621710": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Ponparappi SO"
  },
  "621711": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Pullambadi SO"
  },
  "621712": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Puvalur SO"
  },
  "621718": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Rayambaram SO"
  },
  "621714": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Sendurai SO Ariyalur"
  },
  "612904": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Thathampettai Palur SO"
  },
  "621851": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Thirumazhapadi SO"
  },
  "621715": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Tirumanur SO"
  },
  "621804": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Udayarpalayam SO Ariyalur"
  },
  "621218": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Valady SO"
  },
  "621805": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Varadarajampettai SO"
  },
  "621806": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Variyankaval SO"
  },
  "621722": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Viragalur SO"
  },
  "610103": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Mangudi S.O"
  },
  "639201": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Aravakurichi S.O"
  },
  "311021": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Gulabpura S.O"
  },
  "851101": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Begusarai HO"
  },
  "781037": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Panjabari S.O"
  },
  "781008": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Paltanbazar S.O"
  },
  "781007": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Lachitnagar S.O"
  },
  "208021": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Naubasta SO"
  },
  "607106": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Panruti S.O"
  },
  "607108": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Puthupet (CDL) S.O"
  },
  "607205": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Tiruthuraiyur S.O"
  },
  "607004": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Vandipalayam S.O"
  },
  "607109": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Varakalpattu S.O"
  },
  "212659": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Kora Jahanabad SO"
  },
  "212665": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Mauhar SO"
  },
  "209206": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Ghatampur SO"
  },
  "209307": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR DEHAT",
    "office": "BHAUPUR"
  },
  "784010": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Tezpur Medical College S.O"
  },
  "784001": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Tezpur H.O"
  },
  "222131": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Sikrara SO"
  },
  "222175": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Singramau SO"
  },
  "222145": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Mahraj Ganj SO"
  },
  "222204": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Nibhapur SO"
  },
  "222149": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Sgrd College Dobhi SO"
  },
  "223105": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Soithakalan SO"
  },
  "605758": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Virapandi S.O"
  },
  "142034": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Manuke SO"
  },
  "141105": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Sarabha SO"
  },
  "639107": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Marudur S.O"
  },
  "632519": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Vellore Sugar Mills SO"
  },
  "231302": {
    "state": "UTTAR PRADESH",
    "district": "MIRZAPUR",
    "office": "Adalhat SO"
  },
  "231301": {
    "state": "UTTAR PRADESH",
    "district": "MIRZAPUR",
    "office": "Ahraura SO"
  },
  "784028": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Napaam S.O"
  },
  "751024": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "K I I T S.O"
  },
  "624617": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "KeeranurMA SO"
  },
  "141413": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Dhamote SO"
  },
  "141122": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Jaspal Banger SO"
  },
  "305403": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Sarwar S.O"
  },
  "243407": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Senthal SO"
  },
  "628702": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Mudalur S.O"
  },
  "628617": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Nazareth S.O"
  },
  "628751": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Pannaivilai S.O"
  },
  "628620": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Patemanagaram S.O"
  },
  "608703": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Srimushnam S.O"
  },
  "608401": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Vallampadugai S.O"
  },
  "608801": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Alapakkam S.O"
  },
  "246726": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Haldaur SO"
  },
  "246728": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Jhalu SO"
  },
  "244715": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Ramnagar SO Nainital"
  },
  "244713": {
    "state": "UTTARAKHAND",
    "district": "UDAM SINGH NAGAR",
    "office": "Kila Street SO"
  },
  "263148": {
    "state": "UTTARAKHAND",
    "district": "UDAM SINGH NAGAR",
    "office": "Kichha SO"
  },
  "263153": {
    "state": "UTTARAKHAND",
    "district": "UDAM SINGH NAGAR",
    "office": "COLLECTORATE PARISAR SO"
  },
  "262405": {
    "state": "UTTARAKHAND",
    "district": "UDAM SINGH NAGAR",
    "office": "Sittarganj SO"
  },
  "263145": {
    "state": "UTTARAKHAND",
    "district": "UDAM SINGH NAGAR",
    "office": "Pantnagar SO"
  },
  "212207": {
    "state": "UTTAR PRADESH",
    "district": "KAUSHAMBI",
    "office": "Manjhanpur SO"
  },
  "212214": {
    "state": "UTTAR PRADESH",
    "district": "KAUSHAMBI",
    "office": "Pashchim Sarira SO"
  },
  "212216": {
    "state": "UTTAR PRADESH",
    "district": "KAUSHAMBI",
    "office": "Sarai Akil SO"
  },
  "212217": {
    "state": "UTTAR PRADESH",
    "district": "KAUSHAMBI",
    "office": "Sirathu SO"
  },
  "212303": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Meja Road SO"
  },
  "212302": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Meja SO"
  },
  "274308": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Padrauna City SO"
  },
  "212108": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Shankargarh SO"
  },
  "212305": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Sirsa SO"
  },
  "607102": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Chinnapanaickenpalayam S.O"
  },
  "607401": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Tiruvendhipuram S.O"
  },
  "607303": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Vadalur S.O"
  },
  "311805": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Koshithal S.O"
  },
  "641026": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Komarapalayam Coimbatore SO"
  },
  "641022": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "NGGO Colony SO"
  },
  "641017": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Vadamadurai Kurudampalayam SO"
  },
  "641025": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Velandipalayam SO"
  },
  "621730": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Cement Nagar Dalavoy SO"
  },
  "262726": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Sharda Nagar SO"
  },
  "262905": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Singahi SO"
  },
  "622403": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Melasivapuri S.O"
  },
  "341542": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "I.A.Bidiad S.O"
  },
  "143532": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Behrampur SO"
  },
  "143519": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Dhariwal SO"
  },
  "143531": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Dinanagar SO"
  },
  "143533": {
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "office": "Gharota SO"
  },
  "621713": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Rajajinagar SO Ariyalur"
  },
  "622407": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Ponnamaravathy S.O"
  },
  "622004": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Pudukkottai Ind. Estate S.O"
  },
  "622003": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Rajagopalapuram S.O"
  },
  "622409": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Rangiem S.O"
  },
  "622422": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Sivapuram S.O"
  },
  "622002": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Tirugokarnam S.O"
  },
  "622412": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Virachilai S.O"
  },
  "246149": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Kotdwara Railway Station SO"
  },
  "244414": {
    "state": "UTTAR PRADESH",
    "district": "SAMBHAL",
    "office": "Narauli SO"
  },
  "244302": {
    "state": "UTTAR PRADESH",
    "district": "SAMBHAL",
    "office": "Sambhal SO"
  },
  "244301": {
    "state": "UTTAR PRADESH",
    "district": "SAMBHAL",
    "office": "Sirsi SO Moradabad"
  },
  "328022": {
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "office": "Baseri SO"
  },
  "244402": {
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "office": "Pipalsana RS SO"
  },
  "244601": {
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "office": "Thakurdwara SO"
  },
  "244901": {
    "state": "UTTAR PRADESH",
    "district": "RAMPUR",
    "office": "Islam Ganj SO"
  },
  "244921": {
    "state": "UTTAR PRADESH",
    "district": "RAMPUR",
    "office": "Bilaspur Rampur SO"
  },
  "244923": {
    "state": "UTTAR PRADESH",
    "district": "RAMPUR",
    "office": "Bilaspur Chini Mill SO"
  },
  "244701": {
    "state": "UTTAR PRADESH",
    "district": "RAMPUR",
    "office": "Milak SO"
  },
  "244927": {
    "state": "UTTAR PRADESH",
    "district": "RAMPUR",
    "office": "Said Nagar SO"
  },
  "244922": {
    "state": "UTTAR PRADESH",
    "district": "RAMPUR",
    "office": "Shahbad SO Rampur"
  },
  "603004": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Mahindra World City SO Kanchipuram"
  },
  "284126": {
    "state": "UTTAR PRADESH",
    "district": "LALITPUR",
    "office": "Talbehat SO"
  },
  "622204": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Yembal S.O"
  },
  "609202": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Manalmedu S.O"
  },
  "609404": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Manganallur Bazaar S.O"
  },
  "211010": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "T S L SO"
  },
  "229411": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Anapur SO"
  },
  "229412": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Atrampur SO"
  },
  "221502": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Baraut SO"
  },
  "211019": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Jhunsi SO"
  },
  "229413": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Lalgopal Ganj SO"
  },
  "212507": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Mau Aima SO"
  },
  "211013": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Phaphamau SO"
  },
  "212402": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Phoolpur SO"
  },
  "221507": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Sahson SO"
  },
  "621101": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Puduattur B.O"
  },
  "202143": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Somna SO"
  },
  "202165": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Tappal SO"
  },
  "605105": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Mokshakulam SO"
  },
  "602106": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Sunguvarchatram S.O"
  },
  "305812": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Harmara S.O"
  },
  "303012": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Kanota SO"
  },
  "741122": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Bagchi Jamsherpur SO"
  },
  "605502": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Valudavur SO"
  },
  "605652": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Vikravandi SO"
  },
  "233232": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Goshandepur SO"
  },
  "275203": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Jakhania SO"
  },
  "232339": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Karahiya SO"
  },
  "233224": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Karanda SO"
  },
  "233225": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Karimuddinpur SO"
  },
  "233233": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Khardiha SO"
  },
  "233310": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Malikpura SO"
  },
  "233226": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Mardah SO"
  },
  "233227": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Yusufpur Bazar SO"
  },
  "233301": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Mubarakpur SO Ghazipur"
  },
  "233302": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Nandganj SO"
  },
  "233303": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Nonhara SO"
  },
  "233311": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "NSS Mill SO"
  },
  "233002": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Peernagar SO"
  },
  "233223": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Rampur SO Ghazipur"
  },
  "232328": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Reotipur SO"
  },
  "233230": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Kasimabad SO"
  },
  "275204": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Sadat SO"
  },
  "246731": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Kiratpur SO"
  },
  "243504": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Meerganj SO Bareilly"
  },
  "262406": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Nawabganj SO Bareilly"
  },
  "246729": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Chandpur Sugar Factory SO"
  },
  "222180": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Zafarabad SO"
  },
  "222181": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Thanagaddi SO"
  },
  "742163": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Saktipur SO"
  },
  "742401": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Salar SO"
  },
  "742201": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Aurangabad SO Murshidabad"
  },
  "742122": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Azimganj SO"
  },
  "742235": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Barala SO"
  },
  "742135": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Bhagabangola SO"
  },
  "742202": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Dhuliyan SO"
  },
  "742213": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Chotkalia SO"
  },
  "742123": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Jiaganj SO"
  },
  "742148": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Lalgola SO"
  },
  "781301": {
    "state": "ASSAM",
    "district": "BARPETA",
    "office": "Barpeta H.O"
  },
  "244924": {
    "state": "UTTAR PRADESH",
    "district": "RAMPUR",
    "office": "Suar SO"
  },
  "244415": {
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "office": "Raja Ka Sahaspur SO"
  },
  "244602": {
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "office": "Surjan Nagar SO"
  },
  "222137": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Jamalapur SO"
  },
  "643007": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Dr. Basuviah Nagar S.O"
  },
  "600055": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Avadi IAF SO"
  },
  "601101": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Arni CPT SO"
  },
  "600057": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Ernavur SO"
  },
  "600019": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Kaladipet SO"
  },
  "601206": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Kavarapettai SO"
  },
  "209101": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR DEHAT",
    "office": "Akbarpur SO"
  },
  "209112": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR DEHAT",
    "office": "Amraudha SO"
  },
  "231307": {
    "state": "UTTAR PRADESH",
    "district": "MIRZAPUR",
    "office": "Vindhyachal SO"
  },
  "212218": {
    "state": "UTTAR PRADESH",
    "district": "KAUSHAMBI",
    "office": "Tilhapur SO"
  },
  "231226": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Wyndhamganj SO"
  },
  "601202": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Madarpakkam SO"
  },
  "601204": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Ponneri Public Office SO"
  },
  "263126": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Kathgodam SO"
  },
  "244716": {
    "state": "UTTARAKHAND",
    "district": "UDAM SINGH NAGAR",
    "office": "RTC Hempur SO"
  },
  "209305": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Chakarpur SO"
  },
  "208017": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Avas Vikas Yojna No 3 SO"
  },
  "209217": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Mandhana SO"
  },
  "209401": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Narwal SO"
  },
  "781133": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "Dagaon S.O."
  },
  "781039": {
    "state": "ASSAM",
    "district": "KAMRUP",
    "office": "I I T S.O"
  },
  "263001": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Tallital SO"
  },
  "263136": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Bhimtal SO"
  },
  "263137": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Ramgarh SO Nainital"
  },
  "263132": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Bhowali SO"
  },
  "263159": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Kotabagh SO"
  },
  "614402": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Kokkeri S.O"
  },
  "627103": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Eruvadi SO"
  },
  "631101": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Guruvarajpet SO"
  },
  "643103": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Pasteur Institute S.O"
  },
  "643206": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Denaducombai S.O"
  },
  "637013": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Erampatti S.O"
  },
  "637014": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Karaikurichi S.O (Namakkal)"
  },
  "637015": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Mohanur S.O"
  },
  "637405": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Muthugapatti S.O"
  },
  "637003": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Nallipalayam S.O"
  },
  "637018": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Puduchatram S.O"
  },
  "628614": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Campbellabad S.O"
  },
  "628618": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Neivilai S.O"
  },
  "609306": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Nalladai S.O"
  },
  "341024": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Kuchera S.O (Nagaur)"
  },
  "742184": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Nabagram SO Murshidabad"
  },
  "628656": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Puthantharuvai S.O"
  },
  "341511": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Merta Road S.O"
  },
  "145027": {
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "office": "Bamial SO"
  },
  "145024": {
    "state": "PUNJAB",
    "district": "PATHANKOT",
    "office": "Madhopur SO Gurdaspur"
  },
  "742224": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Nimtita SO"
  },
  "742226": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Sagardighi SO"
  },
  "209209": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "BBGaon SO"
  },
  "212661": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Lalauli SO"
  },
  "212664": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Malwan RS SO"
  },
  "321401": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Kachahri Bayana SO"
  },
  "321410": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Brahmbad SO"
  },
  "321411": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Khareri SO"
  },
  "627006": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Tirunelveli Terku SO"
  },
  "627202": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Ukkirankottai SO"
  },
  "229001": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Zilaparisad SO"
  },
  "273404": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Belghat SO"
  },
  "846008": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "K D S U SO"
  },
  "609310": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Tillaiyadi S.O"
  },
  "609311": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Tirucadaiyur S.O"
  },
  "765034": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "Jaganathpur S.O"
  },
  "742404": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Tenya SO"
  },
  "742212": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Farakka Project SO"
  },
  "612802": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Haridwaramangalam S.O"
  },
  "244303": {
    "state": "UTTAR PRADESH",
    "district": "SAMBHAL",
    "office": "Sarai Tarin SO"
  },
  "284501": {
    "state": "UTTAR PRADESH",
    "district": "LALITPUR",
    "office": "Rajghat Dam Project SO"
  },
  "851114": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Barauni Oil Refinery SO"
  },
  "851135": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Bihat SO"
  },
  "207250": {
    "state": "UTTAR PRADESH",
    "district": "ETAH",
    "office": "Sarai Aghat SO"
  },
  "207403": {
    "state": "UTTAR PRADESH",
    "district": "Kasganj",
    "office": "Soron SO"
  },
  "207246": {
    "state": "UTTAR PRADESH",
    "district": "Kasganj",
    "office": "Sirhpura SO"
  },
  "246121": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Bhrigukhal A SO"
  },
  "249306": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Chila Colony SO"
  },
  "246127": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Dugadda SO"
  },
  "246128": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Dwarikhal SO"
  },
  "246144": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Kandakhal SO"
  },
  "622001": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Bhuvaneswarinagar S.O"
  },
  "614620": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Manamelkudi S.O"
  },
  "622506": {
    "state": "TAMIL NADU",
    "district": "PUDUKKOTTAI",
    "office": "Rayavaram S.O (Pudukkottai)"
  },
  "275301": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "Amila SO"
  },
  "275302": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "Bhopaura SO"
  },
  "276129": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "Chiraia Kot SO"
  },
  "275303": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "Dohari  Ghat SO"
  },
  "221601": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "DUBARI SO"
  },
  "275304": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "GHOSI SO"
  },
  "221705": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "HALDHARPUR SO"
  },
  "276402": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "KARAHA SO"
  },
  "639101": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Andanallur SO"
  },
  "639203": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Isanatham S.O"
  },
  "613704": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Kulikarai S.O"
  },
  "609502": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Mudikondan S.O"
  },
  "639007": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Karur Collectorate S.O"
  },
  "639207": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Pallapatti Bazaar S.O"
  },
  "621306": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Manaparai S.O"
  },
  "246173": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Silogi SO"
  },
  "246275": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Baijrao A SO"
  },
  "246276": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Bironkhal A SO"
  },
  "246277": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Dhumakot SO"
  },
  "607006": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Kondur S.O"
  },
  "625005": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Thiruparankundram SO"
  },
  "600103": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Manali New Town SO"
  },
  "643204": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Chamraj Estate S.O"
  },
  "641008": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Coimbatore Ukkadam SO"
  },
  "206122": {
    "state": "UTTAR PRADESH",
    "district": "AURAIYA",
    "office": "Auraiya HO"
  },
  "206241": {
    "state": "UTTAR PRADESH",
    "district": "AURAIYA",
    "office": "Achhalda SO"
  },
  "206252": {
    "state": "UTTAR PRADESH",
    "district": "AURAIYA",
    "office": "Airwa Katra SO"
  },
  "206121": {
    "state": "UTTAR PRADESH",
    "district": "AURAIYA",
    "office": "Ajitmal SO"
  },
  "600118": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Kodungaiyur SO"
  },
  "600099": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Kolathur SO"
  },
  "607005": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Sipcot Cuddalore S.O"
  },
  "246279": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Dungri SO Pauri Garhwal"
  },
  "328041": {
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "office": "Kanchanpur SO Dholpur"
  },
  "328028": {
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "office": "Keshar Bagh SO"
  },
  "328024": {
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "office": "Maniya SO"
  },
  "302028": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Amer S.O"
  },
  "328029": {
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "office": "Marena SO"
  },
  "328030": {
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "office": "Panch Gaon SO"
  },
  "328025": {
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "office": "Rajakhera SO"
  },
  "328027": {
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "office": "Saipau SO"
  },
  "600049": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Villivakkam SO"
  },
  "600060": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Moolakadai SO"
  },
  "263134": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Betalghat SO"
  },
  "262122": {
    "state": "UTTAR PRADESH",
    "district": "PILIBHIT",
    "office": "Pooranpur SO"
  },
  "321404": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Roopbas SO"
  },
  "321402": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Rudawal SO"
  },
  "321408": {
    "state": "RAJASTHAN",
    "district": "BHARATPUR",
    "office": "Weir SO"
  },
  "742227": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Gankar SO"
  },
  "742223": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Jangipur Barrage SO"
  },
  "243122": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Ner Workshop SO"
  },
  "243002": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Airforce Station"
  },
  "141103": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Mohie SO"
  },
  "621652": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Kallakudi North SO"
  },
  "275105": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "JAMALMIRZAPUR SO"
  },
  "306602": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Chanod S.O"
  },
  "306022": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Jojawar S.O"
  },
  "306501": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Khairwa S.O"
  },
  "306502": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Khinwara S.O"
  },
  "306706": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Lunawa S.O"
  },
  "306705": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Mundara S.O"
  },
  "306603": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Nadol S.O"
  },
  "306504": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Nana S.O"
  },
  "306023": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Ranawas S.O"
  },
  "306702": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Sadri S.O"
  },
  "306103": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Sojat  Road S.O"
  },
  "306503": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Somesar S.O"
  },
  "306401": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Pali Veer Durgadas  Nagar S.O"
  },
  "306101": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Babra S.O (Pali)"
  },
  "306308": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Balunda S.O"
  },
  "306901": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Bankli S.O"
  },
  "625515": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Chinnamanur S.O"
  },
  "625516": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Gandhinagar (Cumbum) S.O"
  },
  "625519": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Highwavys S.O"
  },
  "625524": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Pannaipuram S.O"
  },
  "625525": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Periyar Project S.O"
  },
  "625526": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Royappanpatti S.O"
  },
  "625582": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Subburajnagar S.O"
  },
  "335701": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Anupgarh S.O"
  },
  "335021": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Bishanpura S.O"
  },
  "335022": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Chunawadh S.O"
  },
  "788803": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Badarpurghat S.O"
  },
  "788727": {
    "state": "ASSAM",
    "district": "KARIMGANJ",
    "office": "Bazaricherra Bazar S.O"
  },
  "742237": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Manigram SO"
  },
  "305819": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Karkeri S.O"
  },
  "741161": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Assannagar SO"
  },
  "643218": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Kullakamby S.O"
  },
  "788001": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Silchar H.O"
  },
  "788118": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Silcuri S.O"
  },
  "742113": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Debipur SO"
  },
  "612101": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Aduthurai S.O"
  },
  "609501": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Eravancheri S.O"
  },
  "612604": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Sengalipuram S.O"
  },
  "212404": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Ghiya Nagar SO"
  },
  "221508": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Saidabad SO"
  },
  "212109": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Sikandra SO"
  },
  "621315": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Vaiyampatti S.O"
  },
  "341026": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Marwar Mundwa S.O"
  },
  "620021": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "KKNagar SO Tiruchirappalli"
  },
  "620009": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Ramjeenagar SO"
  },
  "639115": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Tirupparaithurai SO"
  },
  "205001": {
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "office": "Zilla Parishad SO"
  },
  "742166": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Hariharpara SO"
  },
  "742304": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Islampore SO"
  },
  "742305": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Jalangi SO"
  },
  "742187": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Radharghat SO"
  },
  "742308": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Raninagar SO"
  },
  "742175": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Sabdarnagar SO"
  },
  "742306": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Sagarpara SO"
  },
  "204215": {
    "state": "UTTAR PRADESH",
    "district": "HATHRAS",
    "office": "Sikandra Rao SO"
  },
  "742174": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Sarbangapur SO"
  },
  "742405": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Satui SO"
  },
  "742151": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Rajarampur SO"
  },
  "283112": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "IRADAT NAGAR SO"
  },
  "283115": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "JAGNER SO"
  },
  "621002": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Kirambur S.O"
  },
  "621004": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Kottathur S.O"
  },
  "621014": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Pagalavadi S.O"
  },
  "621006": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Pulivalam S.O (Tiruchirappalli)"
  },
  "621008": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Sikkathambur S.O"
  },
  "206251": {
    "state": "UTTAR PRADESH",
    "district": "AURAIYA",
    "office": "Bela SO Auraiya"
  },
  "206243": {
    "state": "UTTAR PRADESH",
    "district": "AURAIYA",
    "office": "Bidhuna SO"
  },
  "206244": {
    "state": "UTTAR PRADESH",
    "district": "AURAIYA",
    "office": "N T P C Dibiapur SO"
  },
  "206246": {
    "state": "UTTAR PRADESH",
    "district": "AURAIYA",
    "office": "Kanchausi Bazar SO"
  },
  "206249": {
    "state": "UTTAR PRADESH",
    "district": "AURAIYA",
    "office": "Ruruganj SO"
  },
  "206248": {
    "state": "UTTAR PRADESH",
    "district": "AURAIYA",
    "office": "Sahar SO Auraiya"
  },
  "206120": {
    "state": "UTTAR PRADESH",
    "district": "ETAWAH",
    "office": "Aheripur SO"
  },
  "206124": {
    "state": "UTTAR PRADESH",
    "district": "ETAWAH",
    "office": "Bakewar SO"
  },
  "206123": {
    "state": "UTTAR PRADESH",
    "district": "ETAWAH",
    "office": "Baralokpur SO"
  },
  "600058": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Ambattur Indl Estate SO"
  },
  "206255": {
    "state": "UTTAR PRADESH",
    "district": "AURAIYA",
    "office": "Malhosi SO"
  },
  "206129": {
    "state": "UTTAR PRADESH",
    "district": "AURAIYA",
    "office": "Muradganj SO"
  },
  "206247": {
    "state": "UTTAR PRADESH",
    "district": "AURAIYA",
    "office": "Phaphund SO"
  },
  "621217": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Thandalaiputhur S.O"
  },
  "621214": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Thathiengarpet S.O"
  },
  "621011": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Uppliapuram S.O"
  },
  "742303": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Dumkal SO"
  },
  "241001": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "White Ganj SO"
  },
  "643238": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Nonsuch S.O"
  },
  "643231": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Wellington S.O"
  },
  "643240": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Bitherkad S.O"
  },
  "631701": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Akkur SO Tiruvannamalai"
  },
  "604401": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Anukkavoor SO"
  },
  "632316": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Chevur SO"
  },
  "604501": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Desur SO"
  },
  "604402": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Hasanamapettai SO"
  },
  "632311": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Kannamangalam SO"
  },
  "604404": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Kilkovalavedu SO"
  },
  "632313": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Kolappalur SO Tiruvannamalai"
  },
  "632314": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Kunnathur Arni SO"
  },
  "604502": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Malayur SO"
  },
  "631702": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Mamandur Kanchipuram SO"
  },
  "643207": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Devarshola S.O"
  },
  "637402": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Belukurichi S.O"
  },
  "637002": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Ganesapuram S.O"
  },
  "637404": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Kalappanaickenpatti S.O"
  },
  "243725": {
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "office": "Saidpur SO Budaun"
  },
  "639205": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Pallapatti S.O (Karur)"
  },
  "637017": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Palapatti S.O"
  },
  "600048": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Mudichur SO"
  },
  "604405": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Marudadu SO"
  },
  "606807": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Nedungunam SO"
  },
  "632315": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Onnupuram SO"
  },
  "604503": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Pernamallur SO"
  },
  "632317": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Sathiyaviziyanagaram SO"
  },
  "604406": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Tellar SO"
  },
  "604407": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Tiruvettipuram SO"
  },
  "604409": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Valkadai SO"
  },
  "206128": {
    "state": "UTTAR PRADESH",
    "district": "ETAWAH",
    "office": "Mandir Mahewa SO"
  },
  "206003": {
    "state": "UTTAR PRADESH",
    "district": "ETAWAH",
    "office": "Ram Lila Road SO"
  },
  "206131": {
    "state": "UTTAR PRADESH",
    "district": "ETAWAH",
    "office": "Udi SO"
  },
  "241121": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Aihrori SO"
  },
  "241122": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Baghauli SO"
  },
  "241401": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Barwan SO Hardoi"
  },
  "241201": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Behander SO"
  },
  "241125": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Behta Gokul SO"
  },
  "241304": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Beniganj SO"
  },
  "241202": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Bharawan SO"
  },
  "241301": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Bilgram BS SO"
  },
  "241203": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Dhikunni SO"
  },
  "206250": {
    "state": "UTTAR PRADESH",
    "district": "AURAIYA",
    "office": "Harchandpur SO Auraiya"
  },
  "263135": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Garampani SO"
  },
  "263138": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "MukteshwarKumaon SO"
  },
  "263157": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Okhalkanda SO"
  },
  "281301": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Baldeo SO"
  },
  "281302": {
    "state": "UTTAR PRADESH",
    "district": "HATHRAS",
    "office": "Bisawar SO"
  },
  "281406": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Chaumuhan SO"
  },
  "281405": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Barsana SO"
  },
  "342606": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Pipar Road SO"
  },
  "342601": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Pipar SO"
  },
  "342025": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Setrawa SO"
  },
  "224125": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Bandipur SO"
  },
  "281401": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Chhata SO Mathura"
  },
  "281122": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Farah SO"
  },
  "281003": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Gayatri Tapo Bhoomi SO"
  },
  "241305": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Gaus Ganj SO"
  },
  "209208": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR DEHAT",
    "office": "Musa Nagar SO"
  },
  "281502": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Goverdhan SO"
  },
  "281403": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Kosi Kalan SO"
  },
  "281104": {
    "state": "UTTAR PRADESH",
    "district": "HATHRAS",
    "office": "Jalesar RS SO"
  },
  "230124": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Amargarh SO Pratapgarh"
  },
  "230501": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Antu SO"
  },
  "230143": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Babaganj SO"
  },
  "230201": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Bhadri SO"
  },
  "230144": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Ajgara SO"
  },
  "230125": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Atheha SO"
  },
  "249304": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Swargashram SO"
  },
  "246155": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Lansdowne HO"
  },
  "342022": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Shergarh SO Jodhpur"
  },
  "212620": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Asother SO"
  },
  "212622": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Bahrampur SO"
  },
  "212663": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Bahua SO"
  },
  "212650": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Chheolaha SO"
  },
  "212641": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Dhata SO"
  },
  "212653": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Erayan SO"
  },
  "212621": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Ghazipur SO Fatehpur"
  },
  "209311": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR DEHAT",
    "office": "Jainpur I A SO"
  },
  "246725": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Chandpur SO"
  },
  "243201": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "KSW Tulsi Nagar"
  },
  "614001": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Mannargudi Bazaar S.O"
  },
  "614101": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Koothanallur S.O"
  },
  "614708": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Kottur S.O (Tiruvarur)"
  },
  "614404": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Nidamangalam S.O"
  },
  "614014": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Pamani MNG S.O"
  },
  "614103": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Podakudi S.O"
  },
  "614016": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Serangolam S.O"
  },
  "614017": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Tirumakottai S.O"
  },
  "243003": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Shubhash Market SO"
  },
  "243202": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Bhojipura"
  },
  "342024": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Soorsagar SO"
  },
  "342028": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Tena SO"
  },
  "342306": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Teori SO"
  },
  "612605": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Tiruchirai S.O"
  },
  "612702": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Darasuram S.O"
  },
  "612202": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Murukkangudi S.O"
  },
  "609802": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Narasinganpettai S.O"
  },
  "612602": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Natchar Koil S.O"
  },
  "781171": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Patharquerry S.O"
  },
  "781034": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Odalbakra S.O"
  },
  "781040": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Sawkuchi S.O"
  },
  "781003": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Assam Tribune S.O"
  },
  "781001": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Guwahati G.P.O."
  },
  "781002": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "IBC Guwahati P.O"
  },
  "781013": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Jalukbari S.O"
  },
  "209304": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Sachendi SO"
  },
  "243126": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Bhuta"
  },
  "243302": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Bisharatganj"
  },
  "243502": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "CBGanj"
  },
  "243503": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Faridpur"
  },
  "243506": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Fatehganj East"
  },
  "243004": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "ITBP"
  },
  "262310": {
    "state": "UTTARAKHAND",
    "district": "CHAMPAWAT",
    "office": "Chandani SO"
  },
  "284121": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Baragaon SO Jhansi"
  },
  "284201": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Barwasagar SO"
  },
  "284127": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Bhattagaon SO"
  },
  "284120": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "BHEL SO Jhansi"
  },
  "284301": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Chirgaon SO Jhansi"
  },
  "284202": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Gursarai SO"
  },
  "284002": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Naria Bazar SO"
  },
  "788103": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Lakhipur S.O (Cachar"
  },
  "788014": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Silchar Medical College S.O"
  },
  "246129": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Dudharkhal SO"
  },
  "246131": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Ekeshwar A SO"
  },
  "209302": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR DEHAT",
    "office": "Jhinjhak SO"
  },
  "209310": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR DEHAT",
    "office": "Mangalpur SO Kanpur Dehat"
  },
  "209308": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Patara SO"
  },
  "209111": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR DEHAT",
    "office": "Pukhrayan SO"
  },
  "209115": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR DEHAT",
    "office": "Rajpur SO Kanpur Dehat"
  },
  "209306": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR DEHAT",
    "office": "Rasulabad SO Kanpur Dehat"
  },
  "209303": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR DEHAT",
    "office": "Rura SO"
  },
  "209121": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR DEHAT",
    "office": "Sarwankhera SO"
  },
  "639111": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Paramathi (Karur) S.O"
  },
  "639113": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Pugalur Sugar Factory S.O"
  },
  "639114": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Puliyur Cement Factory S.O"
  },
  "639206": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Tennilai S.O"
  },
  "639003": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Tirumanilaiyur S.O"
  },
  "639116": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Vangal S.O"
  },
  "639117": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Velayuthampalayam S.O"
  },
  "639118": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Velliyanai S.O"
  },
  "621302": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Elangakurichi S.O"
  },
  "621305": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Kovilpatti S.O"
  },
  "639105": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Lalapet S.O"
  },
  "612401": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Sakkottai S.O"
  },
  "612402": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Tippirajapuram S.O"
  },
  "612203": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Palaiyur S.O"
  },
  "612201": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Konerirajapuram S.O"
  },
  "612001": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Kumbakonam Market S.O"
  },
  "612104": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Tiruvidamarudur S.O"
  },
  "210125": {
    "state": "UTTAR PRADESH",
    "district": "BANDA",
    "office": "Kamasin SO"
  },
  "210120": {
    "state": "UTTAR PRADESH",
    "district": "BANDA",
    "office": "Khurand RS SO"
  },
  "210129": {
    "state": "UTTAR PRADESH",
    "district": "BANDA",
    "office": "Naraini SO"
  },
  "612501": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Koranattukkaruppur S.O"
  },
  "612502": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Lower Anicut S.O"
  },
  "609807": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Pandanallur S.O"
  },
  "612302": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Swamimalai S.O"
  },
  "612102": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Tirumangalakudi S.O"
  },
  "612204": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Tirunageswaram S.O"
  },
  "612103": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Tirupuvanam S.O"
  },
  "612503": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Sholapuram S.O"
  },
  "609804": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Thuhili S.O"
  },
  "612601": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Kodavasal S.O"
  },
  "613703": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Koradacheri S.O"
  },
  "209125": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR DEHAT",
    "office": "Sikandra SO Kanpur Dehat"
  },
  "784166": {
    "state": "ASSAM",
    "district": "Biswanath",
    "office": "Behali S.O"
  },
  "303327": {
    "state": "RAJASTHAN",
    "district": "DAUSA",
    "office": "Baswa SO Dausa"
  },
  "625530": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Thevaram S.O"
  },
  "625533": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Uthamapalayam S.O"
  },
  "625512": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Aundipatti S.O"
  },
  "625602": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Devadanapatti S.O"
  },
  "625517": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Gandamanayakanur S.O"
  },
  "625579": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Kadamalaikundu S.O"
  },
  "625705": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Saptur S.O"
  },
  "335063": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "Sangaria S.O (Hanumangarh)"
  },
  "335526": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "Tibbi S.O"
  },
  "335064": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "Dholipal S.O"
  },
  "713152": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Bannabagram SO"
  },
  "713125": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Bhatar SO"
  },
  "612610": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Manjakudi S.O"
  },
  "613705": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Sellur S.O (Tiruvarur)"
  },
  "612603": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Sembangudi S.O"
  },
  "328026": {
    "state": "RAJASTHAN",
    "district": "DHOLPUR",
    "office": "Sarmathura SO"
  },
  "284135": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "33 Bn Pac Jhansi SO"
  },
  "230126": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Babuganj SO"
  },
  "851115": {
    "state": "BIHAR",
    "district": "BEGUSARAI",
    "office": "Barauni Urvark Nagar SO"
  },
  "600054": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Avadi SO"
  },
  "600095": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Maduravoyal SO"
  },
  "600123": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Nazarethpettai SO"
  },
  "600124": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Thirumushi SO"
  },
  "600077": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Thiruverkadu SO"
  },
  "603112": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Kovalam SO Kanchipuram"
  },
  "600130": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Thazambur"
  },
  "600132": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Tirumudivakkam SO"
  },
  "606801": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Chettupattu Polur SO"
  },
  "606903": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Kalambur SO"
  },
  "262308": {
    "state": "UTTARAKHAND",
    "district": "UDAM SINGH NAGAR",
    "office": "Khatima SO"
  },
  "262302": {
    "state": "UTTAR PRADESH",
    "district": "PILIBHIT",
    "office": "Majhola SO Bareilly"
  },
  "722152": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Taldangra SO"
  },
  "243402": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Ballia SO"
  },
  "243401": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Bhamora SO"
  },
  "614018": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Ullikottai S.O"
  },
  "610206": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Vadapathimangalam S.O"
  },
  "614019": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Vaduvur S.O"
  },
  "606305": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Asanur S.O"
  },
  "606201": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Chinnasalem S.O"
  },
  "607202": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Elavanasur S.O"
  },
  "272163": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Gaur RS SO"
  },
  "341303": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Station Road Didwana S.O"
  },
  "341551": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Berichhoti S.O"
  },
  "341302": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Chhotikhatu S.O"
  },
  "609301": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Akkur S.O (Nagapattinam)"
  },
  "609304": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Kilaiyur S.O"
  },
  "607201": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Eraiyur S.O (Villupuram)"
  },
  "606102": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Kalamarudur S.O"
  },
  "606213": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Kallakurichi South S.O"
  },
  "605702": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Moongilthuraipattu S.O"
  },
  "606203": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Nagalur S.O"
  },
  "606301": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Nainarpalayam S.O"
  },
  "606115": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Padur S.O"
  },
  "606402": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Pandalam S.O (Villupuram)"
  },
  "272165": {
    "state": "UTTAR PRADESH",
    "district": "SANT KABEER NAGAR",
    "office": "Hainsar Bazar SO"
  },
  "272164": {
    "state": "UTTAR PRADESH",
    "district": "SANT KABEER NAGAR",
    "office": "Hariharpur SO"
  },
  "271840": {
    "state": "UTTAR PRADESH",
    "district": "SHRAVASTI",
    "office": "Sirsia SO"
  },
  "614717": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Adichapuram S.O"
  },
  "612801": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Alangudi NID S.O"
  },
  "614013": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Idangankottai Melaiyur S.O"
  },
  "614710": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Naduvakalappal S.O"
  },
  "620010": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Industrial Colony SO"
  },
  "620011": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Melakalkandarkottai SO"
  },
  "620015": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "National Institute of Technology SO"
  },
  "620016": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Ordnance Estate  TR SO"
  },
  "620102": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Somarasampettai SO"
  },
  "620013": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Thiruverumbur SO"
  },
  "620003": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Woriur SO"
  },
  "639008": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Andankoil S.O"
  },
  "614705": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Peruvazhandan S.O"
  },
  "604403": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Kilkodungalur SO"
  },
  "232110": {
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "office": "Saiyadraja SO"
  },
  "232109": {
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "office": "Sakaldiha Bazar SO"
  },
  "232108": {
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "office": "Sakaldiha SO"
  },
  "221115": {
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "office": "Tanda Kalan SO"
  },
  "221201": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Anai SO"
  },
  "632312": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Kattukanur SO"
  },
  "341301": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "Bari Khatu S.O"
  },
  "713520": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Nityanandapur SO"
  },
  "713126": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Bhedia SO"
  },
  "713127": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Bonpas SO"
  },
  "713406": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Galsi SO"
  },
  "621114": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "T.Kalathur S.O"
  },
  "609103": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Anandatandavapuram S.O"
  },
  "609302": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Arangakudi S.O"
  },
  "609401": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Elandangudi S.O"
  },
  "284401": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Babina Town SO"
  },
  "284302": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Erich SO"
  },
  "284203": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Garautha SO"
  },
  "609801": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Kuttalam East S.O"
  },
  "609204": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Tirumeniarkoil S.O"
  },
  "610107": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Tiruvidacherry S.O"
  },
  "612504": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Tirupanandal S.O"
  },
  "224159": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Malipur SO"
  },
  "243630": {
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "office": "Samrer SO"
  },
  "243639": {
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "office": "Santigarh  Ujhani SO"
  },
  "243726": {
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "office": "Wazirganj SO Budaun"
  },
  "243641": {
    "state": "UTTAR PRADESH",
    "district": "BUDAUN",
    "office": "Usehat SO"
  },
  "224210": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Bariyawan SO"
  },
  "342015": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Saran Nagar SO"
  },
  "342021": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Somesar SO"
  },
  "262908": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Chandan Chauki SO"
  },
  "225001": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Munshiganj SO Barabanki"
  },
  "225401": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Aliabad SO"
  },
  "225416": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Asandra SO"
  },
  "225201": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Bahramghat SO"
  },
  "225202": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Burhwal Sugar Mill SO"
  },
  "225403": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Dariya Bad SO"
  },
  "225404": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Dariyabad RS SO"
  },
  "225301": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Dewa Sharif SO"
  },
  "225003": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Gandhi Aashram SO"
  },
  "335023": {
    "state": "RAJASTHAN",
    "district": "GANGANAGAR",
    "office": "Dalpatsinghpur S.O"
  },
  "621118": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Nakkasalem S.O"
  },
  "621003": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Kottapalayam S.O"
  },
  "621210": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Mettupalayam S.O"
  },
  "621007": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Puthanampatti S.O"
  },
  "225124": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Haidergarh SO"
  },
  "225121": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Harakh SO"
  },
  "639004": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Pasupathipalayam S.O"
  },
  "639002": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Sengunthapuram S.O"
  },
  "639006": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Vengamedu S.O"
  },
  "621301": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Chinthamanipatti S.O"
  },
  "639102": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Krishnarayapuram S.O"
  },
  "639104": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Kulittalai Bazaar S.O"
  },
  "632326": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Susainagar SO"
  },
  "206130": {
    "state": "UTTAR PRADESH",
    "district": "ETAWAH",
    "office": "Saifai SO"
  },
  "612803": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Puvanur S.O"
  },
  "612701": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Avoor S.O"
  },
  "281308": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Jugasana SO"
  },
  "243203": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Deorania"
  },
  "229212": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Sareni SO"
  },
  "229211": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Semri SO"
  },
  "229135": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Aharwabhawani SO"
  },
  "229301": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Bachrawan SO"
  },
  "229310": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Deeh SO"
  },
  "229406": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Fgtp Unchahar SO"
  },
  "229302": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Fursatganj SO"
  },
  "229103": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Hallaur SO Raebareli"
  },
  "229304": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Harbansganj SO"
  },
  "229801": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Inhauna SO"
  },
  "229401": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Itaurabujurg SO"
  },
  "614301": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Melattur S.O (Thanjavur)"
  },
  "614205": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Papanasam Bazaar S.O"
  },
  "272150": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Hanumanganj SO"
  },
  "272301": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Kalwari SO"
  },
  "229402": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Jagatpur SO Raebareli"
  },
  "229305": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Wahabganj SO"
  },
  "229124": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "K K Bajar SO"
  },
  "229306": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Mahrajganj SO Raebareli"
  },
  "229128": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Mejarganj SO"
  },
  "229404": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Mustafabad SO Raebareli"
  },
  "342013": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Rajasthan High Court NB SO"
  },
  "225405": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Hathaunda SO"
  },
  "225203": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Jahangeerabad Raj SO"
  },
  "225119": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Kothi SO Barabanki"
  },
  "225302": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Kursi SO"
  },
  "306114": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Bagri Nagar S.O"
  },
  "306701": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Bali S.O"
  },
  "306601": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Bijowa S.O"
  },
  "306126": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Jawai  Bandh S.O"
  },
  "784026": {
    "state": "ASSAM",
    "district": "SONITPUR",
    "office": "Khalihamari S.O"
  },
  "306115": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Rani Sadar Bazar S.O"
  },
  "306707": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Sewari S.O"
  },
  "306301": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Anandpur Kalu S.O"
  },
  "612703": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Patteeswaram S.O"
  },
  "612303": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Tirupirambiyam S.O"
  },
  "612105": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Veppathur S.O"
  },
  "306703": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Desuri S.O"
  },
  "306116": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Falna  I. E. S.O"
  },
  "212635": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Purani Bindki SO"
  },
  "209204": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR DEHAT",
    "office": "Sheoli SO"
  },
  "613702": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Attikkadai S.O"
  },
  "224129": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Baskhari SO"
  },
  "224132": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Bhiti SO"
  },
  "224137": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Deoria SO Ambedkar Nagar"
  },
  "224139": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Dulahoopur SO"
  },
  "281004": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Krishna Nagar SO Mathura"
  },
  "227816": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Raniganj SO Sultanpur"
  },
  "621012": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Vyrichettipalayam S.O"
  },
  "606208": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Murarbad S.O"
  },
  "614015": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Paravakottai S.O"
  },
  "614401": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Ammapet S.O"
  },
  "614202": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Ganapathi Agraharam S.O"
  },
  "229215": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Purepandey SO"
  },
  "229308": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Shivgarh SO"
  },
  "781035": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Garchuk S.O"
  },
  "781006": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Assam Sachivalaya S.O"
  },
  "781036": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Hengrabari S.O"
  },
  "781032": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Indrapur S.O"
  },
  "241404": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Gopamau SO"
  },
  "302027": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Crpf Campus  Lalwas S.O"
  },
  "302031": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Jamdoli S.O"
  },
  "302026": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Bhankrota S.O"
  },
  "263642": {
    "state": "UTTARAKHAND",
    "district": "BAGESHWAR",
    "office": "Collectorate Bageshwar SO"
  },
  "263641": {
    "state": "UTTARAKHAND",
    "district": "BAGESHWAR",
    "office": "Baijnath SO Bageshwar"
  },
  "620012": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Craw Ford Colony SO"
  },
  "246124": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Dadamandi SO"
  },
  "246193": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Jahrikhal B SO"
  },
  "246162": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Naugaonkhal SO"
  },
  "246179": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Rikhnikhal A SO"
  },
  "246172": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Satpuli SO"
  },
  "244401": {
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "office": "Dilari SO"
  },
  "229303": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Harchandpur SO Raebareli"
  },
  "229123": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Hardoi SO"
  },
  "209870": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Rasulabad SO Unnao"
  },
  "209871": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Safipur SO"
  },
  "713128": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Gushkara SO"
  },
  "713407": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Hatgobindapur SO"
  },
  "713408": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Jamalpur SO Bardhaman"
  },
  "713141": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Khana Jn SO"
  },
  "713428": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Adrahati SO"
  },
  "713401": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Ajhapur SO"
  },
  "713121": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Aruar SO"
  },
  "713122": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Baidyapur SO"
  },
  "600125": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Mugalivakkam SO"
  },
  "632319": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Kammavanpettai SO"
  },
  "600128": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Kovur SO Tamilnadu Circle"
  },
  "731124": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Hetampur Rajbati SO"
  },
  "731214": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Illambazar SO"
  },
  "224143": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Hanswar SO"
  },
  "224145": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Iltifatganj SO"
  },
  "224146": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Jafarganj SO"
  },
  "224147": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Jahangirganj SO"
  },
  "224149": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Jalalpur SO Ambedkar Nagar"
  },
  "224151": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Katehari SO"
  },
  "224230": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Kedarnagar SO"
  },
  "224157": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Khemapur SO"
  },
  "625518": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Gudalur S.O"
  },
  "625520": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Kamatchipuram S.O"
  },
  "625521": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Kamayakoundanpatti S.O"
  },
  "625540": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Odaipatti S.O"
  },
  "625528": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Sillamarathupatti S.O"
  },
  "620025": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Hapf Township SO"
  },
  "620101": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Mutharasanallur SO"
  },
  "639112": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Pettavaithalai SO"
  },
  "209860": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Achalganj"
  },
  "788109": {
    "state": "ASSAM",
    "district": "CACHAR",
    "office": "Kumbhirgram Airport S.O"
  },
  "731126": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Karidhya SO"
  },
  "731125": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Khoyrasole SO"
  },
  "731215": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Khujutipara SO"
  },
  "731302": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Kirnahar SO"
  },
  "110029": {
    "state": "DELHI",
    "district": "SOUTH",
    "office": "Nauroji Nagar SO"
  },
  "713124": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Chakshanjadi BO"
  },
  "713153": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Bhatkunda SO"
  },
  "713403": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Budbud SO"
  },
  "713104": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Harisava SO"
  },
  "713404": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Chakdighi SO"
  },
  "263601": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Vikas Bhawan Almora SO"
  },
  "262722": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Aira Estate SO"
  },
  "262801": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Bankey Ganj SO"
  },
  "210205": {
    "state": "UTTAR PRADESH",
    "district": "CHITRAKOOT",
    "office": "Karwi RS SO"
  },
  "210431": {
    "state": "UTTAR PRADESH",
    "district": "HAMIRPUR",
    "office": "Rath SO"
  },
  "612106": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Kadiramangalam S.O"
  },
  "224155": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Kichhauccha SO"
  },
  "110022": {
    "state": "DELHI",
    "district": "NEW DELHI",
    "office": "R K Puram Sect12 SO"
  },
  "722153": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Tiluri SO"
  },
  "263127": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Jeolikote SO"
  },
  "263158": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Narain Swamy Ashram SO"
  },
  "229010": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "ITI SO Raebareli"
  },
  "210208": {
    "state": "UTTAR PRADESH",
    "district": "CHITRAKOOT",
    "office": "Manikpur SO Chitrakoot"
  },
  "210209": {
    "state": "UTTAR PRADESH",
    "district": "CHITRAKOOT",
    "office": "Mauchhibu SO"
  },
  "224231": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Maharuwa Gola SO"
  },
  "224152": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Mijhaura SO"
  },
  "224168": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Pahitipur SO"
  },
  "224176": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Rajesultanpur SO"
  },
  "620007": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Tiruchirappalli Airport SO"
  },
  "306704": {
    "state": "RAJASTHAN",
    "district": "PALI",
    "office": "Ghanerao S.O"
  },
  "604504": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Tirumani SO"
  },
  "713131": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Kasemnagar SO"
  },
  "742149": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Murshidabad SO"
  },
  "625203": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Genguvarpatti S.O"
  },
  "625604": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Periyakulam East S.O"
  },
  "742168": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Andi SO"
  },
  "742138": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Bagdanga SO"
  },
  "742132": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Barwan SO Murshidabad"
  },
  "742301": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Bharatpur SO Murshidabad"
  },
  "244104": {
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "office": "Mundha SO"
  },
  "736146": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Mathabhanga SO"
  },
  "736169": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Nigamnagar SO"
  },
  "736156": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Nilkuthi SO"
  },
  "246278": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Syunsinagar SO"
  },
  "246001": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Upper Bazar SO"
  },
  "625523": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Lakshmipuram S.O (Theni)"
  },
  "242306": {
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR",
    "office": "Rosa RS SO"
  },
  "242406": {
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR",
    "office": "Rosa SO"
  },
  "242307": {
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR",
    "office": "Tilhar SO"
  },
  "262546": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Garbyang SO"
  },
  "735214": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Hamiltonganj SO"
  },
  "609811": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Kali S.O"
  },
  "609805": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Komal S.O"
  },
  "609806": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Malliyam S.O"
  },
  "731303": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Labpur SO"
  },
  "262203": {
    "state": "UTTAR PRADESH",
    "district": "PILIBHIT",
    "office": "Barkhera SO"
  },
  "262202": {
    "state": "UTTAR PRADESH",
    "district": "PILIBHIT",
    "office": "Bilsanda SO"
  },
  "614102": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Lakshmangudi S.O"
  },
  "614020": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Painganadu S.O"
  },
  "736201": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Hatipotha SO"
  },
  "735217": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Kalchini SO"
  },
  "736202": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Kamaskhyaguri SO"
  },
  "736204": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Mathurabagan SO"
  },
  "736145": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Gossanimari SO"
  },
  "246161": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Nainidanda B SO"
  },
  "271208": {
    "state": "UTTAR PRADESH",
    "district": "BALRAMPUR",
    "office": "Tulsipur SO"
  },
  "271604": {
    "state": "UTTAR PRADESH",
    "district": "BALRAMPUR",
    "office": "Utraula SO"
  },
  "743318": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Birlapur SO"
  },
  "743503": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Bishnupur SO South 24 Parganas"
  },
  "272176": {
    "state": "UTTAR PRADESH",
    "district": "SANT KABEER NAGAR",
    "office": "Ganpatganj SO"
  },
  "229216": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Cheolaha SO"
  },
  "229307": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Nasirabad SO"
  },
  "110066": {
    "state": "DELHI",
    "district": "NEW DELHI",
    "office": "R K Puram Main SO"
  },
  "246701": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Nai Basti SO"
  },
  "262201": {
    "state": "UTTAR PRADESH",
    "district": "PILIBHIT",
    "office": "Bisalpur SO"
  },
  "609303": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Ayappadi S.O"
  },
  "609402": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Kiliyanur S.O (Nagapattinam)"
  },
  "276128": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "CHANDESAR"
  },
  "223221": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Aharaula SO"
  },
  "276124": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Ajamat Garh Estate SO"
  },
  "223222": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Ambari SO"
  },
  "223223": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Ataraulia SO"
  },
  "276301": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Bardah SO"
  },
  "276121": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Bilaria Ganj SO"
  },
  "276201": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "DEOGAON SO"
  },
  "223224": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "DIDARGANJ SO"
  },
  "276302": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "GAMBHIRPUR SO"
  },
  "210001": {
    "state": "UTTAR PRADESH",
    "district": "BANDA",
    "office": "Banda DC SO"
  },
  "210201": {
    "state": "UTTAR PRADESH",
    "district": "BANDA",
    "office": "Atarra SO"
  },
  "210121": {
    "state": "UTTAR PRADESH",
    "district": "BANDA",
    "office": "Baberu SO"
  },
  "210202": {
    "state": "UTTAR PRADESH",
    "district": "BANDA",
    "office": "Badausa SO"
  },
  "210203": {
    "state": "UTTAR PRADESH",
    "district": "BANDA",
    "office": "Bisanda SO"
  },
  "227411": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Shahgarh SO Sultanpur"
  },
  "227811": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Sukul Ka Bazar SO"
  },
  "227413": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Tikarmafi SO"
  },
  "228161": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Tawakkalpur Nagra SO"
  },
  "276135": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "KANDHARAPUR SO"
  },
  "276142": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "KOILSA SO"
  },
  "276141": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Terahi SO"
  },
  "276303": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Thekma SO"
  },
  "276208": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Tika Pur SO"
  },
  "210204": {
    "state": "UTTAR PRADESH",
    "district": "CHITRAKOOT",
    "office": "Chitrakot SO"
  },
  "209601": {
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "office": "RRC Fatehgarh SO"
  },
  "209621": {
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "office": "Aligarh SO Farrukhabad"
  },
  "209622": {
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "office": "Amratpur SO"
  },
  "209720": {
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "office": "Bishungarh SO Kannauj"
  },
  "209602": {
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "office": "Central Jail SO"
  },
  "209721": {
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "office": "Chhibramau SO"
  },
  "209625": {
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "office": "Bibiganj SO Farrukhabad"
  },
  "263624": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Barechhina SO"
  },
  "263622": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Dania SO"
  },
  "721135": {
    "state": "WEST BENGAL",
    "district": "Jhargram",
    "office": "Kultikri SO"
  },
  "262305": {
    "state": "UTTAR PRADESH",
    "district": "PILIBHIT",
    "office": "Neoria SO"
  },
  "262121": {
    "state": "UTTAR PRADESH",
    "district": "PILIBHIT",
    "office": "Amaria SO"
  },
  "743329": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Canning Town SO"
  },
  "743330": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Champahati SO"
  },
  "743372": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Dakshin Barasat SO"
  },
  "743399": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Dholahat SO"
  },
  "263128": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Patwadanger SO"
  },
  "273212": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Khajni SO"
  },
  "229130": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Malik Mau Chaubara SO"
  },
  "229405": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Munshiganj SO Raebareli"
  },
  "271865": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Nanpara SO"
  },
  "271871": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Payagpur SO"
  },
  "271875": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Risia SO"
  },
  "271881": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Rupaidiha SO"
  },
  "271830": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Shivpur SO Bahraich"
  },
  "263679": {
    "state": "UTTARAKHAND",
    "district": "BAGESHWAR",
    "office": "Bharari SO"
  },
  "263635": {
    "state": "UTTARAKHAND",
    "district": "BAGESHWAR",
    "office": "Dangoli SO"
  },
  "263634": {
    "state": "UTTARAKHAND",
    "district": "BAGESHWAR",
    "office": "Dofar SO"
  },
  "246169": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Pokhra A SO"
  },
  "246177": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Vedikhal SO"
  },
  "244231": {
    "state": "UTTAR PRADESH",
    "district": "AMROHA",
    "office": "Dhanaura SO"
  },
  "244235": {
    "state": "UTTAR PRADESH",
    "district": "AMROHA",
    "office": "Gajraula SO"
  },
  "244241": {
    "state": "UTTAR PRADESH",
    "district": "AMROHA",
    "office": "M B Hasanpur SO"
  },
  "244222": {
    "state": "UTTAR PRADESH",
    "district": "AMROHA",
    "office": "Joya SO"
  },
  "244501": {
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "office": "Kanth SO"
  },
  "244251": {
    "state": "UTTAR PRADESH",
    "district": "AMROHA",
    "office": "Nawgawan SO"
  },
  "244102": {
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "office": "Pakbara SO"
  },
  "244236": {
    "state": "UTTAR PRADESH",
    "district": "AMROHA",
    "office": "Rajab Pur SO"
  },
  "244255": {
    "state": "UTTAR PRADESH",
    "district": "AMROHA",
    "office": "Rehra SO"
  },
  "743504": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Falta SO"
  },
  "741404": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Shyamchandpara SO"
  },
  "743513": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Fatehpur SO South 24 Parganas"
  },
  "743336": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Ghateswar SO"
  },
  "244242": {
    "state": "UTTAR PRADESH",
    "district": "AMROHA",
    "office": "Ujhari SO"
  },
  "246123": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Chipalghat A SO"
  },
  "249301": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Devprayag SO"
  },
  "246146": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Kanskhet SO"
  },
  "246147": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Khirshu SO"
  },
  "246159": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Lwali SO"
  },
  "246163": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Mawadhar SO"
  },
  "246167": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Patisain SO"
  },
  "246174": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Srinagar SO Pauri Garhwal"
  },
  "246285": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Thalisain SO"
  },
  "700137": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Budge Budge Natun Bazar SO"
  },
  "227812": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Wallipur SO"
  },
  "228172": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Belwai SO"
  },
  "227801": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Gaura Jamon SO"
  },
  "227409": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Gauriganj SO"
  },
  "227412": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "H A L Korwa SO"
  },
  "227815": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Haliapur SO"
  },
  "311022": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Hurda S.O"
  },
  "743378": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Chhoto Mollakhali SO"
  },
  "242001": {
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR",
    "office": "Shahjahanpur R S SO"
  },
  "242042": {
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR",
    "office": "Banda SO Shahjahanpur"
  },
  "227808": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Hasanpur SO Sultanpur"
  },
  "632504": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Damarapakkam SO"
  },
  "283203": {
    "state": "UTTAR PRADESH",
    "district": "FIROZABAD",
    "office": "S N H Road Firozabad SO"
  },
  "283152": {
    "state": "UTTAR PRADESH",
    "district": "FIROZABAD",
    "office": "Eka SO"
  },
  "283206": {
    "state": "UTTAR PRADESH",
    "district": "FIROZABAD",
    "office": "Kotla SO Firozabad"
  },
  "283145": {
    "state": "UTTAR PRADESH",
    "district": "FIROZABAD",
    "office": "Makkhanpur SO"
  },
  "283103": {
    "state": "UTTAR PRADESH",
    "district": "FIROZABAD",
    "office": "Oef  Firozabad SO"
  },
  "742136": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Gokarna SO"
  },
  "742140": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Jemo Rajbati SO"
  },
  "742147": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Khargram SO"
  },
  "285129": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Umri SO Jalaun"
  },
  "283130": {
    "state": "UTTAR PRADESH",
    "district": "FIROZABAD",
    "office": "Parham SO"
  },
  "283142": {
    "state": "UTTAR PRADESH",
    "district": "FIROZABAD",
    "office": "Pariyar SO"
  },
  "283207": {
    "state": "UTTAR PRADESH",
    "district": "FIROZABAD",
    "office": "Phariha SO"
  },
  "283141": {
    "state": "UTTAR PRADESH",
    "district": "FIROZABAD",
    "office": "Shikohabad RS SO"
  },
  "283151": {
    "state": "UTTAR PRADESH",
    "district": "FIROZABAD",
    "office": "Sirsaganj SO"
  },
  "283204": {
    "state": "UTTAR PRADESH",
    "district": "FIROZABAD",
    "office": "Tundla Chauraha SO"
  },
  "283136": {
    "state": "UTTAR PRADESH",
    "district": "FIROZABAD",
    "office": "Jasrana SO"
  },
  "742159": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Nagar SO Murshidabad"
  },
  "742161": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Panchthupi SO"
  },
  "262522": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Gangolihat SO"
  },
  "742103": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Indraprastha SO"
  },
  "262124": {
    "state": "UTTAR PRADESH",
    "district": "PILIBHIT",
    "office": "Kali Nagar SO"
  },
  "262311": {
    "state": "UTTARAKHAND",
    "district": "UDAM SINGH NAGAR",
    "office": "Nanakmatta SO"
  },
  "251305": {
    "state": "UTTAR PRADESH",
    "district": "SHAMLI",
    "office": "Babri SO"
  },
  "243301": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Tehsil Aonla SO"
  },
  "246736": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Bashta SO"
  },
  "246764": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Kotwali SO Bijnor"
  },
  "246721": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Mandawar SO Bijnor"
  },
  "246732": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Nagal SO Bijnor"
  },
  "246763": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Najibabad Tehsil SO"
  },
  "246749": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Sahanpur SO"
  },
  "246761": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Dhampur Sugar Mill SO"
  },
  "227809": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Jagdishpur SO Sultanpur"
  },
  "227813": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Musafirkhana SO"
  },
  "227807": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Pindara SO"
  },
  "228159": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "CRPF CAMP TRISUNDI SO"
  },
  "263655": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Daulaghat SO"
  },
  "721143": {
    "state": "WEST BENGAL",
    "district": "Jhargram",
    "office": "Rohini SO"
  },
  "721501": {
    "state": "WEST BENGAL",
    "district": "Jhargram",
    "office": "Belpahari SO"
  },
  "721503": {
    "state": "WEST BENGAL",
    "district": "Jhargram",
    "office": "Chilkigarh SO"
  },
  "721504": {
    "state": "WEST BENGAL",
    "district": "Jhargram",
    "office": "Dahijuri SO"
  },
  "721505": {
    "state": "WEST BENGAL",
    "district": "Jhargram",
    "office": "Gidni SO"
  },
  "721506": {
    "state": "WEST BENGAL",
    "district": "Jhargram",
    "office": "Gopi Ballavpur SO"
  },
  "210123": {
    "state": "UTTAR PRADESH",
    "district": "BANDA",
    "office": "Chillatara SO"
  },
  "204211": {
    "state": "UTTAR PRADESH",
    "district": "HATHRAS",
    "office": "Kachaura SO"
  },
  "202150": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Palirajapur SO"
  },
  "204214": {
    "state": "UTTAR PRADESH",
    "district": "HATHRAS",
    "office": "Purdilpur SO"
  },
  "204216": {
    "state": "UTTAR PRADESH",
    "district": "HATHRAS",
    "office": "G C Sasni SO"
  },
  "202142": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Birpura S.O"
  },
  "202132": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Chandaus S.O"
  },
  "390006": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Fatepura SO Vadodara"
  },
  "390001": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Vadodara HO"
  },
  "390017": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Wadi SN Road SO"
  },
  "390025": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Soma Talav SO"
  },
  "209203": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Chaubepur SO"
  },
  "395003": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Muglisara SO"
  },
  "736182": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "New Market Jaigaon SO"
  },
  "246722": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Afzalgarh SO"
  },
  "246727": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Hassupura SO"
  },
  "246762": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Nagina Bazar SO"
  },
  "246733": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Nehtaur SO"
  },
  "271870": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Chilwaria SO"
  },
  "271806": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Khutehna Chauraha SO"
  },
  "271902": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Fakharpur SO"
  },
  "396171": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Umargam IE SO"
  },
  "396002": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Valsad Abrama SO"
  },
  "274306": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Laxmiganj SO"
  },
  "228141": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Jaisinghpur SO Sultanpur"
  },
  "222301": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Koiripur SO"
  },
  "228151": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Kurebhar SO"
  },
  "228155": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Kurwar SO"
  },
  "222302": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Lambhua SO"
  },
  "274802": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Raja Bazar Khadda SO"
  },
  "274305": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Ramkola SO"
  },
  "274806": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Deoria Railway Station SO"
  },
  "274201": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Baitalpur SO"
  },
  "274601": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Barhaj SO"
  },
  "274602": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Bhagalpur SO"
  },
  "274701": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Bhatani SO"
  },
  "274702": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Bhatpar Rani SO"
  },
  "274603": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Gaura Jai Nagar SO"
  },
  "274202": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Gauri Bazar SO"
  },
  "274501": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Khukhundoo SO"
  },
  "643242": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Tuttapallam S.O"
  },
  "600056": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Poonamallee SO"
  },
  "600127": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Melakkottaiyur SO"
  },
  "246734": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Noorpur SO"
  },
  "246745": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Sahaspur SO Bijnor"
  },
  "246747": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Sherkot SO"
  },
  "271872": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Huzoorpur SO"
  },
  "271904": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Jarwal SO"
  },
  "271903": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Kaiserganj SO"
  },
  "274505": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Lar Road SO"
  },
  "274502": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Lar SO"
  },
  "274205": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Madanpur SO"
  },
  "274506": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Majhauli Raj SO"
  },
  "274703": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Paratappur SO"
  },
  "274404": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Patherdewa SO"
  },
  "244225": {
    "state": "UTTAR PRADESH",
    "district": "AMROHA",
    "office": "Bachhraon SO"
  },
  "133301": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "B.C.W. Suraj Pur S.O"
  },
  "134108": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "G.K. Panchkula S.O"
  },
  "134101": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "H.M.T.Pinjore S.O"
  },
  "274508": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Pindi SO"
  },
  "271802": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Kalpipara SO"
  },
  "271851": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Kharighat SO"
  },
  "271824": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Mahsi Tahsil SO"
  },
  "271882": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Matera RS SO"
  },
  "271855": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Mihinpurwa SO"
  },
  "273412": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Shivpur SO Gorakhpur"
  },
  "272161": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Babhnan SO"
  },
  "272155": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Harraiya SO"
  },
  "272125": {
    "state": "UTTAR PRADESH",
    "district": "SANT KABEER NAGAR",
    "office": "Dudhara SO"
  },
  "222303": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Maharani Pachchhim SO"
  },
  "228142": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Mahmoodpur Semri SO"
  },
  "210128": {
    "state": "UTTAR PRADESH",
    "district": "BANDA",
    "office": "Tindwari SO"
  },
  "210206": {
    "state": "UTTAR PRADESH",
    "district": "CHITRAKOOT",
    "office": "Pahari SO Chitrakoot"
  },
  "209722": {
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "office": "Gurusahaiganj SO"
  },
  "209723": {
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "office": "Indergarh SO Kannauj"
  },
  "209739": {
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "office": "Jahanganj SO"
  },
  "209733": {
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "office": "Jalalabad SO Kannauj"
  },
  "209502": {
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "office": "Rly Road Kaimganj SO"
  },
  "209724": {
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "office": "Kamalganj SO"
  },
  "209736": {
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "office": "Khairnagar SO"
  },
  "210432": {
    "state": "UTTAR PRADESH",
    "district": "HAMIRPUR",
    "office": "Sarila State SO"
  },
  "210433": {
    "state": "UTTAR PRADESH",
    "district": "MAHOBA",
    "office": "Srinagar SO Mahoba"
  },
  "263629": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Chanoda SO"
  },
  "262728": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Nakha SO"
  },
  "600069": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Kunnathur SO Kanchipuram"
  },
  "600122": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Mangadu SO"
  },
  "600116": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Porur SO"
  },
  "600071": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Kamarajnagar SO"
  },
  "600072": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Thandarai SO"
  },
  "600062": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Senthilnagar SO"
  },
  "603103": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Padur SO"
  },
  "600126": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Madambakkam SO"
  },
  "643205": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Cherambadi S.O"
  },
  "246735": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Rajakatajpur SO"
  },
  "246746": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Seohara SO"
  },
  "721157": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Amlasuli BO"
  },
  "721131": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Hour SO"
  },
  "721155": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Jalchak SO"
  },
  "721150": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Keshpur SO"
  },
  "721301": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Mathurakati SO"
  },
  "225204": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Masauli SO"
  },
  "721222": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Kharar SO West Midnapore"
  },
  "228119": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Gosainganj SO Sultanpur"
  },
  "274207": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Sukrauli SO"
  },
  "274407": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Tamkuhi SO"
  },
  "274409": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Tarya Sujan SO"
  },
  "274406": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Seorahi SO"
  },
  "274704": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Bankata SO"
  },
  "274182": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Bhaluani SO"
  },
  "274705": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Ghanti SO"
  },
  "285206": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Nadigaon SO"
  },
  "285127": {
    "state": "UTTAR PRADESH",
    "district": "JALAUN",
    "office": "Rampura SO Jalaun"
  },
  "271803": {
    "state": "UTTAR PRADESH",
    "district": "SHRAVASTI",
    "office": "Patna Malhipur SO"
  },
  "271835": {
    "state": "UTTAR PRADESH",
    "district": "SHRAVASTI",
    "office": "Gilaula SO"
  },
  "271845": {
    "state": "UTTAR PRADESH",
    "district": "SHRAVASTI",
    "office": "Ikauna SO"
  },
  "271804": {
    "state": "UTTAR PRADESH",
    "district": "SHRAVASTI",
    "office": "Laxman Nagar Bazar SO"
  },
  "271841": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Girijapuri Coloney SO"
  },
  "394111": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Kim Char Rasta SO"
  },
  "621202": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Ayyampalayam S.O"
  },
  "621216": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Bikshandarkoil S.O"
  },
  "621204": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Gunasilam S.O"
  },
  "621105": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Irungalur S.O"
  },
  "621207": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Kattuputhur S.O"
  },
  "271603": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Srinagar SO Gonda"
  },
  "228145": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Kadipur SO"
  },
  "261302": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Kamlapur SO Sitapur"
  },
  "261131": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Khairabad SO Sitapur"
  },
  "621208": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Kolakkudi S.O"
  },
  "621005": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Manachanalloor S.O"
  },
  "621211": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Musiri S.O"
  },
  "271210": {
    "state": "UTTAR PRADESH",
    "district": "BALRAMPUR",
    "office": "Gainsari SO"
  },
  "271203": {
    "state": "UTTAR PRADESH",
    "district": "BALRAMPUR",
    "office": "Jarwa SO"
  },
  "271205": {
    "state": "UTTAR PRADESH",
    "district": "BALRAMPUR",
    "office": "Mahrajganj SO Balrampur"
  },
  "271607": {
    "state": "UTTAR PRADESH",
    "district": "BALRAMPUR",
    "office": "Sriduttganj SO"
  },
  "621203": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Balasamudram S.O (Tiruchirappalli)"
  },
  "134116": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "Sector 26 Panchkula S.O"
  },
  "134107": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "Chandi Mandir S.O"
  },
  "134103": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "I.T.B.P.  Bhanu S.O"
  },
  "134113": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "Sector 15 Panchkula S.O"
  },
  "621209": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Manamedu S.O"
  },
  "621213": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Sirugambur S.O"
  },
  "621215": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Thottiam S.O"
  },
  "620005": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "EVR Nagar S.O"
  },
  "621009": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Tiruvellerai S.O"
  },
  "621001": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Erakudi S.O"
  },
  "621205": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Jambunathapuram S.O"
  },
  "621206": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Kannanur S.O"
  },
  "271609": {
    "state": "UTTAR PRADESH",
    "district": "BALRAMPUR",
    "office": "Chamrupur SO"
  },
  "202130": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Chharra SO"
  },
  "202133": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Dadon SO"
  },
  "202141": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Dayal Nagar SO"
  },
  "202136": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Gabhana SO"
  },
  "202131": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Bijauli S.O"
  },
  "271901": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Jarwal Road SO"
  },
  "202124": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Iglas SO"
  },
  "700154": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Boral SO"
  },
  "242220": {
    "state": "UTTAR PRADESH",
    "district": "SHAHJAHANPUR",
    "office": "Allahganj SO"
  },
  "202281": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "J D Singh SO"
  },
  "202282": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Malviya Nagar SO Aligarh"
  },
  "202128": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Jalali SO"
  },
  "202137": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Jattari SO"
  },
  "202126": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Jawan SO"
  },
  "202127": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "N C Kasimpur SO"
  },
  "202129": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Kauriyaganj SO"
  },
  "202138": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Khair SO"
  },
  "202140": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Lodha SO"
  },
  "271206": {
    "state": "UTTAR PRADESH",
    "district": "BALRAMPUR",
    "office": "Pachperwa SO"
  },
  "271602": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Dhaneypur SO"
  },
  "271202": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Intyathok SO"
  },
  "271209": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Jaiprabha Gram SO"
  },
  "271204": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Khargoopur SO"
  },
  "262542": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Dewalthal SO"
  },
  "202139": {
    "state": "UTTAR PRADESH",
    "district": "HATHRAS",
    "office": "K G W Sasni SO"
  },
  "204213": {
    "state": "UTTAR PRADESH",
    "district": "HATHRAS",
    "office": "Mursan SO"
  },
  "202155": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Pisawah SO"
  },
  "283119": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "KAGROL SO"
  },
  "283121": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "KHERAGARH SO"
  },
  "283122": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "KIRAOLI SO"
  },
  "283124": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "SAIYAN  SO"
  },
  "262545": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Dharchula SO"
  },
  "262551": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Didihat SO"
  },
  "262532": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Ganai Gangoli SO"
  },
  "244412": {
    "state": "UTTAR PRADESH",
    "district": "SAMBHAL",
    "office": "Chandausi Bara Bazar SO"
  },
  "244304": {
    "state": "UTTAR PRADESH",
    "district": "SAMBHAL",
    "office": "Asmoli SO"
  },
  "244410": {
    "state": "UTTAR PRADESH",
    "district": "SAMBHAL",
    "office": "Bahjoi SO"
  },
  "134104": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "C.R.P.F. Pinjore S.O"
  },
  "134112": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "Panchkula Sector 12 S.O"
  },
  "244413": {
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "office": "Kundarki SO"
  },
  "251306": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Baghra SO Muzaffarnagar"
  },
  "251308": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Bhopa SO"
  },
  "251301": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Alipur Kheri SO"
  },
  "251307": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Barla SO"
  },
  "283135": {
    "state": "UTTAR PRADESH",
    "district": "FIROZABAD",
    "office": "Shikohabad SO"
  },
  "205121": {
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "office": "Ghiror SO"
  },
  "271861": {
    "state": "UTTAR PRADESH",
    "district": "BALRAMPUR",
    "office": "Mathura Bazar SO"
  },
  "271215": {
    "state": "UTTAR PRADESH",
    "district": "BALRAMPUR",
    "office": "Purani Bazar Pachperwa SO"
  },
  "271207": {
    "state": "UTTAR PRADESH",
    "district": "BALRAMPUR",
    "office": "Shivpura SO"
  },
  "274309": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Padrauna Chhavani SO"
  },
  "621111": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Purathakudi S.O"
  },
  "205268": {
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "office": "Kurra SO"
  },
  "205247": {
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "office": "Ajitganj SO"
  },
  "205261": {
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "office": "Baranahal SO"
  },
  "205301": {
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "office": "Bewar Bazar SO"
  },
  "205262": {
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "office": "Bhongaon SO"
  },
  "205263": {
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "office": "Jeonti SO"
  },
  "205264": {
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "office": "Karhal SO Mainpuri"
  },
  "205303": {
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "office": "Kishni SO"
  },
  "274604": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Paina SO"
  },
  "231218": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Renusagar SO"
  },
  "231216": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Robertsganj Hydle Colony SO"
  },
  "275101": {
    "state": "UTTAR PRADESH",
    "district": "MAU",
    "office": "Mirjahadipura Chowk SO"
  },
  "276126": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Bansgaon SO Azamgarh"
  },
  "262523": {
    "state": "UTTARAKHAND",
    "district": "CHAMPAWAT",
    "office": "Collectorate Parisar"
  },
  "276127": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Bazar Gosain SO"
  },
  "276131": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "JAHANAGANJ SO"
  },
  "276202": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "LALGANJ SO"
  },
  "391345": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Petrochemical  T Ship SO"
  },
  "390020": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Akota SO"
  },
  "391776": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Manjusar GIDC"
  },
  "390024": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Chhani Rd SO"
  },
  "391320": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Jawahar Nagar SO Vadodara"
  },
  "244105": {
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "office": "Vikas Bhawan Moradabad SO"
  },
  "244411": {
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "office": "Bilari SO"
  },
  "134003": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Ambala City H.O"
  },
  "133001": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Sadar Bazar S.O (Ambala)"
  },
  "743370": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Gosaba SO"
  },
  "786125": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Tinsukia H.O"
  },
  "786155": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Sadiya S.O"
  },
  "209505": {
    "state": "UTTAR PRADESH",
    "district": "FARRUKHABAD",
    "office": "Kampil SO"
  },
  "223227": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Sanjar Pur SO"
  },
  "276305": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Saraimeer SO"
  },
  "276139": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Sardaha SO"
  },
  "276406": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Sathion SO"
  },
  "263630": {
    "state": "UTTARAKHAND",
    "district": "BAGESHWAR",
    "office": "Billori SO"
  },
  "721305": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Inda SO"
  },
  "390016": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Industrial Estate Vadodara SO"
  },
  "390023": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Subhanpura SO"
  },
  "390021": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "T B Sanatorium SO"
  },
  "722122": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Lalbandh SO"
  },
  "722157": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Bonradhanagar SO"
  },
  "262580": {
    "state": "UTTARAKHAND",
    "district": "CHAMPAWAT",
    "office": "Devidhura SO"
  },
  "202122": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Aligarh Dairy Farm S.O"
  },
  "202002": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Medical College SO Aligarh"
  },
  "202145": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Beswan S.O"
  },
  "202170": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Bijaigarh S.O"
  },
  "390018": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Karelibaug SO"
  },
  "390011": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Manjalpur SO"
  },
  "394101": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Mota Varachha SO"
  },
  "395011": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Puna Kumbharia SO"
  },
  "133010": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Defence Colony S.O"
  },
  "133207": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "M.M.E.Complex Mulana S.O"
  },
  "244504": {
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "office": "Aghwanpur SO"
  },
  "394541": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Saras SO"
  },
  "395006": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Varachha Road SO"
  },
  "277208": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Raniganj Bazar SO"
  },
  "277123": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "RATSAR SO"
  },
  "277209": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "REOTI SO"
  },
  "277211": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Sahatwar SO"
  },
  "277303": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "SIKANDERPUR SO"
  },
  "277304": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "SUKHPURA SO"
  },
  "335525": {
    "state": "RAJASTHAN",
    "district": "HANUMANGARH",
    "office": "Talwara Jheel S.O"
  },
  "722132": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Chhatna SO"
  },
  "722162": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Fulkusma SO"
  },
  "722133": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Gangajalghati SO"
  },
  "722134": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Garhraipur SO"
  },
  "722135": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Gorabari SO"
  },
  "722205": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Indas SO"
  },
  "722136": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Indpur SO"
  },
  "247771": {
    "state": "UTTAR PRADESH",
    "district": "SHAMLI",
    "office": "Ailum SO"
  },
  "277213": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "VBNarayanpur SO"
  },
  "221712": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Rasra Town SO"
  },
  "221715": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "BILTHARA ROAD SO"
  },
  "221701": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Chilkahar SO"
  },
  "221709": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "GARHMALPUR SO"
  },
  "277121": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Garwar SO"
  },
  "221718": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Khandwa SO"
  },
  "221716": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Kidihirapur SO"
  },
  "277501": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Korantadih SO"
  },
  "221711": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "NAGRA SO"
  },
  "262502": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Degree College SO Pithoragarh"
  },
  "722154": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Gelia SO"
  },
  "277502": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Narhi SO"
  },
  "277506": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Sagarpali SO"
  },
  "277124": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Pur SO Ballia"
  },
  "781021": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Bamunimaidan S.O"
  },
  "781016": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Gopinathnagar S.O"
  },
  "781004": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Kharguli S.O"
  },
  "781010": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Kamakhya S.O"
  },
  "781022": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Khanapara S.O"
  },
  "781020": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Noonmati S.O"
  },
  "396001": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Valsad HO"
  },
  "396180": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Udvada SO"
  },
  "396115": {
    "state": "GUJARAT",
    "district": "VALSAD",
    "office": "Kolak SO"
  },
  "221713": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Chitbaragaon SO"
  },
  "743337": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Joynagar Majilpur SO"
  },
  "283125": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "SHAMSABAD SO"
  },
  "743349": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Kashinagar SO South 24 Parganas"
  },
  "743610": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Madarat SO"
  },
  "785001": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Jorhat H.O"
  },
  "700141": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Mahestala SO"
  },
  "700145": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Malancha Mahinagar SO"
  },
  "743354": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Mathurapur RS SO"
  },
  "743338": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Nimpith Ashram SO"
  },
  "700152": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Panchpota SO"
  },
  "743611": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Pathan Khali SO"
  },
  "743387": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Piyali Town SO"
  },
  "743383": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Raidighi SO"
  },
  "700150": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Sonarpur SO"
  },
  "743395": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "South Bishnupur SO"
  },
  "743376": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Taldi SO"
  },
  "786623": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Parbatpur S.O"
  },
  "786153": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Rupaisiding S.O"
  },
  "743502": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Bhangar SO"
  },
  "722151": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Simlapal SO"
  },
  "722207": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Sonamukhi Rath Tala SO"
  },
  "244925": {
    "state": "UTTAR PRADESH",
    "district": "RAMPUR",
    "office": "Tanda Badli SO"
  },
  "731222": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Rajgaon SO"
  },
  "743145": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Kanchrapara SO"
  },
  "743126": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Kankinara SO"
  },
  "743127": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Feeder Road SO"
  },
  "700110": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Sodepur GHE SO"
  },
  "700083": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Nandan Nagar SO"
  },
  "700059": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Baguiati Super Market SO"
  },
  "700156": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "New Town SO"
  },
  "731243": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Nalhati Township SO"
  },
  "731221": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Paikar SO"
  },
  "731223": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "R K Sikshapith SO"
  },
  "731121": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Abinashpur SO"
  },
  "721516": {
    "state": "WEST BENGAL",
    "district": "Jhargram",
    "office": "Purnapani BO"
  },
  "262701": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Lakhimpur SO"
  },
  "134005": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Jandli S.O"
  },
  "133006": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Ind estate S.O"
  },
  "246130": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Chakisain B SO"
  },
  "621112": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Samayapuram S.O"
  },
  "620006": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Ammamandapam S.O"
  },
  "846001": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Laheriasarai HO"
  },
  "225409": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Ram Sanehi Ghat SO"
  },
  "731201": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Iswarpurndtso SO"
  },
  "110064": {
    "state": "DELHI",
    "district": "WEST",
    "office": "Hari Nagar S.O (West Delhi)"
  },
  "700103": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Narendrapur SO"
  },
  "614211": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Chakrapalli S.O"
  },
  "743165": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Naihati SO"
  },
  "700121": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Nilganj Bazaar SO"
  },
  "731240": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Bahiri SO"
  },
  "731103": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Barabagan SO"
  },
  "225206": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Saadatganj SO Barabanki"
  },
  "225412": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Safderganj SO"
  },
  "225122": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Satrikh SO"
  },
  "225306": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Shahpur Bhagauli SO"
  },
  "225125": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Subeha SO"
  },
  "225304": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Suratganj SO"
  },
  "225305": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Tehsil Fateh Pur SO"
  },
  "225415": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Tikait Nagar SO"
  },
  "246194": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "GB Pant Engg College SO"
  },
  "246113": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Kalzikhal SO"
  },
  "246148": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Kot SO Pauri Garhwal"
  },
  "246175": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Naithana SO"
  },
  "246164": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Pabau B SO"
  },
  "246165": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Paidul SO"
  },
  "735215": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Hasimara SO"
  },
  "736203": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Kumargramduar SO"
  },
  "731204": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Bolpur SO"
  },
  "731123": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Jangaldubrajpur SO"
  },
  "731102": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Hatjanbazar SO"
  },
  "736172": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Gossairhat Bandar SO"
  },
  "736179": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "New Cooch Behar SO"
  },
  "276137": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "MAHARAJGANJ SO"
  },
  "276123": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Tarawa SO"
  },
  "225126": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Trivediganj SO"
  },
  "431601": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Sachkhand Nanded S.O"
  },
  "682011": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Ernakulam HO"
  },
  "742121": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Amtala SO"
  },
  "742189": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Barua SO"
  },
  "742165": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Baruipara SO Murshidabad"
  },
  "742406": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Basantpur SO Murshidabad"
  },
  "742133": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Beldanga SO"
  },
  "700138": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Pujali SO"
  },
  "262501": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Siltham SO"
  },
  "670101": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Thalassery Bazar SO"
  },
  "621107": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Kurumbalur S.O"
  },
  "621108": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Labbaikudikadu S.O"
  },
  "621113": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Siruvachur S.O"
  },
  "621716": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Tungapuram S.O"
  },
  "621115": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Valikondapuram S.O"
  },
  "621116": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Veppanthattai S.O"
  },
  "621717": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Veppur S.O"
  },
  "261145": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Manpur SO Sitapur"
  },
  "261401": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Mishrikh Tirth SO"
  },
  "261402": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Naimisharanya SO"
  },
  "261404": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Parsada SO"
  },
  "261151": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Pisawan SO"
  },
  "621109": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Padalur S.O"
  },
  "261204": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Rampur Mathura SO"
  },
  "261205": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Reosa SO"
  },
  "261206": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Saraiyan Raja Saheb SO"
  },
  "261303": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Sidhauli SO"
  },
  "621110": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Poolambadi S.O"
  },
  "621117": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "V.Kalathur S.O"
  },
  "743377": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Bakrahat SO"
  },
  "743363": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Bansra SO"
  },
  "743312": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Basanti SO"
  },
  "700140": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Batanagar SO"
  },
  "673001": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Parappil SO"
  },
  "673305": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Koyilandi HO"
  },
  "676505": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Malappuram Civil Station SO"
  },
  "679577": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Ponani HO"
  },
  "700151": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Dakshin Jagatdal SO"
  },
  "231306": {
    "state": "UTTAR PRADESH",
    "district": "MIRZAPUR",
    "office": "Sikhar SO"
  },
  "713148": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Panagar Bazara SO"
  },
  "731104": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "BkTPP SO"
  },
  "271805": {
    "state": "UTTAR PRADESH",
    "district": "SHRAVASTI",
    "office": "Shravasti SO"
  },
  "721632": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Nandakumar SO"
  },
  "721631": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Nandigram SO"
  },
  "721633": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Narghat SO"
  },
  "721629": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Moyna SO"
  },
  "685584": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Thodupuzha West SO"
  },
  "246166": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Parsundakhal SO"
  },
  "225120": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Usmanpur SO"
  },
  "225303": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Mohammad Pur Khaley SO"
  },
  "225205": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Ramnagar SO Barabanki"
  },
  "225413": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Sidhaur SO"
  },
  "225207": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Sirauli Gaus Pur SO"
  },
  "228118": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Kamla Nehru Institute SO"
  },
  "691523": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Adur Kla HO"
  },
  "689101": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Tiruvalla Market Jn SO"
  },
  "691305": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Punalur HO"
  },
  "689645": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Makkankunnu SO"
  },
  "621708": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Kunnam S.O (Perambalur)"
  },
  "731301": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "ChNanoor SO"
  },
  "205265": {
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "office": "Galla Mandi Kurawali SO"
  },
  "690502": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Kayangulam College SO"
  },
  "682555": {
    "state": "LAKSHADWEEP",
    "district": "LAKSHADWEEP DISTRICT",
    "office": "Kavaratti H.O"
  },
  "721159": {
    "state": "WEST BENGAL",
    "district": "Jhargram",
    "office": "Kharikamathani SO"
  },
  "273007": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Fertilizer Factory S.O"
  },
  "273309": {
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "office": "Koluhi S.O"
  },
  "273162": {
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "office": "Laxmipur Maharajganj S.O"
  },
  "273303": {
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "office": "Collectrate Compound Maharajganj S.O"
  },
  "273164": {
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "office": "Nautanwa Bazar S.O"
  },
  "273311": {
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "office": "Orwalliya S.O"
  },
  "273310": {
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "office": "Paniyara S.O"
  },
  "273165": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Pepeeganj S.O"
  },
  "273161": {
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "office": "Dhani Bazar S.O"
  },
  "273151": {
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "office": "Ghughli R.S. S.O"
  },
  "273010": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "M.M.M.E.College S.O"
  },
  "273207": {
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "office": "Mithaura Bazar S.O"
  },
  "621219": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Yesanai S.O"
  },
  "261135": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Laharpur SO"
  },
  "742134": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Bhabta SO"
  },
  "713146": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Memari SO"
  },
  "713166": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Nabagram SO Bardhaman"
  },
  "713102": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Nutanganj SO"
  },
  "737128": {
    "state": "SIKKIM",
    "district": "SOUTH DISTRICT",
    "office": "Melli Bazar SO"
  },
  "700104": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Joka SO"
  },
  "700139": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Vivekananda Pally SO"
  },
  "743609": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Hansuri SO"
  },
  "743332": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Hatuganj SO"
  },
  "743347": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Kakdwip SO"
  },
  "743348": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Karanjali SO"
  },
  "743351": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Kulpi SO"
  },
  "743355": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Magrahat SO"
  },
  "743356": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Mud Point SO"
  },
  "743357": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Nam Khana SO"
  },
  "743374": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Nishchinta Pur SO"
  },
  "742102": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Cossimbazar Raj SO"
  },
  "742104": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "DLSSJdham SO"
  },
  "742302": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Daulatabad SO Murshidabad"
  },
  "243403": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Iffco Township SO"
  },
  "679101": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Ottapalam HO"
  },
  "700157": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Hatiara SO"
  },
  "272178": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Munderwa SO"
  },
  "251310": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Basera SO"
  },
  "731218": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Mayureswar SO"
  },
  "731127": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "MdBazar SO"
  },
  "731130": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Rajnagar SO Birbhum"
  },
  "731234": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Sainthia Bazar SO"
  },
  "731236": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Sriniketan SO"
  },
  "272126": {
    "state": "UTTAR PRADESH",
    "district": "SANT KABEER NAGAR",
    "office": "Semariyawan SO"
  },
  "711322": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Panchla SO"
  },
  "711314": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Shyampur SO Howrah"
  },
  "711226": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Udaynarayanpur SO"
  },
  "711316": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Uluberia RS SO"
  },
  "711315": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Uluberia SO"
  },
  "711227": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Ghoshpara SO Howrah"
  },
  "711205": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Daws Temple Rd SO"
  },
  "263139": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Bhotia Parao SO"
  },
  "756001": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Srikanthapur S.O"
  },
  "756032": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Nayabazar Jaleswar S.O"
  },
  "263140": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Kaladhungi SO"
  },
  "743221": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Arkhali Amdanga SO"
  },
  "743232": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Bagdah SO"
  },
  "743235": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Champaberia SO"
  },
  "743233": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Banipur SO North 24 Parganas"
  },
  "743234": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Bira Ballavepara SO"
  },
  "743245": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Chand Para Bazar SO"
  },
  "680307": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Chalakudi Town SO"
  },
  "731304": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "KURUNNAHAR SO"
  },
  "627853": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Nallur S.O (Tirunelveli)"
  },
  "627854": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Nettur S.O (Tirunelveli)"
  },
  "627809": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Sengottai S.O"
  },
  "627859": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Surandai S.O"
  },
  "134114": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "Mansa  Devi Sec 5 S.O"
  },
  "134117": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "Sector 20 Panchkula S.O"
  },
  "134105": {
    "state": "HARYANA",
    "district": "PANCHKULA",
    "office": "Amravati  Enclave SO"
  },
  "400014": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Naigaon S.O (Mumbai)"
  },
  "249130": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "VKPuram SO"
  },
  "249125": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Chamiyala SO"
  },
  "249181": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Pilkhi SO"
  },
  "249185": {
    "state": "UTTARAKHAND",
    "district": "UTTAR KASHI",
    "office": "Purola SO"
  },
  "249199": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Ranichauri SO"
  },
  "249192": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Shivanand Nagar SO"
  },
  "249186": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Sigunisera SO"
  },
  "262401": {
    "state": "UTTARAKHAND",
    "district": "UDAM SINGH NAGAR",
    "office": "Bazpur SO"
  },
  "263152": {
    "state": "UTTARAKHAND",
    "district": "UDAM SINGH NAGAR",
    "office": "Gadarpur SO"
  },
  "244712": {
    "state": "UTTARAKHAND",
    "district": "UDAM SINGH NAGAR",
    "office": "Jaspur SO"
  },
  "743247": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Dakshin Chatra SO"
  },
  "630610": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Tiruppachetti SO"
  },
  "630611": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Tiruppuvanam SO"
  },
  "630566": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Eriyur SO"
  },
  "630305": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Kallal SO"
  },
  "630203": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Kandavarayanpatti SO"
  },
  "630552": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Kilapungudi SO"
  },
  "630553": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Madagupatti SO"
  },
  "630557": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Okkur SO"
  },
  "630313": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Sembanur SO"
  },
  "630562": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Sivaganga Collectorate SO"
  },
  "630211": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Tirupattur SO"
  },
  "630210": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Tirukoshtiyur SO"
  },
  "273152": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Pipraich S.O"
  },
  "273202": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Sardar Nagar S.O"
  },
  "273163": {
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "office": "Siswa Bazar S.O"
  },
  "756100": {
    "state": "ODISHA",
    "district": "BHADRAK",
    "office": "Kuans S.O"
  },
  "273301": {
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "office": "Partawal Bazar S.O"
  },
  "273305": {
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "office": "Thuthibari S.O"
  },
  "737120": {
    "state": "SIKKIM",
    "district": "NORTH DISTRICT",
    "office": "Chungthang SO"
  },
  "737111": {
    "state": "SIKKIM",
    "district": "WEST DISTRICT",
    "office": "Gayzing SO"
  },
  "737116": {
    "state": "SIKKIM",
    "district": "NORTH DISTRICT",
    "office": "Mangan SO"
  },
  "737107": {
    "state": "SIKKIM",
    "district": "EAST DISTRICT",
    "office": "Dikchu SO"
  },
  "713142": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Khandaghosh SO"
  },
  "713426": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Mandalgram SO"
  },
  "713144": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Mankar SO"
  },
  "713145": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Purbakhanpur Bamunpara BO"
  },
  "743371": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Pathar Pratima SO"
  },
  "743373": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Rudra Nagar SO"
  },
  "743368": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Sarisha SO"
  },
  "733208": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR UTTAR",
    "office": "Panjipara SO"
  },
  "733134": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR UTTAR",
    "office": "Raiganj Bandar SO"
  },
  "733207": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR UTTAR",
    "office": "Ramganj SO North Dinajpur"
  },
  "272302": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Nagar Bazar SO"
  },
  "272181": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Paikolia SO"
  },
  "272130": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Parasrampur SO"
  },
  "272002": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "TB Clinic SO Basti"
  },
  "272148": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Rayath SO"
  },
  "272151": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Rudranagar SO"
  },
  "272190": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Saltauwa SO"
  },
  "272129": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Shankarpur SO"
  },
  "770001": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Mahesdihi S.O"
  },
  "229202": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Bhojpur SO Raebareli"
  },
  "229203": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Dalmau SO"
  },
  "713324": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Barakar SO"
  },
  "713325": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Rambandh SO"
  },
  "713334": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Domahani Bazar SO"
  },
  "733133": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR DAKSHIN",
    "office": "Patiram SO"
  },
  "733140": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR DAKSHIN",
    "office": "Rampur SO South Dinajpur"
  },
  "261405": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Machharehta SO"
  },
  "261203": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Mahmudabad SO"
  },
  "261141": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Maholi SO"
  },
  "416003": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Kolhapur H.O"
  },
  "422001": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Budhwar Peth S.O"
  },
  "422101": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "India Security Press S.O"
  },
  "400601": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Thane R.S. S.O"
  },
  "721133": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Keshiary SO"
  },
  "206125": {
    "state": "UTTAR PRADESH",
    "district": "ETAWAH",
    "office": "Chakar Nagar SO"
  },
  "229204": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Gaura SO Raebareli"
  },
  "229122": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Gurbuxganj SO"
  },
  "229125": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Kathgar SO"
  },
  "229205": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Khiro SO"
  },
  "229210": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Atarhar SO"
  },
  "229207": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Murai Ka Bagh SO"
  },
  "272270": {
    "state": "UTTAR PRADESH",
    "district": "SANT KABEER NAGAR",
    "office": "Santha SO"
  },
  "743424": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Debalaya SO"
  },
  "743423": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Deganga SO"
  },
  "743249": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Gaighata SO"
  },
  "743251": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Ganrapota SO"
  },
  "231217": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Renukoot SO"
  },
  "231221": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Turra SO"
  },
  "711401": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Amta SO"
  },
  "711302": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Andul mouri SO"
  },
  "711303": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Bagnan SO"
  },
  "246723": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Balawali SO"
  },
  "246724": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Badhapur SO"
  },
  "458001": {
    "state": "MADHYA PRADESH",
    "district": "MANDSAUR",
    "office": "Shri Ramtekri Mandsaur S.O"
  },
  "424001": {
    "state": "MAHARASHTRA",
    "district": "DHULE",
    "office": "Dhule Station Road S.O"
  },
  "261403": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Aurangabad SO Sitapur"
  },
  "261301": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Bhandia SO"
  },
  "261201": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Biswan SO"
  },
  "261121": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "HS Mills SO"
  },
  "261125": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Husainganj SO Sitapur"
  },
  "261202": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Jahangirabad SO Sitapur"
  },
  "225208": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Tilokpur SO Barabanki"
  },
  "225414": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Zaidpur SO"
  },
  "402201": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Alibag HO"
  },
  "690518": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Karunagappally HO"
  },
  "691506": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kottarakara HO"
  },
  "691001": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kollam Bazar SO"
  },
  "277503": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Phehpana SO"
  },
  "277504": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "SOHAON SO"
  },
  "500073": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Srinagar Colony S.O"
  },
  "500109": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "IBC Hyderabad"
  },
  "142001": {
    "state": "PUNJAB",
    "district": "MOGA",
    "office": "Industrial Area Moga SO"
  },
  "249180": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Thatyur SO"
  },
  "249193": {
    "state": "UTTARAKHAND",
    "district": "UTTAR KASHI",
    "office": "Gyansu SO"
  },
  "754211": {
    "state": "ODISHA",
    "district": "KENDRAPARA",
    "office": "Keshpur Bazar S.O"
  },
  "276122": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "RAUNAPAR SO"
  },
  "261001": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Naveen Mandi SO"
  },
  "390013": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Maneja SO"
  },
  "249121": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Anjanisain SO"
  },
  "249126": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Bhallegaon SO"
  },
  "249135": {
    "state": "UTTARAKHAND",
    "district": "UTTAR KASHI",
    "office": "Bhatwari SO"
  },
  "247670": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Gurkul Narsan SO"
  },
  "249404": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Gurukul Pharmecy SO"
  },
  "247668": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Iqbalpur SO"
  },
  "247663": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Laksar SO"
  },
  "440002": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Nayapura S.O"
  },
  "440001": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Sadar Bazar S.O (Nagpur)"
  },
  "414001": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Anandibazar S.O"
  },
  "713335": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Hindustan Cables SO"
  },
  "713336": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Jamuriahat SO"
  },
  "713371": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Mithani SO"
  },
  "713359": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Sitarampur SO"
  },
  "713373": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Sripur Bazar SO Bardhaman"
  },
  "713212": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Durgapur Bidhannagar Postal Colony SO"
  },
  "713211": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Durgapur Sagarbhanga Colony SO"
  },
  "713205": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Durgapur Steel Town East SO"
  },
  "713204": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Durgapur Steel Town West SO"
  },
  "400071": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Chembur HO"
  },
  "680503": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kunnamkulam HO"
  },
  "680582": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "WadakancheryTC HO"
  },
  "721125": {
    "state": "WEST BENGAL",
    "district": "Jhargram",
    "office": "Baligeria SO"
  },
  "713321": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Andal South Bazar SO"
  },
  "713420": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Panagar SO Bardhaman"
  },
  "713421": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Raina SO"
  },
  "713151": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Rasulpur SO"
  },
  "713149": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Saktigarh SO Bardhaman"
  },
  "752055": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Khurda H.O"
  },
  "395002": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Sagrampura Putli SO"
  },
  "442401": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Shashtrinagar S.O"
  },
  "212645": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Haswa SO"
  },
  "212652": {
    "state": "UTTAR PRADESH",
    "district": "FATEHPUR",
    "office": "Hathgaon SO"
  },
  "411002": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Raviwar Peth S.O"
  },
  "731132": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "MdBazar Town Ship SO"
  },
  "731133": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Panchrahat SO"
  },
  "272182": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Walterganj SO"
  },
  "272189": {
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTH NAGAR",
    "office": "Domariyaganj SO"
  },
  "272191": {
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTH NAGAR",
    "office": "Hallaur SO"
  },
  "272192": {
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTH NAGAR",
    "office": "Itwa SO"
  },
  "500012": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Begum Bazar S.O"
  },
  "500066": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "High Court S.O"
  },
  "500058": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Kanchanbagh S.O"
  },
  "500059": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Saidabad Colony S.O"
  },
  "500044": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Vidyanagar S.O"
  },
  "695101": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Attingal HO"
  },
  "695001": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Thiruvananthapuram  AGs SO"
  },
  "713422": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Satgachia SO"
  },
  "713423": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Sehara SO"
  },
  "272206": {
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTH NAGAR",
    "office": "Sheopatinagar SO"
  },
  "272205": {
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTH NAGAR",
    "office": "Shoharatgarh SO"
  },
  "272207": {
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTH NAGAR",
    "office": "Civil Line Siddharth Nagar"
  },
  "272204": {
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTH NAGAR",
    "office": "Udairajganj SO"
  },
  "272208": {
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTH NAGAR",
    "office": "Uska Bazar SO"
  },
  "272127": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Amorha"
  },
  "142026": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Jagraon Tehsil SO"
  },
  "141401": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Nai Mandi Khanna SO"
  },
  "247664": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Landhaura SO"
  },
  "247656": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Manglour Town SO"
  },
  "732205": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Ratua SO"
  },
  "732139": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Samsi SO"
  },
  "732209": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Sovanagar SO"
  },
  "249131": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Kamand SO"
  },
  "249127": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Rajakhet SO"
  },
  "249141": {
    "state": "UTTARAKHAND",
    "district": "UTTAR KASHI",
    "office": "Burkot SO"
  },
  "627861": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Virakeralmpudur S.O"
  },
  "768028": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Bargarh Bazar S.O"
  },
  "625501": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Alanganallur SO"
  },
  "625514": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Checkanurani SO"
  },
  "625205": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Karupatti SO"
  },
  "625503": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Palamedu SO"
  },
  "625402": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Samayanallur SO"
  },
  "625221": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Thanichiyam SO"
  },
  "625234": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Tiruvedagam SO"
  },
  "625701": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Kalligudi SO"
  },
  "625008": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Kappalur IndlEstate SO"
  },
  "625003": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Tvs Nagar SO"
  },
  "625703": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Peraiyur SO Madurai"
  },
  "782001": {
    "state": "ASSAM",
    "district": "NAGAON",
    "office": "Nagaon H.O"
  },
  "737134": {
    "state": "SIKKIM",
    "district": "EAST DISTRICT",
    "office": "Singtam SO"
  },
  "737102": {
    "state": "SIKKIM",
    "district": "EAST DISTRICT",
    "office": "SMUSikkim Manipal University"
  },
  "500086": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Don Bosco Nagar S.O"
  },
  "500077": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Kattedan I.E. S.O"
  },
  "500060": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Chaitanyapuri Colony S.O"
  },
  "500013": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Amberpet S.O"
  },
  "500076": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Snehapuri Colony S.O"
  },
  "500102": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Rama Krishnapuram S.O"
  },
  "500074": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Lal Bahadurnagar S.O"
  },
  "713427": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Uchalan SO"
  },
  "721452": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Satmile SO"
  },
  "271306": {
    "state": "UTTAR PRADESH",
    "district": "BALRAMPUR",
    "office": "Rehra Bazar SO"
  },
  "712410": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Chaulpatty SO"
  },
  "560001": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Vidhana Soudha S.O"
  },
  "205304": {
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "office": "Kusmara SO"
  },
  "205267": {
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "office": "Sultanganj SO Mainpuri"
  },
  "205119": {
    "state": "UTTAR PRADESH",
    "district": "MAINPURI",
    "office": "Tindauli SO"
  },
  "431203": {
    "state": "MAHARASHTRA",
    "district": "JALNA",
    "office": "Jalna Mondha S.O"
  },
  "413501": {
    "state": "MAHARASHTRA",
    "district": "OSMANABAD",
    "office": "Mily Colony S.O"
  },
  "152001": {
    "state": "PUNJAB",
    "district": "FIROZEPUR",
    "office": "Cantt Railway Station Ferozepu SO"
  },
  "271312": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Gaura Chawki SO"
  },
  "271503": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Katra Bazar SO Gonda"
  },
  "731129": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Purundarpur SO"
  },
  "271122": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Kauria SO"
  },
  "271123": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Khorasha SO"
  },
  "271302": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Mankapur SO Gonda"
  },
  "271305": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Maskanwa Rs SO"
  },
  "846006": {
    "state": "BIHAR",
    "district": "DARBHANGA",
    "office": "Subhankarpur SO"
  },
  "759001": {
    "state": "ODISHA",
    "district": "DHENKANAL",
    "office": "Dhenkanal College S.O"
  },
  "210207": {
    "state": "UTTAR PRADESH",
    "district": "CHITRAKOOT",
    "office": "Rajapur SO Chitrakoot"
  },
  "444805": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Chhota Bazar S.O"
  },
  "392001": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Sindhvai SO"
  },
  "210301": {
    "state": "UTTAR PRADESH",
    "district": "HAMIRPUR",
    "office": "Hamirpur DB SO"
  },
  "210502": {
    "state": "UTTAR PRADESH",
    "district": "HAMIRPUR",
    "office": "Baruwa Sumerpur SO"
  },
  "231222": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Shaktinagar Thermal Power Stat SO"
  },
  "228001": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Shyamnagar SO Sultanpur"
  },
  "110016": {
    "state": "DELHI",
    "district": "SOUTH",
    "office": "Hauz Khas Market SO"
  },
  "560004": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Pampamahakavi Road S.O"
  },
  "263160": {
    "state": "UTTARAKHAND",
    "district": "UDAM SINGH NAGAR",
    "office": "Dineshpur SO"
  },
  "500029": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Ramakrishna Mutt S.O"
  },
  "500001": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Hyderabad G.P.O."
  },
  "500063": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "New Mla Quarters S.O"
  },
  "500095": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Putlibowli S.O"
  },
  "281201": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Bajna SO Mathura"
  },
  "500114": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Motinagar SO"
  },
  "500111": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "I S B Campus S.O"
  },
  "500091": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Himayat Sagar SO"
  },
  "500104": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Chitrapuri Colony S.O."
  },
  "797001": {
    "state": "NAGALAND",
    "district": "KOHIMA",
    "office": "Kohima H.O"
  },
  "273304": {
    "state": "UTTAR PRADESH",
    "district": "MAHARAJGANJ",
    "office": "Nichlaul S.O"
  },
  "273014": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Pac Camp SO"
  },
  "271301": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Motiganj SO Gonda"
  },
  "261136": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Singhnapur SO"
  },
  "209312": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR DEHAT",
    "office": "BARAUR"
  },
  "209202": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "BILHAUR"
  },
  "209301": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR DEHAT",
    "office": "Derapur SO"
  },
  "395001": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Govt Medical College SO"
  },
  "227805": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Aliganj Bazar SO"
  },
  "228121": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Atarsuma SO"
  },
  "227814": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Ataula SO"
  },
  "227806": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Bazar Baldirai SO"
  },
  "228133": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Belahari SO"
  },
  "753002": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Orissa High Court S.O"
  },
  "757043": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Rairangpur R.S S.O"
  },
  "757001": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Tulasichoura S.O"
  },
  "582101": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Gadag Cotton Market S.O"
  },
  "141001": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Ludhiana Kty SO"
  },
  "627804": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Idaikal(TKS) S.O"
  },
  "627805": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Ilanji S.O"
  },
  "627751": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Kadayanallur Pettai S.O"
  },
  "627806": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Kilapavur S.O"
  },
  "627814": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Kizhapuliyur S.O"
  },
  "627807": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Panpuli S.O"
  },
  "627808": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Pavoorchatram S.O"
  },
  "627812": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Vadakarai S.O (Tirunelveli)"
  },
  "625022": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Postal Training Centre SO"
  },
  "625702": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "TKallupatti SO"
  },
  "712122": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Badanganj SO"
  },
  "712616": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Balidewanganj SO"
  },
  "712615": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Batanal SO"
  },
  "712611": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Bengai SO"
  },
  "712602": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Chandur SO Hooghly"
  },
  "712614": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Goghat SO"
  },
  "712613": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Gourhati SO"
  },
  "712412": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Helan SO"
  },
  "712612": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Kamarpukur SO"
  },
  "712406": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Khanakul SO"
  },
  "712413": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Mayapur SO Hooghly"
  },
  "712416": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Natibpur SO"
  },
  "711114": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Kona SO"
  },
  "722140": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Khatra SO"
  },
  "225123": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Somaiya Nagar SO"
  },
  "210421": {
    "state": "UTTAR PRADESH",
    "district": "MAHOBA",
    "office": "Charkhari State SO"
  },
  "210430": {
    "state": "UTTAR PRADESH",
    "district": "HAMIRPUR",
    "office": "Gohand SO"
  },
  "712417": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Rajhati Bandar SO"
  },
  "712501": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Balagarh SO"
  },
  "403001": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Tapal Bhavan"
  },
  "401404": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Palghar H.O"
  },
  "625016": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Mudakkuchalai SO"
  },
  "732206": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Sujapur SO"
  },
  "732140": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Tulsihatta SO"
  },
  "247665": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Jhabrera SO"
  },
  "249408": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Kankhal SO"
  },
  "249405": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Patanjali Yogpeeth SO"
  },
  "625018": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Shanthi Nagar SO"
  },
  "625218": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Vadipatti SO"
  },
  "625704": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "TPudupatti SO"
  },
  "625207": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Mullipallam SO"
  },
  "132103": {
    "state": "HARYANA",
    "district": "PANIPAT",
    "office": "Panipat GT Road S.O"
  },
  "249132": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Chham SO"
  },
  "249171": {
    "state": "UTTARAKHAND",
    "district": "UTTAR KASHI",
    "office": "Naugaon SO"
  },
  "754103": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Svm College S.O"
  },
  "272203": {
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTH NAGAR",
    "office": "Naugarh SO"
  },
  "678541": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Alathur Mbr HO"
  },
  "733127": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR DAKSHIN",
    "office": "Tapan SO"
  },
  "733145": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR DAKSHIN",
    "office": "Teor SO"
  },
  "733158": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR UTTAR",
    "office": "Atrai SO"
  },
  "733103": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR DAKSHIN",
    "office": "District School Board SO South Dinajpur"
  },
  "733121": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR DAKSHIN",
    "office": "Buniadpur SO"
  },
  "733102": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR DAKSHIN",
    "office": "Chakvrigu SO"
  },
  "110052": {
    "state": "DELHI",
    "district": "NORTH",
    "office": "Wazir Pur III SO"
  },
  "247666": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Milap Nagar SO"
  },
  "247671": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Raisi SO"
  },
  "122001": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Basai Road SO"
  },
  "712414": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Deulpara SO"
  },
  "262529": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Gurna SO"
  },
  "673121": {
    "state": "KERALA",
    "district": "WAYANAD",
    "office": "Kalpetta HO"
  },
  "743613": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "South Garia SO"
  },
  "721438": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Panchetgarh SO"
  },
  "721447": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Panchrol SO"
  },
  "721448": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Paniparul SO"
  },
  "721439": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Patashpur SO"
  },
  "712415": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Saidpur SO Hooghly"
  },
  "713333": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Disergarh SO"
  },
  "520008": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Currency Nagar S.O"
  },
  "520002": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Buckinghampet H.O"
  },
  "520004": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Machavaram S.O (Krishna)"
  },
  "520013": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "RAMALINGESWAR NAGAR S.O"
  },
  "521137": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Poranki S.O"
  },
  "713339": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Kalipahari SO"
  },
  "713341": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Kanyapur SO"
  },
  "713315": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Panuria SO"
  },
  "713203": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Durgapur DSP SB SO"
  },
  "682001": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kochi HO"
  },
  "676121": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Manjeri Bazar SO"
  },
  "676101": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Tirur East Bazar SO"
  },
  "712617": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Baradangal SO"
  },
  "210501": {
    "state": "UTTAR PRADESH",
    "district": "HAMIRPUR",
    "office": "Bewar SO Hamirpur"
  },
  "415001": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Satara H.O"
  },
  "210126": {
    "state": "UTTAR PRADESH",
    "district": "BANDA",
    "office": "Pailani SO"
  },
  "560013": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Jalahalli East S.O"
  },
  "712409": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Singur SO"
  },
  "400053": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Azad Nagar S.O (Mumbai)"
  },
  "400001": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Bazargate SO"
  },
  "735135": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Kamarvita SO"
  },
  "735224": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Maynaguri SO"
  },
  "735132": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Pandapara Kalibari SO"
  },
  "735133": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Prasannanagar SO"
  },
  "151001": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "MRSTU Bathinda"
  },
  "753001": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Meria Bazar S.O"
  },
  "143505": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Judicial Complex Batala SO"
  },
  "576104": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Dist Offices Complex Manipal SO"
  },
  "576201": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Gandhimaidan SO"
  },
  "732216": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Mahadipur SO"
  },
  "732142": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Mangalbari SO"
  },
  "732202": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Manikchak SO"
  },
  "732203": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Mathurapur SO Malda"
  },
  "721641": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Khukurdaha SO"
  },
  "721654": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Lakshya SO"
  },
  "721628": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Mahisadal SO"
  },
  "721649": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Mirikpur SO"
  },
  "262540": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Jajardewal SO"
  },
  "721440": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Pratapdighi SO"
  },
  "721441": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Ramnagar SO East Midnapore"
  },
  "721446": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Sagareswar SO"
  },
  "262525": {
    "state": "UTTARAKHAND",
    "district": "CHAMPAWAT",
    "office": "Abbotmount SO"
  },
  "262527": {
    "state": "UTTARAKHAND",
    "district": "CHAMPAWAT",
    "office": "Barakote SO"
  },
  "786173": {
    "state": "ASSAM",
    "district": "TINSUKIA",
    "office": "Jubilee Digboi S.O"
  },
  "400091": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Borivali HO"
  },
  "400008": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Falkland Road S.O"
  },
  "110021": {
    "state": "DELHI",
    "district": "NEW DELHI",
    "office": "Malcha Marg SO"
  },
  "110057": {
    "state": "DELHI",
    "district": "NEW DELHI",
    "office": "Vasant Vihar2 SO"
  },
  "110028": {
    "state": "DELHI",
    "district": "NEW DELHI",
    "office": "Naraina Industrial Estate H.O"
  },
  "400002": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Thakurdwar S.O"
  },
  "400016": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Mahim Bazar S.O"
  },
  "362001": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Junagadh Sardarbag SO"
  },
  "125001": {
    "state": "HARYANA",
    "district": "HISAR",
    "office": "NAM Hisar SO"
  },
  "743222": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Asoknagar Rs SO"
  },
  "700128": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Badu SO North 24 Parganas"
  },
  "363001": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Surendranagar Junction NDTSO"
  },
  "135001": {
    "state": "HARYANA",
    "district": "YAMUNANAGAR",
    "office": "Sugar Mill S.O"
  },
  "732207": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Mothabari SO"
  },
  "625019": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Nagamalai SO"
  },
  "625021": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Palkalai Nagar SO"
  },
  "575005": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kulshekar H.O"
  },
  "575001": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Falnir S.O"
  },
  "627802": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Courtallam S.O"
  },
  "743702": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Rajibpur SO"
  },
  "743294": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Chhoto Jagulia SO"
  },
  "722121": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Bheduasole SO"
  },
  "700113": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Natagarh SO"
  },
  "700119": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Bramhasthan SO"
  },
  "700105": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Dhapa SO"
  },
  "627803": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Elathur S.O (Tirunelveli)"
  },
  "627813": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Puliyara S.O"
  },
  "627856": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Sambavarvadakarai S.O"
  },
  "743135": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Hazinagar SO"
  },
  "700112": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Pansila SO"
  },
  "700159": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Aswini Nagar SO"
  },
  "110046": {
    "state": "DELHI",
    "district": "NEW DELHI",
    "office": "Sagarpur S.O"
  },
  "711404": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Bargachia SO"
  },
  "711411": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Begri SO"
  },
  "711412": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Chitrasenpur SO"
  },
  "711309": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Delta Mil SO"
  },
  "711405": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Domjur SO"
  },
  "711310": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Fortgloster SO"
  },
  "711413": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Gazipur SO"
  },
  "711408": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Jagatballavpur SO"
  },
  "711312": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Mugkalyan SO"
  },
  "711410": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Munshirhat SO"
  },
  "572101": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Western Extn S.O"
  },
  "261208": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Tambour SO"
  },
  "743345": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Bijoyganj Bazar SO"
  },
  "673020": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Calicut Collectorate SO"
  },
  "673101": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Vadakara HO"
  },
  "733124": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR DAKSHIN",
    "office": "Gangarampur SO"
  },
  "262534": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Agar SO"
  },
  "262530": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Aincholi SO"
  },
  "262543": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Askote SO"
  },
  "262576": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Baluwakote SO"
  },
  "262555": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Bansbagar SO"
  },
  "262531": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Berinag SO"
  },
  "721453": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Depal SO"
  },
  "721427": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Deulbarh SO"
  },
  "721428": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Digha SO East Midnapore"
  },
  "721429": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Egra SO"
  },
  "721430": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Haria SO"
  },
  "462001": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Shahajahanabad S.O"
  },
  "712123": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Bandel Junction SO"
  },
  "462003": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Raj Bhawan S.O (Bhopal)"
  },
  "700149": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Rajpur Bazar SO"
  },
  "733143": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR UTTAR",
    "office": "Bhupalpur SO"
  },
  "733156": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR UTTAR",
    "office": "Bindole SO"
  },
  "733201": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR UTTAR",
    "office": "Dalkhola SO"
  },
  "733123": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR UTTAR",
    "office": "Debinagar SO"
  },
  "735134": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Rajganj SO"
  },
  "735202": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Banarhat SO"
  },
  "735207": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Chamurchi SO"
  },
  "735216": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Jateswar SO"
  },
  "686001": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kottayam North SO"
  },
  "686575": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Pala Market Junction SO"
  },
  "686141": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Vaikom HO"
  },
  "721426": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Bamanda BO"
  },
  "721467": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Dasagram SO"
  },
  "721457": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Gomunda SO"
  },
  "721443": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Jahalda SO"
  },
  "261207": {
    "state": "UTTAR PRADESH",
    "district": "SITAPUR",
    "office": "Talgaon SO"
  },
  "800004": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "JCRoad SO"
  },
  "416115": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Jawaharnagar Ichalkaranji S.O"
  },
  "751001": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Bhubaneswar Secretariate S.O"
  },
  "416012": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Babujamal S.O"
  },
  "143401": {
    "state": "PUNJAB",
    "district": "Tarn Taran",
    "office": "Tarn Taran HO"
  },
  "520001": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Vijayawada H.O"
  },
  "520011": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Madhuranagar S.O"
  },
  "500048": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Hyderguda S.O"
  },
  "500069": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Research Centre Imarat S.O"
  },
  "500097": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Meerpet S.O"
  },
  "695121": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Neyyattinkara Town SO"
  },
  "500108": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "R.G.I. Airport S.O"
  },
  "500068": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "G.S.I (S.R) Bandlaguda S.O"
  },
  "500051": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Hindustan Cables S.O"
  },
  "785013": {
    "state": "ASSAM",
    "district": "JORHAT",
    "office": "Assam Agriculture University S.O"
  },
  "713330": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Charanpur SO"
  },
  "713360": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Sunderchak SO"
  },
  "678002": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Olavakkot HO"
  },
  "678001": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Palakkad College SO"
  },
  "800001": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Bank Road SO Patna"
  },
  "577001": {
    "state": "KARNATAKA",
    "district": "DAVANGERE",
    "office": "Mini Vidhanasoudha S.O"
  },
  "768001": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Bss Nagar S.O"
  },
  "492001": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Vivekanand Ashram SO"
  },
  "711301": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Anantapur SO Howrah"
  },
  "764001": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Sriram Nagar S.O"
  },
  "764020": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Koraput Collectorate S.O"
  },
  "209801": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Qila SO"
  },
  "209831": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Ajgain SO"
  },
  "209868": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Bangermau SO"
  },
  "209864": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Bhagwant Nagar SO"
  },
  "209865": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Bighapur SO"
  },
  "209866": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Bihar SO"
  },
  "209827": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Chamiyani SO"
  },
  "209869": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Ganj Moradabad SO"
  },
  "209862": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Magarwara SO"
  },
  "209825": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Purwa SO"
  },
  "209821": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Maurawan SO"
  },
  "209881": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Mohan SO"
  },
  "711403": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Bankra SO"
  },
  "711307": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Chackasi SO"
  },
  "711414": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Maju SO"
  },
  "711409": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Makardaha SO"
  },
  "209859": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Nawabganj SO Unnao"
  },
  "110001": {
    "state": "DELHI",
    "district": "NEW DELHI",
    "office": "Parliament House SO"
  },
  "361001": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Station Road SO Jamnagar"
  },
  "127021": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Mini Sect Bhiwani SO"
  },
  "263653": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Dwarahat SO"
  },
  "110051": {
    "state": "DELHI",
    "district": "EAST",
    "office": "Ram Nagar SO East Delhi"
  },
  "571401": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Mandya Shankarnagar S.O"
  },
  "160017": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Chandigarh GPO"
  },
  "711313": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Bharat Cooperative SO"
  },
  "711104": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Chakraberia SO"
  },
  "206126": {
    "state": "UTTAR PRADESH",
    "district": "ETAWAH",
    "office": "Ekdil SO"
  },
  "206002": {
    "state": "UTTAR PRADESH",
    "district": "ETAWAH",
    "office": "I T I Etawah SO"
  },
  "206245": {
    "state": "UTTAR PRADESH",
    "district": "ETAWAH",
    "office": "Jaswant Nagar Bazar SO"
  },
  "206127": {
    "state": "UTTAR PRADESH",
    "district": "ETAWAH",
    "office": "Lakhana SO"
  },
  "522201": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Tenali Bazar S.O"
  },
  "140001": {
    "state": "PUNJAB",
    "district": "RUPNAGAR",
    "office": "Minisectt Ropar SO"
  },
  "586101": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Vijayapura Market Yard S.O"
  },
  "767001": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Balangir RS S.O"
  },
  "752069": {
    "state": "ODISHA",
    "district": "NAYAGARH",
    "office": "Sinduria S.O"
  },
  "143521": {
    "state": "PUNJAB",
    "district": "GURDASPUR",
    "office": "Gurdaspur Kutchery SO"
  },
  "227304": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Bharkhare SO"
  },
  "228132": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Deara SO"
  },
  "227408": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Dhammaur SO"
  },
  "228131": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Dostpur SO"
  },
  "625708": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "TKunnathur SO"
  },
  "732103": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Mukdumpur SO"
  },
  "732141": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Narayanpur SO Malda"
  },
  "732128": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Old Malda SO"
  },
  "732138": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Pakuahat SO"
  },
  "732204": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Paranpur SO"
  },
  "110007": {
    "state": "DELHI",
    "district": "NORTH",
    "office": "Roop Nagar SO"
  },
  "110083": {
    "state": "DELHI",
    "district": "NORTH WEST",
    "office": "Mangolpuri S Block SO"
  },
  "110034": {
    "state": "DELHI",
    "district": "NORTH WEST",
    "office": "Sri Nagar Colony SO"
  },
  "229209": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Paho SO"
  },
  "571301": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Srikantapuri Extension S.O"
  },
  "754029": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Athagarh College S.O"
  },
  "360575": {
    "state": "GUJARAT",
    "district": "PORBANDAR",
    "office": "Porbandar M G Road SO"
  },
  "228125": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Dwarikaganj SO"
  },
  "227405": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Amethi HO"
  },
  "227407": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Bisesarganj SO"
  },
  "759122": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Angul Bazar S.O"
  },
  "758001": {
    "state": "ODISHA",
    "district": "KENDUJHAR",
    "office": "Keonjhar Mining School S.O"
  },
  "380002": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Railwaypura SO"
  },
  "580001": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Dharwad Market S.O"
  },
  "580020": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Hubballi Sarafkatta S.O"
  },
  "246125": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Dehalchauri SO"
  },
  "110054": {
    "state": "DELHI",
    "district": "CENTRAL",
    "office": "Timarpur SO"
  },
  "781028": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Beltola S.O"
  },
  "781009": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Bharalumukh S.O"
  },
  "781018": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Binovanagar S.O"
  },
  "781038": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Hatigaon Chariali S.O"
  },
  "781019": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Kahilipara S.O"
  },
  "411001": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Sachapir Street S.O"
  },
  "441904": {
    "state": "MAHARASHTRA",
    "district": "BHANDARA",
    "office": "Bhandara Town S.O"
  },
  "424101": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Chalisgaon Adarsha Nagar S.O"
  },
  "136038": {
    "state": "HARYANA",
    "district": "KURUKSHETRA",
    "office": "Amin S.O"
  },
  "685508": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Kattappana HO"
  },
  "227406": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Bhadar SO"
  },
  "671315": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Kanhangad HO"
  },
  "670001": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kannur Railway Station SO"
  },
  "500019": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Lingampalli S.O"
  },
  "500046": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "CUC S.O"
  },
  "500032": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Gachibowli S.O"
  },
  "500022": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Central Secretariat S.O"
  },
  "500031": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Ibrahim Bagh Lines S.O"
  },
  "500006": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Kulsumpura S.O"
  },
  "230405": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Darchhut SO"
  },
  "230128": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Derwa SO"
  },
  "230202": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Garhi Manikpur SO"
  },
  "500057": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Vijay Nagar Colony S.O"
  },
  "500110": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Prashasan Nagar S.O"
  },
  "670141": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Taliparamba HO"
  },
  "180001": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Bakshinagar SO"
  },
  "184101": {
    "state": "JAMMU AND KASHMIR",
    "district": "KATHUA",
    "office": "Kathua HO"
  },
  "560010": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Rajajinagar IVth Block S.O"
  },
  "735304": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Mekhliganj SO"
  },
  "686101": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Changanacherry Market SO"
  },
  "110032": {
    "state": "DELHI",
    "district": "SHAHDARA",
    "office": "Loni Road SO"
  },
  "110031": {
    "state": "DELHI",
    "district": "EAST",
    "office": "Shastri Nagar SO East Delhi"
  },
  "110092": {
    "state": "DELHI",
    "district": "EAST",
    "office": "Laxmi Nagar Extension SO"
  },
  "360001": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Rajkot Municipal Corporation SO"
  },
  "686661": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Muvattupuzha HO"
  },
  "711204": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "AGuha Road SO"
  },
  "262528": {
    "state": "UTTARAKHAND",
    "district": "CHAMPAWAT",
    "office": "Khetikhan SO"
  },
  "262524": {
    "state": "UTTARAKHAND",
    "district": "CHAMPAWAT",
    "office": "Lohaghat SO"
  },
  "743248": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Duttapukur SO"
  },
  "700132": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Ganganagar SO North 24 Parganas"
  },
  "722144": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Onda SO"
  },
  "731235": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Santiniketan SO"
  },
  "147001": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "NSNIS PATIALA SO"
  },
  "140401": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "IFP Rajpura SO"
  },
  "844101": {
    "state": "BIHAR",
    "district": "VAISHALI",
    "office": "Rambhadra SO"
  },
  "390007": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Vidhyut Nagar Colony SO"
  },
  "391750": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Fartilizer Nagar SO"
  },
  "452007": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Indore Siyaganj S.O"
  },
  "794001": {
    "state": "MEGHALAYA",
    "district": "WEST GARO HILLS",
    "office": "Tura H.O"
  },
  "411005": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "S.S.C.Exam Board S.O"
  },
  "799001": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Agartala Court S.O"
  },
  "793001": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Oakland S.O"
  },
  "443001": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Buldana H.O"
  },
  "765001": {
    "state": "ODISHA",
    "district": "RAYAGADA",
    "office": "Rayagada Bazar S.O"
  },
  "799120": {
    "state": "TRIPURA",
    "district": "Gomati",
    "office": "Radhakishorepur H.O"
  },
  "761200": {
    "state": "ODISHA",
    "district": "GAJAPATI",
    "office": "Jangam Street"
  },
  "761110": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Sunambo Street S.O"
  },
  "761126": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Bhanjamargo S.O"
  },
  "766001": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Bhawanipatna Stadium S.O"
  },
  "452001": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Indore Tukoganj S.O"
  },
  "271126": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "BBSingh SO"
  },
  "721642": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Arankiarana SO"
  },
  "721655": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Kismatbajkul SO"
  },
  "721134": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Paikpari SO"
  },
  "721658": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Kukrahati SO"
  },
  "721652": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Kumarchak SO"
  },
  "721659": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Mathchandipur SO"
  },
  "262541": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Kanalichina SO"
  },
  "262554": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Munsiari SO"
  },
  "262547": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Pangu SO"
  },
  "262553": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Tejam SO"
  },
  "262552": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Thal SO Pithoragarh"
  },
  "271313": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Babhnan Sugar Factory SO"
  },
  "271125": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Balpur SO"
  },
  "271310": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Bankatwa Dehat SO"
  },
  "271311": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Bargadi Kot SO"
  },
  "271002": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Dadua Bazar SO"
  },
  "271402": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Begamganj SO"
  },
  "271401": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Belser SO"
  },
  "271601": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Bishunpur Bairiya SO"
  },
  "271003": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Gonda City SO"
  },
  "271129": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Chandapur SO Gonda"
  },
  "271502": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Colonelganj SO Gonda"
  },
  "271309": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "DPGhat SO"
  },
  "262561": {
    "state": "UTTARAKHAND",
    "district": "CHAMPAWAT",
    "office": "Pati SO"
  },
  "262544": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Jauljibi SO"
  },
  "262550": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Merthi SO"
  },
  "262533": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Pankhu SO"
  },
  "262521": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Wadda SO"
  },
  "721458": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Palpara SO East Midnapore"
  },
  "533103": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Rtc Bus Complex Centre S.O"
  },
  "533104": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Aryapuram S.O"
  },
  "533101": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Rajahmundry H.O"
  },
  "387411": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Kheda HO"
  },
  "387001": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Desai Vago SO"
  },
  "825301": {
    "state": "JHARKHAND",
    "district": "HAZARIBAGH",
    "office": "Pethiatand SO"
  },
  "760001": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Godavarishanagar S.O"
  },
  "761020": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Chatrapur Bazar S.O"
  },
  "177101": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Dehra HO"
  },
  "815301": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Giridih Bazar SO"
  },
  "833201": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "Bari Bazar SO"
  },
  "444601": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Walgaon Road Tso Amravati S.O"
  },
  "431401": {
    "state": "MAHARASHTRA",
    "district": "PARBHANI",
    "office": "Shivajinagar Parbhani S.O"
  },
  "762001": {
    "state": "ODISHA",
    "district": "KANDHAMAL",
    "office": "Phulbani Bazar S.O"
  },
  "415110": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Tilak Path Karad S.O"
  },
  "431001": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Saraswati Colony S.O"
  },
  "533003": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Sriramnagar S.O (Kakinada)"
  },
  "560008": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Halasur Bazar S.O"
  },
  "560032": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "P and T Colony Kavalbyrasandra S.O"
  },
  "247662": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Chhutmalpur SO"
  },
  "768201": {
    "state": "ODISHA",
    "district": "JHARSUGUDA",
    "office": "Sarbahal S.O"
  },
  "272194": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Asnahra SO"
  },
  "821115": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Sasaram Local Board SO"
  },
  "577501": {
    "state": "KARNATAKA",
    "district": "CHITRADURGA",
    "office": "Chitradurga Chickpet S.O"
  },
  "272199": {
    "state": "UTTAR PRADESH",
    "district": "SANT KABEER NAGAR",
    "office": "Bakhira SO"
  },
  "272162": {
    "state": "UTTAR PRADESH",
    "district": "SANT KABEER NAGAR",
    "office": "Dhanghata SO"
  },
  "110003": {
    "state": "DELHI",
    "district": "South East",
    "office": "Kasturba Nagar SO South Delhi"
  },
  "190001": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "SKSectrate SO"
  },
  "735102": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "JpgGovt Engg College SO"
  },
  "735233": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Nathuahat SO"
  },
  "735205": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Carron SO"
  },
  "413709": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Gondhavani S.O"
  },
  "413512": {
    "state": "MAHARASHTRA",
    "district": "LATUR",
    "office": "Latur RS S.O"
  },
  "835207": {
    "state": "JHARKHAND",
    "district": "GUMLA",
    "office": "Gumla Bazar SO"
  },
  "416410": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Miraj Station Road S.O"
  },
  "416416": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Sangli City S.O"
  },
  "262520": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Bharkatia SO"
  },
  "733142": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR DAKSHIN",
    "office": "Nayabazar SO South Dinajpur"
  },
  "755001": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Jajpur College S.O"
  },
  "769012": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Katchery Road S.O"
  },
  "583231": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Koppal R S S.O"
  },
  "505001": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Karimnagar H.O"
  },
  "769001": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Daily Market S.O"
  },
  "587101": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Bagalkot B.H.School S.O"
  },
  "226201": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Bakshi Ka Talab SO"
  },
  "226028": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Chinhat SO"
  },
  "226202": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "FFTC INDAURABAGH SO"
  },
  "226501": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Gosainganj SO"
  },
  "226203": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Itaunja SO"
  },
  "571438": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Srirangapatna H.O"
  },
  "735220": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Madarihat SO"
  },
  "735228": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Ramjhora SO"
  },
  "735206": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Chalsa SO"
  },
  "735218": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Krantihat SO"
  },
  "735219": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Lataguri SO"
  },
  "735223": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Matelli SO"
  },
  "735225": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Nagrakata SO"
  },
  "686507": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kanjirapally HO"
  },
  "735213": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Gopal Bagan SO"
  },
  "228120": {
    "state": "UTTAR PRADESH",
    "district": "SULTANPUR",
    "office": "Baraunsa SO"
  },
  "272123": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Bankati Bazar SO"
  },
  "272128": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Bishesharganj SO"
  },
  "272131": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Captainganj SO"
  },
  "262572": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Muwani SO"
  },
  "121007": {
    "state": "HARYANA",
    "district": "FARIDABAD",
    "office": "Faridabad Sector 15 SO"
  },
  "121005": {
    "state": "HARYANA",
    "district": "FARIDABAD",
    "office": "Jawahar Colony Faridabad SO"
  },
  "121006": {
    "state": "HARYANA",
    "district": "FARIDABAD",
    "office": "Faridabad Sector 7 SO"
  },
  "121001": {
    "state": "HARYANA",
    "district": "FARIDABAD",
    "office": "Nh4 Faridabad SO"
  },
  "396445": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Junathana SO"
  },
  "413001": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Jawaharlal Nehru Vastigrah S.O"
  },
  "396321": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Bilimora HO"
  },
  "176310": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Rangmehal SO"
  },
  "517325": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Kothapeta Madanapalle S.O"
  },
  "814101": {
    "state": "JHARKHAND",
    "district": "DUMKA",
    "office": "Dumka Court SO"
  },
  "814112": {
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "office": "Deoghar Court SO"
  },
  "209205": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Sheorajpur SO"
  },
  "209210": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Uttaripura SO"
  },
  "509001": {
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "office": "T.D. Gutta S.O"
  },
  "201314": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Shiv Nadar University SO"
  },
  "201312": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Gautam Budh University SO"
  },
  "201305": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "NEPZ SO"
  },
  "121012": {
    "state": "HARYANA",
    "district": "FARIDABAD",
    "office": "Sector21D  SO"
  },
  "229208": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Nihastha SO"
  },
  "560041": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Jayanagar East S.O"
  },
  "743286": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Sanrapul BO"
  },
  "500092": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Boduppal S.O"
  },
  "500035": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Saroornagar S.O"
  },
  "500053": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Uppuguda S.O"
  },
  "500065": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Shahalibanda S.O"
  },
  "500023": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Yakutpura S.O"
  },
  "500020": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Golconda Chowrastha S.O"
  },
  "486001": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Rewa Chauhatta S.O"
  },
  "500024": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Sahifa S.O"
  },
  "500027": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Stn. Kachiguda H.O"
  },
  "520010": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Punnamathota S.O"
  },
  "721137": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Ktpp SO"
  },
  "431122": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "M.GANJ S.O"
  },
  "517506": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Settipalli S.O"
  },
  "533001": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Kakinada H.O"
  },
  "394601": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Sardarbaug Bardoli SO"
  },
  "533215": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Bodasakurru S.O"
  },
  "425001": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Jalgaon Navi Peth S.O"
  },
  "791111": {
    "state": "ARUNACHAL PRADESH",
    "district": "PAPUM PARE",
    "office": "Arunachal Pradesh Secretariat S.O"
  },
  "456001": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Ujjain H.O"
  },
  "444001": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Ramdaspeth Akola S.O"
  },
  "441001": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Kamthi City SO"
  },
  "781014": {
    "state": "ASSAM",
    "district": "KAMRUP METRO",
    "office": "Guwahati University H.O"
  },
  "683542": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Perumbavoor HO"
  },
  "121010": {
    "state": "HARYANA",
    "district": "FARIDABAD",
    "office": "SECTOR46"
  },
  "121015": {
    "state": "HARYANA",
    "district": "FARIDABAD",
    "office": "Sector55 PO"
  },
  "723121": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Bonra BO"
  },
  "380001": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Lal Darwaja SO"
  },
  "577201": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "Shivamogga District Office S.O"
  },
  "585401": {
    "state": "KARNATAKA",
    "district": "BIDAR",
    "office": "IAF Stn  S.O"
  },
  "585101": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "GB Shahabazar S.O"
  },
  "585201": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Yadgiri Town S.O"
  },
  "584101": {
    "state": "KARNATAKA",
    "district": "RAICHUR",
    "office": "Raichur Saath Katchery S.O"
  },
  "506167": {
    "state": "TELANGANA",
    "district": "JANGOAN",
    "office": "Jangaon H.O"
  },
  "274208": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Saraon SO"
  },
  "823001": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "New Godown SO"
  },
  "274408": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Tarkulwa SO"
  },
  "274307": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Padrauna Sugar Factory SO"
  },
  "834001": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Argora SO"
  },
  "735230": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Baradighi SO"
  },
  "180004": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Guru Nanak Nagar SO Jammu"
  },
  "110019": {
    "state": "DELHI",
    "district": "South East",
    "office": "Nehru Place SO"
  },
  "247340": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Ambehta SO"
  },
  "247120": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Babail Buzurg SO"
  },
  "247121": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Behat SO Saharanpur"
  },
  "247231": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Chilkana SO"
  },
  "247554": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Industrial Estate Deoband SO"
  },
  "247669": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Gagalheri SO"
  },
  "247341": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Gangoh SO"
  },
  "247129": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Muzaffrabad SO"
  },
  "247551": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Nagal SO Saharanpur"
  },
  "247342": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Nakur SO"
  },
  "247452": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Nanauta SO"
  },
  "247451": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Prasar Kendra Rampur SO"
  },
  "247232": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Sarsawa SO"
  },
  "723104": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Sainik School SO Puruliya"
  },
  "723126": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Anara RS SO"
  },
  "723152": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Bagmundi SO"
  },
  "723143": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Radha Gobindapur BO"
  },
  "723128": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Balakdih SO"
  },
  "723130": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Manguria Lalpur BO"
  },
  "723127": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Barabhum SO"
  },
  "723129": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Bundwan SO"
  },
  "723102": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Pundru BO"
  },
  "723201": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Garjaipur SO"
  },
  "713332": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Devchandnagar SO"
  },
  "713343": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Kendua SO"
  },
  "713206": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Durgapur Abl Township SO"
  },
  "723148": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Sindurpur BO"
  },
  "143001": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "NRL Workshop SO"
  },
  "380009": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Gujarat University SO"
  },
  "506101": {
    "state": "TELANGANA",
    "district": "MAHABUBABAD",
    "office": "Mahabubabad H.O"
  },
  "201206": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Murad Nagar SO"
  },
  "245304": {
    "state": "UTTAR PRADESH",
    "district": "HAPUR",
    "office": "New Market Pilkhauwa SO"
  },
  "518501": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Sanjeeva Nagar S.O"
  },
  "822101": {
    "state": "JHARKHAND",
    "district": "PALAMU",
    "office": "Hamidganj SO"
  },
  "531001": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Anakapalle H.O"
  },
  "245201": {
    "state": "UTTAR PRADESH",
    "district": "HAPUR",
    "office": "Kuchesar Chopla SO"
  },
  "737121": {
    "state": "SIKKIM",
    "district": "WEST DISTRICT",
    "office": "Naya Bazar SO West Sikkim"
  },
  "737113": {
    "state": "SIKKIM",
    "district": "WEST DISTRICT",
    "office": "Pelling SO"
  },
  "737103": {
    "state": "SIKKIM",
    "district": "EAST DISTRICT",
    "office": "Tashiling SO"
  },
  "122002": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "DLF QE SO"
  },
  "122018": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "D Block South City II Gurgaon"
  },
  "122015": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Palam Road SO"
  },
  "123031": {
    "state": "HARYANA",
    "district": "MAHENDRAGARH",
    "office": "Central University Haryana Mohindergarh SO"
  },
  "274149": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Bodarwar SO"
  },
  "274301": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Captainganj SO"
  },
  "274302": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Dudhai SO"
  },
  "274401": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Fazilnagar SO"
  },
  "274203": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "HATA SO"
  },
  "274206": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "Hetimpur S O"
  },
  "274402": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Kasia S O"
  },
  "274303": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Kathkuiyan SO"
  },
  "731241": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Dunigram BO"
  },
  "700051": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Birati SO"
  },
  "110015": {
    "state": "DELHI",
    "district": "WEST",
    "office": "Moti Nagar S.O"
  },
  "247776": {
    "state": "UTTAR PRADESH",
    "district": "SHAMLI",
    "office": "Ganna Samiti Shamli SO"
  },
  "247777": {
    "state": "UTTAR PRADESH",
    "district": "SHAMLI",
    "office": "Thanabhawan SO"
  },
  "731202": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Baswa SO Birbhum"
  },
  "731233": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Kharun BO"
  },
  "731238": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Rudranagar BO"
  },
  "731245": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Turigram BO"
  },
  "731242": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Kurumgram SO"
  },
  "731237": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Lohapur SO"
  },
  "731216": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Mallarpur SO"
  },
  "731219": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Murarai SO"
  },
  "516360": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Proddatur Fort S.O"
  },
  "247453": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Jaroda Panda SO"
  },
  "732210": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Baishnabnagar SO"
  },
  "732122": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Bulbulchandi SO"
  },
  "732123": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Chanchal SO"
  },
  "732124": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Gajol SO"
  },
  "732125": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Harishchandrapur SO"
  },
  "732102": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Jhaljhalia Railway Colony SO"
  },
  "732201": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Kaliachak SO"
  },
  "732126": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Kaligaon SO"
  },
  "732127": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Khejuriaghat SO"
  },
  "110009": {
    "state": "DELHI",
    "district": "NORTH",
    "office": "G T B Nagar extension SO"
  },
  "732121": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Aiho SO"
  },
  "732208": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Amrity SO"
  },
  "711109": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Bakultala SO"
  },
  "829122": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Ramgarh SO Ramgarh"
  },
  "530001": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Fortward S.O"
  },
  "515001": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Satyanandanagar S.O"
  },
  "389001": {
    "state": "GUJARAT",
    "district": "PANCH MAHALS",
    "office": "Godhra Civil Lines SO"
  },
  "390002": {
    "state": "GUJARAT",
    "district": "VADODARA",
    "office": "Fateganj HO"
  },
  "389151": {
    "state": "GUJARAT",
    "district": "DOHAD",
    "office": "Dahod RS SO"
  },
  "515801": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Timmanacharla S.O"
  },
  "530004": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "LIC Building S.O"
  },
  "723215": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Baglata SO"
  },
  "171001": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "IGMC SO"
  },
  "209867": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Patan SO Unnao"
  },
  "721147": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Shalboni SO"
  },
  "721102": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Vidyasagar University SO"
  },
  "110002": {
    "state": "DELHI",
    "district": "CENTRAL",
    "office": "Civic Centre PO"
  },
  "735231": {
    "state": "WEST BENGAL",
    "district": "KALIMPONG",
    "office": "Fagu SO Darjeeling"
  },
  "734503": {
    "state": "WEST BENGAL",
    "district": "KALIMPONG",
    "office": "Jaldhaka Hydel Project SO"
  },
  "516115": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Rajampet Rs S.O"
  },
  "518001": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Kurnool Dt Court S.O"
  },
  "209841": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Hasanganj SO"
  },
  "530016": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "New Colony S.O"
  },
  "110023": {
    "state": "DELHI",
    "district": "NEW DELHI",
    "office": "Kidwai Nagar West SO"
  },
  "700135": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Shyamnagar BO"
  },
  "700163": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "New Town Action Area I SO"
  },
  "722206": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Patrasayer SO"
  },
  "722146": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Rajagram SO"
  },
  "722148": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Ranibandh SO"
  },
  "722149": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Sabrakone SO"
  },
  "722158": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Saltora SO"
  },
  "722150": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Sarenga SO"
  },
  "743252": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Nakpul Kuchlia BO"
  },
  "743262": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Gopalnagar SO North 24 Parganas"
  },
  "743263": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Habra SO"
  },
  "743270": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Baneswarpur BO"
  },
  "743273": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Taranipur BO"
  },
  "403601": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Gandhi Market Complex Margao S.O"
  },
  "148001": {
    "state": "PUNJAB",
    "district": "SANGRUR",
    "office": "Mini Secteriate Sangrur SO"
  },
  "505172": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Peddapalli R.S S.O"
  },
  "272177": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Banpur SO"
  },
  "743438": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Kolsur SO"
  },
  "743289": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Simulpur BO"
  },
  "743290": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Nahata SO"
  },
  "700131": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Newbarrackpur SO"
  },
  "700125": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Noapara SO North 24 Parganas"
  },
  "743701": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Sulka Durgapur BO"
  },
  "743405": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Petrapole SO"
  },
  "743711": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Suria SO"
  },
  "743287": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Thakurnagar SO"
  },
  "743425": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Narabunia BO"
  },
  "743401": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Baduria SO"
  },
  "241405": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Hariyawan SO"
  },
  "241402": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Harpalpur SO Hardoi"
  },
  "721431": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Janka SO"
  },
  "110006": {
    "state": "DELHI",
    "district": "CENTRAL",
    "office": "Hauz Qazi SO"
  },
  "364001": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Bhavnagar Wadva SO"
  },
  "688001": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Alappuzha Collectorate SO"
  },
  "737126": {
    "state": "SIKKIM",
    "district": "SOUTH DISTRICT",
    "office": "Namchi SO"
  },
  "737132": {
    "state": "SIKKIM",
    "district": "EAST DISTRICT",
    "office": "Rangpo SO"
  },
  "737139": {
    "state": "SIKKIM",
    "district": "SOUTH DISTRICT",
    "office": "Ravangla SO"
  },
  "723145": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Moutore BO"
  },
  "713378": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Haripur SO Bardhaman"
  },
  "713385": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Laudoha SO"
  },
  "713381": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Nutandanga SO"
  },
  "713346": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Pandaveshwar SO"
  },
  "713362": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Toposi SO"
  },
  "713363": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Ukhra SO"
  },
  "721445": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Khakurda SO"
  },
  "721436": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Mohanpur SO West Midnapore"
  },
  "721437": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Narayangarh SO West Midnapore"
  },
  "245205": {
    "state": "UTTAR PRADESH",
    "district": "HAPUR",
    "office": "Garhmukteshwar SO"
  },
  "201201": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Harmukhpuri SO"
  },
  "201204": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Modi Nagar SO"
  },
  "700035": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Deshbandhu Road SO"
  },
  "700108": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Ashokegarh SO"
  },
  "700028": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Nagerbazar SO"
  },
  "700052": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Kolkata Airport  Po SO"
  },
  "700036": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Baranagar SO"
  },
  "263636": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Hawalbagh SO"
  },
  "263626": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Jainti SO"
  },
  "245207": {
    "state": "UTTAR PRADESH",
    "district": "HAPUR",
    "office": "Simbhaoli SO"
  },
  "509125": {
    "state": "TELANGANA",
    "district": "JOGULAMBA GADWAL",
    "office": "Gadwal H.O"
  },
  "271303": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Nawabganj SO Gonda"
  },
  "271504": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Paraspur SO"
  },
  "721451": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Nekurseni SO"
  },
  "713323": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Ballavpur SO"
  },
  "713358": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Searsole Rajbari SO"
  },
  "241302": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Madhoganj SO Hardoi"
  },
  "241303": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Mallawan SO"
  },
  "241123": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Pali SO Hardoi"
  },
  "241406": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Pihani SO"
  },
  "241407": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Saadat Nagar SO"
  },
  "241204": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Sandila SO"
  },
  "241124": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Shahabad BS SO"
  },
  "241126": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Kachhauna SO"
  },
  "241403": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Sandi SO"
  },
  "737106": {
    "state": "SIKKIM",
    "district": "EAST DISTRICT",
    "office": "Pakyong SO"
  },
  "737131": {
    "state": "SIKKIM",
    "district": "EAST DISTRICT",
    "office": "Rangli Bazar SO"
  },
  "737135": {
    "state": "SIKKIM",
    "district": "EAST DISTRICT",
    "office": "Ranipool SO"
  },
  "737133": {
    "state": "SIKKIM",
    "district": "EAST DISTRICT",
    "office": "Rhenock SO"
  },
  "805110": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Nawadha HO"
  },
  "521153": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Kolavennu S.O"
  },
  "246176": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Toli SO"
  },
  "721148": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Kheput SO"
  },
  "743710": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Goribpur SO"
  },
  "700129": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Madhyamgram SO"
  },
  "700091": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Bidhan Nagar CK Market SO"
  },
  "700048": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Sadhana Ausudhalaya Road SO"
  },
  "700160": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "New Town Action Area III"
  },
  "700161": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "New Town Action Area II SO"
  },
  "500015": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Aoc Records S.O"
  },
  "500003": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Secunderabad H.O"
  },
  "209861": {
    "state": "UTTAR PRADESH",
    "district": "UNNAO",
    "office": "Ganga Ghat SO"
  },
  "500084": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Kothaguda S.O"
  },
  "500107": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Gopanpally S.O"
  },
  "230127": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Dalippur SO Pratapgarh"
  },
  "535001": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Vizianagaram City S.O"
  },
  "530007": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Muralinagar S.O"
  },
  "530009": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Visakhapatnam Airport S.O"
  },
  "530014": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Naval Base S.O"
  },
  "530015": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Zinc Smelter P S.O"
  },
  "530032": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "VM Steel Projrct Town Ship S.O"
  },
  "229408": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Kalakankar SO"
  },
  "532001": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Srikakulam Zilla Parishad S.O"
  },
  "827001": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Civil Court Area Bokaro SO"
  },
  "826001": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Naya Bazar Wasseypur SO"
  },
  "208020": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Panki SO Kanpur Nagar"
  },
  "799250": {
    "state": "TRIPURA",
    "district": "North Tripura",
    "office": "Dharmanagar H.O"
  },
  "515671": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Dharmavaram Bazar S.O"
  },
  "176215": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Ram Nagar Dharamsala SO"
  },
  "274801": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Chhitauni SO"
  },
  "151203": {
    "state": "PUNJAB",
    "district": "FARIDKOT",
    "office": "Faridkot Mandi SO"
  },
  "506164": {
    "state": "TELANGANA",
    "district": "WARANGAL RURAL",
    "office": "Parkal H.O"
  },
  "570001": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Mysuru Sorting"
  },
  "570009": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Saraswathipuram H.O"
  },
  "504208": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Grain Market S.O"
  },
  "508001": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Bottuguda S.O"
  },
  "804408": {
    "state": "BIHAR",
    "district": "JEHANABAD",
    "office": "Jehanabad Kutchary SO"
  },
  "363002": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Surendranagar MPSC SO"
  },
  "249001": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "New Tehri Collectrate SO"
  },
  "133008": {
    "state": "HARYANA",
    "district": "AMBALA",
    "office": "Majri S.O"
  },
  "721130": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Gopalnagar SO East Midnapore"
  },
  "721153": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Joteghanashyam SO"
  },
  "721636": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Sankarara SO"
  },
  "263625": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Lamgara SO"
  },
  "263643": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Kosi SO Almora"
  },
  "263623": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Panuwanaula SO"
  },
  "700073": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Pollock Street SO"
  },
  "700001": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Kolkatta GPO"
  },
  "700050": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "South Sinhee SO"
  },
  "263619": {
    "state": "UTTARAKHAND",
    "district": "BAGESHWAR",
    "office": "Ghingartola SO"
  },
  "263640": {
    "state": "UTTARAKHAND",
    "district": "BAGESHWAR",
    "office": "Kameridevi SO"
  },
  "263631": {
    "state": "UTTARAKHAND",
    "district": "BAGESHWAR",
    "office": "Kanda SO"
  },
  "263632": {
    "state": "UTTARAKHAND",
    "district": "BAGESHWAR",
    "office": "Kapkote SO"
  },
  "263639": {
    "state": "UTTARAKHAND",
    "district": "BAGESHWAR",
    "office": "Kausani SO"
  },
  "263633": {
    "state": "UTTARAKHAND",
    "district": "BAGESHWAR",
    "office": "Shama SO"
  },
  "731220": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Nalhati SO"
  },
  "734201": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Bijanbari SO"
  },
  "734102": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Ghoom SO"
  },
  "247778": {
    "state": "UTTAR PRADESH",
    "district": "SHAMLI",
    "office": "Un SO Muzaffarnagar"
  },
  "700054": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Bengal Chemical SO"
  },
  "700015": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Tangra SO"
  },
  "700014": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Asylum Lane SO"
  },
  "700039": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Bediadanga SO"
  },
  "110058": {
    "state": "DELHI",
    "district": "WEST",
    "office": "Janakpuri A 3 S.O"
  },
  "110026": {
    "state": "DELHI",
    "district": "WEST",
    "office": "Shivaji Park S.O (West Delhi)"
  },
  "110027": {
    "state": "DELHI",
    "district": "WEST",
    "office": "Subhash Nagar West S.O"
  },
  "263628": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Takula SO"
  },
  "700007": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Vaishya Sabha SO"
  },
  "700062": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "West Bengal Governors Camp SO"
  },
  "700002": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Cossipore HO"
  },
  "735122": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Haldibari SO"
  },
  "700077": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Bediapara SO"
  },
  "700065": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Subhas Nagar SO"
  },
  "700080": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Jessore Road SO"
  },
  "700090": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Noapara SO"
  },
  "743297": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Sindrani SO"
  },
  "743456": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Bhebia SO"
  },
  "743291": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Champapukur SO"
  },
  "743437": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Matia BO"
  },
  "722164": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Bankadaha SO"
  },
  "722202": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Barjora SO"
  },
  "722203": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Beliatore SO"
  },
  "721601": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Bhagwanpur SO East Midnapore"
  },
  "721151": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Bhogpur SO East Midnapore"
  },
  "721648": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Byabattarhat SO"
  },
  "721645": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Chaitannyapur SO"
  },
  "721653": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Chanserpur SO"
  },
  "721657": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Debhog SO"
  },
  "721603": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Geonkhali SO"
  },
  "721625": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Hanschara SO"
  },
  "721626": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Kajlagarh SO"
  },
  "721158": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Baishnabchak SO"
  },
  "786005": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Jalan Nagar S.O"
  },
  "786692": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Anandapara S.O"
  },
  "786006": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Lepetkata S.O"
  },
  "721602": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Durgachak SO"
  },
  "721627": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Kelomal SO"
  },
  "721432": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Kalagachia SO East Midnapore"
  },
  "721401": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Nayaput BO"
  },
  "721434": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Manglamaro SO"
  },
  "721449": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Marisda SO"
  },
  "721444": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Nachinda Bazar SO"
  },
  "723147": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Vivekananda Nagar SO"
  },
  "723212": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Pusti BO"
  },
  "121008": {
    "state": "HARYANA",
    "district": "FARIDABAD",
    "office": "Faridabad Sector 29 SO"
  },
  "721643": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Khanchi SO"
  },
  "110089": {
    "state": "DELHI",
    "district": "NORTH WEST",
    "office": "Rohini Sector 15 extension So"
  },
  "230301": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Gaura R S SO"
  },
  "230302": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Jamtali SO"
  },
  "230129": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Jethwara SO"
  },
  "230502": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Garwara SO"
  },
  "534260": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Palakol Bazar S.O"
  },
  "534001": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Eluru Bazar S.O"
  },
  "277216": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Lalganj Ballia SO"
  },
  "277403": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Majhua SO"
  },
  "277207": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Maniar SO"
  },
  "221717": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Nawanagar SO Ballia"
  },
  "521121": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Avanigadda H.O"
  },
  "277219": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Kheosar SO"
  },
  "534447": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Jangareddygudem H.O"
  },
  "263678": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Shitalakhet SO"
  },
  "263637": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Someshwar SO"
  },
  "263645": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Ranikhet Sadar Bazar SO"
  },
  "263646": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Bhatronjkhan SO"
  },
  "263667": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Bhikiyasen SO"
  },
  "263680": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Chaunallia SO"
  },
  "263660": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Daula SO"
  },
  "263659": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Deghat SO"
  },
  "263664": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Deolikhet SO"
  },
  "533002": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "M S N Charties S.O"
  },
  "743412": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Basirhat College SO"
  },
  "743422": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Pifa BO"
  },
  "743445": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Gopalpur SO North 24 Parganas"
  },
  "743426": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Sulkuniabad BO"
  },
  "743439": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Hatgachha SO"
  },
  "722201": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Akui SO"
  },
  "121013": {
    "state": "HARYANA",
    "district": "FARIDABAD",
    "office": "Sec91 SO"
  },
  "121014": {
    "state": "HARYANA",
    "district": "FARIDABAD",
    "office": "Greater Faridabad PO"
  },
  "533004": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Ramaraopet S.O"
  },
  "517101": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Chandragiri Fort S.O"
  },
  "226002": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "CRPF Bijnore SO Lucknow"
  },
  "226021": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Jankipuram SO"
  },
  "723153": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Kantadih SO"
  },
  "271319": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Pure Shivdayal Ganj SO"
  },
  "271403": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Tarabganj SO"
  },
  "230131": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Katra Medniganj SO"
  },
  "271124": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Wazeerganj SO"
  },
  "384012": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Ganpat Vidyanagar SO"
  },
  "743435": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Hingalganj SO"
  },
  "743292": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Itinda SO"
  },
  "743427": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Katiahat SO"
  },
  "743442": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Nazat Hatkhola SO"
  },
  "743446": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Joygopalpur Korakati Milanbazar BO"
  },
  "743704": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Prithiba BO"
  },
  "743272": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Sendanga BO"
  },
  "384320": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Umta SO"
  },
  "384160": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Unava SO"
  },
  "700126": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Malikapur BO"
  },
  "743411": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Basirhat HO"
  },
  "743293": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Jadurhati SO"
  },
  "743428": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Kholapota SO"
  },
  "416606": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Malvan H.O"
  },
  "416510": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Sawantwadi H.O"
  },
  "505327": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "New Abadi Jagtial S.O"
  },
  "226013": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "IIM Lucknow SO"
  },
  "226010": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Vishwas Khand SO"
  },
  "226026": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "IIT Dasauli SO"
  },
  "508213": {
    "state": "TELANGANA",
    "district": "SURYAPET",
    "office": "Bank Street S.O"
  },
  "203207": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Dadri SO"
  },
  "201311": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Container Depot SO"
  },
  "843301": {
    "state": "BIHAR",
    "district": "SITAMARHI",
    "office": "Shaktipith Chandidham SO"
  },
  "802101": {
    "state": "BIHAR",
    "district": "BUXAR",
    "office": "Sohni Patti SO"
  },
  "273413": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Kauriram SO"
  },
  "273013": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "BRD Medical College SO"
  },
  "273403": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Bansgaon SO Gorakhpur"
  },
  "273402": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Barhalganj SO"
  },
  "273401": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Bhowapar SO"
  },
  "273409": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Deidiha SO"
  },
  "273411": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Gagaha SO"
  },
  "854105": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Katihar Bara Bazar SO"
  },
  "812001": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Tilkamanjhi"
  },
  "712706": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Seakhala SO"
  },
  "712223": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Sheoraphuli SO"
  },
  "722147": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Ramsagar SO"
  },
  "743271": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Hijalpukuria SO"
  },
  "507001": {
    "state": "TELANGANA",
    "district": "KHAMMAM",
    "office": "Church Road S.O"
  },
  "721656": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Terapakhia SO"
  },
  "273408": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Gola SO Gorakhpur"
  },
  "273211": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Dhakhwa Bazar SO"
  },
  "700130": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Madhyamgram Bazar SO"
  },
  "521231": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "JNNURM Colony S.O"
  },
  "735101": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Bowbazar SO Jalpaiguri"
  },
  "734501": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Bagrakote SO"
  },
  "500098": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Medipalli S.O"
  },
  "500070": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Vanasthalipuram S.O"
  },
  "500115": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Autonagar SO"
  },
  "201310": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Alpha Greater Noida SO"
  },
  "201304": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Maharshi Nagar SO"
  },
  "201307": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Sec 12 Noida SO"
  },
  "201008": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Vidyut Nagar SO"
  },
  "847211": {
    "state": "BIHAR",
    "district": "MADHUBANI",
    "office": "Madhubani Court SO"
  },
  "842001": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Sikandarpur SO Muzaffarpur"
  },
  "508207": {
    "state": "TELANGANA",
    "district": "NALGONDA",
    "office": "Miryalguda H.O"
  },
  "735222": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Manabari SO"
  },
  "735221": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Panwar Busty SO"
  },
  "735229": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Sailihat SO"
  },
  "505468": {
    "state": "TELANGANA",
    "district": "KARIMNAGAR",
    "office": "Huzurabad H.O"
  },
  "824101": {
    "state": "BIHAR",
    "district": "AURANGABAD",
    "office": "Aurangabad Kutchehry SO"
  },
  "229316": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Ratapur SO"
  },
  "229127": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Salon SO"
  },
  "743429": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Taki Market SO"
  },
  "229311": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Sehgon SO"
  },
  "229126": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Semrauta SO"
  },
  "229802": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Sheoratanganj SO"
  },
  "229309": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Tiloi SO"
  },
  "734007": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Bhaktinagar SO"
  },
  "734015": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Mahananda Project SO"
  },
  "251319": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Sisauli SO"
  },
  "731244": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Budhigram BO"
  },
  "736171": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Ghoksadanga SO"
  },
  "736170": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Ghughumari SO"
  },
  "229206": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Lalganj Raebareli HO"
  },
  "229129": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Parsadepur SO"
  },
  "533242": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Razole H.O"
  },
  "532185": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Amadalavalasa H.O"
  },
  "532201": {
    "state": "ANDHRA PRADESH",
    "district": "SRIKAKULAM",
    "office": "Tekkali H.O"
  },
  "208004": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Narona Exchange SO"
  },
  "208002": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Swarup Nagar SO"
  },
  "122008": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "DLF PhII SO"
  },
  "122010": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "DLF PhIII SO"
  },
  "122009": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Galleria DLFIV SO"
  },
  "122011": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Gurgaon Sector 56 SO"
  },
  "122016": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Industrial Complex Dundahera SO"
  },
  "122007": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Industrial Estate SO Gurgaon"
  },
  "122052": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "IMT Manesar SO"
  },
  "122012": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Vatika India Sec 82 SO"
  },
  "121009": {
    "state": "HARYANA",
    "district": "FARIDABAD",
    "office": "Surajkund Faridabad SO"
  },
  "122005": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "Air Force SO"
  },
  "388001": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Veternary College  Anand SO"
  },
  "388330": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Khambholej SO"
  },
  "388543": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Alarsa SO"
  },
  "388545": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Kavitha SO"
  },
  "721607": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Haldia TS SO"
  },
  "852201": {
    "state": "BIHAR",
    "district": "SAHARSA",
    "office": "Saharsa DistBoard SO"
  },
  "811307": {
    "state": "BIHAR",
    "district": "JAMUI",
    "office": "Jamui Court SO"
  },
  "723103": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Chirka BO"
  },
  "388121": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Vithal Udyognagar SO"
  },
  "516390": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Ankalammapeta S.O"
  },
  "531116": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Narsipatnam H.O"
  },
  "263638": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Manan SO"
  },
  "741223": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Purbabishnupur SO"
  },
  "741248": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Simurali SO"
  },
  "741249": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Subarnapur SO"
  },
  "741255": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Anulia SO"
  },
  "741501": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Arangahta SO"
  },
  "741121": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Badkulla SO"
  },
  "741502": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Bagula SO"
  },
  "741503": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Banpur SO Nadia"
  },
  "271307": {
    "state": "UTTAR PRADESH",
    "district": "BALRAMPUR",
    "office": "Sadullanagar SO"
  },
  "741509": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Chandannagar SO Nadia"
  },
  "741151": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Dhakshinpara SO"
  },
  "741402": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Fulia Colony SO"
  },
  "741238": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Gangnapur SO"
  },
  "741505": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Hanskhali SO"
  },
  "741506": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Krishnaganj SO"
  },
  "741507": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Majdia SO"
  },
  "741202": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Nasra SO"
  },
  "741201": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Siddheswaritala SO"
  },
  "364081": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Alang SBY SO"
  },
  "364003": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Bhavnagar Para SO"
  },
  "364006": {
    "state": "GUJARAT",
    "district": "BHAVNAGAR",
    "office": "Bhavnagar Kumbharwada SO"
  },
  "384002": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Mahesana I E SO"
  },
  "384345": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Sundhia SO"
  },
  "841418": {
    "state": "BIHAR",
    "district": "SARAN",
    "office": "Marhowrah HO"
  },
  "380015": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "S A C SO"
  },
  "380054": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Thaltej Road SO"
  },
  "380051": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Jivraj Park SO"
  },
  "380013": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Shastrinagar SO Ahmedabad"
  },
  "713322": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Bahula SO"
  },
  "713337": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Bidhanbag SO"
  },
  "713338": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Kajoragram SO"
  },
  "786102": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Chabua Air Field S.O"
  },
  "787001": {
    "state": "ASSAM",
    "district": "LAKHIMPUR",
    "office": "North Lakhimpur H.O"
  },
  "785621": {
    "state": "ASSAM",
    "district": "GOLAGHAT",
    "office": "Golaghat H.O"
  },
  "273015": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Jatepur North SO"
  },
  "229121": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Aihar SO"
  },
  "229201": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Behta SO"
  },
  "535558": {
    "state": "ANDHRA PRADESH",
    "district": "VIZIANAGARAM",
    "office": "Bobbili H.O"
  },
  "533255": {
    "state": "ANDHRA PRADESH",
    "district": "EAST GODAVARI",
    "office": "Ramachandrapuram H.O"
  },
  "530026": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Gajuwaka S.O"
  },
  "700136": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Rajarhat Gopalpur SO"
  },
  "734203": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Dumaram Busty SO"
  },
  "734105": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Lebong SO"
  },
  "734215": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Nagrispur SO"
  },
  "734104": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "North Point SO"
  },
  "734217": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Pankhabari SO"
  },
  "734216": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Pokhriabong SO"
  },
  "734226": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Rangli Rangliot SO"
  },
  "734209": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Sonada SO"
  },
  "743166": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Ramghat SO North 24 Parganas"
  },
  "743223": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Haripur SO North 24 Parganas"
  },
  "734221": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Sukhiapokhari SO"
  },
  "734222": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Takdah SO"
  },
  "734312": {
    "state": "WEST BENGAL",
    "district": "KALIMPONG",
    "office": "Tista Bridge SO"
  },
  "734224": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Tung SO"
  },
  "734014": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Bagdogra SO"
  },
  "734423": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Belgachi SO"
  },
  "734429": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Naksalbari SO"
  },
  "734427": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Khoribari SO"
  },
  "734214": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Mirik SO"
  },
  "735303": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Jamaldah SO"
  },
  "712408": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Rajbalhat SO"
  },
  "127045": {
    "state": "HARYANA",
    "district": "BHIWANI",
    "office": "Barwa SO"
  },
  "700037": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Belgachia SO"
  },
  "721513": {
    "state": "WEST BENGAL",
    "district": "Jhargram",
    "office": "Manikpara SO"
  },
  "721304": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Dhekia SO"
  },
  "721121": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Bagri Krishnanagar BO"
  },
  "262723": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Dhaurahara SO Kheri"
  },
  "262802": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Gola Gokaran Nath SO"
  },
  "363643": {
    "state": "GUJARAT",
    "district": "MORBI",
    "office": "Sakat Sanala SO"
  },
  "742407": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Chaltia SO"
  },
  "742137": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Kandi HO"
  },
  "782460": {
    "state": "ASSAM",
    "district": "KARBI ANGLONG",
    "office": "Diphu H.O"
  },
  "741251": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Netajisubhas Sanatorium SO"
  },
  "741253": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Anishmali SO"
  },
  "741256": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Begopara SO"
  },
  "741127": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Birnagar SO"
  },
  "248199": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Tuini SO"
  },
  "248198": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Vikasnagar SO Dehradun"
  },
  "248143": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Bhogpur SO Dehradun"
  },
  "248001": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Sachivalaya Parisar SO"
  },
  "248002": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Turner Road SO"
  },
  "248140": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Doiwala SO"
  },
  "248005": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "IIP SO"
  },
  "248014": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Nehrugram SO"
  },
  "248008": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "RaipurOF SO"
  },
  "249205": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Raiwala SO"
  },
  "248145": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Rani Pokhari SO"
  },
  "248013": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Sahastradhara Road SO"
  },
  "247667": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Roorkee City SO"
  },
  "247661": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Bhagwanpur SO Haridwar"
  },
  "248121": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Ajabpur SO"
  },
  "249204": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "SN Temple SO"
  },
  "261502": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Isanagar SO Kheri"
  },
  "262724": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Jatpurwa SO"
  },
  "262702": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Kheri Town SO"
  },
  "226017": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Rajajipuram SO"
  },
  "226401": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Banthara SO Lucknow"
  },
  "509103": {
    "state": "TELANGANA",
    "district": "WANAPARTHY",
    "office": "Wanaparthy H.O"
  },
  "734313": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Mungpoo SO"
  },
  "734013": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "North Bengal University SO"
  },
  "734434": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Phansidewa SO"
  },
  "734218": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Phuguri SO"
  },
  "734003": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Pradhan Nagar SO"
  },
  "700017": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Shakespeare Sarani SO"
  },
  "700010": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Beleghata HO"
  },
  "700085": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "KG Bose Sarani SO"
  },
  "700011": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Narkeldanga SO"
  },
  "721450": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Junput SO"
  },
  "509301": {
    "state": "TELANGANA",
    "district": "MAHABUBNAGAR",
    "office": "Stn. Jadcherla H.O"
  },
  "733210": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR UTTAR",
    "office": "Goalpokher SO"
  },
  "523155": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Santha Bazar S.O"
  },
  "523105": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Kandukur South S.O"
  },
  "501101": {
    "state": "TELANGANA",
    "district": "VIKARABAD",
    "office": "Vikarabad H.O"
  },
  "524101": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Gudur Bazar S.O"
  },
  "523240": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Podili H.O"
  },
  "854301": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Purnea DB SO"
  },
  "524001": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Trunk Road S.O (Nellore)"
  },
  "523001": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Santhapeta (O) S.O"
  },
  "700100": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Vip Nagar SO"
  },
  "249202": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Virbhadra SO"
  },
  "248016": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Jollygrant SO"
  },
  "744201": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "NORTH AND MIDDLE ANDAMAN",
    "office": "Betapur S.O"
  },
  "744202": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "NORTH AND MIDDLE ANDAMAN",
    "office": "Diglipur S.O"
  },
  "744302": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "NICOBARS",
    "office": "Campbelbay S.O"
  },
  "744303": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "NICOBARS",
    "office": "Nancowrie S.O"
  },
  "736122": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Alipurduar Court SO"
  },
  "736123": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Alipurduar Junction SO"
  },
  "736121": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Alipurduar SO"
  },
  "507111": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "B.R.Colony S.O"
  },
  "503224": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Armoor H.O"
  },
  "503111": {
    "state": "TELANGANA",
    "district": "KAMAREDDY",
    "office": "Kamareddy H.O"
  },
  "504001": {
    "state": "TELANGANA",
    "district": "ADILABAD",
    "office": "Bhagyanagar S.O"
  },
  "503001": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Shivajinagar S.O"
  },
  "507125": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "P.V.Township S.O"
  },
  "504303": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Srirampur Colony S.O"
  },
  "733202": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR UTTAR",
    "office": "Islampur SO North Dinajpur"
  },
  "733128": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR UTTAR",
    "office": "Itahar SO"
  },
  "733129": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR UTTAR",
    "office": "Kaliyaganj SO"
  },
  "721433": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Khalisabhanga SO"
  },
  "741508": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Khalboalia SO"
  },
  "733141": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR DAKSHIN",
    "office": "Gopalganj SO"
  },
  "733126": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR DAKSHIN",
    "office": "Hili SO"
  },
  "522503": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Apsp Colony(Mangalagiri) S.O"
  },
  "262721": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Lagucha SO"
  },
  "261506": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Mahewa Ganj SO"
  },
  "721514": {
    "state": "WEST BENGAL",
    "district": "Jhargram",
    "office": "Binpur BO"
  },
  "721515": {
    "state": "WEST BENGAL",
    "district": "Jhargram",
    "office": "Ashakanthi BO"
  },
  "630408": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Tiruvegampet SO"
  },
  "630612": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Pottapalayam SO"
  },
  "630204": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Kandramanickam SO"
  },
  "630555": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Natarajapuram SO Sivaganga"
  },
  "630556": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Nattarasankottai SO"
  },
  "742402": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Talibpur SO"
  },
  "742409": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Shaikhpara SO"
  },
  "742408": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Sargachi Ashram SO"
  },
  "742410": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "REJINAGAR SO"
  },
  "742225": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Raghunathganj HO"
  },
  "733125": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR DAKSHIN",
    "office": "Harirampur SO"
  },
  "741124": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Hatisala BO"
  },
  "741163": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Lalbazar BO"
  },
  "741103": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Dhopatta BO"
  },
  "741152": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Khanpur BO"
  },
  "201103": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Tronica City SO"
  },
  "802302": {
    "state": "BIHAR",
    "district": "BHOJPUR",
    "office": "Anaith SO"
  },
  "700127": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Hridaypur SO"
  },
  "700124": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Barasat Bazar SO"
  },
  "734301": {
    "state": "WEST BENGAL",
    "district": "KALIMPONG",
    "office": "Kalimpong Bazar SO"
  },
  "734315": {
    "state": "WEST BENGAL",
    "district": "KALIMPONG",
    "office": "Munsong SO"
  },
  "734316": {
    "state": "WEST BENGAL",
    "district": "KALIMPONG",
    "office": "Topkhana SO"
  },
  "125056": {
    "state": "HARYANA",
    "district": "SIRSA",
    "office": "JCD Vidyapeeth Sirsa"
  },
  "721517": {
    "state": "WEST BENGAL",
    "district": "Jhargram",
    "office": "Tapsia SO"
  },
  "261505": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Maigal Ganj SO"
  },
  "506001": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Lashkar Bazar S.O"
  },
  "508116": {
    "state": "TELANGANA",
    "district": "YADADRI BHUVANAGIRI",
    "office": "Bhongir H.O"
  },
  "504107": {
    "state": "TELANGANA",
    "district": "Nirmal",
    "office": "RGU IIIT Campus Basar S.O"
  },
  "570005": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Mysuru University S.O"
  },
  "506004": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Fatimanagar S.O"
  },
  "263621": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Bagwalipokhar SO"
  },
  "530008": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Kancharapalem S.O"
  },
  "530011": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Malkapuram S.O"
  },
  "530018": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Marripalem S.O"
  },
  "530046": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Vadlapudi S.O"
  },
  "516001": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Nagarajupet S.O"
  },
  "518301": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "S.K.D.Nagar S.O"
  },
  "245208": {
    "state": "UTTAR PRADESH",
    "district": "HAPUR",
    "office": "Bahadurgarh SO"
  },
  "229410": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Kaithola SO"
  },
  "534201": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Someswaralayam S.O"
  },
  "380019": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Railway Colony SO Ahmedabad"
  },
  "380027": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Gandhi Ashram SO Ahmedabad"
  },
  "380005": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Sabarmati SO"
  },
  "201005": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Sahibabad SO"
  },
  "743375": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Usthi SO"
  },
  "786622": {
    "state": "ASSAM",
    "district": "DIBRUGARH",
    "office": "Namrup Thermal Power Station S.O"
  },
  "700055": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Bangur Avenue SO"
  },
  "700102": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Krishnapur SO North 24 Parganas"
  },
  "700101": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Prafulla Kanan SO"
  },
  "734311": {
    "state": "WEST BENGAL",
    "district": "KALIMPONG",
    "office": "Pedong SO"
  },
  "735204": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Birpara Bazar SO"
  },
  "721145": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Salua SO"
  },
  "110004": {
    "state": "DELHI",
    "district": "NEW DELHI",
    "office": "Rashtrapati Bhawan SO"
  },
  "110069": {
    "state": "DELHI",
    "district": "NEW DELHI",
    "office": "Union Public Service Commission SO"
  },
  "110005": {
    "state": "DELHI",
    "district": "CENTRAL",
    "office": "Guru Gobind Singh Marg SO"
  },
  "505326": {
    "state": "TELANGANA",
    "district": "Jagitial",
    "office": "Koratla S.O"
  },
  "502001": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Sangareddy Collectorate S.O"
  },
  "570023": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Kuvempunagar II Stage S.O"
  },
  "570033": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Dattagalli S.O"
  },
  "506011": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "D H Suthoon S.O"
  },
  "734213": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Lopchu SO"
  },
  "734223": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Tindharia SO"
  },
  "700097": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Purbachal SO"
  },
  "700162": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Gouranganagar SO"
  },
  "731224": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Railpar SO Birbhum"
  },
  "731101": {
    "state": "WEST BENGAL",
    "district": "BIRBHUM",
    "office": "Suri HO"
  },
  "570034": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Sri Rampura 2nd Stage S.O"
  },
  "507101": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Laxmidepalli S.O"
  },
  "736207": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Barobisha SO"
  },
  "744105": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "SOUTH ANDAMANS",
    "office": "Garacharama S.O"
  },
  "744102": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "SOUTH ANDAMANS",
    "office": "Haddo S.O"
  },
  "744104": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "SOUTH ANDAMANS",
    "office": "Aberdeen  Bazar S.O"
  },
  "744107": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "SOUTH ANDAMANS",
    "office": "Bambooflat S.O"
  },
  "744211": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "SOUTH ANDAMANS",
    "office": "Havelock S.O"
  },
  "744207": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "SOUTH ANDAMANS",
    "office": "Hut  Bay S.O"
  },
  "744103": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "SOUTH ANDAMANS",
    "office": "Junglighat S.O"
  },
  "744206": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "SOUTH ANDAMANS",
    "office": "Wimberlygunj S.O"
  },
  "394190": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Kholvad SO"
  },
  "515201": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Hindupur Extns S.O"
  },
  "744301": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "NICOBARS",
    "office": "Carnicobar S.O"
  },
  "744304": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "NICOBARS",
    "office": "Kapanga S.O"
  },
  "736131": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Bakshirhat SO"
  },
  "736168": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Bamanhat SO"
  },
  "736133": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Baneswar SO"
  },
  "736134": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Dewanhat SO"
  },
  "507154": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Siil Campus S.O"
  },
  "506350": {
    "state": "TELANGANA",
    "district": "WARANGAL RURAL",
    "office": "Nallabelli S.O"
  },
  "490023": {
    "state": "CHHATTISGARH",
    "district": "DURG",
    "office": "Supela Bhilai SO"
  },
  "490020": {
    "state": "CHHATTISGARH",
    "district": "DURG",
    "office": "Motilal Nehru Nagr Bhilai SO"
  },
  "736135": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Dinhata SO"
  },
  "123110": {
    "state": "HARYANA",
    "district": "REWARI",
    "office": "Industrial Area Dharuhera SO"
  },
  "721435": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Menkapur SO"
  },
  "741101": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Nagendranagar SO"
  },
  "741167": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Sakdaha BO"
  },
  "741164": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Tilakpur BO"
  },
  "741317": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Joania BO"
  },
  "713424": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Shyamsundar SO"
  },
  "246421": {
    "state": "UTTARAKHAND",
    "district": "RUDRA PRAYAG",
    "office": "Augustmuni SO"
  },
  "246419": {
    "state": "UTTARAKHAND",
    "district": "RUDRA PRAYAG",
    "office": "Bhiri SO"
  },
  "734008": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Salugarah SO"
  },
  "637211": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Tiruchengodu North S.O"
  },
  "796001": {
    "state": "MIZORAM",
    "district": "AIZAWL",
    "office": "Dawrpui S.O"
  },
  "221301": {
    "state": "UTTAR PRADESH",
    "district": "BHADOHI",
    "office": "Aurai SO Sant Ravidas Nagar"
  },
  "221401": {
    "state": "UTTAR PRADESH",
    "district": "BHADOHI",
    "office": "Katra Bazar SO Varanasi"
  },
  "221304": {
    "state": "UTTAR PRADESH",
    "district": "BHADOHI",
    "office": "Gyanpur SO"
  },
  "221306": {
    "state": "UTTAR PRADESH",
    "district": "BHADOHI",
    "office": "Khamaria SO Varanasi"
  },
  "221309": {
    "state": "UTTAR PRADESH",
    "district": "BHADOHI",
    "office": "Koirauna SO"
  },
  "246425": {
    "state": "UTTARAKHAND",
    "district": "RUDRA PRAYAG",
    "office": "Chandrapuri SO"
  },
  "363035": {
    "state": "GUJARAT",
    "district": "SURENDRANAGAR",
    "office": "Wadhwancity Ind Estate SO"
  },
  "744204": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "NORTH AND MIDDLE ANDAMAN",
    "office": "Mayabander S.O"
  },
  "744210": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "NORTH AND MIDDLE ANDAMAN",
    "office": "Oralkatcha S.O"
  },
  "744205": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "NORTH AND MIDDLE ANDAMAN",
    "office": "Rangat S.O"
  },
  "497555": {
    "state": "CHHATTISGARH",
    "district": "KOREA",
    "office": "Godripara SO"
  },
  "497446": {
    "state": "CHHATTISGARH",
    "district": "KOREA",
    "office": "Jhagrakhand Colly SO"
  },
  "226101": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Kakori SO"
  },
  "226102": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Malihabad SO"
  },
  "226104": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "MALL SO"
  },
  "735211": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Falakata SO"
  },
  "262803": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Mailani SO"
  },
  "262727": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Mitauli SO"
  },
  "262804": {
    "state": "UTTAR PRADESH",
    "district": "KHERI",
    "office": "Mohammadi SO"
  },
  "263656": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Ganai SO"
  },
  "263658": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Masi SO"
  },
  "263665": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Matela SO"
  },
  "263676": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Maulekhal SO"
  },
  "263661": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Syalde SO"
  },
  "700030": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Ghugudanga SO"
  },
  "110012": {
    "state": "DELHI",
    "district": "WEST",
    "office": "National Physical Laboratory SO"
  },
  "110008": {
    "state": "DELHI",
    "district": "WEST",
    "office": "Patel Nagar East SO"
  },
  "735305": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Bhotepatty SO"
  },
  "388120": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Vallabh  Vidyanagar SO"
  },
  "522002": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Brodipet(Guntur) S.O"
  },
  "522403": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Gandhi Chowk S.O (Guntur)"
  },
  "522601": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "N.S.C.Colony S.O"
  },
  "221314": {
    "state": "UTTAR PRADESH",
    "district": "BHADOHI",
    "office": "Mahrajganj SO Sant Ravidas Nagar"
  },
  "221402": {
    "state": "UTTAR PRADESH",
    "district": "BHADOHI",
    "office": "Parsipur SO"
  },
  "221006": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Babatpur Ad SO"
  },
  "221302": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Gangapur Varanasi SO"
  },
  "221106": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Industrial Estate Varanasi SO"
  },
  "221305": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Jakhini SO"
  },
  "221207": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Kathiraon SO"
  },
  "221202": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Mangari SO"
  },
  "722161": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Jayrambati SO"
  },
  "722137": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Jhantipahari SO"
  },
  "534101": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Subbaraopeta S.O"
  },
  "522238": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "A.P.Secretariat S.O"
  },
  "522510": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Nagarjuna Nagar S.O"
  },
  "522001": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Nehru Nagar(Guntur) S.O"
  },
  "522003": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Choutra(Guntur) S.O"
  },
  "522004": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Trunk Road(Guntur) S.O"
  },
  "522007": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Chandramoulinagar S.O"
  },
  "521301": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Satyanarayanapuram S.O (Gudivada)"
  },
  "641001": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Sukrawarpettai SO"
  },
  "226301": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Mohanlalganj SO"
  },
  "226303": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Nagram SO"
  },
  "226302": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Nigohan SO"
  },
  "226103": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Rahimabad SO"
  },
  "226008": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "SNI AREA SO"
  },
  "735121": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Danguajhar SO"
  },
  "735210": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Dhupguri SO"
  },
  "110011": {
    "state": "DELHI",
    "district": "NEW DELHI",
    "office": "Nirman Bhawan SO"
  },
  "110055": {
    "state": "DELHI",
    "district": "CENTRAL",
    "office": "Swami Ram Tirth Nagar SO"
  },
  "735302": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Domohani SO"
  },
  "735212": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Gairkata SO"
  },
  "722173": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Jorda SO"
  },
  "722138": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Joypur SO"
  },
  "734006": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Rabindra Sarani SO"
  },
  "700009": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Raja Ram Mohan Sarani SO"
  },
  "734004": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Desbandhupara SO"
  },
  "722141": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Kotalpur SO"
  },
  "272154": {
    "state": "UTTAR PRADESH",
    "district": "SANT KABEER NAGAR",
    "office": "Dharamsinghwa SO"
  },
  "630561": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Bosenagar SO Sivaganga"
  },
  "492012": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Krishak Nagar SO"
  },
  "504218": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Devapur Cement Works S.O"
  },
  "628601": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Srivaikuntam H.O"
  },
  "274001": {
    "state": "UTTAR PRADESH",
    "district": "DEORIA",
    "office": "RAM GULAM TOLA SO"
  },
  "274304": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "Padrauna HO"
  },
  "502220": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Zaheerabad H.O"
  },
  "534211": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Tanuku Bazar S.O"
  },
  "521001": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Rajupet S.O"
  },
  "277302": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Kharasara SO"
  },
  "603001": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Chengalpattu Cutcherry SO"
  },
  "281501": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Aring SO"
  },
  "246440": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Adibadri SO"
  },
  "246475": {
    "state": "UTTARAKHAND",
    "district": "RUDRA PRAYAG",
    "office": "Tilwara SO"
  },
  "248009": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Rajpur SO Dehradun"
  },
  "249402": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Bahadrabad SO"
  },
  "246486": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Bachhuwaban SO"
  },
  "246424": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Chamoli SO"
  },
  "110110": {
    "state": "DELHI",
    "district": "NORTH WEST",
    "office": "Nodal Delivery Centre(Parcel), Rohini"
  },
  "721152": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Panskura RS SO"
  },
  "721139": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Panskura SO"
  },
  "721154": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Pulsita SO"
  },
  "246429": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Gauchar SO"
  },
  "246439": {
    "state": "UTTARAKHAND",
    "district": "RUDRA PRAYAG",
    "office": "Guptkashi SO"
  },
  "110062": {
    "state": "DELHI",
    "district": "SOUTH",
    "office": "Hamdard Nagar SO"
  },
  "110025": {
    "state": "DELHI",
    "district": "South East",
    "office": "Sukhdev Vihar SO"
  },
  "110024": {
    "state": "DELHI",
    "district": "SOUTH",
    "office": "Lajpat Nagar South Delhi SO"
  },
  "110013": {
    "state": "DELHI",
    "district": "SOUTH",
    "office": "Hazrat Nizamuddin SO"
  },
  "110017": {
    "state": "DELHI",
    "district": "SOUTH",
    "office": "South Malviya Nagar SO"
  },
  "493881": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Nawapara Rajim SO"
  },
  "492010": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Science College SO"
  },
  "272201": {
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTH NAGAR",
    "office": "Barhni SO"
  },
  "272193": {
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTH NAGAR",
    "office": "Bhanwapur SO"
  },
  "272202": {
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTH NAGAR",
    "office": "Birdpur SO"
  },
  "272152": {
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTH NAGAR",
    "office": "Daldala SO"
  },
  "722142": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Maliara SO"
  },
  "360026": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Sapar Veraval SO"
  },
  "360028": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Rajkot Bedi DSO"
  },
  "742236": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Ntpc Farakka SO"
  },
  "742238": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Palsandamore SO"
  },
  "122098": {
    "state": "HARYANA",
    "district": "GURUGRAM",
    "office": "CRPF Kadarpur SO"
  },
  "713502": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Dainhat SO"
  },
  "500002": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Charminar HO"
  },
  "500062": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Ecil S.O"
  },
  "635001": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Krishnagiri Courts S.O"
  },
  "522006": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "Chowdaripeta(Guntur) S.O"
  },
  "110067": {
    "state": "DELHI",
    "district": "NEW DELHI",
    "office": "Munirka SO"
  },
  "734426": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Kamala Bagan SO"
  },
  "734010": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Matigara SO"
  },
  "734009": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Sukna SO"
  },
  "251309": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Budhana SO"
  },
  "251311": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Charthawal SO"
  },
  "251003": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Industrial Estate SO Muzaffarnagar"
  },
  "247772": {
    "state": "UTTAR PRADESH",
    "district": "SHAMLI",
    "office": "Jalalabad SO Muzaffarnagar"
  },
  "251314": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Jansath SO"
  },
  "247774": {
    "state": "UTTAR PRADESH",
    "district": "SHAMLI",
    "office": "Kairana SO"
  },
  "247773": {
    "state": "UTTAR PRADESH",
    "district": "SHAMLI",
    "office": "Jhinjhana SO"
  },
  "247775": {
    "state": "UTTAR PRADESH",
    "district": "SHAMLI",
    "office": "Ganj Bazar Kandhala SO"
  },
  "251201": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Khatauli SO"
  },
  "721507": {
    "state": "WEST BENGAL",
    "district": "Jhargram",
    "office": "Jhargram HO"
  },
  "712124": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Bhadreswar SO"
  },
  "712401": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Champadanga SO"
  },
  "712403": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Haripal SO"
  },
  "500083": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Nagaram S.O"
  },
  "741165": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Nazirpur SO Nadia"
  },
  "741102": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Saktinagar SO"
  },
  "741125": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Belpukur SO"
  },
  "741126": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Bethuadahari SO"
  },
  "741140": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Dhubulia T B Hospital SO"
  },
  "741162": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Kasiadanga SO"
  },
  "741302": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Nabadwip Dham RS SO"
  },
  "741181": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Paglachandi SO"
  },
  "741155": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Palashipara SO"
  },
  "741156": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Plassey SO"
  },
  "741316": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Srirampur SO Nadia"
  },
  "741315": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Swarupganj SO"
  },
  "741222": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Lalpur SO Nadia"
  },
  "741245": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Madanpur SO Nadia"
  },
  "741257": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Nagarukhra SO"
  },
  "733132": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR DAKSHIN",
    "office": "Kushmandi SO"
  },
  "251203": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Mansurpur SO"
  },
  "251315": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Miranpur SO"
  },
  "251316": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Morna SO"
  },
  "251320": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Ramraj SO"
  },
  "251202": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Rohana Mills SO"
  },
  "251318": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Shahpur Muzaffarnagar SO"
  },
  "711206": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Sapuipara SO"
  },
  "734103": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Jalapahar SO"
  },
  "734220": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "StMarys Hill SO"
  },
  "721644": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Paramanandapur SO"
  },
  "721634": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Raghunathbari SO"
  },
  "721647": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Ramchandrapur SO East Midnapore"
  },
  "721650": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Reapara SO"
  },
  "721651": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Srirampur Mid SO"
  },
  "721635": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Sutahata SO"
  },
  "721646": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Tekhalibazar SO"
  },
  "246426": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Chhinka SO"
  },
  "246427": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Debal SO"
  },
  "246428": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Gairsain SO"
  },
  "246435": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Ghat SO"
  },
  "803101": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Sakunat SO"
  },
  "713123": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Banwaribad Raj SO"
  },
  "323615": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Lakheri Gaon S.O"
  },
  "723202": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Durgi BO"
  },
  "723213": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Ropo BO"
  },
  "723131": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Tarabari BO"
  },
  "723132": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Tara BO"
  },
  "723151": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Bhutam BO"
  },
  "712102": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Chinsurah RS SO"
  },
  "712302": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Dhaniakhali SO"
  },
  "712512": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Guptipara SO"
  },
  "712103": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Hooghly SO"
  },
  "712147": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Itachuna SO"
  },
  "712515": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Khamargachi SO"
  },
  "712148": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Magra SO"
  },
  "712149": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Pandua SO"
  },
  "712305": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Puinan SO"
  },
  "500037": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Balanagar Township S.O"
  },
  "500103": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Jai Jawan Colony S.O"
  },
  "500042": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Hal S.O"
  },
  "689121": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Chengannur RS SO"
  },
  "500080": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Gandhinagar S.O"
  },
  "500007": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Jama I Osmania S.O"
  },
  "500016": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Begumpet S.O"
  },
  "500025": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Himmatnagar S.O"
  },
  "500010": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Alwal S.O"
  },
  "500014": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Hakimpet S.O"
  },
  "500017": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Lallapet S.O"
  },
  "500050": {
    "state": "TELANGANA",
    "district": "RANGA REDDY",
    "office": "Chandanagar S.O"
  },
  "500047": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Anandbagh S.O"
  },
  "500049": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Mathrusri Nagar S.O"
  },
  "201306": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "IA Surajpur SO"
  },
  "201309": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Sec62 Noida SO"
  },
  "625513": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Bodinayakanur H.O"
  },
  "384470": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Gozaria SO"
  },
  "723149": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Natua BO"
  },
  "723156": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Murardih SO"
  },
  "723155": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Dubra BO"
  },
  "502110": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Medak Town S.O"
  },
  "277201": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Bairia SO Ballia"
  },
  "277203": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Bansdih Road SO"
  },
  "600003": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Ripon Buildings S.O"
  },
  "600002": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Chintadripet"
  },
  "600008": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "EGMORE NDSO"
  },
  "277202": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Bansdih SO"
  },
  "277204": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Dallan Chhapra SO"
  },
  "246401": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Gopeshwar Collectorate SO"
  },
  "246422": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Badrinath Seasonal SO"
  },
  "110056": {
    "state": "DELHI",
    "district": "NORTH WEST",
    "office": "Shakur Basti Depot SO"
  },
  "110099": {
    "state": "DELHI",
    "district": "NORTH WEST",
    "office": "ROHINI SECTOR 23 SO"
  },
  "248003": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Telbhawan SO"
  },
  "246495": {
    "state": "UTTARAKHAND",
    "district": "RUDRA PRAYAG",
    "office": "Chopra SO Rudraprayag"
  },
  "712304": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Janai SO"
  },
  "712404": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Jangipara SO"
  },
  "712405": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Khamarchandi SO"
  },
  "712202": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Mahesh 1 SO"
  },
  "712139": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Mankundu SO"
  },
  "712701": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Masat SO"
  },
  "712250": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Morepukur SO"
  },
  "712407": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Nalikul SO"
  },
  "324007": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Chhawni Ram Chandra Pura S.O"
  },
  "324006": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Kota City S.O"
  },
  "721127": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Kharkusma BO"
  },
  "721306": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Hijli Cooperative BO"
  },
  "721101": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Midnapore Sitala SO"
  },
  "609110": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Sirkali H.O"
  },
  "246441": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Gwaldam SO"
  },
  "246443": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Vishnupuram SO"
  },
  "246444": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Karanprayag SO"
  },
  "246446": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Langasu SO"
  },
  "246431": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Mehalchauri SO"
  },
  "246488": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Nainisain SO"
  },
  "246453": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Nalgaun SO"
  },
  "246449": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Nandprayag SO"
  },
  "246455": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Narayan Bagar SO"
  },
  "623501": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Ramanathapuram HO"
  },
  "626117": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Rajapalayam Bus Stand SO"
  },
  "606202": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Kallakurichi H.O"
  },
  "493887": {
    "state": "CHHATTISGARH",
    "district": "GARIYABAND",
    "office": "Kopra SO"
  },
  "626134": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Chettikurichi SO"
  },
  "626106": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Kariapatti SO"
  },
  "713405": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Dhatrigram SO"
  },
  "713103": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Sripalli SO"
  },
  "733209": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR UTTAR",
    "office": "Kanki SO"
  },
  "733215": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR UTTAR",
    "office": "Karandighi SO"
  },
  "272195": {
    "state": "UTTAR PRADESH",
    "district": "SIDDHARTH NAGAR",
    "office": "Bayara SO"
  },
  "630606": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Manamadurai RS SO"
  },
  "492009": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Raipur Ganj SO"
  },
  "700074": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Motijheel SO"
  },
  "636001": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Salem Bazaar S.O"
  },
  "641002": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "RSPuram East SO"
  },
  "723133": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Rakshatpur BO"
  },
  "723154": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Thumba Jhalda BO"
  },
  "631152": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Suraksha Cisf Campus SO"
  },
  "211001": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "K N Marg SO"
  },
  "276136": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "LATGHAT SO"
  },
  "223225": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "MAHUL SO"
  },
  "276203": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "MEHNAJPUR SO"
  },
  "276204": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "MEHNAGAR SO"
  },
  "263652": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Majkhali SO"
  },
  "263663": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Tarikhet SO"
  },
  "383006": {
    "state": "GUJARAT",
    "district": "SABAR KANTHA",
    "office": "Boria SO Sabarkantha"
  },
  "621212": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Perambalur Collectorate S.O"
  },
  "621103": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Arumbavur S.O"
  },
  "621104": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Chathiramanai B.O"
  },
  "621133": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Eraiyur S.O (Perambalur)"
  },
  "621106": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Sathanur B.O"
  },
  "733130": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR UTTAR",
    "office": "Karnojora SO"
  },
  "712402": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Dasghara SO"
  },
  "712303": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Gurap SO"
  },
  "712146": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Ilsobamondalai SO"
  },
  "741158": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Shikarpur SO Nadia"
  },
  "741160": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Tehatta SO"
  },
  "741301": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Char Brahmanagar SO"
  },
  "741137": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Debagram SO"
  },
  "500085": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "VASANTHNAGAR SO"
  },
  "500072": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Kukatpally S.O"
  },
  "492018": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Sector  27 Naya Raipur SO"
  },
  "722102": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Lokepur SO"
  },
  "722139": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Kenjakura SO"
  },
  "722155": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Kesiakole SO"
  },
  "700004": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Shyambazar Mail SO"
  },
  "721303": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Kalaikunda A F SO"
  },
  "721124": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Kalikadihi BO"
  },
  "721201": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Pandua BO"
  },
  "276143": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "MITTOOPUR"
  },
  "276205": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "MOHAMMADPUR SO"
  },
  "276404": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "MUBARAKPUR SO"
  },
  "276206": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "NIZAMBAD SO"
  },
  "627811": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Tenkasi RS S.O"
  },
  "497450": {
    "state": "CHHATTISGARH",
    "district": "KOREA",
    "office": "Khadgawan SO"
  },
  "607001": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Semmandalam S.O"
  },
  "612002": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Melakaveri H.O"
  },
  "496108": {
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "office": "Urjanagar Telirampur SO"
  },
  "628501": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Kovilpatti Town S.O"
  },
  "625001": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Vilakkuthoon SO"
  },
  "628215": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Tiruchendur Devasthanam S.O"
  },
  "626118": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "MReddiapatti SO"
  },
  "626607": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Narikudi SO"
  },
  "626112": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Palayampatti SO"
  },
  "626113": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Pandalgudi SO"
  },
  "626129": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Tiruchuli SO"
  },
  "626102": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Chatrapatti SO Virudhunagar"
  },
  "626111": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Muhavur SO"
  },
  "626127": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Tamilnadu Cements Alangulam SO"
  },
  "722160": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Lakshmisagar SO"
  },
  "722143": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Mejhia SO"
  },
  "722208": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Pakhanna SO"
  },
  "722156": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Panchmura SO"
  },
  "604001": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Tindivanam Bazaar SO"
  },
  "605602": {
    "state": "TAMIL NADU",
    "district": "VILLUPURAM",
    "office": "Villupuram West SO"
  },
  "233001": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Markeenganj SO"
  },
  "500026": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Nehrunagar S.O"
  },
  "500056": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Neredmet S.O"
  },
  "500061": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Sitaphalmandi S.O"
  },
  "500011": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Bowenpally S.O"
  },
  "500094": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Sainikpuri S.O"
  },
  "500040": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Ie Moulali S.O"
  },
  "500009": {
    "state": "TELANGANA",
    "district": "HYDERABAD",
    "office": "Manovikasnagar S.O"
  },
  "734005": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Siliguri Bazar SO"
  },
  "734012": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Sushrut Nagar SO"
  },
  "221307": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Mirzamurad SO"
  },
  "221403": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Sewapuri SO"
  },
  "221208": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Sindhora SO"
  },
  "600070": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Anakaputhur SO"
  },
  "600064": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Hasthinapuram SO"
  },
  "600043": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Rajajinagar SO Kanchipuram"
  },
  "600131": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "SITHALAPAKKAM SO"
  },
  "643101": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Coonoor H.O"
  },
  "276288": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "PAWAI SO"
  },
  "276304": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "PHOOLPUR TOWN SO"
  },
  "223226": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "PUSPNAGAR SO"
  },
  "276207": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "RANI KI SARAI SO"
  },
  "276138": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "SAGRI SO"
  },
  "620001": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Tiruchirappalli RS SO"
  },
  "600117": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Keelakattalai SO"
  },
  "221404": {
    "state": "UTTAR PRADESH",
    "district": "BHADOHI",
    "office": "Suriyawan SO"
  },
  "530020": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "VM Bus Station S.O"
  },
  "530017": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "L B Colony S.O"
  },
  "530002": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Maharanipeta S.O"
  },
  "515872": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Herial S.O"
  },
  "246487": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Nauti SO"
  },
  "246472": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Pipalkoti SO"
  },
  "246473": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Pokhari Nagnath SO"
  },
  "246442": {
    "state": "UTTARAKHAND",
    "district": "RUDRA PRAYAG",
    "office": "Jakhani SO"
  },
  "246141": {
    "state": "UTTARAKHAND",
    "district": "RUDRA PRAYAG",
    "office": "Jakholi SO"
  },
  "626138": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Kunnur SO"
  },
  "626141": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Malli SO"
  },
  "626137": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Pillayarkulam SO"
  },
  "627002": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Samadanapuram SO"
  },
  "271801": {
    "state": "UTTAR PRADESH",
    "district": "BAHRAICH",
    "office": "Bahraich City SO"
  },
  "700012": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Yogayog Bhawan SO"
  },
  "711106": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Hooghly Dock SO"
  },
  "251327": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Purkazi SO"
  },
  "110097": {
    "state": "DELHI",
    "district": "SOUTH WEST",
    "office": "Kapashera SO"
  },
  "626001": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Virudhunagar Town SO"
  },
  "626101": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Aruppukottai Bazzar SO"
  },
  "496109": {
    "state": "CHHATTISGARH",
    "district": "RAIGARH",
    "office": "Punjipathra SO"
  },
  "628001": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Vetrivelpuram S.O"
  },
  "628207": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Kurumbur S.O"
  },
  "628218": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Mannanvilai S.O"
  },
  "628210": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Megnanapuram S.O"
  },
  "628211": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Nalumavadi S.O"
  },
  "628152": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Pazhaiyalkayal S.O"
  },
  "628008": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Millerpuram S.O"
  },
  "492004": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Shanker Nagar SO"
  },
  "492014": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Saddu SO"
  },
  "492005": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Vidhan Sabha SO Raipur"
  },
  "628851": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Ellanaickenpatti S.O"
  },
  "628002": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Victoria Extension Road S.O"
  },
  "628303": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Naraikinar S.O"
  },
  "628401": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Otapidaram S.O"
  },
  "628402": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Pudiyamputhur S.O"
  },
  "638452": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Gobichettipalayam East SO"
  },
  "600026": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Vadapalani S.O"
  },
  "600033": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Mambalam R.S. S.O"
  },
  "600016": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Alandur(Reopened W.E.F.6.6.05) S.O"
  },
  "600001": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Flower Bazaar"
  },
  "277402": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Haldi SO Ballia"
  },
  "735301": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Changrabandha SO"
  },
  "630321": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Vethiyur SO"
  },
  "630558": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Paganeri SO"
  },
  "605757": {
    "state": "TAMIL NADU",
    "district": "KALLAKURICHI",
    "office": "Tirukkoyilur Bazaar S.O"
  },
  "606001": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Vriddhachalam Bazaar S.O"
  },
  "206001": {
    "state": "UTTAR PRADESH",
    "district": "ETAWAH",
    "office": "K K D C Etawah SO"
  },
  "643001": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Udagamandalam Race Course S.O"
  },
  "221204": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Baragaon SO Varanasi"
  },
  "221108": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Bhulanpur Pac SO"
  },
  "221105": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Harhua SO"
  },
  "741138": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Dharmada SO"
  },
  "741150": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Kaliganj SO"
  },
  "741154": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Muragachha SO"
  },
  "741157": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Plassey Sugar Mill SO"
  },
  "741313": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Sreemayapur SO"
  },
  "713409": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Kalna SO"
  },
  "713129": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Komarpur BO"
  },
  "277301": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Basantpur SO Ballia"
  },
  "277401": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Bharsar SO"
  },
  "277210": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Chhata SO Ballia"
  },
  "277214": {
    "state": "UTTAR PRADESH",
    "district": "BALLIA",
    "office": "Karanchhapa SO"
  },
  "636005": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Suramangalam Railway Colony S.O"
  },
  "600010": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Kilpauk S.O"
  },
  "600082": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "G K M Colony S.O"
  },
  "600011": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Sembiam S.O"
  },
  "712308": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Khanpur SO Hooghly"
  },
  "712152": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Rameswarpur SO"
  },
  "632401": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Ranipet Bazar SO"
  },
  "712310": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Dankuni Coal Complex SO"
  },
  "712311": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Dankuni SO"
  },
  "712138": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Khalisani SO"
  },
  "712203": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Mallickpara SO"
  },
  "712249": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Prabasnagar SO"
  },
  "110065": {
    "state": "DELHI",
    "district": "SOUTH",
    "office": "Sriniwaspuri SO"
  },
  "741166": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Seemanagar SO"
  },
  "741153": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Matiari SO"
  },
  "741504": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Duttapulia SO"
  },
  "723146": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Santaldih TP SO"
  },
  "380006": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Ellisbridge SO"
  },
  "380052": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Memnagar SO"
  },
  "625601": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Vadagarai S.O"
  },
  "380007": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Paldi SO Ahmedabad"
  },
  "380061": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Ghatlodia SO"
  },
  "380055": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Juhapura SO"
  },
  "576220": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Kollur SO"
  },
  "276140": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "JIYANPUR SO"
  },
  "380014": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Navjivan SO"
  },
  "624208": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Nilakottai HO"
  },
  "600004": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Mandaveli S.O"
  },
  "600017": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Thygarayanagar South NDS.O"
  },
  "500054": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "HMT Township S.O"
  },
  "500067": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Suchitra Junction S.O"
  },
  "500093": {
    "state": "TELANGANA",
    "district": "MEDCHAL MALKAJGIRI",
    "office": "Vikasnagar S.O"
  },
  "602001": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Nggo Colony Tiruvallur S.O"
  },
  "641301": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Mettupalayam HO"
  },
  "282003": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "Gandhi Nagar"
  },
  "788151": {
    "state": "ASSAM",
    "district": "HAILAKANDI",
    "office": "Hailakandi H.O"
  },
  "517001": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Ctr Market S.O"
  },
  "516005": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Yogi Vemana University S.O."
  },
  "763002": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "R Zone(Sunabeda) S.O"
  },
  "144023": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Dakoha SO"
  },
  "144010": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Dhanowali SO"
  },
  "271001": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Civil Line SO Gonda"
  },
  "221405": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Hathi Bazar SO"
  },
  "221313": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Kachhwa Road SO"
  },
  "221107": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Lohta SO"
  },
  "221206": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Pindra SO"
  },
  "221311": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Rajatalab SO"
  },
  "201301": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Sec 27 Noida SO"
  },
  "626104": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Kalkurichi SO"
  },
  "626107": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Kovilangulam SO"
  },
  "231001": {
    "state": "UTTAR PRADESH",
    "district": "MIRZAPUR",
    "office": "Ganesh Ganj SO Mirzapur"
  },
  "642006": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Suleeswaran Patti S.O"
  },
  "636102": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Aturbazaar S.O"
  },
  "635601": {
    "state": "TAMIL NADU",
    "district": "Tirupathur",
    "office": "Gandhipet   TPT S.O"
  },
  "631005": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Winterpet SO"
  },
  "632406": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Bhel Ranipet SO"
  },
  "522239": {
    "state": "ANDHRA PRADESH",
    "district": "GUNTUR",
    "office": "A.P.High Court S.O"
  },
  "642126": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Eripalayam S.O"
  },
  "110048": {
    "state": "DELHI",
    "district": "South East",
    "office": "Masjid Moth SO"
  },
  "517646": {
    "state": "ANDHRA PRADESH",
    "district": "CHITTOOR",
    "office": "Sricity S.E.Z SO"
  },
  "431005": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Session Court S.O (Aurangabad)"
  },
  "431004": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Begumpura S.O"
  },
  "523316": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Markapur Bazar S.O"
  },
  "388239": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Wanakbori TPS SO"
  },
  "626004": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Palavanatham SO"
  },
  "626114": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Paralachi SO"
  },
  "626115": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Sethu Institute of Technology SO"
  },
  "272001": {
    "state": "UTTAR PRADESH",
    "district": "BASTI",
    "office": "Orijote SO"
  },
  "632001": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Sainathapuram S.O"
  },
  "221303": {
    "state": "UTTAR PRADESH",
    "district": "BHADOHI",
    "office": "Gopiganj SO"
  },
  "221310": {
    "state": "UTTAR PRADESH",
    "district": "BHADOHI",
    "office": "Jangiganj SO"
  },
  "221406": {
    "state": "UTTAR PRADESH",
    "district": "BHADOHI",
    "office": "Mondh SO"
  },
  "221409": {
    "state": "UTTAR PRADESH",
    "district": "BHADOHI",
    "office": "Nai Bazar SO Sant Ravidas Nagar"
  },
  "221308": {
    "state": "UTTAR PRADESH",
    "district": "BHADOHI",
    "office": "Ozh SO"
  },
  "632301": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Arni Fort SO"
  },
  "515413": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Bhogasamudram Project S.O"
  },
  "530022": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Isakathota S.O"
  },
  "530013": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "P and T Colony (VM) S.O"
  },
  "825421": {
    "state": "JHARKHAND",
    "district": "KODERMA",
    "office": "Koderma Thermal Power Station SO"
  },
  "530041": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Pothinamallayapalem S.O"
  },
  "530024": {
    "state": "ANDHRA PRADESH",
    "district": "VISAKHAPATANAM",
    "office": "Salagramapuram S.O"
  },
  "700111": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Ghola Bazar SO"
  },
  "743268": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Habra Prafulla Nagar SO"
  },
  "700133": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Michealnagar SO"
  },
  "600032": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Guindy Industrial Estate S.O"
  },
  "600115": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Neelangarai S.O"
  },
  "600091": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Ram Nagar"
  },
  "600088": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Adambakkam S.O"
  },
  "600097": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Karapakkam S.O"
  },
  "600041": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Valmiki Nagar S.O"
  },
  "600096": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Dr Ambedkar Law Univeristy"
  },
  "600022": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Rajbhavan S.O (Chennai)"
  },
  "600042": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Velacheri S.O"
  },
  "628103": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Pudukottai S.O"
  },
  "506146": {
    "state": "TELANGANA",
    "district": "JANGOAN",
    "office": "Palakurthy S.O"
  },
  "823005": {
    "state": "BIHAR",
    "district": "GAYA",
    "office": "Asc CentreN Gaya SO"
  },
  "628208": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Manaduthandapathu S.O"
  },
  "825326": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Tapin SO"
  },
  "825415": {
    "state": "JHARKHAND",
    "district": "CHATRA",
    "office": "NTPC North Karanpura SO"
  },
  "829130": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Prc SO"
  },
  "302002": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Tripolia Bazar S.O"
  },
  "302003": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Jaipur City S.O"
  },
  "302001": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "C.P.M.G S.O"
  },
  "302004": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "S.M.S.Hospital S.O"
  },
  "302006": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Station Road S.O (Jaipur)"
  },
  "302039": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Vidhyadhar Nagar S.O"
  },
  "302016": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Shastri Nagar H.O"
  },
  "302036": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Jaisinghpura Khore S.O"
  },
  "302019": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Shyam Nagar S.O (Jaipur)"
  },
  "302021": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Vaishali Nagar S.O"
  },
  "302020": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "S.F.S.Mansarovar S.O"
  },
  "628213": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Paramankurichi S.O"
  },
  "628203": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Udangudi Christianagaram S.O"
  },
  "628301": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Kailasapuram S.O (Tuticorin)"
  },
  "570027": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Infosys Campus S.O"
  },
  "570014": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Jayanagar S.O (Mysuru)"
  },
  "570022": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Ramakrishna Nagar S.O (Mysuru)"
  },
  "497773": {
    "state": "CHHATTISGARH",
    "district": "KOREA",
    "office": "West Chirimiri SO"
  },
  "628101": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Korampollam S.O"
  },
  "628102": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Mudittanendal S.O"
  },
  "628304": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Tattaparai S.O"
  },
  "413004": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Indiranagar S.O (Solapur)"
  },
  "413005": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Sakhar Peth S.O"
  },
  "396421": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Jalalpore SO"
  },
  "396370": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Kachholi SO"
  },
  "324004": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Udyog Puri Kota S.O"
  },
  "110060": {
    "state": "DELHI",
    "district": "CENTRAL",
    "office": "Rajender Nagar SO"
  },
  "393017": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Avidha SO"
  },
  "388310": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Ajarpura SO"
  },
  "387315": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Chaklashi SO"
  },
  "626612": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Viracholan SO"
  },
  "626139": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Cholapuram South SO"
  },
  "626136": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Kilarajakularaman SO"
  },
  "626121": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Seithur SO"
  },
  "626142": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Sundaranachiarpuram SO"
  },
  "626132": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Watrap SO"
  },
  "628252": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Vallanad S.O"
  },
  "628251": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Sawyerpuram S.O"
  },
  "628104": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Sekkarakudi S.O"
  },
  "628105": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Taruvaikulam S.O"
  },
  "342003": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Pratap Nagar SO Jodhpur"
  },
  "600013": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Rayapuram S.O"
  },
  "600081": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Tondiarpet S.O"
  },
  "600021": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Washermanpet S.O"
  },
  "207001": {
    "state": "UTTAR PRADESH",
    "district": "ETAH",
    "office": "Gandhi Market SO Etah"
  },
  "600093": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Saligramam S.O"
  },
  "741254": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Kalinarayanpur SO"
  },
  "303329": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "A C Jobner SO"
  },
  "600102": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Anna Nagar East S.O"
  },
  "600101": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Anna Nagar Western Extn S.O"
  },
  "600023": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Aynavaram S.O"
  },
  "600031": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "World University Service Centre"
  },
  "600106": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Arumbakkam S.O"
  },
  "600012": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Perambur Barracks S.O"
  },
  "600030": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Aminjikarai S.O"
  },
  "600039": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Vyasarpadi S.O"
  },
  "600020": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Shastri Nagar S.O (Chennai)"
  },
  "600083": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Jafferkhanpet S.O"
  },
  "600036": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Indian Institute Of Technology S.O"
  },
  "600078": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Kalaignar Karunanidhi Nagar S.O"
  },
  "600061": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Pazhavanthangal S.O"
  },
  "360007": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Rajkot Raiya Road SO"
  },
  "363623": {
    "state": "GUJARAT",
    "district": "MORBI",
    "office": "Dhuva S.O"
  },
  "627401": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Ambasamudram East SO"
  },
  "626110": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Mohamed Sahibpuram SO"
  },
  "732101": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Sarbamangalapally SO"
  },
  "506009": {
    "state": "TELANGANA",
    "district": "WARANGAL URBAN",
    "office": "Vidyaranyapuri S.O"
  },
  "342007": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Jodhpur KUM Mandore Road SO"
  },
  "784125": {
    "state": "ASSAM",
    "district": "DARRANG",
    "office": "Mangaldoi H.O"
  },
  "626116": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "W Pudupatti SO"
  },
  "626123": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Sivakasi Bus Stand SO"
  },
  "387003": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Petlad Road SO"
  },
  "144415": {
    "state": "PUNJAB",
    "district": "Shahid Bhagat Singh Nagar",
    "office": "Lassara SO"
  },
  "842006": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Kalwari SO Muzaffarpur"
  },
  "843130": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "Kanti TPS SO"
  },
  "700089": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Lake Town SO North 24 Parganas"
  },
  "700064": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Bidhannagr CC Block SO"
  },
  "605001": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "Pondicherry HO"
  },
  "641601": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Tirupur HO"
  },
  "631501": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Thoopul S.O"
  },
  "700033": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "TCRoad SO"
  },
  "504220": {
    "state": "TELANGANA",
    "district": "MANCHERIAL",
    "office": "Madaram Township S.O"
  },
  "243501": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "B R Factory"
  },
  "700046": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Abinash Chaowdhury Lane SO"
  },
  "764006": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Bariniput S.O"
  },
  "763004": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Nad, Sunabeda S.O"
  },
  "763001": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Sunabeda 1 S.O"
  },
  "413411": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "K.V.Nagar Barshi S.O"
  },
  "505211": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Gv8incline S.O"
  },
  "396403": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Aat SO"
  },
  "396424": {
    "state": "GUJARAT",
    "district": "NAVSARI",
    "office": "Kabilpore SO"
  },
  "814167": {
    "state": "JHARKHAND",
    "district": "DUMKA",
    "office": "Ranga Masalia SO"
  },
  "394516": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Adityanagar SO"
  },
  "395017": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Althan SO"
  },
  "394270": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Nandniketan SO"
  },
  "394515": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Kribhconagar SO"
  },
  "394518": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Ongc Nagar SO"
  },
  "392135": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Jolva SO"
  },
  "621601": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Lalgudi HO"
  },
  "160059": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Chandigarh Sector 59 SO"
  },
  "160062": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Chandigarh Sector 67 SO"
  },
  "611001": {
    "state": "TAMIL NADU",
    "district": "NAGAPATTINAM",
    "office": "Velippalayam S.O"
  },
  "576114": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Kallianapura SO"
  },
  "700016": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Park Street HO"
  },
  "700069": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Income Tax Building SO"
  },
  "700071": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Middleton Row SO"
  },
  "700021": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Fort William SO"
  },
  "700072": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Hindustan Building SO"
  },
  "560093": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "C V Raman Nagar S.O"
  },
  "560016": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Ramamurthy Nagar S.O"
  },
  "560017": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "N A L S.O"
  },
  "560115": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Kannamangala S.O"
  },
  "560300": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Bengaluru International Airport S.O"
  },
  "560005": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Fraser Town S.O"
  },
  "492002": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Mantralaya Raipur SO"
  },
  "492003": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Urla SO"
  },
  "492016": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "Mana Basti SO"
  },
  "492017": {
    "state": "CHHATTISGARH",
    "district": "RAIPUR",
    "office": "IBC Raipur PO"
  },
  "900056": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "1CBPO"
  },
  "394327": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Kadodara SO"
  },
  "394660": {
    "state": "GUJARAT",
    "district": "TAPI",
    "office": "Centrap Pulp Mill SO"
  },
  "686022": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Chengalam South SO"
  },
  "686002": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kottayam Collectorate SO"
  },
  "712306": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Begampur SO Hooghly"
  },
  "302005": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "N.C.R.Building S.O"
  },
  "302018": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Durgapura S.O"
  },
  "302015": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Tonk Road SO"
  },
  "302017": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Malviya Nagar S.O (Jaipur)"
  },
  "302033": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Pratap Nagar Sector 11 S.O"
  },
  "721172": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Nonakuribazar SO"
  },
  "246474": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Simli SO"
  },
  "246481": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Tharali SO"
  },
  "246171": {
    "state": "UTTARAKHAND",
    "district": "RUDRA PRAYAG",
    "office": "Pallabazar SO"
  },
  "627756": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Sankarankovil Bazaar S.O"
  },
  "497553": {
    "state": "CHHATTISGARH",
    "district": "KOREA",
    "office": "Kurasia Colly SO"
  },
  "625002": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Madurai Corporation Building SO"
  },
  "491996": {
    "state": "CHHATTISGARH",
    "district": "KABIRDHAM",
    "office": "SahasPur Lohara SO"
  },
  "497451": {
    "state": "CHHATTISGARH",
    "district": "KOREA",
    "office": "Haldibadi SO"
  },
  "497557": {
    "state": "CHHATTISGARH",
    "district": "KOREA",
    "office": "Sonawani Colly SO"
  },
  "712702": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Chanditala SO"
  },
  "712245": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Makhla SO"
  },
  "712246": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Nabagram SO Hooghly"
  },
  "302042": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Bad Ke Balaji S.O"
  },
  "388355": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Navli SO"
  },
  "825329": {
    "state": "JHARKHAND",
    "district": "GIRIDIH",
    "office": "Shikherjee SO"
  },
  "833212": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "Danguaposi SO"
  },
  "831005": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Kadma SO"
  },
  "680691": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Koolimuttam SO"
  },
  "311001": {
    "state": "RAJASTHAN",
    "district": "BHILWARA",
    "office": "Krisi Upaj Mandi Bwa S.O"
  },
  "721637": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Abasbari SO"
  },
  "248171": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Majra SO Dehradun"
  },
  "248012": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Defence Colony SO"
  },
  "700086": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Baghajatin SO"
  },
  "700025": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Ramkrishna Park SO"
  },
  "700042": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Kasba SO Kolkata"
  },
  "700107": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Madurdaha SO"
  },
  "700019": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Golpark SO"
  },
  "700082": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "KPBazar SO Kolkata"
  },
  "700020": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "AJCBose Road SO"
  },
  "700031": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Dhakuria SO"
  },
  "700026": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Kalimandir SO"
  },
  "700047": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Raipur Jorabagan Road SO"
  },
  "700040": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Netaji Nagar SO Kolkata"
  },
  "700094": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Sammilani Mahavidyalaya SO"
  },
  "700078": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Jadavgarh SO"
  },
  "700022": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Hastings SO"
  },
  "700032": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Jadavpur University SO"
  },
  "700045": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Lake Gardens SO"
  },
  "700092": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Regent Estate SO"
  },
  "700061": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Dakshin Behala SO"
  },
  "734101": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Darjeeling Court SO"
  },
  "388470": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Sunav SO"
  },
  "766003": {
    "state": "ODISHA",
    "district": "KALAHANDI",
    "office": "Bhawanipatna Engineering College SO"
  },
  "388465": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Palaj SO"
  },
  "741250": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Kataganj SO"
  },
  "700144": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Baruipur HO"
  },
  "713201": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Durgapur Rabindra Pally SO"
  },
  "678013": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kunnathurmedu SO"
  },
  "678533": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Meenakshipuram SO"
  },
  "678014": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Palakkad City SO"
  },
  "690532": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Chingoli SO"
  },
  "690511": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Muttomalleppey SO"
  },
  "690530": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Thamarakulam SO"
  },
  "689623": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Kuttemperur SO"
  },
  "690510": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Olakettiambalam SO"
  },
  "721122": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Sahaspur BO"
  },
  "721211": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Molighati BO"
  },
  "721126": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Mukshudpur BO"
  },
  "721212": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Bandar BO"
  },
  "721161": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Mohar SO"
  },
  "744209": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "NORTH AND MIDDLE ANDAMAN",
    "office": "Kadamtala S.O (North And Middle Andaman)"
  },
  "742101": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Laldighi SO"
  },
  "742160": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Nashipur Rajbati SO"
  },
  "384003": {
    "state": "GUJARAT",
    "district": "MAHESANA",
    "office": "Mahesana Ongc Colony SO"
  },
  "624001": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Pandianagar SO"
  },
  "624601": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Palani Devastanam SO"
  },
  "614601": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Pattukottai H.O"
  },
  "246469": {
    "state": "UTTARAKHAND",
    "district": "RUDRA PRAYAG",
    "office": "Okhimath SO"
  },
  "621102": {
    "state": "TAMIL NADU",
    "district": "PERAMBALUR",
    "office": "Arasalur B.O"
  },
  "712301": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Bhandarhati SO"
  },
  "712134": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Boinchi SO"
  },
  "683573": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Angamally South SO"
  },
  "683502": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Binanipuram SO"
  },
  "683512": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Chendamangalam SO"
  },
  "683571": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Chowara SO"
  },
  "497448": {
    "state": "CHHATTISGARH",
    "district": "KOREA",
    "office": "South Jhagrakhand Colly SO"
  },
  "587156": {
    "state": "KARNATAKA",
    "district": "BAGALKOTE",
    "office": "Shirur S.O"
  },
  "639001": {
    "state": "TAMIL NADU",
    "district": "KARUR",
    "office": "Karur West S.O"
  },
  "276001": {
    "state": "UTTAR PRADESH",
    "district": "AZAMGARH",
    "office": "Azamgarh RS SO"
  },
  "160004": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Airforce Highground SO"
  },
  "713130": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Katwa College SO"
  },
  "683111": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kochi Airport SO"
  },
  "712513": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Nayasarai SO"
  },
  "688012": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Alappuzha Bazar SO"
  },
  "221003": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Chandmari SO"
  },
  "637001": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Thillaipuram S.O"
  },
  "221001": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Vijay Sirohi Nagar SO"
  },
  "221002": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "UP Collage SO"
  },
  "831021": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Nodal Delivery Centre Jamshedpur"
  },
  "832113": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Hata Chowk SO"
  },
  "822117": {
    "state": "JHARKHAND",
    "district": "PALAMU",
    "office": "Japla C F SO"
  },
  "831014": {
    "state": "JHARKHAND",
    "district": "SARAIKELA KHARSAWAN",
    "office": "NIT SO"
  },
  "628219": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Vellalanvilai S.O"
  },
  "613010": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Tamil University S.O"
  },
  "505215": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Jyothinagar NTPC S.O"
  },
  "614201": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Ayyampet S.O"
  },
  "688014": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Punnapra North SO"
  },
  "688004": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Punnapra SO"
  },
  "688534": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Aroor SO"
  },
  "688533": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Kuthiathode SO"
  },
  "688528": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Thycattussery SO"
  },
  "688536": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Vayalar SO"
  },
  "323601": {
    "state": "RAJASTHAN",
    "district": "BUNDI",
    "office": "Kesoraipatan S.O"
  },
  "814115": {
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "office": "Hindipith SO"
  },
  "342005": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Kuri Bhagtasni Housing Board SO"
  },
  "342006": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Jodhpur Umaid Bhawan SO"
  },
  "342011": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Ratanada SO"
  },
  "628212": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Panickanadarkudiyiruppu S.O"
  },
  "490022": {
    "state": "CHHATTISGARH",
    "district": "DURG",
    "office": "S A F Lines Bhilai SO"
  },
  "763003": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "D.P.Camp, Sunabeda S.O"
  },
  "144001": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Session Court SO Jalandhar"
  },
  "144007": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Ladhewali SO"
  },
  "144005": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Sadar Bazar Jalandhar Cantt SO"
  },
  "621010": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Turaiyur Extension S.O"
  },
  "614713": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Tiruturaipundi R.S. S.O"
  },
  "741246": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Mohanpur SO Nadia"
  },
  "723101": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Purulia HO"
  },
  "144601": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "Kanjli Road Kapurthala SO"
  },
  "144401": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "Banga Road Phagwara SO"
  },
  "814116": {
    "state": "JHARKHAND",
    "district": "DEOGHAR",
    "office": "Satsang SO"
  },
  "816115": {
    "state": "JHARKHAND",
    "district": "SAHEBGANJ",
    "office": "Sakrigali Ghat SO"
  },
  "413007": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Solapur City S.O"
  },
  "515003": {
    "state": "ANDHRA PRADESH",
    "district": "ANANTAPUR",
    "office": "Sri Venkateswara Puram S.O"
  },
  "829129": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Tenughat Dam SO"
  },
  "829131": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Src SO"
  },
  "711201": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Bally SO"
  },
  "400701": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Ghansoli S.O"
  },
  "400710": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Millenium Business Park S.O"
  },
  "400703": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Vashi S.O (Thane)"
  },
  "505214": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Vithalnagar S.O"
  },
  "505210": {
    "state": "TELANGANA",
    "district": "PEDDAPALLI",
    "office": "Fertilizercity S.O"
  },
  "834013": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Nodal Mechanized Delivery Office SO"
  },
  "431006": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Chikalthana Industrial Area S.O"
  },
  "829149": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "TTPSLalpania SO"
  },
  "723142": {
    "state": "WEST BENGAL",
    "district": "PURULIA",
    "office": "Ramchandrapur Ashram SO"
  },
  "602117": {
    "state": "TAMIL NADU",
    "district": "KANCHIPURAM",
    "office": "Irungattukottai S.O"
  },
  "642128": {
    "state": "TAMIL NADU",
    "district": "TIRUPPUR",
    "office": "Venkatesa Mills S.O"
  },
  "631001": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Ashoknagar SO Vellore"
  },
  "211002": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Rajapur SO"
  },
  "713101": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Ranisayar SO"
  },
  "222001": {
    "state": "UTTAR PRADESH",
    "district": "JAUNPUR",
    "office": "Shakarmandi SO"
  },
  "600113": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "TTTI Taramani S.O"
  },
  "600009": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Fort St George S.O"
  },
  "600104": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "High Court Building S.O (Chennai)"
  },
  "600089": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Ramapuram S.O (Kanchipuram)"
  },
  "603211": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Annai Anjugam Nagar SO"
  },
  "246471": {
    "state": "UTTARAKHAND",
    "district": "RUDRA PRAYAG",
    "office": "Phata SO"
  },
  "246483": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Tapoban SO"
  },
  "421501": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Ambernath South S.O"
  },
  "421002": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Ulhasnagar 2 S.O"
  },
  "421203": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Dombivali I.A. S.O"
  },
  "421004": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Ulhasnagar 4 S.O"
  },
  "144205": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Dasuya HO"
  },
  "281001": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Veterinary College SO"
  },
  "638001": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Erode Market SO"
  },
  "230001": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Station Road SO"
  },
  "700106": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Bidhan Nagar IB Market SO"
  },
  "734314": {
    "state": "WEST BENGAL",
    "district": "KALIMPONG",
    "office": "Algarah SO"
  },
  "342026": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Jodhpur BSF Trg Centre SO"
  },
  "246482": {
    "state": "UTTARAKHAND",
    "district": "CHAMOLI",
    "office": "Talwari SO"
  },
  "248124": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Barontha SO"
  },
  "248123": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Chakrata SO"
  },
  "502325": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Aie Bollaram S.O"
  },
  "502205": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "O.F.Yeddumailaram S.O"
  },
  "603127": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Anupuram SO"
  },
  "600087": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Alwarthirunagar S.O"
  },
  "600092": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Virugambakkam S.O"
  },
  "600040": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Anna Nagar S.O (Chennai)"
  },
  "600084": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Flowers Road S.O"
  },
  "600038": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Icf Colony S.O"
  },
  "600107": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Koyambedu Wholesale Market Complex"
  },
  "600025": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Engineering College S.O (Chennai)"
  },
  "248125": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Dakpathar SO"
  },
  "248142": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Herbertpur SO"
  },
  "248159": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Kalsi Gate SO"
  },
  "248158": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Kalsi SO"
  },
  "248165": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Koti SO"
  },
  "248179": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Landaur SO"
  },
  "248007": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "IMA SO"
  },
  "248197": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Sahaspur SO Dehradun"
  },
  "248196": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Sahiya SO"
  },
  "249145": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Chamma SO"
  },
  "249196": {
    "state": "UTTARAKHAND",
    "district": "UTTAR KASHI",
    "office": "Chinyalisour SO"
  },
  "249151": {
    "state": "UTTARAKHAND",
    "district": "UTTAR KASHI",
    "office": "Dunda SO"
  },
  "249146": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Gajja SO"
  },
  "249152": {
    "state": "UTTARAKHAND",
    "district": "UTTAR KASHI",
    "office": "Geonla SO"
  },
  "249155": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Ghansali SO"
  },
  "249122": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Hindolakhal SO"
  },
  "249123": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Jakhnidhar SO"
  },
  "249161": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Kirtinagar SO"
  },
  "249165": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Lambgaon SO"
  },
  "249194": {
    "state": "UTTARAKHAND",
    "district": "UTTAR KASHI",
    "office": "MD Colony SO"
  },
  "249128": {
    "state": "UTTARAKHAND",
    "district": "UTTAR KASHI",
    "office": "Mori SO"
  },
  "249175": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Narendra Nagar SO Tehri Garhwal"
  },
  "342012": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Boranada SO"
  },
  "630005": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Devakottai Road S.O"
  },
  "829108": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Giddi A SO"
  },
  "829135": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Bhurkunda SO"
  },
  "680122": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Edathirinji SO"
  },
  "680670": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Karupadanna SO"
  },
  "680712": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Madayikonam SO"
  },
  "680661": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Nadavaramba SO"
  },
  "680665": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Panangad SO Thrissur"
  },
  "680565": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Peringottukara SO"
  },
  "400011": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Agripada S.O"
  },
  "400006": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Malabar Hill S.O"
  },
  "400020": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Marine Lines S.O"
  },
  "400005": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "VWTC SO"
  },
  "324001": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Kota Kutchery S.O"
  },
  "679564": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Andathode SO"
  },
  "630003": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Cecri Campus S.O"
  },
  "581303": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Kodibag S.O"
  },
  "581304": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Nandangadda S.O"
  },
  "628005": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Muthiahpuram S.O"
  },
  "628302": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Ottanatham S.O"
  },
  "342008": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "Subhash Nagar Jodhpur SO"
  },
  "736157": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Nishiganj SO"
  },
  "736165": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Pundibari SO"
  },
  "736167": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Sitaihat SO"
  },
  "736158": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Sitalkuchi SO"
  },
  "686653": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Kadanad Meenachil SO"
  },
  "690559": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Perungala SO"
  },
  "834008": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Ranchi University SO"
  },
  "736160": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Tufanganj New Town SO"
  },
  "736159": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Tufanganj SO"
  },
  "614207": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Rajaghiri S.O"
  },
  "140604": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Baltana SO"
  },
  "712502": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Shibpur Bansberia SO"
  },
  "764048": {
    "state": "ODISHA",
    "district": "MALKANGIRI",
    "office": "Malkangiri Colony S.O"
  },
  "413003": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Sadar Bazar S.O (Solapur)"
  },
  "440024": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Nandavan Colony S.O"
  },
  "626105": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Kallurani SO"
  },
  "400007": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Bharat Nagar S.O (Mumbai)"
  },
  "400034": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Tulsiwadi S.O"
  },
  "574112": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Palimar SO"
  },
  "834007": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Sail City S.O"
  },
  "842005": {
    "state": "BIHAR",
    "district": "MUZAFFARPUR",
    "office": "MIC SO"
  },
  "131030": {
    "state": "HARYANA",
    "district": "SONIPAT",
    "office": "TDI City Kundli SO"
  },
  "440017": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Dr.Ambedkar Marg S.O"
  },
  "440010": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "V R C E S.O"
  },
  "440037": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "BESA Road S.O"
  },
  "440012": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Sitabuldi S.O"
  },
  "440036": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Jaitala S.O"
  },
  "440022": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Shradhananpeth S.O"
  },
  "440005": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Nagpur Airport S.O"
  },
  "440015": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Samartha Nagar S.O"
  },
  "440020": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Neeri S.O"
  },
  "440007": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Vayusena Nagar S.O"
  },
  "629810": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Kandanvilai S.O"
  },
  "440003": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Medical College S.O (Nagpur)"
  },
  "146001": {
    "state": "PUNJAB",
    "district": "HOSHIARPUR",
    "office": "Railway Road SO Hoshiarpur"
  },
  "629156": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Kappiyarai S.O"
  },
  "689512": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Kudassanad SO"
  },
  "689627": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Melpadom SO"
  },
  "721129": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Beuncha BO"
  },
  "680521": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Arthat SO"
  },
  "700013": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Dharmatala SO"
  },
  "181152": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Bathindi SO"
  },
  "560007": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Air Force Hospital S.O"
  },
  "560103": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Bellandur S.O"
  },
  "560036": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Krishnarajapuram S.O"
  },
  "560038": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Indiranagar S.O (Bengaluru)"
  },
  "302037": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Mahindra World City S.O (Jaipur)"
  },
  "302034": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Panchyawala S.O"
  },
  "302038": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Kookas S.O"
  },
  "302045": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Sirsi SO"
  },
  "302046": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Bhanpur kalan S.O"
  },
  "721128": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Pingboni BO"
  },
  "721302": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Kharagpur Technology SO"
  },
  "683587": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Malayattoor SO"
  },
  "683589": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Mekkad SO"
  },
  "688008": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Thumpoly SO"
  },
  "688555": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Varanam SO"
  },
  "700095": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Golf Green SO"
  },
  "700099": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Mukundapur SO"
  },
  "581212": {
    "state": "KARNATAKA",
    "district": "HAVERI",
    "office": "Tadas S.O"
  },
  "600015": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Saidapet S.O (Chennai)"
  },
  "600085": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Kotturpuram S.O"
  },
  "502324": {
    "state": "TELANGANA",
    "district": "SANGAREDDY",
    "office": "Icrisat S.O"
  },
  "700075": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Santoshpur SO"
  },
  "602003": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Kakalur Ind Estate S.O"
  },
  "854305": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Khuskibagh SO"
  },
  "854302": {
    "state": "BIHAR",
    "district": "PURNIA",
    "office": "Purnea City SO"
  },
  "721132": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Reserve Bank Nm Ltd SO"
  },
  "302043": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Muhana S.O"
  },
  "302040": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Nangal Jaisabohara S.O"
  },
  "534350": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "RTC Bustand(kovvur S.O"
  },
  "812003": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Barari SO"
  },
  "631006": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Ins Rajali SO"
  },
  "834014": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "SEMBO S.O"
  },
  "834005": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Hehal SO"
  },
  "440018": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Mominpura S.O"
  },
  "440032": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Mahal S.O (Nagpur)"
  },
  "440013": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Katolroad S.O"
  },
  "440025": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Ujwal Nagar S.O (Nagpur)"
  },
  "440030": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Nadt Campus S.O"
  },
  "173230": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Nauni SO"
  },
  "395023": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Bhestan SO"
  },
  "312001": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Ranasanga  Bazar  Chittorgarh S.O"
  },
  "736101": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Kharimala Khagrbari SO"
  },
  "835215": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Mesra SO"
  },
  "834011": {
    "state": "JHARKHAND",
    "district": "RANCHI",
    "office": "Krishnapuri S O"
  },
  "392215": {
    "state": "GUJARAT",
    "district": "BHARUCH",
    "office": "Urja Nagar SO"
  },
  "689521": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Kozhuvallur SO"
  },
  "600129": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Kovilambakkam SO"
  },
  "600075": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Pammal SO"
  },
  "600074": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Polichalur SO"
  },
  "626108": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Kumarasamy Raja Nagar SO"
  },
  "626133": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Kummapatti SO"
  },
  "410204": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Khopoli Power House S.O"
  },
  "410102": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Matheran S.O"
  },
  "422221": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Ojhar A.F. Stn. S.O"
  },
  "421308": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Bhiwandi S.O"
  },
  "400605": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Kalwa S.O"
  },
  "400602": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Gokhale Road S.O (Thane)"
  },
  "400615": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Kasarvadavali S.O"
  },
  "585229": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Shahabad ACC S.O"
  },
  "570002": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Vani Vilas Mohalla S.O"
  },
  "570004": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Lakshmipuram S.O (Mysuru)"
  },
  "585106": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "GB Jnanaganga S.O"
  },
  "585107": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Kalaburagi HCB S.O"
  },
  "585367": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Central University of Karnataka,Kad"
  },
  "570025": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "G S Ashram S.O"
  },
  "570031": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Jaya Prakash Nagar S.O"
  },
  "575016": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Shakthinagar (Dakshina Kannada) S.O"
  },
  "401302": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Arnala S.O"
  },
  "305001": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Shastri Nagar S.O (Ajmer)"
  },
  "688013": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Thondankulangara SO"
  },
  "303122": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Vedaant Gyan Valley SO"
  },
  "303123": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Karansar SO"
  },
  "144006": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "PAP Lines Jalandhar Cantt SO"
  },
  "575006": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Ashoknagar(MR) S.O"
  },
  "575003": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "District Courts S.O (Dakshina Kannada)"
  },
  "440021": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "A.D. Project S.O"
  },
  "440016": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "SRPF S.O"
  },
  "411037": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Salisbury Park S.O"
  },
  "411028": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Sasanenagar S.O"
  },
  "176218": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Khaniara SO"
  },
  "560047": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Austin Town S.O"
  },
  "560066": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "E P I P S.O"
  },
  "560024": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "H A Farm S.O"
  },
  "560046": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Benson Town S.O"
  },
  "560063": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "A F Station Yelahanka S.O"
  },
  "560065": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "G K V K S.O"
  },
  "560006": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "J C Nagar S.O"
  },
  "560043": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Jalavayuvihar S.O"
  },
  "560025": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "CMP Centre And School S.O"
  },
  "461122": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "OFE Itarsi S.O"
  },
  "461881": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "Pachmarhi S.O"
  },
  "415213": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Chimbhave SO"
  },
  "400705": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Sanpada S.O"
  },
  "400709": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Kopar Khairne S.O"
  },
  "613503": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Sri Pushpam College S.O"
  },
  "711108": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Netajigarh SO"
  },
  "711115": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Jagadishpurhat SO"
  },
  "734001": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Siliguri Road SO"
  },
  "711101": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Ross Road SO"
  },
  "744101": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "SOUTH ANDAMANS",
    "office": "N.S.Building S.O"
  },
  "833213": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "Gua SO"
  },
  "833223": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "Meghahatuburu SO"
  },
  "831009": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Agrico SO"
  },
  "831007": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "N M L SO"
  },
  "832111": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Narwa Mines  SO"
  },
  "421005": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Ulhasnagar 5 S.O"
  },
  "400603": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Thane East S.O"
  },
  "421101": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Padgha S.O"
  },
  "303121": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "NIMS University SO"
  },
  "678010": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Sekharipuram SO"
  },
  "741235": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Kalyani Hospital SO"
  },
  "743331": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Diamond Harbour RS SO"
  },
  "735227": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Rajabhatkhawa SO"
  },
  "736208": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Salsalabari SO"
  },
  "736206": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Saontalpur SO"
  },
  "678512": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kakkayur SO"
  },
  "713347": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Kharsuli Bazar SO"
  },
  "563115": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Bharathnagar S.O"
  },
  "563117": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Championreefs S.O"
  },
  "421305": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Vidyashram S.O"
  },
  "421502": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "O.E.Ambernath S.O"
  },
  "400610": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Apna Bazar S.O"
  },
  "422206": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Ojhar S.O"
  },
  "422008": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Trimurti Chowk S.O"
  },
  "422301": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "B.S. Nagar S.O"
  },
  "422501": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Devlali Air Force S.O"
  },
  "764004": {
    "state": "ODISHA",
    "district": "KORAPUT",
    "office": "Jeypore(K) Irrigation Colony S.O"
  },
  "362540": {
    "state": "THE DADRA AND NAGAR HAVELI AND DAMAN AND DIU",
    "district": "DIU",
    "office": "Ghoghla SO"
  },
  "829125": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Sayal SO"
  },
  "829126": {
    "state": "JHARKHAND",
    "district": "RAMGARH",
    "office": "Sounda C SO"
  },
  "388410": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Bandhani SO"
  },
  "388421": {
    "state": "GUJARAT",
    "district": "ANAND",
    "office": "Changa SO"
  },
  "518102": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "S.S.Dam East S.O"
  },
  "518101": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Srisailam S.O"
  },
  "712135": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Boinchigram SO"
  },
  "412112": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Dasve Lavasa S.O"
  },
  "410508": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Dhamani S.O"
  },
  "410403": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Kaivalyadham S.O"
  },
  "712105": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Buroshibtala SO Hooghly"
  },
  "713301": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "SBGorai Road SO"
  },
  "452006": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Army Head Quarter S.O"
  },
  "452005": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Bijasan Road S.O"
  },
  "452002": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Indore City 2 S.O"
  },
  "452011": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Nanda Nagar S.O"
  },
  "452010": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Indore Nipaniya SO"
  },
  "387325": {
    "state": "GUJARAT",
    "district": "KHEDA",
    "office": "Kanjari SO"
  },
  "563160": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Malur Railway Station S.O"
  },
  "462066": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "IISER Bhouri S.O"
  },
  "302044": {
    "state": "RAJASTHAN",
    "district": "JAIPUR",
    "office": "Govindpura S.O."
  },
  "686609": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Mevelloor SO"
  },
  "686616": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Newsprint Nagar SO"
  },
  "689515": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Poozhikkad SO"
  },
  "686122": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Aruvithura SO"
  },
  "575002": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kankanady S.O"
  },
  "575025": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Srinivasnagar S.O"
  },
  "560071": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Domlur S.O"
  },
  "629155": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Kanjiracode S.O"
  },
  "682302": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Ambalamugal SO"
  },
  "683514": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Cherai SO"
  },
  "683112": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Erumathala SO"
  },
  "683563": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Naval Armament Depot  Aluva SO"
  },
  "700027": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Natioinal Library SO"
  },
  "713154": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Amadpur SO"
  },
  "442003": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Hindinagar S.O"
  },
  "442111": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Paunar S.O"
  },
  "442105": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Sindi S.O"
  },
  "394221": {
    "state": "GUJARAT",
    "district": "SURAT",
    "office": "Pandesara IE SO"
  },
  "173222": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Mamlig SO"
  },
  "560075": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "New Thippasandra S.O"
  },
  "560094": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "R M V Extension II Stage S.O"
  },
  "560045": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Arabic College S.O"
  },
  "560084": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "St. Thomas Town S.O"
  },
  "560033": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Maruthi Sevanagar S.O"
  },
  "413118": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Yeshwantnagar S.O (Solapur)"
  },
  "174317": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Bhadsali SO"
  },
  "177202": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Mubarikpur SO"
  },
  "440014": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Bezonbagh S.O"
  },
  "440035": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Kalmna Market Yard S.O"
  },
  "440034": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Mhalginagar S.O"
  },
  "440027": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Vishwakarma Nagar S.O"
  },
  "440026": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Uppalwadi S.O"
  },
  "440019": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "C.R.P.F. Nagpur S.O"
  },
  "440006": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Seminary Hills S.O"
  },
  "600007": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Vepery S.O"
  },
  "413303": {
    "state": "MAHARASHTRA",
    "district": "SOLAPUR",
    "office": "Ashti S.O (Solapur)"
  },
  "440033": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "University Campus S.O (Nagpur)"
  },
  "600090": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Rajaji Bhavan S.O"
  },
  "600119": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Sholinganallur S.O"
  },
  "524005": {
    "state": "ANDHRA PRADESH",
    "district": "SPSR NELLORE",
    "office": "Polytechnic S.O (Nellore)"
  },
  "441109": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Sillewara Project S.O"
  },
  "441123": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Godhani S.O"
  },
  "442107": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Sawangi Meghe SO"
  },
  "173202": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Sanawar SO"
  },
  "173236": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Kuthar SO"
  },
  "411043": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Dhankawadi S.O"
  },
  "411016": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Shivaji Housing Society S.O"
  },
  "411024": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Khadakwasla R.S. S.O"
  },
  "411030": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Sadashiv Peth S.O"
  },
  "410209": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "KAMOTHE S.O"
  },
  "410210": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Kharghar S.O"
  },
  "410222": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Mohopada S.O"
  },
  "827006": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "SectorVI SO"
  },
  "826005": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "BCCl Township SO"
  },
  "411039": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Bhosarigoan S.O"
  },
  "411019": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "M.Phulenagar S.O"
  },
  "411012": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Dapodi S.O"
  },
  "411013": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Hadpsar I.E. S.O"
  },
  "574267": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Badagayedapadavu S.O"
  },
  "575020": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Ullal S.O"
  },
  "176304": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Dalhousie Court Road"
  },
  "414110": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "MIRC S.O"
  },
  "176305": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Dalhousie cantt"
  },
  "585219": {
    "state": "KARNATAKA",
    "district": "YADGIR",
    "office": "Narayanpur S.O (Yadgir)"
  },
  "453552": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Simrol S.O"
  },
  "190014": {
    "state": "JAMMU AND KASHMIR",
    "district": "Budgam",
    "office": "Hyderpora SO"
  },
  "313004": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Udaipur H.O"
  },
  "686630": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Thellakom SO"
  },
  "686010": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Vadavathoor SO"
  },
  "629179": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Unnamalakada S.O"
  },
  "576228": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Shiruru Udupi SO"
  },
  "632403": {
    "state": "TAMIL NADU",
    "district": "Ranipet",
    "office": "Ranipet Industrial Estate SO"
  },
  "176317": {
    "state": "HIMACHAL PRADESH",
    "district": "CHAMBA",
    "office": "Surangani SO"
  },
  "737101": {
    "state": "SIKKIM",
    "district": "EAST DISTRICT",
    "office": "Sichey Gaon SO"
  },
  "854109": {
    "state": "BIHAR",
    "district": "KATIHAR",
    "office": "Katihar Court SO"
  },
  "831019": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Birsanagar SO"
  },
  "832109": {
    "state": "JHARKHAND",
    "district": "SARAIKELA KHARSAWAN",
    "office": "Adityapur Industrial Area SO"
  },
  "831013": {
    "state": "JHARKHAND",
    "district": "SARAIKELA KHARSAWAN",
    "office": "Adityapur SO"
  },
  "370201": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Ganeshnagar SO Gujrat Circle"
  },
  "370230": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Kandla Free Trade Zone SO"
  },
  "700068": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Jodhpur Park SO"
  },
  "700041": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Sirity SO"
  },
  "733101": {
    "state": "WEST BENGAL",
    "district": "DINAJPUR DAKSHIN",
    "office": "Narayanpur SO South Dinajpur"
  },
  "712601": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Natunbazar SO Hooghly"
  },
  "712101": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Pratappur SO Hooghly"
  },
  "713140": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Nirol BO"
  },
  "431003": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Nizamganj S.O"
  },
  "445216": {
    "state": "MAHARASHTRA",
    "district": "YAVATMAL",
    "office": "P.N.C. Pusad S.O"
  },
  "686123": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Thidanad SO"
  },
  "712201": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Serampore Court SO"
  },
  "180015": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Chani Himat SO"
  },
  "180009": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "SKUASTCHATHA SO"
  },
  "461005": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "Sp Mills Hoshangabad S.O"
  },
  "713132": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Boinchee BO"
  },
  "713143": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Purba Gopalpur BO"
  },
  "713147": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Athghara BO"
  },
  "713512": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Ukhra Sarangpur BO"
  },
  "713513": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Kasthashali BO"
  },
  "713519": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Nasaratpur BO"
  },
  "713514": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Okarsa BO"
  },
  "713150": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Churpuni BO"
  },
  "721454": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Alukaranbarh BO"
  },
  "305007": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Gc Road Ajmer S.O"
  },
  "194402": {
    "state": "LADAKH",
    "district": "LEH LADAKH",
    "office": "Saspol S.O"
  },
  "688521": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Pathirappally SO"
  },
  "572103": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Kuvempunagara S.O"
  },
  "827004": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Sector IV SO"
  },
  "828128": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Tundoo SO"
  },
  "827015": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Chira Chas SO"
  },
  "828124": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "ACC Colony SO"
  },
  "828108": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Fri SO"
  },
  "826003": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Jagjivan Nagar SO"
  },
  "144031": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "RURKA KALAN SO"
  },
  "688525": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Muhamma SO"
  },
  "688570": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Perumbalam SO"
  },
  "462008": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Barkhedi S.O"
  },
  "683543": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Rayonpuram SO"
  },
  "828122": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Saharpura SO"
  },
  "828126": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Sudamdih SO"
  },
  "826008": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "KGAshram SO"
  },
  "826007": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Housing Colony SO"
  },
  "827014": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Balidih SO"
  },
  "828103": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Bhelatand SO"
  },
  "683106": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Thaikkattukara SO"
  },
  "721456": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Lalua BO"
  },
  "414003": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Savedi Road S.O"
  },
  "440008": {
    "state": "MAHARASHTRA",
    "district": "NAGPUR",
    "office": "Bagadganj S.O"
  },
  "177205": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Ambota SO"
  },
  "411069": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Baner DSO (Pune)"
  },
  "182207": {
    "state": "JAMMU AND KASHMIR",
    "district": "DODA",
    "office": "GANDOH SO"
  },
  "700056": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Rathtala SO"
  },
  "400035": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Rajbhavan S.O (Mumbai)"
  },
  "827012": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Marafari Colony SO"
  },
  "828135": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Chasnalla SO"
  },
  "411032": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Vidyanagar S.O (Pune)"
  },
  "411026": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Indrayaninagar S.O"
  },
  "411003": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "H.E. Factory S.O"
  },
  "826009": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "KkPolytechnic SO"
  },
  "826011": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "NDC DHANBAD"
  },
  "411060": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Mohamadwadi S.O"
  },
  "411018": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Masulkar Colony S.O"
  },
  "583203": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Hosapete N C C S.O"
  },
  "574327": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kurunjibag S.O"
  },
  "360577": {
    "state": "GUJARAT",
    "district": "PORBANDAR",
    "office": "Porbandar GIDC SO"
  },
  "570007": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Narasimha Raja Mohalla S.O"
  },
  "570020": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Yadavagiri S.O"
  },
  "585292": {
    "state": "KARNATAKA",
    "district": "KALABURAGI",
    "office": "Malkhed Road S.O"
  },
  "577451": {
    "state": "KARNATAKA",
    "district": "SHIVAMOGGA",
    "office": "KVV Shankaraghattta S.O"
  },
  "722101": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Lalbazar SO Bankura"
  },
  "700120": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Barrackpore GovtHousing SO"
  },
  "400004": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Ambewadi S.O (Mumbai)"
  },
  "400028": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Gokhale Road S.O (Mumbai)"
  },
  "400017": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Dharavi S.O"
  },
  "400025": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Prabhadevi S.O"
  },
  "400018": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Worli Naka S.O"
  },
  "560080": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Sadashivanagar S.O"
  },
  "560051": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "H K P Road S.O"
  },
  "461335": {
    "state": "MADHYA PRADESH",
    "district": "HARDA",
    "office": "SIRALI SO"
  },
  "180020": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "TRIKUTA NAGAR"
  },
  "400026": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Cumballa Sea Face S.O"
  },
  "680685": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Mathilakam SO"
  },
  "680570": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Vadakkummuri SO"
  },
  "362226": {
    "state": "GUJARAT",
    "district": "JUNAGADH",
    "office": "Mangrol Bundar SO"
  },
  "182104": {
    "state": "JAMMU AND KASHMIR",
    "district": "UDHAMPUR",
    "office": "PTC Udhampur SO"
  },
  "400032": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Secretariate SO"
  },
  "452015": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Industrial Estate S.O (Indore)"
  },
  "452009": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Sudama Nagar S.O"
  },
  "174320": {
    "state": "HIMACHAL PRADESH",
    "district": "UNA",
    "office": "Talmehra SO"
  },
  "370210": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Kandla Port SO"
  },
  "678531": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Peruvemba SO"
  },
  "682309": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Irimbanam SO"
  },
  "682020": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kadavanthara SO"
  },
  "682304": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Maradu SO"
  },
  "682040": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Nettoor SO"
  },
  "682036": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Panampilly Nagar SO"
  },
  "682015": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Perumanur SO"
  },
  "682031": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Ernakulam High Court SO"
  },
  "682013": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Thevara SO"
  },
  "682028": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Vennala SO"
  },
  "682042": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "InfoparkKochi SO"
  },
  "682501": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Ayyampilly SO"
  },
  "682010": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Edakochi SO"
  },
  "682505": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Narakkal SO"
  },
  "682009": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "North End SO"
  },
  "828119": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Patherdih SO"
  },
  "828123": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "SIT SO"
  },
  "826010": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "BARWADDA S.O"
  },
  "411035": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Akurdi S.O"
  },
  "411027": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Sangavi S.O"
  },
  "411031": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "C M E S.O"
  },
  "736176": {
    "state": "WEST BENGAL",
    "district": "COOCHBEHAR",
    "office": "Sahebganj SO Cooch Behar"
  },
  "831006": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Jugsalai SO"
  },
  "831011": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Sonari SO East Singhbhum"
  },
  "831020": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Pardih"
  },
  "833222": {
    "state": "JHARKHAND",
    "district": "WEST SINGHBHUM",
    "office": "Kiriburu Base Camp SO"
  },
  "831017": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Baridih Colony SO"
  },
  "180018": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Udheywala SO"
  },
  "180006": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Qilla Bahu SO"
  },
  "180005": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Rehari Mohalla SO"
  },
  "181124": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Bsf Camp Paloura SO"
  },
  "180007": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Janipur SO"
  },
  "181205": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Muthi SO"
  },
  "180013": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Roopnagar Jammu Tawi SO"
  },
  "700087": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "New Market SO"
  },
  "686021": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Pariyaram SO Kottayam"
  },
  "686637": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Peroor SO"
  },
  "686560": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Priyadarsini Hills SO"
  },
  "180016": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Krishna Nagar SO Jammu"
  },
  "180019": {
    "state": "JAMMU AND KASHMIR",
    "district": "JAMMU",
    "office": "Sidhra Housing colony"
  },
  "190010": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Karan Nagar SO Srinagar"
  },
  "190002": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Safukadul SO"
  },
  "686548": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Nalukody SO"
  },
  "686537": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Pallickachirakavala SO"
  },
  "686517": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Chakompathal SO"
  },
  "190009": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "New Secretariat Srinagar SO"
  },
  "190005": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Sanat Nagar SO"
  },
  "831015": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Gobindpur Housing Colony SO"
  },
  "831003": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Golmuri SO"
  },
  "832103": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Moubhandar SO"
  },
  "831016": {
    "state": "JHARKHAND",
    "district": "EAST SINGHBUM",
    "office": "Rahargora SO"
  },
  "690571": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Nooranad Sanatorium SO"
  },
  "690537": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Pullikanakku SO"
  },
  "190021": {
    "state": "JAMMU AND KASHMIR",
    "district": "Budgam",
    "office": "Hamhama SO"
  },
  "576216": {
    "state": "KARNATAKA",
    "district": "UDUPI",
    "office": "Ganguli SO"
  },
  "682553": {
    "state": "LAKSHADWEEP",
    "district": "LAKSHADWEEP DISTRICT",
    "office": "Agathi S.O"
  },
  "682557": {
    "state": "LAKSHADWEEP",
    "district": "LAKSHADWEEP DISTRICT",
    "office": "Kalpeni S.O"
  },
  "193403": {
    "state": "JAMMU AND KASHMIR",
    "district": "BARAMULLA",
    "office": "Gulmarg SO"
  },
  "686041": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Malloossery SO"
  },
  "686018": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Manganam SO"
  },
  "686006": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Nattassery S H Mount SO"
  },
  "686007": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Pallom SO"
  },
  "683521": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Vadakkumpuram SO"
  },
  "742164": {
    "state": "WEST BENGAL",
    "district": "MURSHIDABAD",
    "office": "Roshanbagh SO"
  },
  "683515": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Palliport SO"
  },
  "452003": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Indore Pardesipura S.O"
  },
  "400614": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Konkan Bhavan S.O"
  },
  "410216": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Jagdish Nagar S.O"
  },
  "410218": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Kalamboli Node S.O"
  },
  "583276": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "K U Campus S.O"
  },
  "629102": {
    "state": "TAMIL NADU",
    "district": "KANNIYAKUMARI",
    "office": "Kodayarkilthangal S.O"
  },
  "686009": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Rubber Board SO"
  },
  "560079": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Kamakshipalya S.O"
  },
  "560023": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Magadi Road S.O"
  },
  "560086": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "West of Chord Road II stage S.O"
  },
  "402125": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "PCTS Nagothane SO"
  },
  "402207": {
    "state": "MAHARASHTRA",
    "district": "RAIGAD",
    "office": "Thal SO RaigarhMH"
  },
  "586109": {
    "state": "KARNATAKA",
    "district": "VIJAYAPURA",
    "office": "Vijayapura Jalanagar S.O"
  },
  "341020": {
    "state": "RAJASTHAN",
    "district": "NAGAUR",
    "office": "PANCHORI S.O."
  },
  "191132": {
    "state": "JAMMU AND KASHMIR",
    "district": "Budgam",
    "office": "Rangreth SO"
  },
  "190007": {
    "state": "JAMMU AND KASHMIR",
    "district": "Budgam",
    "office": "Sk Airport SO"
  },
  "190004": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Batwara SO"
  },
  "190023": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Lal Bazar SO"
  },
  "577181": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Horanadu S.O"
  },
  "821307": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Dehri R S SO"
  },
  "190012": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Zainakote SO"
  },
  "176066": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Ghallour SO"
  },
  "829116": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Kathara SO"
  },
  "415212": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Marul Haveli S.O"
  },
  "642114": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Malayandipattinam S.O"
  },
  "630301": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Amaravathipudur S.O"
  },
  "630102": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Chettinad S.O"
  },
  "194404": {
    "state": "LADAKH",
    "district": "LEH LADAKH",
    "office": "Nyoma Mud S.O"
  },
  "682016": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kochi MGRoad SO"
  },
  "682012": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Pachalam SO"
  },
  "682038": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Poonithura SO"
  },
  "682032": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Thammanam SO"
  },
  "410301": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Khandala S.O"
  },
  "581307": {
    "state": "KARNATAKA",
    "district": "UTTARA KANNADA",
    "office": "Binaga S.O"
  },
  "410302": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "R P T S Khandala S.O"
  },
  "828309": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Jitpur SO"
  },
  "827003": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Sector III SO"
  },
  "828130": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "BPolytechnic SO"
  },
  "828133": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Bhulan Bararee SO"
  },
  "828107": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Domgarh SO"
  },
  "812002": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "Sujaganj Bazar SO"
  },
  "176002": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Tanda SO"
  },
  "518186": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Illuri Kotha Peta S.O"
  },
  "182206": {
    "state": "JAMMU AND KASHMIR",
    "district": "KISHTWAR",
    "office": "Dul Hasti Project SO"
  },
  "360578": {
    "state": "GUJARAT",
    "district": "PORBANDAR",
    "office": "Chhaya SO"
  },
  "516439": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Mylavaram S.O (Cuddapah)"
  },
  "828404": {
    "state": "JHARKHAND",
    "district": "BOKARO",
    "office": "Dugdha Coal washery SO"
  },
  "144602": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "RAIL COACH FACTORY KAPURTHALA SO"
  },
  "416002": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Laxmipuri S.O"
  },
  "470340": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "DALPATPUR S.O."
  },
  "470002": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Sagar Bhuteshwar S.O"
  },
  "421506": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Additional Ambernath S.O"
  },
  "421202": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Vishnunagar S.O"
  },
  "400606": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Jekegram S.O"
  },
  "400604": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Wagle I.E. S.O"
  },
  "144408": {
    "state": "PUNJAB",
    "district": "KAPURTHALA",
    "office": "PANCHHAT SO"
  },
  "800016": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Rajendra Nagar SO Patna"
  },
  "800025": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Ashiananagar SO"
  },
  "800026": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Kumhrar SO"
  },
  "800022": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "RAJ BHAWAN SO"
  },
  "800018": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Bataganj SO"
  },
  "486004": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Rewa City S.O"
  },
  "486002": {
    "state": "MADHYA PRADESH",
    "district": "REWA",
    "office": "Rewa Engineering College S.O"
  },
  "518005": {
    "state": "ANDHRA PRADESH",
    "district": "KURNOOL",
    "office": "Ashoknagar S.O (Kurnool)"
  },
  "678104": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Chittur College SO"
  },
  "721424": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR WEST",
    "office": "Tarua BO"
  },
  "683550": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Okkal SO"
  },
  "683548": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Iringole SO"
  },
  "686666": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kothamangalam College SO"
  },
  "682041": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "AIMS Ponekkara SO"
  },
  "682033": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Changampuzha Nagar SO"
  },
  "800027": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "New Jaganpura SO"
  },
  "800013": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Patliputra SO"
  },
  "800014": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Patna Aerodrome SO"
  },
  "563118": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Coromandel S.O"
  },
  "563119": {
    "state": "KARNATAKA",
    "district": "KOLAR",
    "office": "Marikuppam S.O"
  },
  "144008": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "D A V  College SO"
  },
  "523002": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "M.M.Donka (O) S.O"
  },
  "682037": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Cochin Special Economic Zone SO"
  },
  "682026": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Elamakkara SO"
  },
  "682035": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Ernakulam College SO"
  },
  "682018": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Ernakulam North SO"
  },
  "360460": {
    "state": "GUJARAT",
    "district": "RAJKOT",
    "office": "Dhank SO"
  },
  "670676": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kadavathur SO"
  },
  "673311": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "New Mahe SO"
  },
  "682017": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kaloor SO"
  },
  "682022": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kochi University SO"
  },
  "453555": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Shri Aurobindo S.O"
  },
  "562161": {
    "state": "KARNATAKA",
    "district": "RAMANAGARA",
    "office": "Government Silk Farm S.O"
  },
  "700003": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Baghbazar SO"
  },
  "361004": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Udyognagar SO"
  },
  "191102": {
    "state": "JAMMU AND KASHMIR",
    "district": "PULWAMA",
    "office": "Wuyan SO"
  },
  "686531": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Chingavanam SO"
  },
  "176062": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Auc Palampur SO"
  },
  "570015": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Shivaraathreeswar Nagar S.O"
  },
  "570012": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Jayalakshmipuram S.O (Mysuru)"
  },
  "570030": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Vijayanagar III Stage S.O"
  },
  "570032": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Vijayanagar IV Stage S.O"
  },
  "686505": {
    "state": "KERALA",
    "district": "KOTTAYAM",
    "office": "Theerthapadapuram SO"
  },
  "560072": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Nagarbhavi II Stage PO"
  },
  "560003": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Palace Guttahalli S.O"
  },
  "342030": {
    "state": "RAJASTHAN",
    "district": "JODHPUR",
    "office": "IIT JODHPUR"
  },
  "682023": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Vaduthala SO"
  },
  "682019": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Vyttila SO"
  },
  "682502": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Edavanakad SO"
  },
  "682511": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Malipuram SO"
  },
  "682029": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Matsyapuri SO"
  },
  "682003": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Willingdon Island SO"
  },
  "682002": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Mattancherry SO"
  },
  "682051": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kochi Parcel Centre PO"
  },
  "682034": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Cheranallur SO"
  },
  "683503": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Hmt Colony SO"
  },
  "676312": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Ariyallur SO"
  },
  "676309": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Kodinhi SO"
  },
  "370203": {
    "state": "GUJARAT",
    "district": "KACHCHH",
    "office": "Udaynagar SO"
  },
  "482011": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Jabalpur Factory S.O"
  },
  "486885": {
    "state": "MADHYA PRADESH",
    "district": "SINGRAULI",
    "office": "Vindhyanagar S.O"
  },
  "800006": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Mahendru SO"
  },
  "416008": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Rajarampuri S.O"
  },
  "800028": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Patna High Court SO"
  },
  "800017": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "BSEBOARD SO"
  },
  "800024": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Keshari Nagar S.O"
  },
  "202146": {
    "state": "UTTAR PRADESH",
    "district": "ALIGARH",
    "office": "Mangalayatan University SO"
  },
  "486884": {
    "state": "MADHYA PRADESH",
    "district": "SINGRAULI",
    "office": "Nigahi Project S.O"
  },
  "689574": {
    "state": "KERALA",
    "district": "ALAPPUZHA",
    "office": "Muttar SO"
  },
  "171015": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Baldeyan SO"
  },
  "173210": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Dagshai SO"
  },
  "177021": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "Bagwara SO"
  },
  "600046": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Tambaram IAF SO"
  },
  "484220": {
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "office": "Chachai S.O"
  },
  "799046": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "NIT Agartala S.O"
  },
  "799005": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Abhoynagar S.O"
  },
  "177005": {
    "state": "HIMACHAL PRADESH",
    "district": "HAMIRPUR",
    "office": "NIT Hamirpur SO"
  },
  "679583": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Ponani Nagaram SO"
  },
  "676109": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Niramaruthur SO"
  },
  "676107": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Pookayil Bazar SO"
  },
  "670104": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Cherakkara SO"
  },
  "673316": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kariyad South SO"
  },
  "670662": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Muzhappilangad SO"
  },
  "673312": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Peringadi SO"
  },
  "713515": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Nadanghat SO"
  },
  "799022": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Tripura University S.O"
  },
  "793107": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Bholaganj Bazar S.O"
  },
  "583215": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "Hampi Power House S.O"
  },
  "583225": {
    "state": "KARNATAKA",
    "district": "BALLARI",
    "office": "T B Dam S.O"
  },
  "560026": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Nayandahalli S.O"
  },
  "560102": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "HSR Layout S.O"
  },
  "560070": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Padmanabhnagar S.O"
  },
  "560085": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Kathriguppe S.O"
  },
  "453446": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Rasalpura S.O"
  },
  "828132": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Patherdih Coal Washery SO"
  },
  "828105": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Shramik Nagar SO"
  },
  "560050": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Dasarahalli(Srinagar) S.O"
  },
  "560114": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Begur"
  },
  "560081": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Chandapura S.O"
  },
  "560500": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "CPC ITD BNPL booking HUB"
  },
  "362520": {
    "state": "THE DADRA AND NAGAR HAVELI AND DAMAN AND DIU",
    "district": "DIU",
    "office": "Diu SO"
  },
  "574225": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Mijar S.O"
  },
  "572168": {
    "state": "KARNATAKA",
    "district": "TUMAKURU",
    "office": "Hirehalli S.O"
  },
  "721422": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Naskarpur BO"
  },
  "721423": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Shyampur BO"
  },
  "721442": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Dariapur BO"
  },
  "591246": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Yamakanmardi S.O"
  },
  "571607": {
    "state": "KARNATAKA",
    "district": "MANDYA",
    "office": "Krishnaraja Sagar S.O"
  },
  "813214": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "STP Kahalgaon SO"
  },
  "415516": {
    "state": "MAHARASHTRA",
    "district": "SATARA",
    "office": "Kavathe S.O"
  },
  "721425": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Dumandari BO"
  },
  "721455": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Silampur BO"
  },
  "700044": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Rajabagan Dock Yard SO"
  },
  "700024": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "TGRoad SO"
  },
  "700063": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Thakurpukur SO"
  },
  "700053": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "New Alipore SO"
  },
  "700018": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Bartala SO"
  },
  "700008": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Barisha SO"
  },
  "700034": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Behala SO"
  },
  "700066": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Bidhangarh SO"
  },
  "700029": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Lake Market SO"
  },
  "173201": {
    "state": "HIMACHAL PRADESH",
    "district": "SOLAN",
    "office": "Garkhal SO"
  },
  "442303": {
    "state": "MAHARASHTRA",
    "district": "WARDHA",
    "office": "Pulgaon Camp S.O"
  },
  "560042": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Sivan Chetty Gardens S.O"
  },
  "560107": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Achitnagar S.O"
  },
  "560054": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Mathikere S.O"
  },
  "560058": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Laggere S.O"
  },
  "560097": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Vidyaranyapura S.O"
  },
  "682552": {
    "state": "LAKSHADWEEP",
    "district": "LAKSHADWEEP DISTRICT",
    "office": "Amini S.O"
  },
  "682556": {
    "state": "LAKSHADWEEP",
    "district": "LAKSHADWEEP DISTRICT",
    "office": "Kadamat S.O"
  },
  "682558": {
    "state": "LAKSHADWEEP",
    "district": "LAKSHADWEEP DISTRICT",
    "office": "Kiltan S.O"
  },
  "682559": {
    "state": "LAKSHADWEEP",
    "district": "LAKSHADWEEP DISTRICT",
    "office": "Minicoy S.O"
  },
  "700005": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Ahiritola SO"
  },
  "700006": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Beadon Street SO"
  },
  "700067": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Lily Biscuit SO"
  },
  "680613": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kandassankadavu SO"
  },
  "190020": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Bachpora SO"
  },
  "560021": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Gayathrinagar S.O"
  },
  "753010": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "O G Press S.O"
  },
  "755020": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Ferro Chrome Project S.O"
  },
  "562165": {
    "state": "KARNATAKA",
    "district": "BENGALURU RURAL",
    "office": "Budigere S.O"
  },
  "190025": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Skuast SO"
  },
  "190024": {
    "state": "JAMMU AND KASHMIR",
    "district": "SRINAGAR",
    "office": "Zakoora"
  },
  "680546": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kaiparamba SO"
  },
  "209725": {
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "office": "Kannauj Samachar SO"
  },
  "413713": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Loni Kd S.O"
  },
  "174005": {
    "state": "HIMACHAL PRADESH",
    "district": "BILASPUR",
    "office": "Raghunath Pura SO"
  },
  "411038": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Kothrud S.O"
  },
  "411052": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Navsahyadri S.O"
  },
  "411011": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Mangalwar Peth S.O (Pune)"
  },
  "411009": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Parvati S.O"
  },
  "411042": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Swargate Chowk S.O"
  },
  "411068": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Nanded S.O (Pune)"
  },
  "700060": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Parnasree Pally SO"
  },
  "700038": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Sahapur SO"
  },
  "670708": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kannur International Airport S.O"
  },
  "678546": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Erimayur SO"
  },
  "209726": {
    "state": "UTTAR PRADESH",
    "district": "KANNAUJ",
    "office": "Makrand Nagar SO"
  },
  "678051": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "PALAKKAD NDC"
  },
  "791114": {
    "state": "ARUNACHAL PRADESH",
    "district": "PAPUM PARE",
    "office": "Sagalee S.O"
  },
  "790103": {
    "state": "ARUNACHAL PRADESH",
    "district": "PAKKE KESSANG",
    "office": "Seijosa S.O"
  },
  "431011": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Kanchanwadi SO"
  },
  "680612": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kanjani SO"
  },
  "680655": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Ollukkara SO"
  },
  "534006": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Ramachandra Rao Peta S.O"
  },
  "534005": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Tangellamudi S.O"
  },
  "685603": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Idukki Painavu SO"
  },
  "249136": {
    "state": "UTTARAKHAND",
    "district": "UTTAR KASHI",
    "office": "Gangotri Seasonal SO"
  },
  "685591": {
    "state": "KERALA",
    "district": "IDUKKI",
    "office": "Arakulam SO"
  },
  "534215": {
    "state": "ANDHRA PRADESH",
    "district": "WEST GODAVARI",
    "office": "Venkatrayapuram S.O"
  },
  "798623": {
    "state": "NAGALAND",
    "district": "MOKOKCHUNG",
    "office": "Paper Nagar S.O"
  },
  "454775": {
    "state": "MADHYA PRADESH",
    "district": "DHAR",
    "office": "Pithampur S.O"
  },
  "828207": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Maithon Dam SO"
  },
  "828120": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Motinagar SO Dhanbad"
  },
  "828206": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Panchet Dam SO"
  },
  "828127": {
    "state": "JHARKHAND",
    "district": "DHANBAD",
    "office": "Saraidhela SO"
  },
  "208027": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Barra Vishwa Bank SectorA SO"
  },
  "208013": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Dmsrde SO"
  },
  "411034": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Kasarwadi S.O"
  },
  "700147": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Subhas Gram SO"
  },
  "305009": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Mds University Ajmer S.O"
  },
  "400030": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Worli Police Camp S.O"
  },
  "362715": {
    "state": "GUJARAT",
    "district": "GIR SOMNATH",
    "office": "Ambujanagar SO"
  },
  "560030": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Adugodi S.O"
  },
  "560018": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Goripalya SO"
  },
  "560095": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Koramangala VI Bk S.O"
  },
  "560098": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Channasandra PO"
  },
  "560027": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Wilson Garden S.O"
  },
  "560100": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Electronics City S.O"
  },
  "361347": {
    "state": "GUJARAT",
    "district": "DEVBHUMI DWARKA",
    "office": "Surajkaradi SO"
  },
  "560015": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Jalahalli West S.O"
  },
  "560022": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Yeshwanthpur Bazar S.O"
  },
  "560088": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Hessarghatta S.O"
  },
  "247002": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "PTC SO"
  },
  "247343": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Titron SO"
  },
  "560002": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Bengaluru Corporation Building S.O"
  },
  "560009": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "K. G. Road S.O"
  },
  "560040": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Vijayanagar S.O (Bengaluru)"
  },
  "560055": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Malleswaram West S.O"
  },
  "575004": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Bijai S.O"
  },
  "574148": {
    "state": "KARNATAKA",
    "district": "DAKSHINA KANNADA",
    "office": "Kateel S.O"
  },
  "841447": {
    "state": "BIHAR",
    "district": "SIWAN",
    "office": "Lakrinabiganj S.O"
  },
  "577125": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Kammaradi S.O"
  },
  "821303": {
    "state": "BIHAR",
    "district": "ROHTAS",
    "office": "Banjari SO"
  },
  "560111": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Kumaraswamy Layout S.O"
  },
  "800003": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Kadamkuan SO"
  },
  "800021": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Vidyut Parisad SO"
  },
  "798607": {
    "state": "NAGALAND",
    "district": "MOKOKCHUNG",
    "office": "Alichen S.O"
  },
  "691013": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kollam Cutchery SO"
  },
  "691515": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Nallila SO"
  },
  "691504": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Perumpuzha SO"
  },
  "411044": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Yamunanagar S.O"
  },
  "700148": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Harinavi SO"
  },
  "700070": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Bansdroni SO"
  },
  "700084": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Garia Garden SO"
  },
  "700146": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Kodalia SO"
  },
  "305817": {
    "state": "RAJASTHAN",
    "district": "AJMER",
    "office": "Central University of Rajasthan S.O"
  },
  "700023": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Raja J.N.Market S.O"
  },
  "700043": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "South Eastern Railway SO"
  },
  "700088": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "Telecom Factory S.O"
  },
  "689111": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Tiruvalla RS SO"
  },
  "805114": {
    "state": "BIHAR",
    "district": "NAWADA",
    "office": "Bihar Keshri sri Krishn Singh SO"
  },
  "470124": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Bina BORL S.O"
  },
  "470229": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Garhakota S.O"
  },
  "523156": {
    "state": "ANDHRA PRADESH",
    "district": "PRAKASAM",
    "office": "Mgc Market(C ) S.O"
  },
  "695302": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Murukumpuzhaa SO"
  },
  "695585": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Sainik School SO Thiruvananthapuram"
  },
  "695318": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Vennicode SO"
  },
  "695025": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Muttada SO"
  },
  "695033": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Public Office SO Thiruvananthapuram"
  },
  "695036": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Thiruvananthapuram  Chalai SO"
  },
  "695016": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Thiruvananthapuram  Engg College SO"
  },
  "695023": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Attakulangara SO"
  },
  "695022": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Thiruvananthapuram  ISRO SO"
  },
  "695035": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Vanchiyoor Junction SO"
  },
  "695317": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Thonnakkal SO"
  },
  "695029": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Anayara SO"
  },
  "695582": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kazhakuttam SO"
  },
  "695015": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Nalanchira SO"
  },
  "695007": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Thiruvananthapuram  Beach SO"
  },
  "695588": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Powdikonam"
  },
  "695051": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "NDC TRIVANDRUM FORT"
  },
  "695142": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Cherunniyur SO"
  },
  "695611": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Manambur SO"
  },
  "695587": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Chempazhanthy SO"
  },
  "695316": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Pallipuram SO Thiruvananthapuram"
  },
  "689626": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Parumala SO"
  },
  "689115": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Thirumoolapuram SO"
  },
  "689597": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Thuruthicaud SO"
  },
  "560035": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Carmelram S.O"
  },
  "560053": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Chickpet S.O"
  },
  "560059": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Rv Niketan S.O"
  },
  "560110": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Ullalu Upanagar S.O"
  },
  "560108": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Anjanapura S.O"
  },
  "560029": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Tavarekere S.O"
  },
  "560062": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Konanakunte S.O"
  },
  "560061": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Chikkalasandra S.O"
  },
  "484114": {
    "state": "MADHYA PRADESH",
    "district": "SHAHDOL",
    "office": "Dhanpuri S.O"
  },
  "411006": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Yerwada T.S. S.O"
  },
  "208007": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Hal Colony SO"
  },
  "691301": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Paravur SO Kollam"
  },
  "691581": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Sakthikulangara SO"
  },
  "691007": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Thangasserry SO"
  },
  "691319": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Thekkumbhagom SO"
  },
  "691019": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Uliyakovil SO"
  },
  "691527": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Nellikunnam SO"
  },
  "691304": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Pullichira SO"
  },
  "691012": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Thirumullavaram SO"
  },
  "796004": {
    "state": "MIZORAM",
    "district": "AIZAWL",
    "office": "Mizoram University S.O"
  },
  "796036": {
    "state": "MIZORAM",
    "district": "AIZAWL",
    "office": "Sihphir S.O"
  },
  "796230": {
    "state": "MIZORAM",
    "district": "AIZAWL",
    "office": "Sialsuk S.O"
  },
  "796075": {
    "state": "MIZORAM",
    "district": "KOLASIB",
    "office": "Thingdawl S.O"
  },
  "796471": {
    "state": "MIZORAM",
    "district": "MAMIT",
    "office": "Zawlnuam S.O"
  },
  "689551": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Otherawest SO"
  },
  "799014": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Agartala ONGC S.O"
  },
  "799010": {
    "state": "TRIPURA",
    "district": "West Tripura",
    "office": "Agartala Secretariat S.O"
  },
  "208005": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Sarvodaya Nagar SO"
  },
  "208012": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Sisamau SO"
  },
  "208025": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Saketpuri SO"
  },
  "208023": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "T P Nagar SO"
  },
  "208009": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Armapore SO"
  },
  "208024": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "K P University SO"
  },
  "560096": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Nandinilayout S.O"
  },
  "361350": {
    "state": "GUJARAT",
    "district": "DEVBHUMI DWARKA",
    "office": "Okha SO"
  },
  "680656": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kerala Agriuniversity SO"
  },
  "812007": {
    "state": "BIHAR",
    "district": "BHAGALPUR",
    "office": "T N B College SO"
  },
  "516311": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Krishna Nagar S.O (Cuddapah)"
  },
  "630002": {
    "state": "TAMIL NADU",
    "district": "SIVAGANGA",
    "office": "Sekkalai S.O"
  },
  "503002": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Gurbabadi S.O"
  },
  "570016": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Metagalli S.O"
  },
  "570006": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "University Campus S.O (Mysuru)"
  },
  "570029": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Shakthinagar S.O"
  },
  "570011": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Siddarthanagar Nagar S.O"
  },
  "570017": {
    "state": "KARNATAKA",
    "district": "MYSURU",
    "office": "Vijaynagar II Stage S.O"
  },
  "274403": {
    "state": "UTTAR PRADESH",
    "district": "KUSHI NAGAR",
    "office": "KUSHINAGAR SO"
  },
  "744203": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "NORTH AND MIDDLE ANDAMAN",
    "office": "Long Island S.O"
  },
  "414605": {
    "state": "MAHARASHTRA",
    "district": "AHMEDNAGAR",
    "office": "Bhende SK S.O"
  },
  "797099": {
    "state": "NAGALAND",
    "district": "WOKHA",
    "office": "Bhandari S.O"
  },
  "691006": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Pallithottam SO"
  },
  "691016": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Thekkevila SO"
  },
  "691009": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Thevally SO"
  },
  "691589": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Umayanallur I E SO"
  },
  "208026": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Indira Nagar SO Kanpur Nagar"
  },
  "791003": {
    "state": "ARUNACHAL PRADESH",
    "district": "SHI YOMI",
    "office": "Mechuka S.O"
  },
  "176075": {
    "state": "HIMACHAL PRADESH",
    "district": "KANGRA",
    "office": "Duhak SO"
  },
  "792123": {
    "state": "ARUNACHAL PRADESH",
    "district": "CHANGLANG",
    "office": "Nampong S.O"
  },
  "791109": {
    "state": "ARUNACHAL PRADESH",
    "district": "PAPUM PARE",
    "office": "Nirjuli S.O"
  },
  "208011": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Yashoda Nagar SO"
  },
  "208003": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Chauki Jarib SO"
  },
  "208008": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "CAT SO"
  },
  "208006": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Govind Nagar West SO"
  },
  "855106": {
    "state": "BIHAR",
    "district": "KISHANGANJ",
    "office": "Galgalia SO"
  },
  "636002": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Shevapet S.O"
  },
  "636017": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Allikuttai S.O"
  },
  "636016": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Fairlands S.O"
  },
  "208015": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "New Pac Lines SO"
  },
  "799202": {
    "state": "TRIPURA",
    "district": "Khowai",
    "office": "Khowai Court S.O"
  },
  "208010": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Shiwans Tanney SO"
  },
  "208014": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Nirala Nagar SO"
  },
  "208019": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Syyed Nagar Post Office SO"
  },
  "636007": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Hasthampatti S.O"
  },
  "682551": {
    "state": "LAKSHADWEEP",
    "district": "LAKSHADWEEP DISTRICT",
    "office": "Androth S.O"
  },
  "680013": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kuttur SO Thrissur"
  },
  "680502": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Choondal SO"
  },
  "680520": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Thozhiyur SO"
  },
  "680618": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Aranattukara SO"
  },
  "560104": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Hampinagar S.O"
  },
  "560020": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Seshadripuram S.O"
  },
  "768031": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Ambabhana S.O"
  },
  "623806": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Sathaksalai SO"
  },
  "560112": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Kodigehalli S.O"
  },
  "361009": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Bedi SO"
  },
  "173026": {
    "state": "HIMACHAL PRADESH",
    "district": "SIRMAUR",
    "office": "Kw Bhood SO"
  },
  "796810": {
    "state": "MIZORAM",
    "district": "LAWNGTLAI",
    "office": "Sangau S.O"
  },
  "484120": {
    "state": "MADHYA PRADESH",
    "district": "ANUPPUR",
    "office": "S.K. Nagar S.O"
  },
  "796772": {
    "state": "MIZORAM",
    "district": "LAWNGTLAI",
    "office": "Kamalanagar S.O (Lawngtlai)"
  },
  "221009": {
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "office": "Sahupuri SO"
  },
  "689592": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Perumpatty SO"
  },
  "470003": {
    "state": "MADHYA PRADESH",
    "district": "SAGAR",
    "office": "Sagar University S.O"
  },
  "486888": {
    "state": "MADHYA PRADESH",
    "district": "SINGRAULI",
    "office": "Dudhichua Project S.O"
  },
  "486890": {
    "state": "MADHYA PRADESH",
    "district": "SINGRAULI",
    "office": "Jayant Colliery S.O"
  },
  "482020": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Bilhari S.O"
  },
  "695017": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Sreekaryam SO"
  },
  "221407": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "NDC Varanasi"
  },
  "221010": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Nagar Maha Palika SO"
  },
  "221004": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "DLW SO"
  },
  "682025": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Palarivattom SO"
  },
  "682039": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Rajagiri Valley SO"
  },
  "682050": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "International Business Centre IBC"
  },
  "682317": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "KULAYATTIKKARA"
  },
  "682503": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Elamkunnapuzha SO"
  },
  "682004": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Kochi Naval Base SO"
  },
  "682005": {
    "state": "KERALA",
    "district": "ERNAKULAM",
    "office": "Thoppumpady SO"
  },
  "679585": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Alankode SO"
  },
  "679587": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Eramangalam SO"
  },
  "679581": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Marancheri SO"
  },
  "679572": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Irimbiliyam SO"
  },
  "721463": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Digha New Township SO"
  },
  "721406": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Monoharchak SO"
  },
  "670106": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Dharmadam SO"
  },
  "673313": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Olavilam SO"
  },
  "678011": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Ambikapuram SO Palakkad"
  },
  "678732": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kottekkad SO"
  },
  "721420": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Jerthan BO"
  },
  "721405": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Athilagori SO"
  },
  "800005": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Patna University SO"
  },
  "800019": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "CDA SO"
  },
  "800011": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Makhdumpur Digha SO"
  },
  "210122": {
    "state": "UTTAR PRADESH",
    "district": "BANDA",
    "office": "Oran S.O"
  },
  "753003": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "College Square S.O (Cuttack)"
  },
  "753016": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "NDC Cuttack"
  },
  "767042": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Bhatipara S.O"
  },
  "768218": {
    "state": "ODISHA",
    "district": "JHARSUGUDA",
    "office": "Belpahar S.O"
  },
  "797121": {
    "state": "NAGALAND",
    "district": "KOHIMA",
    "office": "High School Junction S.O"
  },
  "678705": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Mudappallur SO"
  },
  "678505": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Pallassana SO"
  },
  "673103": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Vadakara Beach SO"
  },
  "700142": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Santosh Pur Maheshtalaso SO"
  },
  "473112": {
    "state": "MADHYA PRADESH",
    "district": "GUNA",
    "office": "Gail Complex S.O"
  },
  "676104": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Trikkandiyur SO"
  },
  "462031": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "3 EME Centre S.O"
  },
  "800023": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "LBS Nagar SO"
  },
  "800015": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Patna Sectt SO"
  },
  "636401": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Metturdam S.O"
  },
  "636456": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Salem Camp S.O"
  },
  "600028": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Ramakrishna Nagar S.O (Chennai)"
  },
  "636402": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Metturdam RS S.O"
  },
  "312622": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Adityapuram S.O"
  },
  "503322": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "Telangana University S.O"
  },
  "603210": {
    "state": "TAMIL NADU",
    "district": "CHENGALPATTU",
    "office": "Urapakkam SO"
  },
  "625012": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Villapuram SO"
  },
  "680515": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Edakkaliyur SO"
  },
  "680504": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Koonamoochi SO"
  },
  "680509": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Mullassery SO"
  },
  "755050": {
    "state": "ODISHA",
    "district": "JAJAPUR",
    "office": "Jaraka S.O"
  },
  "754011": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Adaspur S.O"
  },
  "753015": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Sector ll CDA, Cuttack S.O"
  },
  "754013": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "CISF Mundali S.O"
  },
  "591308": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Gokak Falls S.O"
  },
  "744106": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "SOUTH ANDAMANS",
    "office": "Shadipur S.O"
  },
  "744112": {
    "state": "ANDAMAN AND NICOBAR ISLANDS",
    "district": "SOUTH ANDAMANS",
    "office": "Chakargoan S.O"
  },
  "208016": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Iit SO"
  },
  "768203": {
    "state": "ODISHA",
    "district": "JHARSUGUDA",
    "office": "Industrial Estate Jharsuguda S S.O"
  },
  "627451": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Gopalasamudram SO"
  },
  "361330": {
    "state": "GUJARAT",
    "district": "DEVBHUMI DWARKA",
    "office": "Bet SO"
  },
  "361003": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Aerodromme SO"
  },
  "361002": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Bedeshwar SO"
  },
  "361005": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Digvijay Plot SO"
  },
  "560113": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Horamavu S.O"
  },
  "627452": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Melaseval SO"
  },
  "627422": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Papanasam Mills SO"
  },
  "627420": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Manjolai SO"
  },
  "415705": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Adur S.O (Ratnagiri)"
  },
  "800010": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "Sadaquat Ashram SO"
  },
  "801106": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "IIT Patna Bihta SO"
  },
  "144011": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "REC Jalandhar SO"
  },
  "456010": {
    "state": "MADHYA PRADESH",
    "district": "UJJAIN",
    "office": "Ujjain  M.L.Nagar S.O"
  },
  "411022": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Srpf S.O"
  },
  "411040": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Wanowarie S.O"
  },
  "444604": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "V.M.V. (Amravati) S.O"
  },
  "444603": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Shivaji Nagar S.O (Amravati)"
  },
  "689550": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kuriannoor SO"
  },
  "521201": {
    "state": "ANDHRA PRADESH",
    "district": "KRISHNA",
    "office": "Dum Dum Gardens S.O"
  },
  "689584": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Mallappally East SO"
  },
  "689591": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Mepral SO"
  },
  "689602": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Puthusserry South SO"
  },
  "600005": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Tiruvallikeni S.O"
  },
  "600034": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Loyola College S.O"
  },
  "600006": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Teynampet West S.O"
  },
  "796008": {
    "state": "MIZORAM",
    "district": "AIZAWL",
    "office": "Armed Veng S.O"
  },
  "700155": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Abdalpur SO"
  },
  "480003": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "CHANDANGAON SO"
  },
  "680011": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kanattukara SO"
  },
  "680616": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kundaliyur SO"
  },
  "680545": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Peramangalam SO"
  },
  "680002": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Punkunnu SO"
  },
  "680642": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Puthenpeedika SO"
  },
  "680611": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Elthuruth SO"
  },
  "361142": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Reliance Greens SO"
  },
  "361150": {
    "state": "GUJARAT",
    "district": "JAMNAGAR",
    "office": "Valsura SO"
  },
  "560057": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Peenya Dasarahalli S.O"
  },
  "560012": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Science Institute S.O"
  },
  "560078": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Yelachenahalli S.O"
  },
  "560011": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Madhavan Park S.O"
  },
  "679515": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kadambur SO Palakkad"
  },
  "793011": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Assam Rifles S.O"
  },
  "600035": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Nandanam S.O"
  },
  "312627": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Sadas S.O"
  },
  "144009": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Regional Campus GNDU SO"
  },
  "144027": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Suranussi SO"
  },
  "759102": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Deulbera Colliery S.O"
  },
  "759111": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Jindal Nagar S.O"
  },
  "759037": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Samal Barrage Township S.O"
  },
  "759149": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "JARAPADA S.O"
  },
  "759116": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Balanda S.O"
  },
  "416006": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Kasba Bavada S.O"
  },
  "401702": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Gholvad S.O"
  },
  "700153": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Laskar Pur SO"
  },
  "700093": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Purba Putiary SO"
  },
  "700143": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Sarkarpool SO"
  },
  "323305": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Rawatbhatta  Bazar S.O"
  },
  "246142": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Kalagarh SO"
  },
  "474002": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "Industrial Estate Gwalior S.O"
  },
  "474009": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "Phalka Bazar S.O"
  },
  "411051": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Anandnagar S.O (Pune)"
  },
  "411020": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Range Hills S.O"
  },
  "411004": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "A.R. Shala S.O"
  },
  "411058": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Warje S.O"
  },
  "411067": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Aundh S.O (Pune)"
  },
  "442502": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Cementnagar S.O"
  },
  "695308": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Vakkom SO"
  },
  "695034": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Thiruvananthapuram  University SO"
  },
  "282010": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "Bhogipura SO"
  },
  "627818": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Melagaram S.O"
  },
  "636406": {
    "state": "TAMIL NADU",
    "district": "SALEM",
    "office": "Mettur Thermal Project S.O"
  },
  "803121": {
    "state": "BIHAR",
    "district": "NALANDA",
    "office": "Ordnance Factory Rajgir SO"
  },
  "284125": {
    "state": "UTTAR PRADESH",
    "district": "LALITPUR",
    "office": "Lakeviewcamp SO"
  },
  "678704": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Chittilancheri SO"
  },
  "678685": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Mannapra SO"
  },
  "678504": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Vadavannur SO"
  },
  "444304": {
    "state": "MAHARASHTRA",
    "district": "BULDHANA",
    "office": "Matergaon S.O"
  },
  "144012": {
    "state": "PUNJAB",
    "district": "JALANDHAR",
    "office": "Nodal Delivery Centre, Jalandhar"
  },
  "625556": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "C.Pudupatti S.O"
  },
  "711103": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "BGarden SO"
  },
  "711110": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Baksara SO"
  },
  "711308": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Chengail SO"
  },
  "711102": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "TMG Lane SO"
  },
  "231209": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Gurma Markundi SO"
  },
  "767070": {
    "state": "ODISHA",
    "district": "BALANGIR",
    "office": "Of Badmal S.O"
  },
  "711112": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Gip Colony SO"
  },
  "711225": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Pancharul SO"
  },
  "560109": {
    "state": "KARNATAKA",
    "district": "BENGALURU URBAN",
    "office": "Thalaghattapura S.O"
  },
  "244717": {
    "state": "UTTARAKHAND",
    "district": "UDAM SINGH NAGAR",
    "office": "SM Nadehi SO"
  },
  "400013": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Delisle Road S.O"
  },
  "577128": {
    "state": "KARNATAKA",
    "district": "CHIKKAMAGALURU",
    "office": "Lakkavalli S.O"
  },
  "753013": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Kalyani Nagar S.O"
  },
  "444810": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Sirasgaon Kasba S.O"
  },
  "431009": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Garkheda S.O"
  },
  "431010": {
    "state": "MAHARASHTRA",
    "district": "AURANGABAD",
    "office": "Satara Parisar S.O"
  },
  "624701": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Attur SO"
  },
  "600094": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Choolaimedu S.O"
  },
  "160012": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Sector 12 Chandigarh SO"
  },
  "160019": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Sector 27ChandigarhSO"
  },
  "225002": {
    "state": "UTTAR PRADESH",
    "district": "BARABANKI",
    "office": "Barabanki Sugar Mill SO"
  },
  "160104": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Dhakaoli SO"
  },
  "160103": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Naya Gaon SO Mohali"
  },
  "416316": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Ankalkhop S.O"
  },
  "416307": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Kavathe Ekand S.O"
  },
  "768053": {
    "state": "ODISHA",
    "district": "BARGARH",
    "office": "Renaglipali Canal  Colony  SO"
  },
  "613008": {
    "state": "TAMIL NADU",
    "district": "THANJAVUR",
    "office": "Thanjavur North Gate S.O"
  },
  "627428": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Agasthiyarpatti SO"
  },
  "415717": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Kelshi S.O"
  },
  "415614": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Jaigad S.O"
  },
  "431520": {
    "state": "MAHARASHTRA",
    "district": "BEED",
    "office": "Parli Tps S.O"
  },
  "208022": {
    "state": "UTTAR PRADESH",
    "district": "KANPUR NAGAR",
    "office": "Udyog Nagar SO Kanpur Nagar"
  },
  "411061": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Pimple Gurav S.O"
  },
  "641407": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Arasur SO"
  },
  "721403": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Contai Bazar SO"
  },
  "721402": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Contai Super Market SO"
  },
  "721404": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Karkuli SO"
  },
  "627759": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Krishnapuram (TVL) S.O"
  },
  "627858": {
    "state": "TAMIL NADU",
    "district": "TENKASI",
    "office": "Sundapandiapuram S.O"
  },
  "462024": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "H.E. Hospital S.O"
  },
  "624301": {
    "state": "TAMIL NADU",
    "district": "DINDIGUL",
    "office": "Chinnalapatti SO"
  },
  "803215": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "NTPC Barh SO"
  },
  "284305": {
    "state": "UTTAR PRADESH",
    "district": "JHANSI",
    "office": "Parichha Thermal Power Project SO"
  },
  "343002": {
    "state": "RAJASTHAN",
    "district": "JALORE",
    "office": "I.A.Jalore S.O"
  },
  "401206": {
    "state": "MAHARASHTRA",
    "district": "THANE",
    "office": "Ganeshpuri S.O"
  },
  "625522": {
    "state": "TAMIL NADU",
    "district": "THENI",
    "office": "Kombai S.O"
  },
  "416527": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Tillarinagar S.O"
  },
  "751006": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Budheswari Colony S.O"
  },
  "751008": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Rajbhawan S.O (Khorda)"
  },
  "751010": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Rasulgarh S.O"
  },
  "751013": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Regional Research Laboratory S.O"
  },
  "751026": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "N.M.D Parcel Centre Bhubaneswar"
  },
  "751033": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "BARAMUNDA NDC"
  },
  "801507": {
    "state": "BIHAR",
    "district": "PATNA",
    "office": "AIIMS SO"
  },
  "759107": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Talcher Town S.O"
  },
  "759106": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Vikrampur S.O"
  },
  "759040": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Talmul S.O"
  },
  "160001": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "New Sectt Chandigarh SO"
  },
  "160011": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Sector 10 Chandigarh SO"
  },
  "160015": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Sector 15 Chandigarh SO"
  },
  "160022": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Sector 21 Chandigarh SO"
  },
  "160030": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Sector 31 Chandigarh SO"
  },
  "516330": {
    "state": "ANDHRA PRADESH",
    "district": "Y.S.R.",
    "office": "Idupulapaya(IIIT) S.O"
  },
  "625214": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Sholavandan SO"
  },
  "141003": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Indl  Colony SO"
  },
  "141013": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Passi Nagar SO"
  },
  "141014": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Daba Road SO"
  },
  "249137": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Munikireti SO"
  },
  "474012": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "S.P. Ashram S.O"
  },
  "793019": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Nongmynsong S.O"
  },
  "711203": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Bhattanagar SO"
  },
  "711105": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Belgachia Mansatala SO"
  },
  "711107": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Ghusuri SO"
  },
  "711304": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Banipur SO Howrah"
  },
  "711306": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Kulgachia SO"
  },
  "711331": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Paniara S.O"
  },
  "244720": {
    "state": "UTTARAKHAND",
    "district": "UDAM SINGH NAGAR",
    "office": "SULTANPUR PATTI"
  },
  "263142": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Halduchaur S.O"
  },
  "444606": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Rukhmini Nagar S.O"
  },
  "444605": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "H. V. Nagar S.O"
  },
  "444607": {
    "state": "MAHARASHTRA",
    "district": "AMRAVATI",
    "office": "Sai Nagar S.O"
  },
  "415601": {
    "state": "MAHARASHTRA",
    "district": "RATNAGIRI",
    "office": "Pophali S.O"
  },
  "401506": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Tarapur Ti S.O"
  },
  "401305": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Virar East S.O"
  },
  "759148": {
    "state": "ODISHA",
    "district": "ANUGUL",
    "office": "Nehru Satabdi Nagar(Bharatpu) S.O"
  },
  "462002": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Vidya Vihar S.O"
  },
  "462004": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "M.P. Vidhan Sabha S.O"
  },
  "462016": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "MP Bhoj Open University S.O"
  },
  "462039": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Trilanga S.O"
  },
  "462020": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "AIIMS S.O"
  },
  "670358": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Payangadi R S SO"
  },
  "461114": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "Cpe Itarsi S.O"
  },
  "670004": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Pallikunnu SO"
  },
  "670327": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Edat SO"
  },
  "670567": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kannur University Campus SO"
  },
  "211003": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Prayag Mahila Vidyapith SO"
  },
  "793014": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Nongthymmai S.O"
  },
  "793122": {
    "state": "MEGHALAYA",
    "district": "RI BHOI",
    "office": "Ucc S.O"
  },
  "794112": {
    "state": "MEGHALAYA",
    "district": "WEST GARO HILLS",
    "office": "Mendipathar S.O"
  },
  "452012": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Rajendra Nagar S.O (Indore)"
  },
  "452014": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Khatiwala Tank S.O"
  },
  "793002": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Jaiaw S.O"
  },
  "793016": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Mawiong S.O"
  },
  "160005": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "IBC CHANDGIARH SO"
  },
  "160006": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "NDC Chandigarh"
  },
  "793003": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Laitumkhrah S.O"
  },
  "754034": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Maniabandha S.O"
  },
  "753009": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Rajabagicha S.O"
  },
  "751012": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Nayapalli S.O"
  },
  "751034": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "RASULGARH NDC"
  },
  "751032": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "PAHAL S.O"
  },
  "401703": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Kosbad hill S.O"
  },
  "411007": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Ganeshkhind S.O"
  },
  "411008": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "N.C.L. Pune S.O"
  },
  "753012": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Khannagar S.O"
  },
  "753007": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Medical College S.O (Cuttack)"
  },
  "416803": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Mutat S.O"
  },
  "670002": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Civil Station Kannur SO"
  },
  "670310": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Ezhimala Naval Academy SO"
  },
  "712234": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Kanaipur SO"
  },
  "712235": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Criper Road SO"
  },
  "712125": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Rajabazar SO Hooghly"
  },
  "680524": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Padoor SO"
  },
  "680516": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Tiruvatra SO"
  },
  "680026": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Chiyyaram SO"
  },
  "400070": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Kurla West SO"
  },
  "400024": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Nehru Nagar SO"
  },
  "400022": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Raoli Camp SO"
  },
  "400058": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "H.M.P. School S.O"
  },
  "400050": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Bandra West S.O"
  },
  "400051": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Bandra W eCOM  Nodal Delivery Centre"
  },
  "400093": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Chakala Midc S.O"
  },
  "400099": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Airport S.O (Mumbai)"
  },
  "400049": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Juhu S.O"
  },
  "400055": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Santacruz(East) S.O"
  },
  "400084": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Barve Nagar SO"
  },
  "400074": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Mahul Road SO"
  },
  "400088": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Trombay SO"
  },
  "400080": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "SB Road SO"
  },
  "400076": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Powai Iit SO"
  },
  "400079": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Vikhroli SO"
  },
  "400075": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Pant Nagar SO"
  },
  "400078": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "JM Road SO"
  },
  "671122": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "Talangara SO"
  },
  "671320": {
    "state": "KERALA",
    "district": "KASARAGOD",
    "office": "PERIYE S.O"
  },
  "670008": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Alavil SO"
  },
  "670014": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Chalad SO"
  },
  "670017": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kannur District Hospital SO"
  },
  "416517": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Redi S.O"
  },
  "411041": {
    "state": "MAHARASHTRA",
    "district": "PUNE",
    "office": "Sinhgad Technical Education Society"
  },
  "453556": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "IIM CAMPUS RAO S.O"
  },
  "312617": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Kailash  Nagar S.O"
  },
  "400012": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Parel Naka S.O"
  },
  "627603": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Vadakku Ariyanayagipuram Petta SO"
  },
  "627105": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Kavalkinaru SO"
  },
  "769011": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Rourkela - 11 S.O"
  },
  "769006": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Sector - 2 S.O"
  },
  "612905": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Ulkottai SO"
  },
  "621731": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Reddipalayam SO"
  },
  "620004": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Golden Rock SO"
  },
  "620014": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Administrative OfficeBHEL SO"
  },
  "769013": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Rourkela - 13 S.O"
  },
  "769008": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Rourkela - 8 S.O"
  },
  "400033": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Tank Road S.O"
  },
  "400003": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "B.P.Lane S.O"
  },
  "400027": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "V J B Udyan S.O"
  },
  "400037": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Antop Hill S.O"
  },
  "400031": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Wadala Rs S.O"
  },
  "400009": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Noor Baug S.O"
  },
  "249124": {
    "state": "UTTARAKHAND",
    "district": "TEHRI GARHWAL",
    "office": "Bhagirathipuram SO"
  },
  "757002": {
    "state": "ODISHA",
    "district": "MAYURBHANJ",
    "office": "Bijay Ramchandrapur S.O"
  },
  "768019": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Jyoti Vihar Burla S.O"
  },
  "768003": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Khetrajpur S.O"
  },
  "768002": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Mudipara S.O"
  },
  "462100": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Nariyalkheda S.O"
  },
  "462041": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Ayodhaya Nagar S.O"
  },
  "462023": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Govindpura S.O"
  },
  "416437": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Subhashnagar S.O"
  },
  "416417": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Kavathe Piran S.O"
  },
  "769007": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Rourkela - 7 S.O"
  },
  "507138": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Gouthampur S.O"
  },
  "400010": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Mazgaon Road S.O"
  },
  "754297": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Khuntuni S.O"
  },
  "221012": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Kustha Sewa Ashram SO"
  },
  "751022": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Madhusudan Nagar S.O (Khorda)"
  },
  "751025": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "G.G.P.Colony S.O"
  },
  "751015": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "I R C Village S.O"
  },
  "751030": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Khandagiri S.O"
  },
  "751020": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Airport S.O (Khorda)"
  },
  "751023": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "S.E Rly.Proj. Complex S.O"
  },
  "401209": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Nallosapare E S.O"
  },
  "756089": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "VYASAVIHAR S.O"
  },
  "770032": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Bandomunda S.O"
  },
  "769010": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Rourkela - 10 S.O"
  },
  "769014": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Rourkela - 14 S.O"
  },
  "769002": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Sector - 6 S.O"
  },
  "769016": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Rourkela -16 S.O"
  },
  "620022": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Thuvakudimalai SO"
  },
  "620002": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Teppakulam SO"
  },
  "751007": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "V S S Nagar S.O"
  },
  "751005": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Sainik School S.O (Khorda)"
  },
  "473638": {
    "state": "MADHYA PRADESH",
    "district": "SHIVPURI",
    "office": "Katthamil Shivpuri S.O"
  },
  "462040": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "IBD Hallmark city kolar road"
  },
  "211014": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "C D A P SO"
  },
  "503174": {
    "state": "TELANGANA",
    "district": "NIZAMABAD",
    "office": "APSP Camp S.O"
  },
  "507119": {
    "state": "TELANGANA",
    "district": "BHADRADRI KOTHAGUDEM",
    "office": "Rudrampur S.O"
  },
  "344024": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Jasol S.O"
  },
  "334004": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Rcp Colony S.O"
  },
  "334403": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Bhinasar S.O"
  },
  "334401": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Gangashahar S.O"
  },
  "141006": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Gne College SO"
  },
  "141017": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Jugiana SO"
  },
  "609808": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Terizhandur S.O"
  },
  "480112": {
    "state": "MADHYA PRADESH",
    "district": "CHHINDWARA",
    "office": "MOHKHED SO"
  },
  "600024": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Kodambakkam S.O"
  },
  "221110": {
    "state": "UTTAR PRADESH",
    "district": "CHANDAULI",
    "office": "Basant Nagar SO"
  },
  "221103": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Manduadih SO"
  },
  "221109": {
    "state": "UTTAR PRADESH",
    "district": "VARANASI",
    "office": "Jayapur SO Varanasi"
  },
  "679104": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kanniampuram SO"
  },
  "262309": {
    "state": "UTTARAKHAND",
    "district": "CHAMPAWAT",
    "office": "Tanakpur SO"
  },
  "620027": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Tamilnadu National Law School SO"
  },
  "416406": {
    "state": "MAHARASHTRA",
    "district": "SANGLI",
    "office": "Madhavnagar S.O"
  },
  "751004": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Utkal University S.O"
  },
  "751031": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Patia S.O"
  },
  "754012": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Bhola S.O"
  },
  "751009": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Udyan Marg S.O"
  },
  "752115": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Bhatpatna S.O"
  },
  "751014": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "B J B Nagar S.O"
  },
  "751011": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "C R P Lines S.O"
  },
  "400067": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Kandivali RS SO"
  },
  "400068": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Dahisar SO"
  },
  "400102": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Oshiwara SO"
  },
  "400064": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Malad West Dely SO"
  },
  "263151": {
    "state": "UTTARAKHAND",
    "district": "UDAM SINGH NAGAR",
    "office": "Shaktifarm SO"
  },
  "400104": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Goregaon SO Mumbai"
  },
  "400065": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "S R P F Camp SO"
  },
  "770025": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "NTPC  Darlipali SO"
  },
  "751018": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Badagarh Brit Colony S.O"
  },
  "600014": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Lloyds Estate S.O"
  },
  "600018": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Pr. Accountant General S.O"
  },
  "605008": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "Lawspet SO"
  },
  "605003": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "Muthialpet SO"
  },
  "281303": {
    "state": "UTTAR PRADESH",
    "district": "MATHURA",
    "office": "Gokul SO"
  },
  "460447": {
    "state": "MADHYA PRADESH",
    "district": "BETUL",
    "office": "Sarni S.O"
  },
  "638011": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Erode Collectorate SO"
  },
  "621729": {
    "state": "TAMIL NADU",
    "district": "Ariyalur",
    "office": "Ariyalur Cement Factory SO"
  },
  "670304": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Madayi SO"
  },
  "670501": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Mandurkannur SO"
  },
  "400072": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Vihar Road SO"
  },
  "680514": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Kadappuram SO"
  },
  "670010": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Valapattanam SO"
  },
  "712136": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Chandannagar SO Hooghly"
  },
  "712248": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Gandhisarak SO"
  },
  "605005": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "Nellithope SO"
  },
  "605011": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "Venkata Nagar SO"
  },
  "600086": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Gopalapuram S.O (Chennai)"
  },
  "282008": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "IAF SO"
  },
  "400019": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Matunga SO"
  },
  "400057": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Vileparle Railway Station S.O"
  },
  "400052": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "V.P. Road S.O"
  },
  "400059": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "J.B. Nagar S.O"
  },
  "400069": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Andheri East S.O"
  },
  "400098": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Vidyanagari S.O"
  },
  "400094": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Anushakti Nagar SO"
  },
  "400082": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Mulund Colony SO"
  },
  "400042": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Bhandup East SO"
  },
  "400089": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Tilak Nagar SO Mumbai"
  },
  "400043": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Shivaji Nagar SO Mumbai"
  },
  "400086": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Sahakar Bhavan SO"
  },
  "400081": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Mhada Colony SO"
  },
  "400077": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Rajawadi SO"
  },
  "416007": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Kalamba S.O"
  },
  "147003": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "Gurbax Colony SO"
  },
  "680513": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Toyakkavu SO"
  },
  "680555": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Amalanagar SO"
  },
  "680615": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Engandiyur SO"
  },
  "141106": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Halwara Aerodrome SO"
  },
  "400066": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "S KNagar SO"
  },
  "400063": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Sharma Estate SO"
  },
  "400060": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Jogeshwari East SO"
  },
  "679551": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Anakkara SO Palakkad"
  },
  "400101": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Kandivali East SO"
  },
  "400095": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Ins Hamla SO"
  },
  "400097": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Malad East SO"
  },
  "482010": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Richhai S.O"
  },
  "605006": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "Dhanvantri Nagar SO"
  },
  "502101": {
    "state": "TELANGANA",
    "district": "MEDAK",
    "office": "Ramayampet S.O"
  },
  "141002": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Model Town Ludhiana SO"
  },
  "344025": {
    "state": "RAJASTHAN",
    "district": "BARMER",
    "office": "Mewanagar S.O"
  },
  "462037": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Peoples Campus S.O"
  },
  "462033": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "RGPV S.O"
  },
  "462011": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Shiksha Mandal S.O"
  },
  "741139": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Dhubulia SO"
  },
  "713331": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Simjuri SO"
  },
  "444007": {
    "state": "MAHARASHTRA",
    "district": "AKOLA",
    "office": "Wholesale Kirana Market Sub Post Office, Akola"
  },
  "425101": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "Asoda S.O"
  },
  "327024": {
    "state": "RAJASTHAN",
    "district": "BANSWARA",
    "office": "Partapur S.O"
  },
  "246178": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Srikot SO"
  },
  "679516": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Vengasseri SO"
  },
  "711113": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Balitikuri SO"
  },
  "711317": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Radhadasi SO"
  },
  "679553": {
    "state": "KERALA",
    "district": "PALAKKAD",
    "office": "Kumbidi SO"
  },
  "768016": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Hirakud S.O"
  },
  "323303": {
    "state": "RAJASTHAN",
    "district": "CHITTORGARH",
    "office": "Anushakti S.O"
  },
  "249302": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Laxmanjhula B SO"
  },
  "246150": {
    "state": "UTTARAKHAND",
    "district": "PAURI GARHWAL",
    "office": "Padampur Sukhro"
  },
  "843335": {
    "state": "BIHAR",
    "district": "SHEOHAR",
    "office": "Barahi Jagdish SO"
  },
  "160025": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Maloya Colony SO"
  },
  "160018": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Govt Press Chandigarh SO"
  },
  "160020": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Sector 20 Chandigarh SO"
  },
  "160009": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Sector 9 Chandigarh SO"
  },
  "160043": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Sector43 Chandigarh"
  },
  "224232": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Hakeem Pur SO"
  },
  "224238": {
    "state": "UTTAR PRADESH",
    "district": "AMBEDKAR NAGAR",
    "office": "Vidhut Nagar SO"
  },
  "141016": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Lohora SO"
  },
  "643201": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Aravenu S.O"
  },
  "643270": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Devala SO"
  },
  "754145": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Ppl Township S.O"
  },
  "713326": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Chotodighari SO"
  },
  "713302": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Railpar SO Bardhaman"
  },
  "676522": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Kolaparamba SO"
  },
  "753006": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "C R R I S.O (Cuttack)"
  },
  "735234": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Gajoldoba SO"
  },
  "400054": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Santacruz(West) S.O"
  },
  "400029": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "A I Staff Colony S.O"
  },
  "400061": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Vesava S.O"
  },
  "400056": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "IRLA S.O"
  },
  "324009": {
    "state": "RAJASTHAN",
    "district": "KOTA",
    "office": "Dadabari Kota S.O"
  },
  "231224": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Kakari Project SO"
  },
  "283205": {
    "state": "UTTAR PRADESH",
    "district": "FIROZABAD",
    "office": "Collectorate firozabad SO"
  },
  "768017": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Burla S.O"
  },
  "768118": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Naktideul S.O"
  },
  "673635": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Calicut University SO"
  },
  "263156": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Ghorakhal SO"
  },
  "734002": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Salbari SO"
  },
  "734425": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Bidhannagar SO"
  },
  "620020": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "P and T Colony SO Tiruchirappalli"
  },
  "620019": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Pappakurichi Kattur SO"
  },
  "620017": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Tennur SO"
  },
  "334003": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Pawanpuri S.O (Bikaner)"
  },
  "334006": {
    "state": "RAJASTHAN",
    "district": "BIKANER",
    "office": "Bichhwal Ind.Area S.O"
  },
  "713304": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Hill View SO"
  },
  "752003": {
    "state": "ODISHA",
    "district": "PURI",
    "office": "Srivihar S.O"
  },
  "141010": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Moti Nagar SO"
  },
  "141004": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "PAU SO"
  },
  "141012": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Rajguru Nagar SO"
  },
  "141011": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Nodal Delivery Centre, Ludhiana"
  },
  "793123": {
    "state": "MEGHALAYA",
    "district": "RI BHOI",
    "office": "Umsaw S.O"
  },
  "172028": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Delath SO"
  },
  "713365": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Chittaranjan TS SO"
  },
  "713340": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Kalla Central Hospital SO"
  },
  "713344": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Nandi SO Bardhaman"
  },
  "713386": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Rupnarayanpur Bazar SO"
  },
  "713303": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "SDHospital SO"
  },
  "673011": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Nadakavu SO"
  },
  "760004": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Medical College S.O (Ganjam)"
  },
  "400092": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Borivali West SO"
  },
  "400103": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Mandapeshwar SO"
  },
  "711305": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Bauria SO"
  },
  "711111": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Jagacha SO"
  },
  "638006": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Pallipalayam SO"
  },
  "249195": {
    "state": "UTTARAKHAND",
    "district": "UTTAR KASHI",
    "office": "Mahidanda BO"
  },
  "171008": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Jutogh SO"
  },
  "401105": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Bhayander East S.O"
  },
  "401608": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Dahanu TPS S.O"
  },
  "401402": {
    "state": "MAHARASHTRA",
    "district": "PALGHAR",
    "office": "Kelwa mahim S.O"
  },
  "461446": {
    "state": "MADHYA PRADESH",
    "district": "HOSHANGABAD",
    "office": "Of Itarsi S.O"
  },
  "400087": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "NITIE SO"
  },
  "400083": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Kannamwar Nagar SO"
  },
  "735203": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Binnaguri SO"
  },
  "760005": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Hillpatna S.O"
  },
  "175051": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Seoh SO"
  },
  "614738": {
    "state": "TAMIL NADU",
    "district": "THIRUVARUR",
    "office": "Jambavanodai S.O"
  },
  "262526": {
    "state": "UTTARAKHAND",
    "district": "PITHORAGARH",
    "office": "Jhulaghat SO"
  },
  "741319": {
    "state": "WEST BENGAL",
    "district": "PURBA BARDHAMAN",
    "office": "Bidyanagar SO"
  },
  "737136": {
    "state": "SIKKIM",
    "district": "EAST DISTRICT",
    "office": "Majitar SO"
  },
  "673647": {
    "state": "KERALA",
    "district": "MALAPPURAM",
    "office": "Calicut Airport SO"
  },
  "760006": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Sankarapur S.O"
  },
  "760011": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "AMBAPUA SO"
  },
  "175075": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Kamand SO"
  },
  "250003": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "Meerut Kutchery SO"
  },
  "741221": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Barajaguli SO"
  },
  "713369": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Kalyaneshwari SO"
  },
  "713372": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Radhanagar Rly Colony SO"
  },
  "713357": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Salanpur SO"
  },
  "713361": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Suryanagar SO Bardhaman"
  },
  "713213": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Benachity SO"
  },
  "713305": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Ramkrishna Mission SO"
  },
  "713216": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "City Centre SO"
  },
  "673028": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Arakinar SO"
  },
  "673328": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Mannur SO Kozhikode"
  },
  "171215": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Mandhole SO"
  },
  "171002": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Khalini SO"
  },
  "271308": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Iti Mankapur SO"
  },
  "751021": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Sailashree Vihar S.O"
  },
  "751027": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "International Business Centre"
  },
  "751029": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Mahalaxmivihar S.O"
  },
  "751028": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Tamando S.O"
  },
  "380016": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Meghaningar SO"
  },
  "380004": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Shahpur SO Ahmedabad"
  },
  "380024": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Bapunagar SO"
  },
  "382415": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Odhav SO"
  },
  "382345": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Naroda Road SO"
  },
  "380018": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Saraspur SO"
  },
  "380026": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Ctm Char Rasta SO"
  },
  "282004": {
    "state": "UTTAR PRADESH",
    "district": "AGRA",
    "office": "Agra University SO"
  },
  "673002": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Chalapuram SO"
  },
  "462027": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Arera Hills S.O"
  },
  "462043": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Bag Mungalia S.O"
  },
  "462045": {
    "state": "MADHYA PRADESH",
    "district": "BHOPAL",
    "office": "Bangrasia S.O"
  },
  "769015": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Rourkela - 15 S.O"
  },
  "770042": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Tensa S.O"
  },
  "416807": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Tirlot S.O"
  },
  "416515": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Tulas S.O"
  },
  "609803": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Tiruvavaduthurai S.O"
  },
  "382024": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Gandhinagar Sector 23 SO"
  },
  "382030": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Gandhinagar Sector 29 SO"
  },
  "382620": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Randheja SO"
  },
  "607807": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Neyveli II Thermal Station S.O"
  },
  "273005": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Turkmanpur SO"
  },
  "273009": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Gorakhpur University SO"
  },
  "273012": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Railway Colony SO Gorakhpur"
  },
  "626161": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Athipatti SO"
  },
  "626122": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Settiyarpatti SO"
  },
  "626188": {
    "state": "TAMIL NADU",
    "district": "VIRUDHUNAGAR",
    "office": "Dhalavaipuram SO"
  },
  "591223": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Kagvad S.O"
  },
  "160071": {
    "state": "PUNJAB",
    "district": "S.A.S Nagar",
    "office": "Chandigarh Sector 71 SO"
  },
  "583233": {
    "state": "KARNATAKA",
    "district": "KOPPAL",
    "office": "Munirabad S.O"
  },
  "607002": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Tiruppadiripuliyur West S.O"
  },
  "382021": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Gandhinagar Sector 21 SO"
  },
  "382045": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "BSF GANDHINAGAR SO"
  },
  "638053": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Perundurai Sanitorium SO"
  },
  "230130": {
    "state": "UTTAR PRADESH",
    "district": "PRATAPGARH",
    "office": "Laxmanpur SO"
  },
  "732144": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Kotwali SO Malda"
  },
  "637415": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "Solakkadu S.O"
  },
  "643233": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Pandalur S.O"
  },
  "643243": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Yellanhalli S.O"
  },
  "452013": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Indore Cat S.O"
  },
  "452018": {
    "state": "MADHYA PRADESH",
    "district": "INDORE",
    "office": "Indore Tillaknagar S.O"
  },
  "322021": {
    "state": "RAJASTHAN",
    "district": "SAWAI MADHOPUR",
    "office": "Alanpur SO"
  },
  "263149": {
    "state": "UTTARAKHAND",
    "district": "UDAM SINGH NAGAR",
    "office": "DF Nagla SO"
  },
  "732215": {
    "state": "WEST BENGAL",
    "district": "MALDAH",
    "office": "Pubarun SO"
  },
  "249403": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Adm BlockBHEL SO"
  },
  "249401": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Mayapur SO Haridwar"
  },
  "249407": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Jwalapur SO"
  },
  "249410": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Sadhubela Bhupatwala SO"
  },
  "249411": {
    "state": "UTTARAKHAND",
    "district": "HARIDWAR",
    "office": "Shantikunj SO"
  },
  "248006": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Newforest SO"
  },
  "248122": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Barlowganj SO"
  },
  "248195": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "IPE SO"
  },
  "248146": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Seemadwar SO"
  },
  "248011": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Selaqui SO"
  },
  "382041": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Thermal Power Station SO"
  },
  "249203": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Pashulok SO"
  },
  "249201": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Rishikesh SO"
  },
  "248018": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Mehunwala SO"
  },
  "670013": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Burnacherry SO"
  },
  "670325": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Mattul North SO"
  },
  "670302": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Mattul SO"
  },
  "670018": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Thazhe Chovva SO"
  },
  "670051": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Kannur NDC"
  },
  "670503": {
    "state": "KERALA",
    "district": "KANNUR",
    "office": "Pariyaram Medical College SO"
  },
  "734204": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Dowhill SO"
  },
  "273003": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Arogyamandir SO"
  },
  "273004": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Basharatpur SO"
  },
  "273006": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Gita Vatika SO"
  },
  "273017": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Siddharth Enclave SO"
  },
  "380008": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Vasisthnagar SO"
  },
  "382340": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Kubernagar SO"
  },
  "380022": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "M D Marg SO"
  },
  "263651": {
    "state": "UTTARAKHAND",
    "district": "ALMORA",
    "office": "Chaubattia SO"
  },
  "712258": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Uttarpara SO"
  },
  "628007": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Heavy Water Project Colony S.O"
  },
  "628004": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Tuticorin Harbour Estate S.O"
  },
  "628003": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "New Colony S.O (Tuticorin)"
  },
  "382428": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Bhat SO"
  },
  "607803": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Block 26, Neyveli S.O"
  },
  "607308": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Gandhi Nagar S.O (Cuddalore)"
  },
  "751016": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Chandra Sekhar Pur S.O"
  },
  "201011": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Chandra Nagar SO"
  },
  "201018": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Model Town SO"
  },
  "201016": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Crossings Republik SO"
  },
  "580008": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Dharwad Narayanpur S.O"
  },
  "580021": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Hubballi Vidyanagar S.O"
  },
  "380063": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Sola H B C SO"
  },
  "380021": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Gomtipur SO"
  },
  "380023": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Sukhrampura SO"
  },
  "382350": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Khodiyarnagar SO"
  },
  "380003": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "DELIVERY HUB AHMEDABAD"
  },
  "628753": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Sivagalai S.O"
  },
  "628229": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Sahupuram S.O"
  },
  "160023": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "Sector 23  Chandigarh SO"
  },
  "160016": {
    "state": "CHANDIGARH",
    "district": "CHANDIGARH",
    "office": "NODAL DELIVERY  SPEED POST  CHANDIGARH"
  },
  "770052": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Kalta S.O"
  },
  "736205": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "New Lands SO"
  },
  "380028": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Shah Alam Roza SO"
  },
  "382443": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Isanpur SO"
  },
  "450119": {
    "state": "MADHYA PRADESH",
    "district": "EAST NIMAR",
    "office": "Narmada Nagar S.O (East Nimar)"
  },
  "227817": {
    "state": "UTTAR PRADESH",
    "district": "Amethi",
    "office": "Jagdishpur Industrial Area SO"
  },
  "641018": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Redfields SO"
  },
  "627005": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Melapalayam SO Tirunelveli"
  },
  "627009": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Tirunelveli Collectorate SO"
  },
  "627003": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Vannarpettai SO"
  },
  "403102": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Chorao S.O"
  },
  "403206": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Goa University S.O"
  },
  "403109": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "N B Verem S.O"
  },
  "403106": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Sant Estevam S.O"
  },
  "403202": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Bambolim Complex S.O"
  },
  "769005": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Rourkela - 5 S.O"
  },
  "403526": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Tivim Ie S.O"
  },
  "623520": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Marine Fisheries SO"
  },
  "711202": {
    "state": "WEST BENGAL",
    "district": "HOWRAH",
    "office": "Belur Math SO"
  },
  "400015": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI",
    "office": "Sewri S.O"
  },
  "246448": {
    "state": "UTTARAKHAND",
    "district": "RUDRA PRAYAG",
    "office": "Maikoti SO"
  },
  "735208": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Dalshingpara SO"
  },
  "735226": {
    "state": "WEST BENGAL",
    "district": "Alipurduar",
    "office": "Panabasti SO"
  },
  "301002": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "MOTIDOONGRI S.O"
  },
  "271304": {
    "state": "UTTAR PRADESH",
    "district": "GONDA",
    "office": "Nawabganj S F SO"
  },
  "244223": {
    "state": "UTTAR PRADESH",
    "district": "AMROHA",
    "office": "Bhartiya Gram SO"
  },
  "201303": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Sector 30 Noida SO"
  },
  "201302": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "NDC Noida"
  },
  "201006": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Bhopura SO"
  },
  "201013": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Govindpuram SO"
  },
  "754298": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "KALARABANKA S.O"
  },
  "638012": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Thindal SO"
  },
  "628217": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Adaikalapuram S.O"
  },
  "628209": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Manapad S.O"
  },
  "628216": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Virapandianpatanam S.O"
  },
  "628615": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Karungulam S.O"
  },
  "761052": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Golabandha S.O"
  },
  "458470": {
    "state": "MADHYA PRADESH",
    "district": "NEEMUCH",
    "office": "Khor S.O"
  },
  "201017": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Raj Nagar Extension SO"
  },
  "201012": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Vasundhra SO"
  },
  "201004": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Hindon Air Field SO"
  },
  "201014": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Shipra Sun City SO"
  },
  "201020": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Khora SO"
  },
  "400096": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "Seepz S.O"
  },
  "400085": {
    "state": "MAHARASHTRA",
    "district": "MUMBAI SUBURBAN",
    "office": "BARC SO"
  },
  "735232": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Binnaguri Cantt SO"
  },
  "735209": {
    "state": "WEST BENGAL",
    "district": "JALPAIGURI",
    "office": "Damdim SO"
  },
  "591219": {
    "state": "KARNATAKA",
    "district": "BELAGAVI",
    "office": "Galataga S.O"
  },
  "482009": {
    "state": "MADHYA PRADESH",
    "district": "JABALPUR",
    "office": "Shobhapur S.O"
  },
  "477450": {
    "state": "MADHYA PRADESH",
    "district": "BHIND",
    "office": "Rawatpura sarkar ashram S.O"
  },
  "141201": {
    "state": "PUNJAB",
    "district": "LUDHIANA",
    "office": "Kila Raipur SO"
  },
  "600051": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Madhavaram Milk Colony SO"
  },
  "643105": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Ottupattarai S.O"
  },
  "600037": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Mogappair SO"
  },
  "251002": {
    "state": "UTTAR PRADESH",
    "district": "MUZAFFARNAGAR",
    "office": "Prempuri SO"
  },
  "673051": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "KOZHIKODE PARCEL CENTRE"
  },
  "422012": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Ashok Nagar S.O (Nashik)"
  },
  "416623": {
    "state": "MAHARASHTRA",
    "district": "SINDHUDURG",
    "office": "Mond S.O"
  },
  "431604": {
    "state": "MAHARASHTRA",
    "district": "NANDED",
    "office": "Karimabad Nanded S.O"
  },
  "333702": {
    "state": "RAJASTHAN",
    "district": "JHUNJHUNU",
    "office": "Dundlod S.O"
  },
  "580002": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Dharwad Tejaswi Nagar S.O"
  },
  "382480": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Ranip SO"
  },
  "313805": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Dhelana"
  },
  "382475": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Sardarnagar SO"
  },
  "380049": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Nikol SO"
  },
  "380050": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Ghodasar SO Ahmedabad"
  },
  "382418": {
    "state": "GUJARAT",
    "district": "AHMADABAD",
    "office": "Vastral SO"
  },
  "201007": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Mohan Nagar SO"
  },
  "201019": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Vaishali SO"
  },
  "201021": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIABAD",
    "office": "Abhay Khand 03 SO"
  },
  "262402": {
    "state": "UTTARAKHAND",
    "district": "NAINITAL",
    "office": "Lalkua SO"
  },
  "793007": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Happy Valley S.O"
  },
  "620026": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Annanagar SO"
  },
  "620008": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Tiruchirappalli Fort SO"
  },
  "211005": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Allahabad Fort SO"
  },
  "211017": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Allahabad High Court SO"
  },
  "580003": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Dharwad K V V S.O"
  },
  "580030": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Hubballi Akashaya Colony"
  },
  "580031": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Hubballi Eng College S.O"
  },
  "580032": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Hubballi Vijayanagar S.O"
  },
  "713370": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Ningha SO"
  },
  "713214": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Durgapur CRPF Camp SO"
  },
  "713215": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Durgapur Brick Field SO"
  },
  "673032": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Calicut Courts SO"
  },
  "673301": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Chaliyam SO"
  },
  "673655": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Cheruvannur SO"
  },
  "673021": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Puthiyangadi SO"
  },
  "628752": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Perungulam S.O (Tuticorin)"
  },
  "756088": {
    "state": "ODISHA",
    "district": "BALESHWAR",
    "office": "Chormara S.O"
  },
  "474004": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "Birla Nagar S.O"
  },
  "244245": {
    "state": "UTTAR PRADESH",
    "district": "AMROHA",
    "office": "Kundan Nagar SO"
  },
  "635124": {
    "state": "TAMIL NADU",
    "district": "KRISHNAGIRI",
    "office": "Belathur S.O"
  },
  "680553": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Puzhakkal SO"
  },
  "680591": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Killimangalam SO"
  },
  "313002": {
    "state": "RAJASTHAN",
    "district": "UDAIPUR",
    "office": "Udaipur H Magri S.O"
  },
  "768233": {
    "state": "ODISHA",
    "district": "JHARSUGUDA",
    "office": "Orient Colliery Brajarajnagar S.O"
  },
  "754120": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Atharbanki Rly Colony S.O"
  },
  "754143": {
    "state": "ODISHA",
    "district": "JAGATSINGHAPUR",
    "office": "Sector 21 S.O"
  },
  "768004": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Budharaja S.O"
  },
  "403712": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Cansaulim S.O"
  },
  "403602": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Fatorda S.O"
  },
  "605013": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "SaramPy SO"
  },
  "605002": {
    "state": "PUDUCHERRY",
    "district": "PONDICHERRY",
    "office": "Sri Aurobindo Ashram SO"
  },
  "632008": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Shenbakkam S.O"
  },
  "643203": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Balacola S.O"
  },
  "643006": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Finger Post S.O"
  },
  "734421": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Bagdogra Air Port SO"
  },
  "734424": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Bendubi SO"
  },
  "734011": {
    "state": "WEST BENGAL",
    "district": "DARJEELING",
    "office": "Kadamtala SO Darjiling"
  },
  "143006": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Focal Point SO"
  },
  "143005": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Guru Nanak Dev University SO"
  },
  "201316": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Sec 122 Noida SO"
  },
  "422002": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Gole Colony S.O"
  },
  "201315": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Gurjinder Vihar SO"
  },
  "422011": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Dwarka Corner S.O"
  },
  "416144": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Akiwate Industrial Estate S.O"
  },
  "416116": {
    "state": "MAHARASHTRA",
    "district": "KOLHAPUR",
    "office": "Ganganagar Ichalkaranji S.O"
  },
  "403806": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Bogmalo S.O"
  },
  "403725": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Dramapur S.O"
  },
  "403729": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Navelim Camp S.O"
  },
  "403724": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Orlim S.O"
  },
  "403720": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Raia S.O"
  },
  "403521": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Alto Betim S.O"
  },
  "403201": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Bambolim Camp S.O"
  },
  "403529": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Bicholim Industrial Estate S.O"
  },
  "627004": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Tirunelveli Pettai SO"
  },
  "580026": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Hubballi Tarihal Indl. Estate S.O"
  },
  "580029": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Hubballi Bharat Mill S.O"
  },
  "580027": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Gokul S.O"
  },
  "143002": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "JFMill SO"
  },
  "147002": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "Urban Estate SO"
  },
  "741159": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Taherpur SO"
  },
  "741252": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Krishivisyavidyalaya SO"
  },
  "403527": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Mandrem S.O"
  },
  "403203": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Pilar S.O (North Goa)"
  },
  "403501": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Porvorim S.O"
  },
  "273008": {
    "state": "UTTAR PRADESH",
    "district": "GORAKHPUR",
    "office": "Kunraghat S.O"
  },
  "201313": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Amity university SO"
  },
  "201318": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Sec 01 Greater Noida SO"
  },
  "147008": {
    "state": "PUNJAB",
    "district": "PATIALA",
    "office": "Nodal Delivery Center (Parcel)  Patiala"
  },
  "752037": {
    "state": "ODISHA",
    "district": "KHORDHA",
    "office": "Navalbasechilika  S.O"
  },
  "768018": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Engineering College Burla S.O"
  },
  "768020": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Jagruti Vihar Burla S.O"
  },
  "582210": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Shigli S.O"
  },
  "609305": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Mannampandal S.O"
  },
  "689507": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Mezhuveli SO"
  },
  "403701": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Assolna S.O"
  },
  "403716": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Benaulim S.O"
  },
  "403717": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Carmona S.O"
  },
  "403711": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Chicalim S.O"
  },
  "403803": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Mormugao S.O"
  },
  "403804": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Sada S.O"
  },
  "403721": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Varca S.O"
  },
  "403722": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Verna S.O"
  },
  "643253": {
    "state": "TAMIL NADU",
    "district": "THE NILGIRIS",
    "office": "Kolapalli S.O"
  },
  "600110": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Ponniammanmedu SO"
  },
  "632115": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Thiruvalluvar University S.O"
  },
  "244103": {
    "state": "UTTAR PRADESH",
    "district": "MORADABAD",
    "office": "Majhola SO Moradabad"
  },
  "474011": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "R. K. Puri Gwalior SO"
  },
  "474007": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "Moti Mahal S.O"
  },
  "474015": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "AB VIII TM Gwalior S.O"
  },
  "474008": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "Gwalior Fort S.O"
  },
  "474003": {
    "state": "MADHYA PRADESH",
    "district": "GWALIOR",
    "office": "GWALIOR CITY SO"
  },
  "609810": {
    "state": "TAMIL NADU",
    "district": "MAYILADUTHURAI",
    "office": "Tiruvalangadu S.O"
  },
  "625007": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Pudur Bazaar SO"
  },
  "607801": {
    "state": "TAMIL NADU",
    "district": "CUDDALORE",
    "office": "Neyveli 1 S.O"
  },
  "625011": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Subramaniapuram SO Madurai"
  },
  "625004": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Pasumalai SO"
  },
  "625023": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Madras High Court Madurai Bench SO"
  },
  "690546": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Amrithapuri SO"
  },
  "638010": {
    "state": "TAMIL NADU",
    "district": "NAMAKKAL",
    "office": "SPB Colony SO"
  },
  "690525": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Clappana SO"
  },
  "690539": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "S R P Market SO"
  },
  "691590": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Koivila SO"
  },
  "691002": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Asramom SO"
  },
  "691014": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Chandanathope SO"
  },
  "721606": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Haldia OR SO"
  },
  "721604": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Haldia SO"
  },
  "721171": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Ktpp TS SO"
  },
  "770046": {
    "state": "ODISHA",
    "district": "SUNDARGARH",
    "office": "Hatibari S.O"
  },
  "680022": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Thiruvambady TSR SO"
  },
  "680009": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Thrissur Engg College SO"
  },
  "679105": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Mayannur SO"
  },
  "680020": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Thrissur City SO"
  },
  "680021": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Thrissur R S SO"
  },
  "680654": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Vellanikkara SO"
  },
  "211018": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Public Service Commission SO"
  },
  "211016": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Kesaria Road SO"
  },
  "211004": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Cavellary Lines SO"
  },
  "641014": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Coimbatore Aerodrome SO"
  },
  "641042": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Kovaipudur SO"
  },
  "632004": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Vellore Fort S.O"
  },
  "243005": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "Old City SO"
  },
  "689644": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kuzhikala SO"
  },
  "741232": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Coopers Camp SO"
  },
  "741401": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Dignagar SO"
  },
  "250005": {
    "state": "UTTAR PRADESH",
    "district": "MEERUT",
    "office": "MIET SO"
  },
  "641045": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Ramanathapuram Coimbatore SO"
  },
  "151003": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Nfl Bathinda SO"
  },
  "722183": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Mejia Th Power Station SO"
  },
  "620024": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Bharathidasan University SO"
  },
  "226016": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Indiranagar Sec21 SO"
  },
  "226014": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Sgpgi SO"
  },
  "226004": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Blunt Square SO"
  },
  "226005": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Singar Nagar SO"
  },
  "226018": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Wazirganj SO Lucknow"
  },
  "580004": {
    "state": "KARNATAKA",
    "district": "DHARWAD",
    "office": "Dharwad Vidyagiri S.O"
  },
  "700057": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Nowdapara SO"
  },
  "226023": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "32 Bn PAC SO Lucknow"
  },
  "620023": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Khajanagar SO"
  },
  "620018": {
    "state": "TAMIL NADU",
    "district": "TIRUCHIRAPPALLI",
    "office": "Thillai Nagar SO"
  },
  "761025": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Jayashree S.O"
  },
  "760008": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Lanjipalli S.O"
  },
  "641050": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Malumichampatti SO"
  },
  "641036": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Nanjundapuram SO"
  },
  "641033": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Neelikonampalayam SO"
  },
  "641049": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Chinnavedampatti SO"
  },
  "641004": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Peelamedu SO"
  },
  "641037": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Pappanaickenpalayam West SO"
  },
  "641009": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Ramnagar Coimbatore SO"
  },
  "641044": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Siddhapudur SO"
  },
  "641005": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Singanallur SO"
  },
  "700114": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Bangodaya SO"
  },
  "700081": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Rajbari Colony SO"
  },
  "700115": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Sukchar SO North 24 Parganas"
  },
  "700117": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Khardah SO"
  },
  "743144": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Ichapur SO"
  },
  "743128": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Athpur SO"
  },
  "743123": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Muktarpur SO"
  },
  "743133": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Pinkal SO"
  },
  "743125": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Jagatdal SO"
  },
  "700122": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Jaffarpur SO"
  },
  "700123": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Barrackpore RS SO"
  },
  "243006": {
    "state": "UTTAR PRADESH",
    "district": "BAREILLY",
    "office": "RKUniversity SO"
  },
  "641012": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Tatabad SO"
  },
  "641013": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "GovtCollege Of Technology SO"
  },
  "641003": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Lawley Road SO"
  },
  "641041": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Vadavalli SO"
  },
  "641034": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Tudiyalur SO"
  },
  "211015": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Subedarganj SO"
  },
  "211023": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Allahabad NDC"
  },
  "211006": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Nirala Chowk SO"
  },
  "211021": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Rajarshi Tondon Open University SO"
  },
  "231311": {
    "state": "UTTAR PRADESH",
    "district": "MIRZAPUR",
    "office": "Chunar Cement Factory SO"
  },
  "246737": {
    "state": "UTTAR PRADESH",
    "district": "BIJNOR",
    "office": "Rahu Nagli SO"
  },
  "700076": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Dakshineswar SO"
  },
  "700079": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Italghacha SO"
  },
  "700058": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Elias Road SO"
  },
  "700049": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Udaipur SO"
  },
  "700118": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Rahara SO"
  },
  "743134": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Halishahar SO"
  },
  "743136": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Nabanagar SO"
  },
  "632057": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Munjurpattu S.O"
  },
  "632012": {
    "state": "TAMIL NADU",
    "district": "VELLORE",
    "office": "Saidapet S.O (Vellore)"
  },
  "600066": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Pozhal SO"
  },
  "211022": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "CRPF Group Center Ismailganj SO"
  },
  "641024": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Sundarapuram SO"
  },
  "641015": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Uppilipalayam SO"
  },
  "712222": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Champdani SO"
  },
  "712221": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Angus SO"
  },
  "712204": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Chatra SO Hooghly"
  },
  "712233": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Hindmotor SO"
  },
  "712232": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Bhadrakali SO"
  },
  "712137": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Gondalpara SO"
  },
  "641040": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "NDC Coimbatore"
  },
  "212105": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Chheoki SO"
  },
  "691530": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Mannady SO Pathanamthitta"
  },
  "689652": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Punnakkad SO"
  },
  "695508": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Parasuvaickal SO"
  },
  "695005": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Perurkada SO"
  },
  "673018": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Calicut Arts  Science College SO"
  },
  "673302": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Kadalundi SO"
  },
  "673027": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Nallalam SO"
  },
  "712104": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Sahaganj SO"
  },
  "712503": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Btps SO Hooghly"
  },
  "241127": {
    "state": "UTTAR PRADESH",
    "district": "HARDOI",
    "office": "Sandila I Estate SO"
  },
  "695032": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Aramada SO"
  },
  "695522": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Vellayani SO"
  },
  "695019": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Industrial Estate SO Thiruvananthapuram"
  },
  "695014": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Jagathy SO"
  },
  "689654": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kozhencherry  Thekkemala SO"
  },
  "689661": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Kumpalampoika SO"
  },
  "689713": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "SABARIMALA"
  },
  "600068": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Manali SO Tiruvallur"
  },
  "600050": {
    "state": "TAMIL NADU",
    "district": "THIRUVALLUR",
    "office": "Korattur SO"
  },
  "211020": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Arail PO Kumbh Mela"
  },
  "263620": {
    "state": "UTTARAKHAND",
    "district": "BAGESHWAR",
    "office": "Kausani Estate SO"
  },
  "226022": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Kalyanpur SO Lucknow"
  },
  "226020": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Daliganj SO"
  },
  "226027": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "UPG Camp SO"
  },
  "226024": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Chandganj SO"
  },
  "226006": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Mahanagar SO"
  },
  "226007": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "New Hyderabad SO"
  },
  "226025": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "B R A University SO"
  },
  "226019": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Industria Area Chinhat SO"
  },
  "226009": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "AMAUSI AD SO"
  },
  "226012": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Ashiana Colony SO"
  },
  "226011": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "MANAK NAGAR SO"
  },
  "425004": {
    "state": "MAHARASHTRA",
    "district": "JALGAON",
    "office": "N M University Jalgaon S.O"
  },
  "175020": {
    "state": "HIMACHAL PRADESH",
    "district": "MANDI",
    "office": "Gumma (Mandi) S.O"
  },
  "721624": {
    "state": "WEST BENGAL",
    "district": "MEDINIPUR EAST",
    "office": "Rangibasan SO"
  },
  "263150": {
    "state": "UTTARAKHAND",
    "district": "UDAM SINGH NAGAR",
    "office": "Kelakhera SO"
  },
  "743122": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Bengal Enamel SO"
  },
  "743124": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "ESD M SO"
  },
  "246445": {
    "state": "UTTARAKHAND",
    "district": "RUDRA PRAYAG",
    "office": "Kedarnath Seasional SO"
  },
  "248015": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Sudhowala SO"
  },
  "229120": {
    "state": "UTTAR PRADESH",
    "district": "RAE BARELI",
    "office": "Rail Coach Factory LalganjRaebareli SO"
  },
  "754071": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Kapaleswar S.O"
  },
  "403002": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Caranzalem S.O"
  },
  "641027": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Rathinapuri SO"
  },
  "641039": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Telungupalayam SO"
  },
  "212212": {
    "state": "UTTAR PRADESH",
    "district": "PRAYAGRAJ",
    "office": "Manauri AF SO"
  },
  "382006": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Gandhinagar Sector 6 SO"
  },
  "382630": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Rupal SO"
  },
  "382729": {
    "state": "GUJARAT",
    "district": "GANDHINAGAR",
    "office": "Chhatral SO"
  },
  "712121": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Addconagar SO"
  },
  "712514": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Sripur Bazar SO Hooghly"
  },
  "226030": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Sushant Golf City SO"
  },
  "582206": {
    "state": "KARNATAKA",
    "district": "GADAG",
    "office": "Konnur S.O (Gadag)"
  },
  "151004": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "Bathinda Cantt SO"
  },
  "151006": {
    "state": "PUNJAB",
    "district": "BATHINDA",
    "office": "NDC Bathinda"
  },
  "627119": {
    "state": "TAMIL NADU",
    "district": "TIRUNELVELI",
    "office": "Vijayanarayanam Naval Base SO"
  },
  "403801": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "A.P.Terminal S.O"
  },
  "403731": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Cavelossim S.O"
  },
  "403715": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Chinchinim S.O"
  },
  "403409": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Betora I.E. S.O"
  },
  "628006": {
    "state": "TAMIL NADU",
    "district": "TUTICORIN",
    "office": "Thermal Nagagr S.O"
  },
  "625015": {
    "state": "TAMIL NADU",
    "district": "MADURAI",
    "office": "Thiagarajar Engg College SO"
  },
  "700096": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS SOUTH",
    "office": "Brahmapur SO"
  },
  "713342": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Kenda SO"
  },
  "713210": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "V K Nagar SO"
  },
  "713209": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Durgapur Mg Avenue SO"
  },
  "712504": {
    "state": "WEST BENGAL",
    "district": "HOOGHLY",
    "office": "Chandrahati SO"
  },
  "226029": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Vrindavan Colony SO"
  },
  "226015": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Cimap SO"
  },
  "226031": {
    "state": "UTTAR PRADESH",
    "district": "LUCKNOW",
    "office": "Jankipuram Extension SO"
  },
  "754026": {
    "state": "ODISHA",
    "district": "CUTTACK",
    "office": "Daulatabad S.O (Cuttack)"
  },
  "403005": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Santa Cruz S.O"
  },
  "403204": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "St. Lourence S.O"
  },
  "403402": {
    "state": "GOA",
    "district": "NORTH GOA",
    "office": "Velha goa S.O"
  },
  "623566": {
    "state": "TAMIL NADU",
    "district": "RAMANATHAPURAM",
    "office": "Ervadi Dargha SO"
  },
  "385506": {
    "state": "GUJARAT",
    "district": "BANAS KANTHA",
    "office": "Sardar Krishinagar SO"
  },
  "600076": {
    "state": "TAMIL NADU",
    "district": "CHENNAI",
    "office": "Korattur RS SO"
  },
  "231220": {
    "state": "UTTAR PRADESH",
    "district": "SONBHADRA",
    "office": "Beena Project SO"
  },
  "641038": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Kuppakonanpudur SO"
  },
  "201317": {
    "state": "UTTAR PRADESH",
    "district": "GAUTAM BUDDHA NAGAR",
    "office": "Sec 128 Noida SO"
  },
  "422009": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "Indira Nagar S.O (Nashik)"
  },
  "422005": {
    "state": "MAHARASHTRA",
    "district": "NASHIK",
    "office": "H P T College S.O"
  },
  "248019": {
    "state": "UTTARAKHAND",
    "district": "DEHRADUN",
    "office": "Balawala SO"
  },
  "768210": {
    "state": "ODISHA",
    "district": "SAMBALPUR",
    "office": "Thelkuli S.O"
  },
  "403719": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Sem rachol  Soso S.O"
  },
  "403726": {
    "state": "GOA",
    "district": "SOUTH GOA",
    "office": "Zuarinagar S.O"
  },
  "691572": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Chathannur SO"
  },
  "638060": {
    "state": "TAMIL NADU",
    "district": "ERODE",
    "office": "Thoppupalayam SO"
  },
  "140407": {
    "state": "PUNJAB",
    "district": "FATEHGARH SAHIB",
    "office": "Fatehgarh Sahib SO"
  },
  "233234": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "Sherpur Kalan SO"
  },
  "232325": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "BARA"
  },
  "695040": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kaimanam SO"
  },
  "695030": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kanjirampara SO"
  },
  "695099": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kerala Governors Camp SO"
  },
  "680631": {
    "state": "KERALA",
    "district": "THRISSUR",
    "office": "Ramavarmapuram SO"
  },
  "247122": {
    "state": "UTTAR PRADESH",
    "district": "SAHARANPUR",
    "office": "Badshahi Bagh SO"
  },
  "641043": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Sahs College SO"
  },
  "641011": {
    "state": "TAMIL NADU",
    "district": "COIMBATORE",
    "office": "Saibaba Mission SO"
  },
  "695507": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Ooruttambalam SO"
  },
  "695042": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kalliyoor SO"
  },
  "695003": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Kaudiar SO"
  },
  "695018": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Pappanamcode SO"
  },
  "695038": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "PTP Nagar SO"
  },
  "695513": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Pozhiyoor SO"
  },
  "695134": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Vlathankara SO"
  },
  "695528": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Naruvamoodu SO"
  },
  "713208": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Durgapur ASP SB SO"
  },
  "606811": {
    "state": "TAMIL NADU",
    "district": "TIRUVANNAMALAI",
    "office": "Thachampattu SO"
  },
  "760009": {
    "state": "ODISHA",
    "district": "GANJAM",
    "office": "Nabeen S.O"
  },
  "793017": {
    "state": "MEGHALAYA",
    "district": "EAST KHASI HILLS",
    "office": "Mawlai S.O"
  },
  "172034": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Bonda SO"
  },
  "172103": {
    "state": "HIMACHAL PRADESH",
    "district": "KINNAUR",
    "office": "Nichar SO"
  },
  "713376": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Dhandadihi SO"
  },
  "673570": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Iim Kozhikode Campus SO"
  },
  "442901": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Ballarpur Paper Mill S.O"
  },
  "442501": {
    "state": "MAHARASHTRA",
    "district": "CHANDRAPUR",
    "office": "Chandrapur Ord Fact S.O"
  },
  "691008": {
    "state": "KERALA",
    "district": "KOLLAM",
    "office": "Kadappakada SO"
  },
  "900099": {
    "state": "WEST BENGAL",
    "district": "KOLKATA",
    "office": "2CBPO"
  },
  "301416": {
    "state": "RAJASTHAN",
    "district": "ALWAR",
    "office": "Rampur S.O (Alwar)"
  },
  "244926": {
    "state": "UTTAR PRADESH",
    "district": "RAMPUR",
    "office": "Modipur SO"
  },
  "722204": {
    "state": "WEST BENGAL",
    "district": "BANKURA",
    "office": "Hatasuria SO"
  },
  "171223": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Arhal SO"
  },
  "143003": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "NODAL DELIVERY OFFICE"
  },
  "143004": {
    "state": "PUNJAB",
    "district": "AMRITSAR",
    "office": "Nodal Delivery Centre, Amritsar"
  },
  "743194": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Ramlakshi Busti Lane SO"
  },
  "244928": {
    "state": "UTTAR PRADESH",
    "district": "RAMPUR",
    "office": "Kemri SO Rampur"
  },
  "695547": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Valiamala SO"
  },
  "695570": {
    "state": "KERALA",
    "district": "THIRUVANANTHAPURAM",
    "office": "Machel SO"
  },
  "689666": {
    "state": "KERALA",
    "district": "PATHANAMTHITTA",
    "office": "Malayalapuzha Thazham SO"
  },
  "232341": {
    "state": "UTTAR PRADESH",
    "district": "GHAZIPUR",
    "office": "SUHWAL SO"
  },
  "741234": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Gayeshpur SO"
  },
  "741247": {
    "state": "WEST BENGAL",
    "district": "NADIA",
    "office": "Pritinagar SO"
  },
  "713202": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Durgapur Coke Oven Colony SO"
  },
  "713207": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Durgapur Thermal Power Station SO"
  },
  "700109": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Agarpara SO"
  },
  "700116": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "BDSopan SO"
  },
  "700158": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Bisharpara SO"
  },
  "700134": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Nilachal SO"
  },
  "743130": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Dogachia SO"
  },
  "743129": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Fingapara SO"
  },
  "743193": {
    "state": "WEST BENGAL",
    "district": "24 PARAGANAS NORTH",
    "office": "Kampa SO"
  },
  "713217": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Oyaria SO"
  },
  "713384": {
    "state": "WEST BENGAL",
    "district": "PASCHIM BARDHAMAN",
    "office": "Parasea SO"
  },
  "171218": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Junga SO"
  },
  "171010": {
    "state": "HIMACHAL PRADESH",
    "district": "SHIMLA",
    "office": "Tara Devi SO"
  },
  "673006": {
    "state": "KERALA",
    "district": "KOZHIKODE",
    "office": "Eranhipalam SO"
  }
};